
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gK4nz", function(module, exports) {
var $4244d10cd87ad238$export$c23e925a9f49ee3c = /*#__PURE__*/ function(ConfluenceGraphQLDateFilterFieldType) {
    ConfluenceGraphQLDateFilterFieldType["LASTMODIFIED"] = "LASTMODIFIED";
    ConfluenceGraphQLDateFilterFieldType["CREATED"] = "CREATED,";
    return ConfluenceGraphQLDateFilterFieldType;
}({});


const $6397ad55becd6315$export$52e069b7e2e3e8fb = 'ari:cloud:confluence::site/';
const $6397ad55becd6315$var$MAX_RESULTS_PAGE_BLOG_ATTACHMENTS = 10;
const $6397ad55becd6315$var$MAX_RESULTS_SPACES = 3;
const $6397ad55becd6315$export$9101978d57f6d48a = 'ati:cloud:confluence:page';
const $6397ad55becd6315$export$5e59c260151d03b2 = 'ati:cloud:confluence:blogpost';
const $6397ad55becd6315$var$ATTACHMENT_ATI = 'ati:cloud:confluence:attachment';
const $6397ad55becd6315$export$71fb3a6d48f3d84f = [
    $6397ad55becd6315$export$9101978d57f6d48a,
    $6397ad55becd6315$export$5e59c260151d03b2,
    $6397ad55becd6315$var$ATTACHMENT_ATI
];
const $6397ad55becd6315$var$graphQLFilterMapper = (filters)=>{
    const confluenceFilters = {};
    filters.forEach((filter)=>{
        switch(filter['@type']){
            case 'spaces':
                confluenceFilters['spacesFilter'] = filter.spaceKeys;
                break;
            case 'verified':
                confluenceFilters['isVerified'] = filter.verified;
                break;
            case 'contributors':
                confluenceFilters['contributorsFilter'] = filter.accountIds;
                break;
            case 'lastModified':
                confluenceFilters['range'] = {
                    field: (0, $4244d10cd87ad238$export$c23e925a9f49ee3c).LASTMODIFIED,
                    gt: filter.from,
                    lt: filter.to
                };
                break;
            case 'titleMatchOnly':
                confluenceFilters['titleMatchOnly'] = filter.enabled;
                break;
            default:
                break;
        }
    });
    return confluenceFilters;
};
const $6397ad55becd6315$export$74c39e342047d9d1 = (filters)=>filters.some((filter)=>{
        if (filter['@type'] === 'spaces' && filter.spaceKeys && filter.spaceKeys.length > 0) return true;
        else if (filter['@type'] === 'contributors' && filter.accountIds && filter.accountIds.length > 0) return true;
        else if (filter['@type'] === 'lastModified' && filter.from && filter.to) return true;
        return false;
    });
const $6397ad55becd6315$export$76ca4f6f223de78a = ({ query: query, filters: filters, contentEntities: contentEntities = $6397ad55becd6315$export$71fb3a6d48f3d84f, analyticsInfo: analyticsInfo, cloudId: cloudId, pageBlogAttachmentLimit: pageBlogAttachmentLimit = $6397ad55becd6315$var$MAX_RESULTS_PAGE_BLOG_ATTACHMENTS, spaceLimit: spaceLimit = $6397ad55becd6315$var$MAX_RESULTS_SPACES, includeAncestors: includeAncestors = false, experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers })=>{
    return {
        query: query,
        cloudIdARI: `${$6397ad55becd6315$export$52e069b7e2e3e8fb}${cloudId}`,
        pageBlogAttachmentLimit: pageBlogAttachmentLimit,
        spaceLimit: spaceLimit,
        includeAncestors: includeAncestors,
        contentEntities: contentEntities,
        confluenceFilters: $6397ad55becd6315$var$graphQLFilterMapper(filters),
        searchSessionId: analyticsInfo?.searchSessionId,
        queryVersion: analyticsInfo?.queryVersion,
        includeSpaces: !$6397ad55becd6315$export$74c39e342047d9d1(filters),
        experimentContext: {
            experimentId: experimentId,
            shadowExperimentId: shadowExperimentId,
            experimentLayers: experimentLayers
        }
    };
};
module.exports["CONFLUENCE_ARI_PREFIX"] = $6397ad55becd6315$export$52e069b7e2e3e8fb;
module.exports["PAGE_ATI"] = $6397ad55becd6315$export$9101978d57f6d48a;
module.exports["BLOGPOST_ATI"] = $6397ad55becd6315$export$5e59c260151d03b2;

});

parcelRegister("glYzA", function(module, exports) {

var $4mTS8 = parcelRequire("4mTS8");


var $gtxdb = parcelRequire("gtxdb");


var $1EqNn = parcelRequire("1EqNn");


var $iQC4a = parcelRequire("iQC4a");


var $bGd7w = parcelRequire("bGd7w");


var $2Btfj = parcelRequire("2Btfj");


var $ERUZZ = parcelRequire("ERUZZ");


var $57Ynd = parcelRequire("57Ynd");


var $af8fO = parcelRequire("af8fO");


var $1rDtO = parcelRequire("1rDtO");

const $ad30114c791eb142$export$3f23d3d88b2b0734 = `
description
iconUrl
id
title
type
url
__typename
`;
const $ad30114c791eb142$export$9f64d624a5905b0b = ()=>{
    return `
		${(0, $2Btfj.getConfluencePartials)()}
		${(0, $ERUZZ.getJiraPartials)()}
		${(0, $1rDtO.getTrelloPartials)()}
		${(0, $iQC4a.getAtlasPartials)()}
		${(0, $bGd7w.getCompassPartials)()}
		${(0, $af8fO.getGooglePartials)()}
		${(0, $af8fO.getMicrosoftPartials)()}
		${(0, $af8fO.getSlackPartials)()}
		${(0, $57Ynd.getGraphPartials)()}
	`;
};
const $ad30114c791eb142$export$5db520940cf00715 = 'SearchPageQuery';
const $ad30114c791eb142$export$bcad4d0714f0772f = ()=>{
    const partials = $ad30114c791eb142$export$9f64d624a5905b0b();
    const graphQuery = `
	query ${$ad30114c791eb142$export$5db520940cf00715}(
		$query: String!
		$cloudIdARI: String!
		$tenantId: ID!
		$limit: Int!
		$entities: [String!]!
		$queryVersion: Int
		$searchSessionId: String
		$commonFilters: SearchCommonFilter
		$confluenceFilters: SearchConfluenceFilter
		$jiraFilters: SearchJiraFilter
		$thirdPartyFilters:  SearchThirdPartyFilter
		$sort: [SearchSortInput]
		$sourceProduct: String
		$experimentId: String
		$shadowExperimentId: String
		$experimentLayers: [SearchExperimentLayer]
		$after: String
		$disableQueryReplacement: Boolean
	) {
		search {
			results: search(
				experience: "search-page"
				query: $query
				first: $limit
				after: $after
				sort: $sort
				disableQueryReplacement: $disableQueryReplacement
				filters: {
					entities: $entities
					locations: [$cloudIdARI]
					commonFilters: $commonFilters
					confluenceFilters: $confluenceFilters
					jiraFilters: $jiraFilters
					thirdPartyFilters: $thirdPartyFilters
				}
		analytics: {
					queryVersion: $queryVersion
					searchSessionId: $searchSessionId
					sourceProduct: $sourceProduct
				}
		experimentContext: {
			experimentId: $experimentId
			shadowExperimentId: $shadowExperimentId
			experimentLayers: $experimentLayers
		}
			) {
				edges {
					node {
						${$ad30114c791eb142$export$3f23d3d88b2b0734}
						${partials}
					}
				}
				queryInfo {
					originalQuery
					replacementQuery
					originalQueryType
					confidenceScore
					shouldTriggerAutocorrectionExperience
				}
				abTest {
					abTestId
					controlId
					experimentId
				}
				totalCount
				totalCounts {
					product
					count
				}
        pageInfo {
          endCursor
        }
			}
		}
	}
	`;
    return graphQuery;
};
const $ad30114c791eb142$export$59ff8b98cf7da770 = 'ResultsCountQuery';
const $ad30114c791eb142$export$35addfdbe1c7b563 = ()=>{
    const graphQuery = `
	query ${$ad30114c791eb142$export$59ff8b98cf7da770}(
		$query: String!
		$cloudIdARI: String!
		$limit: Int!
		$entities: [String!]!
		$queryVersion: Int
		$searchSessionId: String
		$commonFilters: SearchCommonFilter
		$confluenceFilters: SearchConfluenceFilter
		$jiraFilters: SearchJiraFilter
		$thirdPartyFilters:  SearchThirdPartyFilter
		$sort: [SearchSortInput]
		$sourceProduct: String
		$experimentId: String
		$shadowExperimentId: String
		$experimentLayers: [SearchExperimentLayer]
		$disableQueryReplacement: Boolean
	) {
		search {
			results: search(
				experience: "search-page"
				query: $query
				first: $limit
				sort: $sort
				disableQueryReplacement: $disableQueryReplacement
				filters: {
					entities: $entities
					locations: [$cloudIdARI]
					commonFilters: $commonFilters
					confluenceFilters: $confluenceFilters
					jiraFilters: $jiraFilters
					thirdPartyFilters: $thirdPartyFilters
				}
		analytics: {
					queryVersion: $queryVersion
					searchSessionId: $searchSessionId
					sourceProduct: $sourceProduct
				}
		experimentContext: {
			experimentId: $experimentId
			shadowExperimentId: $shadowExperimentId
			experimentLayers: $experimentLayers
		}
			) {

				queryInfo {
					originalQuery
					replacementQuery
					originalQueryType
					confidenceScore
					shouldTriggerAutocorrectionExperience
				}
				abTest {
					abTestId
					controlId
					experimentId
				}
				totalCount
				totalCounts {
					product
					count
				}
			}
		}
	}
	`;
    return graphQuery;
};


const $e4c8e49c6682f0a7$export$69a3209f1a06c04d = (0, $1EqNn.inMemoryCache)();
const $e4c8e49c6682f0a7$export$a4f9b7f788f9e71f = (variables, originalQuery)=>{
    /**
	 * Results once fetched will be used for upto 15 minutes from an in memory cache.
	 * 1. Generate key based on query, entities, filters
	 * 2. Serve from cache if present without resetting the expiration, evict if results are expired
	 * 3. If not present or expired then invoke the api
	 * 4. If API is invoked then store response in the cache with expiration and return back the response
	 */ const keyObj = {
        query: variables.query,
        entities: variables.entities,
        commonFilters: variables.commonFilters,
        confluenceFilters: variables.confluenceFilters,
        jiraFilters: variables.jiraFilters,
        thirdPartyFilters: variables.thirdPartyFilters,
        cloudIdARI: variables.cloudIdARI,
        sortField: variables.sort.at(0)?.field ?? '',
        sortOrder: variables.sort.at(0)?.order ?? '',
        after: variables.after,
        originalQuery: originalQuery
    };
    return (0, $gtxdb.generateHashFromVariables)(keyObj);
};
// Expire the cache if there are errors or edges are empty
const $e4c8e49c6682f0a7$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    return data.search.results.edges.length === 0;
};
const $e4c8e49c6682f0a7$export$8d55189398f4cde7 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery })=>{
    const graphQuery = (0, $ad30114c791eb142$export$bcad4d0714f0772f)();
    return $e4c8e49c6682f0a7$export$69a3209f1a06c04d.inMemoryDecorator($e4c8e49c6682f0a7$export$a4f9b7f788f9e71f(variables, originalQuery), ()=>(0, $4mTS8.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: $ad30114c791eb142$export$5db520940cf00715
        }), $e4c8e49c6682f0a7$var$expireWhen);
};
const $e4c8e49c6682f0a7$export$3dbd5bda6e5269b6 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery })=>{
    const graphQuery = (0, $ad30114c791eb142$export$35addfdbe1c7b563)();
    return $e4c8e49c6682f0a7$export$69a3209f1a06c04d.inMemoryDecorator($e4c8e49c6682f0a7$export$a4f9b7f788f9e71f(variables, originalQuery), ()=>(0, $4mTS8.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: (0, $ad30114c791eb142$export$59ff8b98cf7da770)
        }));
};
module.exports["cache"] = $e4c8e49c6682f0a7$export$69a3209f1a06c04d;
module.exports["searchPageQuery"] = $e4c8e49c6682f0a7$export$8d55189398f4cde7;
module.exports["resultsCountQuery"] = $e4c8e49c6682f0a7$export$3dbd5bda6e5269b6;

});

parcelRegister("4ERNs", function(module, exports) {
const $30c4571a19104026$export$fdf34174678f07b6 = {
    LAST_MODIFIED_DATE: 'latestModifiedDate',
    CREATED_DATE: 'createdDate'
};
const $30c4571a19104026$export$d33cb9b119034d29 = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $30c4571a19104026$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC = `${$30c4571a19104026$export$fdf34174678f07b6.LAST_MODIFIED_DATE}${$30c4571a19104026$export$d33cb9b119034d29.DESC}`;
const $30c4571a19104026$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC = `${$30c4571a19104026$export$fdf34174678f07b6.LAST_MODIFIED_DATE}${$30c4571a19104026$export$d33cb9b119034d29.ASC}`;
const $30c4571a19104026$var$SORT_FIELD_KEY_CREATED_DATE_DESC = `${$30c4571a19104026$export$fdf34174678f07b6.CREATED_DATE}${$30c4571a19104026$export$d33cb9b119034d29.DESC}`;
const $30c4571a19104026$var$SORT_FIELD_KEY_CREATED_DATE_ASC = `${$30c4571a19104026$export$fdf34174678f07b6.CREATED_DATE}${$30c4571a19104026$export$d33cb9b119034d29.ASC}`;
const $30c4571a19104026$export$6b492fdcc7e8d1f4 = {
    [$30c4571a19104026$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC]: {
        field: $30c4571a19104026$export$fdf34174678f07b6.LAST_MODIFIED_DATE,
        order: $30c4571a19104026$export$d33cb9b119034d29.DESC,
        labelKey: $30c4571a19104026$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC,
        selectedLabelKey: `${$30c4571a19104026$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC}Selected`,
        drawerOrder: 0
    },
    [$30c4571a19104026$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC]: {
        field: $30c4571a19104026$export$fdf34174678f07b6.LAST_MODIFIED_DATE,
        order: $30c4571a19104026$export$d33cb9b119034d29.ASC,
        labelKey: $30c4571a19104026$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC,
        selectedLabelKey: `${$30c4571a19104026$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC}Selected`,
        drawerOrder: 1
    },
    [$30c4571a19104026$var$SORT_FIELD_KEY_CREATED_DATE_DESC]: {
        field: $30c4571a19104026$export$fdf34174678f07b6.CREATED_DATE,
        order: $30c4571a19104026$export$d33cb9b119034d29.DESC,
        labelKey: $30c4571a19104026$var$SORT_FIELD_KEY_CREATED_DATE_DESC,
        selectedLabelKey: `${$30c4571a19104026$var$SORT_FIELD_KEY_CREATED_DATE_DESC}Selected`,
        drawerOrder: 2
    },
    [$30c4571a19104026$var$SORT_FIELD_KEY_CREATED_DATE_ASC]: {
        field: $30c4571a19104026$export$fdf34174678f07b6.CREATED_DATE,
        order: $30c4571a19104026$export$d33cb9b119034d29.ASC,
        labelKey: $30c4571a19104026$var$SORT_FIELD_KEY_CREATED_DATE_ASC,
        selectedLabelKey: `${$30c4571a19104026$var$SORT_FIELD_KEY_CREATED_DATE_ASC}Selected`,
        drawerOrder: 3
    }
};
const $30c4571a19104026$export$76673e1b214c1378 = Object.values($30c4571a19104026$export$6b492fdcc7e8d1f4).sort((a, b)=>a.drawerOrder - b.drawerOrder);
const $30c4571a19104026$export$d3cbda30e53df6f6 = (field, order)=>`${field}${order}`;
module.exports["SORT_FIELD_KEY"] = $30c4571a19104026$export$fdf34174678f07b6;
module.exports["SORT_ORDER"] = $30c4571a19104026$export$d33cb9b119034d29;
module.exports["RESULTS_SORT_FIELDS"] = $30c4571a19104026$export$6b492fdcc7e8d1f4;
module.exports["ResultsSortOptions"] = $30c4571a19104026$export$76673e1b214c1378;
module.exports["getOptionKey"] = $30c4571a19104026$export$d3cbda30e53df6f6;

});

parcelRegister("33vwh", function(module, exports) {

var $2nDCB = parcelRequire("2nDCB");


var $4sOnC = parcelRequire("4sOnC");


var $7tGzv = parcelRequire("7tGzv");


var $k6Hr4 = parcelRequire("k6Hr4");

const $0710dce45ffd38a7$var$GOOGLE_INTEGRATION_ARI = 'ari:cloud:platform::integration/google';
const $0710dce45ffd38a7$var$MICROSOFT_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $0710dce45ffd38a7$var$WEB_CRAWLER_INTEGRATION_ARI = 'ari:cloud:platform::integration/atlassian-web-crawler';
const $0710dce45ffd38a7$var$GITHUB_INTEGRATION_ARI = 'ari:cloud:platform::integration/github';
const $0710dce45ffd38a7$var$TEAMS_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $0710dce45ffd38a7$var$FIGMA_INTEGRATION_ARI = 'ari:cloud:platform::integration/figma';
const $0710dce45ffd38a7$var$LOOM_INTEGRATION_ARI = 'ari:cloud:platform::integration/loom';
const $0710dce45ffd38a7$var$DROPBOX_INTEGRATION_ARI = 'ari:cloud:platform::integration/dropbox';
const $0710dce45ffd38a7$var$SLACK_INTEGRATION_ARI = 'ari:cloud:platform::integration/slack';
const $0710dce45ffd38a7$var$AIRTABLE_INTEGRATION_ARI = 'ari:cloud:platform::integration/airtable';
const $0710dce45ffd38a7$var$BITBUCKET_INTEGRATION_ARI = 'ari:cloud:platform::integration/bitbucket';
const $0710dce45ffd38a7$var$NOTION_INTEGRATION_ARI = 'ari:cloud:platform::integration/notion';
const $0710dce45ffd38a7$var$MIRO_INTEGRATION_ARI = 'ari:cloud:platform::integration/miro';
const $0710dce45ffd38a7$export$b7b676578c62639d = ()=>({
        commonFilters: {},
        confluenceFilters: {
            spacesFilter: [],
            contributorsFilter: [],
            ancestorIdsFilter: [],
            range: [],
            owners: [],
            labelsFilter: []
        },
        jiraFilters: {
            issueFilter: {
                assigneeARIs: [],
                projectARIs: []
            }
        },
        thirdPartyFilters: {
            titleMatchOnly: false,
            subtypes: [],
            integrations: []
        }
    });
const $0710dce45ffd38a7$export$79cd775d0d5c2a2 = (from, to)=>{
    const fromDate = from ? new Date(from) : new Date();
    const startOfTheFromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), 0, 0, 0, 0);
    const toDate = to ? new Date(to) : new Date();
    const endOfTheToDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), 23, 59, 59, 999);
    return {
        gt: from ? startOfTheFromDate.toISOString().split('Z')[0] : undefined,
        lt: to ? endOfTheToDate.toISOString().split('Z')[0] : undefined
    };
};
const $0710dce45ffd38a7$export$8db446d8af54b4b5 = (fromOffset, toOffset)=>{
    const currentDate = new Date();
    return {
        gt: new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()).getTime() - fromOffset * 86400000).toISOString().split('Z')[0],
        lt: new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59, 999).getTime() - toOffset * 86400000).toISOString().split('Z')[0]
    };
};
const $0710dce45ffd38a7$export$50da93f10cdc6a84 = (lastUpdated)=>{
    let dateRangeValues;
    switch(lastUpdated){
        case 'today':
            dateRangeValues = $0710dce45ffd38a7$export$8db446d8af54b4b5(0, 0);
            break;
        case 'yesterday':
            dateRangeValues = $0710dce45ffd38a7$export$8db446d8af54b4b5(1, 1);
            break;
        case 'past7Days':
            dateRangeValues = $0710dce45ffd38a7$export$8db446d8af54b4b5(7, 0);
            break;
        case 'past30Days':
            dateRangeValues = $0710dce45ffd38a7$export$8db446d8af54b4b5(30, 0);
            break;
        case 'pastYear':
            dateRangeValues = $0710dce45ffd38a7$export$8db446d8af54b4b5(365, 0);
            break;
        default:
            dateRangeValues = {
                gt: '',
                lt: ''
            };
    }
    return dateRangeValues;
};
const $0710dce45ffd38a7$export$e048252fb7949a77 = (from, to)=>{
    const { gt: gt, lt: lt } = $0710dce45ffd38a7$export$79cd775d0d5c2a2(from, to);
    return {
        field: 'LASTMODIFIED',
        gt: gt,
        lt: lt
    };
};
const $0710dce45ffd38a7$export$405f2efecb6f5de6 = (selectedDateOption)=>{
    const dateRangeValues = $0710dce45ffd38a7$export$50da93f10cdc6a84(selectedDateOption);
    const { gt: gt, lt: lt } = dateRangeValues;
    return {
        field: 'LASTMODIFIED',
        gt: gt,
        lt: lt
    };
};
const $0710dce45ffd38a7$export$d82a82f2333502ad = {
    [(0, $7tGzv.ProductKey).GoogleDrive]: $0710dce45ffd38a7$var$GOOGLE_INTEGRATION_ARI,
    [(0, $7tGzv.ProductKey).Sharepoint]: $0710dce45ffd38a7$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $7tGzv.ProductKey).AtlassianWebCrawler]: $0710dce45ffd38a7$var$WEB_CRAWLER_INTEGRATION_ARI,
    [(0, $7tGzv.ProductKey).Teams]: $0710dce45ffd38a7$var$TEAMS_INTEGRATION_ARI,
    [(0, $7tGzv.ProductKey).Figma]: $0710dce45ffd38a7$var$FIGMA_INTEGRATION_ARI,
    [(0, $7tGzv.ProductKey).Loom]: $0710dce45ffd38a7$var$LOOM_INTEGRATION_ARI,
    [(0, $7tGzv.ProductKey).OneDrive]: $0710dce45ffd38a7$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $7tGzv.ProductKey).Github]: $0710dce45ffd38a7$var$GITHUB_INTEGRATION_ARI,
    [(0, $7tGzv.ProductKey).Airtable]: $0710dce45ffd38a7$var$AIRTABLE_INTEGRATION_ARI,
    [(0, $7tGzv.ProductKey).Notion]: $0710dce45ffd38a7$var$NOTION_INTEGRATION_ARI,
    [(0, $7tGzv.ProductKey).Miro]: $0710dce45ffd38a7$var$MIRO_INTEGRATION_ARI
};
const $0710dce45ffd38a7$export$3766c9ce0c94452 = (products, titleMatchValue, entities, outboundAuthConfigs, baseIntegrationARIs, range)=>{
    if (!products.length || products.some((p)=>(0, $4sOnC.products)[p]?.is3P || p === (0, $7tGzv.ProductKey).Bitbucket)) {
        const typeMapping = (0, $k6Hr4.getTypeMapping)();
        // Conditionally create the dynamic integration ARIs based on the config
        const getIntegrationARIsFromConfig = ()=>{
            const integrationMap = {};
            (0, $2nDCB.ThirdPartyConfigs).forEach((config, productKey3P)=>{
                if (config.isEnabled()) integrationMap[productKey3P] = config.integrationAri;
            });
            return integrationMap;
        };
        const integrationARIsFromConfig = getIntegrationARIsFromConfig();
        // Combine static and dynamic integration ARIs
        // fg('rovo-full-page-search-3p-static-config') => false
        let productToIntegrationARIMap = baseIntegrationARIs;
        {
            productToIntegrationARIMap = {
                ...productToIntegrationARIMap,
                [(0, $7tGzv.ProductKey).Dropbox]: $0710dce45ffd38a7$var$DROPBOX_INTEGRATION_ARI
            };
            const isAllSelectedAndSlackAllDisabled = products.length > 1 && true;
            if (!isAllSelectedAndSlackAllDisabled) productToIntegrationARIMap = {
                ...productToIntegrationARIMap,
                [(0, $7tGzv.ProductKey).Slack]: $0710dce45ffd38a7$var$SLACK_INTEGRATION_ARI
            };
        }
        // get the subtypes by looking at each type's subcategories
        const subtypes = entities.flatMap((entity)=>typeMapping[entity]?.subCategories ?? []);
        if (Object.keys(productToIntegrationARIMap).length !== 0) {
            const integrationARIs = products.filter((product)=>!(0, $4sOnC.products)[product]?.is3P || !outboundAuthConfigs[product]?.userNeedsOAuth).map((product)=>productToIntegrationARIMap[product]).filter((ari)=>!!ari)//remove duplicates (eg sharepoint, teams)
            .filter((ari, pos, arr)=>{
                return arr.indexOf(ari) === pos;
            });
            return {
                range: range,
                titleMatchOnly: titleMatchValue,
                subtypes: subtypes,
                integrations: integrationARIs
            };
        } else return {
            range: range,
            titleMatchOnly: titleMatchValue,
            subtypes: subtypes
        };
    }
    return {
        titleMatchOnly: false,
        subtypes: [],
        integrations: []
    };
};
var $0710dce45ffd38a7$export$b367612b2293421c = /*#__PURE__*/ function(DateRangeError) {
    DateRangeError["FROM_AFTER_TO_ERROR"] = "fromAfterToError";
    DateRangeError["FROM_IN_FUTURE_ERROR"] = "fromInFutureError";
    DateRangeError["TO_IN_FUTURE_ERROR"] = "toInFutureError";
    return DateRangeError;
}({});
const $0710dce45ffd38a7$export$d3eb8baea7b2ff96 = (from, to)=>{
    if (!from && !to) return null;
    const dateFrom = new Date(`${from}${from ? 'T00:00:00' : ''}`);
    const dateTo = new Date(`${to}${to ? 'T00:00:00' : ''}`);
    if (dateFrom > dateTo) return "fromAfterToError";
    return null;
};
const $0710dce45ffd38a7$export$ef6dfb919b1d7267 = (filterId)=>{
    const productsForFilter = [];
    (0, $2nDCB.ThirdPartyConfigs).forEach((_, productKey3P)=>{
        if ((0, $2nDCB.ThirdPartyConfigs).get(productKey3P)?.filters?.includes(filterId)) productsForFilter.push(productKey3P);
    });
    return productsForFilter;
};
module.exports["getEmptySelectedFilters"] = $0710dce45ffd38a7$export$b7b676578c62639d;
module.exports["convertCustomDateToRange"] = $0710dce45ffd38a7$export$79cd775d0d5c2a2;
module.exports["convertLastUpdatedToDateRange"] = $0710dce45ffd38a7$export$50da93f10cdc6a84;
module.exports["getConfluenceDateOptionFromCustomDates"] = $0710dce45ffd38a7$export$e048252fb7949a77;
module.exports["getConfluenceDateOptionValues"] = $0710dce45ffd38a7$export$405f2efecb6f5de6;
module.exports["baseIntegrationARIs"] = $0710dce45ffd38a7$export$d82a82f2333502ad;
module.exports["getThirdPartyFilters"] = $0710dce45ffd38a7$export$3766c9ce0c94452;
module.exports["DateRangeError"] = $0710dce45ffd38a7$export$b367612b2293421c;
module.exports["getInvalidDateRange"] = $0710dce45ffd38a7$export$d3eb8baea7b2ff96;
module.exports["getProducts3PFromConfigForFilter"] = $0710dce45ffd38a7$export$ef6dfb919b1d7267;

});

parcelRegister("4sOnC", function(module, exports) {
/* products.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gtD4K = parcelRequire("gtD4K");


var $4Nwes = parcelRequire("4Nwes");

var $lAFHW = parcelRequire("lAFHW");


var $2nDCB = parcelRequire("2nDCB");


var $eMyDT = parcelRequire("eMyDT");


var $htLpQ = parcelRequire("htLpQ");


var $ia5aS = parcelRequire("ia5aS");




parcelRequire("42omo");

const $711be8f8697ea568$export$b0a52366c3fb9b = (_)=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M15.555 30.1532C8.07887 30.1532 2 24.0743 2 16.5981C2 9.12199 8.07887 3.04312 15.555 3.04312V5.2012C9.26799 5.2012 4.15883 10.3104 4.15883 16.5974C4.15883 22.8844 9.26799 27.9936 15.555 27.9936V30.1517V30.1532Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M15.5547 30.1532V27.9951C21.8417 27.9951 26.9509 22.8859 26.9509 16.5989H29.109C29.109 24.075 23.0301 30.1539 15.554 30.1539L15.5547 30.1532Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M29.1099 16.5981H26.9519C26.9519 10.3111 21.8427 5.20194 15.5557 5.20194V3.04385C23.0318 3.04385 29.1107 9.12272 29.1107 16.5989L29.1099 16.5981Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M21.3291 20.7481C19.8899 20.4665 18.7539 19.9558 16.8662 19.1007C16.345 18.8715 15.7714 18.611 15.1147 18.3189C14.7186 18.1415 14.3539 17.985 13.9885 17.8292C11.1422 16.5674 9.57795 15.8793 7.65948 15.8793C6.31461 15.8793 5.30297 16.244 4.73986 16.9321C4.35422 17.3911 4.19772 17.985 4.31229 18.5585L2.19539 18.9652C1.96625 17.7558 2.27851 16.515 3.0715 15.5558C3.75966 14.7216 5.11502 13.7205 7.65948 13.7205C10.037 13.7205 11.9554 14.5756 14.8646 15.8583C15.2188 16.0148 15.5842 16.1818 15.9803 16.348C16.6475 16.6401 17.2316 16.9007 17.7527 17.1403C19.5566 17.9535 20.5473 18.402 21.7462 18.6312L21.3291 20.7481V20.7481Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M23.437 20.9562C22.7174 20.9562 22.0292 20.8933 21.3306 20.7481L21.7477 18.6312C22.3108 18.7457 22.8634 18.7982 23.437 18.7982C24.7714 18.7982 25.783 18.4642 26.3671 17.8284C26.9512 17.1927 26.9721 16.4207 26.9407 16.0141L29.0883 15.8261C29.2028 17.1395 28.8067 18.3706 27.9621 19.2879C27.2634 20.0487 25.9185 20.9562 23.437 20.9562Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M15.555 30.1531V27.9951C18.652 27.9951 20.4971 24.8358 20.4971 19.5492C20.4971 14.2626 18.6206 9.83109 14.7732 5.73358L16.3479 4.25317C20.5915 8.76777 22.656 13.7728 22.656 19.5492C22.656 26.0871 19.9348 30.1531 15.555 30.1531V30.1531Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M15.5535 30.1532C10.8929 30.1532 8.22339 26.3582 8.22339 19.7372C8.22339 12.0109 11.602 7.69399 14.7613 4.26367L16.3465 5.72311C12.6661 9.72702 10.3822 13.4599 10.3822 19.7364C10.3822 26.5656 13.1978 27.9943 15.5543 27.9943V30.1524L15.5535 30.1532Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M9.77765 17.7244C11.1712 17.7244 12.3012 16.5944 12.3012 15.2009C12.3012 13.8073 11.1712 12.6774 9.77765 12.6774C8.38411 12.6774 7.25415 13.8073 7.25415 15.2009C7.25415 16.5944 8.38411 17.7244 9.77765 17.7244Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M21.4429 22.0727C22.8365 22.0727 23.9664 20.9427 23.9664 19.5492C23.9664 18.1556 22.8365 17.0257 21.4429 17.0257C20.0494 17.0257 18.9194 18.1556 18.9194 19.5492C18.9194 20.9427 20.0494 22.0727 21.4429 22.0727V22.0727Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M15.5526 7.047C16.9461 7.047 18.0761 5.91704 18.0761 4.5235C18.0761 3.12996 16.9461 2 15.5526 2C14.159 2 13.0291 3.12996 13.0291 4.5235C13.0291 5.91704 14.159 7.047 15.5526 7.047V7.047Z",
                fill: "#1868DB"
            })
        ]
    });





parcelRequire("42omo");

const $c97c1cd67134df77$export$93ca83db1787dea = (_)=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                clipPath: "url(#clip0_6321_165872)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M26.4672 20.5704C19.2874 16.9391 17.1899 16.3965 14.1647 16.3965C10.6151 16.3965 7.58992 17.9409 4.88739 22.2817L4.4437 22.9913C4.08067 23.5757 4 23.7843 4 24.0348C4 24.2852 4.12101 24.4939 4.56471 24.7861L9.12269 27.7496C9.36471 27.9165 9.56639 28 9.76807 28C10.0101 28 10.1714 27.8748 10.4134 27.4991L11.1395 26.3304C12.2689 24.5357 13.2773 23.9513 14.5681 23.9513C15.6975 23.9513 17.0286 24.2852 18.6824 25.12L23.442 27.4574C23.9261 27.7078 24.4504 27.5826 24.6924 26.9983L26.9513 21.8226C27.1933 21.2383 27.0319 20.8626 26.4672 20.5704ZM5.53277 11.4296C12.7126 15.0609 14.8101 15.6035 17.8353 15.6035C21.3849 15.6035 24.4101 14.0591 27.1126 9.71826L27.5563 9.0087C27.9193 8.42435 28 8.21565 28 7.96522C28 7.71478 27.879 7.50609 27.4353 7.21391L22.8773 4.25043C22.6353 4.08348 22.4336 4 22.2319 4C21.9899 4 21.8286 4.12522 21.5866 4.50087L20.8605 5.66957C19.7311 7.46435 18.7227 8.0487 17.4319 8.0487C16.3025 8.0487 14.9714 7.71478 13.3176 6.88L8.55798 4.54261C8.07395 4.29217 7.54958 4.41739 7.30756 5.00174L5.04874 10.1774C4.80672 10.7617 4.96807 11.1374 5.53277 11.4296Z",
                    fill: "#357DE8"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_6321_165872",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white",
                        transform: "translate(4 4)"
                    })
                })
            })
        ]
    });



var $lC6Bo = parcelRequire("lC6Bo");


var $kNd5F = parcelRequire("kNd5F");


var $cFnPW = parcelRequire("cFnPW");


var $jIZgI = parcelRequire("jIZgI");


var $aZEPk = parcelRequire("aZEPk");


var $72WyQ = parcelRequire("72WyQ");


var $6sPwH = parcelRequire("6sPwH");


var $1tp1E = parcelRequire("1tp1E");


var $5ErYS = parcelRequire("5ErYS");




parcelRequire("42omo");

const $b17a0819c372f444$export$f68d29dbb4f2da82 = (_)=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M16 14V16M16 18V16M16 16H18M16 16H14",
                stroke: "#E2483D",
                strokeWidth: "0.0333333",
                strokeDasharray: "0.13 0.13"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                clipPath: "url(#clip0_6321_165880)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M11.7181 20.2933H9.56828C6.32599 20.2933 4 18.3226 4 15.4369H15.5595C16.1586 15.4369 16.5463 15.8592 16.5463 16.4575V28C13.6564 28 11.7181 25.6774 11.7181 22.4399V20.2933ZM17.4273 14.5572H15.2775C12.0352 14.5572 9.70925 12.6217 9.70925 9.73607H21.2687C21.8678 9.73607 22.2907 10.1232 22.2907 10.7214V22.2639C19.4009 22.2639 17.4273 19.9413 17.4273 16.7038V14.5572ZM23.1718 8.85631H21.022C17.7797 8.85631 15.4537 6.88563 15.4537 4H27.0132C27.6123 4 28 4.42229 28 4.98534V16.5279C25.1101 16.5279 23.1718 14.2053 23.1718 10.9677V8.85631Z",
                    fill: "#357DE8"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_6321_165880",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white",
                        transform: "translate(4 4)"
                    })
                })
            })
        ]
    });



var $c7WVa = parcelRequire("c7WVa");


var $hy7mW = parcelRequire("hy7mW");


var $gQ6Bq = parcelRequire("gQ6Bq");


var $IzNHb = parcelRequire("IzNHb");


var $kqu9k = parcelRequire("kqu9k");


var $6RO5S = parcelRequire("6RO5S");


var $lTHwu = parcelRequire("lTHwu");


var $1gvAG = parcelRequire("1gvAG");


var $b4FVC = parcelRequire("b4FVC");


var $77KdG = parcelRequire("77KdG");


var $i26Jf = parcelRequire("i26Jf");


var $dHucp = parcelRequire("dHucp");


var $97rBY = parcelRequire("97rBY");


var $c3jFl = parcelRequire("c3jFl");


var $k1Fwx = parcelRequire("k1Fwx");


var $djVXt = parcelRequire("djVXt");


var $c5nm0 = parcelRequire("c5nm0");

const $84105b4cf221b92c$var$iconStyles = null;
const $84105b4cf221b92c$var$iconSizeStyles = {
    small: "_1lve7vkz _1pww7vkz",
    medium: "_1lve1tcg _1pww1tcg",
    large: "_1lvezwfg _1pwwzwfg"
};
const $84105b4cf221b92c$var$ProductKeys1P = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    Opsgenie: 'opsgenie',
    Trello: 'trello'
};
const $84105b4cf221b92c$export$93aa518ca2694c2d = (0, $2nDCB.DO_NOT_IMPORT_ProductKeys3P);
const $84105b4cf221b92c$export$ef2c0ffddaaaf76c = {
    ...$84105b4cf221b92c$var$ProductKeys1P,
    ...(0, $2nDCB.DO_NOT_IMPORT_ProductKeys3P)
};
const $84105b4cf221b92c$export$73be91b73ebbdb05 = Object.values($84105b4cf221b92c$export$ef2c0ffddaaaf76c);
const $84105b4cf221b92c$export$57043b2770b3924d = Object.values((0, $2nDCB.DO_NOT_IMPORT_ProductKeys3P));
const $84105b4cf221b92c$export$225f36a2f261b1e7 = Object.values($84105b4cf221b92c$var$ProductKeys1P);
const $84105b4cf221b92c$export$ae4856d6227d0649 = (key)=>$84105b4cf221b92c$export$57043b2770b3924d.includes(key); // This is different to ProductKeys, it represents products we have support for mounting Search Page in
const $84105b4cf221b92c$export$15d12effc8830544 = {
    // Fully supported as GA
    Atlas: 'townsquare',
    Confluence: 'confluence',
    // In development
    Jira: 'jira',
    Mercury: 'mercury',
    Elevate: 'elevate'
};
const $84105b4cf221b92c$var$sizesCorrection = {
    xxsmall: 'small',
    small: 'medium',
    medium: 'large'
};
const $84105b4cf221b92c$export$16b26cd5e98d9100 = ({ label: label, icon: icon })=>{
    return ({ size: size = 'medium' })=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
            className: (0, $gMc0m.default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o",
                $84105b4cf221b92c$var$iconSizeStyles[$84105b4cf221b92c$var$sizesCorrection[size]]
            ]),
            children: icon({
                'aria-label': label
            })
        });
}; /**
    * This is the source of truth for the products that are supported in Full Page Search.
    * Note: there is additional logic in controllers/store/bootstrap/utils.ts for products being rolled out.
    *
    * QS-5444 3P references in this object are being deprecated. Please add to ./3p-product-configs
    */ 
const $84105b4cf221b92c$export$b6aad051bad07f12 = {
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.Confluence]: {
        displayName: 'Confluence',
        Icon: (0, $lAFHW.ConfluenceIcon),
        SearchResultIcon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $c97c1cd67134df77$export$93ca83db1787dea),
            label: 'Confluence'
        })
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.Atlas]: {
        displayName: 'Atlas',
        Icon: (0, $4Nwes.AtlassianIcon),
        SearchResultIcon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $711be8f8697ea568$export$b0a52366c3fb9b),
            label: (0, $c5nm0.messages).atlas.defaultMessage
        })
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.Jira]: {
        displayName: 'Jira',
        Icon: (0, $lAFHW.JiraIcon),
        SearchResultIcon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $b17a0819c372f444$export$f68d29dbb4f2da82),
            label: 'Jira'
        })
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.JiraProductDiscovery]: {
        displayName: 'Jira Product Discovery',
        Icon: (0, $lAFHW.JiraProductDiscoveryIcon)
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.JiraServiceManagement]: {
        displayName: 'Jira Service Management',
        Icon: (0, $lAFHW.JiraServiceManagementIcon)
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.Bitbucket]: {
        displayName: 'Bitbucket',
        Icon: (0, $lAFHW.BitbucketIcon),
        SearchResultIcon: (0, $lAFHW.BitbucketIcon)
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.Trello]: {
        displayName: 'Trello',
        Icon: (0, $lAFHW.TrelloIcon)
    },
    // [ProductKeys.Opsgenie]: {
    // 	displayName: 'Opsgenie',
    // 	Icon: OpsgenieIcon,
    // },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.Compass]: {
        displayName: 'Compass',
        Icon: (0, $lAFHW.CompassIcon)
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.GoogleDrive]: {
        displayName: 'Google Drive',
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        Icon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $1tp1E.GoogleDriveIcon),
            label: 'Google Drive'
        }),
        is3P: true,
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        SearchResultIcon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $5ErYS.GoogleDriveSearchResultIcon),
            label: 'Google Drive'
        })
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.Sharepoint]: {
        displayName: 'Microsoft SharePoint',
        Icon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $1gvAG.SharePointIcon),
            label: (0, $c5nm0.messages).sharepoint.defaultMessage
        }),
        is3P: true,
        SearchResultIcon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $b4FVC.SharePointSearchResultIcon),
            label: (0, $c5nm0.messages).sharepoint.defaultMessage
        })
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.AtlassianWebCrawler]: {
        displayName: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $c5nm0.messages).webPage
        }),
        Icon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $c3jFl.WebDomainIcon),
            label: (0, $c5nm0.messages).atlassianWebCrawler.defaultMessage
        }),
        is3P: true,
        SearchResultIcon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $k1Fwx.WebDomainSearchResultIcon),
            label: (0, $c5nm0.messages).atlassianWebCrawler.defaultMessage
        })
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.Teams]: {
        displayName: 'Teams',
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        Icon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $dHucp.TeamsIcon),
            label: 'Teams'
        }),
        is3P: true,
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        SearchResultIcon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $97rBY.TeamsSearchResultIcon),
            label: 'Teams'
        })
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.Loom]: {
        displayName: 'Loom',
        Icon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $c7WVa.LoomIcon),
            label: 'Loom'
        }),
        is3P: true
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.OneDrive]: {
        displayName: 'OneDrive',
        Icon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $6RO5S.OneDriveIcon),
            label: 'OneDrive'
        }),
        is3P: true
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.Slack]: {
        displayName: 'Slack',
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        Icon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $77KdG.SlackIcon),
            label: 'Slack'
        }),
        is3P: true,
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        SearchResultIcon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $i26Jf.SlackSearchResultIcon),
            label: 'Slack'
        })
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.Github]: {
        displayName: 'GitHub',
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        Icon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $jIZgI.GithubIcon),
            label: 'Github'
        }),
        is3P: true,
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        SearchResultIcon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $aZEPk.GithubSearchResultIcon),
            label: 'Github'
        })
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.Figma]: {
        displayName: 'Figma',
        Icon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $kNd5F.FigmaIcon),
            label: 'Figma'
        }),
        is3P: true,
        SearchResultIcon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $cFnPW.FigmaSearchResultIcon),
            label: 'Figma'
        })
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.Dropbox]: {
        displayName: 'Dropbox',
        Icon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $lC6Bo.DropboxIcon),
            label: 'Dropbox'
        }),
        is3P: true
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.GoogleCalendar]: {
        displayName: 'Google Calendar',
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        Icon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $6sPwH.GoogleCalendarIcon),
            label: 'Google Calendar'
        }),
        is3P: true
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.Gmail]: {
        displayName: 'Gmail',
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        Icon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $72WyQ.GmailIcon),
            label: 'Gmail'
        }),
        is3P: true
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.OutlookCalendar]: {
        displayName: 'Outlook Calendar',
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        Icon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $lTHwu.OutlookCalendarIcon),
            label: 'Outlook Calendar'
        }),
        is3P: true
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.Airtable]: {
        displayName: 'Airtable',
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        Icon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $htLpQ.AirtableFilterIcon),
            label: 'Airtable'
        }),
        is3P: true,
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        SearchResultIcon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $eMyDT.AirtableIcon),
            label: 'Airtable'
        })
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.Asana]: {
        displayName: 'Asana',
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        Icon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $ia5aS.AsanaIcon),
            label: 'Asana'
        }),
        is3P: true
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.Zendesk]: {
        displayName: 'Zendesk',
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        Icon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $djVXt.ZendeskIcon),
            label: 'Zendesk'
        }),
        is3P: true
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.Notion]: {
        displayName: 'Notion',
        Icon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $kqu9k.NotionFilterIcon),
            label: 'Notion'
        }),
        is3P: true,
        SearchResultIcon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $IzNHb.NotionIcon),
            label: 'Notion'
        })
    },
    [$84105b4cf221b92c$export$ef2c0ffddaaaf76c.Miro]: {
        displayName: 'Miro',
        Icon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $gQ6Bq.MiroFilterIcon),
            label: 'Miro'
        }),
        is3P: true,
        SearchResultIcon: $84105b4cf221b92c$export$16b26cd5e98d9100({
            icon: (0, $hy7mW.MiroIcon),
            label: 'Miro'
        })
    }
};
const $84105b4cf221b92c$export$64c23f2d9ef43822 = [
    $84105b4cf221b92c$export$ef2c0ffddaaaf76c.Confluence,
    $84105b4cf221b92c$export$ef2c0ffddaaaf76c.Jira,
    $84105b4cf221b92c$export$ef2c0ffddaaaf76c.JiraProductDiscovery,
    $84105b4cf221b92c$export$ef2c0ffddaaaf76c.JiraServiceManagement,
    $84105b4cf221b92c$export$ef2c0ffddaaaf76c.Atlas,
    $84105b4cf221b92c$export$ef2c0ffddaaaf76c.Trello,
    $84105b4cf221b92c$export$ef2c0ffddaaaf76c.Bitbucket,
    $84105b4cf221b92c$export$ef2c0ffddaaaf76c.Opsgenie,
    $84105b4cf221b92c$export$ef2c0ffddaaaf76c.Compass,
    ...(0, $2nDCB.DO_NOT_IMPORT_ProductsOrder3P)
];
module.exports["ProductKeys3P"] = $84105b4cf221b92c$export$93aa518ca2694c2d;
module.exports["ProductKeys"] = $84105b4cf221b92c$export$ef2c0ffddaaaf76c;
module.exports["allProductKeys"] = $84105b4cf221b92c$export$73be91b73ebbdb05;
module.exports["all1pProductKeys"] = $84105b4cf221b92c$export$225f36a2f261b1e7;
module.exports["products"] = $84105b4cf221b92c$export$b6aad051bad07f12;

});

parcelRegister("l3R5C", function(module, exports) {
/**
 * @generated SignedSource<<c860b22e6de7771cf930ae9316a43da2>>
 * @relayHash 92c054ec87105eceb11beb31723f69c6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 89e658cd3b2db7689fb583d9d8727c51a184fe45869f170c937504395bf5f105
const $78456055720bf691$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKeys"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKeys",
                    "variableName": "spaceKeys"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useGetSpaceIdFromSpaceKeyQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useGetSpaceIdFromSpaceKeyQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "89e658cd3b2db7689fb583d9d8727c51a184fe45869f170c937504395bf5f105",
            "metadata": {},
            "name": "useGetSpaceIdFromSpaceKeyQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$78456055720bf691$var$node.hash = "b0222c2296e4b6c56b7da0af2f53839f";
var $78456055720bf691$export$2e2bcd8739ae039 = $78456055720bf691$var$node;



var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $gWF6I = parcelRequire("gWF6I");


var $fOKpq = parcelRequire("fOKpq");

const $63271b136a95bbd3$export$50f68914d42bd134 = ()=>{
    const { submitError: submitError } = (0, $fOKpq.useProductDependencies)();
    const environment = (0, $gWF6I.useRelayEnvironmentProvider)().getEnvironment({});
    return (0, $42omo.useCallback)(async (spaceKeys)=>{
        if (spaceKeys.length === 0) return [];
        try {
            const data = await (0, $irOoi.fetchQuery)(environment, (0, $78456055720bf691$export$2e2bcd8739ae039), {
                spaceKeys: spaceKeys
            }).toPromise();
            const spaceIds = (data?.spaces?.nodes ?? []).map((node)=>node?.id ?? '').filter((id)=>!!id);
            return spaceIds;
        } catch (error) {
            submitError?.(error);
        }
        return [];
    }, [
        submitError,
        environment
    ]);
};
module.exports["useGetSpaceIdsFromSpaceKeys"] = $63271b136a95bbd3$export$50f68914d42bd134;

});

parcelRegister("eqHN5", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");





var $42omo = parcelRequire("42omo");


var $jSnXV = parcelRequire("jSnXV");

const $bdcfd319a02b1672$var$WidthObserverContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $bdcfd319a02b1672$export$75f7910544138d14 = ({ children: children })=>{
    const [elements, setElements] = (0, $42omo.useState)({});
    const [callbacks, setCallbacks] = (0, $42omo.useState)({});
    (0, $42omo.useEffect)(()=>{
        const handleResize = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))((entries)=>{
            entries.forEach((entry)=>{
                const id = entry.target.getAttribute('data-width-observer-id');
                if (id && callbacks[id]) {
                    const width = entry.contentRect.width;
                    callbacks[id].forEach((callback)=>callback(width));
                }
            });
        }, 100, {
            leading: true,
            trailing: true
        });
        const observer = new ResizeObserver(handleResize);
        Object.values(elements).forEach((element)=>observer.observe(element));
        return ()=>{
            observer.disconnect();
        };
    }, [
        elements,
        callbacks
    ]);
    const registerElement = (0, $42omo.useCallback)((id, element)=>{
        setElements((prev)=>({
                ...prev,
                [id]: element
            }));
    }, [
        setElements
    ]);
    const unregisterElement = (0, $42omo.useCallback)((id)=>{
        setElements((prev)=>{
            const newElements = {
                ...prev
            };
            delete newElements[id];
            return newElements;
        });
    }, [
        setElements
    ]);
    const subscribe = (0, $42omo.useCallback)((id, callback)=>{
        setCallbacks((prev)=>({
                ...prev,
                [id]: [
                    ...prev[id] || [],
                    callback
                ]
            }));
        return ()=>{
            setCallbacks((prev)=>({
                    ...prev,
                    [id]: (prev[id] || []).filter((cb)=>cb !== callback)
                }));
        };
    }, [
        setCallbacks
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($bdcfd319a02b1672$var$WidthObserverContext.Provider, {
        value: {
            registerElement: registerElement,
            unregisterElement: unregisterElement,
            subscribe: subscribe
        },
        children: children
    });
};
const $bdcfd319a02b1672$export$b78842cb7cd02769 = ()=>{
    const context = (0, $42omo.useContext)($bdcfd319a02b1672$var$WidthObserverContext);
    if (!context) throw new Error('useWidthObserver must be used within a WidthObserverProvider');
    return context;
};
const $bdcfd319a02b1672$export$f8586f54f6b8f867 = ({ id: id, children: children })=>{
    const { registerElement: registerElement, unregisterElement: unregisterElement } = $bdcfd319a02b1672$export$b78842cb7cd02769();
    const elementRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const element = elementRef.current;
        if (element) {
            element.setAttribute('data-width-observer-id', id);
            registerElement(id, element);
        }
        return ()=>{
            unregisterElement(id);
        };
    }, [
        id,
        registerElement,
        unregisterElement
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(children, {
            ref: elementRef
        })
    });
};
const $bdcfd319a02b1672$export$1217913212f99c7 = (id)=>{
    const { subscribe: subscribe } = $bdcfd319a02b1672$export$b78842cb7cd02769();
    const [width, setWidth] = (0, $42omo.useState)(0);
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = subscribe(id, setWidth);
        return ()=>{
            unsubscribe();
        };
    }, [
        id,
        subscribe
    ]);
    return width;
};
const $bdcfd319a02b1672$export$f29cb180c1a7eb72 = ({ target: id, children: children })=>{
    const width = $bdcfd319a02b1672$export$1217913212f99c7(id);
    if (width === 0) return null;
    return children(width);
};
const $bdcfd319a02b1672$var$breakpoints = {
    xxs: 0,
    xs: 480,
    sm: 768,
    md: 1024,
    lg: 1440,
    xl: 1768
};
const $bdcfd319a02b1672$export$c44b7f69e7aa026 = ({ width: width, above: above, below: below })=>{
    return above && width > $bdcfd319a02b1672$var$breakpoints[above] || below && width < $bdcfd319a02b1672$var$breakpoints[below] || false;
};
const $bdcfd319a02b1672$export$f6a3d19be20f5819 = ({ target: target, above: above, below: below, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($bdcfd319a02b1672$export$f29cb180c1a7eb72, {
        target: target,
        children: (width)=>{
            if ($bdcfd319a02b1672$export$c44b7f69e7aa026({
                width: width,
                above: above,
                below: below
            })) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                children: children
            });
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
        }
    });
};
const $bdcfd319a02b1672$export$bed28288a051538 = ({ target: target, above: above, below: below, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($bdcfd319a02b1672$export$f29cb180c1a7eb72, {
        target: target,
        children: (width)=>{
            if ($bdcfd319a02b1672$export$c44b7f69e7aa026({
                width: width,
                above: above,
                below: below
            })) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                children: children
            });
        }
    });
};





parcelRequire("42omo");


var $1s5hv = parcelRequire("1s5hv");

var $u9agA = parcelRequire("u9agA");







// https://atlassian-2y.sentry.io/projects/search-page/getting-started
const $0e0fa44627b55be3$export$6faa4a850bc4d0ce = 'https://dcf49f8a57e71c9e77d30808a7708f8c@o55978.ingest.us.sentry.io/4506951588773888';
const $0e0fa44627b55be3$export$ea77880e3935182d = 'unknown';
const $0e0fa44627b55be3$export$d60e93659f587f71 = {
    companyHub: true
};

/* eslint-disable @repo/internal/react/no-class-components */ 


class $f4f3bef07fb06b6b$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        this.props.onException(error);
    }
    render() {
        if (this.state.error) return this.props.fallback !== undefined ? this.props.fallback : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            error: undefined
        };
    }
}

// @ts-nocheck - extra properties on window are not known
/**
 * Constants for the build version of the product. Each product specifies
 * build version in a different way.
 *  - Jira: window.BUILD_KEY
 *  - Confluence: window.__buildInfo.FRONTEND_VERSION
 */ const $26faa63e2481c818$export$668f31ea3127f48f = window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION;



let $2a1040f7bc0912ba$var$Sentry;
const $2a1040f7bc0912ba$var$getEnvironment = ()=>{
    if (window.location.hostname.includes('localhost')) return 'development';
    else if (window.location.hostname.includes('jira-dev.com') || window.location.hostname.includes('stg.atlassian.com')) return 'staging';
    else return 'production';
};
const $2a1040f7bc0912ba$var$beforeSend = (event)=>{
    if (event.environment === 'development') return null;
    // Ignore errors that do not come from company hub projects
    if (!event.tags?.companyHub) return null;
    // Delete the query string as it contains UGC
    if (event.request?.url) event.request.url = event.request.url.split('?')[0];
    if (event.request?.headers?.Referer) event.request.headers.Referer = event.request.headers.Referer.split('?')[0];
    return event;
};

const $2a1040f7bc0912ba$export$f553e8b08ef59d31 = async ()=>{
    if (!$2a1040f7bc0912ba$var$Sentry) $2a1040f7bc0912ba$var$Sentry = Promise.resolve((parcelRequire("7hGsm"))).then((SentryModule)=>{
        SentryModule.init({
            dsn: (0, $0e0fa44627b55be3$export$6faa4a850bc4d0ce),
            attachStacktrace: true,
            release: (0, $26faa63e2481c818$export$668f31ea3127f48f) || (0, $0e0fa44627b55be3$export$ea77880e3935182d),
            environment: $2a1040f7bc0912ba$var$getEnvironment(),
            beforeSend: $2a1040f7bc0912ba$var$beforeSend
        });
        return SentryModule;
    }).catch(()=>{
    // TODO: Retry mechanism for chunk loading failures?
    });
    return $2a1040f7bc0912ba$var$Sentry;
};



var $5d9b4 = parcelRequire("5d9b4");


var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $cclHy = parcelRequire("cclHy");

var $1P1Tu = parcelRequire("1P1Tu");


var $9NrbM = parcelRequire("9NrbM");

var $5f67793cebea6085$export$a82073022ded66e8 = /*#__PURE__*/ function(UserStatus) {
    UserStatus["Unauthenticated"] = "unauthenticated";
    UserStatus["Anonymous"] = "anonymous";
    UserStatus["Authenticated"] = "authenticated";
    return UserStatus;
}({});



var $fFmb3 = parcelRequire("fFmb3");

const $ee6ce766a2e08634$var$HELLO_TENANT_ID = 'a436116f-02ce-4520-8fbb-7301462a1674';
const $ee6ce766a2e08634$export$d4c72bab9d6cc13a = {
    products: [],
    allFilterExcludedProducts: [],
    outboundAuthConfigs: {},
    searchSessionId: 'searchSessionId',
    queryParams: {},
    prevQueryParams: {},
    initialSpaceARIs: [],
    experimentConfig: {
        backendExperiment: undefined,
        frontendExperiments: undefined
    },
    isNounsAvailable: false,
    features: {
        // These feature defaults are included to be backwards-compatible with initial search implementation forked from search pkg
        quickSearch: {
            enabled: false
        },
        inlineSearch: {
            enabled: true
        },
        autoSuggestion: {
            enabled: true
        },
        recentSearches: {
            enabled: true
        },
        recentViews: {
            enabled: true
        },
        peopleAndTeamsSearch: {
            enabled: true
        },
        fetchInitialResults: {
            enabled: true
        },
        engagement: {
            enabled: true
        }
    }
};
const $ee6ce766a2e08634$export$e324594224ef24da = {
    setState: (partialState)=>({ setState: setState })=>{
            setState(partialState);
        },
    loadUserPicture: ()=>({ setState: setState, getState: getState })=>{
            const userState = getState().user;
            const userId = userState?.id;
            if (!userState || !userId || !!userState.picture) return;
            (0, $9NrbM.userQuery)(userId).then((x)=>{
                setState({
                    user: {
                        id: userState.id,
                        name: userState.name,
                        email: userState.email,
                        picture: x.data?.user.picture ?? null
                    }
                });
            }).catch((_)=>{
            // TODO: >>>> Send warning to sentry
            });
        },
    setQueryParams: (queryParam)=>({}, { queryParams: queryParams, queryParamsCallback: queryParamsCallback = ()=>{} })=>{
            const areEqualQueryParams = (0, $fFmb3.areAllEqualQueryParams)(queryParam, (0, $fFmb3.parseQueryParams)(queryParams ?? {}));
            if (areEqualQueryParams) return;
            queryParamsCallback((0, $fFmb3.toQueryParamsRaw)(queryParam));
        },
    syncQueryParams: ()=>({ setState: setState, getState: getState }, { queryParams: queryParams, queryParamsCallback: queryParamsCallback = ()=>{} })=>{
            // queryParams is the query params coming from the URL or React Router in this case
            const { prevQueryParams: prevQueryParams, queryParams: diffQueryParamsState } = getState();
            const queryParamsURL = (0, $fFmb3.parseQueryParams)(queryParams ?? {});
            const prevQueryParamsString = (0, $fFmb3.toQueryString)(prevQueryParams);
            const diffQueryParamsURLString = (0, $fFmb3.toQueryString)(queryParamsURL);
            const diffQueryParamsStateString = (0, $fFmb3.toQueryString)(diffQueryParamsState);
            const allQueryParamsAreEqual = (0, $fFmb3.areAllEqualQueryParams)(queryParamsURL, prevQueryParams, diffQueryParamsState);
            if (allQueryParamsAreEqual) return;
            // Any changes from the url takes the highest precedence
            const hasURLQueryParams = !!queryParams;
            if (hasURLQueryParams && prevQueryParamsString !== diffQueryParamsURLString) {
                setState({
                    prevQueryParams: queryParamsURL,
                    queryParams: queryParamsURL
                });
                return;
            }
            if (prevQueryParamsString !== diffQueryParamsStateString) {
                //  NOTE: If you are running the callback and you don't see the query params being updated,
                //  the callback might be sanitising the query parameters. This is the case for Confluence.
                queryParamsCallback((0, $fFmb3.toQueryParamsRaw)(diffQueryParamsState));
                setState({
                    prevQueryParams: diffQueryParamsState,
                    queryParams: diffQueryParamsState
                });
                return;
            }
        },
    initializeSpaceARIsFromSpaceKeys: (spaceKeys)=>async ({ setState: setState, getState: getState }, { getSpaceIdsFromSpaceKeys: getSpaceIdsFromSpaceKeys })=>{
            const { cloudId: cloudId } = getState();
            if (spaceKeys.length === 0 || !getSpaceIdsFromSpaceKeys) return;
            const spaceIds = await getSpaceIdsFromSpaceKeys(spaceKeys);
            const spaceARIs = spaceIds.map((id)=>`ari:cloud:confluence:${cloudId}:space/${id}`);
            setState({
                initialSpaceARIs: spaceARIs
            });
        },
    clearSpaceARIs: ()=>({ setState: setState })=>{
            setState({
                initialSpaceARIs: []
            });
        }
};
// Keep store private and use hooks to access state and actions
const $ee6ce766a2e08634$var$Store = (0, $1P1Tu.createStore)({
    initialState: $ee6ce766a2e08634$export$d4c72bab9d6cc13a,
    actions: $ee6ce766a2e08634$export$e324594224ef24da,
    name: 'dynamic-cards-bootstrap'
});
const $ee6ce766a2e08634$var$buildProducts = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((a, b)=>{
    return [
        ...new Set([
            ...a,
            ...b
        ])
    ];
}, (a, b)=>a.join('') + b.join(''));
const $ee6ce766a2e08634$export$7d8c755e49b2156f = (initialState, initialProps)=>{
    const defaultFeatures = initialState.features || {};
    const overrideFeatures = initialProps.features || {};
    // TODO: Fix any
    const mergedFeatures = {
        ...defaultFeatures
    };
    for(const key in overrideFeatures){
        const typedKey = key;
        if (overrideFeatures[typedKey] !== undefined) mergedFeatures[typedKey] = {
            ...defaultFeatures[typedKey],
            ...overrideFeatures[typedKey]
        };
    }
    return mergedFeatures;
};
const $ee6ce766a2e08634$export$557bf45c8d0f5bd = (0, $FOT9i.createContainer)($ee6ce766a2e08634$var$Store, {
    onInit: ()=>({ getState: getState, setState: setState, dispatch: dispatch }, { initialProps: initialProps, queryParams: queryParams })=>{
            const parsedQueryParams = queryParams && (0, $fFmb3.parseQueryParams)(queryParams);
            const initialState = getState();
            const initState = {
                ...initialState,
                ...initialProps,
                ...queryParams && {
                    queryParams: parsedQueryParams
                },
                referrer: parsedQueryParams?.referrer,
                features: $ee6ce766a2e08634$export$7d8c755e49b2156f(initialState, initialProps)
            };
            setState(initState);
            dispatch($ee6ce766a2e08634$export$e324594224ef24da.loadUserPicture());
        },
    onUpdate: ()=>({ setState: setState, getState: getState, dispatch: dispatch }, { initialProps: initialProps, queryParams: queryParams })=>{
            const parsedQueryParams = queryParams && (0, $fFmb3.parseQueryParams)(queryParams);
            const initialState = getState();
            const products = $ee6ce766a2e08634$var$buildProducts(initialState.products, initialProps?.products ?? []);
            setState({
                ...initialState,
                ...initialProps,
                products: products,
                referrer: parsedQueryParams?.referrer,
                features: $ee6ce766a2e08634$export$7d8c755e49b2156f(initialState, initialProps)
            });
            if (parsedQueryParams?.spaces) dispatch($ee6ce766a2e08634$export$e324594224ef24da.initializeSpaceARIsFromSpaceKeys(parsedQueryParams.spaces));
            else dispatch($ee6ce766a2e08634$export$e324594224ef24da.clearSpaceARIs());
            dispatch($ee6ce766a2e08634$export$e324594224ef24da.syncQueryParams());
        }
});
const $ee6ce766a2e08634$export$cf715ed8590c209b = (0, $9zUhf.createActionsHook)($ee6ce766a2e08634$var$Store);
const $ee6ce766a2e08634$export$9ba1f1f28043c5bf = (0, $9zUhf.createHook)($ee6ce766a2e08634$var$Store);
const $ee6ce766a2e08634$export$1fd8522aeddaccda = (0, $9zUhf.createHook)($ee6ce766a2e08634$var$Store, {
    selector: (state)=>state.analyticsAttributes
});
const $ee6ce766a2e08634$export$5afbfe6edea8e998 = (0, $9zUhf.createHook)($ee6ce766a2e08634$var$Store, {
    selector: (state)=>state.products
});
const $ee6ce766a2e08634$export$f7c6299b3492081c = (0, $9zUhf.createHook)($ee6ce766a2e08634$var$Store, {
    selector: (state)=>state.products.length === 0
});
const $ee6ce766a2e08634$export$92c6f3c7c09f3247 = (0, $9zUhf.createHook)($ee6ce766a2e08634$var$Store, {
    selector: (state)=>state.primaryProduct
});
const $ee6ce766a2e08634$export$e1e7a4797df1a656 = (0, $9zUhf.createHook)($ee6ce766a2e08634$var$Store, {
    selector: (state)=>state.searchSessionId
});
const $ee6ce766a2e08634$export$1a0be923fb1117e4 = (0, $9zUhf.createHook)($ee6ce766a2e08634$var$Store, {
    selector: (state)=>state.cloudId === $ee6ce766a2e08634$var$HELLO_TENANT_ID
});
const $ee6ce766a2e08634$export$4a39035bacc4ed76 = (0, $9zUhf.createHook)($ee6ce766a2e08634$var$Store, {
    selector: (state)=>state.features
});
const $ee6ce766a2e08634$export$7c355de7fd01eb66 = (0, $9zUhf.createHook)($ee6ce766a2e08634$var$Store, {
    selector: (state)=>state.components
});
const $ee6ce766a2e08634$export$4f9dad8ddb27a630 = (0, $9zUhf.createHook)($ee6ce766a2e08634$var$Store, {
    selector: (state)=>state.styleOverrides
});
const $ee6ce766a2e08634$export$b9e6179ff71a6122 = (0, $9zUhf.createHook)($ee6ce766a2e08634$var$Store, {
    selector: (state)=>state.experimentConfig
});
const $ee6ce766a2e08634$export$9e89c81d9ff2c758 = (0, $9zUhf.createHook)($ee6ce766a2e08634$var$Store, {
    selector: (state)=>state.experimentConfig.backendExperiment
});
const $ee6ce766a2e08634$export$d2c28b106f1bf70b = (0, $9zUhf.createHook)($ee6ce766a2e08634$var$Store, {
    selector: (state)=>state.experimentConfig.frontendExperiments
});
const $ee6ce766a2e08634$export$8ab143228c6f49a2 = (0, $9zUhf.createHook)($ee6ce766a2e08634$var$Store, {
    selector: (state)=>state.intercomHmac
});
const $ee6ce766a2e08634$export$efd66ec4f7062878 = (0, $9zUhf.createHook)($ee6ce766a2e08634$var$Store, {
    selector: (state)=>state.isNounsAvailable
});
const $ee6ce766a2e08634$export$23bbbc4533528f03 = (0, $9zUhf.createHook)($ee6ce766a2e08634$var$Store, {
    selector: (state)=>{
        const user = state.user;
        if (!user || !user.id) return {
            status: (0, $5f67793cebea6085$export$a82073022ded66e8).Unauthenticated,
            id: null,
            name: null,
            email: null
        };
        if (user.id === 'unidentified') return {
            status: (0, $5f67793cebea6085$export$a82073022ded66e8).Anonymous,
            ...user
        };
        return {
            status: (0, $5f67793cebea6085$export$a82073022ded66e8).Authenticated,
            ...user
        };
    }
});
const $ee6ce766a2e08634$export$e99d08753f6dce85 = (0, $9zUhf.createHook)($ee6ce766a2e08634$var$Store, {
    selector: (state)=>state.referrer
});
const $ee6ce766a2e08634$export$52a03a3207af3687 = (0, $9zUhf.createHook)($ee6ce766a2e08634$var$Store, {
    selector: (state)=>state.orgId
});
const $ee6ce766a2e08634$export$9da0f7c65f28ed16 = (0, $9zUhf.createHook)($ee6ce766a2e08634$var$Store, {
    selector: (0, $cclHy.createSelector)([
        (state)=>state.cloudId
    ], (cloudId)=>cloudId)
});
const $ee6ce766a2e08634$export$b37ee0d76c6d2fbc = (0, $9zUhf.createHook)($ee6ce766a2e08634$var$Store, {
    selector: (state)=>state.queryParams
});


const $63afac6f9f5eb800$export$67ff3bc9583d7c16 = ()=>{
    const [{ user: user, primaryProduct: primaryProduct }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    return (0, $42omo.useCallback)(async (error)=>{
        try {
            const SentryClient = await (0, $2a1040f7bc0912ba$export$f553e8b08ef59d31)();
            if (!SentryClient) return;
            SentryClient.withScope((scope)=>{
                for (const [key, value] of Object.entries((0, $0e0fa44627b55be3$export$d60e93659f587f71)))scope.setTag(key, value);
                scope.setUser({
                    id: user?.id || (0, $0e0fa44627b55be3$export$ea77880e3935182d)
                });
                scope.setTag('product', primaryProduct || (0, $0e0fa44627b55be3$export$ea77880e3935182d));
                SentryClient.captureException(error, scope);
            });
        } catch (error) {
            // When there was an error with Sentry, just output to console
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }, [
        primaryProduct,
        user?.id
    ]);
};
const $63afac6f9f5eb800$export$e926676385687eaf = (props)=>{
    const onException = $63afac6f9f5eb800$export$67ff3bc9583d7c16();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $f4f3bef07fb06b6b$export$e926676385687eaf), {
        ...props,
        onException: onException,
        children: props.children
    });
};






parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $966bacae4db23ddd$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.100'
});
const $966bacae4db23ddd$var$filterStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: 'radius.small',
    height: 'size.300',
    width: 'size.600'
});
const $966bacae4db23ddd$export$d5722e1c0b3e12f1 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $966bacae4db23ddd$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $966bacae4db23ddd$var$filterStyles
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $966bacae4db23ddd$var$filterStyles
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $966bacae4db23ddd$var$filterStyles
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $966bacae4db23ddd$var$filterStyles
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $966bacae4db23ddd$var$filterStyles
            })
        ]
    });
};











var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");




var $7mBSb = parcelRequire("7mBSb");


var $4sOnC = parcelRequire("4sOnC");

const $930693b11d26c5f4$export$1b49510872e7246c = 'platform.search-platform.rovo-changeboarding-app-selectors';
const $930693b11d26c5f4$export$b2c6f9ee831a1261 = 'platform.search-platform.rovo-changeboarding-product-filters';
const $930693b11d26c5f4$export$d2ea4f931a71a509 = 'search-platform-filters-changeboarding';









var $5izcQ = parcelRequire("5izcQ");




var $cwkWT = parcelRequire("cwkWT");




var $a90ar = parcelRequire("a90ar");


var $1oCLl = parcelRequire("1oCLl");








var $8C5kA = parcelRequire("8C5kA");


var $5RBJ9 = parcelRequire("5RBJ9");


var $dh538 = parcelRequire("dh538");


var $iXCQx = parcelRequire("iXCQx");


var $bqAtB = parcelRequire("bqAtB");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fNcP1 = parcelRequire("fNcP1");

var $aG6kF = parcelRequire("aG6kF");













const $79f0e1d5b0d8f48f$var$initialState = {
    spotlight: {
        state: 'hidden'
    }
};
const $79f0e1d5b0d8f48f$var$actions = {
    start: ()=>({ getState: getState, setState: setState })=>{
            const { spotlight: spotlight } = getState();
            if (spotlight.state !== 'hidden') return;
            setState({
                spotlight: {
                    state: 'visible',
                    activeSpotlight: 0
                }
            });
        },
    next: ()=>({ setState: setState, getState: getState })=>{
            const { spotlight: spotlight } = getState();
            if (spotlight.state !== 'visible') return;
            setState({
                spotlight: {
                    state: 'visible',
                    activeSpotlight: spotlight.activeSpotlight + 1
                }
            });
        },
    end: ()=>({ setState: setState })=>{
            setState({
                spotlight: {
                    state: 'seen'
                }
            });
        },
    dismiss: ()=>({ setState: setState })=>{
            setState({
                spotlight: {
                    state: 'dismiss'
                }
            });
        }
};
const $79f0e1d5b0d8f48f$var$SpotlightStore = (0, $1P1Tu.createStore)({
    initialState: $79f0e1d5b0d8f48f$var$initialState,
    actions: $79f0e1d5b0d8f48f$var$actions,
    name: 'SpotlightStore'
});
const $79f0e1d5b0d8f48f$export$d52beefead77af4c = (0, $9zUhf.createActionsHook)($79f0e1d5b0d8f48f$var$SpotlightStore);
const $79f0e1d5b0d8f48f$export$42b1420c4bc8ee20 = (0, $9zUhf.createHook)($79f0e1d5b0d8f48f$var$SpotlightStore);
const $79f0e1d5b0d8f48f$export$a771c137b2620ff2 = (0, $9zUhf.createHook)($79f0e1d5b0d8f48f$var$SpotlightStore, {
    selector: (0, $cclHy.createSelector)((state)=>state.spotlight, (spotlightState)=>spotlightState)
});



var $cgtv4 = parcelRequire("cgtv4");

var $3fc13b682d608d36$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    dismiss: {
        id: "dynamic-cards-search-page.rovo-onboarding-dismiss",
        defaultMessage: "Dismiss"
    },
    next: {
        id: "dynamic-cards-search-page.rovo-onboarding-next",
        defaultMessage: "Next"
    },
    done: {
        id: "dynamic-cards-search-page.rovo-onboarding-done",
        defaultMessage: "Done"
    },
    onboardingStep1Heading: {
        id: "dynamic-cards-search-page.rovo-onboarding-step-1-heading",
        defaultMessage: "Search across all your company workspaces"
    },
    onboardingStep1Description: {
        id: "dynamic-cards-search-page.rovo-onboarding-step-1-description",
        defaultMessage: "Filter by product to get more relevant search results."
    },
    onboardingStep1Progress: {
        id: "dynamic-cards-search-page.rovo-onboarding-step-1-progress",
        defaultMessage: "1/2"
    },
    onboardingStep2Heading: {
        id: "dynamic-cards-search-page.rovo-onboarding-step-2-heading",
        defaultMessage: "Find exactly what you're looking for"
    },
    onboardingStep2Description: {
        id: "dynamic-cards-search-page.rovo-onboarding-step-2-description",
        defaultMessage: "Depending on the product you're filtering by, these options change to help you get specific results."
    },
    onboardingStep2Progress: {
        id: "dynamic-cards-search-page.rovo-onboarding-step-2-progress",
        defaultMessage: "2/2"
    },
    onboardingStep1DescriptionAppify: {
        id: "dynamic-cards-search-page.rovo-onboarding-step-1-description-appify",
        defaultMessage: "Filter by app to get more relevant search results."
    },
    onboardingStep2DescriptionAppify: {
        id: "dynamic-cards-search-page.rovo-onboarding-step-2-description-appify",
        defaultMessage: "Depending on the app you're filtering by, these options change to help you get specific results."
    }
});


const $bfe18f41f115b880$export$af2c08784ffc2e37 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [spotlight, { next: next, dismiss: dismiss }] = (0, $79f0e1d5b0d8f48f$export$a771c137b2620ff2)();
    const [availableProducts] = (0, $ee6ce766a2e08634$export$5afbfe6edea8e998)();
    const renderSpotlight = spotlight.state === 'visible' && availableProducts.length > 0; // Only render the spotlight after available products have been fetched
    if (!renderSpotlight) return null;
    const renderActiveSpotlight = ()=>{
        const deprecatedSpotlights = [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5RBJ9.default), {
                actionsBeforeElement: formatMessage((0, $3fc13b682d608d36$export$2e2bcd8739ae039).onboardingStep1Progress),
                actions: [
                    {
                        onClick: ()=>{
                            next();
                        },
                        text: formatMessage((0, $3fc13b682d608d36$export$2e2bcd8739ae039).next)
                    },
                    {
                        onClick: ()=>{
                            dismiss();
                        },
                        text: formatMessage((0, $3fc13b682d608d36$export$2e2bcd8739ae039).dismiss),
                        appearance: 'subtle'
                    }
                ],
                heading: formatMessage((0, $3fc13b682d608d36$export$2e2bcd8739ae039).onboardingStep1Heading),
                target: (0, $930693b11d26c5f4$export$1b49510872e7246c),
                dialogWidth: 275,
                dialogPlacement: "left top",
                targetRadius: 8,
                children: formatMessage((0, $dh538.fg)('product-terminology-refresh') ? (0, $3fc13b682d608d36$export$2e2bcd8739ae039).onboardingStep1DescriptionAppify : (0, $3fc13b682d608d36$export$2e2bcd8739ae039).onboardingStep1Description)
            }, (0, $930693b11d26c5f4$export$1b49510872e7246c)),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5RBJ9.default), {
                actionsBeforeElement: formatMessage((0, $3fc13b682d608d36$export$2e2bcd8739ae039).onboardingStep2Progress),
                actions: [
                    {
                        onClick: ()=>{
                            dismiss();
                        },
                        text: formatMessage((0, $3fc13b682d608d36$export$2e2bcd8739ae039).done)
                    }
                ],
                heading: formatMessage((0, $3fc13b682d608d36$export$2e2bcd8739ae039).onboardingStep2Heading),
                target: (0, $930693b11d26c5f4$export$b2c6f9ee831a1261),
                dialogWidth: 275,
                targetRadius: 8,
                children: formatMessage((0, $dh538.fg)('product-terminology-refresh') ? (0, $3fc13b682d608d36$export$2e2bcd8739ae039).onboardingStep2DescriptionAppify : (0, $3fc13b682d608d36$export$2e2bcd8739ae039).onboardingStep2Description)
            }, (0, $930693b11d26c5f4$export$b2c6f9ee831a1261))
        ];
        const spotlights = [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $bqAtB.PopoverContent), {
                dismiss: dismiss,
                placement: "right-end",
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $71521.SpotlightCard), {
                    testId: (0, $930693b11d26c5f4$export$1b49510872e7246c),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $aZQ5F.SpotlightHeader), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $bUJpY.SpotlightHeadline), {
                                    children: formatMessage((0, $3fc13b682d608d36$export$2e2bcd8739ae039).onboardingStep1Heading)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $aVS0S.SpotlightControls), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2owmo.SpotlightDismissControl), {
                                        onClick: dismiss
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $f1UQW.SpotlightBody), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                children: formatMessage((0, $dh538.fg)('product-terminology-refresh') ? (0, $3fc13b682d608d36$export$2e2bcd8739ae039).onboardingStep1DescriptionAppify : (0, $3fc13b682d608d36$export$2e2bcd8739ae039).onboardingStep1Description)
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $eopLP.SpotlightFooter), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $aG6kF.SpotlightStepCount), {
                                    children: formatMessage((0, $3fc13b682d608d36$export$2e2bcd8739ae039).onboardingStep1Progress)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $3chlW.SpotlightActions), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fNcP1.SpotlightPrimaryAction), {
                                        onClick: next,
                                        children: formatMessage((0, $3fc13b682d608d36$export$2e2bcd8739ae039).next)
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $bqAtB.PopoverContent), {
                dismiss: dismiss,
                placement: "right-end",
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $71521.SpotlightCard), {
                    testId: (0, $930693b11d26c5f4$export$b2c6f9ee831a1261),
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $aZQ5F.SpotlightHeader), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $bUJpY.SpotlightHeadline), {
                                    children: formatMessage((0, $3fc13b682d608d36$export$2e2bcd8739ae039).onboardingStep2Heading)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $aVS0S.SpotlightControls), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2owmo.SpotlightDismissControl), {
                                        onClick: dismiss
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $f1UQW.SpotlightBody), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                children: formatMessage((0, $dh538.fg)('product-terminology-refresh') ? (0, $3fc13b682d608d36$export$2e2bcd8739ae039).onboardingStep2DescriptionAppify : (0, $3fc13b682d608d36$export$2e2bcd8739ae039).onboardingStep2Description)
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $eopLP.SpotlightFooter), {
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $aG6kF.SpotlightStepCount), {
                                    children: formatMessage((0, $3fc13b682d608d36$export$2e2bcd8739ae039).onboardingStep2Progress)
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $3chlW.SpotlightActions), {
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fNcP1.SpotlightPrimaryAction), {
                                        onClick: dismiss,
                                        children: formatMessage((0, $3fc13b682d608d36$export$2e2bcd8739ae039).done)
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ];
        return (0, $1oCLl.expValEquals)('company_hub_deprecate_atlaskit_onboarding', 'isEnabled', true) ? spotlights[spotlight.activeSpotlight] : deprecatedSpotlights[spotlight.activeSpotlight];
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: renderActiveSpotlight()
    });
};


const $11d4b0b18ed41ef3$var$gridOverlapStyles = (0, $ecnYn.xcss)({
    gridRow: 1,
    gridColumn: 1
});
const $11d4b0b18ed41ef3$var$spotlightFillStyles = (0, $ecnYn.xcss)({
    height: '100%',
    width: '100%'
});
const $11d4b0b18ed41ef3$var$isAboveSmBreakpoint = ()=>window.innerWidth > 768;
const $11d4b0b18ed41ef3$export$95d78afe1ba1dce1 = ({ children: children, name: name })=>{
    const [displaySpotlight] = (0, $42omo.useState)($11d4b0b18ed41ef3$var$isAboveSmBreakpoint());
    if (!displaySpotlight) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $11d4b0b18ed41ef3$var$gridOverlapStyles,
                        children: (0, $1oCLl.expValEquals)('company_hub_deprecate_atlaskit_onboarding', 'isEnabled', true) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $a90ar.PopoverTarget), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                xcss: $11d4b0b18ed41ef3$var$spotlightFillStyles,
                                testId: "spotlight-target"
                            })
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $5izcQ.default), {
                            name: name,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                xcss: $11d4b0b18ed41ef3$var$spotlightFillStyles
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $11d4b0b18ed41ef3$var$gridOverlapStyles,
                        children: children
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $bfe18f41f115b880$export$af2c08784ffc2e37), {})
        ]
    });
};



var $7tL1u = parcelRequire("7tL1u");





var $dKCFm = parcelRequire("dKCFm");


var $7l9HL = parcelRequire("7l9HL");


var $eJ38t = parcelRequire("eJ38t");


var $11Uwq = parcelRequire("11Uwq");


var $i4ijn = parcelRequire("i4ijn");


var $2zUQE = parcelRequire("2zUQE");


var $hYkUd = parcelRequire("hYkUd");


var $e4Y2w = parcelRequire("e4Y2w");


var $9md6K = parcelRequire("9md6K");


var $lKbSE = parcelRequire("lKbSE");




parcelRequire("42omo");











var $c4sKh = parcelRequire("c4sKh");


var $c9mMn = parcelRequire("c9mMn");

var $6Ipjn = parcelRequire("6Ipjn");




parcelRequire("42omo");


var $ghftu = parcelRequire("ghftu");






var $2W0qg = parcelRequire("2W0qg");




var $6fnsQ = parcelRequire("6fnsQ");




parcelRequire("42omo");


var $8DN9t = parcelRequire("8DN9t");


var $4AkKf = parcelRequire("4AkKf");


var $5tmwS = parcelRequire("5tmwS");


var $cUQMr = parcelRequire("cUQMr");


var $8jHAi = parcelRequire("8jHAi");


var $6767u = parcelRequire("6767u");


var $bVHZY = parcelRequire("bVHZY");


var $dmsGX = parcelRequire("dmsGX");


var $bh5s2 = parcelRequire("bh5s2");


var $av0Vd = parcelRequire("av0Vd");




const $366ad95c9acca0f8$export$16b26cd5e98d9100 = ({ filterOrControlId: filterOrControlId, isSelected: isSelected, label: label = '' })=>{
    switch(filterOrControlId){
        case 'owner':
        case 'assignee':
        case 'contributor':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6767u))), {
                spacing: "none",
                label: label,
                color: isSelected ? `var(--ds-icon-selected, ${0, $6fnsQ.B400})` : `var(--ds-icon, ${0, $6fnsQ.N500})`
            });
        case 'verified':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
                spacing: "none",
                label: label,
                color: isSelected ? `var(--ds-icon-selected, ${0, $6fnsQ.B400})` : `var(--ds-icon, ${0, $6fnsQ.N500})`
            });
        case 'label':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($av0Vd))), {
                spacing: "none",
                label: label,
                color: isSelected ? `var(--ds-icon-selected, ${0, $6fnsQ.B400})` : `var(--ds-icon, ${0, $6fnsQ.N500})`
            });
        case 'content':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cUQMr))), {
                spacing: "none",
                label: label,
                color: isSelected ? `var(--ds-icon-selected, ${0, $6fnsQ.B400})` : `var(--ds-icon, ${0, $6fnsQ.N500})`
            });
        case 'lastUpdated':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))), {
                spacing: "none",
                label: label,
                color: isSelected ? `var(--ds-icon-selected, ${0, $6fnsQ.B400})` : `var(--ds-icon, ${0, $6fnsQ.N500})`
            });
        case 'project':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bVHZY))), {
                spacing: "none",
                label: label,
                color: isSelected ? `var(--ds-icon-selected, ${0, $6fnsQ.B400})` : `var(--ds-icon, ${0, $6fnsQ.N500})`
            });
        case 'space':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))), {
                spacing: "none",
                label: label,
                color: isSelected ? `var(--ds-icon-selected, ${0, $6fnsQ.B400})` : `var(--ds-icon, ${0, $6fnsQ.N500})`
            });
        case 'onlyTitleMatch':
            return null;
        // Title match doesn't show an icon, only a checkbox
        case 'universalTypeFilter':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                spacing: "none",
                label: label,
                color: isSelected ? `var(--ds-icon-selected, ${0, $6fnsQ.B400})` : `var(--ds-icon, ${0, $6fnsQ.N500})`
            });
        case 'dropdown':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))), {
                spacing: "none",
                label: label,
                color: isSelected ? `var(--ds-icon-selected, ${0, $6fnsQ.B400})` : `var(--ds-icon, ${0, $6fnsQ.N500})`
            });
        case 'sort':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dmsGX))), {
                spacing: "none",
                label: label,
                color: isSelected ? `var(--ds-icon-selected, ${0, $6fnsQ.B400})` : `var(--ds-icon, ${0, $6fnsQ.N500})`
            });
    }
};


const $753a7c5d9f81c8ec$var$baseStyles = (0, $ecnYn.xcss)({
    height: '32px',
    paddingInline: 'space.150',
    width: '100%',
    borderRadius: 'radius.small',
    color: 'color.text',
    backgroundColor: 'color.background.neutral',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    }
});
const $753a7c5d9f81c8ec$var$selectedStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.accent.blue',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    }
});
const $753a7c5d9f81c8ec$var$buttonIconStyles = (0, $ecnYn.xcss)({
    display: 'flex'
});
const $753a7c5d9f81c8ec$var$ButtonIcon = ({ filterOrControlId: filterOrControlId, isSelected: isSelected })=>{
    const buttonIcon = (0, $366ad95c9acca0f8$export$16b26cd5e98d9100)({
        filterOrControlId: filterOrControlId,
        isSelected: isSelected
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $753a7c5d9f81c8ec$var$buttonIconStyles,
        children: buttonIcon
    });
};
const $753a7c5d9f81c8ec$var$buttonWrapperStyles = (0, $ecnYn.xcss)({
    maxWidth: '280px' // matches dropdown of 312px (and padding)
});
const $753a7c5d9f81c8ec$var$textStyles = (0, $ecnYn.xcss)({
    // ellipsis for overflow text
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)"
});
const $753a7c5d9f81c8ec$export$fb46dd9777cc6db0 = ({ otherProps: otherProps, isSelected: isSelected, filterOrControlId: filterOrControlId, label: label, selectionBadge: selectionBadge, onClick: onClick, onKeyDown: onKeyDown, wide: wide, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: !wide && $753a7c5d9f81c8ec$var$buttonWrapperStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
            onClick: onClick,
            onKeyDown: onKeyDown,
            ...otherProps,
            testId: testId,
            xcss: [
                $753a7c5d9f81c8ec$var$baseStyles,
                isSelected && $753a7c5d9f81c8ec$var$selectedStyles
            ],
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                alignInline: "start",
                space: "space.100",
                spread: "space-between",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                        alignBlock: "center",
                        alignInline: "start",
                        xcss: $753a7c5d9f81c8ec$var$textStyles,
                        space: "space.100",
                        children: [
                            filterOrControlId && /*#__PURE__*/ (0, $l998X.jsx)($753a7c5d9f81c8ec$var$ButtonIcon, {
                                filterOrControlId: filterOrControlId,
                                isSelected: isSelected
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                xcss: $753a7c5d9f81c8ec$var$textStyles,
                                children: label
                            }),
                            selectionBadge
                        ]
                    }),
                    filterOrControlId !== 'dropdown' && /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        label: "",
                        color: isSelected ? `var(--ds-icon-selected, ${0, $6fnsQ.B400})` : `var(--ds-icon, ${0, $6fnsQ.N500})`,
                        size: "small"
                    })
                ]
            })
        })
    });
};





parcelRequire("42omo");







var $3hOY6 = parcelRequire("3hOY6");

const $23946072b7f5d32e$var$boxStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small',
    boxSizing: 'border-box'
});
const $23946072b7f5d32e$export$7a7fa4424cb20976 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: props.selectProps.isSearchable && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            paddingInline: "space.100",
            paddingBlockStart: "space.100",
            xcss: $23946072b7f5d32e$var$boxStyles,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).Control, {
                ...props
            })
        })
    });





parcelRequire("42omo");




















const $2753021049704a28$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    searchClearFilterLabel: {
        id: "dynamic-cards-search-page.filter.clear.filter.label",
        defaultMessage: "Clear filter"
    }
});


const $a5eea3aacc7bc278$var$clearFilterOptionsButtonStyles = (0, $ecnYn.xcss)({
    background: `var(--ds-background-input, ${(0, $6fnsQ.N0)})`,
    color: 'color.text.subtle',
    border: 'none',
    paddingLeft: 'space.250',
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '36px',
    width: '100%',
    ':hover': {
        backgroundColor: 'color.background.input.hovered'
    },
    ':disabled': {
        color: 'color.text.accent.gray',
        cursor: 'default'
    }
});
const $a5eea3aacc7bc278$var$ClearFilterOptionsButton = ({ disabled: disabled, onClick: onClick, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
        onClick: onClick,
        xcss: $a5eea3aacc7bc278$var$clearFilterOptionsButtonStyles,
        isDisabled: disabled,
        children: children
    });
};
const $a5eea3aacc7bc278$var$menuFooterStyles = (0, $ecnYn.xcss)({
    borderTop: `${`var(--ds-border, ${(0, $6fnsQ.N40)})`} solid ${"var(--ds-border-width, 1px)"}`
});
const $a5eea3aacc7bc278$export$d4c4e98c5044dc8 = (props)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).MenuList, {
                ...props
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $a5eea3aacc7bc278$var$menuFooterStyles,
                children: props.selectProps.canClearFilter && /*#__PURE__*/ (0, $l998X.jsx)($a5eea3aacc7bc278$var$ClearFilterOptionsButton, {
                    disabled: props.selectProps.clearOptionsDisabled,
                    onClick: ()=>props.selectProps.onClearOptions(),
                    children: formatMessage((0, $2753021049704a28$export$a7357cdd1f0b0168).searchClearFilterLabel)
                })
            })
        ]
    });
};


const $64cfcf7920c92b4e$var$SelectFilter = ({ defaultIsOpen: defaultIsOpen = false, isSearchable: isSearchable = false, isLoading: isLoading = false, clearOptionsDisabled: clearOptionsDisabled = false, canClearFilter: canClearFilter = false, checkboxIndicators: checkboxIndicators = false, formatOptionLabel: formatOptionLabel, placeholder: placeholder, searchInput: searchInput, onSearchInputChange: onSearchInputChange, onSelectChange: onSelectChange, onDropdownOpen: onDropdownOpen, onDropdownClose: onDropdownClose, options: options, selectedOptions: selectedOptions, label: label, noOptionsMessage: noOptionsMessage, filterOrControlId: filterOrControlId, getFirstSelectedLabel: getFirstSelectedLabel, onClearOptions: onClearOptions, minMenuWidth: minMenuWidth, testId: testId })=>{
    const numSelectedOptions = selectedOptions.length;
    const firstSelected = selectedOptions[0];
    const debounceTimeout = (0, $42omo.useRef)(null);
    // TODO: this can be removed if we have debounce in the store when lookup
    const [currentSearchInput, setCurrentSearchInput] = (0, $42omo.useState)(searchInput);
    const handleInputChange = (0, $42omo.useCallback)((value, action)=>{
        if (action.action !== 'input-change') return;
        setCurrentSearchInput(value);
        if (!onSearchInputChange) return;
        if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
        debounceTimeout.current = setTimeout(()=>{
            onSearchInputChange(value);
        }, 300);
    }, [
        onSearchInputChange
    ]);
    const handleChange = (0, $42omo.useCallback)((value)=>{
        onSelectChange(value);
    }, [
        onSelectChange
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6Ipjn.default), {
        placeholder: placeholder,
        onMenuOpen: onDropdownOpen,
        onMenuClose: ()=>{
            setCurrentSearchInput('');
            onDropdownClose?.();
        },
        minMenuWidth: minMenuWidth,
        maxMenuWidth: "22rem",
        maxMenuHeight: 400,
        menuPlacement: "bottom",
        defaultIsOpen: defaultIsOpen,
        closeMenuOnSelect: !checkboxIndicators,
        isSearchable: isSearchable,
        searchThreshold: -1,
        blurInputOnSelect: false,
        tabSelectsValue: false,
        backspaceRemovesValue: false,
        hideSelectedOptions: false,
        controlShouldRenderValue: false,
        isClearable: false,
        // @ts-ignore - https://product-fabric.atlassian.net/browse/DSP-21000
        defaultOptions: false,
        isLoading: isLoading,
        clearOptionsDisabled: clearOptionsDisabled,
        inputValue: currentSearchInput,
        onInputChange: handleInputChange,
        noOptionsMessage: currentSearchInput ? undefined : ()=>noOptionsMessage,
        canClearFilter: canClearFilter,
        onChange: handleChange,
        onClearOptions: onClearOptions,
        formatOptionLabel: formatOptionLabel,
        options: options,
        isOptionSelected: (option)=>option.isSelected,
        shouldCloseMenuOnTab: false,
        components: {
            Control: $23946072b7f5d32e$export$7a7fa4424cb20976,
            MenuList: $a5eea3aacc7bc278$export$d4c4e98c5044dc8,
            ...checkboxIndicators ? {
                Option: (0, $c9mMn.CheckboxOption)
            } : {}
        },
        popperProps: {
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            8
                        ]
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        rootBoundary: 'viewport'
                    },
                    enabled: false
                }
            ]
        },
        target: ({ isOpen: isOpen, ...triggerProps })=>{
            let firstSelectedLabel = getFirstSelectedLabel?.(firstSelected) || firstSelected?.label;
            let labelElement = label;
            if (typeof label === 'string') labelElement = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    label,
                    firstSelectedLabel ? `: ${firstSelectedLabel}${numSelectedOptions > 1 ? `,` : ''}` : ''
                ]
            });
            const isSelected = isOpen || numSelectedOptions > 0;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $753a7c5d9f81c8ec$export$fb46dd9777cc6db0), {
                testId: testId ? `${testId}-button` : undefined,
                otherProps: triggerProps,
                isSelected: isSelected,
                label: labelElement,
                filterOrControlId: filterOrControlId,
                selectionBadge: numSelectedOptions > 1 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $c4sKh.default), {
                    appearance: "primary",
                    children: `+${numSelectedOptions - 1}`
                }) : undefined
            });
        }
    });
};
var $64cfcf7920c92b4e$export$2e2bcd8739ae039 = $64cfcf7920c92b4e$var$SelectFilter;





parcelRequire("42omo");


var $esRft = parcelRequire("esRft");




var $bUlM5 = parcelRequire("bUlM5");





const $db5452cc2a2c823d$var$optionTextWrapperStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginLeft: 'space.100',
    color: 'color.text',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $db5452cc2a2c823d$export$2cf7ef1e2dd6c6b1 = ({ option: option, state: state, children: children })=>{
    if (state.context === 'menu' || state.context === 'value') {
        const spaces = {
            menu: 'space.050',
            value: undefined
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
            space: spaces[state.context],
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                alignItems: "center",
                children: [
                    children,
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $db5452cc2a2c823d$var$optionTextWrapperStyles,
                        children: option.label
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $db5452cc2a2c823d$var$optionTextWrapperStyles,
        children: option.label
    });
};
const $db5452cc2a2c823d$export$100d0de045bdee7c = (Component)=>(option, state)=>{
        const props = {
            option: option,
            state: state
        };
        return /*#__PURE__*/ (0, $l998X.jsx)($db5452cc2a2c823d$export$2cf7ef1e2dd6c6b1, {
            ...props,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                ...props
            })
        });
    };
const $db5452cc2a2c823d$var$AvatarOptionLabel = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
        src: props.option.avatarUrl,
        appearance: "circle",
        size: "small",
        borderColor: "none"
    });
const $db5452cc2a2c823d$export$aaa1dc33930567f9 = $db5452cc2a2c823d$export$100d0de045bdee7c($db5452cc2a2c823d$var$AvatarOptionLabel);



var $e2xgH = parcelRequire("e2xgH");







const $2b38b92fdc728969$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    assignee: {
        id: "dynamic-cards-search-page.filters.names.assignee",
        defaultMessage: "Assignee"
    },
    jiraFilterContributorPlaceholder: {
        id: "dynamic-cards-search-page.jira.filter.assignee.placeholder",
        defaultMessage: "Find people"
    },
    jiraFilterAssigneeLabelSelected: {
        id: "dynamic-cards-search-page.jira.filter.assignee.selected",
        defaultMessage: "Selected"
    },
    jiraFilterAssigneeLabelUnselected: {
        id: "dynamic-cards-search-page.jira.filter.assignee.unselected",
        defaultMessage: "Suggested"
    }
});


const $1c0b14ce8c4baa2a$var$AssigneeFilter = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $e2xgH.useSelectFilter)({
        filterId: (0, $dKCFm.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $2b38b92fdc728969$export$a7357cdd1f0b0168).jiraFilterAssigneeLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $2b38b92fdc728969$export$a7357cdd1f0b0168).jiraFilterAssigneeLabelUnselected),
            options: suggestedOptions
        }
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $64cfcf7920c92b4e$export$2e2bcd8739ae039), {
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $2b38b92fdc728969$export$a7357cdd1f0b0168).assignee),
        placeholder: formatMessage((0, $2b38b92fdc728969$export$a7357cdd1f0b0168).jiraFilterContributorPlaceholder),
        filterOrControlId: 'assignee',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $db5452cc2a2c823d$export$aaa1dc33930567f9),
        onClearOptions: clearOptions
    });
};
var $1c0b14ce8c4baa2a$export$2e2bcd8739ae039 = $1c0b14ce8c4baa2a$var$AssigneeFilter;





parcelRequire("42omo");





var $13WX1 = parcelRequire("13WX1");












const $dd25ca9b4bdbb668$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    content: {
        id: "dynamic-cards-search-page.filters.names.content",
        defaultMessage: "Content under"
    },
    confluenceFilterPlaceholder: {
        id: "dynamic-cards-search-page.confluence.filter.content.placeholder",
        defaultMessage: "Find content"
    },
    confluenceFilterLabelSelected: {
        id: "dynamic-cards-search-page.confluence.filter.content.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterLabelUnselected: {
        id: "dynamic-cards-search-page.confluence.filter.content.unselected",
        defaultMessage: "Suggested"
    }
});


const $4fc68d5e59a588e8$var$formatContentIconOptionLabel = (0, $db5452cc2a2c823d$export$100d0de045bdee7c)(({ option: option })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $13WX1.default), {
        label: option.label
    }));
const $4fc68d5e59a588e8$var$ContentFilter = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $e2xgH.useSelectFilter)({
        filterId: (0, $7l9HL.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $dd25ca9b4bdbb668$export$a7357cdd1f0b0168).confluenceFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $dd25ca9b4bdbb668$export$a7357cdd1f0b0168).confluenceFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $64cfcf7920c92b4e$export$2e2bcd8739ae039), {
        canClearFilter: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $dd25ca9b4bdbb668$export$a7357cdd1f0b0168).content),
        placeholder: formatMessage((0, $dd25ca9b4bdbb668$export$a7357cdd1f0b0168).confluenceFilterPlaceholder),
        filterOrControlId: 'content',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: $4fc68d5e59a588e8$var$formatContentIconOptionLabel,
        onClearOptions: clearOptions
    });
};
var $4fc68d5e59a588e8$export$2e2bcd8739ae039 = $4fc68d5e59a588e8$var$ContentFilter;





parcelRequire("42omo");















const $1d9a38a4777d25bd$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    contributor: {
        id: "dynamic-cards-search-page.filters.names.contributor",
        defaultMessage: "Contributor"
    },
    confluenceFilterContributorPlaceholder: {
        id: "dynamic-cards-search-page.confluence.filter.contributor.placeholder",
        defaultMessage: "Find people"
    },
    confluenceFilterContributorLabelSelected: {
        id: "dynamic-cards-search-page.confluence.filter.contributor.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterContributorLabelUnselected: {
        id: "dynamic-cards-search-page.confluence.filter.contributor.label.unselected",
        defaultMessage: "Suggested"
    }
});


const $92be3f9a8d7795d0$var$ContributorFilter = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $e2xgH.useSelectFilter)({
        filterId: (0, $eJ38t.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $1d9a38a4777d25bd$export$a7357cdd1f0b0168).confluenceFilterContributorLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $1d9a38a4777d25bd$export$a7357cdd1f0b0168).confluenceFilterContributorLabelUnselected),
            options: suggestedOptions
        }
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $64cfcf7920c92b4e$export$2e2bcd8739ae039), {
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $1d9a38a4777d25bd$export$a7357cdd1f0b0168).contributor),
        placeholder: formatMessage((0, $1d9a38a4777d25bd$export$a7357cdd1f0b0168).confluenceFilterContributorPlaceholder),
        filterOrControlId: 'contributor',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $db5452cc2a2c823d$export$aaa1dc33930567f9),
        onClearOptions: clearOptions
    });
};
var $92be3f9a8d7795d0$export$2e2bcd8739ae039 = $92be3f9a8d7795d0$var$ContributorFilter;


/* eslint-disable @atlassian/tangerine/import/no-parent-imports */ 


parcelRequire("42omo");








var $ccHMk = parcelRequire("ccHMk");


var $52EPl = parcelRequire("52EPl");






















































parcelRequire("42omo");














const $11b99b93d0ffecad$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    label: {
        id: "dynamic-cards-search-page.filters.names.labels",
        defaultMessage: "Label"
    },
    confluenceFilterLabelPlaceholder: {
        id: "dynamic-cards-search-page.confluence.filter.labels.placeholder",
        defaultMessage: "Find labels"
    },
    confluenceFilterLabelSelected: {
        id: "dynamic-cards-search-page.confluence.filter.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterLabelsNoText: {
        id: "dynamic-cards-search-page.advanced-search.labels.filter.no.text",
        defaultMessage: "Start typing to search for a label"
    }
});


const $5507e89c148336fd$var$LabelFilter = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $e2xgH.useSelectFilter)({
        filterId: (0, $11Uwq.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $11b99b93d0ffecad$export$a7357cdd1f0b0168).confluenceFilterLabelSelected),
            options: selectedOptions
        }
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $64cfcf7920c92b4e$export$2e2bcd8739ae039), {
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $11b99b93d0ffecad$export$a7357cdd1f0b0168).label),
        noOptionsMessage: formatMessage((0, $11b99b93d0ffecad$export$a7357cdd1f0b0168).confluenceFilterLabelsNoText),
        placeholder: formatMessage((0, $11b99b93d0ffecad$export$a7357cdd1f0b0168).confluenceFilterLabelPlaceholder),
        filterOrControlId: 'label',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        onClearOptions: clearOptions,
        minMenuWidth: '360px'
    });
};
var $5507e89c148336fd$export$2e2bcd8739ae039 = $5507e89c148336fd$var$LabelFilter;





parcelRequire("42omo");














var $lGgRw = parcelRequire("lGgRw");







var $dTk3A = parcelRequire("dTk3A");








parcelRequire("42omo");








const $cda8b9e2942132f1$var$itemStyles = (0, $ecnYn.xcss)({
    cursor: 'default',
    borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid`,
    borderColor: 'color.border.inverse',
    ':hover': {
        borderColor: 'color.border.selected',
        backgroundColor: 'color.background.neutral.subtle.hovered'
    }
});
const $cda8b9e2942132f1$var$insideItemStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.negative.025'
});
const $cda8b9e2942132f1$var$itemHoveredStyles = (0, $ecnYn.xcss)({
    borderColor: 'color.border.selected',
    backgroundColor: 'color.background.neutral.subtle.hovered'
});
const $cda8b9e2942132f1$var$itemSelectedStyles = (0, $ecnYn.xcss)({
    borderColor: 'color.border.selected',
    backgroundColor: 'color.background.selected'
});
const $cda8b9e2942132f1$var$DateOption = ({ option: option, hovered: hovered, onClick: onClick })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
        xcss: [
            $cda8b9e2942132f1$var$itemStyles,
            option.isSelected && $cda8b9e2942132f1$var$itemSelectedStyles,
            hovered && $cda8b9e2942132f1$var$itemHoveredStyles
        ],
        onClick: onClick,
        paddingInline: "space.150",
        paddingBlock: "space.075",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $cda8b9e2942132f1$var$insideItemStyles,
            children: option.label
        })
    });
var $cda8b9e2942132f1$export$2e2bcd8739ae039 = $cda8b9e2942132f1$var$DateOption;









var $gtD4K = parcelRequire("gtD4K");







var $c4Cbx = parcelRequire("c4Cbx");


var $a3fRD = parcelRequire("a3fRD");








var $5dK2X = parcelRequire("5dK2X");







var $33vwh = parcelRequire("33vwh");




const $dfe334a69161d08c$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    dateFilterTitle: {
        id: "dynamic-cards-search-page.date.filter.title",
        defaultMessage: "Last updated"
    },
    dateFilterFromTitle: {
        id: "dynamic-cards-search-page.date.filter.from.title",
        defaultMessage: "From"
    },
    dateFilterToTitle: {
        id: "dynamic-cards-search-page.date.filter.to.title",
        defaultMessage: "To"
    },
    dateFilterDateInputPlaceholder: {
        id: "dynamic-cards-search-page.date.filter.input.placeholder",
        defaultMessage: "Choose a date"
    },
    dateFilterAnyTime: {
        id: "dynamic-cards-search-page.date.filter.any.time",
        defaultMessage: "Anytime"
    },
    dateFilterToday: {
        id: "dynamic-cards-search-page.date.filter.today",
        defaultMessage: "Today"
    },
    dateFilterYesterday: {
        id: "dynamic-cards-search-page.date.filter.yesterday",
        defaultMessage: "Yesterday"
    },
    dateFilterLastWeek: {
        id: "dynamic-cards-search-page.date.filter.last.week",
        defaultMessage: "Past 7 days"
    },
    dateFilterLastMonth: {
        id: "dynamic-cards-search-page.date.filter.last.month",
        defaultMessage: "Past 30 days"
    },
    dateFilterLastYear: {
        id: "dynamic-cards-search-page.date.filter.last.year",
        defaultMessage: "Past year"
    },
    dateFilterCustom: {
        id: "dynamic-cards-search-page.date.filter.custom",
        defaultMessage: "Custom"
    },
    dateFilterCustomInvalidDateAfterToday: {
        id: "dynamic-cards-search-page.date.filter.custom.invalid.after.today",
        defaultMessage: "The From date can\u2019t be in the future"
    },
    dateFilterCustomInvalidToDateAfterToday: {
        id: "dynamic-cards-search-page.date.filter.custom.invalid.to.after.today",
        defaultMessage: "The To date can\u2019t be in the future"
    },
    dateFilterCustomInvalidDateAfterEnd: {
        id: "dynamic-cards-search-page.date.filter.custom.invalid.after.end",
        defaultMessage: "The From date has to be before the To date"
    },
    dateFilterToRange: {
        id: "dynamic-cards-search-page.date.filter.to.range",
        defaultMessage: "to"
    },
    dateFilterUpdateButton: {
        id: "dynamic-cards-search-page.date.filter.update.button",
        defaultMessage: "Update"
    },
    dateFilterBeforeLabel: {
        id: "dynamic-cards-search-page.date.filter.before.label",
        defaultMessage: "before"
    },
    dateFilterAfterLabel: {
        id: "dynamic-cards-search-page.date.filter.after.label",
        defaultMessage: "after"
    }
});


const $0294f8312aa3c666$export$1dc6c6b3e4774b92 = {
    [(0, $33vwh.DateRangeError).FROM_AFTER_TO_ERROR]: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...(0, $dfe334a69161d08c$export$a7357cdd1f0b0168).dateFilterCustomInvalidDateAfterEnd
    }),
    [(0, $33vwh.DateRangeError).FROM_IN_FUTURE_ERROR]: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...(0, $dfe334a69161d08c$export$a7357cdd1f0b0168).dateFilterCustomInvalidDateAfterToday
    }),
    [(0, $33vwh.DateRangeError).TO_IN_FUTURE_ERROR]: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...(0, $dfe334a69161d08c$export$a7357cdd1f0b0168).dateFilterCustomInvalidToDateAfterToday
    })
};
const $0294f8312aa3c666$var$datePickerWrapper = (0, $ecnYn.xcss)({
    width: '140px'
});
const $0294f8312aa3c666$var$DateRangePicker = ({ onCustomDateRangeChange: onCustomDateRangeChange, customDateRange: customDateRange })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8C5kA.default)();
    const [selectedFromDate, setSelectedFromDate] = (0, $42omo.useState)(customDateRange.from);
    const [selectedToDate, setSelectedToDate] = (0, $42omo.useState)(customDateRange.to);
    const invalidDateRange = (0, $33vwh.getInvalidDateRange)(selectedFromDate, selectedToDate);
    const handleUpdateSelectedDates = ()=>{
        if (Boolean(invalidDateRange)) return;
        onCustomDateRangeChange(selectedFromDate, selectedToDate);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        paddingInline: "space.150",
        paddingBlock: "space.075",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
            space: "space.150",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                    alignInline: "start",
                    alignBlock: "center",
                    spread: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            xcss: $0294f8312aa3c666$var$datePickerWrapper,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $c4Cbx.default), {
                                onChange: (date)=>setSelectedFromDate(date),
                                defaultValue: selectedFromDate,
                                placeholder: formatMessage((0, $dfe334a69161d08c$export$a7357cdd1f0b0168).dateFilterFromTitle),
                                isInvalid: Boolean(invalidDateRange),
                                locale: locale,
                                shouldShowCalendarButton: true
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            children: formatMessage((0, $dfe334a69161d08c$export$a7357cdd1f0b0168).dateFilterToRange)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            xcss: $0294f8312aa3c666$var$datePickerWrapper,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $c4Cbx.default), {
                                onChange: (date)=>setSelectedToDate(date),
                                defaultValue: selectedToDate,
                                placeholder: formatMessage((0, $dfe334a69161d08c$export$a7357cdd1f0b0168).dateFilterToTitle),
                                isInvalid: invalidDateRange === (0, $33vwh.DateRangeError).FROM_AFTER_TO_ERROR,
                                locale: locale,
                                shouldShowCalendarButton: true
                            })
                        })
                    ]
                }),
                invalidDateRange ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    paddingBlock: "space.050",
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                        alignBlock: "center",
                        space: "space.050",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                                color: `var(--ds-icon-danger, ${(0, $6fnsQ.R400)})`,
                                label: "Date range error"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                color: "color.text.danger",
                                children: $0294f8312aa3c666$export$1dc6c6b3e4774b92[invalidDateRange]
                            })
                        ]
                    })
                }) : null,
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        isDisabled: Boolean(invalidDateRange),
                        onClick: handleUpdateSelectedDates,
                        children: formatMessage((0, $dfe334a69161d08c$export$a7357cdd1f0b0168).dateFilterUpdateButton)
                    })
                })
            ]
        })
    });
};
var $0294f8312aa3c666$export$2e2bcd8739ae039 = $0294f8312aa3c666$var$DateRangePicker;



// a higher layer is needed to make sure the popup is on top of the dropdown menu rendered on top of a modal
const $fec0d281d25e5b6b$var$layerAbovePopupInModal = (0, $dTk3A.layers).flag();
const $fec0d281d25e5b6b$var$containerStyles = (0, $ecnYn.xcss)({
    boxSizing: 'border-box',
    width: '360px',
    overflow: 'visible',
    backgroundColor: 'elevation.surface.overlay',
    ':focus': {
        outline: 'none'
    },
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.overlay'
});
const $fec0d281d25e5b6b$var$PopupComponent = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        ...props,
        paddingBlock: "space.100",
        ref: ref,
        xcss: $fec0d281d25e5b6b$var$containerStyles,
        "data-testid": undefined
    }));
const $fec0d281d25e5b6b$var$formatDate = (dateString, locale)=>{
    // to keep date string in local time, not UTC:
    // https://stackoverflow.com/questions/39223481/incorrect-date-shown-in-new-date-in-javascript
    const modifiedDateString = dateString.concat('T00:00');
    return new Date(modifiedDateString).toLocaleDateString(locale);
};
const $fec0d281d25e5b6b$var$createDatePickerLabel = (locale, afterString, beforeString, from, to)=>{
    if (from && !to) {
        const localeFromDate = $fec0d281d25e5b6b$var$formatDate(from, locale);
        return `${afterString} ${localeFromDate}`;
    }
    if (!from && to) {
        const localeToDate = $fec0d281d25e5b6b$var$formatDate(to, locale);
        return `${beforeString} ${localeToDate}`;
    }
    if (from && to) {
        const localeFromDate = $fec0d281d25e5b6b$var$formatDate(from, locale);
        const localeToDate = $fec0d281d25e5b6b$var$formatDate(to, locale);
        return `${localeFromDate} - ${localeToDate}`;
    }
};
const $fec0d281d25e5b6b$var$getButtonLabel = (isSelected, isCustomDateSelected, selectedLabel, label, afterString, beforeString, locale, from, to)=>{
    if (!isSelected) return label;
    if (isCustomDateSelected && (from || to)) {
        const valueLabel = $fec0d281d25e5b6b$var$createDatePickerLabel(locale, afterString, beforeString, from, to);
        return `${label}: ${valueLabel}`;
    }
    return `${label}: ${selectedLabel}`;
};
const $fec0d281d25e5b6b$var$DateFilterWithCustomRangePicker = ({ options: options, onDropdownOpen: onDropdownOpen, onSelectChange: onSelectChange, selectedOptions: selectedOptions, customDateRange: customDateRange, label: label, testId: testId })=>{
    const [open, setOpen] = (0, $42omo.useState)(false);
    const [customDateOpen, setCustomDateOpen] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage, locale: locale } = (0, $8C5kA.default)();
    const [focusedOption, setFocusedOption] = (0, $42omo.useState)(0);
    const [mouseHovered, setMouseHovered] = (0, $42omo.useState)(false);
    const buttonRef = (0, $42omo.useRef)(null);
    const isSelected = selectedOptions.length > 0;
    const firstSelected = selectedOptions[0];
    const isCustomDateSelected = firstSelected?.value === (0, $7mBSb.CUSTOM_OPTION_VALUE);
    const labelToDisplay = $fec0d281d25e5b6b$var$getButtonLabel(isSelected, isCustomDateSelected, firstSelected?.label || '', label, formatMessage((0, $dfe334a69161d08c$export$a7357cdd1f0b0168).dateFilterAfterLabel), formatMessage((0, $dfe334a69161d08c$export$a7357cdd1f0b0168).dateFilterBeforeLabel), locale, customDateRange.from, customDateRange.to);
    const handleOptionClick = (option)=>{
        if (option.value === (0, $7mBSb.CUSTOM_OPTION_VALUE)) setCustomDateOpen(true);
        else {
            setCustomDateOpen(false);
            onSelectChange(option, customDateRange);
            setOpen(false);
        }
    };
    const handleCustomDateRangeChange = (from, to)=>{
        const option = options.find((o)=>o.value === (0, $7mBSb.CUSTOM_OPTION_VALUE));
        if (!option) return;
        onSelectChange(option, {
            from: from,
            to: to
        });
        setOpen(false);
    };
    const handleClickDropdownBtn = ()=>{
        if (!open && onDropdownOpen) onDropdownOpen();
        setOpen(!open);
        setFocusedOption(0);
        buttonRef.current?.focus();
    };
    const handleKeyDown = (event)=>{
        if (event.key === 'ArrowDown') {
            event.preventDefault();
            setFocusedOption((prev)=>(prev + 1) % options.length);
        }
        if (event.key === 'ArrowUp') {
            event.preventDefault();
            setFocusedOption((prev)=>(prev - 1 + options.length) % options.length);
        }
        if (event.key === 'Enter' && open) {
            event.preventDefault();
            handleOptionClick(options[focusedOption]);
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        placement: "bottom-start",
        onClose: ()=>setOpen(false),
        isOpen: open,
        zIndex: $fec0d281d25e5b6b$var$layerAbovePopupInModal,
        autoFocus: false,
        popupComponent: $fec0d281d25e5b6b$var$PopupComponent,
        content: ()=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                onMouseOver: ()=>setMouseHovered(true),
                onMouseOut: ()=>setMouseHovered(false),
                children: [
                    options.map((option, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $cda8b9e2942132f1$export$2e2bcd8739ae039), {
                            hovered: !mouseHovered && focusedOption === index,
                            option: option,
                            onClick: ()=>handleOptionClick(option)
                        }, option.value)),
                    (customDateOpen || isCustomDateSelected) && /*#__PURE__*/ (0, $l998X.jsx)((0, $0294f8312aa3c666$export$2e2bcd8739ae039), {
                        onCustomDateRangeChange: handleCustomDateRangeChange,
                        customDateRange: customDateRange
                    })
                ]
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $753a7c5d9f81c8ec$export$fb46dd9777cc6db0), {
                label: labelToDisplay,
                filterOrControlId: 'lastUpdated',
                otherProps: triggerProps,
                isSelected: isSelected,
                onClick: handleClickDropdownBtn,
                testId: testId ? `${testId}-button` : undefined,
                onKeyDown: handleKeyDown,
                wide: true
            })
    });
};
var $fec0d281d25e5b6b$export$2e2bcd8739ae039 = $fec0d281d25e5b6b$var$DateFilterWithCustomRangePicker;








const $6300650c94cb7bef$export$a7357cdd1f0b0168 = {
    lastUpdated: {
        id: 'dynamic-cards-search-page.filters.names.lastUpdated',
        defaultMessage: 'Last updated',
        description: 'Label for filtering by last updated time'
    }
};


const $f50dfd995c7604d4$var$LastUpdatedFilter = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [filterData, { setOption: setOption, loadInitialOptions: loadInitialOptions }] = (0, $e2xgH.useSelectFilter)({
        filterId: (0, $i4ijn.filter).id
    });
    if (!filterData) return null;
    const { options: options, selectedOptions: selectedOptions, customValue: customValue } = filterData;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fec0d281d25e5b6b$export$2e2bcd8739ae039), {
        options: options,
        onSelectChange: setOption,
        label: formatMessage((0, $6300650c94cb7bef$export$a7357cdd1f0b0168).lastUpdated),
        onDropdownOpen: loadInitialOptions,
        selectedOptions: selectedOptions,
        customDateRange: customValue || {
            from: '',
            to: ''
        },
        testId: "universal-last-updated-filter"
    });
};
var $f50dfd995c7604d4$export$2e2bcd8739ae039 = $f50dfd995c7604d4$var$LastUpdatedFilter;





parcelRequire("42omo");















const $b22ce0b2831c690c$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    owner: {
        id: "dynamic-cards-search-page.filters.names.owner",
        defaultMessage: "Owner"
    },
    confluenceFilterOwnerPlaceholder: {
        id: "dynamic-cards-search-page.confluence.filter.contributor.placeholder",
        defaultMessage: "Find people"
    },
    confluenceFilterOwnerLabelSelected: {
        id: "dynamic-cards-search-page.confluence.filter.contributor.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterOwnerLabelUnselected: {
        id: "dynamic-cards-search-page.confluence.filter.contributor.label.unselected",
        defaultMessage: "Suggested"
    }
});


const $6a89f1316016588a$var$OwnerFilter = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $e2xgH.useSelectFilter)({
        filterId: (0, $2zUQE.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $b22ce0b2831c690c$export$a7357cdd1f0b0168).confluenceFilterOwnerLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $b22ce0b2831c690c$export$a7357cdd1f0b0168).confluenceFilterOwnerLabelUnselected),
            options: suggestedOptions
        }
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $64cfcf7920c92b4e$export$2e2bcd8739ae039), {
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $b22ce0b2831c690c$export$a7357cdd1f0b0168).owner),
        placeholder: formatMessage((0, $b22ce0b2831c690c$export$a7357cdd1f0b0168).confluenceFilterOwnerPlaceholder),
        filterOrControlId: 'owner',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $db5452cc2a2c823d$export$aaa1dc33930567f9),
        onClearOptions: clearOptions
    });
};
var $6a89f1316016588a$export$2e2bcd8739ae039 = $6a89f1316016588a$var$OwnerFilter;





parcelRequire("42omo");















const $e0761a4380ebc313$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    project: {
        id: "dynamic-cards-search-page.filters.names.project",
        defaultMessage: "Project"
    },
    jiraFilterProjectPlaceholder: {
        id: "dynamic-cards-search-page.jira.filter.project.placeholder",
        defaultMessage: "Find projects"
    },
    jiraFilterProjectLabelSelected: {
        id: "dynamic-cards-search-page.jira.filter.project.selected",
        defaultMessage: "Selected"
    },
    jiraFilterProjectLabelUnselected: {
        id: "dynamic-cards-search-page.jira.filter.project.unselected",
        defaultMessage: "Suggested"
    }
});


const $bfdcecceb19b6316$var$ProjectFilter = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $e2xgH.useSelectFilter)({
        filterId: (0, $hYkUd.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $e0761a4380ebc313$export$a7357cdd1f0b0168).jiraFilterProjectLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $e0761a4380ebc313$export$a7357cdd1f0b0168).jiraFilterProjectLabelUnselected),
            options: suggestedOptions
        }
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $64cfcf7920c92b4e$export$2e2bcd8739ae039), {
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $e0761a4380ebc313$export$a7357cdd1f0b0168).project),
        placeholder: formatMessage((0, $e0761a4380ebc313$export$a7357cdd1f0b0168).jiraFilterProjectPlaceholder),
        filterOrControlId: 'project',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $db5452cc2a2c823d$export$aaa1dc33930567f9),
        onClearOptions: clearOptions
    });
};
var $bfdcecceb19b6316$export$2e2bcd8739ae039 = $bfdcecceb19b6316$var$ProjectFilter;





parcelRequire("42omo");








var $4ERNs = parcelRequire("4ERNs");











const $2a866244687c0e27$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    latestModifiedDateDESC: {
        id: "dynamic-cards-search-page.results-sort.latestModifiedDateDESC",
        defaultMessage: "Updated (newest)"
    },
    latestModifiedDateDESCSelected: {
        id: "dynamic-cards-search-page.results-sort.latestModifiedDateDESC.selected",
        defaultMessage: "Sort by updated (newest)"
    },
    latestModifiedDateASC: {
        id: "dynamic-cards-search-page.results-sort.latestModifiedDateASC",
        defaultMessage: "Updated (oldest)"
    },
    latestModifiedDateASCSelected: {
        id: "dynamic-cards-search-page.results-sort.latestModifiedDateASC.selected",
        defaultMessage: "Sort by updated (oldest)"
    },
    createdDateDESC: {
        id: "dynamic-cards-search-page.results-sort.createdDateDESC",
        defaultMessage: "Created (newest)"
    },
    createdDateDESCSelected: {
        id: "dynamic-cards-search-page.results-sort.createdDate.selected",
        defaultMessage: "Sort by created (newest)"
    },
    createdDateASC: {
        id: "dynamic-cards-search-page.results-sort.createdDateASC",
        defaultMessage: "Created (oldest)"
    },
    createdDateASCSelected: {
        id: "dynamic-cards-search-page.results-sort.createdDateASC.selected",
        defaultMessage: "Sort by created (oldest)"
    },
    sortOptionsLabel: {
        id: "dynamic-cards-search-page.results-sort.sort-options.label",
        defaultMessage: "Change list sorting"
    }
});


const $f4d5925a874aa402$export$66a8c50d62eea7ce = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [selectedProduct] = (0, $7tL1u.useSelectedProduct)();
    const [{ order: order, field: field }, { setResultsSort: setResultsSort }] = (0, $7tL1u.useResultsSort)();
    const handleSelectOption = (option)=>{
        setResultsSort({
            order: (0, $4ERNs.RESULTS_SORT_FIELDS)[option.value].order,
            field: (0, $4ERNs.RESULTS_SORT_FIELDS)[option.value].field
        });
    };
    if (selectedProduct !== (0, $4sOnC.ProductKeys).Confluence) return null;
    const selectedOptionKey = (0, $4ERNs.getOptionKey)(field, order);
    const options = (0, $4ERNs.ResultsSortOptions).map((option)=>({
            label: formatMessage((0, $2a866244687c0e27$export$defe85febe8b728c)[option.labelKey]),
            value: option.labelKey,
            isSelected: option.labelKey === selectedOptionKey
        }));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6Ipjn.default), {
        label: formatMessage((0, $2a866244687c0e27$export$defe85febe8b728c).sortOptionsLabel),
        blurInputOnSelect: false,
        tabSelectsValue: false,
        backspaceRemovesValue: false,
        hideSelectedOptions: false,
        controlShouldRenderValue: false,
        isClearable: false,
        maxMenuWidth: "22rem",
        maxMenuHeight: 400,
        menuPlacement: "bottom",
        isOptionSelected: (option)=>option.isSelected,
        onChange: (value)=>value && handleSelectOption(value),
        options: options,
        popperProps: {
            strategy: 'fixed',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            8
                        ]
                    }
                },
                {
                    name: 'preventOverflow',
                    enabled: false
                }
            ]
        },
        target: ({ isOpen: isOpen, ...triggerProps })=>{
            const isSelected = isOpen || field !== (0, $4ERNs.SORT_FIELD_KEY).LAST_MODIFIED_DATE || order !== (0, $4ERNs.SORT_ORDER).DESC;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $753a7c5d9f81c8ec$export$fb46dd9777cc6db0), {
                isSelected: isSelected,
                otherProps: triggerProps,
                label: formatMessage((0, $2a866244687c0e27$export$defe85febe8b728c)[(0, $4ERNs.RESULTS_SORT_FIELDS)[selectedOptionKey].selectedLabelKey]),
                filterOrControlId: 'sort'
            });
        }
    });
};





parcelRequire("42omo");















const $716c7fb0d20bea04$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    space: {
        id: "dynamic-cards-search-page.filters.names.space",
        defaultMessage: "Space"
    },
    confluenceFilterSpacePlaceholder: {
        id: "dynamic-cards-search-page.confluence.filter.space.placeholder",
        defaultMessage: "Find spaces"
    },
    confluenceFilterLabelSelected: {
        id: "dynamic-cards-search-page.confluence.filter.label.selected",
        defaultMessage: "Selected"
    },
    confluenceFilterLabelUnselected: {
        id: "dynamic-cards-search-page.confluence.filter.label.unselected",
        defaultMessage: "Suggested"
    }
});


const $e9d3896870159dcb$var$SpaceFilter = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [filterData, { loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, setOption: setOption, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $e2xgH.useSelectFilter)({
        filterId: (0, $e4Y2w.filter).id
    });
    if (!filterData) return null;
    const { isLoading: isLoading, suggestedOptions: suggestedOptions, selectedOptions: selectedOptions, options: options, isLookupDefined: isLookupDefined, lookupInput: lookupInput, isLookupActive: isLookupActive } = filterData;
    const groupedOptions = [
        {
            label: formatMessage((0, $716c7fb0d20bea04$export$a7357cdd1f0b0168).confluenceFilterLabelSelected),
            options: selectedOptions
        },
        {
            label: formatMessage((0, $716c7fb0d20bea04$export$a7357cdd1f0b0168).confluenceFilterLabelUnselected),
            options: suggestedOptions
        }
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $64cfcf7920c92b4e$export$2e2bcd8739ae039), {
        canClearFilter: true,
        checkboxIndicators: true,
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSearchInputChange: setLookupInput,
        onSelectChange: setOption,
        options: isLookupActive ? options : groupedOptions,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $716c7fb0d20bea04$export$a7357cdd1f0b0168).space),
        placeholder: formatMessage((0, $716c7fb0d20bea04$export$a7357cdd1f0b0168).confluenceFilterSpacePlaceholder),
        filterOrControlId: 'space',
        isLoading: isLoading,
        isSearchable: isLookupDefined,
        searchInput: lookupInput,
        formatOptionLabel: (0, $db5452cc2a2c823d$export$aaa1dc33930567f9),
        onClearOptions: clearOptions
    });
};
var $e9d3896870159dcb$export$2e2bcd8739ae039 = $e9d3896870159dcb$var$SpaceFilter;





parcelRequire("42omo");







parcelRequire("42omo");


var $7gpC4 = parcelRequire("7gpC4");






const $ebd006a24026ec6e$var$containerStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.150',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    boxSizing: 'border-box',
    borderRadius: 'radius.small',
    maxWidth: '280px' // matches filter button
});
const $ebd006a24026ec6e$var$backgroundStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral'
});
const $ebd006a24026ec6e$var$containerCheckedStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.selected'
});
const $ebd006a24026ec6e$var$labelStyles = (0, $ecnYn.xcss)({
    fontWeight: "var(--ds-font-weight-medium, 500)"
});
const $ebd006a24026ec6e$var$labelActiveStyle = (0, $ecnYn.xcss)({
    color: 'color.text.selected'
});
const $ebd006a24026ec6e$export$2e955e9ca7bb51ef = ({ children: children, onChange: onChange, isChecked: isChecked, autoFocus: autoFocus = false, isFilterInDropdown: isFilterInDropdown = false })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: [
            $ebd006a24026ec6e$var$containerStyles,
            ...!isFilterInDropdown ? [
                $ebd006a24026ec6e$var$backgroundStyles,
                isChecked && $ebd006a24026ec6e$var$containerCheckedStyles
            ] : []
        ],
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7gpC4.default), {
            label: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $ebd006a24026ec6e$var$labelStyles,
                    isChecked && $ebd006a24026ec6e$var$labelActiveStyle
                ],
                children: children
            }),
            onChange: onChange,
            isChecked: isChecked,
            autoFocus: autoFocus
        })
    });
};



var $fjZo5 = parcelRequire("fjZo5");







const $ca01cb93720beac3$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    onlyTitleMatch: {
        id: "dynamic-cards-search-page.filters.names.titleMatchOnly",
        defaultMessage: "Title match"
    }
});


const $2fa18f4a50e2a68a$var$TitleMatchOnlyFilter = ({ isFilterInDropdown: isFilterInDropdown = false })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [state, { toggle: toggle }] = (0, $fjZo5.useBooleanFilter)({
        filterId: (0, $9md6K.filter).id
    });
    if (!state) return null;
    const { value: value, autoFocus: autoFocus } = state;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ebd006a24026ec6e$export$2e955e9ca7bb51ef), {
        onChange: toggle,
        isChecked: value,
        autoFocus: autoFocus,
        isFilterInDropdown: isFilterInDropdown,
        children: formatMessage((0, $ca01cb93720beac3$export$a7357cdd1f0b0168).onlyTitleMatch)
    });
};
var $2fa18f4a50e2a68a$export$2e2bcd8739ae039 = $2fa18f4a50e2a68a$var$TitleMatchOnlyFilter;





parcelRequire("42omo");












var $k6Hr4 = parcelRequire("k6Hr4");










const $cc23a1b8cca82726$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    type: {
        id: "dynamic-cards-search-page.filters.names.type",
        defaultMessage: "Type"
    },
    filterTypePlaceholder: {
        id: "dynamic-cards-search-page.filter.type.placeholder",
        defaultMessage: "Find type"
    }
});


const $2374bee18d0db5d7$var$getOptionsToProducts = (typeMapping)=>{
    const optionsToProducts = {};
    (0, $7mBSb.allTypeFilterValueKeys).forEach((type)=>{
        optionsToProducts[type] = typeMapping[type].products || [];
    });
    return optionsToProducts;
};
const $2374bee18d0db5d7$var$TypeFilter = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const typeMapping = (0, $k6Hr4.getTypeMapping)();
    const optionsToProducts = $2374bee18d0db5d7$var$getOptionsToProducts(typeMapping);
    const [productSelected] = (0, $7tL1u.useSelectedProduct)();
    const [filterData, { setOption: setOption, loadInitialOptions: loadInitialOptions, setLookupInput: setLookupInput, clearLookupInput: clearLookupInput, clearOptions: clearOptions }] = (0, $e2xgH.useUniversalSelectFilter)({
        filterId: (0, $7mBSb.universalTypeFilterId),
        optionsToProducts: optionsToProducts
    });
    if (!filterData) return null;
    // Do not show TypeFilter for Atlas since that is handled by Noun filters
    if (productSelected === (0, $4sOnC.ProductKeys).Atlas) return null;
    const { options: options, lookupInput: lookupInput, selectedOptions: selectedOptions } = filterData;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $64cfcf7920c92b4e$export$2e2bcd8739ae039), {
        onDropdownOpen: loadInitialOptions,
        onDropdownClose: clearLookupInput,
        onSelectChange: setOption,
        options: options,
        selectedOptions: selectedOptions,
        label: formatMessage((0, $cc23a1b8cca82726$export$a7357cdd1f0b0168).type),
        placeholder: formatMessage((0, $cc23a1b8cca82726$export$a7357cdd1f0b0168).filterTypePlaceholder),
        filterOrControlId: (0, $7mBSb.universalTypeFilterId),
        searchInput: lookupInput,
        onSearchInputChange: setLookupInput,
        isSearchable: true,
        onClearOptions: clearOptions,
        testId: "universal-type-filter"
    });
};
var $2374bee18d0db5d7$export$2e2bcd8739ae039 = $2374bee18d0db5d7$var$TypeFilter;





parcelRequire("42omo");








parcelRequire("42omo");










const $dfa2ed0142a27f5d$var$baseStyles = (0, $ecnYn.xcss)({
    height: '32px',
    paddingInline: 'space.150',
    width: '100%',
    borderRadius: 'radius.small',
    color: 'color.text',
    backgroundColor: 'color.background.neutral',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    }
});
const $dfa2ed0142a27f5d$var$selectedStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.accent.blue',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    }
});
const $dfa2ed0142a27f5d$var$buttonWrapperStyles = (0, $ecnYn.xcss)({
    maxWidth: '280px' // matches dropdown of 312px (and padding)
});
const $dfa2ed0142a27f5d$var$textStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)"
});
const $dfa2ed0142a27f5d$var$PressableToggleFilter = ({ icon: icon, label: label, onClick: onClick, isSelected: isSelected, autoFocus: autoFocus })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $dfa2ed0142a27f5d$var$buttonWrapperStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
            onClick: onClick,
            autoFocus: autoFocus,
            xcss: [
                $dfa2ed0142a27f5d$var$baseStyles,
                isSelected && $dfa2ed0142a27f5d$var$selectedStyles
            ],
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                alignBlock: "center",
                alignInline: "start",
                xcss: $dfa2ed0142a27f5d$var$textStyles,
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
                        alignBlock: "center",
                        alignInline: "center",
                        children: icon
                    }),
                    label
                ]
            })
        })
    });
};
var $dfa2ed0142a27f5d$export$2e2bcd8739ae039 = $dfa2ed0142a27f5d$var$PressableToggleFilter;











const $0b68f860b2f81619$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    verified: {
        id: "dynamic-cards-search-page.filters.names.verified",
        defaultMessage: "Verified"
    }
});


const $4267bfca5ee58f3b$var$VerifiedFilter = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [state, { toggle: toggle }] = (0, $fjZo5.useBooleanFilter)({
        filterId: (0, $lKbSE.filter).id
    });
    if (!state) return null;
    const { value: value, autoFocus: autoFocus } = state;
    const buttonIcon = (0, $366ad95c9acca0f8$export$16b26cd5e98d9100)({
        filterOrControlId: (0, $lKbSE.filter).id,
        isSelected: value
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dfa2ed0142a27f5d$export$2e2bcd8739ae039), {
        icon: buttonIcon,
        label: formatMessage((0, $0b68f860b2f81619$export$a7357cdd1f0b0168).verified),
        onClick: toggle,
        isSelected: value,
        autoFocus: autoFocus
    });
};
var $4267bfca5ee58f3b$export$2e2bcd8739ae039 = $4267bfca5ee58f3b$var$VerifiedFilter;





const $4b90425eb6ca8f61$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    title: {
        id: "dynamic-cards-search-page.filters.dropdown.title",
        defaultMessage: "Filter"
    },
    clearAll: {
        id: "dynamic-cards-search-page.filters.dropdown.clear-all",
        defaultMessage: "Clear all"
    }
});


const $69e5851a686aa643$var$dropdownContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.200',
    width: '312px'
});
const $69e5851a686aa643$var$filters = {
    [(0, $7mBSb.universalTypeFilterId)]: /*#__PURE__*/ (0, $l998X.jsx)((0, $2374bee18d0db5d7$export$2e2bcd8739ae039), {}, (0, $7mBSb.universalTypeFilterId)),
    [(0, $i4ijn.filter).id]: /*#__PURE__*/ (0, $l998X.jsx)((0, $f50dfd995c7604d4$export$2e2bcd8739ae039), {}, (0, $i4ijn.filter).id),
    [(0, $eJ38t.filter).id]: /*#__PURE__*/ (0, $l998X.jsx)((0, $92be3f9a8d7795d0$export$2e2bcd8739ae039), {}, (0, $eJ38t.filter).id),
    [(0, $2zUQE.filter).id]: /*#__PURE__*/ (0, $l998X.jsx)((0, $6a89f1316016588a$export$2e2bcd8739ae039), {}, (0, $2zUQE.filter).id),
    [(0, $e4Y2w.filter).id]: /*#__PURE__*/ (0, $l998X.jsx)((0, $e9d3896870159dcb$export$2e2bcd8739ae039), {}, (0, $e4Y2w.filter).id),
    [(0, $dKCFm.filter).id]: /*#__PURE__*/ (0, $l998X.jsx)((0, $1c0b14ce8c4baa2a$export$2e2bcd8739ae039), {}, (0, $dKCFm.filter).id),
    [(0, $hYkUd.filter).id]: /*#__PURE__*/ (0, $l998X.jsx)((0, $bfdcecceb19b6316$export$2e2bcd8739ae039), {}, (0, $hYkUd.filter).id),
    [(0, $7l9HL.filter).id]: /*#__PURE__*/ (0, $l998X.jsx)((0, $4fc68d5e59a588e8$export$2e2bcd8739ae039), {}, (0, $7l9HL.filter).id),
    [(0, $9md6K.filter).id]: /*#__PURE__*/ (0, $l998X.jsx)((0, $2fa18f4a50e2a68a$export$2e2bcd8739ae039), {
        isFilterInDropdown: true
    }, (0, $9md6K.filter).id),
    [(0, $lKbSE.filter).id]: /*#__PURE__*/ (0, $l998X.jsx)((0, $4267bfca5ee58f3b$export$2e2bcd8739ae039), {}, (0, $lKbSE.filter).id),
    [(0, $11Uwq.filter).id]: /*#__PURE__*/ (0, $l998X.jsx)((0, $5507e89c148336fd$export$2e2bcd8739ae039), {}, (0, $11Uwq.filter).id)
};
const $69e5851a686aa643$var$dividerStyles = (0, $ecnYn.xcss)({
    borderBottomWidth: 'border.width',
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderTop: 0
});
const $69e5851a686aa643$var$DropdownFilter = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [{ selectedFilterCount: selectedFilterCount }] = (0, $7tL1u.useSelectedFilterCount)();
    const [{ filtersInDropdown: filtersInDropdown }] = (0, $7tL1u.useFiltersToDisplay)();
    const { clearAllAvailableFilters: clearAllAvailableFilters } = (0, $7tL1u.useSearchActions)();
    const [selectedProduct] = (0, $7tL1u.useSelectedProduct)();
    const isConfluence = selectedProduct === (0, $4sOnC.ProductKeys).Confluence;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, testId: testId, ...providedProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $753a7c5d9f81c8ec$export$fb46dd9777cc6db0), {
                otherProps: {
                    ...providedProps,
                    ref: triggerRef
                },
                isSelected: selectedFilterCount > 0,
                filterOrControlId: "dropdown",
                label: formatMessage((0, $4b90425eb6ca8f61$export$a7357cdd1f0b0168).title),
                selectionBadge: selectedFilterCount > 0 ? /*#__PURE__*/ (0, $l998X.jsx)((0, $c4sKh.default), {
                    appearance: "primary",
                    children: selectedFilterCount
                }) : null
            }),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
            xcss: $69e5851a686aa643$var$dropdownContainerStyles,
            space: "space.200",
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                    space: "space.200",
                    children: [
                        filtersInDropdown.map((filterId)=>{
                            // TODO: remove the typecast here
                            // (was added so that product type filters didn't have to be included in the filters object)
                            return $69e5851a686aa643$var$filters[filterId];
                        }),
                        isConfluence && /*#__PURE__*/ (0, $l998X.jsx)((0, $f4d5925a874aa402$export$66a8c50d62eea7ce), {})
                    ]
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    as: "div",
                    xcss: $69e5851a686aa643$var$dividerStyles
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        onClick: clearAllAvailableFilters,
                        children: formatMessage((0, $4b90425eb6ca8f61$export$a7357cdd1f0b0168).clearAll)
                    })
                })
            ]
        })
    });
};
var $69e5851a686aa643$export$2e2bcd8739ae039 = $69e5851a686aa643$var$DropdownFilter;











const $c3b772be3fae45d5$var$filters = {
    [(0, $i4ijn.filter).id]: (0, $f50dfd995c7604d4$export$2e2bcd8739ae039),
    [(0, $7mBSb.universalTypeFilterId)]: (0, $2374bee18d0db5d7$export$2e2bcd8739ae039),
    [(0, $eJ38t.filter).id]: (0, $92be3f9a8d7795d0$export$2e2bcd8739ae039),
    [(0, $e4Y2w.filter).id]: (0, $e9d3896870159dcb$export$2e2bcd8739ae039),
    [(0, $lKbSE.filter).id]: (0, $4267bfca5ee58f3b$export$2e2bcd8739ae039),
    [(0, $dKCFm.filter).id]: (0, $1c0b14ce8c4baa2a$export$2e2bcd8739ae039),
    [(0, $hYkUd.filter).id]: (0, $bfdcecceb19b6316$export$2e2bcd8739ae039),
    [(0, $7l9HL.filter).id]: (0, $4fc68d5e59a588e8$export$2e2bcd8739ae039),
    [(0, $9md6K.filter).id]: (0, $2fa18f4a50e2a68a$export$2e2bcd8739ae039),
    [(0, $2zUQE.filter).id]: (0, $6a89f1316016588a$export$2e2bcd8739ae039),
    [(0, $11Uwq.filter).id]: (0, $5507e89c148336fd$export$2e2bcd8739ae039)
};
const $c3b772be3fae45d5$var$useOverflowFilterObserver = (containerRef, filterRefs, filterIds)=>{
    const observerRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const target = entry.target;
                if (entry.isIntersecting) target.style.visibility = 'visible';
                else target.style.visibility = 'hidden';
            });
        }, {
            root: containerRef.current,
            threshold: 0.85
        });
        observerRef.current = observer;
        return ()=>{
            observer.disconnect();
        };
    }, [
        containerRef
    ]);
    (0, $42omo.useEffect)(()=>{
        const observer = observerRef.current;
        if (!observer) return;
        filterRefs.current.forEach((filterRef)=>{
            observer.observe(filterRef?.current);
        });
    }, [
        filterRefs,
        filterIds
    ]);
};
const $c3b772be3fae45d5$var$flexStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    flexWrap: 'wrap',
    padding: 'space.050'
});
const $c3b772be3fae45d5$var$stackedStyles = (0, $ecnYn.xcss)({
    maxWidth: '280px',
    padding: 'space.0'
});
const $c3b772be3fae45d5$var$ProductFilters = ()=>{
    const [{ filtersInLine: filtersInLine }] = (0, $7tL1u.useFiltersToDisplay)();
    const [productSelected] = (0, $7tL1u.useSelectedProduct)();
    const filterContainerRef = (0, $42omo.useRef)();
    const filterRefs = (0, $42omo.useRef)([]);
    const isConfluence = productSelected === (0, $4sOnC.ProductKeys).Confluence;
    filterRefs.current = filtersInLine.filter((id)=>$c3b772be3fae45d5$var$filters[id]).map((_, i)=>filterRefs.current[i] ?? /*#__PURE__*/ (0, $42omo.createRef)());
    $c3b772be3fae45d5$var$useOverflowFilterObserver(filterContainerRef, filterRefs, filtersInLine);
    const renderInlineFilters = ()=>{
        return filtersInLine.map((id, index)=>{
            const Filter = $c3b772be3fae45d5$var$filters[id];
            if (!Filter) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                ref: filterRefs.current[index],
                children: /*#__PURE__*/ (0, $l998X.jsx)(Filter, {})
            }, id);
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $11d4b0b18ed41ef3$export$95d78afe1ba1dce1), {
        name: (0, $930693b11d26c5f4$export$b2c6f9ee831a1261),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
            ref: filterContainerRef,
            space: "space.100",
            xcss: $c3b772be3fae45d5$var$flexStyles,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $69e5851a686aa643$export$2e2bcd8739ae039), {}),
                renderInlineFilters(),
                isConfluence && /*#__PURE__*/ (0, $l998X.jsx)((0, $f4d5925a874aa402$export$66a8c50d62eea7ce), {})
            ]
        })
    });
};
var $c3b772be3fae45d5$export$2e2bcd8739ae039 = $c3b772be3fae45d5$var$ProductFilters;
const $c3b772be3fae45d5$export$9f76702cd2492a41 = ({ filtersToHide: filtersToHide })=>{
    const [{ filtersInLine: filtersInLine }] = (0, $7tL1u.useFiltersToDisplay)();
    const renderInlineFilters = ()=>{
        return filtersInLine.filter((id)=>!filtersToHide.includes(id)).map((id, index)=>{
            const Filter = $c3b772be3fae45d5$var$filters[id];
            if (!Filter) return null;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)(Filter, {})
            }, id);
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
        space: "space.100",
        xcss: [
            $c3b772be3fae45d5$var$flexStyles,
            $c3b772be3fae45d5$var$stackedStyles
        ],
        children: renderInlineFilters()
    });
};


const $ad6043c85560ba2d$export$92a576f896a9bf72 = ()=>{
    const [bootstrapLoading] = (0, $ee6ce766a2e08634$export$f7c6299b3492081c)();
    if (bootstrapLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $966bacae4db23ddd$export$d5722e1c0b3e12f1), {});
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        direction: "column",
        gap: "space.200",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            space: "space.100",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $c3b772be3fae45d5$export$2e2bcd8739ae039), {})
        })
    });
};
const $ad6043c85560ba2d$var$FiltersWithErrorBoundary = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $63afac6f9f5eb800$export$e926676385687eaf), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($ad6043c85560ba2d$export$92a576f896a9bf72, {})
    });
};
var $ad6043c85560ba2d$export$2e2bcd8739ae039 = $ad6043c85560ba2d$var$FiltersWithErrorBoundary;
const $ad6043c85560ba2d$export$4f7c5f9bd9ac3227 = ({ filtersToHide: filtersToHide })=>{
    const [bootstrapLoading] = (0, $ee6ce766a2e08634$export$f7c6299b3492081c)();
    if (bootstrapLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $966bacae4db23ddd$export$d5722e1c0b3e12f1), {});
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $c3b772be3fae45d5$export$9f76702cd2492a41), {
        filtersToHide: filtersToHide
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $fFa3V = parcelRequire("fFa3V");




















const $4cde92b339c1c935$export$d4c72bab9d6cc13a = {
    showDropdown: false,
    dropdownLoading: true,
    prefetchedRecentViewsResults: undefined,
    prefetchedRecentSearchResults: [],
    peopleAndTeamsResults: {
        results: [],
        duration: -1
    },
    recentViewsResults: [],
    autoSuggestionResults: {
        results: [],
        duration: -1
    },
    quickSearchResults: [],
    recentSearchResults: [],
    resultCount: {
        peopleAndTeams: 0,
        autoSuggestion: 0,
        quickSearch: 0,
        recentSearch: 0,
        recentViews: 0
    },
    selectedInputFilters: []
};
const $4cde92b339c1c935$var$actions = {
    setShowDropdown: (showDropdown)=>({ setState: setState })=>{
            setState({
                showDropdown: showDropdown
            });
        },
    setDropdownLoading: (dropdownLoading)=>({ setState: setState })=>{
            setState({
                dropdownLoading: dropdownLoading
            });
        },
    setPeopleAndTeamsResults: (peopleAndTeamsResults)=>({ setState: setState })=>{
            setState({
                peopleAndTeamsResults: peopleAndTeamsResults
            });
        },
    setRecentViewsResults: (recentViewsResults)=>({ setState: setState })=>{
            setState({
                recentViewsResults: recentViewsResults
            });
        },
    setAutoSuggestionResults: (autoSuggestionResults)=>({ setState: setState })=>{
            setState({
                autoSuggestionResults: autoSuggestionResults
            });
        },
    setRecentSearchResults: (recentSearchResults)=>({ setState: setState })=>{
            setState({
                recentSearchResults: recentSearchResults
            });
        },
    setQuickSearchResults: (quickSearchResults)=>({ setState: setState })=>{
            setState({
                quickSearchResults: quickSearchResults
            });
        },
    setResultCount: (resultCount)=>({ setState: setState })=>{
            setState({
                resultCount: resultCount
            });
        },
    setPrefetchedRecentViewsResults: (prefetchedRecentViewsResults)=>({ setState: setState })=>{
            setState({
                prefetchedRecentViewsResults: prefetchedRecentViewsResults
            });
        },
    setPrefetchedRecentSearchResults: (prefetchedRecentSearchResults)=>({ setState: setState })=>{
            setState({
                prefetchedRecentSearchResults: prefetchedRecentSearchResults
            });
        },
    setSelectedInputFilters: (selectedInputFilters)=>({ setState: setState })=>{
            setState({
                selectedInputFilters: selectedInputFilters
            });
        }
};
const $4cde92b339c1c935$export$1d29bcde96a75168 = (0, $FOT9i.createContainer)();
// Keep store private and use hooks to access state and actions
const $4cde92b339c1c935$var$Store = (0, $1P1Tu.createStore)({
    containedBy: $4cde92b339c1c935$export$1d29bcde96a75168,
    initialState: $4cde92b339c1c935$export$d4c72bab9d6cc13a,
    actions: $4cde92b339c1c935$var$actions,
    name: 'dynamic-cards-dropdown'
});
const $4cde92b339c1c935$export$4e8b5ffe8cfc8886 = (0, $9zUhf.createActionsHook)($4cde92b339c1c935$var$Store);
const $4cde92b339c1c935$export$8c32fdb3462273b4 = (0, $9zUhf.createHook)($4cde92b339c1c935$var$Store, {
    selector: (state)=>state.showDropdown
});
const $4cde92b339c1c935$export$41ba39ed718e7414 = (0, $9zUhf.createHook)($4cde92b339c1c935$var$Store, {
    selector: (state)=>state.dropdownLoading
});
const $4cde92b339c1c935$export$c30c238644aa02ee = (0, $9zUhf.createHook)($4cde92b339c1c935$var$Store, {
    selector: (state)=>state.peopleAndTeamsResults
});
const $4cde92b339c1c935$export$f53e0f96bec5ea4d = (0, $9zUhf.createHook)($4cde92b339c1c935$var$Store, {
    selector: (state)=>state.recentViewsResults
});
const $4cde92b339c1c935$export$30ecbc19a2297251 = (0, $9zUhf.createHook)($4cde92b339c1c935$var$Store, {
    selector: (state)=>state.autoSuggestionResults
});
const $4cde92b339c1c935$export$970bfa0ee111b06 = (0, $9zUhf.createHook)($4cde92b339c1c935$var$Store, {
    selector: (state)=>state.recentSearchResults
});
const $4cde92b339c1c935$export$369bf1e7413c2c02 = (0, $9zUhf.createHook)($4cde92b339c1c935$var$Store, {
    selector: (state)=>state.quickSearchResults
});
const $4cde92b339c1c935$export$22da568447791223 = (0, $9zUhf.createHook)($4cde92b339c1c935$var$Store, {
    selector: (state)=>state.resultCount
});
const $4cde92b339c1c935$export$a7f7068aa342db89 = (0, $9zUhf.createHook)($4cde92b339c1c935$var$Store, {
    selector: (state)=>state.prefetchedRecentViewsResults
});
const $4cde92b339c1c935$export$8fdf7942b5f23117 = (0, $9zUhf.createHook)($4cde92b339c1c935$var$Store, {
    selector: (state)=>state.prefetchedRecentSearchResults
});
const $4cde92b339c1c935$export$5a795cafef59146c = (0, $9zUhf.createHook)($4cde92b339c1c935$var$Store, {
    selector: (state)=>state.selectedInputFilters
});






parcelRequire("42omo");

const $604c75c78a943a42$export$ec4722d39a5031c0 = 'atlassian.unified-search.recent-searches';
const $604c75c78a943a42$export$c1b7badf23670c19 = 50;
const $604c75c78a943a42$export$74e99d9695eabee6 = (value, userId, product, recentSearchKey)=>{
    const recentSearchesRaw = $604c75c78a943a42$var$getLocalStorageItem(recentSearchKey);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    if (!recentSearches[userId]) recentSearches[userId] = {};
    let userSearches = recentSearches[userId];
    if (!userSearches[product]) userSearches[product] = [];
    let productSearches = userSearches[product];
    const trimmedValue = value.trim();
    // Pop the last value of the array if it is too long
    if (productSearches.length === $604c75c78a943a42$export$c1b7badf23670c19) productSearches.pop();
    // If the given value is a duplicate, remove it from the array
    if (productSearches.includes(trimmedValue)) productSearches = productSearches.filter((v)=>v !== trimmedValue);
    productSearches.unshift(trimmedValue);
    recentSearches[userId][product] = productSearches;
    $604c75c78a943a42$var$setLocalStorageItem(recentSearchKey, JSON.stringify(recentSearches));
};
const $604c75c78a943a42$export$1216255791599668 = (userId, product, recentSearchKey)=>{
    const recentSearchesRaw = $604c75c78a943a42$var$getLocalStorageItem(recentSearchKey);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    const userSearches = recentSearches[userId] || {};
    return userSearches[product] || [];
};
const $604c75c78a943a42$export$6adb2cc1366d1e30 = (value, userId, product, recentSearchKey)=>{
    const recentSearchesRaw = $604c75c78a943a42$var$getLocalStorageItem(recentSearchKey);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    if (!recentSearches[userId] || !recentSearches[userId][product]) return [];
    recentSearches[userId][product] = recentSearches[userId][product].filter((v)=>v !== value);
    $604c75c78a943a42$var$setLocalStorageItem(recentSearchKey, JSON.stringify(recentSearches));
    return recentSearches[userId][product];
};
const $604c75c78a943a42$var$setLocalStorageItem = (key, value)=>{
    window.localStorage.setItem(key, value);
};
const $604c75c78a943a42$var$getLocalStorageItem = (key)=>{
    return window.localStorage.getItem(key);
};


// Modified from platform/packages/search/product-search-dialog/src/extensible/product-router/product/result-provider/faster-search-helpers.ts
/**
 * Breakdown of the filtering & ordering logic :
 *
 * 0th pass: if the string has any highlight tags, remove them and continue
 * An alternate could be to exit early, but then we don't have the scoring information from the later passes
 *
 * 1st Pass - Complete match of query broken by words - This checks that all the words of the query must occur somewhere in the Title.
 *    - This is case insensitive.
 *    - This is unordered.
 *    For eg -
 *    Query - "mad max" will NOT let "Nomad" or "Climax" pass through,
 *    but  "Nomad Climax", "Madmax", "max Mad" will pass through
 *
 * 2nd Pass Scoring - Score calculation based on the kind of matches.
 *    There are 3 types - Exact match, StartsWith match & Partial match
 *    For eg -
 *    Exact Match (Score = 100) - Query: "Mad" will score "mad", "mad max" with 100.
 *            Note: Special characters stripped -  "Mad" will score "mad-max", "max-mad" with 100.
 *    StartsWith Match (Score = 10) - Query: "ark" will score "ARKK" and "Arkose Meeting" as 10
 *    Partial Match (Score = 1) - Query: "mad max" will score "Nomad Climax" as 2
 *
 *    Mix of multiple matching scenarios is possible.
 *    For example - "mad max" query will score "Mad Climax" as 100 (Exact) + 1 (Partial) = 101
 *
 * 3rd Pass - Sorting & Highlighting
 *    Sorting happens in the descending order of the score.
 *    Highlighting will match the entered query and inject necessary tags.
 *    Note: if both StartsWith and Partial matching exists in the same word then only StartsWith is highlighted
 *
 *    Two new properties are populated:
 *    1. highlightedText - highlights the query
 *    2. negatedHighlightedText - highights everything except the part that matches the query
 */ const $35ad33aa93b58ce9$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
const $35ad33aa93b58ce9$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
const $35ad33aa93b58ce9$var$SPECIAL_CHARACTER_REGEX = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g;
const $35ad33aa93b58ce9$var$CONSECUTIVE_START_REGEX = new RegExp(`${$35ad33aa93b58ce9$var$HIGHLIGHT_START_TAG}${$35ad33aa93b58ce9$var$HIGHLIGHT_START_TAG}`, 'g');
const $35ad33aa93b58ce9$var$CONSECUTIVE_END_REGEX = new RegExp(`${$35ad33aa93b58ce9$var$HIGHLIGHT_END_TAG}${$35ad33aa93b58ce9$var$HIGHLIGHT_END_TAG}`, 'g');
const $35ad33aa93b58ce9$var$CONSECUTIVE_START_END_REGEX = new RegExp(`${$35ad33aa93b58ce9$var$HIGHLIGHT_START_TAG}${$35ad33aa93b58ce9$var$HIGHLIGHT_END_TAG}`, 'g');
const $35ad33aa93b58ce9$var$ESCAPE_SPECIAL_CHARACTERS = /[.*+?^${}()|[\]\\]/g;
const $35ad33aa93b58ce9$var$cleanStartRegex = new RegExp($35ad33aa93b58ce9$var$HIGHLIGHT_START_TAG, 'g');
const $35ad33aa93b58ce9$var$cleanEndRegex = new RegExp($35ad33aa93b58ce9$var$HIGHLIGHT_END_TAG, 'g');
const $35ad33aa93b58ce9$export$9f4c92a576b56d82 = (source, matchWords)=>{
    // Remove any previous highlighting and regenerate
    // Supports the use case where we perform this on the frontend, and later the backend starts doing it for us first
    const cleanedSource = source.replace($35ad33aa93b58ce9$var$cleanStartRegex, '').replace($35ad33aa93b58ce9$var$cleanEndRegex, '');
    const lowerCaseMatchWords = matchWords.filter((word)=>word !== '').map((word)=>word.toLowerCase());
    const wordsDetails = cleanedSource.split(' ').map((word)=>{
        const lowerCaseWord = word.toLowerCase();
        const alphabetOnlyWord = lowerCaseWord.replace($35ad33aa93b58ce9$var$SPECIAL_CHARACTER_REGEX, ' ').split(' ');
        let partialCount = 0;
        let startsWithCount = 0;
        let exactMatchCount = 0;
        let exactMatch = '';
        let partialMatch = '';
        let startsWithMatch = '';
        for(let i = 0; i < lowerCaseMatchWords.length; ++i){
            if (lowerCaseWord === lowerCaseMatchWords[i] || alphabetOnlyWord.includes(lowerCaseMatchWords[i])) {
                exactMatchCount++;
                exactMatch = lowerCaseMatchWords[i];
                break;
            }
            if (lowerCaseWord.startsWith(lowerCaseMatchWords[i])) {
                startsWithCount++;
                startsWithMatch = lowerCaseMatchWords[i];
                continue;
            }
            if (lowerCaseWord.includes(lowerCaseMatchWords[i])) {
                partialCount++;
                partialMatch = lowerCaseMatchWords[i];
            }
        }
        const score = 100 * exactMatchCount + 10 * startsWithCount + partialCount;
        if (exactMatchCount > 0 || startsWithCount > 0 || partialCount > 0) {
            const pattern = exactMatchCount > 0 ? exactMatch : startsWithCount > 0 ? startsWithMatch : partialMatch;
            const regExp = new RegExp(`(${pattern.replace($35ad33aa93b58ce9$var$ESCAPE_SPECIAL_CHARACTERS, '\\$&')})`, 'ig');
            const openingClosingRegExp = new RegExp(`(${$35ad33aa93b58ce9$var$HIGHLIGHT_START_TAG}|${$35ad33aa93b58ce9$var$HIGHLIGHT_END_TAG})`, 'ig');
            const highlighted = word.replace(regExp, `${$35ad33aa93b58ce9$var$HIGHLIGHT_START_TAG}$1${$35ad33aa93b58ce9$var$HIGHLIGHT_END_TAG}`).replace($35ad33aa93b58ce9$var$CONSECUTIVE_START_END_REGEX, ``);
            const mirror = {
                [`${$35ad33aa93b58ce9$var$HIGHLIGHT_START_TAG}`]: `${$35ad33aa93b58ce9$var$HIGHLIGHT_END_TAG}`,
                [`${$35ad33aa93b58ce9$var$HIGHLIGHT_END_TAG}`]: `${$35ad33aa93b58ce9$var$HIGHLIGHT_START_TAG}`
            };
            const mirroredHighlighted = highlighted.replace(openingClosingRegExp, (ch)=>mirror[ch]);
            const negatedHighlight = `${$35ad33aa93b58ce9$var$HIGHLIGHT_START_TAG}${mirroredHighlighted}${$35ad33aa93b58ce9$var$HIGHLIGHT_END_TAG}`.replace($35ad33aa93b58ce9$var$CONSECUTIVE_START_REGEX, `${$35ad33aa93b58ce9$var$HIGHLIGHT_START_TAG}`).replace($35ad33aa93b58ce9$var$CONSECUTIVE_END_REGEX, `${$35ad33aa93b58ce9$var$HIGHLIGHT_END_TAG}`).replace($35ad33aa93b58ce9$var$CONSECUTIVE_START_END_REGEX, '');
            return {
                highlighted: highlighted,
                negatedHighlight: negatedHighlight,
                score: score
            };
        }
        // no match scenario
        return {
            negatedHighlight: `${$35ad33aa93b58ce9$var$HIGHLIGHT_START_TAG}${word}${$35ad33aa93b58ce9$var$HIGHLIGHT_END_TAG}`,
            highlighted: word,
            score: score
        };
    });
    const highlightedTitle = wordsDetails.map((wordObj)=>wordObj.highlighted).join(' ');
    const negatedHighlightedTitle = wordsDetails.map((wordObj)=>wordObj.negatedHighlight).join(' ');
    const finalScore = wordsDetails.reduce((acc, word)=>acc + word.score, 0);
    if (highlightedTitle !== '' && highlightedTitle !== cleanedSource) return {
        highlightedTitle: highlightedTitle,
        negatedHighlightedTitle: negatedHighlightedTitle,
        score: finalScore
    };
    return {};
};


function $bcd7084616aa17f3$export$18f3758fc3685a84(searchResults, query, numberOfResultItems = 3, negateTitleHighlight) {
    const wordsInQuery = query.split(' ');
    const itemScoreMap = {};
    const filteredResults = searchResults.flatMap((result)=>{
        // 1st pass
        const doAllWordsMatch = wordsInQuery.reduce((acc, word)=>{
            if (!acc) return acc;
            return result.title.toLowerCase().includes(word.toLowerCase());
        }, true);
        if (doAllWordsMatch) {
            // 2nd and 3rd Pass
            const { highlightedTitle: highlightedTitle, negatedHighlightedTitle: negatedHighlightedTitle, score: score = 0 } = (0, $35ad33aa93b58ce9$export$9f4c92a576b56d82)(result.title, wordsInQuery);
            itemScoreMap[result.title] = score;
            return [
                {
                    ...result,
                    highlightedTitle: negateTitleHighlight ? negatedHighlightedTitle : highlightedTitle
                }
            ];
        }
        return [];
    }).sort((item, secondItem)=>item && secondItem ? itemScoreMap[secondItem.title] - itemScoreMap[item.title] : 0).slice(0, numberOfResultItems);
    return filteredResults;
}


const $781d2c0e58644c52$export$7a283d45f414521b = (primaryProduct, userId)=>{
    if (userId && primaryProduct) {
        const recentSearches = (0, $604c75c78a943a42$export$1216255791599668)(userId, primaryProduct, (0, $604c75c78a943a42$export$ec4722d39a5031c0)).map((searchTitle)=>({
                title: searchTitle,
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                onClick: ()=>null
            }));
        return recentSearches;
    }
    return [];
};
const $781d2c0e58644c52$export$9770ca05e8d4f1fe = (recentSearches, inputQuery)=>{
    if (inputQuery.length === 0) return recentSearches;
    return (0, $bcd7084616aa17f3$export$18f3758fc3685a84)(recentSearches, inputQuery, inputQuery.length < 3 ? 3 : 2, true);
};



var $4mTS8 = parcelRequire("4mTS8");

const $9dd9882f33b9c3d2$var$ConfluencePageFragment = `
  fragment ConfluencePageFragment on ConfluencePage {
    __typename
    title
    pageStatus: status
    subtype
    ancestors {
      __typename
      id
      title
    }
    links {
      __typename
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $9dd9882f33b9c3d2$var$ConfluenceBlogPostFragment = `
  fragment ConfluenceBlogPostFragment on ConfluenceBlogPost {
    __typename
    title
    blogStatus: status
    links {
      __typename
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $9dd9882f33b9c3d2$var$ConfluenceWhiteboardFragment = `
  fragment ConfluenceWhiteboardFragment on ConfluenceWhiteboard {
    __typename
    title
    links {
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $9dd9882f33b9c3d2$var$AtlasProjectFragment = `
  fragment AtlasProjectFragment on TownsquareProject {
    __typename
    key
    name
    url
    iconData
  }
`;
const $9dd9882f33b9c3d2$var$AtlasGoalFragment = `
  fragment AtlasGoalFragment on TownsquareGoal {
    __typename
    key
    name
    url
    iconData
  }
`;
const $9dd9882f33b9c3d2$var$JiraSingleIssueLineTextFieldFragment = `
  fragment JiraSingleIssueLineTextFieldFragment on JiraSingleLineTextField {
    text
  }
`;
const $9dd9882f33b9c3d2$var$JiraIssueFragment = `
  fragment JiraIssueFragment on JiraIssue {
    __typename
    key
    webUrl
    fieldsById(ids: ["summary"]) {
      edges {
        node {
          __typename
          ...JiraSingleIssueLineTextFieldFragment
        }
      }
    }
  }
  ${$9dd9882f33b9c3d2$var$JiraSingleIssueLineTextFieldFragment}
`;
const $9dd9882f33b9c3d2$export$5db520940cf00715 = 'QuickFindActivitiesQuery';
const $9dd9882f33b9c3d2$export$8a781e50bcd90a75 = `
  query ${$9dd9882f33b9c3d2$export$5db520940cf00715}(
    $filteredProducts: [String!]
    $filteredObjectTypes: [String!]
    $itemsLimit: Int!
    $filteredRootContainerIds: [ID!]
  ) {
    activity {
      myActivity {
        all(
          filter: {
            arguments: {
              products: $filteredProducts
              objectTypes: $filteredObjectTypes
            }
            rootContainerIds: $filteredRootContainerIds
          }
          first: $itemsLimit
        ) {
          __typename
          edges {
            __typename
            node {
              __typename
              object {
                __typename
                id
                type
                product
                data {
                  __typename
                  ...ConfluencePageFragment
                  ...ConfluenceBlogPostFragment
                  ...ConfluenceWhiteboardFragment
                  ...AtlasProjectFragment
                  ...AtlasGoalFragment
                  ...JiraIssueFragment
                }
              }
              event {
                __typename
                eventType
                timestamp
              }
            }
          }
        }
      }
    }
  }
  ${$9dd9882f33b9c3d2$var$ConfluencePageFragment}
  ${$9dd9882f33b9c3d2$var$ConfluenceBlogPostFragment}
  ${$9dd9882f33b9c3d2$var$ConfluenceWhiteboardFragment}
  ${$9dd9882f33b9c3d2$var$AtlasProjectFragment}
  ${$9dd9882f33b9c3d2$var$AtlasGoalFragment}
  ${$9dd9882f33b9c3d2$var$JiraIssueFragment}
`;


const $be8e51cf7c00e2e3$export$ba6bff93c920ff4a = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    return (0, $4mTS8.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $9dd9882f33b9c3d2$export$8a781e50bcd90a75),
        operationName: $9dd9882f33b9c3d2$export$5db520940cf00715
    });
};










var $2v58P = parcelRequire("2v58P");


var $5yCDo = parcelRequire("5yCDo");

// Copied from confluence/next/packages/navigation-search-dialog/src/suppliers/utils/eventTypeMessage.tsx
// Extracted from @atlassian/recent-work-ui activity-event-type-message to create this
// helper function to convert timestamp to readable metadata



parcelRequire("42omo");


var $dlSEv = parcelRequire("dlSEv");


var $dhNqt = parcelRequire("dhNqt");


var $6gF1I = parcelRequire("6gF1I");






var $a2dru = parcelRequire("a2dru");


var $5mJ0F = parcelRequire("5mJ0F");

var $Lyrmh = parcelRequire("Lyrmh");

var $b55e1bac19310ac6$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    return VIEWED_EVENT;
}({});
var $b55e1bac19310ac6$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
function $b55e1bac19310ac6$export$e873c799b137eec4(date) {
    return (0, $dlSEv.default)(new Date(date), $b55e1bac19310ac6$var$startOfOneWeekAgo());
}
function $b55e1bac19310ac6$var$startOfOneWeekAgo() {
    return (0, $dhNqt.default)((0, $6gF1I.default)(new Date(), 1));
}
const $b55e1bac19310ac6$export$9e4fb3fb50a3c754 = ({ eventType: eventType, timestamp: timestamp })=>{
    const isAbsolute = $b55e1bac19310ac6$export$e873c799b137eec4(timestamp);
    const message = (0, $Lyrmh.useEventTypeMessage)(eventType, {
        isMyActivityData: true,
        isAbsolute: isAbsolute
    });
    const { value: value, unit: unit } = (0, $5mJ0F.selectUnit)(new Date(timestamp).getTime(), new Date(), {
        day: 7
    });
    const values = isAbsolute ? {
        // Show the absolute time if the activity was more than a week ago
        // e.g: You viewed on January 1, 2021
        absoluteTime: /*#__PURE__*/ (0, $l998X.jsx)((0, $cgtv4.FormattedDate), {
            value: timestamp,
            month: "short",
            day: "2-digit",
            year: "numeric"
        })
    } : {
        // Show the relative time if the activity was within a week ago
        // e.g: You viewed 2 hours ago
        relativeTime: /*#__PURE__*/ (0, $l998X.jsx)((0, $a2dru.default), {
            value: value,
            unit: unit
        })
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...message,
        values: values
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ // Copied from confluence/next/packages/navigation-search-dialog/src/suppliers/utils/ConfluenceResultMeta.tsx







var $gMc0m = parcelRequire("gMc0m");


var $3ro6F = parcelRequire("3ro6F");

var $kGnTD = parcelRequire("kGnTD");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7480d87fea25c3b1$var$ConfluenceResultMetaWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $7480d87fea25c3b1$var$BreadcrumbsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0qv77o _1yijwadc _1xbjidpf _1gmmidpf _fggvidpf _86yhidpf _95px1osq _fu36glyw _1bir1h6o _n1rrwadc _gyc2idpf _uzb6idpf _jnu2idpf _2gatidpf _1jn1glyw _1t771h6o _19301osq _1700idpf _10kk1b66 _ceouidpf _rq3g1b66 _1iev1y44 _1hjc1q9c",
            __cmplp.className
        ])
    });
});
const $7480d87fea25c3b1$var$ConfluenceTypeWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syazazsu _1p1d1dk0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7480d87fea25c3b1$var$ConfluenceMetaSpacerWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_syazazsu _19pkidpf _2hwx1b66 _otyridpf _18u01b66",
            __cmplp.className
        ])
    });
});
const $7480d87fea25c3b1$export$9138e703d4b4585b = ({ resultContentType: resultContentType, resultAncestors: resultAncestors, resultSpace: resultSpace })=>{
    const breadcrumbs = $7480d87fea25c3b1$export$ed9f69ac7e699c53(resultAncestors, resultSpace);
    return /*#__PURE__*/ (0, $l998X.jsxs)($7480d87fea25c3b1$var$ConfluenceResultMetaWrapper, {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($7480d87fea25c3b1$var$ConfluenceTypeWrapper, {
                children: "Confluence"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($7480d87fea25c3b1$var$ConfluenceMetaSpacerWrapper, {
                children: "\u2022"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($7480d87fea25c3b1$var$ConfluenceTypeWrapper, {
                children: resultContentType
            }),
            breadcrumbs?.length && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($7480d87fea25c3b1$var$ConfluenceMetaSpacerWrapper, {
                        children: "\u2022"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)($7480d87fea25c3b1$var$BreadcrumbsWrapper, {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kGnTD.default), {
                            maxItems: 2,
                            isExpanded: false,
                            onExpand: (e)=>e.preventDefault(),
                            children: breadcrumbs.map(({ id: id, title: title }, itemIndex)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3ro6F.default), {
                                    text: title || '',
                                    truncationWidth: itemIndex === breadcrumbs.length - 1 || itemIndex === 0 ? 130 : 50
                                }, id))
                        })
                    })
                ]
            })
        ]
    });
};
const $7480d87fea25c3b1$export$ed9f69ac7e699c53 = (ancestors, space)=>{
    let breadcrumbs = [];
    if (space) {
        const spaceBreadcrumb = {
            id: space?.id,
            title: space?.name
        };
        if (!ancestors || ancestors.length === 0) breadcrumbs = [
            spaceBreadcrumb
        ];
        else if (ancestors.length >= 1) breadcrumbs = [
            spaceBreadcrumb,
            ...ancestors.slice(1)
        ];
    }
    return breadcrumbs;
};


const $ac70571361b2d921$var$CONTEXT_PATH = '/wiki/spaces';
const $ac70571361b2d921$export$7192bcb9a5864aaa = (edge)=>{
    const item = edge.node;
    const iconLabel = `${item.object.product} ${item.object.type}`;
    switch(item.object.product){
        case 'jira':
            return {
                title: `${item.object.data?.key}: ${(item.object.data?.fieldsById?.edges || [
                    {}
                ])[0].node?.text}` || '',
                description: `Jira ${item.object.type}`,
                subheading: /*#__PURE__*/ (0, $l998X.jsx)((0, $b55e1bac19310ac6$export$9e4fb3fb50a3c754), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType
                }),
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $2v58P.default), {
                    label: iconLabel
                }),
                onClick: ()=>{},
                navigationUrl: item.object.data?.webUrl || ''
            };
        case 'confluence':
            return {
                title: item.object.data?.title || '',
                description: /*#__PURE__*/ (0, $l998X.jsx)((0, $7480d87fea25c3b1$export$9138e703d4b4585b), {
                    resultContentType: item.object.type,
                    resultAncestors: item.object.data?.ancestors,
                    resultSpace: item.object.data?.space
                }),
                subheading: /*#__PURE__*/ (0, $l998X.jsx)((0, $b55e1bac19310ac6$export$9e4fb3fb50a3c754), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType
                }),
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $5yCDo.default), {
                    label: iconLabel
                }),
                onClick: ()=>{},
                navigationUrl: `${item.object.data?.links?.base || $ac70571361b2d921$var$CONTEXT_PATH}${item.object.data?.links?.webUi || ''}`
            };
        case 'townsquare':
            return {
                title: `${item.object.data?.key}: ${item.object.data?.name}` || '',
                description: `Atlas ${item.object.type}`,
                subheading: /*#__PURE__*/ (0, $l998X.jsx)((0, $b55e1bac19310ac6$export$9e4fb3fb50a3c754), {
                    timestamp: item.event.timestamp,
                    eventType: item.event.eventType
                }),
                icon: /*#__PURE__*/ (0, $l998X.jsx)("img", {
                    width: 24,
                    height: 24,
                    src: item.object.data?.iconData || '',
                    alt: `${item.object.product} ${item.object.type}`
                }),
                onClick: ()=>{},
                navigationUrl: item.object.data?.url || '',
                meta: `Atlas ${item.object.type}`
            };
        default:
            return {
                title: '',
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}),
                onClick: ()=>{
                    return;
                }
            };
    }
};


const $162789f3961bdb60$export$ba7d28c6aa777ec8 = async (cloudId, onError)=>{
    const fetchData = async (filteredProducts, filteredObjectTypes, filteredRootContainerIds, itemsLimit)=>{
        const response = await (0, $be8e51cf7c00e2e3$export$ba6bff93c920ff4a)({
            variables: {
                filteredProducts: filteredProducts,
                filteredObjectTypes: filteredObjectTypes,
                filteredRootContainerIds: filteredRootContainerIds,
                itemsLimit: itemsLimit
            }
        }).catch((error)=>{
            onError(error);
        });
        const data = response && response.data;
        const edges = data?.activity?.myActivity?.all?.edges || [];
        return edges?.map((edge)=>(0, $ac70571361b2d921$export$7192bcb9a5864aaa)(edge));
    };
    return await fetchData([
        'confluence',
        'jira',
        'townsquare'
    ], [
        'page',
        'issue',
        'project'
    ], [
        `ari:cloud:platform::site/${cloudId}`,
        `ari:cloud:townsquare::site/${cloudId}`
    ], 200);
};
const $162789f3961bdb60$export$c8394dd336252c18 = (recentViews, inputQuery)=>{
    if (inputQuery.length === 0) return recentViews;
    return recentViews && (0, $bcd7084616aa17f3$export$18f3758fc3685a84)(recentViews, inputQuery);
};


const $8dea6d9445fd0527$export$11133d09694420f7 = ()=>{
    const [{ user: user, primaryProduct: primaryProduct, cloudId: cloudId }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const { setPrefetchedRecentSearchResults: setPrefetchedRecentSearchResults, setPrefetchedRecentViewsResults: setPrefetchedRecentViewsResults } = (0, $4cde92b339c1c935$export$4e8b5ffe8cfc8886)();
    const [features] = (0, $ee6ce766a2e08634$export$4a39035bacc4ed76)();
    const logException = (0, $63afac6f9f5eb800$export$67ff3bc9583d7c16)();
    (0, $42omo.useEffect)(()=>{
        async function fetchRecentViewsResults() {
            if (!cloudId) return;
            const recentViewsResults = await (0, $162789f3961bdb60$export$ba7d28c6aa777ec8)(cloudId, logException);
            setPrefetchedRecentViewsResults(recentViewsResults);
        }
        if (features?.recentViews?.enabled) fetchRecentViewsResults();
        else setPrefetchedRecentViewsResults([]);
    }, [
        setPrefetchedRecentViewsResults,
        cloudId,
        logException,
        features?.recentViews?.enabled
    ]);
    (0, $42omo.useEffect)(()=>{
        if (features?.recentSearches?.enabled) setPrefetchedRecentSearchResults((0, $781d2c0e58644c52$export$7a283d45f414521b)(primaryProduct, user?.id));
        else setPrefetchedRecentSearchResults([]);
    }, [
        primaryProduct,
        user,
        setPrefetchedRecentSearchResults,
        features?.recentSearches?.enabled
    ]);
};

























var $fpGTa = parcelRequire("fpGTa");

// This function is used to override the values of an object with the values of another object.
// Unless the value is null or undefined, the value from the source object will be used.
function $c4eb26ab9ec575a5$export$8b58be045bf06082(target, source) {
    const result = {
        ...target
    };
    for(const key in source)if (source[key] !== null && source[key] !== undefined) result[key] = source[key];
    return result;
}


function $0e889b123bd025c1$export$f654b28f82155665(url) {
    return url ? new URL(url).origin : window.location.origin;
}
function $0e889b123bd025c1$export$3c0cdf0037f37eca(queryParams) {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams();
    Object.entries(queryParams).forEach(([key, value])=>{
        if (value !== undefined && value !== null) searchParams.set(key, String(value));
    });
    url.search = searchParams.toString();
    return url.href;
}
function $0e889b123bd025c1$export$bd386de500a3324b(url) {
    window.location.href = url;
}


const $cdf2753c4aea5699$export$554c849e7e3a0f1 = {
    linkComponent: (0, $fpGTa.default),
    mapUserIdToProfileUrl: ()=>null,
    generateSearchUrl: (0, $0e889b123bd025c1$export$3c0cdf0037f37eca),
    queryParams: {},
    onNavigate: (0, $0e889b123bd025c1$export$bd386de500a3324b)
};
/**
 * Provides information about the host application that can't be stored in a state store,
 * e.g. a function.
 */ const $cdf2753c4aea5699$var$AppContext = /*#__PURE__*/ (0, $42omo.createContext)($cdf2753c4aea5699$export$554c849e7e3a0f1);
const $cdf2753c4aea5699$export$fdc397e486fa83e7 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($cdf2753c4aea5699$var$AppContext);
const $cdf2753c4aea5699$export$20d2b7652facc723 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)($cdf2753c4aea5699$var$AppContext.Provider, {
        value: (0, $c4eb26ab9ec575a5$export$8b58be045bf06082)($cdf2753c4aea5699$export$554c849e7e3a0f1, props),
        children: children
    });





parcelRequire("42omo");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss



parcelRequire("42omo");






const $22e6fc14f4422000$var$searchLinkWithDescriptionStyles = (0, $ecnYn.xcss)({
    width: 'fill',
    padding: 'space.100',
    display: 'grid',
    columnGap: 'space.100',
    gridTemplateColumns: 'auto 1fr',
    gridTemplateAreas: `
    "icon title"
    "icon description"
  `,
    alignItems: 'center',
    height: '50px',
    borderRadius: 'radius.large'
});
const $22e6fc14f4422000$var$iconSkeleton = (0, $ecnYn.xcss)({
    gridArea: 'icon',
    backgroundColor: 'color.background.neutral',
    width: '24px',
    height: '24px',
    borderRadius: 'radius.xsmall'
});
const $22e6fc14f4422000$var$titleSkeleton = (0, $ecnYn.xcss)({
    gridArea: 'title',
    backgroundColor: 'color.background.neutral',
    width: '260px',
    height: '14px',
    borderRadius: 'radius.xsmall'
});
const $22e6fc14f4422000$var$descriptionSkeleton = (0, $ecnYn.xcss)({
    gridArea: 'description',
    backgroundColor: 'color.background.neutral',
    width: '150px',
    height: '10px',
    borderRadius: 'radius.xsmall'
});
const $22e6fc14f4422000$export$f2db87eaff19de11 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $22e6fc14f4422000$var$searchLinkWithDescriptionStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $22e6fc14f4422000$var$iconSkeleton
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $22e6fc14f4422000$var$titleSkeleton
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $22e6fc14f4422000$var$descriptionSkeleton
            })
        ]
    });
};


const $7b696dc4c8d7dcd8$export$772547de01833b56 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $22e6fc14f4422000$export$f2db87eaff19de11), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $22e6fc14f4422000$export$f2db87eaff19de11), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $22e6fc14f4422000$export$f2db87eaff19de11), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $22e6fc14f4422000$export$f2db87eaff19de11), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $22e6fc14f4422000$export$f2db87eaff19de11), {})
        ]
    });
};





class $143bf33eb5bdc702$export$d7f5e52d091a66db extends Error {
    constructor(...args){
        super(...args);
        this.isCancelled = true;
    }
}
const $143bf33eb5bdc702$var$CANCEL_ERROR = new $143bf33eb5bdc702$export$d7f5e52d091a66db('Promise is cancelled');
class $143bf33eb5bdc702$export$5782acf08706f13d {
    static from(promise) {
        return new $143bf33eb5bdc702$export$5782acf08706f13d(promise);
    }
    constructor(promise){
        this.cancellablePromiseInternal = void 0;
        this.cancelInternal = ()=>{
            // Default throws an error as this should never happen
            throw new Error('Programming error, cancelling promise is not properly rejected');
        };
        this.promise = ()=>this.cancellablePromiseInternal;
        this.cancel = ()=>this.cancelInternal();
        this.cancellablePromiseInternal = Promise.race([
            promise,
            new Promise((_, reject)=>{
                this.cancelInternal = ()=>reject($143bf33eb5bdc702$var$CANCEL_ERROR);
            })
        ]);
    }
}



















































var $k5Lzq = parcelRequire("k5Lzq");




const $f04791d97275b682$export$d8428ac7d93fb69a = Object.freeze({
    [(0, $i4ijn.filter).id]: (0, $i4ijn.filter),
    [(0, $eJ38t.filter).id]: (0, $eJ38t.filter),
    [(0, $e4Y2w.filter).id]: (0, $e4Y2w.filter),
    [(0, $lKbSE.filter).id]: (0, $lKbSE.filter),
    [(0, $dKCFm.filter).id]: (0, $dKCFm.filter),
    [(0, $hYkUd.filter).id]: (0, $hYkUd.filter),
    [(0, $7mBSb.universalTypeFilterId)]: (0, $k5Lzq.filter),
    [(0, $7l9HL.filter).id]: (0, $7l9HL.filter),
    [(0, $9md6K.filter).id]: (0, $9md6K.filter),
    [(0, $2zUQE.filter).id]: (0, $2zUQE.filter),
    [(0, $11Uwq.filter).id]: (0, $11Uwq.filter)
});





const $4b32ad29ed64a485$var$getSelectFilterValue = (filter)=>{
    return (0, $e2xgH.isSelectFilter)(filter?.type) ? filter.value : [];
};
const $4b32ad29ed64a485$var$getSelectFilterCustomOptionValue = (filter)=>{
    return (0, $e2xgH.isSelectFilter)(filter?.type) ? filter.customValue : {};
};
const $4b32ad29ed64a485$var$getBooleanFilterValue = (filter)=>{
    return filter?.type === 'boolean' ? filter.value : false;
};
const $4b32ad29ed64a485$var$getSelectedDateRange = (filter)=>{
    const selectedDateOption = $4b32ad29ed64a485$var$getSelectFilterValue(filter).at(0);
    if (selectedDateOption && selectedDateOption !== (0, $7mBSb.CUSTOM_OPTION_VALUE)) return (0, $33vwh.convertLastUpdatedToDateRange)(selectedDateOption);
    else if (selectedDateOption === (0, $7mBSb.CUSTOM_OPTION_VALUE)) {
        const customDateRange = $4b32ad29ed64a485$var$getSelectFilterCustomOptionValue(filter);
        if (customDateRange?.from || customDateRange?.to) return (0, $33vwh.convertCustomDateToRange)(customDateRange.from, customDateRange.to);
    }
    return;
};
const $4b32ad29ed64a485$var$getFilterDateRange = (filter)=>{
    const selectedDateOption = $4b32ad29ed64a485$var$getSelectFilterValue(filter).at(0);
    if (selectedDateOption && selectedDateOption !== (0, $7mBSb.CUSTOM_OPTION_VALUE)) return [
        (0, $33vwh.getConfluenceDateOptionValues)(selectedDateOption)
    ];
    else if (selectedDateOption === (0, $7mBSb.CUSTOM_OPTION_VALUE)) {
        const customDateRange = $4b32ad29ed64a485$var$getSelectFilterCustomOptionValue(filter);
        if (customDateRange?.from && customDateRange?.to) return [
            (0, $33vwh.getConfluenceDateOptionFromCustomDates)(customDateRange.from, customDateRange.to)
        ];
    }
    return [];
};
const $4b32ad29ed64a485$export$eee2fc39be8ffb4a = (selectedProduct)=>{
    switch(selectedProduct){
        case (0, $4sOnC.ProductKeys).Jira:
            return [
                'software',
                'business'
            ];
        case (0, $4sOnC.ProductKeys).JiraProductDiscovery:
            return [
                'product_discovery'
            ];
        case (0, $4sOnC.ProductKeys).JiraServiceManagement:
            return [
                'service_desk'
            ];
    }
    return [
        'software',
        'business',
        'service_desk',
        'product_discovery'
    ];
};
const $4b32ad29ed64a485$export$e90e90fddddd8154 = ({ outboundAuthConfigs: outboundAuthConfigs })=>{
    const filters = (0, $7tL1u.useFilters)();
    const { selectedProduct: selectedProduct, filteredProducts: filteredProducts, availableProducts: availableProducts } = (0, $7tL1u.useProducts)();
    const { selectedEntities: selectedEntities, entitiesForQuery: entitiesForQuery, entitiesForResultsCountQuery: entitiesForResultsCountQuery } = (0, $7tL1u.useTypeEntities)({
        outboundAuthConfigs: outboundAuthConfigs
    });
    const titleMatchValue = $4b32ad29ed64a485$var$getBooleanFilterValue(filters[(0, $9md6K.filter).id]);
    const selectedDateRange = $4b32ad29ed64a485$var$getSelectedDateRange(filters[(0, $i4ijn.filter).id]);
    const filterDateRange = $4b32ad29ed64a485$var$getFilterDateRange(filters[(0, $i4ijn.filter).id]);
    // fg('universal-contributor-filter') => false
    const commonContributors = undefined;
    const selectedFilters = (0, $42omo.useMemo)(()=>({
            commonFilters: {
                range: {
                    lastModified: selectedDateRange
                },
                contributorsFilter: commonContributors
            },
            jiraFilters: {
                issueFilter: {
                    projectARIs: $4b32ad29ed64a485$var$getSelectFilterValue(filters[(0, $hYkUd.filter).id]),
                    assigneeARIs: $4b32ad29ed64a485$var$getSelectFilterValue(filters[(0, $dKCFm.filter).id])
                },
                projectFilter: {
                    // fg('enable_1p_search_jpd_jsm') => false
                    projectTypes: undefined
                }
            },
            confluenceFilters: {
                spacesFilter: $4b32ad29ed64a485$var$getSelectFilterValue(filters[(0, $e4Y2w.filter).id]),
                isVerified: $4b32ad29ed64a485$var$getBooleanFilterValue(filters[(0, $lKbSE.filter).id]) || undefined,
                contributorsFilter: $4b32ad29ed64a485$var$getSelectFilterValue(filters[(0, $eJ38t.filter).id]),
                ancestorIdsFilter: $4b32ad29ed64a485$var$getSelectFilterValue(filters[(0, $7l9HL.filter).id]),
                range: filterDateRange,
                owners: $4b32ad29ed64a485$var$getSelectFilterValue(filters[(0, $2zUQE.filter).id]),
                labelsFilter: $4b32ad29ed64a485$var$getSelectFilterValue(filters[(0, $11Uwq.filter).id])
            },
            thirdPartyFilters: (0, $33vwh.getThirdPartyFilters)(filteredProducts, titleMatchValue, selectedEntities, outboundAuthConfigs, (0, $33vwh.baseIntegrationARIs), filterDateRange)
        }), [
        filterDateRange,
        filteredProducts,
        filters,
        outboundAuthConfigs,
        selectedDateRange,
        selectedEntities,
        selectedProduct,
        titleMatchValue,
        commonContributors
    ]);
    const unselectedProductsThirdPartyFilters = (0, $42omo.useMemo)(()=>(0, $33vwh.getThirdPartyFilters)(availableProducts, titleMatchValue, selectedEntities, outboundAuthConfigs, (0, $33vwh.baseIntegrationARIs), filterDateRange), [
        availableProducts,
        titleMatchValue,
        selectedEntities,
        outboundAuthConfigs,
        filterDateRange
    ]);
    const { commonFilters: commonFilters, jiraFilters: jiraFilters, confluenceFilters: confluenceFilters, thirdPartyFilters: thirdPartyFilters } = selectedFilters;
    const isEmpty = !commonFilters.range.lastModified && selectedEntities.length === 0 && confluenceFilters.spacesFilter.length === 0 && !confluenceFilters.isVerified && confluenceFilters.contributorsFilter.length === 0 && confluenceFilters.ancestorIdsFilter.length === 0 && confluenceFilters.range.length === 0 && confluenceFilters.owners.length === 0 && confluenceFilters.labelsFilter.length === 0 && jiraFilters.issueFilter.assigneeARIs.length === 0 && jiraFilters.issueFilter.projectARIs.length === 0 && (!thirdPartyFilters.range || thirdPartyFilters?.range?.length === 0) && !thirdPartyFilters.titleMatchOnly && thirdPartyFilters.subtypes.length === 0;
    return {
        selectedFilters: selectedFilters,
        unselectedProductsThirdPartyFilters: unselectedProductsThirdPartyFilters,
        selectedEntities: selectedEntities,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery,
        entities: entitiesForQuery,
        hasFiltersSelected: !isEmpty
    };
};







const $821b7b2e4b1a4d2b$export$e292df53a75b4e9b = (inputQuery, count)=>{
    let { peopleAndTeams: peopleAndTeams, autoSuggestion: autoSuggestion, recentSearch: recentSearch, recentViews: recentViews, quickSearch: quickSearch } = count;
    // case 1: prequery
    let maxDisplayed = {
        peopleAndTeams: 0,
        autoSuggestion: 0,
        recentSearch: 3,
        recentViews: 5,
        quickSearch: 5
    };
    // case 2: 1-2 characters in query
    if (inputQuery.length === 1 || inputQuery.length === 2) {
        // with recent search match (same as prequery)
        if (recentSearch > 0) ;
        else if (autoSuggestion > 0) maxDisplayed = {
            peopleAndTeams: 0,
            autoSuggestion: 8 - Math.min(5, recentViews),
            recentSearch: 0,
            recentViews: 5,
            quickSearch: 5
        };
        else maxDisplayed = {
            peopleAndTeams: 0,
            autoSuggestion: 0,
            recentSearch: 0,
            recentViews: 7,
            quickSearch: 5
        };
    }
    // case 3: 3+ characters in query
    if (inputQuery.length >= 3) {
        // with no person match
        if (peopleAndTeams === 0) {
            // with no person match, with recent search
            if (recentSearch) maxDisplayed = {
                peopleAndTeams: 0,
                autoSuggestion: 3,
                recentSearch: 2,
                recentViews: 3,
                quickSearch: 5
            };
            else maxDisplayed = {
                peopleAndTeams: 0,
                autoSuggestion: 4,
                recentSearch: 0,
                recentViews: 4,
                quickSearch: 5
            };
        } else maxDisplayed = {
            peopleAndTeams: 2,
            autoSuggestion: recentSearch > 0 ? 1 : 3,
            recentSearch: 3,
            recentViews: 3,
            quickSearch: 5
        };
    }
    return {
        peopleAndTeams: Math.min(maxDisplayed.peopleAndTeams, peopleAndTeams),
        autoSuggestion: Math.min(maxDisplayed.autoSuggestion, autoSuggestion),
        recentSearch: Math.min(maxDisplayed.recentSearch, recentSearch),
        recentViews: Math.min(maxDisplayed.recentViews, recentViews),
        quickSearch: Math.min(maxDisplayed.quickSearch, quickSearch)
    };
};



var $c6GJD = parcelRequire("c6GJD");




const $bf7e6228e78e9e0b$var$operationName = 'AutoSuggestionQuery';
const $bf7e6228e78e9e0b$var$AutoSuggestionQuery = `
query ${$bf7e6228e78e9e0b$var$operationName}($query: String, $limit: Int!, $filters: QuerySuggestionFilterInput!) {
  suggest {
    suggest(query: $query, limit: $limit, filters: $filters) {
      nodes {
        title
        type
      }
      totalCount
    }
  }
}
`;
const $bf7e6228e78e9e0b$export$aa1032c480f72e0d = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>(0, $4mTS8.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: $bf7e6228e78e9e0b$var$AutoSuggestionQuery,
        operationName: $bf7e6228e78e9e0b$var$operationName
    });


const $3bd3e43c78176e61$export$2d543e88c46c0c38 = (query, bootstrap, onError)=>{
    const autoSuggestionFilters = {
        entities: [
            'query-suggestion.query-suggestion-item'
        ],
        locations: [
            `ari:cloud:confluence::site/${bootstrap.cloudId}`
        ]
    };
    const primaryProduct = bootstrap.primaryProduct;
    const fetchData = async (query)=>{
        // Confluence killswitch
        // FeatureGates.checkGate('search-plex_auto-suggestion') => false
        if (primaryProduct === 'confluence' && true) return {
            results: [],
            duration: 0
        };
        // Atlas killswitch
        if (primaryProduct === 'townsquare' && !(0, $c6GJD.default).checkGate('atlas_enable_query_suggestion_dropdown')) return {
            results: [],
            duration: 0
        };
        performance.mark('fetchAutoSuggestionResultsStart');
        const response = await (0, $bf7e6228e78e9e0b$export$aa1032c480f72e0d)({
            variables: {
                limit: 10,
                filters: autoSuggestionFilters,
                query: query
            }
        }).catch((error)=>{
            onError(error);
        });
        performance.mark('fetchAutoSuggestionResultsEnd');
        const { duration: duration } = performance.measure('fetchAutoSuggestionResultsDuration', 'fetchAutoSuggestionResultsStart', 'fetchAutoSuggestionResultsEnd');
        return {
            results: response?.data?.suggest?.suggest?.nodes || [],
            duration: duration
        };
    };
    return fetchData(query);
};



var $1L3gY = parcelRequire("1L3gY");

var $c5JjN = parcelRequire("c5JjN");

const $5d260bb54583869b$export$290039782fc4e47 = (query, bootstrap, onError)=>{
    const fetchData = async (query)=>{
        performance.mark('fetchPeopleAndTeamsResultsStart');
        // Map townsquare scope as URS does not support townsquare as a primary product
        const productKey = bootstrap.primaryProduct === 'townsquare' ? 'people' : bootstrap.primaryProduct;
        const recommendations = await (0, $1L3gY.default)({
            query: query,
            context: {
                contextType: 'full_page_search',
                siteId: bootstrap.cloudId || '',
                productKey: productKey || '',
                principalId: bootstrap.user?.id || '',
                organizationId: bootstrap.orgId || ''
            },
            includeUsers: true,
            includeTeams: true,
            includeGroups: false,
            maxNumberOfResults: 3,
            performSearchQueryOnly: false,
            searchQuery: {
                filter: 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)',
                teamSearchFields: [
                    (0, $c5JjN.TeamSearchField).NAME
                ]
            }
        }).catch((error)=>{
            onError(error);
            return [];
        });
        performance.mark('fetchPeopleAndTeamsResultsEnd');
        const { duration: duration } = performance.measure('fetchPeopleAndTeamsResultsDuration', 'fetchPeopleAndTeamsResultsStart', 'fetchPeopleAndTeamsResultsEnd');
        return {
            results: recommendations,
            duration: duration
        };
    };
    return fetchData(query);
};



var $gK4nz = parcelRequire("gK4nz");



const $8a8dc79490451be9$var$SearchResultAtlasProject = `
... on SearchResultAtlasProject @include(if: $includeAtlasProjects) {
  project {
    __typename
    key
  }
}
`;
const $8a8dc79490451be9$var$SearchResultAtlasGoal = `
... on SearchResultAtlasGoal @include(if: $includeAtlasGoals) {
  goal {
    __typename
    key
  }
}
`;
const $8a8dc79490451be9$var$SearchConfluencePageBlogAttachment = `
... on SearchConfluencePageBlogAttachment {
  __typename
  lastModified
  iconCssClass
  space {
    __typename
    id
    name
  }
  confluenceEntity @include(if: $includeAncestors) {
    ... on ConfluencePage {
      __typename
      ancestors {
        __typename
        id
        title
      }
    }
  }
}`;
const $8a8dc79490451be9$export$5db520940cf00715 = 'QuickFindSearchQuery';
const $8a8dc79490451be9$export$5dd443f88002bca3 = `
  query ${$8a8dc79490451be9$export$5db520940cf00715}(
    $query: String!
    $cloudIdARI: String!
    $resultsLimit: Int!
    $spaceLimit: Int!
    $contentEntities: [String!]!
    $confluenceFilters: SearchConfluenceFilter
    $queryVersion: Int
    $searchSessionId: String
    $includeSpaces: Boolean!
    $includeAncestors: Boolean!
		$includeAtlasProjects: Boolean = true
    $includeAtlasGoals: Boolean = true
    $experimentId: String
    $shadowExperimentId: String
    $experimentLayers: [SearchExperimentLayer]
		$experience: String = "quick-find"
		$spacesExperience: String = "searchDialog"
  ) {
    search {
      results: search(
        experience: $experience
        query: $query
        first: $resultsLimit
        filters: {
          entities: $contentEntities
          locations: [$cloudIdARI]
          confluenceFilters: $confluenceFilters
        }
        analytics: {
          queryVersion: $queryVersion
          searchSessionId: $searchSessionId
        }
        experimentContext: {
          experimentId: $experimentId
          shadowExperimentId: $shadowExperimentId
          experimentLayers: $experimentLayers
        }
      ) {
        __typename
        edges {
          __typename
          node {
            id
            title
            url
            type
            iconUrl
            __typename
            ${$8a8dc79490451be9$var$SearchConfluencePageBlogAttachment}
						${$8a8dc79490451be9$var$SearchResultAtlasProject}
						${$8a8dc79490451be9$var$SearchResultAtlasGoal}
          }
        }
        abTest {
          __typename
          abTestId
          controlId
          experimentId
        }
        totalCount
      }
      spaces: search(
				experience: $spacesExperience
        query: $query
        first: $spaceLimit
        filters: {
          entities: ["ati:cloud:confluence:space"]
          locations: [$cloudIdARI]
        }
        analytics: {
          queryVersion: $queryVersion
          searchSessionId: $searchSessionId
        }
      ) @include(if: $includeSpaces) {
        __typename
        edges {
          __typename
          node {
            ... on SearchConfluenceSpace {
              __typename
              id
              key
              title
              type
              url
              iconPath
            }
          }
        }
      }
    }
  }
`;


const $4477b093fb816db4$export$ac350a1cbaa2773a = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    return (0, $4mTS8.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $8a8dc79490451be9$export$5dd443f88002bca3),
        operationName: $8a8dc79490451be9$export$5db520940cf00715
    });
};








parcelRequire("42omo");






const $04942f75109648c1$export$be39b22d05f99edf = (inputQuery)=>({ node: node })=>{
        return {
            title: node?.title || '',
            description: /*#__PURE__*/ (0, $l998X.jsx)((0, $7480d87fea25c3b1$export$9138e703d4b4585b), {
                resultContentType: node?.type ?? 'page',
                resultAncestors: node?.confluenceEntity?.ancestors,
                resultSpace: node?.space
            }),
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $5yCDo.default), {
                label: ""
            }),
            onClick: ()=>{},
            navigationUrl: node?.url,
            highlightedTitle: (0, $35ad33aa93b58ce9$export$9f4c92a576b56d82)(node?.title ?? '', inputQuery.split(' ')).highlightedTitle
        };
    };


const $762eeb549063d764$export$f3ac47fc15573feb = ({ experience: experience, query: query, bootstrap: bootstrap, onError: onError, selectedFilters: selectedFilters, selectedEntities: selectedEntities })=>{
    const { confluenceFilters: confluenceFiltersAll, commonFilters: commonFilters } = selectedFilters || (0, $33vwh.getEmptySelectedFilters)();
    // In this filter set, "range" is defined as an array but the QuickFindSearchQuery expects an object.
    const { range: range, ...restOfconfluenceFilters } = confluenceFiltersAll;
    const confluenceFilters = {
        ...restOfconfluenceFilters,
        range: Array.isArray(range) && range.length > 0 ? range[0] : undefined
    };
    const fetchData = async (query)=>{
        const contentQueryResults = await (0, $4477b093fb816db4$export$ac350a1cbaa2773a)({
            variables: {
                query: query,
                experience: experience,
                cloudIdARI: `${(0, $gK4nz.CONFLUENCE_ARI_PREFIX)}${bootstrap.cloudId}`,
                resultsLimit: 5,
                spaceLimit: 3,
                contentEntities: selectedEntities,
                confluenceFilters: confluenceFilters,
                commonFilters: commonFilters,
                includeAncestors: true,
                includeSpaces: false,
                includeAtlasGoals: false,
                includeAtlasProjects: false,
                searchSessionId: bootstrap.searchSessionId,
                queryVersion: 1
            },
            aggAbsoluteUrl: bootstrap.aggAbsoluteUrl
        });
        const contentResponse = contentQueryResults.data?.search.results?.edges || [];
        const contentResults = contentResponse.map((0, $04942f75109648c1$export$be39b22d05f99edf)(query));
        return {
            results: contentResults,
            duration: null
        };
    };
    return fetchData(query).catch((error)=>{
        onError(error);
        return {
            results: [],
            duration: null
        };
    });
};




const $1cf2ef794a5aaf98$var$fetchAll = async ({ query: query, bootstrap: bootstrap, onError: onError, features: features, selectedFilters: selectedFilters, selectedEntities: selectedEntities })=>{
    const resolveEmpty = ()=>Promise.resolve({
            results: [],
            duration: 0
        });
    return Promise.all([
        features?.peopleAndTeamsSearch?.enabled ? (0, $5d260bb54583869b$export$290039782fc4e47)(query, bootstrap, onError) : resolveEmpty(),
        features?.autoSuggestion?.enabled ? (0, $3bd3e43c78176e61$export$2d543e88c46c0c38)(query, bootstrap, onError) : resolveEmpty(),
        features?.quickSearch?.enabled ? (0, $762eeb549063d764$export$f3ac47fc15573feb)({
            query: query,
            experience: 'company-hub-search',
            bootstrap: bootstrap,
            onError: onError,
            selectedFilters: selectedFilters,
            selectedEntities: selectedEntities
        }) : resolveEmpty()
    ]);
};
const $1cf2ef794a5aaf98$export$4e2bef15a5b74b17 = ()=>{
    const [inputQuery] = (0, $7tL1u.useInputQuery)();
    const [bootstrap] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const [dropdownLoading] = (0, $4cde92b339c1c935$export$41ba39ed718e7414)();
    const requestRef = (0, $42omo.useRef)();
    const [currentInputQuery, setCurrentInputQuery] = (0, $42omo.useState)(inputQuery);
    const [recentSearchResults] = (0, $4cde92b339c1c935$export$8fdf7942b5f23117)();
    const [recentViewsResults] = (0, $4cde92b339c1c935$export$a7f7068aa342db89)();
    const [features] = (0, $ee6ce766a2e08634$export$4a39035bacc4ed76)();
    const logException = (0, $63afac6f9f5eb800$export$67ff3bc9583d7c16)();
    const { setPeopleAndTeamsResults: setPeopleAndTeamsResults, setRecentViewsResults: setRecentViewsResults, setAutoSuggestionResults: setAutoSuggestionResults, setRecentSearchResults: setRecentSearchResults, setQuickSearchResults: setQuickSearchResults, setDropdownLoading: setDropdownLoading, setResultCount: setResultCount } = (0, $4cde92b339c1c935$export$4e8b5ffe8cfc8886)();
    const { selectedFilters: selectedFilters, entitiesForResultsCountQuery: entitiesForResultsCountQuery } = (0, $4b32ad29ed64a485$export$e90e90fddddd8154)({
        outboundAuthConfigs: bootstrap.outboundAuthConfigs
    });
    const debounceTimeout = (0, $42omo.useRef)(null);
    const fetchData = (0, $42omo.useCallback)(async (query, bootstrap)=>{
        setCurrentInputQuery(inputQuery);
        if (requestRef.current) // If there is an existing fetchAll promise, cancel it
        requestRef.current.cancel();
        setDropdownLoading(true);
        // Set the fetchAll promise
        requestRef.current = new (0, $143bf33eb5bdc702$export$5782acf08706f13d)($1cf2ef794a5aaf98$var$fetchAll({
            query: query,
            bootstrap: bootstrap,
            onError: logException,
            features: features,
            selectedFilters: selectedFilters,
            selectedEntities: entitiesForResultsCountQuery
        }));
        try {
            const [peopleAndTeamsResults, autoSuggestionResults, quickSearchResults] = await requestRef.current.promise();
            // update store
            setPeopleAndTeamsResults(peopleAndTeamsResults);
            setAutoSuggestionResults(autoSuggestionResults);
            const filteredRecentSearchResults = (0, $781d2c0e58644c52$export$9770ca05e8d4f1fe)(recentSearchResults, query);
            setRecentSearchResults(filteredRecentSearchResults);
            setQuickSearchResults(quickSearchResults.results);
            const filteredRecentViewsResults = (0, $162789f3961bdb60$export$c8394dd336252c18)(recentViewsResults ?? [], query);
            setRecentViewsResults(filteredRecentViewsResults);
            const resultCounts = (0, $821b7b2e4b1a4d2b$export$e292df53a75b4e9b)(query, {
                peopleAndTeams: peopleAndTeamsResults.results.length,
                autoSuggestion: autoSuggestionResults.results.length,
                quickSearch: quickSearchResults.results.length,
                recentSearch: filteredRecentSearchResults.length,
                recentViews: filteredRecentViewsResults.length
            });
            setResultCount(resultCounts);
            // stop loading
            setDropdownLoading(false);
        } catch (error) {
            if (!(error instanceof (0, $143bf33eb5bdc702$export$d7f5e52d091a66db))) {
                // stop loading
                setDropdownLoading(false);
                // log error
                logException(error);
            }
        }
    }, [
        inputQuery,
        logException,
        recentSearchResults,
        recentViewsResults,
        setAutoSuggestionResults,
        setDropdownLoading,
        setPeopleAndTeamsResults,
        setRecentSearchResults,
        setRecentViewsResults,
        setResultCount,
        setQuickSearchResults,
        features,
        selectedFilters,
        entitiesForResultsCountQuery
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((inputQuery !== currentInputQuery || dropdownLoading && !requestRef.current) && recentViewsResults !== undefined) {
            if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
            debounceTimeout.current = setTimeout(()=>{
                fetchData(inputQuery, bootstrap);
            }, 300);
        }
    }, [
        inputQuery,
        bootstrap,
        currentInputQuery,
        dropdownLoading,
        recentViewsResults,
        fetchData
    ]);
};










parcelRequire("42omo");





var $jluld = parcelRequire("jluld");







/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















parcelRequire("42omo");

const $d31ddad79049cd4c$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
const $d31ddad79049cd4c$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
const $d31ddad79049cd4c$var$highlightRE = new RegExp(`${$d31ddad79049cd4c$var$HIGHLIGHT_START_TAG}(.*?)${$d31ddad79049cd4c$var$HIGHLIGHT_END_TAG}.*`);
const $d31ddad79049cd4c$var$openingTagRE = new RegExp(`(.*?)${$d31ddad79049cd4c$var$HIGHLIGHT_START_TAG}`);
const $d31ddad79049cd4c$export$c43ff622b37ceaa9 = (title)=>{
    const enrichedTitle = [];
    // counter added to maintain uniqueness of element key
    // during subsequent rerenders due to query changes
    let counter = 0;
    if (!title.match($d31ddad79049cd4c$var$highlightRE)) // if there are no matches then return the title as is
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        children: title
    }, title + counter);
    while(title){
        const [preMatch, preText] = title.match($d31ddad79049cd4c$var$openingTagRE) || [];
        title = title.replace(preText, '');
        if (preText && preText !== '') enrichedTitle.push(/*#__PURE__*/ (0, $l998X.jsx)("span", {
            children: preText
        }, preText + counter));
        const [boldMatch, highlightText] = title.match($d31ddad79049cd4c$var$highlightRE) || [];
        title = title.replace(`${$d31ddad79049cd4c$var$HIGHLIGHT_START_TAG}${highlightText}${$d31ddad79049cd4c$var$HIGHLIGHT_END_TAG}`, '');
        if (highlightText && highlightText !== '') // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        enrichedTitle.push(/*#__PURE__*/ (0, $l998X.jsx)("strong", {
            children: highlightText
        }, highlightText + counter));
        if (preMatch === undefined && boldMatch === undefined) {
            if (title !== '') enrichedTitle.push(/*#__PURE__*/ (0, $l998X.jsx)("span", {
                children: title
            }, title + counter));
            break;
        }
        counter++;
    }
    return enrichedTitle;
};







const $b649cb93686b0b29$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    searchLinkLabel: {
        id: "dynamic-cards-search-page.search-link.label",
        defaultMessage: "Search Link"
    }
});


const $55d2bcfca9bb5d3e$var$searchLinkStyles = (0, $ecnYn.xcss)({
    width: 'fill',
    padding: 'space.100',
    display: 'grid',
    columnGap: 'space.100',
    gridTemplateColumns: 'auto 1fr auto',
    gridTemplateAreas: `
    "icon title subheading"
  `,
    alignItems: 'center',
    height: '40px',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    borderRadius: 'radius.large',
    cursor: 'pointer'
});
const $55d2bcfca9bb5d3e$var$searchLinkWithDescriptionStyles = (0, $ecnYn.xcss)({
    width: 'fill',
    padding: 'space.100',
    display: 'grid',
    columnGap: 'space.100',
    gridTemplateColumns: 'auto 1fr',
    gridTemplateAreas: `
    "icon title subheading"
    "icon description subheading"
  `,
    alignItems: 'center',
    height: '50px',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    borderRadius: 'radius.large',
    cursor: 'pointer'
});
const $55d2bcfca9bb5d3e$var$iconStyles = (0, $ecnYn.xcss)({
    gridArea: 'icon'
});
const $55d2bcfca9bb5d3e$var$titleStyles = (0, $ecnYn.xcss)({
    gridArea: 'title',
    color: 'color.text',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $55d2bcfca9bb5d3e$var$descriptionStyles = (0, $ecnYn.xcss)({
    gridArea: 'description',
    display: 'flex',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtle',
    paddingTop: 'space.075'
});
const $55d2bcfca9bb5d3e$var$subheadingStyles = (0, $ecnYn.xcss)({
    gridArea: 'subheading',
    display: 'flex',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtle',
    alignItems: 'center',
    gap: 'space.050'
});
const $55d2bcfca9bb5d3e$var$DropdownResultContent = ({ title: title, description: description, subheading: subheading, icon: icon, onClick: onClick, highlightedTitle: highlightedTitle, rightPanel: rightPanel })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isKeyboardHighlighted = false;
    const [isMouseHighlighted, setIsMouseHighlighted] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $2W0qg.default), {
        xcss: description ? $55d2bcfca9bb5d3e$var$searchLinkWithDescriptionStyles : $55d2bcfca9bb5d3e$var$searchLinkStyles,
        backgroundColor: isKeyboardHighlighted ? 'color.background.neutral.subtle.hovered' : 'color.background.neutral.subtle',
        onClick: onClick,
        onMouseDown: (e)=>e.preventDefault(),
        "aria-label": formatMessage((0, $b649cb93686b0b29$export$defe85febe8b728c).searchLinkLabel),
        onMouseOver: ()=>setIsMouseHighlighted(true),
        onMouseLeave: ()=>setIsMouseHighlighted(false),
        testId: "search-page-dropdown-result",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $55d2bcfca9bb5d3e$var$iconStyles,
                children: icon
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $55d2bcfca9bb5d3e$var$titleStyles,
                children: highlightedTitle ? (0, $d31ddad79049cd4c$export$c43ff622b37ceaa9)(highlightedTitle) : title
            }),
            subheading && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $55d2bcfca9bb5d3e$var$subheadingStyles,
                children: subheading
            }),
            description && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $55d2bcfca9bb5d3e$var$descriptionStyles,
                children: description
            }),
            rightPanel && (isKeyboardHighlighted || isMouseHighlighted) && rightPanel
        ]
    });
};
const $55d2bcfca9bb5d3e$export$5b6118e2ff142a50 = (props)=>{
    const linkRef = (0, $42omo.useRef)(null);
    const { linkComponent: Link } = (0, $cdf2753c4aea5699$export$fdc397e486fa83e7)();
    return /*#__PURE__*/ (0, $l998X.jsx)(Link // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: {
            textDecoration: 'none',
            color: 'inherit'
        },
        ref: linkRef,
        href: props.navigationUrl || '',
        children: /*#__PURE__*/ (0, $l998X.jsx)($55d2bcfca9bb5d3e$var$DropdownResultContent, {
            ...props
        })
    });
};
const $55d2bcfca9bb5d3e$export$f12258e0b62ed378 = (props)=>{
    const [features] = (0, $ee6ce766a2e08634$export$4a39035bacc4ed76)();
    const onClick = (0, $42omo.useCallback)(()=>{
        if (!features?.chromeExtension?.enabled) return;
        const { onInputDropdownResultSelect: onInputDropdownResultSelect } = features.chromeExtension;
        onInputDropdownResultSelect({
            title: props.title,
            url: props.navigationUrl
        });
    }, [
        features?.chromeExtension,
        props.title,
        props.navigationUrl
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($55d2bcfca9bb5d3e$var$DropdownResultContent, {
        ...props,
        onClick: onClick
    });
};
const $55d2bcfca9bb5d3e$export$bbedf2c4ad87789c = (props)=>{
    const [features] = (0, $ee6ce766a2e08634$export$4a39035bacc4ed76)();
    if (features?.chromeExtension?.enabled) return /*#__PURE__*/ (0, $l998X.jsx)($55d2bcfca9bb5d3e$export$f12258e0b62ed378, {
        ...props
    });
    else if (props.navigationUrl) return /*#__PURE__*/ (0, $l998X.jsx)($55d2bcfca9bb5d3e$export$5b6118e2ff142a50, {
        ...props
    });
    else return /*#__PURE__*/ (0, $l998X.jsx)($55d2bcfca9bb5d3e$var$DropdownResultContent, {
        ...props
    });
};









const $f5e0e81a44bceb12$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    searchIconLabel: {
        id: "dynamic-cards-search-page.dropdown_search_icon_label",
        defaultMessage: "Search"
    }
});


const $e53faad5677c2709$var$iconStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.xsmall',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $e53faad5677c2709$export$14bd3dc13236b3f1 = ()=>{
    const [inputQuery, { setSearchQuery: setSearchQuery }] = (0, $7tL1u.useInputQuery)();
    const [, { setShowDropdown: setShowDropdown }] = (0, $4cde92b339c1c935$export$8c32fdb3462273b4)();
    const intl = (0, $8C5kA.default)();
    const [recentSearchResults] = (0, $4cde92b339c1c935$export$970bfa0ee111b06)();
    const [autoSuggestionResults] = (0, $4cde92b339c1c935$export$30ecbc19a2297251)();
    const [resultCount] = (0, $4cde92b339c1c935$export$22da568447791223)();
    const recentSearchTitles = recentSearchResults.slice(0, resultCount.recentSearch).map((search)=>search.title.toLowerCase());
    const filteredAutoSuggestions = autoSuggestionResults.results.filter((suggestion)=>{
        return !recentSearchTitles.includes(suggestion.title.toLowerCase()) && suggestion.title !== inputQuery.toLowerCase();
    }).slice(0, resultCount.autoSuggestion);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: filteredAutoSuggestions.map((suggestion, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $55d2bcfca9bb5d3e$export$bbedf2c4ad87789c), {
                title: suggestion.title || '',
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $e53faad5677c2709$var$iconStyles,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                        color: "currentColor",
                        label: intl.formatMessage((0, $f5e0e81a44bceb12$export$defe85febe8b728c).searchIconLabel)
                    })
                }),
                onClick: ()=>{
                    setSearchQuery(suggestion.title || '');
                    setShowDropdown(false);
                },
                highlightedTitle: (0, $35ad33aa93b58ce9$export$9f4c92a576b56d82)(suggestion.title, inputQuery.split(' ')).negatedHighlightedTitle
            }, `${index}-${suggestion.title}`))
    });
};





const $e53201f82c7b6560$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    searchSuggestionsDropdownLabel: {
        id: "dynamic-cards-search-page.dropdown.search-suggestions-label",
        defaultMessage: "Search Suggestions Dropdown"
    }
});





parcelRequire("42omo");












// Copied from packages/search/search-dialog/src/icons/square-return-icon.tsx



parcelRequire("42omo");




const $963f5e7a3c0840d7$export$4501fc029b186da8 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 20 20",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "20",
                height: "20",
                rx: "3",
                fill: `var(--ds-background-neutral, ${(0, $6fnsQ.N30)})`
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "nonzero",
                d: "M7.99707 14.7949C7.86035 14.7949 7.70312 14.7266 7.59375 14.624L4.47656 11.582C4.35352 11.459 4.29199 11.3154 4.29199 11.165C4.29199 11.0146 4.35352 10.8711 4.47656 10.7549L7.59375 7.71289C7.70312 7.60352 7.86035 7.54199 7.99707 7.54199C8.3252 7.54199 8.53711 7.76074 8.53711 8.08203C8.53711 8.23926 8.48926 8.3623 8.38672 8.45801L6.9375 9.86621L5.95996 10.6797L7.23145 10.6182H13.835C14.3887 10.6182 14.6006 10.3994 14.6006 9.8457V6.71484C14.6006 6.16797 14.3887 5.94922 13.835 5.94922H11.0117C10.6699 5.94922 10.4512 5.70312 10.4512 5.40234C10.4512 5.09473 10.6699 4.84863 11.0117 4.84863H13.835C15.1748 4.84863 15.708 5.375 15.708 6.71484V9.8457C15.708 11.124 15.1748 11.7188 13.835 11.7188H7.23145L5.95996 11.6572L6.9375 12.4707L8.38672 13.8721C8.48926 13.9746 8.53711 14.0908 8.53711 14.248C8.53711 14.5693 8.3252 14.7949 7.99707 14.7949Z",
                fill: `var(--ds-icon-subtle, ${(0, $6fnsQ.N700)})`
            })
        ]
    });










const $0da82713a89f76a8$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    search: {
        id: "dynamic-cards-search-page.dropdown_search",
        defaultMessage: "Search"
    },
    searchIconLabel: {
        id: "dynamic-cards-search-page.dropdown_search_icon_label",
        defaultMessage: "Search"
    }
});


const $738d5a88b733c23d$var$iconStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.xsmall',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $738d5a88b733c23d$var$subheadingTextWrapper = (0, $ecnYn.xcss)({
    marginRight: 'space.100'
});
const $738d5a88b733c23d$export$4a7d659f3bdb9018 = ()=>{
    const intl = (0, $8C5kA.default)();
    const [inputQuery] = (0, $7tL1u.useInputQuery)();
    const { triggerSearch: triggerSearch } = (0, $7tL1u.useSearchActions)();
    const { setShowDropdown: setShowDropdown } = (0, $4cde92b339c1c935$export$4e8b5ffe8cfc8886)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: inputQuery.length > 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $55d2bcfca9bb5d3e$export$bbedf2c4ad87789c), {
            title: inputQuery,
            subheading: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $738d5a88b733c23d$var$subheadingTextWrapper,
                        children: intl.formatMessage((0, $0da82713a89f76a8$export$defe85febe8b728c).search)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $963f5e7a3c0840d7$export$4501fc029b186da8), {})
                ]
            }),
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $738d5a88b733c23d$var$iconStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                    color: "currentColor",
                    label: intl.formatMessage((0, $0da82713a89f76a8$export$defe85febe8b728c).searchIconLabel)
                })
            }),
            onClick: ()=>{
                setShowDropdown(false);
                triggerSearch();
            }
        })
    });
};





parcelRequire("42omo");







parcelRequire("42omo");


var $gj7hi = parcelRequire("gj7hi");








const $27d1d3f58e00c7d2$var$resultStateContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    marginTop: 'space.400',
    marginBottom: 'space.100'
});
const $27d1d3f58e00c7d2$var$imageContainerStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.150'
});
const $27d1d3f58e00c7d2$var$primaryTextContainerStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.150',
    font: 'font.heading.medium',
    fontWeight: 'font.weight.medium'
});
const $27d1d3f58e00c7d2$var$secondaryTextContainerStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.200'
});
const $27d1d3f58e00c7d2$export$d9172702747fb4bc = ({ imageSrcLight: imageSrcLight, imageSrcDark: imageSrcDark, imageWidth: imageWidth, imageHeight: imageHeight, primaryText: primaryText, secondaryText: secondaryText, callToAction: callToAction, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $27d1d3f58e00c7d2$var$resultStateContainerStyles,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $27d1d3f58e00c7d2$var$imageContainerStyles,
                style: {
                    width: imageWidth || '124px',
                    height: imageHeight || '124px'
                },
                children: imageSrcLight && imageSrcDark && /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                    src: imageSrcLight,
                    srcDark: imageSrcDark,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $27d1d3f58e00c7d2$var$primaryTextContainerStyles,
                children: primaryText
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $27d1d3f58e00c7d2$var$secondaryTextContainerStyles,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                    children: secondaryText
                })
            }),
            callToAction && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                children: callToAction
            })
        ]
    });
};


var $3d5ea64853ec0005$exports = {};
$3d5ea64853ec0005$exports = new URL("no-results-dark.a00ae47b.svg", import.meta.url).toString();


var $58d994e1c8eb311d$exports = {};
$58d994e1c8eb311d$exports = new URL("no-results-light.5ca83755.svg", import.meta.url).toString();





const $daf3030cc0ea9202$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    noResultsPrimary: {
        id: "dynamic-cards-search-page.no_results_primary",
        defaultMessage: "We couldn't find anything matching your search"
    }
});


const $1ae31853cd696031$export$73c06a78041d5456 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $27d1d3f58e00c7d2$export$d9172702747fb4bc), {
        imageSrcLight: (0, (/*@__PURE__*/$parcel$interopDefault($58d994e1c8eb311d$exports))),
        imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($3d5ea64853ec0005$exports))),
        primaryText: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $daf3030cc0ea9202$export$defe85febe8b728c).noResultsPrimary
        }),
        secondaryText: ""
    });
};





parcelRequire("42omo");
















var $7UOIm = parcelRequire("7UOIm");

const $fc7dbd439c8c8ef0$export$7512fe8206a7f75b = (text)=>text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
// copied over from @confluence/hash
const $fc7dbd439c8c8ef0$var$hash = (algorithm, data, asBytes = false)=>{
    const hash = (0, (/*@__PURE__*/$parcel$interopDefault($7UOIm))).createHash(algorithm);
    hash.update(data);
    if (asBytes) return Array.from(hash.digest());
    return hash.digest('hex');
};
const $fc7dbd439c8c8ef0$export$5fdf8c875acfc1b3 = (data)=>{
    return $fc7dbd439c8c8ef0$var$hash('sha256', data, true);
};
const $fc7dbd439c8c8ef0$export$7904c6256691057a = (data)=>{
    return $fc7dbd439c8c8ef0$var$hash('sha256', data);
};
const $fc7dbd439c8c8ef0$export$451f7a1e7c934f54 = (userId, primaryProduct, orgId, cloudId)=>{
    if (primaryProduct === 'confluence') return `/wiki/people/${userId}`;
    else if (primaryProduct === 'townsquare') return `/o/${orgId}/people/${userId}?cloudId=${cloudId}`;
};
const $fc7dbd439c8c8ef0$export$9456a8e088bfede1 = (teamId, primaryProduct, orgId, cloudId)=>{
    if (primaryProduct === 'confluence') return `/wiki/people/team/${teamId}`;
    else if (primaryProduct === 'townsquare') return `/o/${orgId}/people/team/${teamId}?cloudId=${cloudId}`;
};










const $94b2d36fb89b4dc3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    teamLabel: {
        id: "dynamic-cards-search-page.team",
        defaultMessage: "Team"
    }
});


const $58900b9ea7bb9fa3$export$9d052a57a86e166 = ()=>{
    const intl = (0, $8C5kA.default)();
    const [cloudId] = (0, $ee6ce766a2e08634$export$9da0f7c65f28ed16)();
    const [orgId] = (0, $ee6ce766a2e08634$export$52a03a3207af3687)();
    const [inputQuery] = (0, $7tL1u.useInputQuery)();
    const [primaryProduct] = (0, $ee6ce766a2e08634$export$92c6f3c7c09f3247)();
    const [, { setShowDropdown: setShowDropdown }] = (0, $4cde92b339c1c935$export$8c32fdb3462273b4)();
    const [resultCount] = (0, $4cde92b339c1c935$export$22da568447791223)();
    const [peopleAndTeamsResults] = (0, $4cde92b339c1c935$export$c30c238644aa02ee)();
    const onClick = ()=>{
        setShowDropdown(false);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: peopleAndTeamsResults.results.slice(0, resultCount.peopleAndTeams).map((result, index)=>{
            if (result.entityType === (0, $c5JjN.EntityType).USER && result.name) {
                const navigationUrl = primaryProduct && cloudId && orgId && (0, $fc7dbd439c8c8ef0$export$451f7a1e7c934f54)(result.id, primaryProduct, orgId, cloudId);
                return /*#__PURE__*/ (0, $l998X.jsx)($58900b9ea7bb9fa3$var$PeopleAndTeamsLink, {
                    title: result.name,
                    description: result.title,
                    avatarUrl: result.avatarUrl,
                    onClick: onClick,
                    inputQuery: inputQuery,
                    navigationUrl: navigationUrl || ''
                }, `${index}-${result.name}`);
            } else if (result.entityType === (0, $c5JjN.EntityType).TEAM && result.displayName) {
                const navigationUrl = primaryProduct && cloudId && orgId && (0, $fc7dbd439c8c8ef0$export$9456a8e088bfede1)(result.id, primaryProduct, orgId, cloudId);
                return /*#__PURE__*/ (0, $l998X.jsx)($58900b9ea7bb9fa3$var$PeopleAndTeamsLink, {
                    title: result.displayName,
                    description: intl.formatMessage((0, $94b2d36fb89b4dc3$export$defe85febe8b728c).teamLabel),
                    avatarUrl: result?.smallAvatarImageUrl,
                    onClick: onClick,
                    inputQuery: inputQuery,
                    navigationUrl: navigationUrl || ''
                }, `${index}-${result.name}`);
            }
        })
    });
};
const $58900b9ea7bb9fa3$var$iconStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.full',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $58900b9ea7bb9fa3$var$PeopleAndTeamsLink = ({ title: title, description: description = '', avatarUrl: avatarUrl = '', inputQuery: inputQuery, onClick: onClick, navigationUrl: navigationUrl })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $55d2bcfca9bb5d3e$export$bbedf2c4ad87789c), {
        title: title,
        description: description,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $58900b9ea7bb9fa3$var$iconStyles,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                src: avatarUrl,
                size: "small"
            })
        }),
        onClick: onClick,
        highlightedTitle: (0, $35ad33aa93b58ce9$export$9f4c92a576b56d82)(title, inputQuery.split(' ')).highlightedTitle,
        navigationUrl: navigationUrl
    });





parcelRequire("42omo");









const $20af6c32d32cf493$var$iconStyles = (0, $ecnYn.xcss)({
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $20af6c32d32cf493$export$8def3ebb7c3d38c = ()=>{
    const [resultCount] = (0, $4cde92b339c1c935$export$22da568447791223)();
    const [, { setShowDropdown: setShowDropdown }] = (0, $4cde92b339c1c935$export$8c32fdb3462273b4)();
    const onClick = ()=>{
        setShowDropdown(false);
    };
    const [quickSearchResults] = (0, $4cde92b339c1c935$export$369bf1e7413c2c02)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: quickSearchResults.slice(0, resultCount.quickSearch).map((result, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $55d2bcfca9bb5d3e$export$bbedf2c4ad87789c), {
                title: result.title,
                description: result.description,
                subheading: result.subheading,
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $20af6c32d32cf493$var$iconStyles,
                    children: result.icon
                }),
                onClick: onClick,
                highlightedTitle: result.highlightedTitle,
                navigationUrl: result.navigationUrl
            }, `${index}-${result.title}`))
    });
};












var $1qfLF = parcelRequire("1qfLF");


var $kevJM = parcelRequire("kevJM");


var $hmuev = parcelRequire("hmuev");















const $6986ee85ccc0aae8$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    recentSearchIconLabel: {
        id: "dynamic-cards-search-page.dropdown_recent_icon_label",
        defaultMessage: "Recent"
    },
    removeRecentSearchIcon: {
        id: "dynamic-cards-search-page.search-result.remove-recent-search",
        defaultMessage: "Remove recent search icon"
    },
    removeRecentSearchSubheading: {
        id: "dynamic-cards-search-page.search-result.remove-recent-search-result-subheading",
        defaultMessage: "Recent search"
    }
});


const $eef0a61e51e85a2f$var$iconStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.xsmall',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $eef0a61e51e85a2f$export$e4bc6828df5bf4e8 = ()=>{
    const { setSearchQuery: setSearchQuery } = (0, $7tL1u.useSearchActions)();
    const [resultCount] = (0, $4cde92b339c1c935$export$22da568447791223)();
    const [, { setShowDropdown: setShowDropdown }] = (0, $4cde92b339c1c935$export$8c32fdb3462273b4)();
    const onClick = (query)=>{
        setShowDropdown(false);
        setSearchQuery(query);
    };
    const [recentSearches] = (0, $4cde92b339c1c935$export$970bfa0ee111b06)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: recentSearches.slice(0, resultCount.recentSearch).map((result, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $55d2bcfca9bb5d3e$export$bbedf2c4ad87789c), {
                title: result.title,
                icon: /*#__PURE__*/ (0, $l998X.jsx)($eef0a61e51e85a2f$export$aa64f88f83123fb7, {}),
                onClick: ()=>onClick(result.title),
                rightPanel: /*#__PURE__*/ (0, $l998X.jsx)($eef0a61e51e85a2f$export$ea04c1e9e2b7cc14, {
                    title: result.title
                })
            }, `${index}-${result.title}`))
    });
};
const $eef0a61e51e85a2f$export$aa64f88f83123fb7 = ()=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $eef0a61e51e85a2f$var$iconStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
            color: "currentColor",
            label: intl.formatMessage((0, $6986ee85ccc0aae8$export$defe85febe8b728c).recentSearchIconLabel),
            spacing: "spacious"
        })
    });
};
const $eef0a61e51e85a2f$var$recentSearchRightPanelStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $eef0a61e51e85a2f$var$subheadingStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.150'
});
const $eef0a61e51e85a2f$export$ea04c1e9e2b7cc14 = ({ title: title })=>{
    const intl = (0, $8C5kA.default)();
    const [{ user: user, primaryProduct: primaryProduct }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const { setRecentSearchResults: setRecentSearchResults } = (0, $4cde92b339c1c935$export$4e8b5ffe8cfc8886)();
    const onClick = (0, $42omo.useCallback)((event)=>{
        event.stopPropagation();
        if (user?.id && primaryProduct) {
            const newRecentSearches = (0, $604c75c78a943a42$export$6adb2cc1366d1e30)(title, user.id, primaryProduct, (0, $604c75c78a943a42$export$ec4722d39a5031c0)).map((searchTitle)=>({
                    // Todo: cleanup this so that we only need to pass the search title.
                    title: searchTitle,
                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
                    onClick: ()=>null
                }));
            setRecentSearchResults(newRecentSearches);
        }
    }, [
        primaryProduct,
        title,
        setRecentSearchResults,
        user?.id
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $eef0a61e51e85a2f$var$recentSearchRightPanelStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                as: "span",
                xcss: $eef0a61e51e85a2f$var$subheadingStyles,
                children: intl.formatMessage((0, $6986ee85ccc0aae8$export$defe85febe8b728c).removeRecentSearchSubheading)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                        ...iconProps,
                        label: intl.formatMessage((0, $6986ee85ccc0aae8$export$defe85febe8b728c).removeRecentSearchIcon),
                        color: "currentColor"
                    }),
                spacing: 'compact',
                onClick: onClick,
                label: intl.formatMessage((0, $6986ee85ccc0aae8$export$defe85febe8b728c).removeRecentSearchIcon),
                appearance: 'subtle'
            })
        ]
    });
};





parcelRequire("42omo");








const $56f1dd8caf238ac0$var$iconStyles = (0, $ecnYn.xcss)({
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $56f1dd8caf238ac0$export$c68af787f8f88afe = ()=>{
    const [recentViewsResults] = (0, $4cde92b339c1c935$export$f53e0f96bec5ea4d)();
    const { setShowDropdown: setShowDropdown } = (0, $4cde92b339c1c935$export$4e8b5ffe8cfc8886)();
    const [resultCount] = (0, $4cde92b339c1c935$export$22da568447791223)();
    const onClick = ()=>{
        setShowDropdown(false);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: recentViewsResults?.slice(0, resultCount.recentViews).map((result, index)=>{
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $55d2bcfca9bb5d3e$export$bbedf2c4ad87789c), {
                title: result.title,
                description: result.description,
                subheading: result.subheading,
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $56f1dd8caf238ac0$var$iconStyles,
                    children: result.icon
                }),
                onClick: onClick,
                highlightedTitle: result.highlightedTitle,
                navigationUrl: result.navigationUrl
            }, `${index}-${result.title}`);
        })
    });
};


const $54a2cf5a05138b0b$var$searchDropdownStyles = (0, $ecnYn.xcss)({
    padding: 'space.100',
    gap: 'space.025',
    boxShadow: 'elevation.shadow.overlay',
    borderWidth: '0',
    boxSizing: 'border-box'
});
const $54a2cf5a05138b0b$export$e33d60b8f4099ae = ({ inputWidth: inputWidth })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    (0, $1cf2ef794a5aaf98$export$4e2bef15a5b74b17)();
    const [dropdownLoading] = (0, $4cde92b339c1c935$export$41ba39ed718e7414)();
    const [features] = (0, $ee6ce766a2e08634$export$4a39035bacc4ed76)();
    const [components] = (0, $ee6ce766a2e08634$export$7c355de7fd01eb66)();
    const [query] = (0, $7tL1u.useInputQuery)();
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $cdf2753c4aea5699$export$fdc397e486fa83e7)();
    const [resultCount] = (0, $4cde92b339c1c935$export$22da568447791223)();
    const totalResultCount = Object.values(resultCount).reduce((sum, count)=>sum + count, 0);
    const containerRef = (0, $42omo.useRef)(null);
    let footerComponent = null;
    if (components?.footer !== undefined) {
        if (typeof components.footer === 'function') footerComponent = components.footer(generateSearchUrl({
            ...queryParams,
            text: query
        }));
        else if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).isValidElement(components.footer)) footerComponent = components.footer;
    }
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $54a2cf5a05138b0b$var$searchDropdownStyles,
        style: {
            width: `${inputWidth}px`
        },
        "aria-label": formatMessage((0, $e53201f82c7b6560$export$defe85febe8b728c).searchSuggestionsDropdownLabel),
        testId: 'search-suggestions-dropdown',
        ref: containerRef,
        children: [
            dropdownLoading && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    Boolean(features?.inlineSearch?.enabled) && /*#__PURE__*/ (0, $l998X.jsx)((0, $738d5a88b733c23d$export$4a7d659f3bdb9018), {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $7b696dc4c8d7dcd8$export$772547de01833b56), {})
                ]
            }),
            !dropdownLoading && totalResultCount === 0 && /*#__PURE__*/ (0, $l998X.jsx)((0, $1ae31853cd696031$export$73c06a78041d5456), {}),
            !dropdownLoading && totalResultCount > 0 && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    Boolean(features?.inlineSearch?.enabled) && /*#__PURE__*/ (0, $l998X.jsx)((0, $738d5a88b733c23d$export$4a7d659f3bdb9018), {}),
                    Boolean(features?.autoSuggestion?.enabled) && /*#__PURE__*/ (0, $l998X.jsx)((0, $e53faad5677c2709$export$14bd3dc13236b3f1), {}),
                    Boolean(features?.recentSearches?.enabled) && /*#__PURE__*/ (0, $l998X.jsx)((0, $eef0a61e51e85a2f$export$e4bc6828df5bf4e8), {}),
                    Boolean(features?.peopleAndTeamsSearch?.enabled) && /*#__PURE__*/ (0, $l998X.jsx)((0, $58900b9ea7bb9fa3$export$9d052a57a86e166), {}),
                    Boolean(features?.recentViews?.enabled) && /*#__PURE__*/ (0, $l998X.jsx)((0, $56f1dd8caf238ac0$export$c68af787f8f88afe), {}),
                    Boolean(features?.quickSearch?.enabled) && /*#__PURE__*/ (0, $l998X.jsx)((0, $20af6c32d32cf493$export$8def3ebb7c3d38c), {}),
                    footerComponent
                ]
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 








var $7sObp = parcelRequire("7sObp");



















var $9hlns = parcelRequire("9hlns");


var $4noo5 = parcelRequire("4noo5");










const $9f013575cbe905d6$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    searchIconLabel: {
        id: "dynamic-cards-search-page.input_search_icon_label",
        defaultMessage: "Search"
    },
    clearIconLabel: {
        id: "dynamic-cards-search-page.input_clear_icon_label",
        defaultMessage: "Clear"
    },
    inputPlaceholder: {
        id: "dynamic-cards-search-page.input_placeholder",
        defaultMessage: "Search or ask anything"
    },
    inputPlaceholderSearchOnly: {
        id: "dynamic-cards-search-page.input_placeholder_search_only",
        defaultMessage: "Search anything"
    }
});


const $e45796af6fa63158$var$textFieldBoxStyles = (0, $ecnYn.xcss)({
    height: 'space.500',
    flexGrow: 1
});
const $e45796af6fa63158$var$cssOverrideWrapperStyles = null;
const $e45796af6fa63158$var$searchIconWrapperStyles = (0, $ecnYn.xcss)({
    minWidth: 'size.200',
    minHeight: 'size.200',
    marginLeft: 'space.100',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $e45796af6fa63158$var$clearIconStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.100'
});
const $e45796af6fa63158$export$1d3bcc092e622e3d = 'ch-search-text-query-input';
const $e45796af6fa63158$export$fb8d8fbc0c4c1705 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { onSubmit: onSubmit } = props;
    let hasReceivedFocus = props.hasReceivedFocus ? props.hasReceivedFocus : ()=>{};
    const [isLoading] = (0, $7tL1u.useIsLoading)();
    const intl = (0, $8C5kA.default)();
    const [query, { setInputQuery: setInputQuery, triggerSearch: triggerSearch }] = (0, $7tL1u.useSearchQuery)();
    const [localQuery, setLocalQuery] = (0, $42omo.useState)(query);
    const [{ primaryProduct: primaryProduct, user: user }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const [userWithStatus] = (0, $ee6ce766a2e08634$export$23bbbc4533528f03)();
    const [showDropdown, { setShowDropdown: setShowDropdown }] = (0, $4cde92b339c1c935$export$8c32fdb3462273b4)();
    const [features] = (0, $ee6ce766a2e08634$export$4a39035bacc4ed76)();
    const isUserAuthenticated = userWithStatus.status === (0, $5f67793cebea6085$export$a82073022ded66e8).Authenticated; // Sync local query with input query
    (0, $42omo.useEffect)(()=>{
        setInputQuery(localQuery);
    }, [
        setInputQuery,
        localQuery
    ]); // Sync search query with local query
    // on search query change, determine intent / get smart answer route
    (0, $42omo.useEffect)(()=>{
        setLocalQuery(query);
    }, [
        query,
        setLocalQuery
    ]);
    const [inputQuery] = (0, $7tL1u.useInputQuery)();
    const { generateSearchUrl: generateSearchUrl, onNavigate: onNavigate, queryParams: queryParams } = (0, $cdf2753c4aea5699$export$fdc397e486fa83e7)();
    const handleOnSubmit = ()=>{
        // Store search in recent searches
        if (localQuery.trim() !== '' && user && user.id && primaryProduct) (0, $604c75c78a943a42$export$74e99d9695eabee6)(localQuery, user.id, primaryProduct, (0, $604c75c78a943a42$export$ec4722d39a5031c0));
         // Handles the delegated UI events like closing the dropdown
        if (onSubmit) onSubmit();
        if (features?.chromeExtension?.enabled) {
            features.chromeExtension.onInputSubmit({
                query: localQuery
            });
            return;
        } // If quick search is enabled, we don't want to trigger whole page search
        if (features?.quickSearch?.enabled) {
            onNavigate(generateSearchUrl({
                ...queryParams,
                text: inputQuery
            }), 'push');
            return;
        }
        triggerSearch();
    };
    const onChange = (e)=>{
        setLocalQuery(e.currentTarget.value);
        hasReceivedFocus();
        if (e.currentTarget.value === '' && !isUserAuthenticated) setShowDropdown(false);
        else if (e.currentTarget.value !== '') setShowDropdown(true);
    };
    const onClick = ()=>{
        hasReceivedFocus();
        if (localQuery === '' && !isUserAuthenticated) setShowDropdown(false);
    };
    const onKeyPress = (event)=>{
        if (event.key === 'Enter') {
            handleOnSubmit();
            event.currentTarget.blur();
        }
    };
    const onKeyDown = (event)=>{
        if (event.key === 'ArrowDown') hasReceivedFocus();
        if (showDropdown && event.key === 'Tab') {
            if (onSubmit) onSubmit();
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $e45796af6fa63158$var$textFieldBoxStyles,
        ref: ref,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                "_zbay1qi0 _1r6fe4h9 _k8em1ylp",
                props.styleOverrides?.borderRadius && "_dhd01flu",
                props.styleOverrides?.textColor && "_sgrm1fvx _1fb91fvx",
                props.styleOverrides?.backgroundColor && "_6ppkc4l7 _s8d2c4l7 _l04lc4l7"
            ]),
            style: {
                "--_ek0kxz": (0, $7sObp.default)(props.styleOverrides?.borderRadius),
                "--_1tv6lz7": (0, $7sObp.default)(props.styleOverrides?.textColor),
                "--_1pi6qsr": (0, $7sObp.default)(props.styleOverrides?.backgroundColor)
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                ref: props.keyboardRef,
                id: $e45796af6fa63158$export$1d3bcc092e622e3d,
                testId: $e45796af6fa63158$export$1d3bcc092e622e3d,
                value: localQuery,
                onKeyPress: (event)=>onKeyPress(event),
                onKeyDown: (event)=>onKeyDown(event),
                onChange: onChange,
                onClick: onClick,
                autoComplete: "off",
                isReadOnly: props.isReadOnly,
                placeholder: props.styleOverrides?.placeholder ?? intl.formatMessage((0, $9f013575cbe905d6$export$defe85febe8b728c).inputPlaceholderSearchOnly),
                elemBeforeInput: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $e45796af6fa63158$var$searchIconWrapperStyles,
                    children: isLoading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                        testId: "search-page-input-spinner",
                        size: "small",
                        appearance: "inherit"
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jluld))), {
                        color: props.styleOverrides?.textColor ? props.styleOverrides?.textColor : 'currentColor',
                        spacing: "spacious",
                        label: intl.formatMessage((0, $9f013575cbe905d6$export$defe85febe8b728c).searchIconLabel)
                    })
                }),
                elemAfterInput: localQuery && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $e45796af6fa63158$var$clearIconStyles,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                ...iconProps,
                                color: props.styleOverrides?.textColor ? props.styleOverrides?.textColor : 'currentColor',
                                label: intl.formatMessage((0, $9f013575cbe905d6$export$defe85febe8b728c).clearIconLabel)
                            }),
                        spacing: 'compact',
                        onClick: ()=>setLocalQuery(''),
                        label: intl.formatMessage((0, $9f013575cbe905d6$export$defe85febe8b728c).clearIconLabel),
                        appearance: 'subtle'
                    })
                })
            })
        })
    });
});


const $9d8cb4bdc48da54f$var$textFieldBoxStyles = (0, $ecnYn.xcss)({
    height: 'space.500',
    flexGrow: 1
});
const $9d8cb4bdc48da54f$export$f5b8910cec6cf069 = ()=>{
    const [showDropdown, { setShowDropdown: setShowDropdown }] = (0, $4cde92b339c1c935$export$8c32fdb3462273b4)();
    const inputBoxRef = (0, $42omo.useRef)(null);
    const inputRef = (0, $42omo.useRef)(null);
    const [styleOverrides] = (0, $ee6ce766a2e08634$export$4f9dad8ddb27a630)();
    (0, $8dea6d9445fd0527$export$11133d09694420f7)();
    const [_, setInputWidth] = (0, $42omo.useState)(inputBoxRef.current?.offsetWidth);
    (0, $42omo.useEffect)(()=>{
        const listener = ()=>setInputWidth(inputBoxRef.current?.offsetWidth);
        const unbind = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: listener
        });
        return unbind;
    }, []);
    const closeDropdown = (0, $42omo.useCallback)(()=>{
        if (showDropdown) setShowDropdown(false);
    }, [
        showDropdown,
        setShowDropdown
    ]);
    const trigger = (0, $42omo.useCallback)((triggerProps)=>{
        // When the SearchTextField receives a submit/enter
        const hasSubmitted = ()=>{
            closeDropdown();
        };
        // When the SearchTextField receives focus - simple API for multiple events that cause this
        const inputHasReceivedFocus = ()=>{
            if (!showDropdown) setShowDropdown(true);
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $9d8cb4bdc48da54f$var$textFieldBoxStyles,
            ref: inputBoxRef,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e45796af6fa63158$export$fb8d8fbc0c4c1705), {
                keyboardRef: inputRef,
                ...triggerProps,
                ref: triggerProps.ref,
                onSubmit: hasSubmitted,
                hasReceivedFocus: inputHasReceivedFocus,
                styleOverrides: styleOverrides?.textfield
            })
        });
    }, [
        closeDropdown,
        showDropdown,
        setShowDropdown,
        styleOverrides?.textfield
    ]);
    const content = /*#__PURE__*/ (0, $l998X.jsx)((0, $54a2cf5a05138b0b$export$e33d60b8f4099ae), {
        inputWidth: inputBoxRef.current?.offsetWidth || 0
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.Popup), {
        shouldReturnFocus: false,
        content: ()=>content,
        isOpen: showDropdown,
        autoFocus: false,
        placement: "bottom-start",
        trigger: trigger,
        onClose: closeDropdown
    });
};
const $9d8cb4bdc48da54f$var$InputWithErrorBoundary = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $63afac6f9f5eb800$export$e926676385687eaf), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $e45796af6fa63158$export$fb8d8fbc0c4c1705), {}),
        children: /*#__PURE__*/ (0, $l998X.jsx)($9d8cb4bdc48da54f$export$f5b8910cec6cf069, {})
    });
};
var $9d8cb4bdc48da54f$export$2e2bcd8739ae039 = $9d8cb4bdc48da54f$var$InputWithErrorBoundary;


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gdv5Z = parcelRequire("gdv5Z");


/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ 

















parcelRequire("42omo");






const $63abe281e38e0336$var$contentContainerStyles = (0, $ecnYn.xcss)({
    margin: 'auto',
    maxWidth: '70rem',
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    boxSizing: 'content-box'
});
const $63abe281e38e0336$export$9d2b4227a95687cc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $63abe281e38e0336$var$contentContainerStyles,
        children: children
    });
};



const $3ef71e4b6fca71ea$var$RightPanelContainerStyles = (0, $ecnYn.xcss)({
    width: '100%',
    display: 'inline'
});
const $3ef71e4b6fca71ea$var$bodyStackStyles = (0, $ecnYn.xcss)({
    // By default, elements with display: flex will have a width of auto, which
    // means they will not shrink below the width of their content. By setting
    // this to 0, it ensures that this stack will not grow beyond its width.
    minWidth: '0'
});
const $3ef71e4b6fca71ea$var$gridStyles = (0, $ecnYn.xcss)({
    grid: '1fr / 100fr',
    gridTemplateColumns: 'auto'
});
const $3ef71e4b6fca71ea$var$gridStylesSmall = (0, $ecnYn.xcss)({
    grid: '1fr / 70fr 30fr',
    gridTemplateColumns: 'auto'
});
const $3ef71e4b6fca71ea$var$gridStylesMedium = (0, $ecnYn.xcss)({
    grid: '1fr / 100fr 320px',
    gridTemplateColumns: 'auto'
});
// Prevent the smart answers dialog from z-indexing above the dialog, filters etc
const $3ef71e4b6fca71ea$var$smartAnswersWrapperStyles = {
    zIndex: 0
};
const $3ef71e4b6fca71ea$export$36cf6d64005c1ddf = ({ components: components })=>{
    const { smartAnswers: smartAnswers, results: resultsComponent, autoCorrection: autoCorrection } = components;
    (0, $42omo.useEffect)(()=>{
        // The scroll is on the window level so we have to scroll window to 0,0 to reset the scroller
        window.scrollTo(0, 0);
    }, [
        smartAnswers,
        resultsComponent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: $3ef71e4b6fca71ea$var$smartAnswersWrapperStyles,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
            space: "space.200",
            xcss: $3ef71e4b6fca71ea$var$bodyStackStyles,
            children: [
                autoCorrection,
                smartAnswers,
                resultsComponent
            ]
        })
    });
};
const $3ef71e4b6fca71ea$export$4b2c32e08f77ff18 = ({ components: components })=>{
    const { rightPanel: rightPanel } = components;
    const width = (0, $bdcfd319a02b1672$export$1217913212f99c7)('layout');
    // Primary use case for this is side-by-side which does not set a rightPanel
    if (!rightPanel) return /*#__PURE__*/ (0, $l998X.jsx)((0, $63abe281e38e0336$export$9d2b4227a95687cc), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cwkWT.default), {
            gap: "space.400",
            templateColumns: '100fr',
            children: /*#__PURE__*/ (0, $l998X.jsx)($3ef71e4b6fca71ea$export$36cf6d64005c1ddf, {
                components: components
            })
        })
    });
    else if (width > 0) {
        const isAboveMedium = (0, $bdcfd319a02b1672$export$c44b7f69e7aa026)({
            width: width,
            above: 'md'
        });
        const isAboveSmall = (0, $bdcfd319a02b1672$export$c44b7f69e7aa026)({
            width: width,
            above: 'sm'
        });
        let className = $3ef71e4b6fca71ea$var$gridStyles;
        if (isAboveMedium) className = $3ef71e4b6fca71ea$var$gridStylesMedium;
        else if (isAboveSmall) className = $3ef71e4b6fca71ea$var$gridStylesSmall;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $63abe281e38e0336$export$9d2b4227a95687cc), {
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
                gap: "space.400",
                xcss: className,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($3ef71e4b6fca71ea$export$36cf6d64005c1ddf, {
                        components: components
                    }),
                    isAboveSmall && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $3ef71e4b6fca71ea$var$RightPanelContainerStyles,
                        children: rightPanel
                    })
                ]
            })
        });
    }
    return null;
};


/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ 














const $8ce34a288baa2edb$var$baseHeaderStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    width: '100%'
});
const $8ce34a288baa2edb$var$headerGridStyles = (0, $ecnYn.xcss)({
    paddingBottom: 'space.200',
    marginBottom: 'space.250',
    borderBottom: `solid ${"var(--ds-border-width, 1px)"} ${"var(--ds-border, #0B120E24)"}`
});
const $8ce34a288baa2edb$var$filtersGridAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'filters'
});
const $8ce34a288baa2edb$var$Header = ({ components: components, disableHeaderGridStyles: disableHeaderGridStyles })=>{
    const { filters: filters } = components;
    const [stickyHeaderStyles, setStickyHeaderStyles] = (0, $42omo.useState)();
    const referenceRef = (0, $42omo.useRef)(null);
    const headerRef = (0, $42omo.useRef)(null);
    // Use the reference element's position to set the sticky styles on the
    // header. This allows `top` to always be correct.
    (0, $42omo.useEffect)(()=>{
        if (!referenceRef.current) return;
        // QS-5148
        // referenceY is a measure of how far the top of search-page is from the top of the scrolling context. This works in old nav, because the scroll matches the viewport
        // In Nav 4, the scroll is the content region and the nav is outside of it
        // This is a temporary fix to unblock Nav4 dogfooding
        let referenceY = referenceRef.current.getBoundingClientRect().top;
        referenceY = 0;
        const scrollY = window.scrollY;
        const top = referenceY + scrollY;
        setStickyHeaderStyles((0, $ecnYn.xcss)({
            position: 'sticky',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundClip: 'padding-box'
        }));
    }, [
        setStickyHeaderStyles
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                ref: referenceRef,
                testId: "search-page-header-reference"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $8ce34a288baa2edb$var$baseHeaderStyles,
                    stickyHeaderStyles
                ],
                testId: "search-page-header",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    zIndex: 1
                },
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $63abe281e38e0336$export$9d2b4227a95687cc), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cwkWT.default), {
                        ref: headerRef,
                        xcss: disableHeaderGridStyles ? undefined : $8ce34a288baa2edb$var$headerGridStyles,
                        columnGap: "space.250",
                        rowGap: "space.200",
                        templateAreas: [
                            'input feedback',
                            'filters filters'
                        ],
                        templateColumns: "65fr 35fr",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                            xcss: $8ce34a288baa2edb$var$filtersGridAreaStyles,
                            children: filters
                        })
                    })
                })
            })
        ]
    });
};
const $8ce34a288baa2edb$var$HeaderWithErrorBoundary = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $63afac6f9f5eb800$export$e926676385687eaf), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: props.disableHeaderGridStyles ? undefined : $8ce34a288baa2edb$var$headerGridStyles,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $63abe281e38e0336$export$9d2b4227a95687cc), {
                children: props.components.input
            })
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)($8ce34a288baa2edb$var$Header, {
            ...props
        })
    });
};
var $8ce34a288baa2edb$export$2e2bcd8739ae039 = $8ce34a288baa2edb$var$HeaderWithErrorBoundary;





parcelRequire("42omo");







const $b69c2bb57cd2ef67$var$baseHeaderStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface',
    width: '100%'
});
const $b69c2bb57cd2ef67$var$headerGridStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.400',
    paddingBottom: 'space.200'
});
const $b69c2bb57cd2ef67$var$HeaderSideBySide = ({ components: components })=>{
    const { filters: filters } = components;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: [
                $b69c2bb57cd2ef67$var$baseHeaderStyles
            ],
            testId: "search-page-header",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                zIndex: 10
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $63abe281e38e0336$export$9d2b4227a95687cc), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $b69c2bb57cd2ef67$var$headerGridStyles,
                    children: filters
                })
            })
        })
    });
};
var $b69c2bb57cd2ef67$export$2e2bcd8739ae039 = $b69c2bb57cd2ef67$var$HeaderSideBySide;


const $281ad989c301d00c$export$c84671f46d6a1ca = ({ components: { filters: filters, results: results = /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}), input: input = /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}), feedback: feedback = /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}), smartAnswers: smartAnswers = /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}), oauthContainer: oauthContainer = /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}), rightPanel: rightPanel = /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}), autoCorrection: autoCorrection = /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {}) }, disableHeaderGridStyles: disableHeaderGridStyles })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $bdcfd319a02b1672$export$f8586f54f6b8f867), {
        id: "layout",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
            testId: "search-page-layout",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $8ce34a288baa2edb$export$2e2bcd8739ae039), {
                    components: {
                        input: input,
                        feedback: feedback,
                        filters: filters
                    },
                    disableHeaderGridStyles: disableHeaderGridStyles
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3ef71e4b6fca71ea$export$4b2c32e08f77ff18), {
                    components: {
                        results: results,
                        smartAnswers: smartAnswers,
                        rightPanel: rightPanel,
                        oauthContainer: oauthContainer,
                        autoCorrection: autoCorrection
                    }
                })
            ]
        })
    });
const $281ad989c301d00c$export$8ac1fb3f3f89d5bf = ({ components: { filters: filters, results: results, smartAnswers: smartAnswers, oauthContainer: oauthContainer, autoCorrection: autoCorrection } })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        testId: "search-page-layout",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $b69c2bb57cd2ef67$export$2e2bcd8739ae039), {
                components: {
                    filters: filters
                }
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3ef71e4b6fca71ea$export$4b2c32e08f77ff18), {
                components: {
                    results: results,
                    smartAnswers: smartAnswers,
                    oauthContainer: oauthContainer,
                    autoCorrection: autoCorrection
                }
            })
        ]
    });

















var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");

const $c00ebe4ee56aadce$var$COMPONENT = 'search-page';
const $c00ebe4ee56aadce$export$a98443e214d7b1fd = new (0, $5aVN7.UFOExperience)('load', {
    type: (0, $9NDUe.ExperienceTypes).Load,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
    platform: {
        component: $c00ebe4ee56aadce$var$COMPONENT
    }
});
const $c00ebe4ee56aadce$export$e882a2ec68d19be8 = new (0, $5aVN7.UFOExperience)('search-results-load', {
    type: (0, $9NDUe.ExperienceTypes).Experience,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: $c00ebe4ee56aadce$var$COMPONENT
    },
    timings: [
        {
            key: 'request',
            startMark: 'request_start',
            endMark: 'request_end'
        },
        {
            key: 'render',
            startMark: 'render_start',
            endMark: 'render_end'
        }
    ]
});





const $7e38068845a191b0$export$44fea6589b7ddc92 = (type)=>{
    switch(type){
        case 'jira':
            return 'Jira';
        case 'confluence':
            return 'Confluence';
        case 'townsquare':
            return 'Atlas';
        case 'drive':
            return 'Google Drive';
        case 'microsoft':
        case 'sharepoint':
            return 'Microsoft SharePoint';
        case 'github':
            return 'GitHub';
        case 'compass':
            return 'Compass';
        case 'trello':
            return 'Trello';
    }
    return '';
};
const $7e38068845a191b0$export$b0f4af9a0173cbfd = (product)=>{
    return (0, $4sOnC.products)[product].is3P;
};




var $7sS82 = parcelRequire("7sS82");

const $6710de068e8e9e3c$export$f0fed4b0765d7314 = ()=>{
    try {
        return (0, $7sS82.useIntercom)();
    } catch (err) {
        return;
    }
};



var $ibSzG = parcelRequire("ibSzG");

var $glYzA = parcelRequire("glYzA");




class $2803a5b285916c4e$export$94cd2e6f39615373 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResultsFetchError';
    }
}
class $2803a5b285916c4e$export$8ba86dff7c04c14c extends $2803a5b285916c4e$export$94cd2e6f39615373 {
    constructor(){
        super('No entities provided to fetch results');
        this.name = 'EmptyEntitiesError';
    }
}
const $2803a5b285916c4e$export$46f82b8a3ce2a183 = async ({ query: query, originalQuery: originalQuery, entities: entities, selectedFilters: selectedFilters, cloudId: cloudId, aggAbsoluteUrl: aggAbsoluteUrl, searchSessionId: searchSessionId, sort: sort, sourceProduct: sourceProduct, experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers, after: after, limit: limit })=>{
    const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, thirdPartyFilters: thirdPartyFilters } = selectedFilters || (0, $33vwh.getEmptySelectedFilters)();
    const sortVariables = [
        sort
    ];
    // If the original query param is present, we want to disable query replacement
    const disableQueryReplacement = !!originalQuery;
    const variables = {
        query: query,
        queryVersion: 1,
        cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
        tenantId: cloudId,
        limit: limit,
        commonFilters: commonFilters,
        confluenceFilters: confluenceFilters,
        jiraFilters: jiraFilters,
        thirdPartyFilters: thirdPartyFilters,
        entities: entities,
        searchSessionId: searchSessionId,
        sort: sortVariables,
        sourceProduct: sourceProduct,
        experimentId: experimentId,
        shadowExperimentId: shadowExperimentId,
        experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId })=>({
                name: name,
                layerId: layerId,
                shadowId: shadowId
            })),
        // eslint-disable-next-line no-constant-condition
        after: undefined,
        disableQueryReplacement: disableQueryReplacement
    };
    if (entities.length === 0) throw new $2803a5b285916c4e$export$8ba86dff7c04c14c();
    const response = (0, $glYzA.searchPageQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        originalQuery: originalQuery
    });
    // If the original query param is not present, we want to cache the response with the replacement query
    // fg('rovo-search-spelling-correction') => false
    // eslint-disable-next-line no-constant-condition
    originalQuery;
    return response;
};
const $2803a5b285916c4e$export$6405a4ba66d50345 = async ({ issueKeys: issueKeys, cloudId: cloudId, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    const variables = {
        issueKeys: issueKeys,
        cloudId: cloudId
    };
    const response = (0, $ibSzG.fetchJiraFieldsQuery)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl
    });
    return response;
};








parcelRequire("42omo");





var $eEA8O = parcelRequire("eEA8O");


var $b54b959ea5115ff8$exports = {};
$b54b959ea5115ff8$exports = new URL("error-dark.43e0a164.svg", import.meta.url).toString();


var $23c12efe6ce8cead$exports = {};
$23c12efe6ce8cead$exports = new URL("error-light.02ef2e6f.svg", import.meta.url).toString();


const $ae5e5e0d6e377a71$export$add61e2630a21f9 = 'cachedImageErrorLight';
const $ae5e5e0d6e377a71$export$4be43fd067fd9d7f = 'cachedImageErrorDark';
const $ae5e5e0d6e377a71$export$7f23364af4709df5 = async (url, key)=>{
    const response = await fetch(url);
    const blob = await response.blob();
    const reader = new FileReader();
    const base64data = await new Promise((resolve, reject)=>{
        reader.onloadend = ()=>{
            resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
    localStorage.setItem(key, base64data);
};
const $ae5e5e0d6e377a71$export$5e3e5ca9e3ba891b = async (isOnline, imageLight, lightImageKey, imageDark, darkImageKey)=>{
    if (isOnline) {
        await $ae5e5e0d6e377a71$export$7f23364af4709df5(imageLight, lightImageKey);
        await $ae5e5e0d6e377a71$export$7f23364af4709df5(imageDark, darkImageKey);
    }
};
const $ae5e5e0d6e377a71$export$ce969d199fe2c04e = (key)=>{
    return localStorage.getItem(key);
};





const $b41cef4e9a1ac454$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    errorPrimary: {
        id: "dynamic-cards-search-page.error_primary",
        defaultMessage: "We're having trouble searching"
    },
    errorSecondary: {
        id: "dynamic-cards-search-page.error_secondary",
        defaultMessage: "It might just be a hiccup. The best thing to do is to <btn>try again</btn>."
    }
});


const $6a2328c2cf65461e$export$edf27be85e5f6da0 = ({ fetchResults: fetchResults })=>{
    const ImageErrorLight = (0, $ae5e5e0d6e377a71$export$ce969d199fe2c04e)('cachedImageErrorLight') || (0, (/*@__PURE__*/$parcel$interopDefault($23c12efe6ce8cead$exports)));
    const ImageErrorDark = (0, $ae5e5e0d6e377a71$export$ce969d199fe2c04e)('cachedImageErrorDark') || (0, (/*@__PURE__*/$parcel$interopDefault($b54b959ea5115ff8$exports)));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $27d1d3f58e00c7d2$export$d9172702747fb4bc), {
            imageSrcLight: ImageErrorLight,
            imageSrcDark: ImageErrorDark,
            primaryText: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $b41cef4e9a1ac454$export$defe85febe8b728c).errorPrimary
            }),
            secondaryText: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $b41cef4e9a1ac454$export$defe85febe8b728c).errorSecondary,
                values: {
                    btn: (chunks)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                            appearance: "link",
                            spacing: "none",
                            onClick: fetchResults,
                            children: chunks
                        })
                }
            }),
            testId: "search-page-error"
        })
    });
};








parcelRequire("42omo");





var $4436fdcf6b5910b7$exports = {};
$4436fdcf6b5910b7$exports = new URL("dynamic-cards-landing.82c00804.svg", import.meta.url).toString();





const $22a667f2de92f008$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    landingPrimary: {
        id: "dynamic-cards-search-page.landing_primary",
        defaultMessage: "Get started with filters for dynamic cards"
    },
    landingSecondary: {
        id: "dynamic-cards-search-page.landing_secondary",
        defaultMessage: "Define your rules to automatically build cards"
    }
});


const $6221778abe8049fc$export$12449a31c6671d53 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $27d1d3f58e00c7d2$export$d9172702747fb4bc), {
        imageSrcLight: (0, (/*@__PURE__*/$parcel$interopDefault($4436fdcf6b5910b7$exports))),
        imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($4436fdcf6b5910b7$exports))),
        imageWidth: '400px',
        imageHeight: '300px',
        primaryText: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $22a667f2de92f008$export$defe85febe8b728c).landingPrimary
        }),
        secondaryText: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $22a667f2de92f008$export$defe85febe8b728c).landingSecondary
        }),
        testId: "search-page-landing"
    });
};





parcelRequire("42omo");









parcelRequire("42omo");






/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 















const $16f3a0992355e942$var$SEARCH_PAGE_VISITED_KEY = 'atlassian.search-page.visited';
const $16f3a0992355e942$var$setLocalStorageItem = (key, value)=>{
    window.localStorage.setItem(key, value);
};
const $16f3a0992355e942$var$getLocalStorageItem = (key)=>{
    return window.localStorage.getItem(key);
};
const $16f3a0992355e942$export$5d8cdaf303406828 = (value)=>{
    $16f3a0992355e942$var$setLocalStorageItem($16f3a0992355e942$var$SEARCH_PAGE_VISITED_KEY, JSON.stringify([
        ...$16f3a0992355e942$export$ea4ff4efe040153f(),
        value
    ]));
};
const $16f3a0992355e942$export$ea4ff4efe040153f = ()=>{
    const visitedLinksRaw = $16f3a0992355e942$var$getLocalStorageItem($16f3a0992355e942$var$SEARCH_PAGE_VISITED_KEY);
    return new Set(visitedLinksRaw ? JSON.parse(visitedLinksRaw) : []);
};
const $16f3a0992355e942$export$df30b8dffa0e57a6 = (visitedLinks, id)=>{
    return visitedLinks.has(id);
};


const $77177493924f77d4$var$containerStyles = (0, $ecnYn.xcss)({
    padding: 'space.100',
    borderRadius: 'radius.small'
});
const $77177493924f77d4$var$iconAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'icon',
    width: 'size.200',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right'
});
const $77177493924f77d4$var$headingAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'heading',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    font: 'font.body.large'
});
const $77177493924f77d4$var$subheadingStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle',
    marginTop: 'space.025',
    font: 'font.body',
    overflow: 'clip',
    overflowClipMargin: '5px' // space for focus outlines
});
const $77177493924f77d4$var$subheadingLeftAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'subheading-left',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $77177493924f77d4$var$bodyAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'body',
    marginTop: 'space.075',
    overflowWrap: 'break-word'
});
const $77177493924f77d4$var$footerAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'footer'
});
const $77177493924f77d4$var$visitedLinkStyles = (0, $ecnYn.xcss)({
    textDecoration: 'none',
    ':visited:active': {
        color: 'color.link.visited.pressed'
    },
    ':visited': {
        color: 'color.link.visited'
    }
});
const $77177493924f77d4$var$visitedLinkPatchStyles = (0, $ecnYn.xcss)({
    color: 'color.link.visited',
    ':active': {
        color: 'color.link.visited.pressed'
    }
});
const $77177493924f77d4$export$a2def421b23768aa = ({ id: id, primaryProduct: _primaryProduct, description: description, footer: footer, icon: icon, headerMetadata: headerMetadata = [], title: title, url: url, isThirdParty: isThirdParty = false, showAISummary: _showAISummary = false, cloudId: _cloudId, onResultClicked: onResultClicked, onResultContextMenu: onResultContextMenu })=>{
    const { setIsHovered: setIsHovered, setIsFocused: setIsFocused } = $77177493924f77d4$var$useVisibilityState();
    /**
   * A dynamic search_id query param and queryHash is appended to the document URL for 1P search results.
   * As result we are unable to use the browser's visited links history to determine if a link has been visited.
   * This is workaround until we have a better solution.
   */ const visitedLinks = (0, $16f3a0992355e942$export$ea4ff4efe040153f)();
    const isVisitedLink = id ? (0, $16f3a0992355e942$export$df30b8dffa0e57a6)(visitedLinks, id) : false;
    const { linkComponent: Link } = (0, $cdf2753c4aea5699$export$fdc397e486fa83e7)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        role: "listitem",
        xcss: $77177493924f77d4$var$containerStyles,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onFocusCapture: ()=>setIsFocused(true),
        onBlurCapture: ()=>setIsFocused(false),
        testId: "search-page-result",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
            columnGap: "space.150",
            templateAreas: [
                'icon heading header-right',
                'icon subheading-left header-right',
                '. body body',
                '. footer footer'
            ],
            templateColumns: "auto 1fr auto",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $77177493924f77d4$var$iconAreaStyles,
                    children: icon
                }),
                id && url ? /*#__PURE__*/ (0, $l998X.jsx)(Link, {
                    xcss: [
                        $77177493924f77d4$var$headingAreaStyles,
                        $77177493924f77d4$var$visitedLinkStyles,
                        isVisitedLink && $77177493924f77d4$var$visitedLinkPatchStyles
                    ],
                    rel: isThirdParty ? 'noreferrer' : '',
                    target: isThirdParty ? '_blank' : undefined,
                    href: url,
                    testId: "search-page-result-link",
                    onClick: ()=>{
                        (0, $16f3a0992355e942$export$5d8cdaf303406828)(id);
                        onResultClicked?.();
                    },
                    onContextMenu: onResultContextMenu,
                    children: title
                }) : onResultClicked ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
                    xcss: $77177493924f77d4$var$headingAreaStyles,
                    onClick: onResultClicked,
                    onContextMenu: onResultContextMenu,
                    children: title
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $77177493924f77d4$var$headingAreaStyles,
                    children: title
                }),
                headerMetadata && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: [
                        $77177493924f77d4$var$subheadingLeftAreaStyles,
                        $77177493924f77d4$var$subheadingStyles
                    ],
                    testId: "search-page-result-metadata",
                    children: headerMetadata
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $77177493924f77d4$var$bodyAreaStyles,
                    children: description
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: $77177493924f77d4$var$footerAreaStyles,
                    children: footer
                })
            ]
        })
    });
};
const $77177493924f77d4$var$useVisibilityState = ()=>{
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    const [isContextMenuOpen, setIsContextMenuOpen] = (0, $42omo.useState)(false);
    return {
        isContextMenuVisible: isHovered || isFocused || isContextMenuOpen,
        isContextMenuOpen: isContextMenuOpen,
        setIsHovered: setIsHovered,
        setIsFocused: setIsFocused,
        setIsContextMenuOpen: setIsContextMenuOpen
    };
};


const $367b99054ac5830c$var$commonStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: 'radius.small'
});
const $367b99054ac5830c$var$skeletonTextStyles = (0, $ecnYn.xcss)({
    height: '14px',
    marginTop: 'space.025',
    marginBottom: 'space.025'
});
const $367b99054ac5830c$var$titleStyles = (0, $ecnYn.xcss)({
    width: '280px'
});
const $367b99054ac5830c$var$iconStyles = (0, $ecnYn.xcss)({
    width: 'size.200',
    height: 'size.200'
});
const $367b99054ac5830c$var$containerStyles = (0, $ecnYn.xcss)({
    pointerEvents: 'none'
});
const $367b99054ac5830c$var$descriptionContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column'
});
const $367b99054ac5830c$var$descriptionStyles = (0, $ecnYn.xcss)({
    width: '100%'
});
const $367b99054ac5830c$var$metadataStyles = (0, $ecnYn.xcss)({
    width: '200px'
});
const $367b99054ac5830c$var$subMetaDataStyles = (0, $ecnYn.xcss)({
    width: '50px'
});
const $367b99054ac5830c$export$9ecbe061c4358be9 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: [
            $367b99054ac5830c$var$commonStyles,
            $367b99054ac5830c$var$skeletonTextStyles,
            $367b99054ac5830c$var$subMetaDataStyles
        ]
    });
};
const $367b99054ac5830c$var$metaDataWideStyles = (0, $ecnYn.xcss)({
    width: '100px'
});
const $367b99054ac5830c$export$a72c2188d2b05fba = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: [
            $367b99054ac5830c$var$commonStyles,
            $367b99054ac5830c$var$skeletonTextStyles,
            $367b99054ac5830c$var$metaDataWideStyles
        ]
    });
};
const $367b99054ac5830c$export$dd3282b157ef6f7a = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $367b99054ac5830c$var$containerStyles,
        role: "list",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $77177493924f77d4$export$a2def421b23768aa), {
            description: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                xcss: [
                    $367b99054ac5830c$var$descriptionContainerStyles
                ],
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $367b99054ac5830c$var$commonStyles,
                            $367b99054ac5830c$var$skeletonTextStyles,
                            $367b99054ac5830c$var$descriptionStyles
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: [
                            $367b99054ac5830c$var$commonStyles,
                            $367b99054ac5830c$var$skeletonTextStyles,
                            $367b99054ac5830c$var$descriptionStyles
                        ]
                    })
                ]
            }),
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $367b99054ac5830c$var$commonStyles,
                    $367b99054ac5830c$var$iconStyles
                ]
            }),
            title: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $367b99054ac5830c$var$commonStyles,
                    $367b99054ac5830c$var$skeletonTextStyles,
                    $367b99054ac5830c$var$titleStyles
                ]
            }),
            headerMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $367b99054ac5830c$var$commonStyles,
                    $367b99054ac5830c$var$skeletonTextStyles,
                    $367b99054ac5830c$var$metadataStyles
                ]
            })
        })
    });
};


const $74599b047b553f98$var$resultsListGridAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'results-list',
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.200'
});
const $74599b047b553f98$export$669f6ea7d267feaf = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $74599b047b553f98$var$resultsListGridAreaStyles,
        testId: "search-page-results-list",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $367b99054ac5830c$export$dd3282b157ef6f7a), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $367b99054ac5830c$export$dd3282b157ef6f7a), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $367b99054ac5830c$export$dd3282b157ef6f7a), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $367b99054ac5830c$export$dd3282b157ef6f7a), {})
        ]
    });
};





parcelRequire("42omo");





var $61fe277df354cb54$exports = {};
$61fe277df354cb54$exports = new URL("no-results-dark.a00ae47b.svg", import.meta.url).toString();


var $2e115399cb521e05$exports = {};
$2e115399cb521e05$exports = new URL("no-results-light.5ca83755.svg", import.meta.url).toString();





const $64c0d0cfb686e433$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    noResultsPrimary: {
        id: "dynamic-cards-search-page.no_results_primary",
        defaultMessage: "We couldn't find anything matching your search"
    },
    noResultsSecondaryFilters: {
        id: "dynamic-cards-search-page.no_results_secondary_some_filters_applied",
        defaultMessage: "Looks like you have some filters applied. You could try clearing them."
    }
});


const $c96f75ecd5461a3e$export$ef6006467f04ee41 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $27d1d3f58e00c7d2$export$d9172702747fb4bc), {
        imageSrcLight: (0, (/*@__PURE__*/$parcel$interopDefault($2e115399cb521e05$exports))),
        imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($61fe277df354cb54$exports))),
        primaryText: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $64c0d0cfb686e433$export$defe85febe8b728c).noResultsPrimary
        }),
        secondaryText: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $64c0d0cfb686e433$export$defe85febe8b728c).noResultsSecondaryFilters
        })
    });
};





















var $iQC4a = parcelRequire("iQC4a");

var $bGd7w = parcelRequire("bGd7w");

var $2Btfj = parcelRequire("2Btfj");

var $ERUZZ = parcelRequire("ERUZZ");

var $57Ynd = parcelRequire("57Ynd");

var $1rDtO = parcelRequire("1rDtO");

var $af8fO = parcelRequire("af8fO");









parcelRequire("42omo");


var $dpPtd = parcelRequire("dpPtd");




















var $cvXh8 = parcelRequire("cvXh8");





var $3uVVG = parcelRequire("3uVVG");





var $dwp40 = parcelRequire("dwp40");


var $gtxdb = parcelRequire("gtxdb");


var $2CHGe = parcelRequire("2CHGe");

const $cf0cf9e106621db7$export$5aa524d86254b4f = (key, value)=>{
    window.localStorage.setItem(key, value);
};
const $cf0cf9e106621db7$export$93d719890ad66653 = (key)=>{
    return window.localStorage.getItem(key);
};


const $1e78a175b581c466$export$3849829f439d9262 = (args)=>{
    const { name: name } = args;
    const cacheInstance = (0, $2CHGe.getInstance)(args);
    const persistedState = (0, $cf0cf9e106621db7$export$93d719890ad66653)(name);
    if (persistedState) cacheInstance.deserialize(persistedState);
    const get = (key, returnExpired)=>cacheInstance.get(key, returnExpired ?? true); // fetch expired result by default.
    const set = async (key, result)=>{
        cacheInstance.set(key, result);
        await result;
        const serialized = await cacheInstance.serialize();
        (0, $cf0cf9e106621db7$export$5aa524d86254b4f)(name, serialized);
    };
    const refreshOnAccessDecorator = (key, supplier, returnExpired)=>{
        // cache hit
        const results = get(key, returnExpired);
        // cache refresh
        const apiPromise = supplier();
        // set the promise in the cache
        set(key, apiPromise);
        if (results) // return the expired result
        return results;
        else // return the latest result
        return apiPromise;
    };
    return {
        get: get,
        refreshOnAccessDecorator: refreshOnAccessDecorator
    };
};


const $2ec7b123413dd1f0$var$RELATIVE_URL = '/gateway/api/xpsearch-aggregator/configuration/v1';
const $2ec7b123413dd1f0$var$RELATIVE_3P_URL = '/gateway/api/third-party-configuration/connected-data-sources';
const { refreshOnAccessDecorator: $2ec7b123413dd1f0$var$refreshOnAccessDecoratorSearch } = (0, $1e78a175b581c466$export$3849829f439d9262)({
    name: 'search-config'
});
const $2ec7b123413dd1f0$export$cf95148f36a28b96 = 'search-3p-config';
const { refreshOnAccessDecorator: $2ec7b123413dd1f0$var$refreshOnAccessDecorator3pSearch } = (0, $1e78a175b581c466$export$3849829f439d9262)({
    name: $2ec7b123413dd1f0$export$cf95148f36a28b96,
    expiration: 300000
});
const $2ec7b123413dd1f0$var$SITELESS_PRODUCTS = [
    'trello',
    'bitbucket'
];
const $2ec7b123413dd1f0$export$2e9655e8b4177582 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId })=>{
    const url = absoluteUrl || `${hostName || ''}${$2ec7b123413dd1f0$var$RELATIVE_URL}`;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $gtxdb.generateHash)(`1p|${userId}|${cloudId}`);
    const supplier = ()=>(0, $dwp40.utils).requestService({
            url: url
        }, options).then((data)=>{
            const resources = data.resources.filter((resource)=>cloudId ? resource.id.includes(cloudId) || $2ec7b123413dd1f0$var$SITELESS_PRODUCTS.find((product)=>resource.id.includes(product)) // Allow access to products that are not associated with a site
                 : true);
            return {
                resources: resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
    return $2ec7b123413dd1f0$var$refreshOnAccessDecoratorSearch(key.toString(), supplier);
};
const $2ec7b123413dd1f0$export$6916ea7f169882e0 = async ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId, userId: userId })=>{
    const baseUrl = absoluteUrl || $2ec7b123413dd1f0$var$RELATIVE_3P_URL;
    const url = `${baseUrl}/${cloudId}`;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = $2ec7b123413dd1f0$export$f80795c7fd0ce9fc(userId || '', cloudId || '');
    const supplier = ()=>(0, $dwp40.utils).requestService({
            url: url
        }, options);
    return $2ec7b123413dd1f0$var$refreshOnAccessDecorator3pSearch(key.toString(), supplier, false);
};
const $2ec7b123413dd1f0$export$f80795c7fd0ce9fc = (userId, cloudId)=>(0, $gtxdb.generateHash)(`3p|${userId}|${cloudId}`);



const $7e759f1480163cfa$export$e5c324cf2a7795e0 = ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId })=>{
    const relativeSlackUrl = `/gateway/api/third-party-user-auth/slack/user-authed`;
    const baseUrl = absoluteUrl || relativeSlackUrl;
    const url = `${baseUrl}/${cloudId}`;
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};








const $b0871c3d5f8c9386$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    authorizationFail: {
        id: "dynamic-cards-search-page.oauth-banner.authorization-fail",
        defaultMessage: "Authorization for {product} failed."
    },
    authorizationSuccess: {
        id: "dynamic-cards-search-page.oauth-banner.authorization-success",
        defaultMessage: "Authorization for {product} successful."
    }
});





parcelRequire("42omo");










var $cO1el = parcelRequire("cO1el");























const $8932e12433c2b0b8$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    connectThirdPartyProductTitle: {
        id: "dynamic-cards-search-page.connect_third_party_product_title",
        defaultMessage: "Your admin has added {product}!"
    },
    connectThirdPartyProductTitleAlternate: {
        id: "dynamic-cards-search-page.connect_third_party_product_title_alternate",
        defaultMessage: "{product} is now available!"
    },
    connectThirdPartyProductDescription: {
        id: "dynamic-cards-search-page.connect_third_party_product_description",
        defaultMessage: "Connect your account to see missing results"
    },
    dismiss: {
        id: "dynamic-cards-search-page.oauth-message-dismiss",
        defaultMessage: "Dismiss"
    },
    connect: {
        id: "dynamic-cards-search-page.oauth-message-connect",
        defaultMessage: "Connect"
    }
});


const $12dba1c163962d17$var$containerStyles = (0, $ecnYn.xcss)({
    wordBreak: 'break-word',
    borderRadius: 'radius.small',
    backgroundColor: 'color.background.neutral',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    paddingTop: 'space.150',
    paddingBottom: 'space.150'
});
const $12dba1c163962d17$var$connectPressableStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    paddingInline: 'space.150',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    color: 'color.link',
    ':hover': {
        textDecoration: 'underline',
        color: 'color.link.pressed'
    },
    ':active': {
        textDecoration: 'underline',
        color: 'color.link.pressed'
    },
    whiteSpace: 'nowrap' // so that "Connect" doesn't get broken up needlessly
});
const $12dba1c163962d17$var$actionsContainer = (0, $ecnYn.xcss)({
    flexBasis: 'fit-content'
});
const $12dba1c163962d17$export$1b25a7895791d4fc = (props)=>{
    const { product: product, onAuthorize: onAuthorize, onDismiss: onDismiss, testId: testId } = props;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const productString = product === 'sharepoint' ? 'SharePoint' : (0, $4sOnC.products)[product].displayName;
    const Icon = (0, $4sOnC.products)[product].Icon;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
        alignItems: "center",
        templateAreas: [
            'icon text cta'
        ],
        templateColumns: "min-content 1fr auto",
        columnGap: "space.150",
        testId: testId,
        xcss: $12dba1c163962d17$var$containerStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                appearance: "brand"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                space: "space.050",
                alignBlock: "center",
                shouldWrap: true,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                        size: "small",
                        children: product === 'figma' ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $8932e12433c2b0b8$export$defe85febe8b728c).connectThirdPartyProductTitleAlternate,
                            values: {
                                product: productString
                            }
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $8932e12433c2b0b8$export$defe85febe8b728c).connectThirdPartyProductTitle,
                            values: {
                                product: productString
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                        size: "medium",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $8932e12433c2b0b8$export$defe85febe8b728c).connectThirdPartyProductDescription
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                testId: testId && `${testId}--actions`,
                space: "space.150",
                rowSpace: "space.0",
                alignBlock: "center",
                xcss: $12dba1c163962d17$var$actionsContainer,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
                        onClick: onAuthorize,
                        backgroundColor: "color.background.neutral.subtle",
                        xcss: $12dba1c163962d17$var$connectPressableStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                            weight: "medium",
                            size: "medium",
                            color: "color.link",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                ...(0, $8932e12433c2b0b8$export$defe85febe8b728c).connect
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                ...iconProps,
                                label: "",
                                color: "currentColor"
                            }),
                        onClick: onDismiss,
                        label: formatMessage((0, $8932e12433c2b0b8$export$defe85febe8b728c).dismiss),
                        appearance: 'subtle',
                        spacing: 'compact'
                    })
                ]
            })
        ]
    });
};


const $4e5c00ada8ef1437$var$LOCAL_STORAGE_BANNER_DISMISS_KEY = 'atlassian.unified-search.oauth-banner-dismiss-counts';
const $4e5c00ada8ef1437$export$afe8c16e492e553f = (product, isHello)=>{
    const dismissCounts = $4e5c00ada8ef1437$var$getLocalStorageData();
    const hasUserDismissedThisProductBefore = (dismissCounts[product] ?? 0) > 0;
    if (isHello) return !(hasUserDismissedThisProductBefore || $4e5c00ada8ef1437$export$67e3eb5caec4ff4c(dismissCounts));
    return !hasUserDismissedThisProductBefore;
};
/**
 * The max number of times the user dismisses **across products**
 */ const $4e5c00ada8ef1437$var$MAX_DISMISSALS = 3;
const $4e5c00ada8ef1437$export$67e3eb5caec4ff4c = (dismissCounts)=>{
    const totalDismissalsAcrossProducts = Object.values(dismissCounts).reduce((prev, curr)=>prev + curr, 0);
    return totalDismissalsAcrossProducts >= $4e5c00ada8ef1437$var$MAX_DISMISSALS;
};
const $4e5c00ada8ef1437$export$94f957a0ee1d39c8 = (product)=>{
    const dismissCounts = $4e5c00ada8ef1437$var$getLocalStorageData();
    dismissCounts[product] = (dismissCounts[product] ?? 0) + 1;
    $4e5c00ada8ef1437$var$saveToLocalStorage(dismissCounts);
};
/**
 * @returns the local storage object that stores products and their dismiss counts
 */ const $4e5c00ada8ef1437$var$getLocalStorageData = ()=>{
    const serializedDismissCounts = localStorage.getItem($4e5c00ada8ef1437$var$LOCAL_STORAGE_BANNER_DISMISS_KEY);
    if (!serializedDismissCounts) return {};
    let localStorageObject;
    try {
        localStorageObject = JSON.parse(serializedDismissCounts);
    } catch (_) {
        return {};
    }
    return localStorageObject;
};
/**
 * Saves the local storage object that stores products and their dismiss counts
 */ const $4e5c00ada8ef1437$var$saveToLocalStorage = (localStorageObject)=>{
    localStorage.setItem($4e5c00ada8ef1437$var$LOCAL_STORAGE_BANNER_DISMISS_KEY, JSON.stringify(localStorageObject));
};


const $1815ce83a173b628$export$4177cdcc6454d6f2 = ({ product: product, outboundAuthUrl: outboundAuthUrl })=>{
    const [{ cloudId: cloudId, user: user, outboundAuthConfigs: outboundAuthConfigs }, { setState: setState }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const userId = user?.id;
    const { retrySearch: retrySearch } = (0, $7tL1u.useSearchActions)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isDismissed, setIsDismissed] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const productCapitalized = product.charAt(0).toUpperCase() + product.slice(1);
    const onSuccess = ()=>{
        if (product === 'slack') (0, $7e759f1480163cfa$export$e5c324cf2a7795e0)({
            cloudId: cloudId
        });
        setIsDismissed(true);
        showFlag({
            title: formatMessage((0, $b0871c3d5f8c9386$export$defe85febe8b728c).authorizationSuccess, {
                product: productCapitalized
            }),
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                spacing: "spacious",
                label: "",
                color: `var(--ds-icon-success, ${(0, $6fnsQ.G300)})`
            }),
            isAutoDismiss: true
        });
        const newOutboundAuthConfigs = $1815ce83a173b628$var$refreshOAuthCache(product, userId || '', cloudId || '', outboundAuthConfigs);
        setState({
            outboundAuthConfigs: newOutboundAuthConfigs
        });
        (0, $glYzA.cache).clear();
        retrySearch();
    };
    const onFail = ()=>{
        showFlag({
            title: formatMessage((0, $b0871c3d5f8c9386$export$defe85febe8b728c).authorizationFail, {
                product: productCapitalized
            }),
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                spacing: "spacious",
                label: "",
                color: `var(--ds-icon-danger, ${(0, $6fnsQ.R400)})`
            }),
            isAutoDismiss: true
        });
    };
    const onAuthorize = ()=>{
        (0, $3uVVG.auth)(outboundAuthUrl).then(onSuccess).catch(onFail);
    };
    const onDismiss = ()=>{
        setIsDismissed(true);
        (0, $4e5c00ada8ef1437$export$94f957a0ee1d39c8)(product);
    };
    if (isDismissed) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $12dba1c163962d17$export$1b25a7895791d4fc), {
        product: product,
        onAuthorize: onAuthorize,
        onDismiss: onDismiss
    });
};
const $1815ce83a173b628$var$refreshOAuthCache = (product, userId, cloudId, outboundAuthConfigs)=>{
    const key = (0, $2ec7b123413dd1f0$export$f80795c7fd0ce9fc)(userId, cloudId);
    const item = localStorage.getItem((0, $2ec7b123413dd1f0$export$cf95148f36a28b96));
    if (!item) return;
    let object;
    try {
        object = JSON.parse(item);
    } catch (_) {
        return;
    }
    const oauthConfig = object?.[key]?.result?.find((config)=>config.type.includes(product));
    if (!oauthConfig) return;
    oauthConfig.isUserOAuthed = true;
    const newOutboundAuthConfigs = {
        ...outboundAuthConfigs
    };
    const updatedConfig = outboundAuthConfigs[product];
    if (updatedConfig) updatedConfig.userNeedsOAuth = false;
    localStorage.setItem((0, $2ec7b123413dd1f0$export$cf95148f36a28b96), JSON.stringify(object));
    return newOutboundAuthConfigs;
};



const $088eb706225a246f$var$OAuthContainer = ()=>{
    const [{ outboundAuthConfigs: outboundAuthConfigs, products: availableProducts }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const [isHello] = (0, $ee6ce766a2e08634$export$1a0be923fb1117e4)();
    let productOrder = [];
    productOrder = [
        (0, $4sOnC.ProductKeys3P).GoogleDrive,
        (0, $4sOnC.ProductKeys3P).Sharepoint,
        (0, $4sOnC.ProductKeys3P).OneDrive,
        (0, $4sOnC.ProductKeys3P).Slack,
        (0, $4sOnC.ProductKeys3P).Teams,
        (0, $4sOnC.ProductKeys3P).Github,
        (0, $4sOnC.ProductKeys3P).Figma
    ];
    const productsToBeDisplayed = productOrder.filter((product)=>availableProducts.includes(product));
    let displayedProduct;
    for (const product of productsToBeDisplayed){
        const config = outboundAuthConfigs[product];
        if (config && config.userNeedsOAuth && (0, $4e5c00ada8ef1437$export$afe8c16e492e553f)(product, isHello)) {
            displayedProduct = product;
            break;
        }
    }
    const outboundAuthUrl = displayedProduct && outboundAuthConfigs[displayedProduct]?.url;
    return displayedProduct && outboundAuthUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1815ce83a173b628$export$4177cdcc6454d6f2), {
            product: displayedProduct,
            outboundAuthUrl: outboundAuthUrl
        })
    }) : null;
};
const $088eb706225a246f$var$OAuthContainerWithErrorBoundary = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $63afac6f9f5eb800$export$e926676385687eaf), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($088eb706225a246f$var$OAuthContainer, {})
    });
};
var $088eb706225a246f$export$2e2bcd8739ae039 = $088eb706225a246f$var$OAuthContainerWithErrorBoundary;












var $5nBzc = parcelRequire("5nBzc");
















parcelRequire("42omo");


var $tvI67 = parcelRequire("tvI67");




/**
 * An icon not available in Design System yet.
 * Copied from https://bitbucket.org/atlassian/status-ui/src/master/packages/ds-icon/glyph/atlas/goal.tsx.
 */ 


parcelRequire("42omo");

function $b6c0babacda65f4b$export$134cbcd70c6693b8() {
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19 12a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm2 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-7 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
            fill: "currentColor"
        })
    });
}

/**
 * An icon not available in Design System yet.
 * Copied from https://bitbucket.org/atlassian/status-ui/src/master/packages/ds-icon/glyph/atlas/project.tsx.
 */ 


parcelRequire("42omo");

function $33aa71d06634324f$export$219c8b8c393795b3() {
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.8284 6C14.5632 6 14.3088 6.10536 14.1213 6.29289L10.4591 9.95515L6.30769 10.4164C6.08201 10.4415 5.87158 10.5426 5.71101 10.7032L5.4142 11L6.53032 12.1161C7.01847 12.6043 7.01847 13.3957 6.53032 13.8839L5.20709 15.2071C4.81657 15.5976 4.1834 15.5976 3.79288 15.2071C3.40235 14.8166 3.40235 14.1834 3.79288 13.7929L4.58577 13L3.64643 12.0607C3.06064 11.4749 3.06065 10.5251 3.64643 9.93934L4.2968 9.28897C4.77849 8.80728 5.40978 8.50387 6.08683 8.42864L9.54092 8.04485L12.7071 4.87868C13.2697 4.31607 14.0328 4 14.8284 4H18C19.1046 4 20 4.89543 20 6V9.17157C20 9.96722 19.6839 10.7303 19.1213 11.2929L15.9551 14.4591L15.5713 17.9132C15.4961 18.5902 15.1927 19.2215 14.711 19.7032L14.0606 20.3536C13.4749 20.9393 12.5251 20.9393 11.9393 20.3536L11 19.4142L10.2071 20.2071C9.81657 20.5976 9.1834 20.5976 8.79288 20.2071C8.40235 19.8166 8.40235 19.1834 8.79288 18.7929L10.1161 17.4697C10.6043 16.9815 11.3957 16.9815 11.8839 17.4697L13 18.5858L13.2968 18.289C13.4574 18.1284 13.5585 17.918 13.5836 17.6923L14.0448 13.5409L17.7071 9.87868C17.8946 9.69114 18 9.43679 18 9.17157V6H14.8284ZM8.70711 15.2929C9.09763 15.6834 9.09763 16.3166 8.70711 16.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L7.29289 15.2929C7.68342 14.9024 8.31658 14.9024 8.70711 15.2929ZM15 10C15.5523 10 16 9.55228 16 9C16 8.44772 15.5523 8 15 8C14.4477 8 14 8.44772 14 9C14 9.55228 14.4477 10 15 10Z",
            fill: "currentColor"
        })
    });
}

/**
 * An icon not available in Design System yet.
 * Copied from https://bitbucket.org/atlassian/status-ui/src/master/packages/ds-icon/glyph/atlas/tag.tsx.
 */ 


parcelRequire("42omo");

function $c5b1711ff008e743$export$80beb1cb95701424() {
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.99 5.141a1 1 0 0 0-1.98-.282L8.561 8H6a1 1 0 0 0 0 2h2.276l-.572 4H5a1 1 0 1 0 0 2h2.418l-.408 2.859a1 1 0 0 0 1.98.282L9.439 16h3.98l-.409 2.859a1 1 0 0 0 1.98.282L15.439 16H18a1 1 0 1 0 0-2h-2.276l.572-4H19a1 1 0 1 0 0-2h-2.418l.408-2.859a1 1 0 1 0-1.98-.282L14.561 8h-3.98l.409-2.859ZM13.704 14l.572-4h-3.98l-.572 4h3.98Z",
            fill: "currentColor"
        })
    });
}



var $c3jFl = parcelRequire("c3jFl");


var $c5nm0 = parcelRequire("c5nm0");

const $7e6b6c837f488e72$export$a93cddd79e3ea530 = {
    project: 'project',
    goal: 'goal',
    tag: 'tag',
    AtlassianWebCrawler: 'atlassian-web-crawler'
};
const $7e6b6c837f488e72$export$5cb7c19fcb84c9cd = {
    [$7e6b6c837f488e72$export$a93cddd79e3ea530.project]: {
        displayName: (0, $c5nm0.messages).project,
        displayNamePlural: (0, $c5nm0.messages).projects,
        Icon: (0, $33aa71d06634324f$export$219c8b8c393795b3)
    },
    [$7e6b6c837f488e72$export$a93cddd79e3ea530.goal]: {
        displayName: (0, $c5nm0.messages).goal,
        displayNamePlural: (0, $c5nm0.messages).goals,
        Icon: (0, $b6c0babacda65f4b$export$134cbcd70c6693b8)
    },
    [$7e6b6c837f488e72$export$a93cddd79e3ea530.tag]: {
        displayName: (0, $c5nm0.messages).tag,
        displayNamePlural: (0, $c5nm0.messages).tags,
        Icon: (0, $c5b1711ff008e743$export$80beb1cb95701424)
    },
    [$7e6b6c837f488e72$export$a93cddd79e3ea530.AtlassianWebCrawler]: {
        displayName: (0, $c5nm0.messages).webPage,
        displayNamePlural: (0, $c5nm0.messages).webPages,
        Icon: (0, $c3jFl.WebDomainIcon)
    }
};
const $7e6b6c837f488e72$export$341b1567666c2663 = [
    $7e6b6c837f488e72$export$a93cddd79e3ea530.project,
    $7e6b6c837f488e72$export$a93cddd79e3ea530.goal,
    $7e6b6c837f488e72$export$a93cddd79e3ea530.tag,
    $7e6b6c837f488e72$export$a93cddd79e3ea530.AtlassianWebCrawler
];





const $bf0e75dc658e43a5$export$1a199e029d5e93d6 = ({ product: product, size: size = 'medium', isSelected: isSelected = false, ...props })=>{
    let Icon;
    if (product) {
        Icon = (0, $4sOnC.products)[product].Icon;
        return /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            ...props,
            size: size,
            appearance: "brand"
        });
    } else return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
        label: "",
        spacing: "spacious",
        color: isSelected ? `var(--ds-icon-selected, ${0, $6fnsQ.B400})` : `var(--ds-icon, ${0, $6fnsQ.N500})`
    });
};
const $bf0e75dc658e43a5$export$fe03eddc92730a5c = ({ productOrNounKey: productOrNounKey, size: size = 'medium', isSelected: isSelected = false, ...props })=>{
    let Icon;
    if (productOrNounKey) {
        Icon = (0, $4sOnC.products)[productOrNounKey]?.Icon || (0, $7e6b6c837f488e72$export$5cb7c19fcb84c9cd)[productOrNounKey]?.Icon;
        return /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            ...props,
            size: size,
            appearance: "brand"
        });
    } else return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
        label: "",
        spacing: "spacious",
        color: isSelected ? `var(--ds-icon-selected, ${0, $6fnsQ.B400})` : `var(--ds-icon, ${0, $6fnsQ.N500})`
    });
};















const $4335848b71c04fe0$var$metadataSpacerStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.075',
    marginRight: 'space.075'
});
const $4335848b71c04fe0$var$Spacer = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        as: "span",
        xcss: $4335848b71c04fe0$var$metadataSpacerStyles,
        children: "\u2022"
    });
const $4335848b71c04fe0$var$renderParts = (part, spacer)=>{
    const [key, value] = Array.isArray(part) ? part : [
        part,
        part
    ];
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            value,
            spacer && /*#__PURE__*/ (0, $l998X.jsx)($4335848b71c04fe0$var$Spacer, {})
        ]
    }, key);
};
const $4335848b71c04fe0$var$filterPart = (part)=>{
    if (Array.isArray(part)) return !!part[1];
    return !!part;
};
const $4335848b71c04fe0$export$8e7fb1f8fe599124 = ({ product: product, productSelected: productSelected, parts: defaultParts = [] })=>{
    const productDisplayName = productSelected ? '' : (0, $7e38068845a191b0$export$44fea6589b7ddc92)(product);
    const parts = defaultParts.filter($4335848b71c04fe0$var$filterPart);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            productDisplayName && /*#__PURE__*/ (0, $l998X.jsxs)((0, $bdcfd319a02b1672$export$f6a3d19be20f5819), {
                target: "layout",
                above: "sm",
                children: [
                    productDisplayName,
                    /*#__PURE__*/ (0, $l998X.jsx)($4335848b71c04fe0$var$Spacer, {})
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                children: parts?.map((m, i)=>$4335848b71c04fe0$var$renderParts(m, i < parts.length - 1))
            })
        ]
    });
};





parcelRequire("42omo");






const $88dbd3800a27f05f$var$anchorStyles = (0, $ecnYn.xcss)({
    display: 'inline-block',
    overflow: 'hidden',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtle',
    textDecoration: 'none',
    ':hover': {
        color: 'color.text.subtle'
    },
    ':visited': {
        color: 'color.text.subtle'
    },
    ':focus': {
        color: 'color.text.subtle'
    },
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $88dbd3800a27f05f$var$SearchMetadataLink = ({ label: label, href: href })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
        href: href,
        xcss: $88dbd3800a27f05f$var$anchorStyles,
        children: label
    });
};
var $88dbd3800a27f05f$export$2e2bcd8739ae039 = $88dbd3800a27f05f$var$SearchMetadataLink;






parcelRequire("42omo");







const $d88cd80e32b47a08$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    page: {
        id: "dynamic-cards-search-page.search_result_type_page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "dynamic-cards-search-page.search_result_type_blogpost",
        defaultMessage: "Blog Post"
    },
    whiteboard: {
        id: "dynamic-cards-search-page.search_result_type_whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "dynamic-cards-search-page.search_result_type_database",
        defaultMessage: "Database"
    },
    space: {
        id: "dynamic-cards-search-page.search_result_type_space",
        defaultMessage: "Space"
    },
    attachment: {
        id: "dynamic-cards-search-page.search_result_type_attachment",
        defaultMessage: "Attachment"
    },
    comment: {
        id: "dynamic-cards-search-page.search_result_type_comment",
        defaultMessage: "Comment"
    },
    folder: {
        id: "dynamic-cards-search-page.search_result_type_folder",
        defaultMessage: "Folder"
    },
    calendar: {
        id: "dynamic-cards-search-page.search_result_type_calendar",
        defaultMessage: "Calendar"
    },
    space_calendar: {
        // snake_case returned by the API
        id: "dynamic-cards-search-page.search_result_type_space_calendar",
        defaultMessage: "Space calendar"
    },
    question: {
        id: "dynamic-cards-search-page.search_result_type_question",
        defaultMessage: "Question"
    },
    answer: {
        id: "dynamic-cards-search-page.search_result_type_answer",
        defaultMessage: "Answer"
    },
    embed: {
        id: "dynamic-cards-search-page.search_result_type_embed",
        defaultMessage: "Smart Link"
    },
    board: {
        id: "dynamic-cards-search-page.search_result_type_board",
        defaultMessage: "Board"
    },
    dashboard: {
        id: "dynamic-cards-search-page.search_result_type_dashboard",
        defaultMessage: "Dashboard"
    },
    filter: {
        id: "dynamic-cards-search-page.search_result_type_filter",
        defaultMessage: "Filter"
    },
    issue: {
        id: "dynamic-cards-search-page.search_result_type_issue",
        defaultMessage: "Issue"
    },
    plan: {
        id: "dynamic-cards-search-page.search_result_type_plan",
        defaultMessage: "Plan"
    },
    project: {
        id: "dynamic-cards-search-page.search_result_type_project",
        defaultMessage: "Project"
    },
    goal: {
        id: "dynamic-cards-search-page.search_result_type_goal",
        defaultMessage: "Goal"
    },
    tag: {
        id: "dynamic-cards-search-page.search_result_type_tag",
        defaultMessage: "Tag"
    },
    learning: {
        id: "dynamic-cards-search-page.search_result_type_learning",
        defaultMessage: "Learning"
    },
    unrecognised: {
        id: "dynamic-cards-search-page.search_result_type_unrecognised",
        defaultMessage: "Unrecognised"
    },
    document: {
        id: "dynamic-cards-search-page.search_result_type_document",
        defaultMessage: "Document"
    },
    spreadsheet: {
        id: "dynamic-cards-search-page.search_result_type_spreadsheet",
        defaultMessage: "Spreadsheet"
    },
    presentation: {
        id: "dynamic-cards-search-page.search_result_type_presentation",
        defaultMessage: "Presentation"
    },
    'sharepoint-document': {
        id: "dynamic-cards-search-page.search_result_type_sharepoint_document",
        defaultMessage: "Sharepoint Document"
    },
    message: {
        id: "dynamic-cards-search-page.search_result_type_message",
        defaultMessage: "Message"
    },
    repository: {
        id: "dynamic-cards-search-page.search_result_type_repository",
        defaultMessage: "Repository"
    },
    'pull-request': {
        id: "dynamic-cards-search-page.search_result_type_pull_request",
        defaultMessage: "Pull Request"
    },
    commit: {
        id: "dynamic-cards-search-page.search_result_type_commit",
        defaultMessage: "Commit"
    },
    branch: {
        id: "dynamic-cards-search-page.search_result_type_branch",
        defaultMessage: "Branch"
    },
    channel: {
        id: "dynamic-cards-search-page.search_result_type_channel",
        defaultMessage: "Channel"
    },
    component: {
        id: "dynamic-cards-search-page.search_result_type_component",
        defaultMessage: "Component"
    },
    'work-item': {
        id: "dynamic-cards-search-page.search_result_type_work_item",
        defaultMessage: "Work Item"
    },
    card: {
        id: "dynamic-cards-search-page.search_result_type_card",
        defaultMessage: "Card"
    }
});


const $8ed8599e79dcdf51$export$95cacd63dfd98bee = ({ type: type })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const message = (0, $d88cd80e32b47a08$export$defe85febe8b728c)[type];
    if (!message) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: formatMessage(message)
    });
};


/**
 * This file was adapted from confluence/next/packages/search-utils/src/excerpt.tsx
 */ 


parcelRequire("42omo");











var $1VCtc = parcelRequire("1VCtc");









parcelRequire("42omo");





var $4wwVl = parcelRequire("4wwVl");









const $0d1f52a9e59555fc$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    personAvatarLabel: {
        id: "personAvatar.label",
        defaultMessage: "Person Avatar"
    },
    initialsAvatarLabel: {
        id: "initialsAvatar.label",
        defaultMessage: "Initials Avatar"
    }
});


const $83d9190d7d9f86c9$var$initialsAvatarColor = "var(--ds-background-neutral, #0515240F)";
const $83d9190d7d9f86c9$var$personAvatarColor = "var(--ds-icon, #292A2E)";
const $83d9190d7d9f86c9$var$textColor = "var(--ds-text, #292A2E)";
const $83d9190d7d9f86c9$var$defaultAvatarCSS = (0, $ecnYn.xcss)({
    padding: 'space.025',
    alignItems: 'center',
    display: 'flex'
});
const $83d9190d7d9f86c9$var$initialsAvatarCSS = (0, $ecnYn.xcss)({
    alignItems: 'center',
    display: 'flex'
});
function $83d9190d7d9f86c9$var$getInitials(name) {
    const names = name.split(' ');
    const lastName = names.length > 1 ? names[names.length - 1] : '';
    const firstInitial = names[0][0].toUpperCase();
    const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';
    return firstInitial + lastInitial;
}
const $83d9190d7d9f86c9$export$e2255cf6045e8d47 = ({ name: name })=>{
    // fg('use_initials_avatar_icon_3pmessages') => false
    const useInitialsAvatar = false;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: useInitialsAvatar ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            testId: "3p-message-avatar",
            xcss: $83d9190d7d9f86c9$var$initialsAvatarCSS,
            children: /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                "aria-label": formatMessage((0, $0d1f52a9e59555fc$export$defe85febe8b728c).initialsAvatarLabel),
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("circle", {
                        cx: "10",
                        cy: "10",
                        r: "10",
                        fill: $83d9190d7d9f86c9$var$initialsAvatarColor
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("text", {
                        x: "50%",
                        y: "55%",
                        fontFamily: "SF Pro Text, sans-serif",
                        dominantBaseline: "middle",
                        textAnchor: "middle",
                        fontSize: "11",
                        fontWeight: "400",
                        fill: $83d9190d7d9f86c9$var$textColor,
                        children: $83d9190d7d9f86c9$var$getInitials(name)
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $83d9190d7d9f86c9$var$defaultAvatarCSS,
            testId: "3p-message-avatar",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4wwVl))), {
                label: formatMessage((0, $0d1f52a9e59555fc$export$defe85febe8b728c).personAvatarLabel),
                color: $83d9190d7d9f86c9$var$personAvatarColor
            })
        })
    });
};





const $12d2cc9f3ae11467$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    lastActive: {
        id: "search-page.results.product-results.third-party.last-active",
        defaultMessage: "Last active {relativeDate}"
    },
    threadTypeLabel: {
        id: "search-page.results.product-results.third-party.thread-type-label",
        defaultMessage: "Thread"
    },
    messageTypeLabel: {
        id: "search-page.results.product-results.third-party.message-type-label",
        defaultMessage: "Message"
    },
    channelTypeLabel: {
        id: "search-page.results.product-results.third-party.channel-type-label",
        defaultMessage: "Channel"
    },
    channelMemberCount: {
        id: "search-page.results.product-results.third-party.channel-member-count",
        defaultMessage: "{memberCount, plural, one {# member} other {# members}}"
    },
    privateConversationText: {
        id: "search-page.results.product-results.third-party.private-conversation-text",
        defaultMessage: "{users} in a private conversation"
    },
    noContributorsText: {
        id: "search-page.results.product-results.third-party.no-contributors-label",
        defaultMessage: "External people in #{channelName}"
    },
    externalPeopleText: {
        id: "search-page.results.product-results.third-party.external-people-label",
        defaultMessage: "External people"
    },
    externalPersonText: {
        id: "search-page.results.product-results.third-party.external-person-label",
        defaultMessage: "External person"
    },
    titleWithRemainingContributors: {
        id: "search-page.results.product-results.third-party.title-with-remaining-contributors",
        defaultMessage: "{title} and {remainingContributorsCount} {remainingContributorsCount, plural, one {other} other {others}}"
    },
    titleAndChannelName: {
        id: "search-page.results.product-results.third-party.title-and-channel-name",
        defaultMessage: "{title} in #{channelName}"
    }
});


const $2c7ab0bafd629c54$var$threadItemCSS = (0, $ecnYn.xcss)({
    paddingBottom: 'space.050',
    paddingTop: 'space.050'
});
const $2c7ab0bafd629c54$var$SPECIAL_CHARS_REGEX = /^[!#$%^&*() ,.<>?\/\[\]_\-+=`~\|:;{}\\]+/;
const $2c7ab0bafd629c54$var$MAX_EXCERPT_LENGTH = 80;
const $2c7ab0bafd629c54$var$USER_DISPLAY_LIMIT = 3;
const $2c7ab0bafd629c54$export$2f5ba0d1129fe71 = (inputStr)=>{
    const htmlEntities = {
        '&nbsp;': ' ',
        '&lt;': '<',
        '&amp;': '&',
        '&quot;': '"',
        '&gt;': '>'
    };
    return Object.keys(htmlEntities).reduce((str, entity)=>{
        return str.replace(new RegExp(entity, 'g'), htmlEntities[entity]);
    }, inputStr);
};
const $2c7ab0bafd629c54$export$16c2ab98757b54d6 = (excerpt, noLeadingEllipsis, prefix)=>{
    if (!excerpt) return [
        /*#__PURE__*/ (0, $l998X.jsx)("span", {}, "empty")
    ];
    excerpt = $2c7ab0bafd629c54$export$2f5ba0d1129fe71(excerpt).trim();
    if (!excerpt) return [
        /*#__PURE__*/ (0, $l998X.jsx)("span", {}, "empty")
    ];
    const beginsWithHighlight = excerpt.slice(0, 8) === '@@@hl@@@';
    const beginsWithUrl = excerpt.slice(0, 4) === 'http' || beginsWithHighlight && excerpt.slice(8, 12) === 'http';
    // Strip leading special characters unless the excerpt begins with a highlight
    if (!beginsWithHighlight) excerpt = excerpt.replace($2c7ab0bafd629c54$var$SPECIAL_CHARS_REGEX, '');
    // Add ellipsis prefix if beginning of excerpt isn't a URL and excerpt length is greater than 80
    if (!noLeadingEllipsis && !beginsWithUrl && excerpt.length > $2c7ab0bafd629c54$var$MAX_EXCERPT_LENGTH) excerpt = '...'.concat(excerpt);
    // Add ellipsis suffix if excerpt doesn't end with ending punctuation and if length is greater than 80
    if (excerpt.length > $2c7ab0bafd629c54$var$MAX_EXCERPT_LENGTH && !excerpt.slice(-1).match(/[.!?]/)) excerpt = excerpt.concat('...');
    // Replace line breaks with separators
    excerpt = excerpt.replace(/\n+/g, " \xb7 ");
    return $2c7ab0bafd629c54$export$b847312d69858d61(excerpt, prefix);
};
const $2c7ab0bafd629c54$export$b847312d69858d61 = (excerpt, prefix)=>{
    if (!excerpt) return [
        /*#__PURE__*/ (0, $l998X.jsx)("span", {}, "empty")
    ];
    excerpt = $2c7ab0bafd629c54$export$2f5ba0d1129fe71(excerpt).trim();
    if (!excerpt) return [
        /*#__PURE__*/ (0, $l998X.jsx)("span", {}, "empty")
    ];
    const res = [];
    let pre, textMatch;
    let i = 0;
    while(excerpt){
        // @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
        const match = excerpt.match(RegExp("(.*?)@@@hl@@@(.*?)@@@endhl@@@(.*)", "s"));
        if (!match) {
            res.push(/*#__PURE__*/ (0, $l998X.jsx)("span", {
                children: excerpt
            }, excerpt));
            break;
        }
        [, pre, textMatch, excerpt] = match;
        if (pre) res.push(/*#__PURE__*/ (0, $l998X.jsx)("span", {
            children: pre
        }, `pre-${i}`));
        if (textMatch) // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        res.push(/*#__PURE__*/ (0, $l998X.jsx)("strong", {
            children: textMatch
        }, `textMatch-${i}`));
        i++;
    }
    return(// NOTE: wrapping these in <div> previously broke focus rings
    // in search results
    /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            prefix,
            res
        ]
    }));
};
function $2c7ab0bafd629c54$export$f2f9c8e083d34d6b(permissionLevel) {
    return permissionLevel === 'restricted' || permissionLevel === 'private';
}
const $2c7ab0bafd629c54$export$85fedc4ba4240156 = (input, maxLength)=>{
    if (input.length <= maxLength) return input;
    return input.substring(0, maxLength) + '...';
};
const $2c7ab0bafd629c54$export$c32a8291d21fb086 = (thumbnailUrl)=>{
    // Parse the URL
    const urlObj = new URL(thumbnailUrl);
    const params = urlObj.searchParams;
    // Extract the required parameters
    const amzExpires = params.get('X-Amz-Expires');
    const amzDate = params.get('X-Amz-Date');
    // if we lose the format, we should not attempt to render the thumbnail
    if (!amzExpires || !amzDate) return true;
    // Convert X-Amz-Date to a Date object
    const amzDateObj = new Date(parseInt(amzDate.substring(0, 4)), // Year
    parseInt(amzDate.substring(4, 6)) - 1, // Month (0-based index)
    parseInt(amzDate.substring(6, 8)), // Day
    parseInt(amzDate.substring(9, 11)), // Hour
    parseInt(amzDate.substring(11, 13)), // Minute
    parseInt(amzDate.substring(13, 15))) // Second
    ;
    // Calculate the expiration time in milliseconds
    const expirationTime = amzDateObj.getTime() + parseInt(amzExpires) * 1000;
    // Get the current time in milliseconds
    const currentTime = Date.now();
    // Determine if the current time is greater than the expiration time
    return currentTime > expirationTime;
};
const $2c7ab0bafd629c54$export$a688e0cd0fe53c61 = (inputString, mentions = [])=>{
    if (!inputString) return '';
    // Replace Slack aliases - @here, @channel, @everyone
    // More information on these can be found here: https://api.slack.com/reference/surfaces/formatting#special-mentions
    let processedString = inputString.replace(/<!(here|channel|everyone)>/g, '@$1');
    // Replace mentions with slack user names
    const slackNamePattern = /<@[^>]+>/g;
    processedString = processedString.replace(slackNamePattern, (externalId)=>{
        // Find the mention with the matching externalId
        const validMentions = mentions.filter((m)=>m !== null && m !== undefined);
        const mention = validMentions.find((m)=>`<@${m.externalId}>` === externalId);
        return mention ? `@${mention.name}` : ''; // Replace with name if found, otherwise remove the string
    });
    return processedString;
};
const $2c7ab0bafd629c54$export$4675aadf6b343fe5 = (allContributors, channelName, intl)=>{
    const { formatMessage: formatMessage } = intl;
    if (!allContributors) return formatMessage((0, $12d2cc9f3ae11467$export$defe85febe8b728c).noContributorsText, {
        channelName: channelName
    });
    const firstNamesString = $2c7ab0bafd629c54$export$71c19251e893ab21(allContributors, intl);
    let title = '';
    // if there are less than 3 contributors, show all
    if (allContributors.length <= $2c7ab0bafd629c54$var$USER_DISPLAY_LIMIT) title = firstNamesString;
    else // if there are more than 3 contributors, show the first 3
    title = formatMessage((0, $12d2cc9f3ae11467$export$defe85febe8b728c).titleWithRemainingContributors, {
        title: firstNamesString,
        remainingContributorsCount: allContributors.length - $2c7ab0bafd629c54$var$USER_DISPLAY_LIMIT
    });
    return formatMessage((0, $12d2cc9f3ae11467$export$defe85febe8b728c).titleAndChannelName, {
        title: title,
        channelName: channelName
    });
};
const $2c7ab0bafd629c54$export$71c19251e893ab21 = (contributors, intl)=>{
    const { formatMessage: formatMessage } = intl;
    const firstNames = contributors.map((contributor)=>contributor?.name?.split(' ')?.[0] || formatMessage((0, $12d2cc9f3ae11467$export$defe85febe8b728c).externalPersonText));
    // if all contributors are external, show external people label
    if (firstNames.every((name)=>name === formatMessage((0, $12d2cc9f3ae11467$export$defe85febe8b728c).externalPersonText))) return formatMessage((0, $12d2cc9f3ae11467$export$defe85febe8b728c).externalPeopleText);
    return firstNames.slice(0, $2c7ab0bafd629c54$var$USER_DISPLAY_LIMIT).join(', ');
};
const $2c7ab0bafd629c54$export$3cf018c7cb5c2c7d = (partial, intl)=>{
    const { formatMessage: formatMessage } = intl;
    const { description: description } = partial;
    let matchedMessage = null;
    let threadMessages = null;
    if ((0, $af8fO.isSlackMessage)(partial)) {
        const { initialContributors: initialContributors, linkedEntities: linkedEntities = [] } = partial;
        const ownerName = initialContributors?.[0]?.name || formatMessage((0, $12d2cc9f3ae11467$export$defe85febe8b728c).externalPersonText);
        matchedMessage = /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $2c7ab0bafd629c54$var$threadItemCSS,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                space: "space.025",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $83d9190d7d9f86c9$export$e2255cf6045e8d47), {
                        name: ownerName
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $5dK2X.default), {
                        maxLines: 1,
                        children: [
                            ownerName,
                            ": ",
                            $2c7ab0bafd629c54$export$b847312d69858d61($2c7ab0bafd629c54$export$a688e0cd0fe53c61(description))
                        ]
                    })
                ]
            }, "initial")
        });
        threadMessages = linkedEntities.slice(0, 2).map((entity)=>{
            const currentMessageOwnerName = entity.initialContributors?.[0]?.name;
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $2c7ab0bafd629c54$var$threadItemCSS,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                    space: "space.025",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $83d9190d7d9f86c9$export$e2255cf6045e8d47), {
                            name: currentMessageOwnerName
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $5dK2X.default), {
                            maxLines: 1,
                            children: [
                                currentMessageOwnerName ? ` ${currentMessageOwnerName}: ` : '',
                                ' ',
                                $2c7ab0bafd629c54$export$b847312d69858d61($2c7ab0bafd629c54$export$a688e0cd0fe53c61(entity.description))
                            ]
                        })
                    ]
                }, entity.id)
            });
        });
    } else if ((0, $57Ynd.isMessageEntity)(partial)) {
        const { initialContributors: initialContributors, linkedEntities: linkedEntities = [] } = partial;
        const ownerName = initialContributors?.[0]?.name;
        matchedMessage = /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $2c7ab0bafd629c54$var$threadItemCSS,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                space: "space.025",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $83d9190d7d9f86c9$export$e2255cf6045e8d47), {
                        name: ownerName
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $5dK2X.default), {
                        maxLines: 1,
                        children: [
                            ownerName,
                            ": ",
                            $2c7ab0bafd629c54$export$b847312d69858d61(description)
                        ]
                    })
                ]
            }, "initial")
        });
        threadMessages = linkedEntities.slice(0, 2).map((entity)=>{
            const currentMessageOwnerName = entity.initialContributors?.[0]?.name || formatMessage((0, $12d2cc9f3ae11467$export$defe85febe8b728c).externalPersonText);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $2c7ab0bafd629c54$var$threadItemCSS,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                    space: "space.025",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $83d9190d7d9f86c9$export$e2255cf6045e8d47), {
                            name: currentMessageOwnerName
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $5dK2X.default), {
                            maxLines: 1,
                            children: [
                                currentMessageOwnerName,
                                ":",
                                $2c7ab0bafd629c54$export$b847312d69858d61(entity.description)
                            ]
                        })
                    ]
                }, entity.id)
            });
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        children: [
            matchedMessage,
            threadMessages?.map((message)=>message)
        ]
    });
};
const $2c7ab0bafd629c54$export$995e2d4c52603c12 = (linkedEntities)=>{
    const contributors = (linkedEntities || []).flatMap((entity)=>entity.initialContributors || []).reduce((acc, curr)=>{
        acc[curr?.externalId] = curr;
        return acc;
    }, {});
    return Object.values(contributors);
};
const $2c7ab0bafd629c54$export$fdcae512e9fdc5ad = (timestamp)=>{
    return $2c7ab0bafd629c54$export$96e2a37e068d7fac($2c7ab0bafd629c54$export$7e0fd00186ff29c6(timestamp));
};
const $2c7ab0bafd629c54$export$158516eb8829fc93 = (timestamp)=>{
    if (!timestamp) timestamp = new Date();
    const now = new Date();
    return (now.getTime() - new Date(timestamp).getTime()) / 1000;
};
const $2c7ab0bafd629c54$export$7e0fd00186ff29c6 = (timestamp)=>{
    if (!timestamp) timestamp = new Date();
    const secondsPast = $2c7ab0bafd629c54$export$158516eb8829fc93(timestamp);
    const timeUnits = {
        seconds: secondsPast,
        minutes: secondsPast / 60,
        hours: secondsPast / 3600,
        days: secondsPast / 86400,
        months: secondsPast / 2592000,
        years: secondsPast / 31536000
    };
    return {
        seconds: Math.floor(timeUnits.seconds),
        minutes: Math.floor(timeUnits.minutes),
        hours: Math.floor(timeUnits.hours),
        days: Math.floor(timeUnits.days),
        months: Math.floor(timeUnits.months),
        years: Math.floor(timeUnits.years)
    };
};
const $2c7ab0bafd629c54$export$96e2a37e068d7fac = ({ seconds: seconds, minutes: minutes, hours: hours, days: days, months: months, years: years })=>{
    return $2c7ab0bafd629c54$export$3e6e07f5a5b9cd48(seconds, minutes, hours, days, months, years);
};
const $2c7ab0bafd629c54$export$3e6e07f5a5b9cd48 = (seconds, minutes, hours, days, months, years)=>{
    if (years > 0) return {
        unit: 'year',
        value: years
    };
    else if (months > 0) return {
        unit: 'month',
        value: months
    };
    else if (days > 0) return {
        unit: 'day',
        value: days
    };
    else if (hours > 0) return {
        unit: 'hour',
        value: hours
    };
    else if (minutes > 0) return {
        unit: 'minute',
        value: minutes
    };
    else return {
        unit: 'second',
        value: seconds
    };
};
const $2c7ab0bafd629c54$export$fb63ba58603395b8 = (integrationId)=>{
    return integrationId ? (0, $1VCtc.PlatformIntegrationAri).parse(integrationId).integrationKey : undefined;
};


const $26450527ac1e8b4f$export$94df0e59ebebf4a7 = (url, key, unencodedValue)=>{
    return $26450527ac1e8b4f$export$cbc5b385481fb319(url, {
        [key]: unencodedValue
    });
};
const $26450527ac1e8b4f$export$cbc5b385481fb319 = (url, params)=>{
    if (!url) return url;
    const sanitisedUrl = url.endsWith('?') || url.endsWith('&') ? url.slice(0, url.length - 1) : url;
    const paramsString = Object.entries(params).reduce((rest, [key, unencodedValue])=>{
        if (!key) return rest;
        const nextPart = `${encodeURIComponent(key)}=${encodeURIComponent(unencodedValue)}`;
        if (rest) return `${rest}&${nextPart}`;
        return nextPart;
    }, '');
    if (!paramsString) return url;
    // If it has a query string already
    if (sanitisedUrl.includes('?')) return `${sanitisedUrl}&${paramsString}`;
    return `${sanitisedUrl}?${paramsString}`;
};








const $096db6c5ba7e5192$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    for: {
        id: "dynamic-cards-search-page.atlas.for",
        defaultMessage: "for"
    },
    'townsquare.api.goal-state.archived': {
        id: "dynamic-cards-search-page.townsquare.api.goal-state.archived",
        defaultMessage: "Archived"
    },
    'townsquare.api.goal-state.off-track': {
        id: "dynamic-cards-search-page.townsquare.api.goal-state.off-track",
        defaultMessage: "Off track"
    },
    'townsquare.api.goal-state.at-risk': {
        id: "dynamic-cards-search-page.townsquare.api.goal-state.at-risk",
        defaultMessage: "At risk"
    },
    'townsquare.api.goal-state.on-track': {
        id: "dynamic-cards-search-page.townsquare.api.goal-state.on-track",
        defaultMessage: "On track"
    },
    'townsquare.api.goal-state.pending': {
        id: "dynamic-cards-search-page.townsquare.api.goal-state.pending",
        defaultMessage: "Pending"
    },
    'townsquare.api.goal-state.paused': {
        id: "dynamic-cards-search-page.townsquare.api.goal-state.paused",
        defaultMessage: "Paused"
    },
    'townsquare.api.goal-state.completed': {
        id: "dynamic-cards-search-page.townsquare.api.goal-state.completed",
        defaultMessage: "Completed"
    },
    'townsquare.api.goal-state.cancelled': {
        id: "dynamic-cards-search-page.townsquare.api.goal-state.cancelled",
        defaultMessage: "Cancelled"
    }
});


const $2946d259ab86f3a0$var$getKey = (partial)=>{
    if ((0, $iQC4a.isSearchResultAtlasProjectPartial)(partial)) return partial.project?.key;
    else if ((0, $iQC4a.isSearchResultAtlasGoalPartial)(partial)) return partial.goal?.key;
    else return null;
};
const $2946d259ab86f3a0$var$statusAndDateContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100'
});
const $2946d259ab86f3a0$var$statusDateStyles = (0, $ecnYn.xcss)({
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtle'
});
const $2946d259ab86f3a0$var$getStatusAndDate = (partial)=>{
    let statusLabel = null;
    let statusValue;
    let date = null;
    if ((0, $iQC4a.isSearchResultAtlasProjectPartial)(partial)) {
        statusLabel = partial.project?.state.label;
        statusValue = partial.project?.state.value;
        date = partial.project?.dueDate.label;
    } else if ((0, $iQC4a.isSearchResultAtlasGoalPartial)(partial)) {
        const messageKey = partial.goal?.status.localizedLabel.messageId;
        statusLabel = (0, $096db6c5ba7e5192$export$defe85febe8b728c)[messageKey] ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...(0, $096db6c5ba7e5192$export$defe85febe8b728c)[messageKey]
        }) : null;
        date = partial.goal?.targetDate.label;
    }
    if (!statusLabel || !statusValue) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: $2946d259ab86f3a0$var$statusAndDateContainerStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                style: $2946d259ab86f3a0$export$e9a2c2b0ecc25ba5(statusValue),
                children: statusLabel
            }),
            date && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $2946d259ab86f3a0$var$statusDateStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $096db6c5ba7e5192$export$defe85febe8b728c).for
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                        style: $2946d259ab86f3a0$var$defaultStatusLozengeStyle,
                        children: date
                    })
                ]
            })
        ]
    });
};
const $2946d259ab86f3a0$var$onTrackStatusLozengeStyle = {
    backgroundColor: `${"var(--ds-background-accent-green-subtlest, #DCFFF1)"}`,
    color: `${"var(--ds-text-accent-green, #216E4E)"}`
};
const $2946d259ab86f3a0$var$atRiskStatusLozengeStyle = {
    backgroundColor: `${"var(--ds-background-accent-yellow-subtlest, #FEF7C8)"}`,
    color: `${"var(--ds-text-accent-orange, #9E4C00)"}`
};
const $2946d259ab86f3a0$var$offTrackStatusLozengeStyle = {
    backgroundColor: `${"var(--ds-background-accent-red-subtlest, #FFECEB)"}`,
    color: `${"var(--ds-text-accent-red, #AE2E24)"}`
};
const $2946d259ab86f3a0$var$defaultStatusLozengeStyle = {
    backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"}`,
    color: `${"var(--ds-text-accent-gray, #505258)"}`
};
const $2946d259ab86f3a0$export$e9a2c2b0ecc25ba5 = (statusType)=>{
    switch(statusType){
        case 'on_track':
            return $2946d259ab86f3a0$var$onTrackStatusLozengeStyle;
        case 'at_risk':
            return $2946d259ab86f3a0$var$atRiskStatusLozengeStyle;
        case 'off_track':
            return $2946d259ab86f3a0$var$offTrackStatusLozengeStyle;
        default:
            return $2946d259ab86f3a0$var$defaultStatusLozengeStyle;
    }
};
const $2946d259ab86f3a0$var$descriptionContainerStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    maxHeight: '60px'
});
const $2946d259ab86f3a0$var$getDescription = (partial)=>{
    let description = '';
    if ((0, $iQC4a.isSearchResultAtlasGoalPartial)(partial) && partial.goal?.description) {
        const parsedDescrption = JSON.parse(partial.goal.description);
        // Recursive function to build the description. Traversal occurs in DFS
        // order. The base case is when the node is a text node, in which case
        // the text is appended to the description.
        const buildDescription = (goalDescription)=>{
            if (goalDescription.content) goalDescription.content.forEach(buildDescription);
            else if (goalDescription.type === 'text') description += goalDescription.text;
        };
        if (parsedDescrption.content) buildDescription(parsedDescrption);
    }
    return description;
};
const $2946d259ab86f3a0$export$a97c0c8e95f01322 = ({ partial: partial, position: position })=>{
    const [searchSessionId] = (0, $ee6ce766a2e08634$export$e1e7a4797df1a656)();
    const [selectedProduct] = (0, $7tL1u.useSelectedProduct)();
    const [searchQuery] = (0, $7tL1u.useSearchQuery)();
    const [primaryProduct] = (0, $ee6ce766a2e08634$export$92c6f3c7c09f3247)();
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle } = (0, $35ad33aa93b58ce9$export$9f4c92a576b56d82)(partial.title, searchQuery.split(' '));
        if (!highlightedTitle) return partial.title;
        return (0, $2c7ab0bafd629c54$export$b847312d69858d61)(highlightedTitle);
    }, [
        partial.title,
        searchQuery
    ]);
    const description = $2946d259ab86f3a0$var$getDescription(partial);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle } = (0, $35ad33aa93b58ce9$export$9f4c92a576b56d82)(description, searchQuery.split(' '));
        if (!highlightedTitle) return description;
        return (0, $2c7ab0bafd629c54$export$16c2ab98757b54d6)(highlightedTitle);
    }, [
        description,
        searchQuery
    ]);
    const url = (0, $42omo.useMemo)(()=>{
        return (0, $26450527ac1e8b4f$export$94df0e59ebebf4a7)(partial.url, 'search_id', searchSessionId);
    }, [
        partial,
        searchSessionId
    ]);
    const keyLink = (0, $42omo.useMemo)(()=>{
        const value = $2946d259ab86f3a0$var$getKey(partial);
        if (!value || !url) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $88dbd3800a27f05f$export$2e2bcd8739ae039), {
            label: value,
            href: url
        });
    }, [
        partial,
        url
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $77177493924f77d4$export$a2def421b23768aa), {
        ...partial,
        primaryProduct: primaryProduct,
        url: url,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $bf0e75dc658e43a5$export$1a199e029d5e93d6), {
            product: (0, $4sOnC.ProductKeys).Atlas,
            label: "Atlas"
        }),
        headerMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $4335848b71c04fe0$export$8e7fb1f8fe599124), {
            product: "townsquare",
            productSelected: !!selectedProduct,
            parts: [
                [
                    'type',
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $8ed8599e79dcdf51$export$95cacd63dfd98bee), {
                        type: partial.type
                    })
                ],
                [
                    'key',
                    keyLink
                ],
                [
                    'status',
                    $2946d259ab86f3a0$var$getStatusAndDate(partial)
                ]
            ]
        }),
        title: enrichedTitle,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $2946d259ab86f3a0$var$descriptionContainerStyles,
            testId: "search-page-atlas-result-description",
            children: enrichedDescription
        }),
        position: position,
        partial: partial
    });
};




























parcelRequire("42omo");












var $3gadb = parcelRequire("3gadb");





const $d42ab57e6aed7e01$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    lastModified: {
        id: "dynamic-cards-search-page.search-result.last-modified",
        defaultMessage: "Updated {formattedDate}"
    }
});


const $13cc6c7031bc6442$export$e6747eee8f26f8c0 = ({ lastModified: lastModified, message: message = (0, $d42ab57e6aed7e01$export$defe85febe8b728c).lastModified })=>{
    if (!lastModified) return null;
    const lastModifiedDate = new Date(lastModified);
    const { value: value, unit: unit } = (0, $2c7ab0bafd629c54$export$fdcae512e9fdc5ad)(lastModifiedDate);
    const absoluteDate = /*#__PURE__*/ (0, $l998X.jsx)((0, $cgtv4.FormattedDate), {
        value: lastModified,
        month: "short",
        day: "numeric",
        year: "numeric"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: absoluteDate,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                ...tooltipProps,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...message,
                    values: {
                        formattedDate: /*#__PURE__*/ (0, $l998X.jsx)((0, $a2dru.default), {
                            value: -value,
                            unit: unit
                        })
                    }
                })
            })
    });
};








const $65b7b5d086d94991$var$MAX_WORDS = 20;
const $65b7b5d086d94991$export$6e2b3cea5902982b = 250;
const $65b7b5d086d94991$export$91c2cc655c44ef69 = (text, query)=>{
    if (!text) return '';
    const lowerCaseQuery = query.toLowerCase();
    const words = text.split(' ');
    const indexOfQuery = words.findIndex((value)=>lowerCaseQuery === value.toLowerCase());
    if (indexOfQuery > $65b7b5d086d94991$var$MAX_WORDS) return [
        '...'
    ].concat(words.slice(indexOfQuery - $65b7b5d086d94991$var$MAX_WORDS, indexOfQuery + $65b7b5d086d94991$var$MAX_WORDS)).concat('...').join(' ');
    return words.slice(0, 2 * $65b7b5d086d94991$var$MAX_WORDS).join(' ').substring(0, $65b7b5d086d94991$export$6e2b3cea5902982b) + (text.length > $65b7b5d086d94991$export$6e2b3cea5902982b ? '...' : '');
};











const $1bf9067798cdaa83$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    tier: {
        id: "dynamic-cards-search-page.compass.tier",
        defaultMessage: "Tier {tier}"
    },
    state: {
        id: "dynamic-cards-search-page.compass.state",
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: "{state}"
    },
    ownerName: {
        id: "dynamic-cards-search-page.compass.owner-name",
        defaultMessage: "Owned by {ownerName}"
    }
});


const $3564a81d001b99dd$var$dotStyles = (0, $ecnYn.xcss)({
    width: '4px',
    height: '4px',
    borderRadius: 'radius.xsmall',
    marginLeft: 'space.050'
});
const $3564a81d001b99dd$var$pendingStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.accent.yellow.subtle'
});
const $3564a81d001b99dd$var$activeStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.accent.green.subtle'
});
const $3564a81d001b99dd$var$archivedStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.accent.gray.subtle'
});
const $3564a81d001b99dd$var$getComponentStateIcon = (state)=>{
    switch(state){
        case 'PENDING':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $3564a81d001b99dd$var$dotStyles,
                    $3564a81d001b99dd$var$pendingStyles
                ]
            });
        case 'ACTIVE':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $3564a81d001b99dd$var$dotStyles,
                    $3564a81d001b99dd$var$activeStyles
                ]
            });
        case 'ARCHIVED':
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: [
                    $3564a81d001b99dd$var$dotStyles,
                    $3564a81d001b99dd$var$archivedStyles
                ]
            });
    }
};
const $3564a81d001b99dd$var$owningTeamStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '200px'
});
const $3564a81d001b99dd$export$cc23f5d092bb479f = ({ partial: partial, position: position })=>{
    const [selectedProduct] = (0, $7tL1u.useSelectedProduct)();
    const [primaryProduct] = (0, $ee6ce766a2e08634$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isCompassTeamsLoading = (0, $7tL1u.useIsCompassTeamsLoading)();
    const [searchQuery] = (0, $7tL1u.useSearchQuery)();
    const { title: title, url: url, tier: tier, component: component, lastModifiedDate: lastModifiedDate, type: type, ownerName: ownerName } = partial;
    const { state: state, description: description } = component || {};
    const getLastModified = (0, $42omo.useMemo)(()=>{
        if (!lastModifiedDate) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $13cc6c7031bc6442$export$e6747eee8f26f8c0), {
            lastModified: lastModifiedDate
        });
    }, [
        lastModifiedDate
    ]);
    const getComponentState = (0, $42omo.useMemo)(()=>{
        if (!state) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
            appearance: 'default',
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                alignBlock: "center",
                space: "space.075",
                children: [
                    $3564a81d001b99dd$var$getComponentStateIcon(state),
                    formatMessage((0, $1bf9067798cdaa83$export$defe85febe8b728c).state, {
                        state: state
                    })
                ]
            })
        });
    }, [
        state,
        formatMessage
    ]);
    const getTier = (0, $42omo.useMemo)(()=>{
        if (!tier) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
            appearance: 'default',
            children: formatMessage((0, $1bf9067798cdaa83$export$defe85febe8b728c).tier, {
                tier: tier
            })
        });
    }, [
        tier,
        formatMessage
    ]);
    const getOwnerName = (0, $42omo.useMemo)(()=>{
        if (ownerName) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $3564a81d001b99dd$var$owningTeamStyles,
            children: formatMessage((0, $1bf9067798cdaa83$export$defe85febe8b728c).ownerName, {
                ownerName: ownerName
            })
        });
        if (isCompassTeamsLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $367b99054ac5830c$export$a72c2188d2b05fba), {});
    }, [
        ownerName,
        formatMessage,
        isCompassTeamsLoading
    ]);
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle } = (0, $35ad33aa93b58ce9$export$9f4c92a576b56d82)(title, searchQuery.split(' '));
        if (!highlightedTitle) return title;
        return (0, $2c7ab0bafd629c54$export$b847312d69858d61)(highlightedTitle);
    }, [
        title,
        searchQuery
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        const reducedDescription = (0, $65b7b5d086d94991$export$91c2cc655c44ef69)(description, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $35ad33aa93b58ce9$export$9f4c92a576b56d82)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $2c7ab0bafd629c54$export$16c2ab98757b54d6)(highlightedTitle);
    }, [
        description,
        searchQuery
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $77177493924f77d4$export$a2def421b23768aa), {
        ...partial,
        primaryProduct: primaryProduct,
        url: url,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $bf0e75dc658e43a5$export$1a199e029d5e93d6), {
            product: (0, $4sOnC.ProductKeys).Compass
        }),
        title: enrichedTitle,
        headerMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $4335848b71c04fe0$export$8e7fb1f8fe599124), {
            product: "compass",
            productSelected: !!selectedProduct,
            parts: [
                [
                    'type',
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $8ed8599e79dcdf51$export$95cacd63dfd98bee), {
                        type: type
                    })
                ],
                [
                    'ownerName',
                    getOwnerName
                ],
                [
                    'lastModified',
                    getLastModified
                ],
                [
                    'componentState',
                    getComponentState
                ],
                [
                    'tier',
                    getTier
                ]
            ]
        }),
        description: enrichedDescription,
        cloudId: cloudId,
        position: position
    });
};





parcelRequire("42omo");












































var $7p4As = parcelRequire("7p4As");


var $1yB28 = parcelRequire("1yB28");


var $1Zr9M = parcelRequire("1Zr9M");


var $ldfch = parcelRequire("ldfch");


var $9M4aB = parcelRequire("9M4aB");











const $7d0ecb99553ac692$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    viewProfile: {
        id: "dynamic-cards-search-ui.search-page.social-signals.user-card.view-profile",
        defaultMessage: "View profile"
    },
    emailButtonLabel: {
        id: "dynamic-cards-search-ui.search-page.social-signals.user-card.email-button-label",
        defaultMessage: "Copy email address"
    }
});
const $7d0ecb99553ac692$export$6bab030fe17f656d = (0, $cgtv4.defineMessages)({
    share: {
        id: "dynamic-cards-search-ui.search-page.social-signals.user-card.shared-time-unit-ago-by",
        defaultMessage: "Shared {relativeDate} by"
    },
    comment: {
        id: "dynamic-cards-search-ui.search-page.social-signals.user-card.commented-time-unit-ago-by",
        defaultMessage: "Commented {relativeDate} by"
    },
    edit: {
        id: "dynamic-cards-search-ui.search-page.social-signals.user-card.edited-time-unit-ago-by",
        defaultMessage: "Edited {relativeDate} by"
    }
});


const $4e7b3f4d5b09bf95$var$cardXcss = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.raised',
    borderRadius: "var(--ds-radius-large, 8px)",
    padding: 'space.200',
    minWidth: '214px',
    width: 'fit-content'
});
const $4e7b3f4d5b09bf95$var$headerXcss = (0, $ecnYn.xcss)({
    font: 'font.body.UNSAFE_small',
    fontWeight: 'font.weight.semibold'
});
const $4e7b3f4d5b09bf95$var$userNameXcss = (0, $ecnYn.xcss)({
    font: 'font.body.large',
    fontWeight: 'font.weight.semibold',
    textAlign: 'center',
    maxWidth: '214px',
    overflowWrap: 'break-word'
});
const $4e7b3f4d5b09bf95$var$userSubheadingXcss = (0, $ecnYn.xcss)({
    font: 'font.body',
    textAlign: 'center',
    maxWidth: '214px',
    overflowWrap: 'break-word'
});
const $4e7b3f4d5b09bf95$export$4c094c8f61edecb4 = ({ signalDate: signalDate, signalType: signalType, user: user, onCopyEmail: onCopyEmail })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
        direction: "column",
        alignItems: "center",
        gap: "space.200",
        xcss: $4e7b3f4d5b09bf95$var$cardXcss,
        children: [
            signalDate && signalType && /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                xcss: $4e7b3f4d5b09bf95$var$headerXcss,
                alignItems: "center",
                gap: "space.075",
                children: /*#__PURE__*/ (0, $l998X.jsx)($4e7b3f4d5b09bf95$export$4a6f3cfec60dc525, {
                    signalDate: signalDate,
                    signalType: signalType
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                    src: user.profilePicUrl,
                    size: "xlarge"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                direction: "column",
                alignItems: "center",
                gap: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $4e7b3f4d5b09bf95$var$userNameXcss,
                        children: user.name
                    }),
                    user.jobTitle && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $4e7b3f4d5b09bf95$var$userSubheadingXcss,
                        children: user.jobTitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
                gap: "space.050",
                children: [
                    onCopyEmail && /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ldfch))),
                        label: formatMessage((0, $7d0ecb99553ac692$export$defe85febe8b728c).emailButtonLabel),
                        isTooltipDisabled: false,
                        onClick: onCopyEmail
                    }),
                    user.profileUrl && /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
                        href: user.profileUrl,
                        target: "_blank",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $7d0ecb99553ac692$export$defe85febe8b728c).viewProfile
                        })
                    })
                ]
            })
        ]
    });
};
const $4e7b3f4d5b09bf95$var$SECONDS_IN_A_DAY = 86400;
const $4e7b3f4d5b09bf95$var$SECONDS_IN_AN_HOUR = 3600;
function $4e7b3f4d5b09bf95$export$e603bc8e48e0cfbb(signalDate) {
    const secondsSinceUpdate = (Date.now() - signalDate.getTime()) / 1000;
    const daysSinceUpdate = Math.floor(secondsSinceUpdate / $4e7b3f4d5b09bf95$var$SECONDS_IN_A_DAY);
    /** Seconds that don't fit into a whole day */ const remainingSecondsInAnHour = secondsSinceUpdate % $4e7b3f4d5b09bf95$var$SECONDS_IN_A_DAY;
    const leftoverHoursSinceUpdate = Math.floor(remainingSecondsInAnHour / $4e7b3f4d5b09bf95$var$SECONDS_IN_AN_HOUR);
    const minutesSinceUpdate = Math.floor(secondsSinceUpdate / 60);
    return {
        daysSinceUpdate: daysSinceUpdate,
        leftoverHoursSinceUpdate: leftoverHoursSinceUpdate,
        minutesSinceUpdate: minutesSinceUpdate
    };
}
const $4e7b3f4d5b09bf95$var$SOCIAL_SIGNAL_ICONS = {
    comment: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
        label: "",
        color: "currentColor"
    }),
    edit: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
        label: "",
        color: "currentColor"
    }),
    share: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9M4aB))), {
        label: "",
        color: "currentColor"
    })
};
const $4e7b3f4d5b09bf95$export$4a6f3cfec60dc525 = ({ signalDate: signalDate, signalType: signalType })=>{
    const icon = $4e7b3f4d5b09bf95$var$SOCIAL_SIGNAL_ICONS[signalType];
    const timeUnitAgoMessage = (0, $7d0ecb99553ac692$export$6bab030fe17f656d)[signalType];
    const { unit: unit, value: value } = (0, $42omo.useMemo)(()=>{
        const { daysSinceUpdate: daysSinceUpdate, leftoverHoursSinceUpdate: leftoverHoursSinceUpdate, minutesSinceUpdate: minutesSinceUpdate } = $4e7b3f4d5b09bf95$export$e603bc8e48e0cfbb(signalDate);
        return $4e7b3f4d5b09bf95$var$getTimeValues(daysSinceUpdate, leftoverHoursSinceUpdate, minutesSinceUpdate);
    }, [
        signalDate
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            icon,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $a2dru.default), {
                value: -value,
                style: "long",
                unit: unit,
                numeric: "auto",
                children: (formattedTime)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...timeUnitAgoMessage,
                        values: {
                            relativeDate: formattedTime
                        }
                    })
            })
        ]
    });
};
const $4e7b3f4d5b09bf95$var$getTimeValues = (daysSinceUpdate, leftoverHoursSinceUpdate, minutesSinceUpdate)=>{
    if (daysSinceUpdate === 0) {
        if (leftoverHoursSinceUpdate < 1) return {
            unit: 'minute',
            value: minutesSinceUpdate
        };
        return {
            unit: 'hour',
            value: leftoverHoursSinceUpdate
        };
    }
    return {
        unit: 'day',
        value: daysSinceUpdate
    };
};

























const $8f2ee2b2bbcacc17$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    share: {
        id: "dynamic-cards-search-ui.search-page.social-signals.user-card-trigger.shared",
        defaultMessage: "{name} shared"
    },
    edit: {
        id: "dynamic-cards-search-ui.search-page.social-signals.user-card-trigger.edited",
        defaultMessage: "{name} edited"
    },
    comment: {
        id: "dynamic-cards-search-ui.search-page.social-signals.user-card-trigger.commented",
        defaultMessage: "{name} commented"
    }
});


const $f4480d8cc7efdba0$var$signalTextXcss = (0, $ecnYn.xcss)({
    color: 'color.text.subtle',
    ':hover': {
        textDecoration: 'underline'
    },
    ':focus-visible': {
        textDecoration: 'underline'
    },
    background: 'none',
    padding: '0'
});
const $f4480d8cc7efdba0$export$b3c2c65aed2f6e98 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ avatarUrl: avatarUrl, userName: userName, onClick: onClick, socialSignalType: socialSignalType, testId: testId, componentName: componentName }, ref)=>{
    const firstName = (0, $42omo.useMemo)(()=>userName.split(' ')[0], [
        userName
    ]);
    const message = (0, $8f2ee2b2bbcacc17$export$defe85febe8b728c)[socialSignalType];
    if (!message) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2W0qg.default), {
        ref: ref,
        onClick: onClick,
        xcss: $f4480d8cc7efdba0$var$signalTextXcss,
        testId: testId,
        componentName: componentName,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
            gap: "space.075",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
                    src: avatarUrl,
                    size: "xsmall"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                    size: "small",
                    color: "color.text.subtle",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...message,
                        values: {
                            name: firstName
                        }
                    })
                })
            ]
        })
    });
});




const $57328df52c3a0d3c$export$b2199c37e85de4a7 = (text)=>{
    const callback = (0, $42omo.useCallback)(()=>{
        navigator.clipboard.writeText(text);
    }, [
        text
    ]);
    return callback;
};



var $4WTnQ = parcelRequire("4WTnQ");


const $f264563e87e0a377$export$2530a1964f2c1c12 = ({ partial: partial })=>{
    const copyEmailToClipboard = (0, $57328df52c3a0d3c$export$b2199c37e85de4a7)(partial.socialSignal?.user?.email ?? '');
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { mapUserIdToProfileUrl: mapUserIdToProfileUrl } = (0, $cdf2753c4aea5699$export$fdc397e486fa83e7)();
    const { socialSignal: socialSignal } = partial;
    if (!socialSignal || !socialSignal.user || !socialSignal.signal || !$f264563e87e0a377$var$isSupportedSocialSignal(socialSignal.signal)) return null;
    const { signal: signal, timestamp: timestamp, user: user } = socialSignal;
    const userProfileUrl = mapUserIdToProfileUrl(user.accountId);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $f4480d8cc7efdba0$export$b3c2c65aed2f6e98), {
                ...triggerProps,
                userName: user.name,
                socialSignalType: signal,
                avatarUrl: user.picture,
                onClick: ()=>{
                    setIsOpen((open)=>!open);
                },
                testId: "search-page-social-signal",
                componentName: `${(0, $4WTnQ.ACTION_SUBJECT_PREFIX)}SocialSignal`
            }),
        content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4e7b3f4d5b09bf95$export$4c094c8f61edecb4), {
                user: {
                    name: user.name,
                    profilePicUrl: user.picture,
                    jobTitle: user.extendedProfile?.jobTitle,
                    profileUrl: userProfileUrl
                },
                onCopyEmail: copyEmailToClipboard,
                signalDate: timestamp ? new Date(timestamp) : undefined,
                signalType: signal
            }),
        shouldRenderToParent: (0, $dh538.fg)('should-render-to-parent-should-be-true-conf')
    });
};
const $f264563e87e0a377$var$supportedSignals = [
    'edit',
    'share',
    'comment'
];
function $f264563e87e0a377$var$isSupportedSocialSignal(signalFromApi) {
    return $f264563e87e0a377$var$supportedSignals.includes(signalFromApi);
}










parcelRequire("42omo");









parcelRequire("42omo");






const $cd506f95dcbef336$var$styles = (0, $ecnYn.xcss)({
    display: 'inline-block',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtle',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
});
const $cd506f95dcbef336$var$SearchMetadataGeneric = ({ label: label })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $cd506f95dcbef336$var$styles,
        children: label
    });
};
var $cd506f95dcbef336$export$2e2bcd8739ae039 = $cd506f95dcbef336$var$SearchMetadataGeneric;




const $e1f59cb0c66706d1$var$breadcrumbsContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: 'size.100',
    maxWidth: '246px'
});
const $e1f59cb0c66706d1$export$9138e703d4b4585b = ({ partial: { space: space, url: url } })=>{
    if (!space || !space.name) return null;
    const baseUrl = url && (0, $0e889b123bd025c1$export$f654b28f82155665)(url);
    const href = `${baseUrl}/wiki${space.webUiLink}`;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
        xcss: $e1f59cb0c66706d1$var$breadcrumbsContainerStyles,
        children: href ? /*#__PURE__*/ (0, $l998X.jsx)((0, $88dbd3800a27f05f$export$2e2bcd8739ae039), {
            label: space.name,
            href: href
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $cd506f95dcbef336$export$2e2bcd8739ae039), {
            label: space.name
        })
    });
};





parcelRequire("42omo");









parcelRequire("42omo");










const $ebfcfefc3bec002c$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    commentIconLabel: {
        id: "dynamic-cards-search-page.comment-icon.label",
        defaultMessage: "Number of comments"
    }
});


// TODO: Replace this custom svg with `import CommentIcon from '@atlaskit/icon/core/comment';` once the icon is the same as this one
const $844060ee04b5eff9$var$CommentIcon = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)("svg", {
        "aria-label": formatMessage((0, $ebfcfefc3bec002c$export$defe85febe8b728c).commentIconLabel),
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: `var(--ds-icon, ${(0, $6fnsQ.N500)})`,
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.77126 13.0019C3.43856 13.2168 3 12.9779 3 12.5819V5C3 3.89543 3.89543 3 5 3H11C12.1046 3 13 3.89543 13 5V8.91667C13 10.0212 12.1046 10.9167 11 10.9167H7L3.77126 13.0019ZM6.55773 9.41667H11C11.2761 9.41667 11.5 9.19281 11.5 8.91667V5C11.5 4.72386 11.2761 4.5 11 4.5H5C4.72386 4.5 4.5 4.72386 4.5 5V10.7456L6.55773 9.41667Z",
            fill: `var(--ds-icon, ${(0, $6fnsQ.N500)})`
        })
    });
};
var $844060ee04b5eff9$export$2e2bcd8739ae039 = $844060ee04b5eff9$var$CommentIcon;


const $67428ca51d36dfff$export$f4c1466e6fdd07b = ({ numberOfComments: numberOfComments })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.050",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $844060ee04b5eff9$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                size: "small",
                children: numberOfComments
            })
        ]
    });
};





parcelRequire("42omo");






const $4efe4a749957de76$export$1bd444ba34dbd512 = ({ numberOfLikes: numberOfLikes })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.050",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                as: "span",
                size: "small",
                children: "\uD83D\uDC4D"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                size: "small",
                children: numberOfLikes
            })
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 




















const $b4cc95614f393f50$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    verifiedIconLabel: {
        id: "search-page.verified-icon-label",
        defaultMessage: "Verified"
    },
    verifiedIconTooltipMessage: {
        id: "search-page.verified-icon-tooltip-message",
        defaultMessage: "This page has been verified by an owner or admin."
    }
});


const $b2076ea4f851f90b$var$TooltipTagStyles = {
    wrapper: "_1e0c1txw"
}; // A custom tag element to prevent a bug where an additional 1-pixel whitespace is rendered after the target element
const $b2076ea4f851f90b$export$48d215ae75c54231 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "div",
        xcss: $b2076ea4f851f90b$var$TooltipTagStyles.wrapper,
        ref: ref,
        ...props
    }));
const $b2076ea4f851f90b$export$eb413699769dd9b1 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: formatMessage((0, $b4cc95614f393f50$export$a7357cdd1f0b0168).verifiedIconTooltipMessage),
        tag: $b2076ea4f851f90b$export$48d215ae75c54231,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh5s2))), {
            label: formatMessage((0, $b4cc95614f393f50$export$a7357cdd1f0b0168).verifiedIconLabel),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        })
    });
};


const $f0dc6d43cf11d6ff$var$getTitle = (partial)=>{
    return (0, $2c7ab0bafd629c54$export$b847312d69858d61)(partial.title);
};
const $f0dc6d43cf11d6ff$var$getLastModified = (partial)=>{
    if (partial.lastModified) return /*#__PURE__*/ (0, $l998X.jsx)((0, $13cc6c7031bc6442$export$e6747eee8f26f8c0), {
        lastModified: partial.lastModified
    });
    return null;
};
const $f0dc6d43cf11d6ff$var$getBreadcrumbs = (partial)=>{
    if (!(0, $2Btfj.isSearchConfluencePageBlogAttachment)(partial)) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $e1f59cb0c66706d1$export$9138e703d4b4585b), {
        partial: partial
    });
};
const $f0dc6d43cf11d6ff$var$getVerifiedIcon = (partial)=>{
    if ((0, $2Btfj.isSearchConfluencePageBlogAttachment)(partial) && partial.isVerified) return /*#__PURE__*/ (0, $l998X.jsx)((0, $b2076ea4f851f90b$export$eb413699769dd9b1), {});
    return null;
};
const $f0dc6d43cf11d6ff$var$getCommentCount = (partial)=>{
    if (!(0, $2Btfj.isSearchConfluencePageBlogAttachment)(partial)) return null;
    const numberOfComments = partial.confluenceEntity?.commentCountSummary?.total ?? 0;
    if (numberOfComments === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $67428ca51d36dfff$export$f4c1466e6fdd07b), {
        numberOfComments: numberOfComments
    });
};
const $f0dc6d43cf11d6ff$var$getLikeCount = (partial)=>{
    if (!(0, $2Btfj.isSearchConfluencePageBlogAttachment)(partial)) return null;
    const numberOfLikes = partial.confluenceEntity?.likesSummary?.count ?? 0;
    if (numberOfLikes === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4efe4a749957de76$export$1bd444ba34dbd512), {
        numberOfLikes: numberOfLikes
    });
};
const $f0dc6d43cf11d6ff$var$getDescription = (partial)=>{
    return (0, $2c7ab0bafd629c54$export$16c2ab98757b54d6)(partial.description);
};
const $f0dc6d43cf11d6ff$export$30adeb861c31a5ed = ({ partial: partial, position: position })=>{
    const [{ cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const [selectedProduct] = (0, $7tL1u.useSelectedProduct)();
    const [searchSessionId] = (0, $ee6ce766a2e08634$export$e1e7a4797df1a656)();
    const [primaryProduct] = (0, $ee6ce766a2e08634$export$92c6f3c7c09f3247)();
    const [query] = (0, $7tL1u.useSearchQuery)();
    const icon = /*#__PURE__*/ (0, $l998X.jsx)((0, $bf0e75dc658e43a5$export$1a199e029d5e93d6), {
        product: (0, $4sOnC.ProductKeys).Confluence
    });
    const metadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $8ed8599e79dcdf51$export$95cacd63dfd98bee), {
                type: partial.type
            })
        ],
        [
            'breadcrumbs',
            $f0dc6d43cf11d6ff$var$getBreadcrumbs(partial)
        ],
        [
            'last-modified',
            $f0dc6d43cf11d6ff$var$getLastModified(partial)
        ],
        [
            'verified',
            $f0dc6d43cf11d6ff$var$getVerifiedIcon(partial)
        ],
        [
            'comment-count',
            $f0dc6d43cf11d6ff$var$getCommentCount(partial)
        ],
        [
            'like-count',
            $f0dc6d43cf11d6ff$var$getLikeCount(partial)
        ]
    ];
    if (partial.socialSignal) metadataParts.push([
        'social-signal',
        /*#__PURE__*/ (0, $l998X.jsx)((0, $f264563e87e0a377$export$2530a1964f2c1c12), {
            partial: partial
        })
    ]);
    const appendAdditionalQueryParams = ({ url: url, resultId: resultId })=>{
        let href = (0, $26450527ac1e8b4f$export$94df0e59ebebf4a7)(partial.url, 'search_id', searchSessionId);
        return href;
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $77177493924f77d4$export$a2def421b23768aa), {
        ...partial,
        primaryProduct: primaryProduct,
        url: appendAdditionalQueryParams({
            url: partial.url,
            resultId: partial.id
        }),
        title: $f0dc6d43cf11d6ff$var$getTitle(partial),
        icon: icon,
        headerMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $4335848b71c04fe0$export$8e7fb1f8fe599124), {
            product: "confluence",
            productSelected: !!selectedProduct,
            parts: metadataParts
        }),
        description: $f0dc6d43cf11d6ff$var$getDescription(partial),
        showAISummary: [
            'page',
            'blogpost'
        ].includes(partial.type) && isAdminHubAIEnabled,
        cloudId: cloudId,
        position: position,
        partial: partial
    });
};































parcelRequire("42omo");








const $636f7880802d95fb$var$jiraProjectProductMap = {
    software: (0, $4sOnC.ProductKeys).Jira,
    business: (0, $4sOnC.ProductKeys).Jira,
    service_desk: (0, $4sOnC.ProductKeys).JiraServiceManagement,
    product_discovery: (0, $4sOnC.ProductKeys).JiraProductDiscovery
};
const $636f7880802d95fb$var$jiraIssueProductMap = {
    SOFTWARE: (0, $4sOnC.ProductKeys).Jira,
    BUSINESS: (0, $4sOnC.ProductKeys).Jira,
    SERVICE_DESK: (0, $4sOnC.ProductKeys).JiraServiceManagement,
    PRODUCT_DISCOVERY: (0, $4sOnC.ProductKeys).JiraProductDiscovery
};
const $636f7880802d95fb$var$jiraBoardProductMap = {
    SOFTWARE: (0, $4sOnC.ProductKeys).Jira,
    BUSINESS: (0, $4sOnC.ProductKeys).Jira
};
const $636f7880802d95fb$export$212b3dd204f7717b = ({ partial: partial })=>{
    let product = (0, $4sOnC.ProductKeys).Jira;
    if ((0, $ERUZZ.isSearchResultJiraProject)(partial)) product = $636f7880802d95fb$var$jiraProjectProductMap[partial.projectType];
    else if ((0, $ERUZZ.isSearchResultJiraIssue)(partial)) {
        const projectType = partial?.issue?.fieldsById.edges[0]?.node.project.projectType;
        product = projectType ? $636f7880802d95fb$var$jiraIssueProductMap[projectType] : product;
    } else if ((0, $ERUZZ.isSearchResultJiraBoard)(partial)) product = $636f7880802d95fb$var$jiraBoardProductMap[partial.product];
    else if ((0, $ERUZZ.isSearchResultJiraFilter)(partial)) ;
    else (0, $ERUZZ.isSearchResultJiraDashboard)(partial);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bf0e75dc658e43a5$export$1a199e029d5e93d6), {
        product: product
    });
};





parcelRequire("42omo");









const $fa84116fde29fc9c$var$containerStyles = (0, $ecnYn.xcss)({
    display: 'inline-block',
    maxWidth: '215px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $fa84116fde29fc9c$export$47d2cbdccded0b18 = ({ project: project })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: project,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $fa84116fde29fc9c$var$containerStyles,
                testId: "project-metadata",
                ...tooltipProps,
                children: project
            })
    });
};


const $4fbd69116e3f56b6$var$findProject = (partial)=>{
    if (!partial.issue) return;
    for (const field of partial.issue.fieldsById.edges){
        if ((0, $ERUZZ.isJiraProjectField)(field.node)) return field.node;
    }
};
const $4fbd69116e3f56b6$var$getIssueOrProjectKey = (partial)=>{
    if ((0, $ERUZZ.isSearchResultJiraIssue)(partial)) return partial.issue?.key;
    if ((0, $ERUZZ.isSearchResultJiraProject)(partial)) return partial.projectKey;
    return null;
};
const $4fbd69116e3f56b6$var$addJiraQueryParams = (url, partial, searchSessionId)=>{
    return (0, $26450527ac1e8b4f$export$cbc5b385481fb319)(url, {
        searchObjectId: partial.id.split('/').pop(),
        searchContentType: partial.type,
        searchSessionId: searchSessionId
    });
};
const $4fbd69116e3f56b6$var$STATUS_REGEX = /[\s-]+/g;
/**
 * This logic would need to be updated to use the color passed from the BE and not the string.
 * https://product-fabric.atlassian.net/browse/QS-3655
 */ const $4fbd69116e3f56b6$var$getAppearance = (name)=>{
    name = name.replace($4fbd69116e3f56b6$var$STATUS_REGEX, '').toLowerCase();
    switch(true){
        case [
            'todo',
            'unavailable',
            'minor',
            'notstarted'
        ].includes(name):
            return 'default';
        case [
            'available',
            'completed',
            'done',
            'approved',
            'resolved',
            'added',
            'closed'
        ].includes(name):
            return 'success';
        case [
            'error',
            'declined',
            'deleted',
            'failed',
            'rejected'
        ].includes(name):
            return 'removed';
        case [
            'inprogress',
            'open',
            'modified'
        ].includes(name):
            return 'inprogress';
    }
    return 'default';
};
const $4fbd69116e3f56b6$var$getStatus = (name, isLoading)=>{
    if (name) {
        const appearance = $4fbd69116e3f56b6$var$getAppearance(name);
        if (appearance) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
            appearance: appearance,
            children: name
        });
    }
    if (isLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $367b99054ac5830c$export$9ecbe061c4358be9), {});
    return null;
};
const $4fbd69116e3f56b6$var$getContentString = (adf, level = 0)=>{
    let aggregatedString = '';
    if (adf.content) adf.content.forEach((node)=>{
        if (node.type === 'text') aggregatedString += node.text;
        else if (node.content && level < 15) aggregatedString += ' ' + $4fbd69116e3f56b6$var$getContentString(node, ++level);
    });
    return aggregatedString;
};
const $4fbd69116e3f56b6$var$getDescription = (description, query)=>{
    /**
	 * This description can be either a complicated JSON which is actually an ADF (Atlassian Document Format) schema of the entire content of the jira issue.
	 * or it could be a simple excerpt. This uncertainity is due to the progressive development of the BE feature and rolling it out.
	 */ try {
        const adf = JSON.parse(description);
        const text = $4fbd69116e3f56b6$var$getContentString(adf);
        return (0, $65b7b5d086d94991$export$91c2cc655c44ef69)(text, query);
    } catch (e) {
        return description.length > (0, $65b7b5d086d94991$export$6e2b3cea5902982b) ? description.substring(0, (0, $65b7b5d086d94991$export$6e2b3cea5902982b)) + '...' : description.substring(0, (0, $65b7b5d086d94991$export$6e2b3cea5902982b));
    }
};
const $4fbd69116e3f56b6$export$3c36ba6ceaed3437 = ({ partial: partial, position: position })=>{
    const [searchSessionId] = (0, $ee6ce766a2e08634$export$e1e7a4797df1a656)();
    const [selectedProduct] = (0, $7tL1u.useSelectedProduct)();
    const [searchQuery] = (0, $7tL1u.useSearchQuery)();
    const [primaryProduct] = (0, $ee6ce766a2e08634$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const isHydrationLoading = (0, $7tL1u.useIsJiraHydrationLoading)();
    const { description: description } = partial;
    let project = '';
    let Status = null;
    let url = partial.url;
    if ((0, $ERUZZ.isSearchResultJiraIssue)(partial)) {
        const projectField = $4fbd69116e3f56b6$var$findProject(partial);
        project = projectField?.project.name || '';
        const projectId = projectField?.project.id || '';
        url = (0, $26450527ac1e8b4f$export$cbc5b385481fb319)(partial.url, {
            searchContainerId: projectId.split('/').pop()
        });
        Status = $4fbd69116e3f56b6$var$getStatus(partial.status?.name, isHydrationLoading);
    }
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle } = (0, $35ad33aa93b58ce9$export$9f4c92a576b56d82)(partial.title, searchQuery.split(' '));
        if (!highlightedTitle) return partial.title;
        return (0, $2c7ab0bafd629c54$export$b847312d69858d61)(highlightedTitle);
    }, [
        partial.title,
        searchQuery
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        const reducedDescription = $4fbd69116e3f56b6$var$getDescription(description, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $35ad33aa93b58ce9$export$9f4c92a576b56d82)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $2c7ab0bafd629c54$export$16c2ab98757b54d6)(highlightedTitle);
    }, [
        description,
        searchQuery
    ]);
    const getUrl = (0, $42omo.useMemo)(()=>{
        return $4fbd69116e3f56b6$var$addJiraQueryParams(url, partial, searchSessionId);
    }, [
        url,
        partial,
        searchSessionId
    ]);
    const getKey = (0, $42omo.useMemo)(()=>{
        const value = $4fbd69116e3f56b6$var$getIssueOrProjectKey(partial);
        if (!value || !getUrl) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $88dbd3800a27f05f$export$2e2bcd8739ae039), {
            label: value,
            href: getUrl
        });
    }, [
        partial,
        getUrl
    ]);
    const getLastModified = (0, $42omo.useMemo)(()=>{
        if (!((0, $ERUZZ.isSearchResultJiraIssue)(partial) || (0, $ERUZZ.isSearchResultJiraProject)(partial))) return null;
        if (partial.lastModifiedDate) return /*#__PURE__*/ (0, $l998X.jsx)((0, $13cc6c7031bc6442$export$e6747eee8f26f8c0), {
            lastModified: partial.lastModifiedDate
        });
        return null;
    }, [
        partial
    ]);
    const metadataParts = [
        [
            'type',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $8ed8599e79dcdf51$export$95cacd63dfd98bee), {
                type: partial.type
            })
        ],
        [
            'key',
            getKey
        ],
        project ? [
            'project',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $fa84116fde29fc9c$export$47d2cbdccded0b18), {
                project: project
            })
        ] : null,
        [
            'lastModified',
            getLastModified
        ],
        [
            'status',
            Status
        ]
    ].filter(Boolean);
    // fg('search-plex-jira-social-signal') => false
    (0, $ERUZZ.isSearchResultJiraIssue)(partial) && partial.socialSignal;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $77177493924f77d4$export$a2def421b23768aa), {
        ...partial,
        primaryProduct: primaryProduct,
        url: getUrl,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $636f7880802d95fb$export$212b3dd204f7717b), {
            partial: partial
        }),
        title: enrichedTitle,
        headerMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $4335848b71c04fe0$export$8e7fb1f8fe599124), {
            product: "jira",
            productSelected: !!selectedProduct,
            parts: metadataParts
        }),
        description: enrichedDescription,
        showAISummary: partial.type === 'issue' && isAdminHubAIEnabled,
        cloudId: cloudId,
        position: position,
        partial: partial
    });
};





parcelRequire("42omo");


var $1bY7o = parcelRequire("1bY7o");


var $k4HRJ = parcelRequire("k4HRJ");












parcelRequire("42omo");








parcelRequire("42omo");





var $9Q2dU = parcelRequire("9Q2dU");










const $09f0c3266b0327b1$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    restrictedTooltip: {
        id: "search-page.results.restricted-result-tooltip",
        defaultMessage: "Only visible to specific people"
    },
    privateTooltip: {
        id: "search-page.results.private-result-tooltip",
        defaultMessage: "Only visible to you"
    }
});


const $e365deb82157152f$var$iconColor = "var(--ds-icon, #292A2E)";
const $e365deb82157152f$export$3aad690c5eb10b93 = 'restricted-lozenge';
const $e365deb82157152f$export$fb0d481c8f77ba99 = ({ permissionLevel: permissionLevel })=>{
    const tooltipText = permissionLevel === 'private' ? (0, $09f0c3266b0327b1$export$defe85febe8b728c).privateTooltip : (0, $09f0c3266b0327b1$export$defe85febe8b728c).restrictedTooltip;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...tooltipText
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            testId: $e365deb82157152f$export$3aad690c5eb10b93,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                label: "",
                color: $e365deb82157152f$var$iconColor,
                size: "small"
            })
        })
    });
};









const $725e98749da50b5a$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    resultLabel: {
        id: "dynamic-cards-search-page.github-branch-result.label",
        defaultMessage: "Branch"
    }
});


const $bcf1a09e4776bc79$export$5620ef5d10869020 = ({ partial: partial, position: position, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [primaryProduct] = (0, $ee6ce766a2e08634$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity } = partial;
    const { name: branchName, container: container } = entity || {};
    const label = formatMessage((0, $725e98749da50b5a$export$defe85febe8b728c).resultLabel);
    const integrationKey = (0, $2c7ab0bafd629c54$export$fb63ba58603395b8)(partial.integrationId);
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $13cc6c7031bc6442$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const padlockIcon = (0, $2c7ab0bafd629c54$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $e365deb82157152f$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $77177493924f77d4$export$a2def421b23768aa), {
        id: partial.id,
        icon: icon,
        description: '',
        headerMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $4335848b71c04fe0$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: true,
            parts: [
                label,
                [
                    'repository-name',
                    container?.name ?? null
                ],
                [
                    'padlock',
                    padlockIcon
                ],
                [
                    'last-modified',
                    lastModifiedComponent
                ]
            ]
        }),
        title: branchName,
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 














var $lE8sM = parcelRequire("lE8sM");








var $6R5uz = parcelRequire("6R5uz");


var $2Yaht = parcelRequire("2Yaht");

















parcelRequire("42omo");




const $49c210a2798c7447$export$10f53ee736dae147 = ({ date: date })=>{
    if (!date) return null;
    const event = new Date(date);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cgtv4.FormattedDate), {
        value: event,
        month: "short",
        day: "numeric",
        year: "numeric"
    });
};





/**
 * Returns a date and time range based on two date strings
 * @example 10-11 AM
 */ const $cdd594a9fdd53ee3$export$abc17c795ac8b09b = ({ from: from, to: to })=>{
    const fromDate = new Date(from);
    const toDate = new Date(to);
    const dateTimeFormat = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: 'numeric'
    });
    const fromDateParts = dateTimeFormat.format(fromDate);
    const toDateParts = dateTimeFormat.format(toDate);
    return `${fromDateParts} - ${toDateParts}`;
};









const $d7301b3c5f161ac3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    eventLabel: {
        id: "dynamic-cards-search-page.calendar-event-search-result.calendar-label",
        defaultMessage: "Calendar"
    },
    meetingLink: {
        id: "dynamic-cards-search-page.calendar-event-search-result.meeting-link",
        defaultMessage: "Meeting link"
    },
    joinMeetingLink: {
        id: "dynamic-cards-search-page.calendar-event-search-result.join-meeting-link",
        defaultMessage: "Join meeting"
    },
    meetingLinkIcon: {
        id: "dynamic-cards-search-page.calendar-event-search-result.meeting-link-icon",
        defaultMessage: "Join meeting"
    },
    recurringEventIcon: {
        id: "dynamic-cards-search-page.calendar-event-search-result.recurring-event-icon",
        defaultMessage: "Recurring event"
    },
    recurringMetadataLabel: {
        id: "dynamic-cards-search-page.calendar-event-search-result.recurring-event-label",
        defaultMessage: "Recurring"
    },
    upcomingEventsButton: {
        id: "dynamic-cards-search-page.calendar-event-search-result.upcoming-events-button",
        defaultMessage: "Upcoming events"
    },
    pastEventsButton: {
        id: "dynamic-cards-search-page.calendar-event-search-result.past-events-button",
        defaultMessage: "Past events"
    }
});


const $d450d753939a3362$var$RELATED_EVENTS_STATE = {
    UPCOMING: 'upcoming',
    PAST: 'past',
    CLOSED: 'closed'
};
const $d450d753939a3362$export$137e3167f558cbc3 = ({ fromDate: fromDate, toDate: toDate, meetingLink: meetingLink })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (!fromDate || !meetingLink || !toDate) return null;
    const currentDate = new Date();
    const startDate = new Date(fromDate);
    startDate.setHours(startDate.getHours() - 2); // Checks if the event is within 2 hours
    const endDate = new Date(toDate);
    const eventIsWithin2hoursOrIsOngoing = startDate < currentDate && currentDate < endDate;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7p4As.default), {
        iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))), {
                color: "var(--ds-icon-subtle)",
                label: ''
            }),
        href: meetingLink,
        children: eventIsWithin2hoursOrIsOngoing ? formatMessage((0, $d7301b3c5f161ac3$export$defe85febe8b728c).joinMeetingLink) : formatMessage((0, $d7301b3c5f161ac3$export$defe85febe8b728c).meetingLink)
    });
};
const $d450d753939a3362$var$calendarEventLinkStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    textDecoration: 'none',
    ':hover': {
        color: 'color.link',
        textDecoration: 'underline'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':visited': {
        color: 'color.link.visited'
    },
    ':visited:active': {
        color: 'color.link.visited.pressed'
    },
    display: 'flex'
});
const $d450d753939a3362$var$relatedCalendarEventMetadataStyles = (0, $ecnYn.xcss)({
    gridColumn: 2,
    alignItems: 'center'
});
const $d450d753939a3362$var$RelatedCalendarEvents = ({ calendarEvents: calendarEvents })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cwkWT.default), {
        gap: "space.200",
        children: calendarEvents.map((calendarEvent)=>{
            const { entity: entity, title: title, url: url } = calendarEvent;
            const labelMessageComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                children: formatMessage((0, $d7301b3c5f161ac3$export$defe85febe8b728c).eventLabel)
            });
            const eventDateComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $49c210a2798c7447$export$10f53ee736dae147), {
                    date: entity.eventStartTime
                })
            });
            const eventTimeComponent = entity.eventStartTime && entity.eventEndTime ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                children: (0, $cdd594a9fdd53ee3$export$abc17c795ac8b09b)({
                    from: entity.eventStartTime,
                    to: entity.eventEndTime
                })
            }) : null;
            const meetingLink = entity.videoMeetingURL ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                    xcss: $d450d753939a3362$var$calendarEventLinkStyles,
                    href: entity.videoMeetingURL,
                    children: formatMessage((0, $d7301b3c5f161ac3$export$defe85febe8b728c).meetingLink)
                })
            }) : null;
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
                templateColumns: "min-content 1fr",
                alignItems: "center",
                columnGap: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
                        size: "16",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))),
                        label: formatMessage((0, $d7301b3c5f161ac3$export$defe85febe8b728c).recurringEventIcon),
                        appearance: "blue"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                        size: "small",
                        weight: "semibold",
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                            xcss: $d450d753939a3362$var$calendarEventLinkStyles,
                            href: url,
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
                        xcss: $d450d753939a3362$var$relatedCalendarEventMetadataStyles,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4335848b71c04fe0$export$8e7fb1f8fe599124), {
                            parts: [
                                [
                                    'calendar-label',
                                    labelMessageComponent
                                ],
                                [
                                    'event-date',
                                    eventDateComponent
                                ],
                                [
                                    'event-time',
                                    eventTimeComponent
                                ],
                                [
                                    'meeting-link',
                                    meetingLink
                                ]
                            ]
                        })
                    })
                ]
            });
        })
    });
};
const $d450d753939a3362$var$calendarEventActionStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    gap: 'space.100'
});
const $d450d753939a3362$var$CalendarEventActions = ({ fromDate: fromDate, toDate: toDate, meetingLink: meetingLink, linkedEntities: linkedEntities })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [relatedEventsState, setEventsToDisplay] = (0, $42omo.useState)($d450d753939a3362$var$RELATED_EVENTS_STATE.CLOSED);
    const isUpcomingEventsSelected = relatedEventsState === $d450d753939a3362$var$RELATED_EVENTS_STATE.UPCOMING;
    const isPastEventsSelected = relatedEventsState === $d450d753939a3362$var$RELATED_EVENTS_STATE.PAST;
    const data = (0, $42omo.useMemo)(()=>{
        const currentDate = new Date();
        const linkedCalendarEvents = linkedEntities.flatMap((linkedEntity)=>linkedEntity.entity ? [
                {
                    title: linkedEntity.title,
                    url: linkedEntity.url,
                    entity: linkedEntity.entity
                }
            ] : []);
        const [pastEvents, upcomingEvents] = linkedCalendarEvents.reduce((events, currentEvent)=>{
            const isPastEvent = new Date(currentEvent.entity.eventStartTime) < currentDate;
            if (isPastEvent) return [
                events[0].concat(currentEvent),
                events[1]
            ];
            return [
                events[0],
                events[1].concat(currentEvent)
            ];
        }, [
            [],
            []
        ]);
        return {
            pastEvents: pastEvents,
            upcomingEvents: upcomingEvents
        };
    }, [
        linkedEntities
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $cwkWT.default), {
        gap: "space.200",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                xcss: $d450d753939a3362$var$calendarEventActionStyles,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($d450d753939a3362$export$137e3167f558cbc3, {
                        fromDate: fromDate,
                        toDate: toDate,
                        meetingLink: meetingLink
                    }),
                    !!data.upcomingEvents.length && /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        iconAfter: (iconProps)=>isUpcomingEventsSelected ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                ...iconProps,
                                size: "small"
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                ...iconProps,
                                size: "small"
                            }),
                        onClick: ()=>setEventsToDisplay(isUpcomingEventsSelected ? $d450d753939a3362$var$RELATED_EVENTS_STATE.CLOSED : $d450d753939a3362$var$RELATED_EVENTS_STATE.UPCOMING),
                        isSelected: isUpcomingEventsSelected,
                        children: formatMessage((0, $d7301b3c5f161ac3$export$defe85febe8b728c).upcomingEventsButton)
                    }),
                    !!data.pastEvents.length && /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                        iconAfter: (iconProps)=>isPastEventsSelected ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                                ...iconProps,
                                size: "small"
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                                ...iconProps,
                                size: "small"
                            }),
                        onClick: ()=>setEventsToDisplay(isPastEventsSelected ? $d450d753939a3362$var$RELATED_EVENTS_STATE.CLOSED : $d450d753939a3362$var$RELATED_EVENTS_STATE.PAST),
                        isSelected: isPastEventsSelected,
                        children: formatMessage((0, $d7301b3c5f161ac3$export$defe85febe8b728c).pastEventsButton)
                    })
                ]
            }),
            relatedEventsState === $d450d753939a3362$var$RELATED_EVENTS_STATE.UPCOMING && /*#__PURE__*/ (0, $l998X.jsx)($d450d753939a3362$var$RelatedCalendarEvents, {
                calendarEvents: data.upcomingEvents
            }),
            relatedEventsState === $d450d753939a3362$var$RELATED_EVENTS_STATE.PAST && /*#__PURE__*/ (0, $l998X.jsx)($d450d753939a3362$var$RelatedCalendarEvents, {
                calendarEvents: data.pastEvents
            })
        ]
    });
};
const $d450d753939a3362$export$2d6c717667f5157c = ({ partial: partial, position: position, icon: icon, product: product })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [selectedProduct] = (0, $7tL1u.useSelectedProduct)();
    const [primaryProduct] = (0, $ee6ce766a2e08634$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const { url: url, permissionLevel: permissionLevel, entity: entity, title: title, linkedEntities: linkedEntities } = partial;
    const calendarEvent = (0, $42omo.useMemo)(()=>{
        const eventTime = entity?.eventStartTime && entity?.eventEndTime ? (0, $cdd594a9fdd53ee3$export$abc17c795ac8b09b)({
            from: entity?.eventStartTime,
            to: entity?.eventEndTime
        }) : null;
        const recurringEvent = entity?.recurringEventID ? formatMessage((0, $d7301b3c5f161ac3$export$defe85febe8b728c).recurringMetadataLabel) : null;
        return {
            labelMessage: formatMessage((0, $d7301b3c5f161ac3$export$defe85febe8b728c).eventLabel),
            calendarName: entity?.parentCalendar.name ?? null,
            eventTime: eventTime,
            recurringEvent: recurringEvent
        };
    }, [
        entity,
        formatMessage
    ]);
    const eventDateComponent = /*#__PURE__*/ (0, $l998X.jsx)((0, $49c210a2798c7447$export$10f53ee736dae147), {
        date: entity?.eventStartTime
    });
    const body = /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        paddingBlockEnd: "space.100",
        children: partial.description
    });
    const padlockIcon = (0, $2c7ab0bafd629c54$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $e365deb82157152f$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $77177493924f77d4$export$a2def421b23768aa), {
        id: partial.id,
        icon: icon,
        description: body,
        headerMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $4335848b71c04fe0$export$8e7fb1f8fe599124), {
            product: product,
            productSelected: !!selectedProduct,
            parts: [
                calendarEvent.labelMessage,
                calendarEvent.calendarName,
                [
                    'event-date',
                    eventDateComponent
                ],
                [
                    'event-time',
                    calendarEvent.eventTime
                ],
                calendarEvent.recurringEvent,
                [
                    'padlock',
                    padlockIcon
                ]
            ]
        }),
        title: (0, $2c7ab0bafd629c54$export$b847312d69858d61)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        footer: /*#__PURE__*/ (0, $l998X.jsx)($d450d753939a3362$var$CalendarEventActions, {
            meetingLink: entity?.videoMeetingURL,
            fromDate: entity?.eventStartTime,
            toDate: entity?.eventEndTime,
            linkedEntities: linkedEntities ?? []
        })
    });
};





parcelRequire("42omo");



















const $e56b7cddd696ca30$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    resultLabel: {
        id: "dynamic-cards-search-page.github-commit-result.label",
        defaultMessage: "Commit"
    }
});


const $7f96d82f37671190$export$35c708bc36dbd879 = ({ partial: partial, position: position, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [primaryProduct] = (0, $ee6ce766a2e08634$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt, entity: entity } = partial;
    const { author: author, container: container } = entity || {};
    const label = formatMessage((0, $e56b7cddd696ca30$export$defe85febe8b728c).resultLabel);
    const integrationKey = (0, $2c7ab0bafd629c54$export$fb63ba58603395b8)(partial.integrationId);
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $13cc6c7031bc6442$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const padlockIcon = (0, $2c7ab0bafd629c54$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $e365deb82157152f$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    let messageDescription;
    if (author?.user) messageDescription = /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.025",
        alignBlock: "start",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $83d9190d7d9f86c9$export$e2255cf6045e8d47), {
                name: author.user.name
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: (0, $2c7ab0bafd629c54$export$16c2ab98757b54d6)(excerpt, true, `${author.user.name}: `)
            })
        ]
    });
    else messageDescription = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        children: (0, $2c7ab0bafd629c54$export$16c2ab98757b54d6)(excerpt, true)
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $77177493924f77d4$export$a2def421b23768aa), {
        id: partial.id,
        icon: icon,
        description: messageDescription,
        headerMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $4335848b71c04fe0$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: true,
            parts: [
                label,
                [
                    'repository-name',
                    container?.name ?? null
                ],
                [
                    'padlock',
                    padlockIcon
                ],
                [
                    'last-modified',
                    lastModifiedComponent
                ]
            ]
        }),
        title: (0, $2c7ab0bafd629c54$export$b847312d69858d61)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};





parcelRequire("42omo");






/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $e6pbP = parcelRequire("e6pbP");




function $23d0e53a1e16ce35$export$7e4bcd4afb389edb(markdown) {
    if (!markdown) return ''; // Handle the case where markdown is null or undefined
    // Convert headers to plain text
    markdown = markdown.replace(/^#+\s*(.+?)\s*$/gm, '$1');
    // Convert bold and italic text to plain text
    markdown = markdown.replace(/\*\*(.+?)\*\*/g, '$1');
    markdown = markdown.replace(/__(.+?)__/g, '$1');
    markdown = markdown.replace(/\*(.+?)\*/g, '$1');
    markdown = markdown.replace(/_(.+?)_/g, '$1');
    // Convert strikethrough text to plain text
    markdown = markdown.replace(/~~(.+?)~~/g, '$1');
    // Convert inline code to plain text
    markdown = markdown.replace(/`(.+?)`/g, '$1');
    // Remove code blocks
    markdown = markdown.replace(/```[\s\S]*?/g, '');
    // Convert links to plain text by keeping only the link text
    markdown = markdown.replace(/\[(.+?)\]\((.+?)\)/g, '$1');
    // Convert autolinks to plain text
    markdown = markdown.replace(/<(?![@#]|!.*>)([^>|\s]+)>/g, '$1');
    // Handle autolinks with display text, like <http://example.com|example.com>
    markdown = markdown.replace(/<([^|>]+)\|([^>]+)>/g, '$2');
    // Fix broken autolinks
    markdown = markdown.replace(/<(?![@#]|!.*>)([^>|\s]+)>?/g, '$1');
    // Remove images, keeping only the alt text
    markdown = markdown.replace(/!\[(.+?)\]\((.+?)\)/g, '$1');
    // Remove blockquotes, preserving the quoted text
    markdown = markdown.replace(/^\s*>\s+(.+?)\s*$/gm, '$1');
    // Preserve list items as plain text, removing the list markers
    markdown = markdown.replace(/^\s*[\*\+-]\s+(.+?)\s*$/gm, '$1');
    markdown = markdown.replace(/^\s*\d+\.\s+(.+?)\s*$/gm, '$1');
    // Remove horizontal lines
    markdown = markdown.replace(/^\s*[-*_]{3,}\s*$/gm, '');
    // Replace multiple newlines with a single newline
    markdown = markdown.replace(/\n\s*\n/g, '\n');
    return markdown.trim();
}


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




const $3dd4f0622154c2fd$var$SPACE = ' ';
const $3dd4f0622154c2fd$var$channelStyle = null;
const $3dd4f0622154c2fd$export$cfdacaa37f9b4dd7 = ({ children: children, associations: associations })=>{
    const channelId = children?.[0];
    const channelAssociation = associations?.filter((edge)=>edge?.node?.entity?.__typename === 'ExternalConversation').find((edge)=>Boolean(channelId) && channelId === edge.node.entity.channelId);
    if (!channelAssociation) return null;
    const entity = channelAssociation?.node?.entity;
    return /*#__PURE__*/ (0, $l998X.jsxs)("span", {
        className: (0, $gMc0m.default)([
            "_o5721q9c"
        ]),
        children: [
            $3dd4f0622154c2fd$var$SPACE,
            "#",
            entity?.displayName || channelAssociation?.node?.title
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");







const $039797a4bced6ed0$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    externalPersonLabel: {
        id: "search-result.user-mention.external-person",
        defaultMessage: "External person"
    }
});


const $cc3c8c36803e7ae7$var$SPACE = ' ';
const $cc3c8c36803e7ae7$export$e891316fea657d90 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("span", {
        children: [
            $cc3c8c36803e7ae7$var$SPACE,
            "@",
            children
        ]
    });
};
const $cc3c8c36803e7ae7$export$85d6e42a90e882cb = ({ children: children, associations: associations })=>{
    const channelId = children?.[0];
    const userAssociation = associations?.find((edge)=>Boolean(channelId) && channelId === edge?.node?.entity?.externalId);
    const name = userAssociation?.node?.entity?.name || /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...(0, $039797a4bced6ed0$export$defe85febe8b728c).externalPersonLabel
    });
    if (!name) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)($cc3c8c36803e7ae7$export$e891316fea657d90, {
        children: name
    });
};


/**
 * The whitespace in between aliases <!here> <!channel> is removed
 * This constant prevent the alias from being pushed together ex: "@here@channel"
 * We are using this constant rather than adding a space through CSS because it adds
 * a real space character that does not break up the text when selecting.
 * */ const $961d94431ab2c118$var$SPACE = ' ';
const $961d94431ab2c118$export$95e34c5d2bf14b09 = (inputString)=>{
    if (!inputString) return '';
    return (0, $23d0e53a1e16ce35$export$7e4bcd4afb389edb)(inputString)//Slack User
    .replace(/<@(\w+)>/g, '<Mention>$1</Mention>')//Teams User
    .replace(/<@([a-zA-Z0-9-]+)>/g, '<Mention>$1</Mention>')//Slack Channel
    .replace(/<#(\w+)\|?>/g, '<Channel>$1</Channel>')//Teams Channel variation 1
    .replace(/<#teamId\/[a-f0-9-]+\/channelId\/teamId\/([a-f0-9-]+)\/channelId\/([0-9a-zA-Z:@._-]+)>/g, '<Channel>teamId/$1/channelId/$2</Channel>')// Teams Channel variation 2
    .replace(/<[@#]teamId\/([a-f0-9-]+)\/channelId\/([0-9a-zA-Z:@._-]+)>/g, '<Channel>teamId/$1/channelId/$2</Channel>').replace(/<\!subteam\^(\w+)>/g, '<Subteam>$1</Subteam>').replace(/<\!(\w+)>/g, '<Alias>$1</Alias>')// emojis, works for those that have repeating pattern as well. eg: :word-word-word:
    .replace(/:((@@@hl@@@.+?@@@endhl@@@)(-@@@hl@@@.+?@@@endhl@@@)*):/g, (match)=>{
        const words = match.match(/@@@hl@@@(.+?)@@@endhl@@@/g)?.map((m)=>m.replace(/@@@hl@@@|@@@endhl@@@/g, '')) || [];
        return `<Highlight>:${words.join('-')}:</Highlight>`;
    }).replace(/@@@hl@@@(.+?)@@@endhl@@@/g, '<Highlight>$1</Highlight>').replace(/<@<Highlight>(.+?)<\/Highlight>>/g, '<Highlight><Mention>$1</Mention></Highlight>').replace(/<#<Highlight>(.+?)<\/Highlight>\|>/g, '<Highlight><Channel>$1</Channel></Highlight>');
// .replace(/\:(\w+)\:/g, '<Emoji>$1</Emoji>') Support for emojis coming soon
};
const $961d94431ab2c118$var$PlainText = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
const $961d94431ab2c118$var$Highlight = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
        as: "strong",
        children: [
            $961d94431ab2c118$var$SPACE,
            children
        ]
    });
const $961d94431ab2c118$export$bf780c85e04b8810 = (excerpt, description)=>{
    if (excerpt.length === 0 || description.length === 0 || excerpt === description) return excerpt;
    var modifiedExcerpt = excerpt;
    // regex which has the starting tag of a mention, but not the end
    const startTagRegex = /<[@#][^> ]*$/g;
    const startTagMatch = modifiedExcerpt.match(startTagRegex);
    if (startTagMatch) {
        // theoretically, there should only be one match at max
        const partialMention = startTagMatch[startTagMatch.length - 1];
        // the partialMention can appear several times in the string. We need to find the correct one
        const partialMentionInExcerptCount = excerpt.split(partialMention).length - 1;
        const splitDescription = description.split(partialMention);
        // check if partial mention is found in description
        if (splitDescription.length >= 2) {
            const splitByClosingTag = splitDescription[partialMentionInExcerptCount].split('>');
            // check if closing tag is found
            if (splitByClosingTag.length >= 2) {
                const restOfString = splitByClosingTag[0];
                modifiedExcerpt = modifiedExcerpt + restOfString + '>';
            }
        }
    }
    // const endTagRegex = /^[^< ]*\.tacv2>/g; This works on channel mentions that I have observed
    // weaker regex which tries to capture the ending tag of a mention (assuming it always ends with >), but not the start
    const weakEndTagRegex = /^[^< ]*>/g;
    const weakEndTagMatch = modifiedExcerpt.match(weakEndTagRegex);
    if (weakEndTagMatch) {
        // theoretically, there should only be one match at max
        const partialMention = weakEndTagMatch[0];
        const splitDescription = description.split(partialMention);
        // partialMention not found in description
        if (splitDescription.length >= 2) {
            const splitByOpeningTag = splitDescription[0].split('<');
            // opening tag found
            if (splitByOpeningTag.length >= 2) {
                const restOfString = splitByOpeningTag[splitByOpeningTag.length - 1];
                modifiedExcerpt = '<' + restOfString + modifiedExcerpt;
            }
        }
    }
    return modifiedExcerpt;
};
const $961d94431ab2c118$export$36e783c4ff07cd7c = ({ partial: partial })=>{
    // in ConversationSearchResult, partial.excerpt is used as the body
    if (partial.excerpt) partial.excerpt = $961d94431ab2c118$export$bf780c85e04b8810(partial.excerpt, partial?.entity?.description ?? '');
    const body = partial.excerpt || partial?.entity?.description || '';
    /**
   * Event hough we remove markdown from the body, we still use this component
   * to render mentions and highlighted text */ return /*#__PURE__*/ (0, $l998X.jsx)((0, $e6pbP.default), {
        options: {
            forceInline: true,
            overrides: {
                a: $961d94431ab2c118$var$PlainText,
                Highlight: $961d94431ab2c118$var$Highlight,
                Alias: (0, $cc3c8c36803e7ae7$export$e891316fea657d90),
                Mention: {
                    component: (0, $cc3c8c36803e7ae7$export$85d6e42a90e882cb),
                    props: {
                        associations: partial?.entity?.associatedWith?.edges
                    }
                },
                Channel: {
                    component: (0, $3dd4f0622154c2fd$export$cfdacaa37f9b4dd7),
                    props: {
                        associations: partial?.entity?.associatedWith?.edges
                    }
                }
            }
        },
        children: $961d94431ab2c118$export$95e34c5d2bf14b09(body)
    });
};








const $1b3ad8f91db97134$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    label: {
        id: "search-page.results.product-results.third-party.conversation-search-result.label",
        defaultMessage: "Channel"
    },
    memberCount: {
        id: "search-page.results.product-results.third-party.conversation-search-result.member-count",
        defaultMessage: "{count, plural, one {# member} other {# members}}"
    },
    lastActive: {
        id: "search-page.results.product-results.third-party.conversation-search-result.time-since-label",
        defaultMessage: "Last active {formattedDate}"
    },
    unknownChannel: {
        id: "search-page.results.product-results.third-party.conversation-search-result.unknown-channel",
        defaultMessage: "unknown-channel"
    }
});


const $243382b913ac38cc$export$4534f971846d5b0b = ({ partial: partial, icon: icon, position: position, integrationKey: integrationKey, cloudId: cloudId })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { entity: entity, url: url } = partial;
    const [primaryProduct] = (0, $ee6ce766a2e08634$export$92c6f3c7c09f3247)();
    const memberCount = entity?.memberCount || entity?.members?.length;
    const parts = [
        [
            'label',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $1b3ad8f91db97134$export$a7357cdd1f0b0168).label
            })
        ],
        [
            'memberCount',
            memberCount && /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $1b3ad8f91db97134$export$a7357cdd1f0b0168).memberCount,
                values: {
                    count: memberCount
                }
            })
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $77177493924f77d4$export$a2def421b23768aa), {
        id: partial.id,
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $961d94431ab2c118$export$36e783c4ff07cd7c), {
            partial: partial
        }),
        icon: icon,
        headerMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $4335848b71c04fe0$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: true,
            parts: parts
        }),
        title: `#${entity?.displayName || formatMessage((0, $1b3ad8f91db97134$export$a7357cdd1f0b0168).unknownChannel)}`,
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};





parcelRequire("42omo");










parcelRequire("42omo");




















const $b163e6b04e119490$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    restrictedLabel: {
        id: "search-page.results.restricted-result-label",
        defaultMessage: "Restricted"
    },
    restrictedTooltip: {
        id: "search-page.results.restricted-result-tooltip",
        defaultMessage: "Only visible to specific people"
    },
    privateLabel: {
        id: "search-page.results.private-result-label",
        defaultMessage: "Private"
    },
    privateTooltip: {
        id: "search-page.results.private-result-tooltip",
        defaultMessage: "Only visible to you"
    }
});


const $f7d93f1ad4e1b432$var$container = (0, $ecnYn.xcss)({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'space.050',
    backgroundColor: 'color.background.neutral',
    paddingLeft: 'space.100',
    paddingRight: 'space.150',
    // different to paddingLeft for visual balance
    paddingTop: 'space.025',
    paddingBottom: 'space.025',
    borderRadius: 'radius.small',
    cursor: 'default' // so that it doesn't change to the text-selecting looking one
});
const $f7d93f1ad4e1b432$var$iconColor = "var(--ds-icon, #292A2E)";
const $f7d93f1ad4e1b432$export$3aad690c5eb10b93 = 'restricted-lozenge';
const $f7d93f1ad4e1b432$export$3eac322cb0b365da = ({ restriction: restriction })=>{
    const label = restriction === 'private' ? (0, $b163e6b04e119490$export$defe85febe8b728c).privateLabel : (0, $b163e6b04e119490$export$defe85febe8b728c).restrictedLabel;
    const tooltipText = restriction === 'private' ? (0, $b163e6b04e119490$export$defe85febe8b728c).privateTooltip : (0, $b163e6b04e119490$export$defe85febe8b728c).restrictedTooltip;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
            ...tooltipText
        }),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
            xcss: $f7d93f1ad4e1b432$var$container,
            testId: $f7d93f1ad4e1b432$export$3aad690c5eb10b93,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
                    label: "",
                    color: $f7d93f1ad4e1b432$var$iconColor,
                    size: "small"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                    color: "color.text",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...label
                    })
                })
            ]
        })
    });
};






const $a8ce7ac5600239f3$var$footerContainer = (0, $ecnYn.xcss)({
    paddingTop: 'space.100'
});
const $a8ce7ac5600239f3$var$typeLabelContainer = (0, $ecnYn.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $a8ce7ac5600239f3$var$getLabel = (entityNoun)=>entityNoun.replace(/-/g, ' ');
const $a8ce7ac5600239f3$export$2917a391c04f0e93 = ({ icon: icon, partial: partial, position: position, resultAri: resultAri, integrationKey: integrationKey })=>{
    const [primaryProduct] = (0, $ee6ce766a2e08634$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt } = partial;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $13cc6c7031bc6442$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const label = $a8ce7ac5600239f3$var$getLabel(resultAri.resourceType);
    const isNotPublic = (0, $2c7ab0bafd629c54$export$f2f9c8e083d34d6b)(permissionLevel);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $77177493924f77d4$export$a2def421b23768aa), {
        id: partial.id,
        description: (0, $2c7ab0bafd629c54$export$16c2ab98757b54d6)(excerpt),
        icon: icon,
        headerMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $4335848b71c04fe0$export$8e7fb1f8fe599124), {
            productSelected: true,
            product: integrationKey,
            parts: [
                [
                    'label',
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        xcss: $a8ce7ac5600239f3$var$typeLabelContainer,
                        children: label
                    })
                ],
                [
                    'last-modified',
                    lastModifiedComponent
                ]
            ]
        }),
        footer: isNotPublic && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $a8ce7ac5600239f3$var$footerContainer,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f7d93f1ad4e1b432$export$3eac322cb0b365da), {
                restriction: permissionLevel
            })
        }),
        title: (0, $2c7ab0bafd629c54$export$b847312d69858d61)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");

























const $b96449350b028f01$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    designLabel: {
        id: "dynamic-cards-search-page.design-search-result.label",
        defaultMessage: "Design"
    }
});


const $134dafd6c25dd068$var$thumbnailContainerStyles = (0, $ecnYn.xcss)({
    gridArea: 'body'
});
const $134dafd6c25dd068$var$thumbnailImageStyles = null;
const $134dafd6c25dd068$var$descriptionLinkStyles = (0, $ecnYn.xcss)({
    display: 'inline-block'
});
const $134dafd6c25dd068$export$f6a73210de3b9a3b = ({ partial: partial, position: position, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [selectedProduct] = (0, $7tL1u.useSelectedProduct)();
    const [primaryProduct] = (0, $ee6ce766a2e08634$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const integrationKey = (0, $2c7ab0bafd629c54$export$fb63ba58603395b8)(partial.integrationId);
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity, title: title } = partial;
    const thumbnailUrl = entity?.thumbnail?.externalUrl;
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $13cc6c7031bc6442$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const label = formatMessage((0, $b96449350b028f01$export$defe85febe8b728c).designLabel);
    const body = !thumbnailUrl || (0, $2c7ab0bafd629c54$export$c32a8291d21fb086)(thumbnailUrl) ? null : /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
        xcss: [
            $134dafd6c25dd068$var$descriptionLinkStyles
        ],
        rel: 'noreferrer',
        target: '_blank',
        href: url,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            testId: "thumbnail-container",
            xcss: $134dafd6c25dd068$var$thumbnailContainerStyles,
            children: /*#__PURE__*/ (0, $l998X.jsx)("img", {
                src: thumbnailUrl,
                alt: "",
                className: (0, $gMc0m.default)([
                    "_2rko1qi0 _189e1dm9 _1dqonqa1 _1h6d1gmx _5ral1dfr _4t3i1et3 _1bsb194s"
                ])
            })
        })
    });
    const padlockIcon = (0, $2c7ab0bafd629c54$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $e365deb82157152f$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $77177493924f77d4$export$a2def421b23768aa), {
        id: partial.id,
        icon: icon,
        description: body,
        headerMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $4335848b71c04fe0$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: !!selectedProduct,
            parts: [
                label,
                [
                    'last-modified',
                    lastModifiedComponent
                ],
                [
                    'padlock',
                    padlockIcon
                ]
            ]
        }),
        title: (0, $2c7ab0bafd629c54$export$b847312d69858d61)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




























const $e9d0a8d04b005fc2$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    googleDocsLabel: {
        id: "dynamic-cards-search-page.document-search-result.google-docs-label",
        defaultMessage: "Docs"
    },
    googleSlidesLabel: {
        id: "dynamic-cards-search-page.document-search-result.google-slides-label",
        defaultMessage: "Slides"
    },
    googleSheetsLabel: {
        id: "dynamic-cards-search-page.document-search-result.google-sheets-label",
        defaultMessage: "Sheets"
    },
    msWordLabel: {
        id: "dynamic-cards-search-page.document-search-result.ms-word-label",
        defaultMessage: "Word"
    },
    msPowerpointLabel: {
        id: "dynamic-cards-search-page.document-search-result.ms-powerpoint-label",
        defaultMessage: "PowerPoint"
    },
    msExcelLabel: {
        id: "dynamic-cards-search-page.document-search-result.ms-excel-label",
        defaultMessage: "Excel"
    }
});


const $0017009db6afe170$var$footerContainer = (0, $ecnYn.xcss)({
    paddingTop: 'space.100'
});
const $0017009db6afe170$var$contentIconStyles = null;
const $0017009db6afe170$var$outerContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: 'size.100',
    maxWidth: '246px' // Specified in the design
});
const $0017009db6afe170$var$parentNameStyles = (0, $ecnYn.xcss)({
    display: 'inline-block',
    overflow: 'hidden',
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtle',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $0017009db6afe170$var$typeLabelContainer = (0, $ecnYn.xcss)({
    '::first-letter': {
        textTransform: 'capitalize'
    }
});
const $0017009db6afe170$var$GOOGLE_INTEGRATION_KEY = 'google';
const $0017009db6afe170$var$MICROSOFT_INTEGRATION_KEY = 'microsoft';
const $0017009db6afe170$var$SUBTYPE_DOCUMENT = 'document';
const $0017009db6afe170$var$SUBTYPE_PRESENTATION = 'presentation';
const $0017009db6afe170$var$SUBTYPE_SPREADSHEET = 'spreadsheet';
const $0017009db6afe170$var$GOOGLE_LABELS = {
    [$0017009db6afe170$var$SUBTYPE_DOCUMENT]: (0, $e9d0a8d04b005fc2$export$defe85febe8b728c).googleDocsLabel,
    [$0017009db6afe170$var$SUBTYPE_PRESENTATION]: (0, $e9d0a8d04b005fc2$export$defe85febe8b728c).googleSlidesLabel,
    [$0017009db6afe170$var$SUBTYPE_SPREADSHEET]: (0, $e9d0a8d04b005fc2$export$defe85febe8b728c).googleSheetsLabel
};
const $0017009db6afe170$var$MICROSOFT_LABELS = {
    [$0017009db6afe170$var$SUBTYPE_DOCUMENT]: (0, $e9d0a8d04b005fc2$export$defe85febe8b728c).msWordLabel,
    [$0017009db6afe170$var$SUBTYPE_PRESENTATION]: (0, $e9d0a8d04b005fc2$export$defe85febe8b728c).msPowerpointLabel,
    [$0017009db6afe170$var$SUBTYPE_SPREADSHEET]: (0, $e9d0a8d04b005fc2$export$defe85febe8b728c).msExcelLabel
};
const $0017009db6afe170$var$getDocumentSubtypeLabel = ({ integrationKey: integrationKey, subtype: subtype })=>{
    if (!subtype) return;
    let label;
    if (integrationKey === $0017009db6afe170$var$GOOGLE_INTEGRATION_KEY) label = $0017009db6afe170$var$GOOGLE_LABELS[subtype];
    if (integrationKey === $0017009db6afe170$var$MICROSOFT_INTEGRATION_KEY) label = $0017009db6afe170$var$MICROSOFT_LABELS[subtype];
    return label;
};
const $0017009db6afe170$var$getParentName = (partial)=>{
    const parentName = partial.entity?.parent?.displayName;
    if (!parentName) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
        xcss: $0017009db6afe170$var$outerContainerStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
            xcss: $0017009db6afe170$var$parentNameStyles,
            children: parentName
        })
    });
};
const $0017009db6afe170$export$43fa1bdcdc4d31ed = ({ icon: icon, partial: partial, position: position, resultAri: resultAri, integrationKey: integrationKey })=>{
    const [primaryProduct] = (0, $ee6ce766a2e08634$export$92c6f3c7c09f3247)();
    const [selectedProduct] = (0, $7tL1u.useSelectedProduct)();
    const [{ cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt, subtype: subtype, entity: entity } = partial;
    const contentIcon = entity?.type?.iconUrl ? /*#__PURE__*/ (0, $l998X.jsx)("img", {
        src: entity.type.iconUrl,
        alt: "",
        className: (0, $gMc0m.default)([
            "_1bsbxy5q _4t3ixy5q _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _vchhusvi _5ral1f51"
        ])
    }) : icon;
    const product = integrationKey;
    const label = $0017009db6afe170$var$getDocumentSubtypeLabel({
        integrationKey: integrationKey,
        subtype: subtype
    });
    const isNotPublic = (0, $2c7ab0bafd629c54$export$f2f9c8e083d34d6b)(permissionLevel);
    const shouldShowLastModified = lastModifiedDate && integrationKey !== 'atlassian-web-crawler';
    const metadataParts = [
        [
            'label',
            label ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $0017009db6afe170$var$typeLabelContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...label
                })
            }) : subtype ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $0017009db6afe170$var$typeLabelContainer,
                children: subtype?.replace(/-/g, ' ')
            }) : null
        ],
        [
            'parentName',
            $0017009db6afe170$var$getParentName(partial)
        ],
        [
            'lastModified',
            shouldShowLastModified && /*#__PURE__*/ (0, $l998X.jsx)((0, $13cc6c7031bc6442$export$e6747eee8f26f8c0), {
                lastModified: lastModifiedDate
            })
        ]
    ];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $77177493924f77d4$export$a2def421b23768aa), {
        id: partial.id,
        description: (0, $2c7ab0bafd629c54$export$16c2ab98757b54d6)(excerpt),
        icon: contentIcon,
        headerMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $4335848b71c04fe0$export$8e7fb1f8fe599124), {
            product: product,
            productSelected: !!selectedProduct,
            parts: metadataParts
        }),
        footer: isNotPublic && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $0017009db6afe170$var$footerContainer,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f7d93f1ad4e1b432$export$3eac322cb0b365da), {
                restriction: permissionLevel
            })
        }),
        title: (0, $2c7ab0bafd629c54$export$b847312d69858d61)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial,
        showAISummary: (0, $af8fO.isGoogleDocument)(partial) && isAdminHubAIEnabled
    });
};





parcelRequire("42omo");






























var $9lz2c = parcelRequire("9lz2c");


var $e3TOY = parcelRequire("e3TOY");








var $fZtQj = parcelRequire("fZtQj");
























const $66341fc5175a42fe$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    attachedDateLabel: {
        id: "dynamic-cards-search-page.search-result.attachments.attached-date.label",
        defaultMessage: "Attached {formattedDate}"
    },
    expandLabel: {
        id: "dynamic-cards-search-page.search-result.attachments.expand.label",
        defaultMessage: "Expand"
    },
    attachmentLabel: {
        id: "dynamic-cards-search-page.search-result.attachment-label",
        defaultMessage: "Attachment"
    },
    pdfLabel: {
        id: "dynamic-cards-search-page.search-result.attachments.pdf-label",
        defaultMessage: "PDF"
    },
    videoLabel: {
        id: "dynamic-cards-search-page.search-result.attachments.video-label",
        defaultMessage: "Video"
    },
    imageLabel: {
        id: "dynamic-cards-search-page.search-result.attachments.image-label",
        defaultMessage: "Image"
    },
    audioLabel: {
        id: "dynamic-cards-search-page.search-result.attachments.audio-label",
        defaultMessage: "Audio"
    }
});


const $48fbcdb8decb2909$var$footerContainer = (0, $ecnYn.xcss)({
    paddingTop: 'space.100',
    position: 'relative'
});
const $48fbcdb8decb2909$var$dropdownItemStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    columnGap: 'space.100',
    paddingBlock: 'space.050',
    marginTop: 'space.100'
});
const $48fbcdb8decb2909$var$attachmentStyles = (0, $ecnYn.xcss)({
    color: 'color.link',
    textDecoration: 'none',
    ':hover': {
        color: 'color.link',
        textDecoration: 'underline'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':visited': {
        color: 'color.link.visited'
    },
    ':visited:active': {
        color: 'color.link.visited.pressed'
    }
});
const $48fbcdb8decb2909$var$mimeTypeToIcon = (mimeType)=>{
    if (!mimeType) return 0, (/*@__PURE__*/$parcel$interopDefault($9lz2c));
    const [type, specificType] = mimeType.split('/');
    if (specificType === 'pdf') return 0, (/*@__PURE__*/$parcel$interopDefault($8jHAi));
    switch(type){
        case 'video':
            return 0, (/*@__PURE__*/$parcel$interopDefault($2Yaht));
        case 'image':
            return 0, (/*@__PURE__*/$parcel$interopDefault($fZtQj));
        case 'audio':
            return 0, (/*@__PURE__*/$parcel$interopDefault($e3TOY));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($9lz2c));
    }
};
const $48fbcdb8decb2909$var$mimeTypeToLabel = (mimeType)=>{
    if (!mimeType) return (0, $66341fc5175a42fe$export$a7357cdd1f0b0168).attachmentLabel;
    const [type, specificType] = mimeType.split('/');
    if (specificType === 'pdf') return (0, $66341fc5175a42fe$export$a7357cdd1f0b0168).pdfLabel;
    switch(type){
        case 'video':
            return (0, $66341fc5175a42fe$export$a7357cdd1f0b0168).videoLabel;
        case 'image':
            return (0, $66341fc5175a42fe$export$a7357cdd1f0b0168).imageLabel;
        case 'audio':
            return (0, $66341fc5175a42fe$export$a7357cdd1f0b0168).audioLabel;
        default:
            return (0, $66341fc5175a42fe$export$a7357cdd1f0b0168).attachmentLabel;
    }
};
const $48fbcdb8decb2909$var$DropdownItems = ({ attachments: attachments, message: message })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        children: attachments.map(({ title: title, mimeType: mimeType, thumbnailUrl: thumbnailUrl })=>{
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                xcss: $48fbcdb8decb2909$var$dropdownItemStyles,
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                        alignBlock: "center",
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
                                size: "16",
                                icon: $48fbcdb8decb2909$var$mimeTypeToIcon(mimeType),
                                label: "icon",
                                appearance: "blue"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                size: "medium",
                                color: "color.link",
                                weight: "medium",
                                children: thumbnailUrl ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fpGTa.default), {
                                    xcss: $48fbcdb8decb2909$var$attachmentStyles,
                                    href: thumbnailUrl,
                                    rel: 'noreferrer',
                                    target: "_blank",
                                    children: title
                                }) : title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                        separator: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                            size: "small",
                            children: "\u2022"
                        }),
                        space: "space.075",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                size: "small",
                                children: formatMessage($48fbcdb8decb2909$var$mimeTypeToLabel(mimeType))
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                size: "small",
                                color: "color.text.subtle",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $13cc6c7031bc6442$export$e6747eee8f26f8c0), {
                                    lastModified: message.lastModifiedDate,
                                    message: (0, $66341fc5175a42fe$export$a7357cdd1f0b0168).attachedDateLabel
                                })
                            })
                        ]
                    })
                ]
            });
        })
    });
};
const $48fbcdb8decb2909$var$DropdownMenu = ({ attachments: attachments, message: message })=>{
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const attachmentWord = `attachment${attachments.length > 1 ? 's' : ''}`;
    const dropdownMessage = `${attachments.length} ${attachmentWord}`;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                iconAfter: isExpanded ? ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        color: "currentColor",
                        label: formatMessage((0, $66341fc5175a42fe$export$a7357cdd1f0b0168).expandLabel),
                        size: "small"
                    }) : ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                        color: "currentColor",
                        label: formatMessage((0, $66341fc5175a42fe$export$a7357cdd1f0b0168).expandLabel),
                        size: "small"
                    }),
                onClick: ()=>setIsExpanded(!isExpanded),
                isSelected: isExpanded,
                children: dropdownMessage
            }),
            isExpanded && /*#__PURE__*/ (0, $l998X.jsx)($48fbcdb8decb2909$var$DropdownItems, {
                attachments: attachments,
                message: message
            })
        ]
    });
};
const $48fbcdb8decb2909$export$c129802f229d9594 = ({ attachments: attachments, message: message })=>{
    if (!attachments || attachments.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $48fbcdb8decb2909$var$footerContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)($48fbcdb8decb2909$var$DropdownMenu, {
            attachments: attachments,
            message: message
        })
    });
};





const $38b099f59c75b3a5$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    threadTypeLabel: {
        id: "dynamic-cards-search-page.search-result.thread-type-label",
        defaultMessage: "Thread"
    },
    messageTypeLabel: {
        id: "dynamic-cards-search-page.search-result.message-type-label",
        defaultMessage: "Message"
    },
    lastActive: {
        id: "dynamic-cards-search-page.search-result.message-last-active",
        defaultMessage: "Last active {formattedDate}"
    },
    attachedDateLabel: {
        id: "dynamic-cards-search-page.search-result.attachments.attached-date.label",
        defaultMessage: "Attached {formattedDate}"
    },
    privateChannelLabel: {
        id: "dynamic-cards-search-page.search-result.private-channel-label",
        defaultMessage: "Private Channel"
    }
});





parcelRequire("42omo");

















const $4187792eade7086e$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    externalPersonLabel: {
        id: "dynamic-cards-search-page.externalPersonLabel",
        defaultMessage: "External person"
    }
});


const $3b473daa079152ab$var$threadItemCSS = (0, $ecnYn.xcss)({
    paddingBottom: 'space.050',
    paddingTop: 'space.050'
});
const $3b473daa079152ab$var$nameContainer = (0, $ecnYn.xcss)({
    whiteSpace: 'nowrap'
});
const $3b473daa079152ab$export$39a3a4657e687b88 = ({ partial: partial, components: components })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const linkedEntities = partial?.linkedEntities || [];
    const { Body: Body } = components;
    const threadMessages = [
        partial,
        ...linkedEntities
    ].slice(0, 3).map((linkedMessage)=>{
        const currentMessageOwnerName = linkedMessage?.entity?.createdBy?.thirdPartyUser?.name || formatMessage((0, $4187792eade7086e$export$a7357cdd1f0b0168).externalPersonLabel);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $3b473daa079152ab$var$threadItemCSS,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                space: "space.025",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $83d9190d7d9f86c9$export$e2255cf6045e8d47), {
                        name: currentMessageOwnerName
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                        xcss: $3b473daa079152ab$var$nameContainer,
                        children: [
                            currentMessageOwnerName,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                        maxLines: 1,
                        children: /*#__PURE__*/ (0, $l998X.jsx)(Body, {
                            partial: linkedMessage
                        })
                    })
                ]
            }, linkedMessage.id)
        });
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: threadMessages
    });
};





parcelRequire("42omo");









const $a11a2256cba9533b$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    threadTitleWithOthers: {
        id: "dynamic-cards-search-page.search-result.thread-title-wth-others",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules, @atlassian/i18n/no-multiple-whitespaces
        defaultMessage: "\n\t\t\t{contributorCount, plural,\n\t\t\t\t=0 {}\n\t\t\t\t=1 {{name1} in }\n\t\t\t\t=2 {{name1} and {name2} in }\n\t\t\t\t=3 {{name1}, {name2}, and {name3} in }\n\t\t\t\t=4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other in }\n\t\t\t\tother {{name1}, {name2}, {name3}, and {overflowContributorCount} others in }\n\t\t\t}#{channelName}\n\t\t\t"
    },
    groupChatTitle: {
        id: "dynamic-cards-search-page.search-result.thread-title-wth-others",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules, @atlassian/i18n/no-multiple-whitespaces
        defaultMessage: "\n\t\t\t{contributorCount, plural,\n\t\t\t\t=0 {Group message with external users}\n\t\t\t\t=1 {{name1}}\n\t\t\t\t=2 {{name1} and {name2}}\n\t\t\t\t=3 {{name1}, {name2}, and {name3}}\n\t\t\t\t=4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other}\n\t\t\t\tother {{name1}, {name2}, {name3}, and {overflowContributorCount} others}\n\t\t\t}\n\t\t\t"
    },
    externalPeopleLabel: {
        id: "dynamic-cards-search-page.externalPeopleLabel",
        defaultMessage: "External people #{channelName}"
    },
    externalPersonLabel: {
        id: "dynamic-cards-search-page.externalPersonLabel",
        defaultMessage: "External person"
    },
    unknownChannel: {
        id: "dynamic-cards-search-page.search-result.unknown-channel-in-thread",
        defaultMessage: "unknown-channel"
    }
});


const $3b70a3d2013f6b6e$var$USER_DISPLAY_LIMIT = 3;
const $3b70a3d2013f6b6e$var$dedupUsers = (userMap, user, index)=>{
    if (!userMap[user.id]) userMap[user.id] = {
        thirdPartyUser: user,
        index: index
    };
    return userMap;
};
const $3b70a3d2013f6b6e$var$getTitleMessageValues = (users = [], intl)=>{
    const { formatMessage: formatMessage } = intl;
    const uniqueUsers = users?.filter((thirdPartyUser)=>Boolean(thirdPartyUser?.name))?.reduce($3b70a3d2013f6b6e$var$dedupUsers, {});
    const validContributors = Object.values(uniqueUsers).sort((a, b)=>a.index - b.index).map((entry)=>entry?.thirdPartyUser?.name || formatMessage((0, $a11a2256cba9533b$export$a7357cdd1f0b0168).externalPersonLabel)).map((name)=>name?.split(' ')[0]);
    const externalPersonLabel = formatMessage((0, $a11a2256cba9533b$export$a7357cdd1f0b0168).externalPersonLabel);
    const externalPersonCount = validContributors.filter((name)=>name === externalPersonLabel).length;
    let adjustedContributors = validContributors;
    if (externalPersonCount > 1) {
        adjustedContributors = validContributors.filter((name)=>name !== externalPersonLabel);
        adjustedContributors.unshift(formatMessage((0, $a11a2256cba9533b$export$a7357cdd1f0b0168).externalPeopleLabel));
    }
    const contributorCount = adjustedContributors.length;
    const namedContributors = adjustedContributors.slice(0, $3b70a3d2013f6b6e$var$USER_DISPLAY_LIMIT);
    const overflowContributorCount = adjustedContributors.slice($3b70a3d2013f6b6e$var$USER_DISPLAY_LIMIT).length;
    return {
        contributorCount: contributorCount,
        namedContributors: namedContributors,
        overflowContributorCount: overflowContributorCount
    };
};
const $3b70a3d2013f6b6e$export$18638a7ae5c7368a = ({ partial: partial })=>{
    const intl = (0, $8C5kA.default)();
    const { formatMessage: formatMessage } = intl;
    let values = {};
    let titleMessage = (0, $a11a2256cba9533b$export$a7357cdd1f0b0168).groupChatTitle;
    if (partial?.entity?.container?.type === 'DIRECT_MESSAGE' || partial?.entity?.container?.type === 'GROUP_DIRECT_MESSAGE') {
        const groupChatParticipants = partial?.entity.container?.members?.map((member)=>member?.thirdPartyUser);
        const { contributorCount: contributorCount, namedContributors: namedContributors, overflowContributorCount: overflowContributorCount } = $3b70a3d2013f6b6e$var$getTitleMessageValues(groupChatParticipants, intl);
        const [name1, name2, name3] = namedContributors;
        values = {
            contributorCount: contributorCount,
            name1: name1,
            name2: name2,
            name3: name3,
            overflowContributorCount: overflowContributorCount
        };
        titleMessage = (0, $a11a2256cba9533b$export$a7357cdd1f0b0168).groupChatTitle;
    } else {
        const linkedEntities = partial.linkedEntities || [];
        const threadUsers = [
            partial,
            ...linkedEntities
        ].map((linkedMessage)=>linkedMessage?.entity?.createdBy?.thirdPartyUser);
        const { contributorCount: contributorCount, namedContributors: namedContributors, overflowContributorCount: overflowContributorCount } = $3b70a3d2013f6b6e$var$getTitleMessageValues(threadUsers, intl);
        const [name1, name2, name3] = namedContributors;
        const channelName = partial?.entity?.container?.displayName || formatMessage((0, $a11a2256cba9533b$export$a7357cdd1f0b0168).unknownChannel);
        values = {
            contributorCount: contributorCount,
            name1: name1,
            name2: name2,
            name3: name3,
            overflowContributorCount: overflowContributorCount,
            channelName: channelName
        };
        titleMessage = (0, $a11a2256cba9533b$export$a7357cdd1f0b0168).threadTitleWithOthers;
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...titleMessage,
        values: values
    });
};


const $772eaa797e4d7b06$export$423dfe6469a8e0dd = ({ partial: partial, position: position, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [primaryProduct] = (0, $ee6ce766a2e08634$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const { url: url, linkedEntities: linkedEntities } = partial;
    const integrationKey = (0, $2c7ab0bafd629c54$export$fb63ba58603395b8)(partial.integrationId);
    const labelMessage = linkedEntities?.length ? (0, $38b099f59c75b3a5$export$a7357cdd1f0b0168).threadTypeLabel : (0, $38b099f59c75b3a5$export$a7357cdd1f0b0168).messageTypeLabel;
    const title = /*#__PURE__*/ (0, $l998X.jsx)((0, $3b70a3d2013f6b6e$export$18638a7ae5c7368a), {
        partial: partial
    });
    const body = /*#__PURE__*/ (0, $l998X.jsx)((0, $3b473daa079152ab$export$39a3a4657e687b88), {
        partial: partial,
        components: {
            Body: (0, $961d94431ab2c118$export$36e783c4ff07cd7c)
        }
    });
    const parts = [
        [
            'label',
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...labelMessage
            })
        ]
    ];
    if (partial?.entity?.container?.membershipType === 'PRIVATE') parts.push([
        'private',
        /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Q2dU))), {
            label: formatMessage((0, $38b099f59c75b3a5$export$a7357cdd1f0b0168).privateChannelLabel),
            color: "var(--ds-icon)",
            size: "small"
        })
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $77177493924f77d4$export$a2def421b23768aa), {
        id: partial.id,
        icon: icon,
        description: body,
        headerMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $4335848b71c04fe0$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: true,
            parts: parts
        }),
        footer: /*#__PURE__*/ (0, $l998X.jsx)((0, $48fbcdb8decb2909$export$c129802f229d9594), {
            attachments: partial.entity?.attachments,
            message: partial
        }),
        title: title,
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};





parcelRequire("42omo");














const $a2359f08b6c999d0$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    resultLabel: {
        id: "dynamic-cards-search-page.github-pull-request-result.label",
        defaultMessage: "Pull request"
    }
});


const $58c9a2d22b71ab01$export$fcb233d1869c46a3 = ({ partial: partial, position: position, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [primaryProduct] = (0, $ee6ce766a2e08634$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const { url: url, permissionLevel: permissionLevel, entity: entity, excerpt: excerpt } = partial;
    const { title: title, lastUpdate: lastUpdate, container: container, pullRequestId: pullRequestId } = entity || {};
    const label = formatMessage((0, $a2359f08b6c999d0$export$defe85febe8b728c).resultLabel);
    const lastModifiedComponent = lastUpdate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $13cc6c7031bc6442$export$e6747eee8f26f8c0), {
        lastModified: lastUpdate
    }) : null;
    const integrationKey = (0, $2c7ab0bafd629c54$export$fb63ba58603395b8)(partial.integrationId);
    const padlockIcon = (0, $2c7ab0bafd629c54$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $e365deb82157152f$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const getDescription = (excerpt)=>{
        const markdownRemoved = (0, $23d0e53a1e16ce35$export$7e4bcd4afb389edb)(excerpt);
        return (0, $2c7ab0bafd629c54$export$16c2ab98757b54d6)(markdownRemoved, true);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $77177493924f77d4$export$a2def421b23768aa), {
        id: partial.id,
        icon: icon,
        description: getDescription(excerpt),
        headerMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $4335848b71c04fe0$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: true,
            parts: [
                label,
                [
                    'pull-request-id',
                    `#${pullRequestId}`
                ],
                [
                    'repository-name',
                    container?.name ?? null
                ],
                [
                    'padlock',
                    padlockIcon
                ],
                [
                    'last-modified',
                    lastModifiedComponent
                ]
            ]
        }),
        title: (0, $2c7ab0bafd629c54$export$b847312d69858d61)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");














const $c7ed3ace40c31c25$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    repositoryLabel: {
        id: "dynamic-cards-search-page.search-result.repository-label",
        defaultMessage: "Repository"
    }
});


const $246840c936e7319c$var$GITHUB_INTEGRATION_KEY = 'github';
const $246840c936e7319c$export$334ba9b7628e002a = ({ partial: partial, position: position, icon: icon })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [primaryProduct] = (0, $ee6ce766a2e08634$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, title: title, excerpt: excerpt } = partial;
    const integrationKey = (0, $2c7ab0bafd629c54$export$fb63ba58603395b8)(partial.integrationId);
    const label = formatMessage((0, $c7ed3ace40c31c25$export$defe85febe8b728c).repositoryLabel);
    const padlockIcon = (0, $2c7ab0bafd629c54$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $e365deb82157152f$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const getDescription = (excerpt)=>{
        const markdownRemoved = (0, $23d0e53a1e16ce35$export$7e4bcd4afb389edb)(excerpt);
        return (0, $2c7ab0bafd629c54$export$16c2ab98757b54d6)(markdownRemoved, true);
    };
    const lastModifiedComponent = lastModifiedDate && integrationKey !== $246840c936e7319c$var$GITHUB_INTEGRATION_KEY ? /*#__PURE__*/ (0, $l998X.jsx)((0, $13cc6c7031bc6442$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $77177493924f77d4$export$a2def421b23768aa), {
        id: partial.id,
        icon: icon,
        description: getDescription(excerpt),
        headerMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $4335848b71c04fe0$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: true,
            parts: [
                label,
                [
                    'padlock',
                    padlockIcon
                ],
                [
                    'last-modified',
                    lastModifiedComponent
                ]
            ]
        }),
        title: (0, $2c7ab0bafd629c54$export$b847312d69858d61)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



























var $auNCB = parcelRequire("auNCB");


















const $a6447dad2f291b85$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    videoThumbnailAltText: {
        id: "dynamic-cards-search-page.video-search-result.video-thumbnail-alt-text",
        defaultMessage: "Video thumbnail"
    },
    videoIconLabel: {
        id: "dynamic-cards-search-page.video-search-result.video-icon-label",
        defaultMessage: "video icon"
    },
    dropdownMessage: {
        id: "dynamic-cards-search-page.video-search-result.dropdown-message",
        defaultMessage: "{chapterCount, plural, one {# chapter in this video} other {# chapters in this video}}"
    },
    seeAllLabel: {
        id: "dynamic-cards-search-page.video-search-result.see-all-label",
        defaultMessage: "See all"
    }
});



var $bKOxc = parcelRequire("bKOxc");


var $dWCFT = parcelRequire("dWCFT");


var $iA9co = parcelRequire("iA9co");

var $56ff82b82de14102$require$Buffer = $iA9co.Buffer;
const $56ff82b82de14102$export$b0d5f79a828d791e = (durationInSeconds, options)=>{
    if (durationInSeconds === undefined) return null;
    const date = (0, $bKOxc.default)(new Date(0), durationInSeconds);
    const ONE_HOUR = 3600;
    const ONE_MINUTE = 60;
    const hours = Math.floor(durationInSeconds / ONE_HOUR);
    const minutes = Math.floor(durationInSeconds % ONE_HOUR / ONE_MINUTE);
    const seconds = durationInSeconds % ONE_MINUTE;
    if (options?.readable) {
        if (durationInSeconds < ONE_MINUTE) return `${seconds} sec`;
        else if (durationInSeconds < 3600) return `${minutes} min`;
        else return `${hours} hour ${minutes} min`;
    }
    if (durationInSeconds < ONE_HOUR) return (0, $dWCFT.default)(date, 'mm:ss');
    return (0, $dWCFT.default)(date, 'HH:mm:ss');
};
const $56ff82b82de14102$export$edf82fe058be01d = (url)=>{
    const urlParams = new URLSearchParams(new URL(url).search);
    const base64Policy = urlParams.get('Policy');
    if (!base64Policy) return true;
    const decodedPolicy = $56ff82b82de14102$require$Buffer.from(base64Policy, 'base64').toString('utf-8');
    const i = decodedPolicy.lastIndexOf('}');
    const sanitizedPolicy = decodedPolicy.substring(0, i + 1);
    let policy;
    try {
        policy = JSON.parse(sanitizedPolicy);
    } catch (_) {
        return true;
    }
    if (policy.Statement && policy.Statement.length > 0) {
        const statement = policy.Statement[0];
        if (statement.Condition && statement.Condition.DateLessThan) {
            const epochTime = statement.Condition.DateLessThan['AWS:EpochTime'];
            const currentTime = Math.floor(Date.now() / 1000);
            return currentTime > epochTime;
        }
    }
    //fallthrough treat as expired
    return true;
};
const $56ff82b82de14102$export$121bfeb3f6fb7f94 = (baseUrl, durationInSeconds)=>{
    return `${baseUrl}?t=${durationInSeconds}`;
};


const $4b9ad9e7e52b310d$var$styles = {
    thumbnailContainer: "_nd5l18xf _kqswh2mm",
    bodyArea: "_1e0c1txw _gy1putpp",
    footerContainer: "_ca0qu2gc _kqswh2mm",
    dropdownItem: "_1rjc1b66 _1e0c1txw _gy1pu2gc _19pku2gc",
    seeAll: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _11c8wadc _19pkutpp",
    thumbnailImageStyles: "_2rko12b0 _c71l1ymo _1bsb1wug",
    chapterLink: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz13af _10531ra0 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _1vhv17z1"
};
const $4b9ad9e7e52b310d$var$VideoThumbnail = ({ thumbnailUrl: thumbnailUrl, url: url })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isErrored, setIsErrored] = (0, $42omo.useState)(false);
    return !thumbnailUrl || (0, $56ff82b82de14102$export$edf82fe058be01d)(thumbnailUrl) || isErrored ? null : /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        testId: "thumbnail-container",
        xcss: $4b9ad9e7e52b310d$var$styles.thumbnailContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
            href: url,
            rel: 'noreferrer',
            target: '_blank',
            children: /*#__PURE__*/ (0, $l998X.jsx)("img", {
                src: thumbnailUrl,
                alt: formatMessage((0, $a6447dad2f291b85$export$defe85febe8b728c).videoThumbnailAltText),
                onError: ()=>setIsErrored(true),
                className: (0, $gMc0m.default)([
                    $4b9ad9e7e52b310d$var$styles.thumbnailImageStyles
                ])
            })
        })
    });
};
const $4b9ad9e7e52b310d$var$VideoChapters = ({ chapters: chapters, url: url })=>{
    if (!chapters || chapters.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $4b9ad9e7e52b310d$var$styles.footerContainer,
        children: /*#__PURE__*/ (0, $l998X.jsx)($4b9ad9e7e52b310d$var$DropdownMenu, {
            chapters: chapters,
            url: url
        })
    });
};
const $4b9ad9e7e52b310d$var$DropdownMenu = ({ chapters: chapters, url: url })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isExpanded, setIsExpanded] = (0, $42omo.useState)(false);
    const dropdownMessage = formatMessage((0, $a6447dad2f291b85$export$defe85febe8b728c).dropdownMessage, {
        chapterCount: chapters.length
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                iconAfter: (iconProps)=>isExpanded ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                        ...iconProps,
                        size: "small"
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                        ...iconProps,
                        size: "small"
                    }),
                onClick: ()=>setIsExpanded(!isExpanded),
                isSelected: isExpanded,
                children: dropdownMessage
            }),
            isExpanded && /*#__PURE__*/ (0, $l998X.jsx)($4b9ad9e7e52b310d$var$DropdownItems, {
                chapters: chapters,
                url: url
            })
        ]
    });
};
const $4b9ad9e7e52b310d$var$DropdownItems = ({ chapters: chapters, url: url })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        children: [
            chapters.map(({ title: title, startTimeInSeconds: startTimeInSeconds })=>{
                return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                    xcss: $4b9ad9e7e52b310d$var$styles.dropdownItem,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $lE8sM.default), {
                            size: "16",
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))),
                            label: formatMessage((0, $a6447dad2f291b85$export$defe85febe8b728c).videoIconLabel),
                            appearance: "blue"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                            space: 'space.050',
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    size: "small",
                                    weight: "medium",
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
                                        xcss: $4b9ad9e7e52b310d$var$styles.chapterLink,
                                        href: (0, $56ff82b82de14102$export$121bfeb3f6fb7f94)(url, startTimeInSeconds),
                                        rel: 'noreferrer',
                                        target: "_blank",
                                        children: (0, $56ff82b82de14102$export$b0d5f79a828d791e)(startTimeInSeconds)
                                    })
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    size: "small",
                                    children: title
                                })
                            ]
                        })
                    ]
                });
            }),
            chapters.length > 10 && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $4b9ad9e7e52b310d$var$styles.seeAll,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
                    href: url,
                    target: "_blank",
                    xcss: $4b9ad9e7e52b310d$var$styles.seeAll,
                    children: formatMessage((0, $a6447dad2f291b85$export$defe85febe8b728c).seeAllLabel)
                })
            })
        ]
    });
};
const $4b9ad9e7e52b310d$export$d343a98cb833c8b = ({ partial: partial, position: position, icon: icon })=>{
    const [selectedProduct] = (0, $7tL1u.useSelectedProduct)();
    const [primaryProduct] = (0, $ee6ce766a2e08634$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity } = partial;
    const { durationInSeconds: durationInSeconds, chapters: chapters, createdBy: createdBy, thumbnailUrl: thumbnailUrl } = entity || {};
    const creatorName = createdBy?.user?.name || createdBy?.thirdPartyUser?.name || null;
    let { title: title, excerpt: excerpt } = partial;
    const excerptToDisplay = (0, $2c7ab0bafd629c54$export$85fedc4ba4240156)(excerpt || '', 300);
    const integrationKey = (0, $2c7ab0bafd629c54$export$fb63ba58603395b8)(partial.integrationId);
    const videoDuration = (0, $56ff82b82de14102$export$b0d5f79a828d791e)(durationInSeconds, {
        readable: true
    });
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $13cc6c7031bc6442$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const body = /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        testId: "thumbnail-container",
        xcss: $4b9ad9e7e52b310d$var$styles.bodyArea,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($4b9ad9e7e52b310d$var$VideoThumbnail, {
                thumbnailUrl: thumbnailUrl,
                url: url
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: (0, $2c7ab0bafd629c54$export$16c2ab98757b54d6)(excerptToDisplay, true)
            })
        ]
    });
    const padlockIcon = (0, $2c7ab0bafd629c54$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $e365deb82157152f$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $77177493924f77d4$export$a2def421b23768aa), {
        id: partial.id,
        description: body,
        icon: icon,
        headerMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $4335848b71c04fe0$export$8e7fb1f8fe599124), {
            product: integrationKey,
            productSelected: !!selectedProduct,
            parts: [
                'Video',
                [
                    'creator-name',
                    creatorName
                ],
                [
                    'last-modified',
                    lastModifiedComponent
                ],
                [
                    'video-duration',
                    videoDuration
                ],
                [
                    'padlock',
                    padlockIcon
                ]
            ]
        }),
        footer: /*#__PURE__*/ (0, $l998X.jsx)($4b9ad9e7e52b310d$var$VideoChapters, {
            chapters: chapters,
            url: url
        }),
        title: (0, $2c7ab0bafd629c54$export$b847312d69858d61)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};





parcelRequire("42omo");






























const $dbcd91c7b5397577$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    workItem: {
        id: "dynamic-cards-search-page.work-item.label",
        defaultMessage: "Work item"
    },
    taskLabel: {
        id: "dynamic-cards-search-page.work-item-task.label",
        defaultMessage: "Task"
    },
    projectLabel: {
        id: "dynamic-cards-search-page.work-item-project.label",
        defaultMessage: "Project"
    },
    ticketLabel: {
        id: "dynamic-cards-search-page.work-item-ticket.label",
        defaultMessage: "Ticket"
    },
    for: {
        id: "dynamic-cards-search-page.work-item-status.for",
        defaultMessage: "for"
    },
    isAssigned: {
        id: "dynamic-cards-search-page.work-item-assignee.assigned",
        defaultMessage: "is assigned"
    },
    created: {
        id: "dynamic-cards-search-page.work-item-creator.created",
        defaultMessage: "created"
    },
    externalPersonLabel: {
        id: "dynamic-cards-search-page.externalPersonLabel",
        defaultMessage: "External person"
    }
});


const $5c2c2289c8bfd67e$var$nameContainer = (0, $ecnYn.xcss)({
    whiteSpace: 'nowrap'
});
const $5c2c2289c8bfd67e$var$statusAndDateContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100'
});
const $5c2c2289c8bfd67e$var$STATUS_REGEX = /[\s-]+/g;
const $5c2c2289c8bfd67e$var$getStatusLozenge = (name)=>{
    name = name.replace($5c2c2289c8bfd67e$var$STATUS_REGEX, '').toLowerCase();
    switch(true){
        case [
            'onhold'
        ].includes(name):
            return 'default';
        case [
            'solved',
            'complete',
            'completed',
            'open'
        ].includes(name):
            return 'success';
        case [
            'offtrack',
            'untriaged'
        ].includes(name):
            return 'removed';
        case [
            'atrisk'
        ].includes(name):
            return 'moved';
        case [
            'todo',
            'new',
            'pending',
            'created'
        ].includes(name):
            return 'new';
        case [
            'inprogress',
            'ontrack'
        ].includes(name):
            return 'inprogress';
    }
    return 'inprogress'; // for custom status labels
};
const $5c2c2289c8bfd67e$export$35f8af203ce4264d = ({ partial: partial, position: position, icon: icon, product: product })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [selectedProduct] = (0, $7tL1u.useSelectedProduct)();
    const [primaryProduct] = (0, $ee6ce766a2e08634$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, entity: entity, excerpt: excerpt, title: title, subtype: subtype } = partial;
    const { assignee: assignee, createdBy: createdBy, dueDate: dueDate, id: id, projectName: projectName, status: status } = entity || {};
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $13cc6c7031bc6442$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const padlockIcon = (0, $2c7ab0bafd629c54$export$f2f9c8e083d34d6b)(permissionLevel) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $e365deb82157152f$export$fb0d481c8f77ba99), {
        permissionLevel: permissionLevel
    }) : null;
    const getStatusAndDate = ()=>{
        if (!status) return null;
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
            xcss: $5c2c2289c8bfd67e$var$statusAndDateContainerStyles,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                    appearance: $5c2c2289c8bfd67e$var$getStatusLozenge(status),
                    children: status
                }),
                dueDate && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            ...(0, $dbcd91c7b5397577$export$defe85febe8b728c).for
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cgtv4.FormattedDate), {
                                value: dueDate,
                                month: "short",
                                day: "numeric"
                            })
                        })
                    ]
                })
            ]
        });
    };
    const getAssigneeOrCreator = ()=>{
        let fullName, firstName, verbMessage;
        if (assignee?.thirdPartyUser?.name) {
            fullName = assignee?.thirdPartyUser?.name || '';
            verbMessage = formatMessage((0, $dbcd91c7b5397577$export$defe85febe8b728c).isAssigned);
        } else {
            fullName = createdBy?.thirdPartyUser?.name || '';
            verbMessage = formatMessage((0, $dbcd91c7b5397577$export$defe85febe8b728c).created);
        }
        firstName = fullName?.split(' ')?.[0] || formatMessage((0, $dbcd91c7b5397577$export$defe85febe8b728c).externalPersonLabel);
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
            space: "space.025",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $83d9190d7d9f86c9$export$e2255cf6045e8d47), {
                    name: fullName
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                    xcss: $5c2c2289c8bfd67e$var$nameContainer,
                    children: [
                        firstName,
                        " ",
                        verbMessage
                    ]
                })
            ]
        });
    };
    let label = formatMessage((0, $dbcd91c7b5397577$export$defe85febe8b728c).workItem);
    if (subtype === 'task') label = formatMessage((0, $dbcd91c7b5397577$export$defe85febe8b728c).taskLabel);
    else if (subtype === 'project') label = formatMessage((0, $dbcd91c7b5397577$export$defe85febe8b728c).projectLabel);
    else if (subtype === 'ticket') label = formatMessage((0, $dbcd91c7b5397577$export$defe85febe8b728c).ticketLabel);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $77177493924f77d4$export$a2def421b23768aa), {
        id: partial.id,
        icon: icon,
        description: (0, $2c7ab0bafd629c54$export$16c2ab98757b54d6)(excerpt, true),
        headerMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $4335848b71c04fe0$export$8e7fb1f8fe599124), {
            product: product,
            productSelected: !!selectedProduct,
            parts: [
                label,
                [
                    'identifier',
                    subtype === 'ticket' && id ? `#${id}` : projectName
                ],
                [
                    'last-modified',
                    lastModifiedComponent
                ],
                [
                    'padlock',
                    padlockIcon
                ],
                [
                    'status',
                    getStatusAndDate()
                ],
                [
                    'person',
                    getAssigneeOrCreator()
                ]
            ]
        }),
        title: (0, $2c7ab0bafd629c54$export$b847312d69858d61)(title),
        url: url,
        isThirdParty: true,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};


const $57895382998fc3a1$var$MICROSOFT_INTEGRATION_KEY = 'microsoft';
const $57895382998fc3a1$var$SHAREPOINT_SUPPORTED_RESOURCE_TYPES = [
    'document'
];
const $57895382998fc3a1$var$TEAMS_SUPPORTED_RESOURCE_TYPES = [
    'message',
    'conversation'
];
const $57895382998fc3a1$var$getIcon = ({ integrationKey: integrationKey, resourceType: resourceType })=>{
    if (!integrationKey) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    });
    let productKey = integrationKey === 'google' ? (0, $4sOnC.ProductKeys).GoogleDrive : integrationKey;
    /**
	 * Temporary fix for Microsoft integrationKey
	 */ if (integrationKey === $57895382998fc3a1$var$MICROSOFT_INTEGRATION_KEY && $57895382998fc3a1$var$SHAREPOINT_SUPPORTED_RESOURCE_TYPES.includes(resourceType)) productKey = (0, $4sOnC.ProductKeys).Sharepoint;
    else if (integrationKey === $57895382998fc3a1$var$MICROSOFT_INTEGRATION_KEY && $57895382998fc3a1$var$TEAMS_SUPPORTED_RESOURCE_TYPES.includes(resourceType)) productKey = (0, $4sOnC.ProductKeys).Teams;
    let IconComponent = (0, $4sOnC.products)[productKey]?.SearchResultIcon || (0, $4sOnC.products)[productKey]?.Icon;
    return IconComponent ? /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
        appearance: "brand",
        label: ""
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    });
};
const $57895382998fc3a1$export$b86b424e0d4929fb = ({ partial: partial, position: position })=>{
    const [{ cloudId: cloudId }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const resultAri = (0, $k4HRJ.AnyAri).parse(partial.id);
    const integrationKey = (0, $2c7ab0bafd629c54$export$fb63ba58603395b8)(partial.integrationId);
    const icon = $57895382998fc3a1$var$getIcon({
        integrationKey: integrationKey,
        resourceType: resultAri.resourceType
    });
    if ((0, $57Ynd.isConversationEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $243382b913ac38cc$export$4534f971846d5b0b), {
        partial: partial,
        position: position,
        icon: icon,
        integrationKey: integrationKey,
        resultAri: resultAri,
        cloudId: cloudId
    });
    if ((0, $57Ynd.isDesignEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $134dafd6c25dd068$export$f6a73210de3b9a3b), {
        partial: partial,
        position: position,
        icon: icon
    });
    if ((0, $57Ynd.isBranchEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $bcf1a09e4776bc79$export$5620ef5d10869020), {
        partial: partial,
        position: position,
        icon: icon
    });
    if ((0, $57Ynd.isCommitEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $7f96d82f37671190$export$35c708bc36dbd879), {
        partial: partial,
        position: position,
        icon: icon
    });
    if ((0, $57Ynd.isPullRequestEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $58c9a2d22b71ab01$export$fcb233d1869c46a3), {
        partial: partial,
        position: position,
        icon: icon
    });
    if ((0, $57Ynd.isRepositoryEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $246840c936e7319c$export$334ba9b7628e002a), {
        partial: partial,
        position: position,
        icon: icon
    });
    if ((0, $57Ynd.isVideoEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $4b9ad9e7e52b310d$export$d343a98cb833c8b), {
        partial: partial,
        position: position,
        icon: icon
    });
    if ((0, $57Ynd.isMessageEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $772eaa797e4d7b06$export$423dfe6469a8e0dd), {
        partial: partial,
        position: position,
        icon: icon
    });
    if ((0, $57Ynd.isDocumentEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $0017009db6afe170$export$43fa1bdcdc4d31ed), {
        partial: partial,
        position: position,
        resultAri: resultAri,
        icon: icon,
        integrationKey: integrationKey
    });
    if ((0, $57Ynd.isCalendarEventEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $d450d753939a3362$export$2d6c717667f5157c), {
        partial: partial,
        position: position,
        icon: icon,
        product: integrationKey
    });
    if ((0, $57Ynd.isWorkItemEntity)(partial)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5c2c2289c8bfd67e$export$35f8af203ce4264d), {
        partial: partial,
        position: position,
        icon: icon,
        product: integrationKey
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $a8ce7ac5600239f3$export$2917a391c04f0e93), {
        partial: partial,
        position: position,
        resultAri: resultAri,
        icon: icon,
        integrationKey: integrationKey
    });
};





parcelRequire("42omo");





















/* product-result-utils.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");










parcelRequire("42omo");

const $3618fc11255b0d3f$export$15f5952b52a8f495 = (_)=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M20.5938 24H8.40625C7.63281 24 7 23.3864 7 22.6364V5.36364C7 4.61364 7.63281 4 8.40625 4H16.8438L22 9V22.6364C22 23.3864 21.3672 24 20.5938 24Z",
                fill: "#3086F6"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M16.8438 4L22 9H16.8438V4Z",
                fill: "#0C67D6"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M18.7188 12.8634H10.2812V11.7271H18.7188V12.8634ZM18.7188 14.4543H10.2812V15.5907H18.7188V14.4543ZM16.375 17.1816H10.2812V18.318H16.375V17.1816Z",
                fill: "#FDFFFF"
            })
        ]
    });





parcelRequire("42omo");

const $b5746289f89776df$export$4fa264492a686961 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                id: "mask0_271_181646",
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "4",
                width: "15",
                height: "20",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                mask: "url(#mask0_271_181646)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L18.7188 7.18182L16.375 4Z",
                    fill: "#F4B400"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                id: "mask1_271_181646",
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "4",
                width: "15",
                height: "20",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                mask: "url(#mask1_271_181646)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M17.5469 13.0908H11.4531C11.0664 13.0908 10.75 13.3976 10.75 13.7726V19.6817C10.75 20.0567 11.0664 20.3635 11.4531 20.3635H17.5469C17.9336 20.3635 18.25 20.0567 18.25 19.6817V13.7726C18.25 13.3976 17.9336 13.0908 17.5469 13.0908ZM17.3125 18.3181H11.6875V15.1363H17.3125V18.3181Z",
                    fill: "#F1F1F1"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                id: "mask2_271_181646",
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "4",
                width: "15",
                height: "20",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                mask: "url(#mask2_271_181646)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.7866 9.05518L22.0003 14.1097V9.45404L16.7866 9.05518Z",
                    fill: "url(#paint0_linear_271_181646)"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                id: "mask3_271_181646",
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "4",
                width: "15",
                height: "20",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                mask: "url(#mask3_271_181646)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.375 4V8.09091C16.375 8.84432 17.0043 9.45454 17.7813 9.45454H22L16.375 4Z",
                    fill: "#FADA80"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                id: "mask4_271_181646",
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "4",
                width: "15",
                height: "20",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                mask: "url(#mask4_271_181646)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.375 4V4.11364L21.8828 9.45454H22L16.375 4Z",
                    fill: "white",
                    fillOpacity: "0.1"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                id: "mask5_271_181646",
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "4",
                width: "15",
                height: "20",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                mask: "url(#mask5_271_181646)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M8.40625 4C7.63281 4 7 4.61364 7 5.36364V5.47727C7 4.72727 7.63281 4.11364 8.40625 4.11364H16.375V4H8.40625Z",
                    fill: "white",
                    fillOpacity: "0.2"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                id: "mask6_271_181646",
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "4",
                width: "15",
                height: "20",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                mask: "url(#mask6_271_181646)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M20.5937 23.8866H8.40625C7.63281 23.8866 7 23.2729 7 22.5229V22.6366C7 23.3866 7.63281 24.0002 8.40625 24.0002H20.5937C21.3672 24.0002 22 23.3866 22 22.6366V22.5229C22 23.2729 21.3672 23.8866 20.5937 23.8866Z",
                    fill: "#BF360C",
                    fillOpacity: "0.2"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                id: "mask7_271_181646",
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "4",
                width: "15",
                height: "20",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                mask: "url(#mask7_271_181646)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M17.7812 9.45494C17.0043 9.45494 16.375 8.84472 16.375 8.09131V8.20495C16.375 8.95835 17.0043 9.56858 17.7812 9.56858H22V9.45494H17.7812Z",
                    fill: "#BF360C",
                    fillOpacity: "0.1"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
                fill: "url(#paint1_radial_271_181646)"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint0_linear_271_181646",
                        x1: "277.498",
                        y1: "52.454",
                        x2: "277.498",
                        y2: "514.58",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "#BF360C",
                                stopOpacity: "0.2"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "#BF360C",
                                stopOpacity: "0.02"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("radialGradient", {
                        id: "paint1_radial_271_181646",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(54.5207 43.5288) scale(2418.73 2345.43)",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "white",
                                stopOpacity: "0.1"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "white",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    });





parcelRequire("42omo");

const $11b15ede1cb657f4$export$26bbd899e059afb8 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                id: "mask0_271_181645",
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "4",
                width: "15",
                height: "20",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                mask: "url(#mask0_271_181645)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L18.7188 7.18182L16.375 4Z",
                    fill: "#0F9D58"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                id: "mask1_271_181645",
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "4",
                width: "15",
                height: "20",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                mask: "url(#mask1_271_181645)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M10.75 13.7734V20.3643H18.25V13.7734H10.75ZM14.0313 19.4553H11.6875V18.3189H14.0313V19.4553ZM14.0313 17.6371H11.6875V16.5007H14.0313V17.6371ZM14.0313 15.8189H11.6875V14.6825H14.0313V15.8189ZM17.3125 19.4553H14.9688V18.3189H17.3125V19.4553ZM17.3125 17.6371H14.9688V16.5007H17.3125V17.6371ZM17.3125 15.8189H14.9688V14.6825H17.3125V15.8189Z",
                    fill: "#F1F1F1"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                id: "mask2_271_181645",
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "4",
                width: "15",
                height: "20",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                mask: "url(#mask2_271_181645)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.7866 9.05518L22.0003 14.1097V9.45404L16.7866 9.05518Z",
                    fill: "url(#paint0_linear_271_181645)"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                id: "mask3_271_181645",
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "4",
                width: "15",
                height: "20",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                mask: "url(#mask3_271_181645)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.375 4V8.09091C16.375 8.84432 17.0043 9.45454 17.7813 9.45454H22L16.375 4Z",
                    fill: "#87CEAC"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                id: "mask4_271_181645",
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "4",
                width: "15",
                height: "20",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                mask: "url(#mask4_271_181645)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M8.40625 4C7.63281 4 7 4.61364 7 5.36364V5.47727C7 4.72727 7.63281 4.11364 8.40625 4.11364H16.375V4H8.40625Z",
                    fill: "white",
                    fillOpacity: "0.2"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                id: "mask5_271_181645",
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "4",
                width: "15",
                height: "20",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                mask: "url(#mask5_271_181645)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M20.5937 23.8866H8.40625C7.63281 23.8866 7 23.2729 7 22.5229V22.6366C7 23.3866 7.63281 24.0002 8.40625 24.0002H20.5937C21.3672 24.0002 22 23.3866 22 22.6366V22.5229C22 23.2729 21.3672 23.8866 20.5937 23.8866Z",
                    fill: "#263238",
                    fillOpacity: "0.2"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("mask", {
                id: "mask6_271_181645",
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "4",
                width: "15",
                height: "20",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                mask: "url(#mask6_271_181645)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M17.7812 9.45494C17.0043 9.45494 16.375 8.84472 16.375 8.09131V8.20495C16.375 8.95835 17.0043 9.56858 17.7812 9.56858H22V9.45494H17.7812Z",
                    fill: "#263238",
                    fillOpacity: "0.1"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M16.375 4H8.40625C7.63281 4 7 4.61364 7 5.36364V22.6364C7 23.3864 7.63281 24 8.40625 24H20.5937C21.3672 24 22 23.3864 22 22.6364V9.45455L16.375 4Z",
                fill: "url(#paint1_radial_271_181645)"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)("linearGradient", {
                        id: "paint0_linear_271_181645",
                        x1: "277.498",
                        y1: "52.454",
                        x2: "277.498",
                        y2: "514.58",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "#263238",
                                stopOpacity: "0.2"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "#263238",
                                stopOpacity: "0.02"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)("radialGradient", {
                        id: "paint1_radial_271_181645",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(54.5207 43.5288) scale(2418.73 2345.43)",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                stopColor: "white",
                                stopOpacity: "0.1"
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("stop", {
                                offset: "1",
                                stopColor: "white",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    });





parcelRequire("42omo");

const $b25e8a5118176d01$export$543eca71a8a23d8c = (_)=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                    clipPath: "url(#clip0_271_181625)",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M21.1472 3H7.50344C7.03258 3 6.65088 3.37303 6.65088 3.83318V7.54545L14.5579 9.81818L21.9997 7.54545V3.83318C21.9997 3.37303 21.618 3 21.1472 3Z",
                            fill: "#41A5EE"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M21.9997 7.54541H6.65088V12.0909L14.5579 13.4545L21.9997 12.0909V7.54541Z",
                            fill: "#2B7CD3"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M6.65088 12.0908V16.6363L14.0927 17.5454L21.9997 16.6363V12.0908H6.65088Z",
                            fill: "#185ABD"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M7.50344 21.1819H21.1472C21.618 21.1819 21.9997 20.8089 21.9997 20.3487V16.6365H6.65088V20.3487C6.65088 20.8089 7.03258 21.1819 7.50344 21.1819Z",
                            fill: "#103F91"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            opacity: "0.1",
                            d: "M12.3099 6.63647H6.65088V18.0001H12.3099C12.7802 17.9986 13.161 17.6265 13.1625 17.1669V7.46966C13.161 7.01013 12.7802 6.63797 12.3099 6.63647Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            opacity: "0.2",
                            d: "M11.8448 7.09082H6.65088V18.4545H11.8448C12.315 18.453 12.6959 18.0808 12.6974 17.6213V7.924C12.6959 7.46447 12.315 7.09232 11.8448 7.09082Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            opacity: "0.2",
                            d: "M11.8448 7.09082H6.65088V17.5454H11.8448C12.315 17.5439 12.6959 17.1717 12.6974 16.7122V7.924C12.6959 7.46447 12.315 7.09232 11.8448 7.09082Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            opacity: "0.2",
                            d: "M11.3797 7.09082H6.65088V17.5454H11.3797C11.8499 17.5439 12.2307 17.1717 12.2323 16.7122V7.924C12.2307 7.46447 11.8499 7.09232 11.3797 7.09082Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M2.85256 7.09082H11.38C11.8509 7.09082 12.2326 7.46385 12.2326 7.924V16.2576C12.2326 16.7178 11.8509 17.0908 11.38 17.0908H2.85256C2.3817 17.0908 2 16.7178 2 16.2576V7.924C2 7.46385 2.3817 7.09082 2.85256 7.09082Z",
                            fill: "#1a5bb8"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M5.49864 13.4809C5.51538 13.6095 5.52654 13.7213 5.53166 13.8172H5.55119C5.55863 13.7263 5.57413 13.6168 5.5977 13.4886C5.62127 13.3604 5.64251 13.2521 5.66142 13.1636L6.55817 9.38268H7.7177L8.64793 13.1068C8.70198 13.3383 8.74067 13.5731 8.76375 13.8095H8.7791C8.79644 13.5804 8.82876 13.3527 8.87585 13.1277L9.61771 9.38086H10.6731L9.3698 14.799H8.13677L7.25305 11.2109C7.22748 11.1077 7.19818 10.9727 7.16608 10.8068C7.13398 10.6408 7.11399 10.5195 7.10608 10.4431H7.09073C7.0805 10.5313 7.06049 10.6622 7.03072 10.8359C7.00096 11.0095 6.97708 11.138 6.95909 11.2213L6.12839 14.7981H4.87443L3.56421 9.38267H4.63862L5.44653 13.1713C5.46468 13.249 5.48189 13.3527 5.49864 13.4809Z",
                            fill: "white"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_271_181625",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "20",
                        height: "18.1818",
                        fill: "white",
                        transform: "translate(2 3)"
                    })
                })
            })
        ]
    });





parcelRequire("42omo");

const $7c474a57a95617e6$export$ad243ee11ac5af03 = (_)=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_271_181627)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M14.0927 12.5417L12.6973 2H12.5932C7.51931 2.01526 3.40983 6.24888 3.39502 11.476V11.5833L14.0927 12.5417Z",
                        fill: "#ED6C47"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M12.8015 2H12.6973V11.5833L17.3484 13.5L21.9996 11.5833V11.476C21.9848 6.24888 17.8753 2.01526 12.8015 2Z",
                        fill: "#FF8F6B"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M21.9997 11.5833V11.6887C21.9851 16.917 17.8746 21.1516 12.7997 21.1666H12.595C7.52004 21.1516 3.40958 16.917 3.39502 11.6887V11.5833H21.9997Z",
                        fill: "#D35230"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.1",
                        d: "M13.1625 6.71013V16.9355C13.1602 17.2909 12.9512 17.6101 12.6322 17.7453C12.5307 17.7896 12.4216 17.8124 12.3113 17.8124H5.59038C5.46015 17.6591 5.33457 17.4962 5.21829 17.3333C4.03331 15.7047 3.39349 13.724 3.39503 11.6887V11.4778C3.39231 9.64206 3.9131 7.8459 4.8927 6.31242C4.99503 6.1495 5.102 5.98659 5.21829 5.83325H12.3113C12.7799 5.83691 13.1589 6.22737 13.1625 6.71013Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.6974 7.18938V17.4148C12.6973 17.5284 12.6752 17.6408 12.6322 17.7454C12.5009 18.074 12.1911 18.2893 11.8462 18.2917H6.01364C5.86648 18.1378 5.72528 17.9779 5.59038 17.8125C5.46015 17.6592 5.33457 17.4962 5.21829 17.3333C4.03331 15.7048 3.39349 13.724 3.39503 11.6887V11.4779C3.39231 9.64214 3.9131 7.84598 4.8927 6.3125H11.8462C12.3148 6.31615 12.6938 6.70661 12.6974 7.18938Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.6974 7.18937V16.4565C12.6938 16.9392 12.3148 17.3297 11.8462 17.3333H5.21829C4.03331 15.7048 3.39349 13.724 3.39503 11.6887V11.4779C3.39231 9.64214 3.9131 7.84598 4.8927 6.3125H11.8462C12.3148 6.31614 12.6938 6.7066 12.6974 7.18937Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.2322 7.18937V16.4565C12.2287 16.9392 11.8497 17.3297 11.3811 17.3333H5.21829C4.03331 15.7048 3.39349 13.724 3.39503 11.6887V11.4779C3.39231 9.64214 3.9131 7.84598 4.8927 6.3125H11.3811C11.8497 6.31614 12.2287 6.7066 12.2322 7.18937Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M2.85231 6.3125H11.3798C11.8506 6.3125 12.2323 6.70574 12.2323 7.19081V15.9758C12.2323 16.4609 11.8506 16.8542 11.3798 16.8542H2.85231C2.38146 16.8542 1.99976 16.4609 1.99976 15.9759V7.19081C1.99976 6.70574 2.38146 6.3125 2.85231 6.3125Z",
                        fill: "#c54220"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M7.20915 8.65514C7.76426 8.61655 8.31459 8.78266 8.76171 9.12377C9.13464 9.46676 9.3339 9.96726 9.30217 10.4812C9.30827 10.8385 9.21585 11.1903 9.03567 11.4956C8.85325 11.7957 8.59043 12.035 8.27892 12.1847C7.9228 12.3553 7.53344 12.4396 7.14077 12.431H6.06217V14.4962H4.95752V8.65514H7.20915ZM6.06125 11.5388H7.01195C7.31334 11.5616 7.61239 11.4697 7.85242 11.2805C8.05094 11.0843 8.155 10.8076 8.1366 10.5249C8.1366 9.88117 7.7735 9.55933 7.0473 9.55933H6.06126V11.5388H6.06125Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_271_181627",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "20",
                        height: "19.1667",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });





parcelRequire("42omo");

const $c0b2de34b14ec480$export$44eea01b1a1915e7 = (_)=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_271_181626)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M14.5583 11.7083L6.65137 10.3333V20.4931C6.65137 20.9571 7.03307 21.3333 7.50392 21.3333H21.1476C21.6185 21.3333 22.0002 20.9571 22.0002 20.4931V16.7499L14.5583 11.7083Z",
                        fill: "#185C37"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M14.5583 3H7.50392C7.03307 3 6.65137 3.37613 6.65137 3.84012V7.58333L14.5583 12.1667L18.7444 13.5417L22.0002 12.1667V7.58333L14.5583 3Z",
                        fill: "#21A366"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M6.65137 7.58325H14.5583V12.1666H6.65137V7.58325Z",
                        fill: "#107C41"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.1",
                        d: "M12.3104 6.66675H6.65137V18.1251H12.3104C12.7807 18.1236 13.1615 17.7483 13.163 17.285V7.50687C13.1615 7.04351 12.7807 6.66825 12.3104 6.66675Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8453 7.125H6.65137V18.5833H11.8453C12.3155 18.5818 12.6964 18.2066 12.6979 17.7432V7.96512C12.6964 7.50176 12.3155 7.12651 11.8453 7.125Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8453 7.125H6.65137V17.6667H11.8453C12.3155 17.6652 12.6964 17.2899 12.6979 16.8265V7.96512C12.6964 7.50176 12.3155 7.12651 11.8453 7.125Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.3802 7.125H6.65137V17.6667H11.3802C11.8504 17.6652 12.2312 17.2899 12.2328 16.8265V7.96512C12.2312 7.50176 11.8504 7.12651 11.3802 7.125Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M2.85256 7.125H11.38C11.8508 7.125 12.2325 7.50113 12.2325 7.96512V16.3682C12.2325 16.8322 11.8508 17.2083 11.38 17.2083H2.85256C2.3817 17.2083 2 16.8322 2 16.3682V7.96512C2 7.50113 2.3817 7.125 2.85256 7.125Z",
                        fill: "#117d42"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M4.64038 14.8975L6.43387 12.159L4.79062 9.43555H6.11247L7.00922 11.1772C7.09201 11.3427 7.14875 11.4655 7.17945 11.5466H7.19108C7.24999 11.4146 7.31201 11.2864 7.37713 11.1621L8.33573 9.43647H9.54921L7.8641 12.1438L9.59201 14.8975H8.30085L7.26503 12.9858C7.21624 12.9045 7.17484 12.819 7.14132 12.7305H7.12597C7.09563 12.8172 7.05537 12.9003 7.00597 12.978L5.93946 14.8975H4.64038Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M21.1474 3H14.5581V7.58333H22V3.84012C22 3.37613 21.6183 3 21.1474 3Z",
                        fill: "#33C481"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M14.5581 12.1667H22V16.7501H14.5581V12.1667Z",
                        fill: "#107C41"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_271_181626",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "20",
                        height: "18.3333",
                        fill: "white",
                        transform: "translate(2 3)"
                    })
                })
            })
        ]
    });



var $77KdG = parcelRequire("77KdG");





const $5fe88ba66a52cb8c$export$16b26cd5e98d9100 = (partial, selectedProduct, label = '')=>{
    const getGoogleIconGlyph = ()=>{
        if ((0, $af8fO.isGoogleDocument)(partial)) return 0, $3618fc11255b0d3f$export$15f5952b52a8f495;
        if ((0, $af8fO.isGooglePresentation)(partial)) return 0, $b5746289f89776df$export$4fa264492a686961;
        if ((0, $af8fO.isGoogleSpreadsheet)(partial)) return 0, $11b15ede1cb657f4$export$26bbd899e059afb8;
    };
    const getSharepointIconGlyph = ()=>{
        if ((0, $af8fO.isSharepointDocument)(partial)) return 0, $b25e8a5118176d01$export$543eca71a8a23d8c;
        if ((0, $af8fO.isSharepointPresentation)(partial)) return 0, $7c474a57a95617e6$export$ad243ee11ac5af03;
        if ((0, $af8fO.isSharepointSpreadsheet)(partial)) return 0, $c0b2de34b14ec480$export$44eea01b1a1915e7;
    };
    if ((0, $af8fO.isGoogleResult)(partial)) return selectedProduct ? getGoogleIconGlyph()?.({
        'aria-label': label
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $bf0e75dc658e43a5$export$1a199e029d5e93d6), {
        product: (0, $4sOnC.ProductKeys).GoogleDrive
    });
    if ((0, $af8fO.isSlackMessage)(partial)) return selectedProduct ? /*#__PURE__*/ (0, $l998X.jsx)((0, $77KdG.SlackIcon), {
        "aria-label": label
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $bf0e75dc658e43a5$export$1a199e029d5e93d6), {
        product: (0, $4sOnC.ProductKeys).Slack
    });
    if ((0, $af8fO.isSharepointResult)(partial)) return selectedProduct ? getSharepointIconGlyph()?.({
        'aria-label': label
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $bf0e75dc658e43a5$export$1a199e029d5e93d6), {
        product: (0, $4sOnC.ProductKeys).Sharepoint
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        color: "currentColor",
        spacing: "spacious",
        label: ""
    });
};
const $5fe88ba66a52cb8c$export$236350842f3cd9bc = (partial)=>{
    if ((0, $af8fO.isSlackMessage)(partial)) return 'Slack';
    if ((0, $af8fO.isGoogleDocument)(partial)) return 'Docs';
    if ((0, $af8fO.isGooglePresentation)(partial)) return 'Slides';
    if ((0, $af8fO.isGoogleSpreadsheet)(partial)) return 'Sheets';
    if ((0, $af8fO.isSharepointDocument)(partial)) return 'Word';
    if ((0, $af8fO.isSharepointPresentation)(partial)) return 'PowerPoint';
    if ((0, $af8fO.isSharepointSpreadsheet)(partial)) return 'Excel';
    return '';
};






const $fde5266add441c01$var$footerContainer = (0, $ecnYn.xcss)({
    paddingTop: 'space.100'
});
const $fde5266add441c01$export$de6215ca63d8bb61 = ({ partial: partial, position: position })=>{
    const [selectedProduct] = (0, $7tL1u.useSelectedProduct)();
    const [primaryProduct] = (0, $ee6ce766a2e08634$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId, isAdminHubAIEnabled: isAdminHubAIEnabled }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const intl = (0, $8C5kA.default)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const product = 'slack';
    const { lastModifiedDate: lastModifiedDate, url: url, permissionLevel: permissionLevel, mentions: mentions, type: type, subtype: subtype, linkedEntities: linkedEntities, lastActive: lastActive, allContributors: allContributors } = partial;
    let { description: description, title: title } = partial;
    let label = (0, $5fe88ba66a52cb8c$export$236350842f3cd9bc)(partial);
    const lastModifiedComponent = lastModifiedDate ? /*#__PURE__*/ (0, $l998X.jsx)((0, $13cc6c7031bc6442$export$e6747eee8f26f8c0), {
        lastModified: lastModifiedDate
    }) : null;
    const [contributor] = (0, $af8fO.isGraphDocument)(partial) && partial.initialContributors || [];
    let parts = [
        label,
        [
            'last-modified',
            lastModifiedComponent
        ],
        contributor?.name
    ];
    let messageDescription;
    const latestModifiedDate = linkedEntities ? linkedEntities[linkedEntities.length - 1]?.lastModifiedDate : lastModifiedDate;
    const timeValues = (0, $2c7ab0bafd629c54$export$7e0fd00186ff29c6)(lastActive || latestModifiedDate || lastModifiedDate);
    const { unit: unit, value: value } = (0, $2c7ab0bafd629c54$export$3e6e07f5a5b9cd48)(timeValues.seconds, timeValues.minutes, timeValues.hours, timeValues.days, timeValues.months, timeValues.years);
    const relativeTime = /*#__PURE__*/ (0, $l998X.jsx)((0, $a2dru.default), {
        value: -value,
        style: "long",
        unit: unit,
        numeric: "auto",
        children: (formattedTime)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $12d2cc9f3ae11467$export$defe85febe8b728c)['lastActive'],
                values: {
                    relativeDate: formattedTime
                }
            })
    });
    const contributors = allContributors || [
        ...(0, $2c7ab0bafd629c54$export$995e2d4c52603c12)([
            partial,
            ...linkedEntities
        ])
    ];
    if (type === 'channel') {
        title = `#${title}`;
        messageDescription = '';
        // need to set these to empty strings to avoid showing any description in the search result
        description = '';
        parts = [
            formatMessage((0, $12d2cc9f3ae11467$export$defe85febe8b728c).channelTypeLabel),
            formatMessage((0, $12d2cc9f3ae11467$export$defe85febe8b728c).channelMemberCount, {
                memberCount: contributors.length
            }),
            [
                'last-active',
                relativeTime
            ]
        ];
    } else {
        if (subtype === 'direct_message') {
            title = (0, $2c7ab0bafd629c54$export$4675aadf6b343fe5)(contributors, formatMessage((0, $12d2cc9f3ae11467$export$defe85febe8b728c).privateConversationText, {
                users: (0, $2c7ab0bafd629c54$export$71c19251e893ab21)(contributors, intl)
            }), intl);
            parts = [
                formatMessage((0, $12d2cc9f3ae11467$export$defe85febe8b728c).messageTypeLabel),
                [
                    'last-active',
                    relativeTime
                ]
            ];
            messageDescription = (0, $2c7ab0bafd629c54$export$b847312d69858d61)((0, $2c7ab0bafd629c54$export$a688e0cd0fe53c61)(description, mentions));
        } else // if it's a thread, build the title and description
        // otherwise if it's a message, just process the description
        if (linkedEntities?.length > 0) {
            title = (0, $2c7ab0bafd629c54$export$4675aadf6b343fe5)(contributors, `#${title}`, intl);
            parts = [
                formatMessage((0, $12d2cc9f3ae11467$export$defe85febe8b728c).threadTypeLabel),
                [
                    'last-active',
                    relativeTime
                ]
            ];
            messageDescription = (0, $2c7ab0bafd629c54$export$3cf018c7cb5c2c7d)(partial, intl);
        } else {
            title = (0, $2c7ab0bafd629c54$export$4675aadf6b343fe5)(contributors, `#${title}`, intl);
            parts = [
                formatMessage((0, $12d2cc9f3ae11467$export$defe85febe8b728c).messageTypeLabel),
                [
                    'last-active',
                    relativeTime
                ]
            ];
            messageDescription = (0, $2c7ab0bafd629c54$export$3cf018c7cb5c2c7d)(partial, intl);
        }
    }
    const icon = (0, $5fe88ba66a52cb8c$export$16b26cd5e98d9100)(partial, selectedProduct, label);
    const isNotPublic = (0, $2c7ab0bafd629c54$export$f2f9c8e083d34d6b)(permissionLevel);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $77177493924f77d4$export$a2def421b23768aa), {
        id: partial.id,
        description: messageDescription,
        icon: icon,
        headerMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $4335848b71c04fe0$export$8e7fb1f8fe599124), {
            product: product,
            productSelected: true,
            parts: parts
        }),
        footer: isNotPublic && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
            xcss: $fde5266add441c01$var$footerContainer,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $f7d93f1ad4e1b432$export$3eac322cb0b365da), {
                restriction: permissionLevel
            })
        }),
        title: (0, $2c7ab0bafd629c54$export$b847312d69858d61)(title),
        url: url,
        isThirdParty: true,
        // AI Summaries are only supported for Google Drive now
        showAISummary: (0, $af8fO.isGoogleDocument)(partial) && isAdminHubAIEnabled,
        cloudId: cloudId,
        primaryProduct: primaryProduct,
        position: position,
        partial: partial
    });
};









var $7MEO5 = parcelRequire("7MEO5");

const $0ab710c1ef1799c8$export$d8a746fe35b1c95d = (ari)=>{
    const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $0ab710c1ef1799c8$export$fccbae65febb6fd4(ari) ? $0ab710c1ef1799c8$export$2f432ca99e30467e(ari) : (0, $7MEO5.parse)(ari);
    return [
        resourceOwner,
        cloudId,
        resourceType,
        resourceId
    ];
};
const $0ab710c1ef1799c8$var$thirdPartyRegex = new RegExp('^ari:third-party:(\\S+)::(\\S+)\\/(\\S+)$');
const $0ab710c1ef1799c8$export$2f432ca99e30467e = (ari)=>{
    const result = $0ab710c1ef1799c8$var$thirdPartyRegex.exec(ari);
    if (!result) throw new Error(`Invalid third party ARI. Use ${$0ab710c1ef1799c8$export$fccbae65febb6fd4.name} to check before calling this function.`);
    const [_, resourceOwner, resourceType, resourceId] = result;
    return {
        resourceId: resourceId,
        resourceOwner: resourceOwner,
        resourceType: resourceType,
        cloudId: resourceId
    };
};
const $0ab710c1ef1799c8$export$fccbae65febb6fd4 = (ari)=>$0ab710c1ef1799c8$var$thirdPartyRegex.test(ari);



















const $6175f42466615de0$export$37a54a397a692113 = ({ partial: partial, position: position })=>{
    const [selectedProduct] = (0, $7tL1u.useSelectedProduct)();
    const [primaryProduct] = (0, $ee6ce766a2e08634$export$92c6f3c7c09f3247)();
    const [{ cloudId: cloudId }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const [searchQuery] = (0, $7tL1u.useSearchQuery)();
    const { id: id, title: title, url: url, type: type, description: description, lastModifiedDate: lastModifiedDate } = partial;
    const metadata = (0, $42omo.useMemo)(()=>{
        const [product] = (0, $0ab710c1ef1799c8$export$d8a746fe35b1c95d)(id);
        return {
            entityType: type === 'issue' ? 'card' : type,
            product: product
        };
    }, [
        id,
        type
    ]);
    const getLastModified = (0, $42omo.useMemo)(()=>{
        if (!lastModifiedDate) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $13cc6c7031bc6442$export$e6747eee8f26f8c0), {
            lastModified: lastModifiedDate
        });
    }, [
        lastModifiedDate
    ]);
    const enrichedTitle = (0, $42omo.useMemo)(()=>{
        const { highlightedTitle: highlightedTitle } = (0, $35ad33aa93b58ce9$export$9f4c92a576b56d82)(title, searchQuery.split(' '));
        if (!highlightedTitle) return title;
        return (0, $2c7ab0bafd629c54$export$b847312d69858d61)(highlightedTitle);
    }, [
        title,
        searchQuery
    ]);
    const enrichedDescription = (0, $42omo.useMemo)(()=>{
        const reducedDescription = (0, $65b7b5d086d94991$export$91c2cc655c44ef69)(description, searchQuery);
        const { highlightedTitle: highlightedTitle } = (0, $35ad33aa93b58ce9$export$9f4c92a576b56d82)(reducedDescription, searchQuery.split(' '));
        if (!highlightedTitle) return reducedDescription;
        return (0, $2c7ab0bafd629c54$export$16c2ab98757b54d6)(highlightedTitle);
    }, [
        description,
        searchQuery
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $77177493924f77d4$export$a2def421b23768aa), {
        ...partial,
        primaryProduct: primaryProduct,
        url: url,
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $bf0e75dc658e43a5$export$1a199e029d5e93d6), {
            product: (0, $4sOnC.ProductKeys).Trello
        }),
        title: enrichedTitle,
        headerMetadata: /*#__PURE__*/ (0, $l998X.jsx)((0, $4335848b71c04fe0$export$8e7fb1f8fe599124), {
            product: metadata.product,
            productSelected: !!selectedProduct,
            parts: [
                [
                    'type',
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $8ed8599e79dcdf51$export$95cacd63dfd98bee), {
                        type: metadata.entityType
                    })
                ],
                [
                    'lastModified',
                    getLastModified
                ]
            ]
        }),
        description: enrichedDescription,
        cloudId: cloudId,
        position: position
    });
};


const $db40cc8bfa168e1a$var$resultsListGridAreaStyles = (0, $ecnYn.xcss)({
    gridArea: 'results-list',
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.200'
});
const $db40cc8bfa168e1a$var$noMoreResultsStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.400'
});
// How many search results to show before the OAuth banner
const $db40cc8bfa168e1a$var$OAUTH_BANNER_CUTOFF = 4;
const $db40cc8bfa168e1a$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    resultsCount: {
        id: "search-result.result.count",
        defaultMessage: "{count, plural, one {Showing {count} result} other {Showing {count} results}}"
    }
});
// TODO: we should monitor for unsupported result types, right now we're failing silently and fall back to null
const $db40cc8bfa168e1a$var$ResultRecord = ({ node: node, index: index })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $63afac6f9f5eb800$export$e926676385687eaf), {
        fallback: null,
        children: (0, $2Btfj.isSearchConfluencePartial)(node) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $f0dc6d43cf11d6ff$export$30adeb861c31a5ed), {
            partial: node,
            position: index
        }) : (0, $ERUZZ.isSearchResultJiraIssue)(node) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $4fbd69116e3f56b6$export$3c36ba6ceaed3437), {
            partial: (0, $ERUZZ.mapJiraIssuePartial)(node),
            position: index
        }) : (0, $ERUZZ.isSearchResultJiraProject)(node) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $4fbd69116e3f56b6$export$3c36ba6ceaed3437), {
            partial: (0, $ERUZZ.mapJiraProjectPartial)(node),
            position: index
        }) : (0, $ERUZZ.isSearchJiraPartial)(node) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $4fbd69116e3f56b6$export$3c36ba6ceaed3437), {
            partial: node,
            position: index
        }) : (0, $iQC4a.isSearchAtlasPartial)(node) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2946d259ab86f3a0$export$a97c0c8e95f01322), {
            partial: node,
            position: index
        }) : (0, $bGd7w.isSearchCompassPartial)(node) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3564a81d001b99dd$export$cc23f5d092bb479f), {
            partial: node,
            position: index
        }) : (0, $1rDtO.isSearchTrelloPartial)(node) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $6175f42466615de0$export$37a54a397a692113), {
            partial: node,
            position: index
        }) : (0, $af8fO.isSlackMessage)(node) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fde5266add441c01$export$de6215ca63d8bb61), {
            partial: node,
            position: index
        }) : (0, $57Ynd.isSearchResultGraphEntity)(node) ? // Leave this one last
        /*#__PURE__*/ (0, $l998X.jsx)((0, $57895382998fc3a1$export$b86b424e0d4929fb), {
            partial: node,
            position: index
        }) : null
    }, node.id);
};
const $db40cc8bfa168e1a$export$4a34de49b46a2bfa = ()=>{
    const [results] = (0, $7tL1u.useResults)();
    const { setFetchFromCursor: setFetchFromCursor } = (0, $7tL1u.useSearchActions)();
    const currentCursor = (0, $7tL1u.useFetchFromCursor)();
    const nextFetchCursor = (0, $7tL1u.usePageEndCursor)();
    const isLoadingMore = (0, $7tL1u.useIsLoadingMore)();
    const hasNextPage = nextFetchCursor && currentCursor !== nextFetchCursor;
    const [selectedProduct] = (0, $7tL1u.useSelectedProduct)();
    const lastResultRef = (0, $42omo.useRef)(null);
    const paginationEnabled = false;
    (0, $42omo.useEffect)(()=>{
        if (!paginationEnabled) return;
        const nextPageObserver = new IntersectionObserver((entries)=>{
            if (entries[0].isIntersecting) {
                if (nextFetchCursor && nextFetchCursor !== currentCursor) setFetchFromCursor(nextFetchCursor);
            }
        }, {});
        if (lastResultRef.current) nextPageObserver.observe(lastResultRef.current);
    }, [
        currentCursor,
        nextFetchCursor,
        paginationEnabled,
        results,
        setFetchFromCursor
    ]);
    if (!results) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
    const initialResults = results.edges.slice(0, $db40cc8bfa168e1a$var$OAUTH_BANNER_CUTOFF);
    const remainingResults = results.edges.slice($db40cc8bfa168e1a$var$OAUTH_BANNER_CUTOFF);
    const resultsCount = paginationEnabled ? results.totalCount : results.edges.length;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        xcss: [
            $db40cc8bfa168e1a$var$resultsListGridAreaStyles,
            $db40cc8bfa168e1a$var$noMoreResultsStyles
        ],
        role: "list",
        testId: "search-page-results-list",
        children: [
            resultsCount && /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                color: "color.text.subtle",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...$db40cc8bfa168e1a$export$a7357cdd1f0b0168.resultsCount,
                    values: {
                        count: resultsCount
                    }
                })
            }),
            initialResults.map(({ node: node }, index)=>/*#__PURE__*/ (0, $l998X.jsx)($db40cc8bfa168e1a$var$ResultRecord, {
                    node: node,
                    index: index
                })),
            !selectedProduct && /*#__PURE__*/ (0, $l998X.jsx)((0, $088eb706225a246f$export$2e2bcd8739ae039), {}),
            remainingResults.length > 0 && remainingResults.map(({ node: node }, index)=>/*#__PURE__*/ (0, $l998X.jsx)($db40cc8bfa168e1a$var$ResultRecord, {
                    node: node,
                    index: index + $db40cc8bfa168e1a$var$OAUTH_BANNER_CUTOFF
                })),
            paginationEnabled && (hasNextPage || isLoadingMore) && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                ref: lastResultRef,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $367b99054ac5830c$export$dd3282b157ef6f7a), {})
            })
        ]
    });
};


const $1d774dbe5a25c5b8$var$resultCountAndSortContainer = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 'space.050'
});
const $1d774dbe5a25c5b8$var$ResultsState = {
    NO_RESULTS: 'noResults',
    INITIAL: 'initial',
    RESULTS: 'results',
    ERROR: 'error',
    IS_LOADING: 'isLoading',
    EMPTY: 'empty'
};
const $1d774dbe5a25c5b8$export$1e51d2073b60bd88 = ()=>{
    // TODO: this hook should be moved to the Store, so it can be used by other components.
    const [{ outboundAuthConfigs: outboundAuthConfigs }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const { hasFiltersSelected: hasFiltersSelected } = (0, $4b32ad29ed64a485$export$e90e90fddddd8154)({
        outboundAuthConfigs: outboundAuthConfigs
    });
    const [isLoading] = (0, $7tL1u.useIsLoading)();
    const [error] = (0, $7tL1u.useResultsError)();
    const [results] = (0, $7tL1u.useResults)();
    return (0, $42omo.useMemo)(()=>{
        // This narrows the result down to either loading or nothing
        if (results === undefined && error === undefined) {
            // In this case, we know user has selected filters, so we can show loading state
            if (hasFiltersSelected) return {
                state: $1d774dbe5a25c5b8$var$ResultsState.IS_LOADING
            };
            /*
				In some cases, isLoading returns true before hasFiltersSelected returns true
				In these cases, we do not know if:
				- the user has selected filters (we should show loading state)
				- the user has not selected filters (we should not show loading state)

				For this reason, we display nothing until we know filter state for certain
			 */ return {
                state: $1d774dbe5a25c5b8$var$ResultsState.EMPTY
            };
        }
        // In this case, we know user has not selected filters, so we can show initial state
        if (!hasFiltersSelected) return {
            state: $1d774dbe5a25c5b8$var$ResultsState.INITIAL
        };
        // This covers loading case where a second query was made
        if (isLoading) return {
            state: $1d774dbe5a25c5b8$var$ResultsState.IS_LOADING
        };
        if (results && results.edges.length > 0) return {
            state: $1d774dbe5a25c5b8$var$ResultsState.RESULTS
        };
        // If there are no entities for a query, an error will throw
        // when no entities for query is equivalent to no results
        if (error instanceof (0, $2803a5b285916c4e$export$8ba86dff7c04c14c) || results && results.edges.length === 0) return {
            state: $1d774dbe5a25c5b8$var$ResultsState.NO_RESULTS
        };
        return {
            state: $1d774dbe5a25c5b8$var$ResultsState.ERROR
        };
    }, [
        hasFiltersSelected,
        isLoading,
        error,
        results
    ]);
};
const $1d774dbe5a25c5b8$export$b4ce9e0c6695ed08 = ()=>{
    const [results] = (0, $7tL1u.useResults)();
    const [requestId] = (0, $7tL1u.useResultsRequestId)();
    const [error] = (0, $7tL1u.useResultsError)();
    const [selectedProduct] = (0, $7tL1u.useSelectedProduct)();
    const { retrySearch: retrySearch } = (0, $7tL1u.useSearchActions)();
    const intercom = (0, $6710de068e8e9e3c$export$f0fed4b0765d7314)();
    const { state: state } = $1d774dbe5a25c5b8$export$1e51d2073b60bd88();
    const [isOnline, _] = (0, $42omo.useState)(navigator.onLine);
    (0, $42omo.useEffect)(()=>{
        if (results && results.edges.length >= 0) {
            (0, $c00ebe4ee56aadce$export$e882a2ec68d19be8).mark('render_end');
            (0, $c00ebe4ee56aadce$export$e882a2ec68d19be8).success({
                metadata: {
                    productFilter: selectedProduct,
                    requestId: requestId
                }
            });
            // Only fire intercom results shown events when there are actually results
            // as we don't know when the user has connected their 3P provider or not
            if (results.edges.length > 0) {
                if (selectedProduct && (0, $7e38068845a191b0$export$b0f4af9a0173cbfd)(selectedProduct)) intercom?.trackEvent('search_results_shown_3p', {
                    product_filter: selectedProduct
                });
                else intercom?.trackEvent('search_results_shown', {
                    product_filter: selectedProduct
                });
            }
        } else if (error && !results) (0, $c00ebe4ee56aadce$export$e882a2ec68d19be8).failure({
            metadata: {
                productFilter: selectedProduct
            }
        });
    }, [
        results,
        selectedProduct,
        error,
        intercom,
        requestId
    ]);
    (0, $42omo.useEffect)(()=>{
        (0, $ae5e5e0d6e377a71$export$5e3e5ca9e3ba891b)(isOnline, (0, (/*@__PURE__*/$parcel$interopDefault($23c12efe6ce8cead$exports))), (0, $ae5e5e0d6e377a71$export$add61e2630a21f9), (0, (/*@__PURE__*/$parcel$interopDefault($b54b959ea5115ff8$exports))), (0, $ae5e5e0d6e377a71$export$4be43fd067fd9d7f));
    }, [
        isOnline
    ]);
    const showResultCountAndSort = (0, $42omo.useMemo)(()=>selectedProduct === (0, $4sOnC.ProductKeys).Confluence, [
        selectedProduct
    ]);
    if (state === $1d774dbe5a25c5b8$var$ResultsState.IS_LOADING) return /*#__PURE__*/ (0, $l998X.jsx)((0, $74599b047b553f98$export$669f6ea7d267feaf), {});
    if (state === $1d774dbe5a25c5b8$var$ResultsState.INITIAL) return /*#__PURE__*/ (0, $l998X.jsx)((0, $6221778abe8049fc$export$12449a31c6671d53), {});
    if (state === $1d774dbe5a25c5b8$var$ResultsState.RESULTS) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
        children: [
            showResultCountAndSort && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $1d774dbe5a25c5b8$var$resultCountAndSortContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {})
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $db40cc8bfa168e1a$export$4a34de49b46a2bfa), {})
        ]
    });
    if (state === $1d774dbe5a25c5b8$var$ResultsState.NO_RESULTS) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $c96f75ecd5461a3e$export$ef6006467f04ee41), {})
    });
    if (state === $1d774dbe5a25c5b8$var$ResultsState.EMPTY) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6a2328c2cf65461e$export$edf27be85e5f6da0), {
        fetchResults: retrySearch
    });
};









var $6cnUO = parcelRequire("6cnUO");


var $k7Tf7 = parcelRequire("k7Tf7");
















var $gLLcz = parcelRequire("gLLcz");


var $7tGzv = parcelRequire("7tGzv");

const $6eeaf2e628370b77$var$outboundAuthConfigSchema = (0, $gLLcz.z).object({
    url: (0, $gLLcz.z).string(),
    userNeedsOAuth: (0, $gLLcz.z).boolean()
});
const $6eeaf2e628370b77$export$550db1eccbaa1ef8 = (0, $gLLcz.z).record((0, $7tGzv.productKeySchema), $6eeaf2e628370b77$var$outboundAuthConfigSchema).or((0, $gLLcz.z).record((0, $gLLcz.z).never())); // Allow for empty objects = {}










const $5495cf3bfcd48acd$var$EXTRACT_PRODUCT = /ari:cloud:(.*)?::/;
const $5495cf3bfcd48acd$var$EXTRACT_CLOUD_ID = /ari:cloud:.*?\/(.*)/;
const $5495cf3bfcd48acd$var$getFirstCloudId = (firstPartyResponse)=>{
    const match = firstPartyResponse.resources[0]?.id.match($5495cf3bfcd48acd$var$EXTRACT_CLOUD_ID);
    const extractedCloudId = match ? match[1] : '';
    return extractedCloudId;
};
const $5495cf3bfcd48acd$var$isNounsAvailable = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isNounsAvailable;
};
const $5495cf3bfcd48acd$export$2b0ac18f7cd43e19 = ({ cloudId: cloudIdProp, configFetchAbsoluteUrl: configFetchAbsoluteUrl, aggregatorHostName: aggregatorHostName, userId: userId, thirdPartyAbsoluteUrl: thirdPartyAbsoluteUrl, primaryProduct: primaryProduct })=>{
    const [firstPartyResponse, setFirstPartyResponse] = (0, $42omo.useState)();
    const [accessibleProducts, setAccessibleProducts] = (0, $42omo.useState)();
    const logException = (0, $63afac6f9f5eb800$export$67ff3bc9583d7c16)();
    const firstCloudId = (0, $42omo.useMemo)(()=>{
        if (!cloudIdProp && firstPartyResponse) return $5495cf3bfcd48acd$var$getFirstCloudId(firstPartyResponse);
        return '';
    }, [
        firstPartyResponse,
        cloudIdProp
    ]);
    const { productKeys: thirdPartyProductKeys, outboundAuthConfigs: outboundAuthConfigs } = $5495cf3bfcd48acd$export$4fc2f66fb6e9d067({
        cloudId: cloudIdProp || firstCloudId || '',
        userId: userId,
        absoluteUrl: thirdPartyAbsoluteUrl
    });
    (0, $42omo.useEffect)(()=>{
        if (!firstPartyResponse) (0, $2ec7b123413dd1f0$export$2e9655e8b4177582)({
            cloudId: cloudIdProp,
            absoluteUrl: configFetchAbsoluteUrl,
            hostName: aggregatorHostName,
            userId: userId
        }).then((response)=>setFirstPartyResponse(response)).catch((error)=>{
            logException(error);
            setFirstPartyResponse({
                resources: [],
                intercomHmac: '',
                siteMetadata: []
            });
        });
    }, [
        firstPartyResponse,
        setFirstPartyResponse,
        cloudIdProp,
        configFetchAbsoluteUrl,
        aggregatorHostName,
        userId,
        logException
    ]);
    (0, $42omo.useEffect)(()=>{
        if (thirdPartyProductKeys && firstPartyResponse && !accessibleProducts) {
            let allAccessibleProducts = [];
            const firstPartyProducts = firstPartyResponse.resources.flatMap((resource)=>{
                const { id: id } = resource;
                const match = id.match($5495cf3bfcd48acd$var$EXTRACT_PRODUCT);
                if (match && match.length >= 2) return [
                    match[1]
                ];
                return [];
            });
            if (firstPartyProducts.length === 0 && primaryProduct) // Use the primary product if the 1P Search Config request fails
            allAccessibleProducts.push(primaryProduct);
            else allAccessibleProducts.push(...firstPartyProducts);
            // Remove Bitbucket from the list of resources if Jira is not available.
            // This is because Bitbucket results only come from workspaces that are connected to a corresponding Jira site
            // See https://hello.atlassian.net/wiki/x/1hI6CQE for details
            if (allAccessibleProducts.includes('bitbucket') && !allAccessibleProducts.includes('jira')) allAccessibleProducts = allAccessibleProducts.filter((product)=>product !== 'bitbucket');
            const allProducts = allAccessibleProducts.concat(thirdPartyProductKeys);
            setAccessibleProducts(allProducts);
        }
    }, [
        thirdPartyProductKeys,
        firstPartyResponse,
        setAccessibleProducts,
        primaryProduct,
        accessibleProducts,
        logException
    ]);
    return {
        accessibleProducts: accessibleProducts,
        outboundAuthConfigs: outboundAuthConfigs,
        firstCloudId: firstCloudId,
        intercomHmac: firstPartyResponse?.intercomHmac,
        isNounsAvailable: $5495cf3bfcd48acd$var$isNounsAvailable(firstPartyResponse, cloudIdProp)
    };
};
const $5495cf3bfcd48acd$var$THIRD_PARTY_TYPES = {
    'ai-3p-connector:google-workspace': `drive`,
    'ai-3p-connector:sharepoint-domain': `sharepoint`,
    'ai-3p-connector:slack-workspace': 'slack',
    //platform connector types use a different naming convention
    'sharepoint-connector': `sharepoint`,
    'webcrawler-connector': 'atlassian-web-crawler',
    'microsoft-teams-connector': 'teams',
    'github-connector': 'github',
    'figma-connector': 'figma',
    'onedrive-connector': 'onedrive',
    'dropbox-connector': 'dropbox',
    'google-calendar-connector': 'google-calendar',
    'gmail-conenctor': 'gmail',
    'airtable-connector': 'airtable',
    'notion-connector': 'notion',
    'miro-connector': 'miro'
};
const $5495cf3bfcd48acd$var$get3pProductKeys = async ({ cloudId: cloudId, absoluteUrl: absoluteUrl, userId: userId })=>{
    const resources = await (0, $2ec7b123413dd1f0$export$6916ea7f169882e0)({
        cloudId: cloudId,
        absoluteUrl: absoluteUrl,
        userId: userId
    });
    let productKeys = [];
    let outboundAuthConfigs = {};
    resources.forEach((resource)=>{
        const productKey = $5495cf3bfcd48acd$var$THIRD_PARTY_TYPES[resource.type] || '';
        if (productKey) {
            productKeys.push(productKey);
            outboundAuthConfigs[productKey] = {
                url: resource.outboundAuthUrl,
                userNeedsOAuth: !resource.isUserOAuthed
            };
        }
    });
    productKeys = productKeys.filter((productKey)=>(0, $4sOnC.products)[productKey]);
    return {
        productKeys: productKeys,
        outboundAuthConfigs: outboundAuthConfigs
    };
};
const $5495cf3bfcd48acd$var$EMPTY_RESPONSE = [];
const $5495cf3bfcd48acd$export$4fc2f66fb6e9d067 = ({ cloudId: cloudId, absoluteUrl: absoluteUrl, userId: userId } = {})=>{
    const [productKeys, setProductKeys] = (0, $42omo.useState)(undefined);
    const [outboundAuthConfigs, setOutboundAutConfigs] = (0, $42omo.useState)({});
    const logException = (0, $63afac6f9f5eb800$export$67ff3bc9583d7c16)();
    (0, $42omo.useEffect)(()=>{
        if (!productKeys) {
            if (cloudId) $5495cf3bfcd48acd$var$get3pProductKeys({
                cloudId: cloudId,
                absoluteUrl: absoluteUrl,
                userId: userId
            }).then((data)=>{
                setProductKeys(data.productKeys);
                if (data.outboundAuthConfigs) setOutboundAutConfigs(data.outboundAuthConfigs);
            }).catch((error)=>{
                setProductKeys($5495cf3bfcd48acd$var$EMPTY_RESPONSE);
                logException(error);
            });
            else setProductKeys($5495cf3bfcd48acd$var$EMPTY_RESPONSE);
        }
    }, [
        cloudId,
        absoluteUrl,
        userId,
        productKeys,
        logException
    ]);
    return {
        productKeys: productKeys,
        outboundAuthConfigs: outboundAuthConfigs
    };
};



const $6c2251f1414b2545$export$8a525a626086c807 = ({ children: children, ...props })=>{
    const { cloudId: cloudId, configFetchAbsoluteUrl: configFetchAbsoluteUrl, user: user, thirdPartyAbsoluteUrl: thirdPartyAbsoluteUrl, primaryProduct: primaryProduct, aggAbsoluteUrl: aggAbsoluteUrl, SAINHostName: SAINHostName, aggregatorHostName: aggregatorHostName, orgId: orgId, analyticsAttributes: analyticsAttributes, queryParams: queryParams, features: features, searchSessionId: searchSessionId, isAdminHubAIEnabled: isAdminHubAIEnabled, callbacks: callbacks, styleOverrides: styleOverrides, components: components } = props;
    const { accessibleProducts: accessibleProducts, outboundAuthConfigs: outboundAuthConfigs, firstCloudId: firstCloudId, intercomHmac: intercomHmac, isNounsAvailable: isNounsAvailable } = (0, $5495cf3bfcd48acd$export$2b0ac18f7cd43e19)({
        cloudId: cloudId,
        configFetchAbsoluteUrl: configFetchAbsoluteUrl,
        aggregatorHostName: aggregatorHostName,
        userId: user?.id,
        thirdPartyAbsoluteUrl: thirdPartyAbsoluteUrl,
        primaryProduct: primaryProduct
    });
    const getInitialProps = (0, $42omo.useCallback)(()=>{
        let storeContainerInitialProps = {
            cloudId: cloudId ?? firstCloudId,
            aggAbsoluteUrl: aggAbsoluteUrl,
            SAINHostName: SAINHostName,
            aggregatorHostName: aggregatorHostName,
            user: user,
            primaryProduct: primaryProduct,
            orgId: orgId,
            analyticsAttributes: analyticsAttributes,
            features: features,
            intercomHmac: intercomHmac,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            isNounsAvailable: isNounsAvailable,
            products: [
                (0, $4sOnC.ProductKeys).Confluence
            ],
            allFilterExcludedProducts: [
                (0, $4sOnC.ProductKeys).Trello
            ],
            styleOverrides: styleOverrides,
            components: components
        };
        if (searchSessionId) storeContainerInitialProps.searchSessionId = searchSessionId;
        if (accessibleProducts) {
            const parsedOutboundAuth = (0, $6eeaf2e628370b77$export$550db1eccbaa1ef8).safeParse(outboundAuthConfigs);
            if (parsedOutboundAuth.success) storeContainerInitialProps.outboundAuthConfigs = outboundAuthConfigs;
        }
        return storeContainerInitialProps;
    }, [
        cloudId,
        firstCloudId,
        aggAbsoluteUrl,
        SAINHostName,
        aggregatorHostName,
        user,
        primaryProduct,
        orgId,
        analyticsAttributes,
        features,
        intercomHmac,
        isAdminHubAIEnabled,
        isNounsAvailable,
        searchSessionId,
        accessibleProducts,
        outboundAuthConfigs,
        styleOverrides,
        components
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ee6ce766a2e08634$export$557bf45c8d0f5bd), {
        initialProps: getInitialProps(),
        queryParams: queryParams,
        queryParamsCallback: callbacks?.updateQueryParameters,
        getSpaceIdsFromSpaceKeys: callbacks?.getSpaceIdsFromSpaceKeys,
        children: children
    });
};






parcelRequire("42omo");









const $bf77c4a804d0a68b$export$3776ece9f99ed2df = ({ children: children })=>{
    const intl = (0, $8C5kA.default)();
    const [{ queryParams: queryParams, cloudId: cloudId, aggAbsoluteUrl: aggAbsoluteUrl, initialSpaceARIs: initialSpaceARIs, user: user, products: products, allFilterExcludedProducts: allFilterExcludedProducts }, { setQueryParams: setQueryParams }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const config = {
        intl: intl,
        ari: '',
        cloudId: cloudId,
        userId: user?.id || '',
        initialSpaceARIs: initialSpaceARIs,
        aggAbsoluteUrl: aggAbsoluteUrl
    };
    const { lastModified_lt: lastModified_lt, lastModified_gt: lastModified_gt, ...queryParamsInUse } = queryParams;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7tL1u.SearchStoreContainer), {
        queryParams: queryParamsInUse,
        allFilters: (0, $f04791d97275b682$export$d8428ac7d93fb69a),
        config: config,
        setQueryParams: setQueryParams,
        availableProducts: products,
        allFilterExcludedProducts: allFilterExcludedProducts,
        children: children
    });
};









var $1662I = parcelRequire("1662I");


var $8lMgE = parcelRequire("8lMgE");




const $ed62788e3b53e87a$export$7eaa56945d1970dc = 'kkvkd7ql';






const $e1f3d4648cb567df$var$generateSearchPageVisitedString = ()=>{
    const currentDate = new Date();
    const year = (0, $8lMgE.default)(currentDate);
    const week = (0, $1662I.default)(currentDate);
    return `search_page_visited_${year}_week_${week}`;
};
const $e1f3d4648cb567df$export$2a1369f17c026393 = ({ children: children })=>{
    const { boot: boot, shutdown: shutdown, trackEvent: trackEvent } = (0, $7sS82.useIntercom)();
    const [intercomHmac] = (0, $ee6ce766a2e08634$export$8ab143228c6f49a2)();
    const [userWithStatus] = (0, $ee6ce766a2e08634$export$23bbbc4533528f03)();
    const [features] = (0, $ee6ce766a2e08634$export$4a39035bacc4ed76)();
    const [availableProducts] = (0, $ee6ce766a2e08634$export$5afbfe6edea8e998)();
    const isUserUnauthenticated = userWithStatus.status === (0, $5f67793cebea6085$export$a82073022ded66e8).Unauthenticated;
    (0, $42omo.useEffect)(()=>{
        // Do not boot if sideBySide feature is enabled
        if (features?.sideBySide?.enabled) return;
        // Do not boot if user details are not available
        if (isUserUnauthenticated || !userWithStatus.name || !userWithStatus.email || !intercomHmac) return;
        // Do not boot if there are no products available
        if (availableProducts.length === 0) return;
        const thirdPartyProducts = availableProducts.filter((product)=>(0, $7e38068845a191b0$export$b0f4af9a0173cbfd)(product));
        boot({
            userId: userWithStatus.id ?? undefined,
            name: userWithStatus.name,
            email: userWithStatus.email,
            userHash: intercomHmac,
            customAttributes: {
                // Some intercom users were registered without an email and succeeding
                // bootstrap calls did not update their email.
                // This change is temporary to ensure all users have an attribute that
                // actually stores the email for them :fried_angry_lol_cry:
                atlassian_account_email: userWithStatus.email,
                connected_third_parties: thirdPartyProducts.join(',')
            }
        });
        // A new intercom event will be created each week of the year.
        // Example: search_page_visited_2024_week_29
        // Events: https://app.intercom.com/a/apps/kkvkd7ql/settings/data/people?tab=events
        const eventString = $e1f3d4648cb567df$var$generateSearchPageVisitedString();
        trackEvent(eventString);
        trackEvent('search_page_visited');
        return ()=>{
            shutdown();
        };
    }, [
        availableProducts,
        boot,
        features?.sideBySide?.enabled,
        intercomHmac,
        shutdown,
        isUserUnauthenticated,
        userWithStatus.id,
        userWithStatus.name,
        userWithStatus.email,
        trackEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
        children: children
    });
};

const $e1f3d4648cb567df$var$Intercom = ({ children: children })=>{
    const [intercomAllowed, setIntercomAllowed] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        const loadCheckThirdParty = async ()=>{
            // lazy loaded because this package breaks VR tests and local storybook when upgrading to react-18
            // https://atlassian.slack.com/archives/C05U6KCDNQJ/p1729037211204509?thread_ts=1725415385.613669&cid=C05U6KCDNQJ
            const { checkThirdParty: checkThirdParty } = await (parcelRequire("kTr2t"));
            checkThirdParty('intercom', async ()=>setIntercomAllowed(true), async ()=>setIntercomAllowed(false));
        };
        loadCheckThirdParty();
    }, []);
    if (!intercomAllowed) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7sS82.IntercomProvider), {
        appId: (0, $ed62788e3b53e87a$export$7eaa56945d1970dc),
        children: /*#__PURE__*/ (0, $l998X.jsx)($e1f3d4648cb567df$export$2a1369f17c026393, {
            children: children
        })
    });
};
const $e1f3d4648cb567df$var$IntercomWithErrorBoundary = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $63afac6f9f5eb800$export$e926676385687eaf), {
        fallback: children,
        children: /*#__PURE__*/ (0, $l998X.jsx)($e1f3d4648cb567df$var$Intercom, {
            children: children
        })
    });
};
var $e1f3d4648cb567df$export$2e2bcd8739ae039 = $e1f3d4648cb567df$var$IntercomWithErrorBoundary;












var $6JNBT = parcelRequire("6JNBT");




var $1EqNn = parcelRequire("1EqNn");

const $84c6998916af141a$var$TEAMS_BULK_REST_API_URL = '/gateway/api/v4/teams/withMembers/bulk';
const $84c6998916af141a$var$cache = (0, $1EqNn.inMemoryCache)();
const $84c6998916af141a$export$a4f9b7f788f9e71f = (request)=>{
    const keyObj = {
        teamIds: request.teamIds.sort()
    };
    return (0, $gtxdb.generateHashFromVariables)(keyObj);
};
const $84c6998916af141a$export$eb16261a2bb165d4 = async (request)=>{
    return $84c6998916af141a$var$cache.inMemoryDecorator($84c6998916af141a$export$a4f9b7f788f9e71f(request), ()=>fetch($84c6998916af141a$var$TEAMS_BULK_REST_API_URL, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(request)
        }).then((response)=>{
            if (response.ok) return response.json();
            return Promise.reject({
                teams: [],
                failures: [
                    {
                        teamIds: request.teamIds,
                        description: `Unable to fetch ${$84c6998916af141a$var$TEAMS_BULK_REST_API_URL} ${response.statusText}`,
                        typeId: 'FETCH_ERROR'
                    }
                ]
            });
        }).catch((e)=>{
            return {
                teams: [],
                failures: [
                    {
                        teamIds: request.teamIds,
                        description: e.message,
                        typeId: 'FETCH_ERROR'
                    }
                ]
            };
        }));
};









var $lPWlo = parcelRequire("lPWlo");




var $7xGy0 = parcelRequire("7xGy0");











const $1064ccc276210b2f$export$60bd4eb259acb432 = ()=>{
    const [{ cloudId: cloudId = '', aggregatorHostName: aggregatorHostName }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const [searchQuery] = (0, $7tL1u.useSearchQuery)();
    const [, { setAutoCorrection: setAutoCorrection }] = (0, $7tL1u.useAutoCorrection)();
    (0, $42omo.useEffect)(()=>{
        const searchClient = (0, $6JNBT.createClient)({
            cloudId: cloudId,
            aggregatorHostName: aggregatorHostName
        });
        const containsSearchQuery = searchQuery !== '';
        const shouldGetAutoCorrection = containsSearchQuery;
        if (!shouldGetAutoCorrection) return;
        searchClient.getAutoCorrection({
            query: searchQuery
        }).then((autoCorrection)=>{
            setAutoCorrection(autoCorrection);
        });
    }, [
        searchQuery,
        cloudId,
        setAutoCorrection,
        aggregatorHostName
    ]);
};
const $1064ccc276210b2f$export$c199ac7e412a5a11 = ()=>{
    const [{ cloudId: cloudId = '', aggAbsoluteUrl: aggAbsoluteUrl, primaryProduct: primaryProduct, outboundAuthConfigs: outboundAuthConfigs }] = (0, $ee6ce766a2e08634$export$9ba1f1f28043c5bf)();
    const isSearchReady = (0, $7tL1u.useIsSearchReady)();
    const [searchSessionId] = (0, $ee6ce766a2e08634$export$e1e7a4797df1a656)();
    const [{ order: order, field: field }] = (0, $7tL1u.useResultsSort)();
    const [selectedProduct] = (0, $7tL1u.useSelectedProduct)();
    const fetchFromCursor = (0, $7tL1u.useFetchFromCursor)();
    const { selectedFilters: selectedFilters, unselectedProductsThirdPartyFilters: unselectedProductsThirdPartyFilters, selectedEntities: selectedEntities, entities: entities, hasFiltersSelected: hasFiltersSelected, entitiesForResultsCountQuery: entitiesForResultsCountQuery } = (0, $4b32ad29ed64a485$export$e90e90fddddd8154)({
        outboundAuthConfigs: outboundAuthConfigs
    });
    const [searchQuery] = (0, $7tL1u.useSearchQuery)();
    const [originalQuery] = (0, $7tL1u.useOriginalQuery)();
    const { setJiraIssueDetails: setJiraIssueDetails, setJiraIssueFieldsLoading: setJiraIssueFieldsLoading, setCompassTeamsLoading: setCompassTeamsLoading, setCompassTeams: setCompassTeams, setIsLoading: setIsLoading, setResults: setResults, setQueryUpdatedTime: setQueryUpdatedTime, resetResults: resetResults, setProductResultCount: setProductResultCount, setIsLoadingMore: setIsLoadingMore, appendMoreResults: appendMoreResults } = (0, $7tL1u.useSearchActions)();
    const [retryCount] = (0, $7tL1u.useRetryCount)();
    const requestRef = (0, $42omo.useRef)();
    const [backendExperiment] = (0, $ee6ce766a2e08634$export$9e89c81d9ff2c758)();
    const { experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers } = backendExperiment || {};
    const intercom = (0, $6710de068e8e9e3c$export$f0fed4b0765d7314)();
    const [frontendExperiments] = (0, $ee6ce766a2e08634$export$d2c28b106f1bf70b)();
    const logException = (0, $63afac6f9f5eb800$export$67ff3bc9583d7c16)();
    const trackIntercomEvents = (0, $42omo.useCallback)(()=>{
        if (selectedProduct && (0, $7e38068845a191b0$export$b0f4af9a0173cbfd)(selectedProduct)) intercom?.trackEvent('search_requested_3p', {
            product_filter: selectedProduct
        });
        else intercom?.trackEvent('search_requested');
    }, [
        selectedProduct,
        intercom
    ]);
    // We compare these via deep value equality, as currently the objects are regenerated
    // The bug this fixes is that when adding a filter from a dropdown, we shouldn't cause a search to run or load
    // TODO refactor this so we can go back to Object.is dependency equality on these objects
    const selectedFiltersValueEquality = JSON.stringify(selectedFilters);
    const selectedEntitiesValueEquality = JSON.stringify(selectedEntities);
    const entitiesValueEquality = JSON.stringify(entities);
    const frontendExperimentsValueEquality = JSON.stringify(frontendExperiments);
    const experimentLayersValueEquality = JSON.stringify(experimentLayers);
    (0, $42omo.useEffect)(()=>{
        if (!isSearchReady) return;
        // Reset results when...
        // 1. There is no search query
        // 2. There is no selected product or the selected product is not Confluence
        // 3. There are no selected child filters
        const containsSearchQuery = searchQuery !== '';
        const confluenceIsSelected = selectedProduct === 'confluence';
        const shouldTriggerSearch = containsSearchQuery || containsSearchQuery && hasFiltersSelected || confluenceIsSelected;
        // Reset results and cancel inflight requests if we are not searching
        if (!shouldTriggerSearch) {
            if (requestRef.current) requestRef.current.cancel();
            resetResults();
            return;
        }
        // Cancel the inflight request if there is one
        if (requestRef.current) requestRef.current.cancel();
        setProductResultCount();
        const restartUFOExperience = async ()=>{
            if (requestRef.current) await (0, $c00ebe4ee56aadce$export$e882a2ec68d19be8).abort();
            await (0, $c00ebe4ee56aadce$export$e882a2ec68d19be8).start();
            (0, $c00ebe4ee56aadce$export$e882a2ec68d19be8).mark('request_start');
        };
        restartUFOExperience();
        if (fetchFromCursor && fetchFromCursor !== '') setIsLoadingMore(true);
        else setIsLoading(true);
        setQueryUpdatedTime();
        requestRef.current = new (0, $143bf33eb5bdc702$export$5782acf08706f13d)((0, $2803a5b285916c4e$export$46f82b8a3ce2a183)({
            query: searchQuery,
            originalQuery: originalQuery,
            entities: entities,
            selectedFilters: selectedFilters,
            aggAbsoluteUrl: aggAbsoluteUrl,
            cloudId: cloudId,
            searchSessionId: searchSessionId,
            sort: {
                order: order,
                field: field
            },
            sourceProduct: primaryProduct,
            experimentId: experimentId,
            shadowExperimentId: shadowExperimentId,
            experimentLayers: experimentLayers,
            after: fetchFromCursor,
            limit: entities.length === (0, $lPWlo.DEFAULT_ENTITY_ATI).length ? (0, $lPWlo.RESULT_LIMIT_FOR_MULTIPLE_PRODUCTS) : (0, $lPWlo.RESULT_LIMIT_FOR_SINGLE_PRODUCT)
        }));
        requestRef.current.promise().then((aggResults)=>{
            const { data: data, extensions: extensions, errors: errors } = aggResults;
            const errorMessage = errors?.[0]?.message;
            const resultsFetchError = errorMessage ? new (0, $2803a5b285916c4e$export$94cd2e6f39615373)(errorMessage) : undefined;
            if (fetchFromCursor && fetchFromCursor !== '') appendMoreResults(data?.search.results);
            else setResults(data?.search.results, resultsFetchError, extensions?.gateway?.request_id || undefined);
            setProductResultCount(data?.search.results.totalCounts || []);
            trackIntercomEvents();
            (0, $c00ebe4ee56aadce$export$e882a2ec68d19be8).mark('request_end');
            (0, $c00ebe4ee56aadce$export$e882a2ec68d19be8).mark('render_start');
            resultsFetchError && logException(resultsFetchError);
            const edges = data?.search.results.edges;
            // Fetch extra fields for Issues
            const issuesToFetch = [];
            // Fetch team names associated with the teamIds in Compass results
            const teamsIdsToFetch = [];
            if (edges && edges.length > 0) edges.forEach((edge)=>{
                if ((0, $ERUZZ.isSearchResultJiraIssue)(edge.node)) {
                    const issueKey = edge.node.issue?.webUrl?.split('/').at(-1) || edge.node.url.split('/').at(-1);
                    if (!!issueKey) issuesToFetch.push(issueKey);
                } else if ((0, $bGd7w.isSearchCompassPartial)(edge.node)) {
                    const teamId = (0, $7xGy0.getTeamId)(edge.node.ownerId);
                    if (teamId && !teamsIdsToFetch.includes(teamId)) teamsIdsToFetch.push(teamId);
                }
            });
            if (issuesToFetch.length > 0) {
                setJiraIssueFieldsLoading(true);
                (0, $2803a5b285916c4e$export$6405a4ba66d50345)({
                    issueKeys: issuesToFetch,
                    cloudId: cloudId,
                    aggAbsoluteUrl: aggAbsoluteUrl
                }).then((jiraHydrationResults)=>{
                    const issues = jiraHydrationResults.data?.jira.issuesByKey;
                    setJiraIssueDetails(issues || []);
                }).finally(()=>{
                    setJiraIssueFieldsLoading(false);
                });
            }
            if (teamsIdsToFetch.length > 0) {
                setCompassTeamsLoading(true);
                (0, $84c6998916af141a$export$eb16261a2bb165d4)({
                    siteId: cloudId,
                    teamIds: teamsIdsToFetch
                }).then((data)=>{
                    setCompassTeams(data.teams);
                }).finally(()=>{
                    setCompassTeamsLoading(false);
                });
            }
        }).catch((e)=>{
            if (e instanceof (0, $2803a5b285916c4e$export$8ba86dff7c04c14c)) setResults(undefined, e);
            else if (!(e instanceof (0, $143bf33eb5bdc702$export$d7f5e52d091a66db))) {
                setResults(undefined, new (0, $2803a5b285916c4e$export$94cd2e6f39615373)(e.message));
                setProductResultCount([]);
                trackIntercomEvents();
            }
        });
        const { commonFilters: commonFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters } = selectedFilters;
        const resultsCountVariables = {
            query: searchQuery,
            queryVersion: 1,
            cloudIdARI: `ari:cloud:confluence::site/${cloudId}`,
            limit: 0,
            commonFilters: commonFilters,
            confluenceFilters: confluenceFilters,
            jiraFilters: jiraFilters,
            thirdPartyFilters: unselectedProductsThirdPartyFilters,
            entities: entitiesForResultsCountQuery,
            searchSessionId: searchSessionId,
            sort: [],
            sourceProduct: primaryProduct
        };
        const showResultCounts = false;
        if (showResultCounts) (0, $glYzA.resultsCountQuery)({
            variables: resultsCountVariables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            originalQuery: originalQuery
        }).then((resultsCountData)=>{
            setProductResultCount(resultsCountData?.data?.search.results.totalCounts || []);
        }).catch(()=>{
            setProductResultCount([]);
        });
    // Note! Please ensure all dependencies are actually here, we're just trying to ignore the xValueEquality ones
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isSearchReady,
        resetResults,
        searchQuery,
        originalQuery,
        selectedFiltersValueEquality,
        selectedEntitiesValueEquality,
        entitiesValueEquality,
        selectedProduct,
        hasFiltersSelected,
        setIsLoading,
        setResults,
        setQueryUpdatedTime,
        setProductResultCount,
        searchSessionId,
        aggAbsoluteUrl,
        cloudId,
        retryCount,
        field,
        order,
        primaryProduct,
        experimentId,
        experimentLayersValueEquality,
        shadowExperimentId,
        trackIntercomEvents,
        frontendExperimentsValueEquality,
        fetchFromCursor
    ]);
};






var $5loD0 = parcelRequire("5loD0");





const $b42b49fb3a6258e5$export$f86c748bd13d5f7a = ()=>{
    const [cloudId] = (0, $ee6ce766a2e08634$export$9da0f7c65f28ed16)();
    const [spotlight, { start: start, end: end }] = (0, $79f0e1d5b0d8f48f$export$a771c137b2620ff2)();
    const requestRef = (0, $42omo.useRef)();
    const coordinationClient = (0, $42omo.useMemo)(()=>{
        if (!cloudId || cloudId === '') return {
            start: (_)=>Promise.resolve(false),
            stop: (_)=>Promise.resolve(false)
        };
        const client = new (0, $5loD0.default)({
            cloudId: cloudId,
            stargateUrl: '/gateway/api'
        });
        return client;
    }, [
        cloudId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (requestRef.current) return;
        requestRef.current = new (0, $143bf33eb5bdc702$export$5782acf08706f13d)(coordinationClient.start((0, $930693b11d26c5f4$export$d2ea4f931a71a509)));
        requestRef.current.promise().then((displaySpotlight)=>{
            displaySpotlight ? start() : end();
        }).catch((_)=>{
            end();
        });
    // The network request for the spotlight exposure should only ever be called once.
    // Otherwise, it will cause conflicts and the spotlight will never be rendered.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (spotlight.state === 'dismiss') coordinationClient.stop((0, $930693b11d26c5f4$export$d2ea4f931a71a509));
    }, [
        coordinationClient,
        spotlight.state
    ]);
};



const $022936a4e76930f4$var$FetchResults = ()=>{
    (0, $1064ccc276210b2f$export$c199ac7e412a5a11)();
    return null;
};
const $022936a4e76930f4$var$SpotlightPrefetch = ()=>{
    (0, $b42b49fb3a6258e5$export$f86c748bd13d5f7a)();
    return null;
};
const $022936a4e76930f4$export$da0f89c65081f644 = ({ children: children })=>{
    const [features] = (0, $ee6ce766a2e08634$export$4a39035bacc4ed76)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
        children: [
            Boolean(features?.fetchInitialResults?.enabled) && /*#__PURE__*/ (0, $l998X.jsx)($022936a4e76930f4$var$FetchResults, {}),
            Boolean(features?.engagement?.enabled) && /*#__PURE__*/ (0, $l998X.jsx)($022936a4e76930f4$var$SpotlightPrefetch, {}),
            children
        ]
    });
};


const $90803853ae77bc7f$var$ConditionalSpotlightManager = ({ children: children })=>{
    const [features] = (0, $ee6ce766a2e08634$export$4a39035bacc4ed76)();
    if (features?.engagement?.enabled) return (0, $1oCLl.expValEquals)('company_hub_deprecate_atlaskit_onboarding', 'isEnabled', true) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $k7Tf7.PopoverProvider), {
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $6cnUO.default), {
        blanketIsTinted: false,
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
const $90803853ae77bc7f$export$794614fa392eb573 = ({ children: children, ...props })=>{
    const { mapUserIdToProfileUrl: mapUserIdToProfileUrl, linkComponent: linkComponent, generateSearchUrl: generateSearchUrl, queryParams: queryParams, onNavigate: onNavigate } = props;
    // Ensure callback is stable by using the initial value only
    const mapUserIdToProfileUrlRef = (0, $42omo.useRef)(mapUserIdToProfileUrl);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $4cde92b339c1c935$export$1d29bcde96a75168), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6c2251f1414b2545$export$8a525a626086c807), {
            ...props,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bf77c4a804d0a68b$export$3776ece9f99ed2df), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $e1f3d4648cb567df$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)($90803853ae77bc7f$var$ConditionalSpotlightManager, {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cdf2753c4aea5699$export$20d2b7652facc723), {
                            linkComponent: linkComponent,
                            mapUserIdToProfileUrl: mapUserIdToProfileUrlRef.current,
                            generateSearchUrl: generateSearchUrl,
                            queryParams: queryParams,
                            onNavigate: onNavigate,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $022936a4e76930f4$export$da0f89c65081f644), {
                                children: children
                            })
                        })
                    })
                })
            })
        })
    });
};


const $8064608dea96676e$export$a54ec244c8863715 = ({ shell: shell, callbacks: callbacks, mapUserIdToProfileUrl: mapUserIdToProfileUrl, linkComponent: linkComponent })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $90803853ae77bc7f$export$794614fa392eb573), {
        ...shell,
        callbacks: callbacks,
        mapUserIdToProfileUrl: mapUserIdToProfileUrl,
        linkComponent: linkComponent,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bdcfd319a02b1672$export$75f7910544138d14), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $281ad989c301d00c$export$c84671f46d6a1ca), {
                components: {
                    filters: /*#__PURE__*/ (0, $l998X.jsx)((0, $ad6043c85560ba2d$export$2e2bcd8739ae039), {}),
                    results: /*#__PURE__*/ (0, $l998X.jsx)((0, $1d774dbe5a25c5b8$export$b4ce9e0c6695ed08), {})
                }
            })
        })
    });
const $8064608dea96676e$export$9303e6cdcc95142a = ({ shell: shell, callbacks: callbacks, mapUserIdToProfileUrl: mapUserIdToProfileUrl, linkComponent: linkComponent, filtersToHide: filtersToHide })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $90803853ae77bc7f$export$794614fa392eb573), {
        ...shell,
        callbacks: callbacks,
        mapUserIdToProfileUrl: mapUserIdToProfileUrl,
        linkComponent: linkComponent,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bdcfd319a02b1672$export$75f7910544138d14), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $281ad989c301d00c$export$c84671f46d6a1ca), {
                components: {
                    filters: /*#__PURE__*/ (0, $l998X.jsx)((0, $ad6043c85560ba2d$export$4f7c5f9bd9ac3227), {
                        filtersToHide: filtersToHide
                    })
                },
                disableHeaderGridStyles: true
            })
        })
    });
const $8064608dea96676e$export$55d7609a8f1eccd2 = ({ shell: shell, callbacks: callbacks, mapUserIdToProfileUrl: mapUserIdToProfileUrl, generateSearchUrl: generateSearchUrl, linkComponent: linkComponent })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $90803853ae77bc7f$export$794614fa392eb573), {
        ...shell,
        callbacks: callbacks,
        mapUserIdToProfileUrl: mapUserIdToProfileUrl,
        generateSearchUrl: generateSearchUrl,
        linkComponent: linkComponent,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bdcfd319a02b1672$export$75f7910544138d14), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9d8cb4bdc48da54f$export$2e2bcd8739ae039), {})
        })
    });
module.exports["SearchPage"] = $8064608dea96676e$export$a54ec244c8863715;
module.exports["CustomSearchMacroConfigFilters"] = $8064608dea96676e$export$9303e6cdcc95142a;
module.exports["SearchInput"] = $8064608dea96676e$export$55d7609a8f1eccd2;

});

parcelRegister("7sS82", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $56f522c14424b615$var$ce = Object.defineProperty;
var $56f522c14424b615$var$v = Object.getOwnPropertySymbols;
var $56f522c14424b615$var$X = Object.prototype.hasOwnProperty, $56f522c14424b615$var$Y = Object.prototype.propertyIsEnumerable;
var $56f522c14424b615$var$Q = (e, o, a)=>o in e ? $56f522c14424b615$var$ce(e, o, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: a
    }) : e[o] = a, $56f522c14424b615$var$m = (e, o)=>{
    for(var a in o || (o = {}))$56f522c14424b615$var$X.call(o, a) && $56f522c14424b615$var$Q(e, a, o[a]);
    if ($56f522c14424b615$var$v) for (var a of $56f522c14424b615$var$v(o))$56f522c14424b615$var$Y.call(o, a) && $56f522c14424b615$var$Q(e, a, o[a]);
    return e;
};
var $56f522c14424b615$var$Z = (e, o)=>{
    var a = {};
    for(var c in e)$56f522c14424b615$var$X.call(e, c) && o.indexOf(c) < 0 && (a[c] = e[c]);
    if (e != null && $56f522c14424b615$var$v) for (var c of $56f522c14424b615$var$v(e))o.indexOf(c) < 0 && $56f522c14424b615$var$Y.call(e, c) && (a[c] = e[c]);
    return a;
};
var $56f522c14424b615$var$w = (e, o)=>{
    let a = "[react-use-intercom]";
    switch(e){
        case "info":
            console.log(`${a} ${o}`);
            break;
        case "warn":
            console.warn(`${a} ${o}`);
            break;
        case "error":
            console.error(`${a} ${o}`);
            break;
        default:
            console.log(`${a} ${o}`);
    }
};
var $56f522c14424b615$var$h = typeof window == "undefined", $56f522c14424b615$var$A = (e)=>(Object.keys(e).forEach((o)=>{
        e[o] && typeof e[o] == "object" ? $56f522c14424b615$var$A(e[o]) : e[o] === void 0 && delete e[o];
    }), e);
var $56f522c14424b615$var$ie = (e, ...o)=>{
    if (!$56f522c14424b615$var$h && window.Intercom) return window.Intercom.apply(null, [
        e,
        ...o
    ]);
    $56f522c14424b615$var$w("error", `${e} Intercom instance is not initalized yet`);
}, $56f522c14424b615$var$s = $56f522c14424b615$var$ie;
var $56f522c14424b615$var$me = $42omo.createContext(void 0), $56f522c14424b615$var$b = $56f522c14424b615$var$me;
var $56f522c14424b615$var$le = (e, o = 0)=>{
    var a = window, c = a.Intercom;
    if (typeof c == "function") c("reattach_activator"), c("update", a.intercomSettings);
    else {
        var f = document, l = function() {
            l.c(arguments);
        };
        l.q = [], l.c = function(u) {
            l.q.push(u);
        }, a.Intercom = l;
        var p = function() {
            setTimeout(function() {
                var u = f.createElement("script");
                u.type = "text/javascript", u.async = !0, u.src = "https://widget.intercom.io/widget/" + e;
                var d = f.getElementsByTagName("script")[0];
                d.parentNode.insertBefore(u, d);
            }, o);
        };
        document.readyState === "complete" ? p() : a.attachEvent ? a.attachEvent("onload", p) : a.addEventListener("load", p, !1);
    }
}, $56f522c14424b615$var$oe = $56f522c14424b615$var$le;
var $56f522c14424b615$var$ue = (e)=>({
        custom_launcher_selector: e.customLauncherSelector,
        alignment: e.alignment,
        vertical_padding: e.verticalPadding,
        horizontal_padding: e.horizontalPadding,
        hide_default_launcher: e.hideDefaultLauncher,
        session_duration: e.sessionDuration,
        action_color: e.actionColor,
        background_color: e.backgroundColor
    }), $56f522c14424b615$var$re = (e)=>$56f522c14424b615$var$m({
        company_id: e.companyId,
        name: e.name,
        created_at: e.createdAt,
        plan: e.plan,
        monthly_spend: e.monthlySpend,
        user_count: e.userCount,
        size: e.size,
        website: e.website,
        industry: e.industry
    }, e.customAttributes), $56f522c14424b615$var$de = (e)=>({
        type: e.type,
        image_url: e.imageUrl
    }), $56f522c14424b615$var$pe = (e)=>{
    var o;
    return $56f522c14424b615$var$m({
        email: e.email,
        user_id: e.userId,
        created_at: e.createdAt,
        name: e.name,
        phone: e.phone,
        last_request_at: e.lastRequestAt,
        unsubscribed_from_emails: e.unsubscribedFromEmails,
        language_override: e.languageOverride,
        utm_campaign: e.utmCampaign,
        utm_content: e.utmContent,
        utm_medium: e.utmMedium,
        utm_source: e.utmSource,
        utm_term: e.utmTerm,
        avatar: e.avatar && $56f522c14424b615$var$de(e.avatar),
        user_hash: e.userHash,
        company: e.company && $56f522c14424b615$var$re(e.company),
        companies: (o = e.companies) == null ? void 0 : o.map($56f522c14424b615$var$re)
    }, e.customAttributes);
}, $56f522c14424b615$var$k = (e)=>$56f522c14424b615$var$A($56f522c14424b615$var$m($56f522c14424b615$var$m({}, $56f522c14424b615$var$ue(e)), $56f522c14424b615$var$pe(e)));
var $56f522c14424b615$export$5091c5023e5c7eba = (ge)=>{
    var _ = ge, { appId: e, autoBoot: o = !1, autoBootProps: a, children: c, onHide: f, onShow: l, onUnreadCountChange: p, onUserEmailSupplied: u, shouldInitialize: d = !$56f522c14424b615$var$h, apiBase: C, initializeDelay: P } = _, ae = $56f522c14424b615$var$Z(_, [
        "appId",
        "autoBoot",
        "autoBootProps",
        "children",
        "onHide",
        "onShow",
        "onUnreadCountChange",
        "onUserEmailSupplied",
        "shouldInitialize",
        "apiBase",
        "initializeDelay"
    ]);
    let g = $42omo.useRef(!1), y = $42omo.useRef(!1), [x, R] = $42omo.useState(!1), S = Object.keys(ae).filter((r)=>!r.startsWith("data-"));
    S.length > 0 && $56f522c14424b615$var$w("warn", [
        "some invalid props were passed to IntercomProvider. ",
        `Please check following props: ${S.join(", ")}.`
    ].join(""));
    let D = $42omo.useCallback(()=>{
        R(!1), f && f();
    }, [
        f,
        R
    ]), M = $42omo.useCallback(()=>{
        R(!0), l && l();
    }, [
        l,
        R
    ]), I = $42omo.useCallback((r)=>{
        if (!window.Intercom && !d) {
            $56f522c14424b615$var$w("warn", "Intercom instance is not initialized because `shouldInitialize` is set to `false` in `IntercomProvider`");
            return;
        }
        $56f522c14424b615$var$s("onHide", D), $56f522c14424b615$var$s("onShow", M), $56f522c14424b615$var$s("onUserEmailSupplied", u), p && $56f522c14424b615$var$s("onUnreadCountChange", p);
        let i = $56f522c14424b615$var$m($56f522c14424b615$var$m({
            app_id: e
        }, C && {
            api_base: C
        }), r && $56f522c14424b615$var$k(r));
        window.intercomSettings = i, $56f522c14424b615$var$s("boot", i), g.current = !0;
    }, [
        C,
        e,
        D,
        M,
        p,
        u,
        d
    ]);
    $42omo.useEffect(()=>{
        !$56f522c14424b615$var$h && d && !y.current && ($56f522c14424b615$var$oe(e, P), o && I(a), y.current = !0);
    }, [
        e,
        o,
        a,
        I,
        P,
        d
    ]);
    let n = $42omo.useCallback((r, i)=>{
        if (!window.Intercom && !d) {
            $56f522c14424b615$var$w("warn", "Intercom instance is not initialized because `shouldInitialize` is set to `false` in `IntercomProvider`");
            return;
        }
        if (!g.current) {
            $56f522c14424b615$var$w("warn", [
                `"${r}" was called but Intercom has not booted yet. `,
                `Please call 'boot' before calling '${r}' or `,
                "set 'autoBoot' to true in the IntercomProvider."
            ].join(""));
            return;
        }
        return i();
    }, [
        d
    ]), T = $42omo.useCallback(()=>{
        g.current && ($56f522c14424b615$var$s("shutdown"), delete window.intercomSettings, g.current = !1);
    }, []), E = $42omo.useCallback(()=>{
        g.current && ($56f522c14424b615$var$s("shutdown"), delete window.Intercom, delete window.intercomSettings, g.current = !1);
    }, []), $ = $42omo.useCallback(()=>{
        n("update", ()=>{
            let r = Math.floor(new Date().getTime() / 1e3);
            $56f522c14424b615$var$s("update", {
                last_request_at: r
            });
        });
    }, [
        n
    ]), N = $42omo.useCallback((r)=>{
        n("update", ()=>{
            if (!r) {
                $();
                return;
            }
            let i = $56f522c14424b615$var$k(r);
            window.intercomSettings = $56f522c14424b615$var$m($56f522c14424b615$var$m({}, window.intercomSettings), i), $56f522c14424b615$var$s("update", i);
        });
    }, [
        n,
        $
    ]), V = $42omo.useCallback(()=>{
        n("hide", ()=>{
            $56f522c14424b615$var$s("hide");
        });
    }, [
        n
    ]), L = $42omo.useCallback(()=>{
        n("show", ()=>$56f522c14424b615$var$s("show"));
    }, [
        n
    ]), z = $42omo.useCallback(()=>{
        n("showMessages", ()=>{
            $56f522c14424b615$var$s("showMessages");
        });
    }, [
        n
    ]), q = $42omo.useCallback((r)=>{
        n("showNewMessage", ()=>{
            r ? $56f522c14424b615$var$s("showNewMessage", r) : $56f522c14424b615$var$s("showNewMessage");
        });
    }, [
        n
    ]), O = $42omo.useCallback(()=>n("getVisitorId", ()=>$56f522c14424b615$var$s("getVisitorId")), [
        n
    ]), W = $42omo.useCallback((r)=>{
        n("startTour", ()=>{
            $56f522c14424b615$var$s("startTour", r);
        });
    }, [
        n
    ]), j = $42omo.useCallback((r)=>{
        n("startChecklist", ()=>{
            $56f522c14424b615$var$s("startChecklist", r);
        });
    }, [
        n
    ]), B = $42omo.useCallback((r, i)=>{
        n("trackEvent", ()=>{
            i ? $56f522c14424b615$var$s("trackEvent", r, i) : $56f522c14424b615$var$s("trackEvent", r);
        });
    }, [
        n
    ]), F = $42omo.useCallback((r)=>n("showArticle", ()=>{
            $56f522c14424b615$var$s("showArticle", r);
        }), [
        n
    ]), U = $42omo.useCallback((r)=>n("showSpace", ()=>{
            $56f522c14424b615$var$s("showSpace", r);
        }), [
        n
    ]), H = $42omo.useCallback((r)=>{
        n("startSurvey", ()=>{
            $56f522c14424b615$var$s("startSurvey", r);
        });
    }, [
        n
    ]), K = $42omo.useCallback((r)=>n("showNews", ()=>{
            $56f522c14424b615$var$s("showNews", r);
        }), [
        n
    ]), G = $42omo.useCallback((r)=>n("showTicket", ()=>{
            $56f522c14424b615$var$s("showTicket", r);
        }), [
        n
    ]), J = $42omo.useCallback((r)=>n("showConversation", ()=>{
            $56f522c14424b615$var$s("showConversation", r);
        }), [
        n
    ]), se = $42omo.useMemo(()=>({
            boot: I,
            shutdown: T,
            hardShutdown: E,
            update: N,
            hide: V,
            show: L,
            isOpen: x,
            showMessages: z,
            showNewMessage: q,
            getVisitorId: O,
            startTour: W,
            startChecklist: j,
            trackEvent: B,
            showArticle: F,
            startSurvey: H,
            showSpace: U,
            showNews: K,
            showTicket: G,
            showConversation: J
        }), [
        I,
        T,
        E,
        N,
        V,
        L,
        x,
        z,
        q,
        O,
        W,
        j,
        B,
        F,
        H,
        U,
        K,
        G,
        J
    ]);
    return $42omo.createElement($56f522c14424b615$var$b.Provider, {
        value: se
    }, c);
}, $56f522c14424b615$var$ne = ()=>{
    let e = $42omo.useContext($56f522c14424b615$var$b);
    if (e === void 0) throw new Error('"useIntercom" must be used within `IntercomProvider`.');
    return e;
};
var $56f522c14424b615$export$624db904a0be2d69 = ()=>$56f522c14424b615$var$ne();
 //# sourceMappingURL=out.js.map
module.exports["IntercomProvider"] = $56f522c14424b615$export$5091c5023e5c7eba;
module.exports["useIntercom"] = $56f522c14424b615$export$624db904a0be2d69;

});

parcelRegister("bKOxc", function(module, exports) {
$parcel$export(module.exports, "default", () => $88eb30b23e388990$export$2e2bcd8739ae039);

var $jZ39j = parcelRequire("jZ39j");


var $lshox = parcelRequire("lshox");


var $b5utg = parcelRequire("b5utg");

function $88eb30b23e388990$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $b5utg.default)(2, arguments);
    var amount = (0, $jZ39j.default)(dirtyAmount);
    return (0, $lshox.default)(dirtyDate, amount * 1000);
}

});

parcelRegister("1662I", function(module, exports) {
$parcel$export(module.exports, "default", () => $0ccb09ee82030ea4$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $ghphD = parcelRequire("ghphD");


var $b5utg = parcelRequire("b5utg");

function $a322980fc7bdc1cb$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    return (0, $ghphD.default)(dirtyDate, {
        weekStartsOn: 1
    });
}









function $2ba63f43afaf9481$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $a322980fc7bdc1cb$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $a322980fc7bdc1cb$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $47f7d34a77e920df$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var year = (0, $2ba63f43afaf9481$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, $a322980fc7bdc1cb$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}





var $0ccb09ee82030ea4$var$MILLISECONDS_IN_WEEK = 604800000;
function $0ccb09ee82030ea4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var diff = (0, $a322980fc7bdc1cb$export$2e2bcd8739ae039)(date).getTime() - (0, $47f7d34a77e920df$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $0ccb09ee82030ea4$var$MILLISECONDS_IN_WEEK) + 1;
}

});

parcelRegister("8lMgE", function(module, exports) {
$parcel$export(module.exports, "default", () => $6145b9d2a216bb48$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $6145b9d2a216bb48$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b5utg.default)(1, arguments);
    return (0, $egXhZ.default)(dirtyDate).getFullYear();
}

});

parcelRegister("kTr2t", function(module, exports) {

let $f35deb0a65135c3b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f35deb0a65135c3b$var$load("9FU4d"),
    $f35deb0a65135c3b$var$load("gctwz"),
    $f35deb0a65135c3b$var$load("hhss7"),
    $f35deb0a65135c3b$var$load("7EorR"),
    $f35deb0a65135c3b$var$load("1mxeO")
]).then(()=>parcelRequire('32tSg'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("lWQ5z", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $6r7Ix = parcelRequire("6r7Ix");

var $6UUyu = parcelRequire("6UUyu");

var $4cOi8 = parcelRequire("4cOi8");

var $3VS69 = parcelRequire("3VS69");

var $fOKpq = parcelRequire("fOKpq");


var $lf1vG = parcelRequire("lf1vG");




const $45e22698d0407c9c$var$updateNodeParameters = (editorActions, updatedParameters)=>{
    const selectedNodeJSON = editorActions.getSelectedNode()?.toJSON();
    const updatedNodeSelection = {
        ...selectedNodeJSON,
        attrs: {
            ...selectedNodeJSON?.attrs,
            parameters: {
                ...updatedParameters
            }
        }
    };
    editorActions.replaceSelection(updatedNodeSelection, true);
};
const $45e22698d0407c9c$var$fetchLocalIdMacroParameters = (editorActions, localId)=>{
    const localIdNode = editorActions?.getNodeByLocalId?.(localId)?.toJSON();
    let params = localIdNode?.attrs?.parameters;
    if (params === undefined) return undefined;
    // Make a copy of the params object to avoid mutating the original object
    params = {
        ...params
    };
    return params;
};
const $45e22698d0407c9c$var$removeProperties = (extensionsPropertiesToRemove, extensionParameters)=>{
    const mutatedParameters = {
        ...extensionParameters
    };
    extensionsPropertiesToRemove.forEach((field)=>{
        if (field in mutatedParameters) delete mutatedParameters[field];
    });
    return mutatedParameters;
};
const $45e22698d0407c9c$export$d78d7700cec50018 = ({ localId: localId, editorActions: editorActions })=>{
    const [extensionParameters, setExtensionParameters] = (0, $42omo.useState)($45e22698d0407c9c$var$fetchLocalIdMacroParameters(editorActions, localId));
    (0, $42omo.useEffect)(()=>{
        const extensionNodeParams = $45e22698d0407c9c$var$fetchLocalIdMacroParameters(editorActions, localId);
        setExtensionParameters(extensionNodeParams);
    }, [
        editorActions,
        localId
    ]);
    const updateExtensionParams = (0, $42omo.useCallback)((newExtensionParameters, options = {})=>{
        setExtensionParameters((prevParams)=>{
            let mutatedFields = {
                ...prevParams
            };
            const fieldsToRemove = [
                ...options?.fieldsToRemove || []
            ];
            if (fieldsToRemove.length > 0) mutatedFields = $45e22698d0407c9c$var$removeProperties(fieldsToRemove, prevParams);
            const updatedParams = {
                ...mutatedFields,
                ...newExtensionParameters
            };
            // Save params to ADF and state
            $45e22698d0407c9c$var$updateNodeParameters(editorActions, updatedParams);
            return updatedParams;
        });
    }, [
        editorActions
    ]);
    const updateMainFormField = (0, $42omo.useCallback)((updatedFields, options = {})=>updateExtensionParams(updatedFields, options), [
        updateExtensionParams
    ]);
    const extensionActions = (0, $42omo.useMemo)(()=>({
            updateMainFormField: updateMainFormField
        }), [
        updateMainFormField
    ]);
    return {
        extensionParameters: extensionParameters,
        extensionActions: extensionActions
    };
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $cO1el = parcelRequire("cO1el");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $1GzhS = parcelRequire("1GzhS");


var $l3R5C = parcelRequire("l3R5C");


var $eqHN5 = parcelRequire("eqHN5");


var $cgtv4 = parcelRequire("cgtv4");

const $0db3e72ff6cf30a3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    filtersTitle: {
        id: "company-hub.search-extension.custom-search-config-panel.filters-title",
        defaultMessage: "Filters"
    }
});


const $9a203b7715b6cb34$var$cssStyles = {
    container: "_1q51pxbi _uwhke4h9 _1i531l7x _15a5nqa1 _85i5pxbi _1doce4h9 _1o3i1l7x _1il9nqa1 _6rthpxbi",
    header: "_18zru2gc"
};
const $9a203b7715b6cb34$export$41dc5c54b6ccd429 = ({ filters: filters, setFilters: setFilters, cloudId: cloudId, userId: userId, displayName: displayName, orgId: orgId, isAdminHubAIEnabled: isAdminHubAIEnabled })=>{
    const getSpaceIdsFromSpaceKeys = (0, $l3R5C.useGetSpaceIdsFromSpaceKeys)();
    const setFiltersInternal = (0, $42omo.useCallback)((newFilters)=>{
        setFilters({
            ...newFilters,
            product: 'confluence'
        });
    }, [
        setFilters
    ]);
    const userDetails = (0, $42omo.useMemo)(()=>{
        return {
            id: userId,
            name: displayName
        };
    }, [
        userId,
        displayName
    ]);
    const filtersToHide = (0, $42omo.useMemo)(()=>{
        // Only enable unified search if:
        // - User is in unified search beta and
        const isUnifiedSearchEnabled = (0, $dh538.fg)('unified_search_in_confluence'); // The "Type" filter is hidden because the current available options are a subset of
        // those on the full search page. This misalignment creats a poor user experience.
        //
        // The "Owner" filter is hidden when unified search is disabled because it is not supported by the
        // non-unified full search page.
        return isUnifiedSearchEnabled ? [
            'universalTypeFilter'
        ] : [
            'universalTypeFilter',
            'owner'
        ];
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
        space: "space.100",
        xcss: $9a203b7715b6cb34$var$cssStyles.container,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: $9a203b7715b6cb34$var$cssStyles.header,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                    size: "small",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $0db3e72ff6cf30a3$export$defe85febe8b728c).filtersTitle
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $eqHN5.CustomSearchMacroConfigFilters), {
                shell: {
                    cloudId: cloudId,
                    orgId: orgId,
                    user: userDetails,
                    primaryProduct: 'confluence',
                    queryParams: filters,
                    isAdminHubAIEnabled: isAdminHubAIEnabled
                },
                callbacks: {
                    updateQueryParameters: setFiltersInternal,
                    getSpaceIdsFromSpaceKeys: getSpaceIdsFromSpaceKeys
                },
                filtersToHide: filtersToHide
            })
        ]
    });
};





const $43761b7b74817414$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    title: {
        id: "company-hub.search-extension.custom-search-config-panel.title",
        defaultMessage: "Custom search"
    },
    preamble: {
        id: "company-hub.search-extension.custom-search-config-panel.preamble",
        defaultMessage: "Add a filtered search bar"
    }
});


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");





var $eXmBZ = parcelRequire("eXmBZ");




var $dcJ7R = parcelRequire("dcJ7R");



var $5dK2X = parcelRequire("5dK2X");


var $fVUfS = parcelRequire("fVUfS");


var $4noo5 = parcelRequire("4noo5");


var $3gadb = parcelRequire("3gadb");


var $5n7dr = parcelRequire("5n7dr");

var $fQWPs = parcelRequire("fQWPs");

var $1u5CA = parcelRequire("1u5CA");


var $4K9rx = parcelRequire("4K9rx");

var $4VyWY = parcelRequire("4VyWY");






const $4a3bf14b7c41e22e$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    stylesTitle: {
        id: "company-hub.search-extension.custom-search-config-panel.styles-title",
        defaultMessage: "Styles"
    },
    fillColorLabel: {
        id: "company-hub.search-extension.custom-search-config-panel.styles-fill-color-label",
        defaultMessage: "Fill color"
    },
    textColorLabel: {
        id: "company-hub.search-extension.custom-search-config-panel.styles-text-color-label",
        defaultMessage: "Text color"
    },
    cornerStyleLabel: {
        id: "company-hub.search-extension.custom-search-config-panel.corner-style-label",
        defaultMessage: "Corners"
    },
    placeholderTextLabel: {
        id: "company-hub.search-extension.custom-search-config-panel.placeholder-text-label",
        defaultMessage: "Placeholder text"
    },
    placeholderTooltipLabel: {
        id: "company-hub.search-extension.custom-search-config-panel.placeholder-tooltip-label",
        defaultMessage: "Customize the prompt your readers will see"
    },
    roundCornerStyleLabel: {
        id: "company-hub.search-extension.custom-search-config-panel.round-corner-style-label",
        defaultMessage: "Round"
    },
    sharpCornerStyleLabel: {
        id: "company-hub.search-extension.custom-search-config-panel.sharp-corner-style-label",
        defaultMessage: "Square"
    },
    defaultPlaceholderText: {
        id: "company-hub.search-extension.custom-search-config-panel.default-placeholder-text",
        defaultMessage: "Search for verified announcements, resources, and policies"
    }
});


const $a5883aad3f5bcb0b$var$cssStyles = {
    container: "_18zru2gc _85i5u2gc",
    borderOptionContainer: "_1rjcv77o _18zr1b66 _bfhkysee _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1tcg _1bsb1tcg",
    border: "_2rko12b0 _189ee4h9 _1h6d1l7x _1dqonqa1",
    selected: "_1h6d1w55 _bfhk1j9a",
    informationIcon: "_bozg1b66 _1q51v77o"
};
const $a5883aad3f5bcb0b$export$97c42e26adc98d54 = ({ styles: styles, setStyles: setStyles, isSSRProductInDarkMode: isSSRProductInDarkMode })=>{
    const { branding: branding } = (0, $fOKpq.useProductDependencies)();
    const { hideDefaultColorPalette: hideDefaultColorPalette, brandBackgroundColorMap: brandBackgroundColorMap } = branding ?? {};
    const { backgroundColorMap: backgroundColorMap, textColorMap: textColorMap, emptyColorMap: emptyColorMap } = (0, $1u5CA.useBuiltInColorMap)(isSSRProductInDarkMode);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const fillColor = styles?.backgroundColor || '';
    const textColor = styles?.textColor || '';
    const cornerStyle = styles?.borderRadius || '';
    const isReadableFillColor = (color)=>(0, $fQWPs.isReadable)(color, textColor);
    const isReadableTextColor = (color)=>(0, $fQWPs.isReadable)(color, fillColor);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
        space: "space.300",
        xcss: $a5883aad3f5bcb0b$var$cssStyles.container,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                size: "small",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    ...(0, $4a3bf14b7c41e22e$export$defe85febe8b728c).stylesTitle
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                        alignBlock: "center",
                        spread: "space-between",
                        testId: "fill-color-wrapper",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                color: "color.text",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $4a3bf14b7c41e22e$export$defe85febe8b728c).fillColorLabel
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5n7dr.ColorPicker), {
                                builtInColorMap: hideDefaultColorPalette && brandBackgroundColorMap ? brandBackgroundColorMap : backgroundColorMap,
                                onChange: (newFillColor)=>setStyles({
                                        ...styles,
                                        backgroundColor: newFillColor || fillColor
                                    }),
                                value: fillColor,
                                pickerTitle: (0, $4a3bf14b7c41e22e$export$defe85febe8b728c).fillColorLabel,
                                showCustomPalette: true,
                                isReadableColor: isReadableFillColor
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                        alignBlock: "center",
                        spread: "space-between",
                        testId: "text-color-wrapper",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                color: "color.text",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $4a3bf14b7c41e22e$export$defe85febe8b728c).textColorLabel
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5n7dr.ColorPicker), {
                                builtInColorMap: hideDefaultColorPalette ? emptyColorMap : textColorMap,
                                onChange: (newTextColor)=>setStyles({
                                        ...styles,
                                        textColor: newTextColor || textColor
                                    }),
                                value: textColor,
                                pickerTitle: (0, $4a3bf14b7c41e22e$export$defe85febe8b728c).textColorLabel,
                                showCustomPalette: true,
                                showTextIcon: true,
                                isReadableColor: isReadableTextColor
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                        alignBlock: "center",
                        spread: "space-between",
                        testId: "corner-style-wrapper",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                color: "color.text",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                    ...(0, $4a3bf14b7c41e22e$export$defe85febe8b728c).cornerStyleLabel
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
                                space: "space.075",
                                children: [
                                    {
                                        cornerOption: "var(--ds-radius-large, 8px)",
                                        IconComponent: (0, $4K9rx.RoundCornerIcon),
                                        label: (0, $4a3bf14b7c41e22e$export$defe85febe8b728c).roundCornerStyleLabel,
                                        textIdPrefix: 'round'
                                    },
                                    {
                                        cornerOption: '0px',
                                        IconComponent: (0, $4VyWY.SharpCornerIcon),
                                        label: (0, $4a3bf14b7c41e22e$export$defe85febe8b728c).sharpCornerStyleLabel,
                                        textIdPrefix: 'sharp'
                                    }
                                ].map(({ cornerOption: cornerOption, IconComponent: IconComponent, label: label, textIdPrefix: textIdPrefix })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                                        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                            ...label
                                        }),
                                        hideTooltipOnMouseDown: true,
                                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
                                            xcss: (0, $1Whri.cx)($a5883aad3f5bcb0b$var$cssStyles.borderOptionContainer, $a5883aad3f5bcb0b$var$cssStyles.border, cornerStyle === cornerOption && $a5883aad3f5bcb0b$var$cssStyles.selected),
                                            onClick: ()=>setStyles({
                                                    ...styles,
                                                    borderRadius: cornerOption
                                                }),
                                            testId: `${textIdPrefix}${cornerStyle === cornerOption ? '--selected' : ''}`,
                                            children: /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
                                                color: cornerStyle === cornerOption ? "var(--ds-icon-accent-blue, #357DE8)" : "var(--ds-icon, #292A2E)",
                                                label: formatMessage(label)
                                            })
                                        })
                                    }, cornerOption))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
                        alignBlock: "center",
                        spread: "space-between",
                        testId: "placeholder-text-wrapper",
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1GzhS.default), {
                            space: "space.100",
                            grow: "fill",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                                    alignBlock: "center",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                                            color: "color.text",
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                ...(0, $4a3bf14b7c41e22e$export$defe85febe8b728c).placeholderTextLabel
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                                            content: formatMessage((0, $4a3bf14b7c41e22e$export$defe85febe8b728c).placeholderTooltipLabel),
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                                xcss: $a5883aad3f5bcb0b$var$cssStyles.informationIcon,
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
                                                    color: "var(--ds-icon-subtlest, #6B6E76)",
                                                    label: ""
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $4noo5.default), {
                                    "aria-label": formatMessage((0, $4a3bf14b7c41e22e$export$defe85febe8b728c).placeholderTextLabel),
                                    onChange: (e)=>setStyles({
                                            ...styles,
                                            placeholder: e.currentTarget.value || ''
                                        }),
                                    value: styles?.placeholder || formatMessage((0, $4a3bf14b7c41e22e$export$defe85febe8b728c).defaultPlaceholderText)
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};


const $ea81e661fddd3c58$var$styles = {
    title: "_18zru2gc",
    preamble: "_18zru2gc",
    stickyFooter: "_1rjc1b66 _1pbykb7n _kqsw1if8 _94n5ze3t _bfhkvuon",
    footerContentWrapper: "_zulpu2gc _1rjcu2gc _1e0c1txw _2lx21bp4"
};
const $ea81e661fddd3c58$var$SearchConfigPanelFeedbackCollector = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $ea81e661fddd3c58$var$styles.stickyFooter,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $ea81e661fddd3c58$var$styles.footerContentWrapper,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6r7Ix.ConfigPanelFeedbackCollector), {
                source: (0, $lf1vG.CUSTOM_SEARCH_EXTENSION_ANALYTIC_SOURCE),
                type: (0, $4cOi8.FeedbackType).CUSTOM_SEARCH
            })
        })
    });
};
const $ea81e661fddd3c58$export$d4705ab11bd150a7 = ({ closeConfigPanel: closeConfigPanel, localId: localId, editorActions: editorActions })=>{
    const { extensionActions: extensionActions, extensionParameters: extensionParameters } = (0, $45e22698d0407c9c$export$d78d7700cec50018)({
        localId: localId,
        editorActions: editorActions,
        extensionType: (0, $lf1vG.SEARCH_EXTENSION_TYPE)
    });
    const { updateMainFormField: updateMainFormField } = extensionActions;
    const { cloudId: cloudId, userId: userId, displayName: displayName, orgId: orgId, isAdminHubAIEnabled: isAdminHubAIEnabled, isSSRProductInDarkMode: isSSRProductInDarkMode } = (0, $fOKpq.useProductDependencies)();
    const filters = extensionParameters.filters;
    const setFilters = (0, $42omo.useCallback)((newFilters)=>{
        updateMainFormField({
            ...extensionParameters,
            filters: {
                ...newFilters,
                product: 'confluence'
            }
        });
    }, [
        extensionParameters,
        updateMainFormField
    ]);
    const extensionStyles = extensionParameters?.styles || {};
    const setStyles = (0, $42omo.useCallback)((newStyles)=>{
        updateMainFormField({
            ...extensionParameters,
            styles: newStyles
        });
    }, [
        extensionParameters,
        updateMainFormField
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $6UUyu.ExtensionsConfigWrapper), {
        title: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $ea81e661fddd3c58$var$styles.title,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                ...(0, $43761b7b74817414$export$defe85febe8b728c).title
            })
        }),
        footerComponent: $ea81e661fddd3c58$var$SearchConfigPanelFeedbackCollector,
        closeConfigPanel: closeConfigPanel,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $ea81e661fddd3c58$var$styles.preamble,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text.subtle",
                    size: "small",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                        ...(0, $43761b7b74817414$export$defe85febe8b728c).preamble
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $3VS69.PremiumGateForExtensionConfigPanel), {
                feature: "premiumSearchConfig",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $a5883aad3f5bcb0b$export$97c42e26adc98d54), {
                        styles: extensionStyles,
                        setStyles: setStyles,
                        isSSRProductInDarkMode: isSSRProductInDarkMode
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $9a203b7715b6cb34$export$41dc5c54b6ccd429), {
                        filters: filters,
                        setFilters: setFilters,
                        cloudId: cloudId,
                        userId: userId ?? null,
                        displayName: displayName ?? null,
                        orgId: orgId,
                        isAdminHubAIEnabled: isAdminHubAIEnabled ?? false
                    })
                ]
            })
        ]
    });
};
module.exports["SearchConfigPanelContent"] = $ea81e661fddd3c58$export$d4705ab11bd150a7;

});

parcelRegister("ibSzG", function(module, exports) {

var $4mTS8 = parcelRequire("4mTS8");


var $gtxdb = parcelRequire("gtxdb");


var $1EqNn = parcelRequire("1EqNn");

const $9ca9df466a1be1d1$export$42679f7213a051c = ()=>{
    return `
	query SearchPageJiraFieldHydration (
		$issueKeys: [String!]!
		$cloudId: ID!
	) {
		jira {
			issuesByKey(cloudId: $cloudId, keys: $issueKeys) {
			  statusField {
				status {
				  name
				}
			  }
			  id
			}
		  }

	}
	`;
};


const $611bb4f8cbf79acc$var$cache = (0, $1EqNn.inMemoryCache)();
const $611bb4f8cbf79acc$export$801183f161baaa36 = (variables)=>{
    const keyObj = {
        issueKeys: variables.issueKeys
    };
    return (0, $gtxdb.generateHashFromVariables)(keyObj);
};
// Expire the cache if there are errors or results are empty
const $611bb4f8cbf79acc$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    return data.jira.issuesByKey.length === 0;
};
const $611bb4f8cbf79acc$export$16b4bc84d4d9549f = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    const graphQuery = (0, $9ca9df466a1be1d1$export$42679f7213a051c)();
    return $611bb4f8cbf79acc$var$cache.inMemoryDecorator($611bb4f8cbf79acc$export$801183f161baaa36(variables), ()=>(0, $4mTS8.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: 'SearchPageJiraFieldHydration'
        }), $611bb4f8cbf79acc$var$expireWhen);
};
module.exports["fetchJiraFieldsQuery"] = $611bb4f8cbf79acc$export$16b4bc84d4d9549f;

});

parcelRegister("7mBSb", function(module, exports) {

var $lPWlo = parcelRequire("lPWlo");

const $7cff4ff80a34163e$export$5ef321009a5b450c = 'custom';
const $7cff4ff80a34163e$export$62fed45313a13eff = 'universalTypeFilter';
const $7cff4ff80a34163e$export$64f2f70bb9f8e772 = [
    'lastUpdated',
    $7cff4ff80a34163e$export$62fed45313a13eff,
    'contributor',
    'owner',
    'space',
    'assignee',
    'project',
    'content',
    'onlyTitleMatch',
    'verified',
    'label'
];
const $7cff4ff80a34163e$export$1fd3303b0f1dd4fb = ()=>{
    return $7cff4ff80a34163e$export$64f2f70bb9f8e772.filter(()=>{
        return true;
    });
};
const $7cff4ff80a34163e$export$49f6cbb853d30562 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    Repository: 'repository',
    PullRequest: 'pull-request',
    Branch: 'branch',
    Commit: 'commit',
    WebPage: 'web-page',
    Conversation: 'conversation',
    Message: 'message',
    Video: 'video',
    Design: 'design',
    Page: 'page',
    Blogpost: 'blogpost',
    Attachment: 'attachment',
    Space: 'space',
    Whiteboard: 'whiteboard',
    Comment: 'comment',
    Database: 'database',
    Embed: 'embed',
    Folder: 'folder',
    Calendar: 'calendar',
    SpaceCalendar: 'space-calendar',
    Question: 'question',
    Answer: 'answer',
    Issue: 'issue',
    Component: 'component',
    Board: 'board',
    Card: 'card',
    Project: 'project',
    Goal: 'goal',
    Tag: 'tag',
    WorkItem: 'work-item'
};
const $7cff4ff80a34163e$export$e01073b80ff953d5 = Object.values($7cff4ff80a34163e$export$49f6cbb853d30562);
const $7cff4ff80a34163e$export$1f2db89e0caa00c9 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    File: 'file',
    Database: 'database',
    WebPage: 'web-page'
};
const $7cff4ff80a34163e$export$a62d9b6a2b7f9510 = new Map([
    [
        $7cff4ff80a34163e$export$49f6cbb853d30562.Document,
        {
            entities3P: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            subTypes3P: [
                $7cff4ff80a34163e$export$1f2db89e0caa00c9.Document
            ]
        }
    ],
    [
        $7cff4ff80a34163e$export$49f6cbb853d30562.Spreadsheet,
        {
            entities3P: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            subTypes3P: [
                $7cff4ff80a34163e$export$1f2db89e0caa00c9.Spreadsheet
            ]
        }
    ],
    [
        $7cff4ff80a34163e$export$49f6cbb853d30562.Presentation,
        {
            entities3P: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            subTypes3P: [
                $7cff4ff80a34163e$export$1f2db89e0caa00c9.Presentation
            ]
        }
    ],
    [
        $7cff4ff80a34163e$export$49f6cbb853d30562.Repository,
        {
            entities3P: [
                'ati:cloud:graph:repository'
            ],
            subTypes3P: []
        }
    ],
    [
        $7cff4ff80a34163e$export$49f6cbb853d30562.PullRequest,
        {
            entities3P: [
                'ati:cloud:graph:pull-request'
            ],
            subTypes3P: []
        }
    ],
    [
        $7cff4ff80a34163e$export$49f6cbb853d30562.Branch,
        {
            entities3P: [
                'ati:cloud:graph:branch'
            ],
            subTypes3P: []
        }
    ],
    [
        $7cff4ff80a34163e$export$49f6cbb853d30562.Commit,
        {
            entities3P: [
                'ati:cloud:graph:commit'
            ],
            subTypes3P: []
        }
    ],
    [
        $7cff4ff80a34163e$export$49f6cbb853d30562.WebPage,
        {
            entities3P: [
                'ati:cloud:graph:document'
            ],
            subTypes3P: [
                $7cff4ff80a34163e$export$1f2db89e0caa00c9.WebPage
            ]
        }
    ],
    [
        $7cff4ff80a34163e$export$49f6cbb853d30562.Conversation,
        {
            entities3P: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
            subTypes3P: []
        }
    ],
    [
        $7cff4ff80a34163e$export$49f6cbb853d30562.Message,
        {
            entities3P: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
            subTypes3P: []
        }
    ],
    [
        $7cff4ff80a34163e$export$49f6cbb853d30562.Video,
        {
            entities3P: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI),
            subTypes3P: []
        }
    ],
    [
        $7cff4ff80a34163e$export$49f6cbb853d30562.Design,
        {
            entities3P: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
            subTypes3P: [
                $7cff4ff80a34163e$export$1f2db89e0caa00c9.File
            ]
        }
    ],
    [
        $7cff4ff80a34163e$export$49f6cbb853d30562.WorkItem,
        {
            entities3P: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
            subTypes3P: []
        }
    ]
]);
module.exports["CUSTOM_OPTION_VALUE"] = $7cff4ff80a34163e$export$5ef321009a5b450c;
module.exports["universalTypeFilterId"] = $7cff4ff80a34163e$export$62fed45313a13eff;
module.exports["getFilterIdOrdering"] = $7cff4ff80a34163e$export$1fd3303b0f1dd4fb;
module.exports["TypeFilterValueKey"] = $7cff4ff80a34163e$export$49f6cbb853d30562;
module.exports["allTypeFilterValueKeys"] = $7cff4ff80a34163e$export$e01073b80ff953d5;
module.exports["TypeFilterTWGNounMapping"] = $7cff4ff80a34163e$export$a62d9b6a2b7f9510;

});

parcelRegister("2nDCB", function(module, exports) {

var $dgfdr = parcelRequire("dgfdr");


var $9d6Pf = parcelRequire("9d6Pf");


var $ifD4G = parcelRequire("ifD4G");


var $1BJiv = parcelRequire("1BJiv");


var $lQmBe = parcelRequire("lQmBe");


var $8nc1P = parcelRequire("8nc1P");


var $3nRFC = parcelRequire("3nRFC");


var $jwCqK = parcelRequire("jwCqK");


var $bM2Mh = parcelRequire("bM2Mh");


var $7OwWa = parcelRequire("7OwWa");


var $ckAAF = parcelRequire("ckAAF");


var $iElCD = parcelRequire("iElCD");


var $i6qjN = parcelRequire("i6qjN");


var $gwQPM = parcelRequire("gwQPM");


var $kMXgf = parcelRequire("kMXgf");


var $jB3tf = parcelRequire("jB3tf");


var $QUygY = parcelRequire("QUygY");


var $7DGGZ = parcelRequire("7DGGZ");

// New 3P? Add it here
const $6b8944cc6d00efb6$var$ProductKeys3P = {
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Figma: 'figma',
    Github: 'github',
    GoogleDrive: 'drive',
    Loom: 'loom',
    OneDrive: 'onedrive',
    Dropbox: 'dropbox',
    Slack: 'slack',
    Sharepoint: 'sharepoint',
    Teams: 'teams',
    GoogleCalendar: 'google-calendar',
    OutlookCalendar: 'outlook-calendar',
    Gmail: 'gmail',
    Asana: 'asana',
    Zendesk: 'zendesk',
    Airtable: 'airtable',
    Notion: 'notion',
    Miro: 'miro'
};
const $6b8944cc6d00efb6$export$f7937c5f282f2571 = new Map([
    [
        $6b8944cc6d00efb6$var$ProductKeys3P.AtlassianWebCrawler,
        (0, $ifD4G.atlassianWebCrawlerConfig)
    ],
    [
        $6b8944cc6d00efb6$var$ProductKeys3P.Figma,
        (0, $lQmBe.figmaConfig)
    ],
    [
        $6b8944cc6d00efb6$var$ProductKeys3P.Github,
        (0, $8nc1P.githubConfig)
    ],
    [
        $6b8944cc6d00efb6$var$ProductKeys3P.GoogleDrive,
        (0, $jwCqK.googleDriveConfig)
    ],
    [
        $6b8944cc6d00efb6$var$ProductKeys3P.Sharepoint,
        (0, $kMXgf.sharepointConfig)
    ],
    [
        $6b8944cc6d00efb6$var$ProductKeys3P.Loom,
        (0, $7OwWa.loomConfig)
    ],
    [
        $6b8944cc6d00efb6$var$ProductKeys3P.OneDrive,
        (0, $i6qjN.oneDriveConfig)
    ],
    [
        $6b8944cc6d00efb6$var$ProductKeys3P.Dropbox,
        (0, $1BJiv.dropboxConfig)
    ],
    [
        $6b8944cc6d00efb6$var$ProductKeys3P.Slack,
        (0, $jB3tf.slackConfig)
    ],
    [
        $6b8944cc6d00efb6$var$ProductKeys3P.Teams,
        (0, $QUygY.teamsConfig)
    ],
    [
        $6b8944cc6d00efb6$var$ProductKeys3P.GoogleCalendar,
        (0, $bM2Mh.googleCalendarConfig)
    ],
    [
        $6b8944cc6d00efb6$var$ProductKeys3P.Gmail,
        (0, $3nRFC.gmailConfig)
    ],
    [
        $6b8944cc6d00efb6$var$ProductKeys3P.OutlookCalendar,
        (0, $gwQPM.outlookCalendarConfig)
    ],
    [
        $6b8944cc6d00efb6$var$ProductKeys3P.Asana,
        (0, $9d6Pf.asanaConfig)
    ],
    [
        $6b8944cc6d00efb6$var$ProductKeys3P.Zendesk,
        (0, $7DGGZ.zendeskConfig)
    ],
    [
        $6b8944cc6d00efb6$var$ProductKeys3P.Airtable,
        (0, $dgfdr.airtableConfig)
    ],
    [
        $6b8944cc6d00efb6$var$ProductKeys3P.Notion,
        (0, $iElCD.notionConfig)
    ],
    [
        $6b8944cc6d00efb6$var$ProductKeys3P.Miro,
        (0, $ckAAF.miroConfig)
    ]
]);
const $6b8944cc6d00efb6$var$ProductsOrder3P = [
    // // Loom is actually a 1P so goes to the top
    $6b8944cc6d00efb6$var$ProductKeys3P.Loom,
    // Eventually this might be "smart"
    // For now this static order isn't strongly defined
    $6b8944cc6d00efb6$var$ProductKeys3P.GoogleDrive,
    $6b8944cc6d00efb6$var$ProductKeys3P.Sharepoint,
    $6b8944cc6d00efb6$var$ProductKeys3P.OneDrive,
    $6b8944cc6d00efb6$var$ProductKeys3P.Dropbox,
    $6b8944cc6d00efb6$var$ProductKeys3P.Slack,
    $6b8944cc6d00efb6$var$ProductKeys3P.Teams,
    $6b8944cc6d00efb6$var$ProductKeys3P.Github,
    $6b8944cc6d00efb6$var$ProductKeys3P.Figma,
    $6b8944cc6d00efb6$var$ProductKeys3P.GoogleCalendar,
    $6b8944cc6d00efb6$var$ProductKeys3P.Gmail,
    $6b8944cc6d00efb6$var$ProductKeys3P.OutlookCalendar,
    $6b8944cc6d00efb6$var$ProductKeys3P.Airtable,
    $6b8944cc6d00efb6$var$ProductKeys3P.Asana,
    $6b8944cc6d00efb6$var$ProductKeys3P.Zendesk,
    $6b8944cc6d00efb6$var$ProductKeys3P.Miro,
    // New 3P? Add it here
    // Always last
    $6b8944cc6d00efb6$var$ProductKeys3P.AtlassianWebCrawler
];
const $6b8944cc6d00efb6$export$1242fc8c436d51cf = $6b8944cc6d00efb6$var$ProductKeys3P;
const $6b8944cc6d00efb6$export$9d22c431a2a02e31 = $6b8944cc6d00efb6$var$ProductsOrder3P;
module.exports["ThirdPartyConfigs"] = $6b8944cc6d00efb6$export$f7937c5f282f2571;
module.exports["DO_NOT_IMPORT_ProductKeys3P"] = $6b8944cc6d00efb6$export$1242fc8c436d51cf;
module.exports["DO_NOT_IMPORT_ProductsOrder3P"] = $6b8944cc6d00efb6$export$9d22c431a2a02e31;

});

parcelRegister("eMyDT", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $87cc79851242f997$export$88b64eee273831fd = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M14.7168 6.25334L5.76892 9.95584C5.27133 10.1618 5.27649 10.8685 5.7772 11.067L14.7625 14.6302C15.552 14.9433 16.4312 14.9433 17.2206 14.6302L26.206 11.067C26.7066 10.8685 26.7119 10.1618 26.2141 9.95584L17.2664 6.25334C16.45 5.91555 15.533 5.91555 14.7168 6.25334Z",
                fill: "#FFBF00"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M16.7887 16.576V25.4773C16.7887 25.9007 17.2156 26.1906 17.6092 26.0346L27.6215 22.1482C27.8501 22.0576 28 21.8368 28 21.591V12.6897C28 12.2663 27.5731 11.9764 27.1795 12.1324L17.1672 16.0187C16.9387 16.1093 16.7887 16.3302 16.7887 16.576Z",
                fill: "#26B5F8"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M14.4508 17.0352L11.4793 18.47L11.1776 18.6158L4.90511 21.6213C4.50749 21.8131 4 21.5233 4 21.0816V12.727C4 12.5672 4.08194 12.4293 4.19182 12.3253C4.23767 12.2794 4.28963 12.2415 4.34362 12.2115C4.49352 12.1216 4.70732 12.0976 4.8891 12.1695L14.4009 15.9382C14.8843 16.13 14.9223 16.8075 14.4508 17.0352Z",
                fill: "#ED3049"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M14.4507 17.0352L11.4793 18.47L4.19177 12.3253C4.23762 12.2794 4.28958 12.2415 4.34357 12.2115C4.49347 12.1216 4.70727 12.0976 4.88905 12.1695L14.4008 15.9382C14.8843 16.13 14.9223 16.8075 14.4507 17.0352Z",
                fill: "black",
                fillOpacity: "0.25"
            })
        ]
    });
module.exports["AirtableIcon"] = $87cc79851242f997$export$88b64eee273831fd;

});

parcelRegister("htLpQ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $e9d3e3fe784a1cec$export$f6d383c62156550f = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M11.2515 6.14778L6.03189 8.30757C5.74163 8.4277 5.74464 8.83998 6.03672 8.95576L11.2781 11.0343C11.7387 11.2169 12.2515 11.2169 12.712 11.0343L17.9535 8.95576C18.2455 8.83998 18.2486 8.4277 17.9583 8.30757L12.7388 6.14778C12.2625 5.95074 11.7276 5.95074 11.2515 6.14778Z",
                fill: "#FFBF00"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.4601 12.1693V17.3617C12.4601 17.6087 12.7091 17.7778 12.9387 17.6868L18.7792 15.4198C18.9126 15.3669 19 15.2381 19 15.0947V9.90228C19 9.65531 18.751 9.4862 18.5214 9.5772L12.6809 11.8442C12.5476 11.8971 12.4601 12.0259 12.4601 12.1693Z",
                fill: "#26B5F8"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M11.0963 12.4372L9.36295 13.2741L9.18695 13.3592L5.52798 15.1124C5.29604 15.2243 5 15.0552 5 14.7976V9.92405C5 9.83083 5.0478 9.75035 5.11189 9.68974C5.13864 9.66291 5.16895 9.64083 5.20045 9.62334C5.28789 9.57088 5.4126 9.55687 5.51864 9.59881L11.0672 11.7972C11.3492 11.9091 11.3714 12.3043 11.0963 12.4372Z",
                fill: "#ED3049"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M11.0963 12.4372L9.36293 13.2741L5.11188 9.68974C5.13862 9.66291 5.16893 9.64083 5.20043 9.62334C5.28787 9.57088 5.41258 9.55687 5.51862 9.59881L11.0671 11.7972C11.3492 11.9091 11.3713 12.3043 11.0963 12.4372Z",
                fill: "black",
                fillOpacity: "0.25"
            })
        ]
    });
module.exports["AirtableFilterIcon"] = $e9d3e3fe784a1cec$export$f6d383c62156550f;

});

parcelRegister("ia5aS", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $18f1fd6ccd18bd21$export$671541d0c7918cd9 = ()=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22.7805 16.7441C19.8977 16.7441 17.5609 19.081 17.5609 21.9638C17.5609 24.8465 19.8977 27.1835 22.7805 27.1835C25.6632 27.1835 28 24.8465 28 21.9638C28 19.081 25.6632 16.7441 22.7805 16.7441ZM9.21957 16.7445C6.33691 16.7445 4 19.081 4 21.9638C4 24.8465 6.33691 27.1835 9.21957 27.1835C12.1024 27.1835 14.4394 24.8465 14.4394 21.9638C14.4394 19.081 12.1024 16.7445 9.21957 16.7445ZM21.2195 10.2195C21.2195 13.1024 18.8827 15.4395 16.0001 15.4395C13.1172 15.4395 10.7804 13.1024 10.7804 10.2195C10.7804 7.33713 13.1172 5 16.0001 5C18.8827 5 21.2195 7.33713 21.2195 10.2195Z",
            fill: "#F06A6A"
        })
    });
var $18f1fd6ccd18bd21$export$2e2bcd8739ae039 = $18f1fd6ccd18bd21$export$671541d0c7918cd9;
module.exports["AsanaIcon"] = $18f1fd6ccd18bd21$export$671541d0c7918cd9;
module.exports["default"] = $18f1fd6ccd18bd21$export$2e2bcd8739ae039;

});

parcelRegister("lC6Bo", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $22fe6cc7ea0a2464$export$5e2362bb78414664 = ()=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "24px",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 43 40",
        version: "1.1",
        height: "24px",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            d: "m12.5 0l-12.5 8.1 8.7 7 12.5-7.8-8.7-7.3zm-12.5 21.9l12.5 8.2 8.7-7.3-12.5-7.7-8.7 6.8zm21.2 0.9l8.8 7.3 12.4-8.1-8.6-6.9-12.6 7.7zm21.2-14.7l-12.4-8.1-8.8 7.3 12.6 7.8 8.6-7zm-21.1 16.3l-8.8 7.3-3.7-2.5v2.8l12.5 7.5 12.5-7.5v-2.8l-3.8 2.5-8.7-7.3z",
            fill: "#007EE5"
        })
    });
module.exports["DropboxIcon"] = $22fe6cc7ea0a2464$export$5e2362bb78414664;

});

parcelRegister("kNd5F", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $cc2199443a653541$export$54e0f4982aa79afe = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "25",
        viewBox: "3 3 18 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_3561_46561)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M9.2277 20.7767C10.6997 20.7767 11.8944 19.582 11.8944 18.11V15.4434H9.2277C7.7557 15.4434 6.56104 16.638 6.56104 18.11C6.56104 19.582 7.7557 20.7767 9.2277 20.7767Z",
                        fill: "#0ACF83"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M6.56104 12.778C6.56104 11.306 7.7557 10.1113 9.2277 10.1113H11.8944V15.4447H9.2277C7.7557 15.4447 6.56104 14.25 6.56104 12.778Z",
                        fill: "#A259FF"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M6.56104 7.44401C6.56104 5.97201 7.7557 4.77734 9.2277 4.77734H11.8944V10.1107H9.2277C7.7557 10.1107 6.56104 8.91601 6.56104 7.44401Z",
                        fill: "#F24E1E"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M11.8945 4.77734H14.5612C16.0332 4.77734 17.2279 5.97201 17.2279 7.44401C17.2279 8.91601 16.0332 10.1107 14.5612 10.1107H11.8945V4.77734Z",
                        fill: "#FF7262"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M17.2279 12.778C17.2279 14.25 16.0332 15.4447 14.5612 15.4447C13.0892 15.4447 11.8945 14.25 11.8945 12.778C11.8945 11.306 13.0892 10.1113 14.5612 10.1113C16.0332 10.1113 17.2279 11.306 17.2279 12.778Z",
                        fill: "#1ABCFE"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_3561_46561",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "translate(4 4.77734)"
                    })
                })
            })
        ]
    });
module.exports["FigmaIcon"] = $cc2199443a653541$export$54e0f4982aa79afe;

});

parcelRegister("cFnPW", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $8f2b7c842fe2cf1d$export$b31792ff95c3d83f = (_)=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_6321_165951)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M11.8418 28C14.0498 28 15.8418 26.208 15.8418 24V20H11.8418C9.6338 20 7.8418 21.792 7.8418 24C7.8418 26.208 9.6338 28 11.8418 28Z",
                        fill: "#0ACF83"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M7.8418 16C7.8418 13.792 9.6338 12 11.8418 12H15.8418V20H11.8418C9.6338 20 7.8418 18.208 7.8418 16Z",
                        fill: "#A259FF"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M7.8418 8C7.8418 5.792 9.6338 4 11.8418 4H15.8418V12H11.8418C9.6338 12 7.8418 10.208 7.8418 8Z",
                        fill: "#F24E1E"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M15.8418 4H19.8418C22.0498 4 23.8418 5.792 23.8418 8C23.8418 10.208 22.0498 12 19.8418 12H15.8418V4Z",
                        fill: "#FF7262"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M23.8418 16C23.8418 18.208 22.0498 20 19.8418 20C17.6338 20 15.8418 18.208 15.8418 16C15.8418 13.792 17.6338 12 19.8418 12C22.0498 12 23.8418 13.792 23.8418 16Z",
                        fill: "#1ABCFE"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_6321_165951",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white",
                        transform: "translate(4 4)"
                    })
                })
            })
        ]
    });
module.exports["FigmaSearchResultIcon"] = $8f2b7c842fe2cf1d$export$b31792ff95c3d83f;

});

parcelRegister("jIZgI", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6fnsQ = parcelRequire("6fnsQ");

const $ef26fcce668eea9d$export$e8e65f186ccd8749 = (_)=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 2.14801C4.685 2.14801 2 4.83301 2 8.14801C2 10.803 3.7175 13.0455 6.1025 13.8405C6.4025 13.893 6.515 13.713 6.515 13.5555C6.515 13.413 6.5075 12.9405 6.5075 12.438C5 12.7155 4.61 12.0705 4.49 11.733C4.4225 11.5605 4.13 11.028 3.875 10.8855C3.665 10.773 3.365 10.4955 3.8675 10.488C4.34 10.4805 4.6775 10.923 4.79 11.103C5.33 12.0105 6.1925 11.7555 6.5375 11.598C6.59 11.208 6.7475 10.9455 6.92 10.7955C5.585 10.6455 4.19 10.128 4.19 7.83301C4.19 7.18051 4.4225 6.64051 4.805 6.22051C4.745 6.07051 4.535 5.45551 4.865 4.63051C4.865 4.63051 5.3675 4.47301 6.515 5.24551C6.995 5.11051 7.505 5.04301 8.015 5.04301C8.525 5.04301 9.035 5.11051 9.515 5.24551C10.6625 4.46551 11.165 4.63051 11.165 4.63051C11.495 5.45551 11.285 6.07051 11.225 6.22051C11.6075 6.64051 11.84 7.17301 11.84 7.83301C11.84 10.1355 10.4375 10.6455 9.1025 10.7955C9.32 10.983 9.5075 11.343 9.5075 11.9055C9.5075 12.708 9.5 13.353 9.5 13.5555C9.5 13.713 9.6125 13.9005 9.9125 13.8405C12.2825 13.0455 14 10.7955 14 8.14801C14 4.83301 11.315 2.14801 8 2.14801Z",
            fill: `var(--ds-icon, ${(0, $6fnsQ.N800)})`
        })
    });
module.exports["GithubIcon"] = $ef26fcce668eea9d$export$e8e65f186ccd8749;

});

parcelRegister("aZEPk", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $6fnsQ = parcelRequire("6fnsQ");

const $0f89746370d70a16$export$fa0f141eb732d2d7 = (_)=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.0001 4C9.3735 4 4 9.50847 4 16.3038C4 21.74 7.43839 26.3519 12.2064 27.9789C12.8061 28.0927 13.0263 27.7119 13.0263 27.387C13.0263 27.0936 13.0152 26.1244 13.01 25.0963C9.67157 25.8405 8.96712 23.6446 8.96712 23.6446C8.42125 22.2224 7.63472 21.8443 7.63472 21.8443C6.54595 21.0806 7.71679 21.0963 7.71679 21.0963C8.92181 21.1831 9.55632 22.3642 9.55632 22.3642C10.6266 24.2452 12.3636 23.7014 13.0484 23.387C13.1561 22.5918 13.4671 22.049 13.8102 21.7418C11.1449 21.4307 8.34295 20.3757 8.34295 15.6612C8.34295 14.3179 8.81172 13.2203 9.57937 12.3587C9.45477 12.0488 9.04402 10.7974 9.69561 9.10261C9.69561 9.10261 10.7033 8.77193 12.9965 10.3638C13.9537 10.0912 14.9803 9.95447 16.0001 9.94979C17.0199 9.95447 18.0473 10.0912 19.0063 10.3638C21.2967 8.77193 22.303 9.10261 22.303 9.10261C22.9562 10.7974 22.5452 12.0488 22.4206 12.3587C23.1901 13.2203 23.6557 14.3179 23.6557 15.6612C23.6557 20.3869 20.8484 21.4274 18.1762 21.732C18.6067 22.1138 18.9902 22.8626 18.9902 24.0105C18.9902 25.6568 18.9763 26.9817 18.9763 27.387C18.9763 27.7144 19.1923 28.098 19.8006 27.9772C24.566 26.3485 28 21.7381 28 16.3038C28 9.50847 22.6273 4 16.0001 4Z",
            fill: `var(--ds-icon, ${(0, $6fnsQ.N800)})`
        })
    });
module.exports["GithubSearchResultIcon"] = $0f89746370d70a16$export$fa0f141eb732d2d7;

});

parcelRegister("72WyQ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $ec1e786334a2dde1$export$856bad9032bbc5ed = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "37 37 115 80",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#4285f4",
                d: "M58 108h14V74L52 59v43c0 3.32 2.69 6 6 6"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#34a853",
                d: "M120 108h14c3.32 0 6-2.69 6-6V59l-20 15"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#fbbc04",
                d: "M120 48v26l20-15v-8c0-7.42-8.47-11.65-14.4-7.2"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#ea4335",
                d: "M72 74V48l24 18 24-18v26L96 92"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#c5221f",
                d: "M52 51v8l20 15V48l-5.6-4.2c-5.94-4.45-14.4-.22-14.4 7.2"
            })
        ]
    });
module.exports["GmailIcon"] = $ec1e786334a2dde1$export$856bad9032bbc5ed;

});

parcelRegister("6sPwH", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $duanB = parcelRequire("duanB");

const $c9705a2efb0571a4$export$5d128e0a6ffc0558 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        "aria-label": formatMessage((0, $duanB.messages).googleCalendarLabel),
        viewBox: "50 50 410 410 ",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#4285f4",
                d: "M100 340h74V174h166v-74H137q-37 0-37 35"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#1967d2",
                d: "M338 100v76h74v-41q0-35-35-35"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#fbbc04",
                d: "M338 174h74v164h-74"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#188038",
                d: "M100 338v39q0 35 35 35h41v-74"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#34a853",
                d: "M174 338h164v74H174"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "#ea4335",
                d: "M338 412v-74h74"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fill: "none",
                stroke: "#4285f4",
                strokeLinejoin: "bevel",
                strokeWidth: 15,
                d: "M204 229a25 22 1 1 1 25 27h-9 9a25 22 1 1 1-25 27m66-52 27-19h4v-7 103"
            })
        ]
    });
};
var $c9705a2efb0571a4$export$2e2bcd8739ae039 = $c9705a2efb0571a4$export$5d128e0a6ffc0558;
module.exports["GoogleCalendarIcon"] = $c9705a2efb0571a4$export$5d128e0a6ffc0558;
module.exports["default"] = $c9705a2efb0571a4$export$2e2bcd8739ae039;

});

parcelRegister("1tp1E", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $34b93ee5004edd98$export$e16bd899bb4eebf9 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                clipPath: "url(#clip0_271_181643)",
                children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                    clipPath: "url(#clip1_271_181643)",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            x: "2",
                            y: "2",
                            width: "20",
                            height: "20",
                            rx: "0.75",
                            fill: "white",
                            fillOpacity: "0.01"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                            clipPath: "url(#clip2_271_181643)",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    d: "M3.51203 18.5459L4.39404 20.1089C4.57732 20.438 4.84078 20.6965 5.15006 20.8845L8.30011 15.2905H2C2 15.6548 2.09164 16.0192 2.27491 16.3482L3.51203 18.5459Z",
                                    fill: "#0066DA"
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    d: "M12 8.70925L8.84994 3.11523C8.54066 3.30327 8.27721 3.56182 8.09393 3.89088L2.27491 14.2328C2.09501 14.5547 2.00024 14.9193 2 15.2904H8.30011L12 8.70925Z",
                                    fill: "#00AC47"
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    d: "M18.85 20.8845C19.1593 20.6965 19.4227 20.438 19.606 20.1089L19.9725 19.4625L21.7251 16.3482C21.9084 16.0192 22 15.6548 22 15.2905H15.6995L17.0401 17.9935L18.85 20.8845Z",
                                    fill: "#EA4335"
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    d: "M12.0002 8.70932L15.1502 3.1153C14.8409 2.92727 14.4858 2.83325 14.1193 2.83325H9.88103C9.51447 2.83325 9.15938 2.93902 8.8501 3.1153L12.0002 8.70932Z",
                                    fill: "#00832D"
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    d: "M15.6997 15.2905H8.29996L5.1499 20.8845C5.45918 21.0726 5.81428 21.1666 6.18083 21.1666H17.8189C18.1854 21.1666 18.5405 21.0608 18.8498 20.8845L15.6997 15.2905Z",
                                    fill: "#2684FC"
                                }),
                                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                    d: "M18.8156 9.06182L15.9061 3.89088C15.7228 3.56182 15.4593 3.30327 15.1501 3.11523L12 8.70925L15.6999 15.2904H21.9885C21.9885 14.9261 21.8969 14.5618 21.7136 14.2328L18.8156 9.06182Z",
                                    fill: "#FFBA00"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip0_271_181643",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "24",
                            height: "24",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip1_271_181643",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            x: "2",
                            y: "2",
                            width: "20",
                            height: "20",
                            rx: "0.75",
                            fill: "white"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip2_271_181643",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "20",
                            height: "18.3333",
                            fill: "white",
                            transform: "translate(2 2.83325)"
                        })
                    })
                ]
            })
        ]
    });
module.exports["GoogleDriveIcon"] = $34b93ee5004edd98$export$e16bd899bb4eebf9;

});

parcelRegister("5ErYS", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $43e3037facc4c0fb$export$99050685a064f8e = (_)=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_6321_165888)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M4.96564 24.5692L6.11226 26.6153C6.35052 27.0461 6.69301 27.3845 7.09508 27.6307L11.1902 20.3076H3C3 20.7845 3.11913 21.2615 3.35739 21.6922L4.96564 24.5692Z",
                        fill: "#0066DA"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M16 11.6922L11.9049 4.36914C11.5029 4.61529 11.1604 4.95376 10.9221 5.38453L3.35739 18.923C3.12351 19.3445 3.00031 19.8218 3 20.3076H11.1901L16 11.6922Z",
                        fill: "#00AC47"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M24.9052 27.6307C25.3073 27.3845 25.6498 27.0461 25.8881 26.6153L26.3646 25.7692L28.6429 21.6922C28.8812 21.2615 29.0003 20.7845 29.0003 20.3076H20.8096L22.5524 23.8461L24.9052 27.6307Z",
                        fill: "#EA4335"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M16.0003 11.6923L20.0954 4.36923C19.6934 4.12308 19.2317 4 18.7552 4H13.2455C12.769 4 12.3073 4.13846 11.9053 4.36923L16.0003 11.6923Z",
                        fill: "#00832D"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M20.8095 20.3076H11.1898L7.09473 27.6307C7.49679 27.8769 7.95842 27.9999 8.43493 27.9999H23.5644C24.0409 27.9999 24.5025 27.8615 24.9046 27.6307L20.8095 20.3076Z",
                        fill: "#2684FC"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M24.8603 11.7846L21.0779 5.01538C20.8396 4.58462 20.4971 4.24615 20.0951 4L16 11.3231L20.8099 19.9385H28.9851C28.9851 19.4615 28.866 18.9846 28.6277 18.5538L24.8603 11.7846Z",
                        fill: "#FFBA00"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_6321_165888",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "26",
                        height: "24",
                        fill: "white",
                        transform: "translate(3 4)"
                    })
                })
            })
        ]
    });
module.exports["GoogleDriveSearchResultIcon"] = $43e3037facc4c0fb$export$99050685a064f8e;

});

parcelRegister("c7WVa", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $a35ba44e2fff6ebc$export$8d789f76fde3e05 = (_)=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "2 2 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                clipPath: "url(#clip0_271_181644)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M24.0115 12.9534H17.9154L23.1946 9.90666L22.1477 8.09334L16.8678 11.14L19.9151 5.86334L18.1014 4.81666L15.0534 10.092V4H12.9581V10.0927L9.91009 4.81666L8.09565 5.86334L11.1431 11.1387L5.86445 8.09334L4.81687 9.90666L10.0961 12.9534H4V15.0473H10.0955L4.81687 18.094L5.86378 19.9073L11.1437 16.8607L8.09565 22.1373L9.90943 23.184L12.9581 17.908V24H15.0534V17.7773L18.1574 23.1507L19.8585 22.1693L16.7537 16.7947L22.1463 19.9066L23.194 18.0934L17.9154 15.0466H24.0108V12.9534H24.0115ZM14.0057 16.8466C13.6317 16.8467 13.2613 16.7731 12.9158 16.6301C12.5703 16.487 12.2563 16.2773 11.9918 16.0129C11.7273 15.7486 11.5175 15.4347 11.3743 15.0893C11.2311 14.7438 11.1575 14.3736 11.1574 13.9997C11.1573 13.6257 11.2309 13.2554 11.374 12.91C11.5172 12.5646 11.7269 12.2506 11.9913 11.9862C12.2557 11.7218 12.5696 11.512 12.9152 11.3689C13.2607 11.2257 13.631 11.1521 14.0051 11.152C14.7604 11.1519 15.4848 11.4518 16.019 11.9857C16.5532 12.5197 16.8534 13.2439 16.8534 13.999C16.8535 14.7541 16.5536 15.4784 16.0195 16.0125C15.4854 16.5466 14.761 16.8466 14.0057 16.8466Z",
                    fill: "#5753F3"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_271_181644",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(4 4)"
                    })
                })
            })
        ]
    });
module.exports["LoomIcon"] = $a35ba44e2fff6ebc$export$8d789f76fde3e05;

});

parcelRegister("hy7mW", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $48574386a30f8dbb$export$38410c1d5582587e = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M4 10C4 6.68629 6.68629 4 10 4H22C25.3137 4 28 6.68629 28 10V22C28 25.3137 25.3137 28 22 28H10C6.68629 28 4 25.3137 4 22V10Z",
                fill: "#FFDD33"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.9558 8.57495H17.7771L19.5927 11.7649L15.5985 8.57495H13.4198L15.417 12.4738L11.2412 8.57495H9.0625L11.2412 13.5378L9.0625 23.4625H11.2412L15.417 12.8288L13.4198 23.4625H15.5985L19.5927 12.1198L17.7771 23.4625H19.9558L23.95 11.0559L19.9558 8.57495Z",
                fill: "black"
            })
        ]
    });
module.exports["MiroIcon"] = $48574386a30f8dbb$export$38410c1d5582587e;

});

parcelRegister("gQ6Bq", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $f91cb1cdda5301c4$export$2de50228fb7919e4 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M5 8.5C5 6.567 6.567 5 8.5 5H15.5C17.433 5 19 6.567 19 8.5V15.5C19 17.433 17.433 19 15.5 19H8.5C6.567 19 5 17.433 5 15.5V8.5Z",
                fill: "#FFDD33"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.3075 7.66882H13.0367L14.0957 9.5296L11.7658 7.66882H10.4949L11.6599 9.94317L9.22401 7.66882H7.95312L9.22401 10.5638L7.95312 16.3532H9.22401L11.6599 10.1502L10.4949 16.3532H11.7658L14.0957 9.73667L13.0367 16.3532H14.3075L16.6375 9.11604L14.3075 7.66882Z",
                fill: "black"
            })
        ]
    });
module.exports["MiroFilterIcon"] = $f91cb1cdda5301c4$export$2de50228fb7919e4;

});

parcelRegister("IzNHb", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $1f5798f9f44e84fb$export$694ff710b1e20299 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M6.44405 5.03539L19.7237 4.05453C21.355 3.91461 21.774 4.00893 22.7997 4.75459L27.0388 7.74085C27.7379 8.25444 27.9707 8.39436 27.9707 8.95355V25.3316C27.9707 26.358 27.598 26.9652 26.2931 27.0578L10.872 27.9919C9.89279 28.0382 9.42647 27.8983 8.9136 27.2448L5.79198 23.1855C5.23208 22.4384 5 21.8792 5 21.2255V6.66735C5 5.82809 5.37271 5.12826 6.44405 5.03539Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.7237 4.05477L6.44405 5.03563C5.37271 5.12826 5 5.82833 5 6.66735V21.2255C5 21.879 5.23208 22.4382 5.79198 23.1855L8.9136 27.2446C9.42647 27.8981 9.89279 28.0382 10.872 27.9917L26.2934 27.0581C27.5972 26.9652 27.9709 26.358 27.9709 25.3318V8.95379C27.9709 8.4234 27.7614 8.27052 27.1446 7.81789L22.7997 4.75459C21.7742 4.00893 21.355 3.91461 19.7237 4.05453V4.05477ZM11.2207 8.68572C9.96142 8.77043 9.67583 8.78963 8.96064 8.20813L7.14244 6.76191C6.95764 6.57472 7.05052 6.3412 7.51611 6.29464L20.2822 5.36178C21.3542 5.26818 21.9125 5.64185 22.3317 5.96825L24.5212 7.55462C24.6148 7.6019 24.8476 7.88101 24.5675 7.88101L11.3839 8.67468L11.2207 8.68572ZM9.75263 25.1919V11.2882C9.75263 10.681 9.93911 10.401 10.4973 10.3539L25.6396 9.46738C26.1532 9.42106 26.3853 9.74746 26.3853 10.3537V24.1647C26.3853 24.7719 26.2917 25.2855 25.4534 25.3318L10.9632 26.1718C10.1249 26.2181 9.75287 25.939 9.75287 25.1919H9.75263ZM24.0564 12.0337C24.1492 12.4536 24.0564 12.8736 23.6364 12.9216L22.938 13.0601V23.3254C22.3315 23.6518 21.7733 23.8383 21.3067 23.8383C20.5611 23.8383 20.3748 23.6048 19.8164 22.9054L15.2492 15.72V22.6719L16.694 22.999C16.694 22.999 16.694 23.839 15.5284 23.839L12.3148 24.0255C12.2212 23.8383 12.3148 23.372 12.6405 23.2791L13.4798 23.0463V13.8545L12.3151 13.7602C12.2215 13.3402 12.4543 12.7337 13.107 12.6867L16.5551 12.4546L21.307 19.7329V13.2939L20.0957 13.1547C20.0021 12.6404 20.3748 12.2667 20.8404 12.2211L24.0564 12.0337Z",
                fill: "black"
            })
        ]
    });
module.exports["NotionIcon"] = $1f5798f9f44e84fb$export$694ff710b1e20299;

});

parcelRegister("kqu9k", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $bc2ace10d7629696$export$ef1f2d131b16090c = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M5.8801 5.63103L13.9736 5.03323C14.9678 4.94796 15.2232 5.00544 15.8483 5.4599L18.4319 7.27992C18.858 7.59294 18.9999 7.67822 18.9999 8.01902V18.0009C18.9999 18.6265 18.7727 18.9965 17.9774 19.053L8.57877 19.6223C7.98199 19.6505 7.69779 19.5652 7.38521 19.1669L5.48269 16.6929C5.14144 16.2376 5 15.8968 5 15.4983V6.62566C5 6.11416 5.22716 5.68764 5.8801 5.63103Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.9736 5.03338L5.8801 5.63118C5.22716 5.68764 5 6.11431 5 6.62566V15.4983C5 15.8966 5.14144 16.2374 5.48269 16.6929L7.38521 19.1668C7.69779 19.5651 7.98199 19.6505 8.57877 19.6221L17.9776 19.0531C18.7723 18.9965 19 18.6265 19 18.001V8.01917C19 7.69591 18.8723 7.60274 18.4964 7.32688L15.8483 5.4599C15.2233 5.00544 14.9678 4.94796 13.9736 5.03323V5.03338ZM8.7913 7.85579C8.02382 7.90742 7.84976 7.91912 7.41388 7.56471L6.30574 6.68329C6.19312 6.5692 6.24972 6.42688 6.53349 6.39851L14.314 5.82996C14.9674 5.77291 15.3076 6.00066 15.5631 6.19958L16.8975 7.16642C16.9546 7.19524 17.0965 7.36535 16.9258 7.36535L8.89076 7.84906L8.7913 7.85579ZM7.89657 17.9157V9.44193C7.89657 9.07187 8.01022 8.90117 8.35044 8.8725L17.5791 8.33218C17.8922 8.30395 18.0336 8.50288 18.0336 8.87236V17.2897C18.0336 17.6598 17.9766 17.9728 17.4656 18.001L8.63435 18.513C8.12343 18.5412 7.89671 18.3711 7.89671 17.9157H7.89657ZM16.6142 9.89624C16.6708 10.1522 16.6142 10.4082 16.3582 10.4374L15.9326 10.5218V16.7782C15.563 16.9771 15.2227 17.0908 14.9384 17.0908C14.4839 17.0908 14.3704 16.9485 14.0301 16.5222L11.2466 12.1429V16.3799L12.1271 16.5793C12.1271 16.5793 12.1271 17.0912 11.4167 17.0912L9.45814 17.2049C9.40109 17.0908 9.45814 16.8066 9.65662 16.75L10.1681 16.6081V11.006L9.45828 10.9485C9.40124 10.6925 9.54312 10.3229 9.94097 10.2942L12.0424 10.1528L14.9385 14.5887V10.6643L14.2003 10.5795C14.1433 10.266 14.3704 10.0383 14.6542 10.0105L16.6142 9.89624Z",
                fill: "black"
            })
        ]
    });
module.exports["NotionFilterIcon"] = $bc2ace10d7629696$export$ef1f2d131b16090c;

});

parcelRegister("6RO5S", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $7fdc370bf8ac0124$export$44884401d09e251c = ()=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "-1 0 26 26",
        children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
            id: "OneDrive",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                    fill: "none",
                    width: "24",
                    height: "24"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M14.5,15l4.95-4.74A7.5,7.5,0,0,0,5.92,8C6,8,14.5,15,14.5,15Z",
                    fill: "#0364BA"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M9.15,8.89h0A6,6,0,0,0,6,8H5.92a6,6,0,0,0-4.84,9.43L8.5,16.5l5.69-4.59Z",
                    fill: "#0078D4"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M19.45,10.26h-.32a4.84,4.84,0,0,0-1.94.4h0l-3,1.26L17.5,16l5.92,1.44a4.88,4.88,0,0,0-4-7.18Z",
                    fill: "#1490DF"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M1.08,17.43A6,6,0,0,0,6,20H19.13a4.89,4.89,0,0,0,4.29-2.56l-9.23-5.53Z",
                    fill: "#28A8EA"
                })
            ]
        })
    });
module.exports["OneDriveIcon"] = $7fdc370bf8ac0124$export$44884401d09e251c;

});

parcelRegister("lTHwu", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $644faf8e4e2166a3$export$62b570fbaf793397 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M25.4456 5.5H12.5525C11.9748 5.5 11.4995 5.97531 11.4995 6.55295V7.74978L18.7665 9.99978L26.4985 7.74978V6.55295C26.4985 5.97531 26.0232 5.5 25.4456 5.5Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M27.7358 17.053C27.8457 16.7078 27.9334 16.3558 27.9983 15.9993C27.9984 15.821 27.903 15.6557 27.7486 15.5666L27.7389 15.5613L27.7358 15.5599L19.6078 10.9297C19.5728 10.907 19.5364 10.8861 19.4991 10.8674C19.1844 10.7114 18.8141 10.7114 18.4994 10.8674C18.4621 10.8861 18.4258 10.9069 18.3906 10.9297L10.2627 15.5599L10.2597 15.5613L10.2498 15.5666C10.0955 15.6557 10.0001 15.821 10.0002 15.9993C10.0652 16.3558 10.1529 16.7078 10.2627 17.053L18.8811 23.3563L27.7358 17.053Z",
                fill: "#0A2767"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M21.9988 7.74982H16.7491L15.2334 9.99982L16.7491 12.2496L21.9988 16.7493H26.4985V12.2496L21.9988 7.74982Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4996 7.74982H16.7493V12.2495H11.4996V7.74982Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.9989 7.74982H26.4986V12.2495H21.9989V7.74982Z",
                fill: "#50D9FF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M21.999 16.7492L16.7493 12.2496H11.4996V16.7492L16.7493 21.249L24.8728 22.5749L21.999 16.7492Z",
                fill: "#0364B8"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.7493 12.2496H21.9989V16.7492H16.7493V12.2496Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.4996 16.7493H16.7493V21.2489H11.4996V16.7493Z",
                fill: "#064A8C"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.9989 16.7493H26.4986V21.2489H21.9989V16.7493Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M19.1423 22.9124L10.2974 16.4628L10.6678 15.8111C10.6678 15.8111 18.7261 20.4008 18.849 20.4698C18.9509 20.5107 19.0654 20.5075 19.1648 20.4608C19.2795 20.3963 27.3632 15.7886 27.3632 15.7886L27.7352 16.4403L19.1423 22.9124Z",
                fill: "#0A2767",
                fillOpacity: "0.498039"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M27.7488 16.4321L27.7391 16.4381L27.7368 16.4396L19.6089 21.0699C19.2809 21.2813 18.8655 21.3072 18.5139 21.1381L21.3449 24.9336L27.5351 26.2813V26.2843C27.8269 26.0732 28.0001 25.7341 28 25.3739V15.9995C28.0001 16.1777 27.9047 16.3431 27.7503 16.4321H27.7488Z",
                fill: "#1490DF"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M27.9985 25.3738V24.8204L20.5117 20.5546L19.608 21.0691C19.2802 21.2805 18.8648 21.3065 18.5132 21.1373L21.3442 24.9329L27.5343 26.2805V26.2835C27.8262 26.0723 27.9993 25.7333 27.9993 25.3731L27.9985 25.3738Z",
                fill: "black",
                fillOpacity: "0.047059"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M27.9611 25.661L19.7543 20.9858L19.608 21.0691C19.2802 21.2805 18.8648 21.3065 18.5132 21.1373L21.3442 24.9329L27.5343 26.2805V26.2835C27.7443 26.1312 27.8954 25.911 27.9618 25.6603L27.9611 25.661Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M10.2621 16.4419V16.4344H10.2547L10.2321 16.4195C10.0866 16.3299 9.99823 16.1703 9.99965 15.9995V25.3754C9.99965 25.9916 10.5068 26.4988 11.1232 26.4988H26.8737C26.9673 26.4978 27.0606 26.4853 27.1511 26.4613C27.1982 26.4531 27.2437 26.4379 27.2862 26.4163C27.3021 26.4147 27.3174 26.4096 27.3311 26.4013C27.3925 26.3762 27.4505 26.3435 27.5036 26.3037L27.5336 26.2813L10.2621 16.4419Z",
                fill: "#28A8EA"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M17.4992 22.4993V10.2503C17.4976 9.70247 17.0473 9.25225 16.4995 9.25061H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V23.5019V23.4989H16.4995C17.0473 23.4973 17.4976 23.047 17.4992 22.4993Z",
                fill: "black",
                fillOpacity: "0.098039"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M16.7493 23.2491V11.0002C16.7477 10.4525 16.2973 10.0022 15.7496 10.0005H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V24.2519V24.2489H15.7496C16.2973 24.2472 16.7477 23.797 16.7493 23.2491ZM16.7493 21.7493V11.0002C16.7477 10.4525 16.2973 10.0022 15.7496 10.0005H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V22.7519V22.749H15.7496C16.2973 22.7473 16.7477 22.2971 16.7493 21.7493ZM15.9993 21.7493V11.0002C15.9977 10.4525 15.5475 10.0022 14.9997 10.0005H11.5229V14.8422L10.2621 15.5606L10.2592 15.5622L10.2495 15.5674C10.095 15.6566 9.99963 15.8219 9.99963 16.0001V22.7519V22.749H14.9997C15.5475 22.7473 15.9977 22.2971 15.9993 21.7493Z",
                fill: "black",
                fillOpacity: "0.2"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M4.99971 9.99988H14.9988C15.5472 9.99988 15.9985 10.4511 15.9985 10.9995V20.9986C15.9985 21.547 15.5472 21.9984 14.9988 21.9984H4.99971C4.45131 21.9984 4 21.547 4 20.9986V10.9995C4 10.4511 4.45131 9.99988 4.99971 9.99988Z",
                fill: "#0078D4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M6.90014 14.1005C7.16577 13.5344 7.59472 13.0606 8.13155 12.7401C8.72643 12.3995 9.40377 12.2299 10.089 12.2497C10.7236 12.2357 11.35 12.3966 11.8993 12.7146C12.4163 13.0225 12.8327 13.4741 13.0977 14.0143C13.3864 14.6095 13.5304 15.2645 13.5177 15.9259C13.5318 16.6172 13.3835 17.3023 13.085 17.9261C12.8142 18.4854 12.3852 18.9533 11.8513 19.2715C11.2806 19.5995 10.6308 19.7648 9.97268 19.7492C9.32435 19.7646 8.6841 19.6019 8.12185 19.2789C7.60083 18.9705 7.17941 18.5185 6.90843 17.977C6.61792 17.3903 6.47228 16.7425 6.48395 16.0879C6.47108 15.4025 6.61366 14.7231 6.9009 14.1005H6.90014ZM8.2125 17.2938C8.35421 17.6517 8.59454 17.9623 8.90555 18.1892C9.22203 18.4109 9.60145 18.5252 9.98763 18.5155C10.3991 18.5318 10.8048 18.4138 11.1433 18.1795C11.4505 17.9526 11.6845 17.6404 11.8161 17.2818C11.964 16.8821 12.0369 16.4585 12.0313 16.0324C12.0359 15.6026 11.9674 15.1749 11.8289 14.768C11.7067 14.4017 11.4811 14.0783 11.1793 13.8374C10.8498 13.5913 10.4452 13.4662 10.0342 13.4834C9.63963 13.4731 9.2517 13.5881 8.9265 13.8118C8.6097 14.0395 8.36403 14.3527 8.2185 14.7148C7.89668 15.5438 7.89483 16.4636 8.21326 17.2938H8.2125Z",
                fill: "white"
            })
        ]
    });
module.exports["OutlookCalendarIcon"] = $644faf8e4e2166a3$export$62b570fbaf793397;

});

parcelRegister("1gvAG", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $7bfba04b070f6d86$export$53d8bcde0f28cd56 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                clipPath: "url(#clip0_271_181641)",
                children: /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                    clipPath: "url(#clip1_271_181641)",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M12.2328 13.4286C15.3153 13.4286 17.8142 10.8702 17.8142 7.71429C17.8142 4.55837 15.3153 2 12.2328 2C9.15024 2 6.65137 4.55837 6.65137 7.71429C6.65137 10.8702 9.15024 13.4286 12.2328 13.4286Z",
                            fill: "#036C70"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M16.8836 18.1906C19.7093 18.1906 21.9999 15.8454 21.9999 12.9525C21.9999 10.0595 19.7093 7.71436 16.8836 7.71436C14.058 7.71436 11.7673 10.0595 11.7673 12.9525C11.7673 15.8454 14.058 18.1906 16.8836 18.1906Z",
                            fill: "#1A9BA1"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M12.9303 22C15.1137 22 16.8838 20.1878 16.8838 17.9524C16.8838 15.717 15.1137 13.9048 12.9303 13.9048C10.7468 13.9048 8.97681 15.717 8.97681 17.9524C8.97681 20.1878 10.7468 22 12.9303 22Z",
                            fill: "#37C6D0"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            opacity: "0.1",
                            d: "M13.1628 7.15707V17.319C13.1605 17.6721 12.9515 17.9893 12.6326 18.1237C12.5311 18.1677 12.4219 18.1904 12.3117 18.1904H8.98144C8.9768 18.1094 8.9768 18.0333 8.9768 17.9523C8.97525 17.8728 8.97835 17.7933 8.9861 17.7142C9.07123 16.192 9.98715 14.849 11.3535 14.2428V13.3571C8.31257 12.8637 6.23802 9.93985 6.71991 6.82647C6.72326 6.8049 6.72671 6.78335 6.73029 6.76183C6.75344 6.60124 6.78607 6.44221 6.82797 6.28564H12.3117C12.781 6.28747 13.1611 6.67656 13.1628 7.15707Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            opacity: "0.2",
                            d: "M11.8464 6.76196H6.73014C6.2133 9.86973 8.25507 12.818 11.2906 13.3472C11.3825 13.3632 11.4748 13.3769 11.5673 13.3882C10.1255 14.0882 9.07479 16.0762 8.98549 17.7143C8.97775 17.7934 8.97463 17.8729 8.97618 17.9524C8.97618 18.0334 8.97618 18.1096 8.98083 18.1905C8.98922 18.3506 9.00944 18.5098 9.04129 18.6667H11.8459C12.1908 18.6644 12.5007 18.4504 12.632 18.1239C12.6749 18.0199 12.6971 17.9082 12.6971 17.7953V7.63339C12.6953 7.15306 12.3156 6.76406 11.8464 6.76196Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            opacity: "0.2",
                            d: "M11.8466 6.76196H6.73034C6.21361 9.87002 8.25569 12.8185 11.2915 13.3475C11.3536 13.3583 11.4158 13.3681 11.4783 13.3767C10.0829 14.1272 9.07361 16.1105 8.98616 17.7143H11.8466C12.3152 17.7107 12.6942 17.3227 12.6978 16.8429V7.63339C12.696 7.15288 12.316 6.76379 11.8466 6.76196Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            opacity: "0.2",
                            d: "M11.3814 6.76196H6.73019C6.24226 9.696 8.03799 12.5215 10.8558 13.2534C9.78883 14.5014 9.13442 16.0628 8.98601 17.7143H11.3814C11.8507 17.7125 12.2307 17.3234 12.2325 16.8429V7.63339C12.2323 7.15223 11.8513 6.76223 11.3814 6.76196Z",
                            fill: "black"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M2.85256 6.76196H11.38C11.8509 6.76196 12.2326 7.15275 12.2326 7.63482V16.3653C12.2326 16.8474 11.8509 17.2382 11.38 17.2382H2.85256C2.3817 17.2382 2 16.8474 2 16.3653V7.63482C2 7.15275 2.3817 6.76196 2.85256 6.76196Z",
                            fill: "#04868B"
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            d: "M5.80776 11.8932C5.60797 11.7575 5.44108 11.5769 5.31985 11.3651C5.20239 11.1437 5.14385 10.8946 5.15008 10.6427C5.13962 10.3017 5.25202 9.96868 5.46589 9.70702C5.69064 9.44505 5.98113 9.25105 6.30589 9.14606C6.67602 9.02134 7.0637 8.95988 7.45333 8.96416C7.96573 8.945 8.47741 9.01835 8.96496 9.18083V10.2761C8.75312 10.1447 8.52238 10.0483 8.28124 9.99036C8.01958 9.92467 7.7511 9.89173 7.4817 9.89226C7.19761 9.88158 6.91534 9.94276 6.65984 10.0704C6.46259 10.1575 6.33467 10.3561 6.33426 10.5761C6.33346 10.7095 6.38352 10.838 6.4738 10.9342C6.58043 11.0476 6.70656 11.1399 6.84589 11.2066C7.00093 11.2856 7.23349 11.3907 7.54357 11.5218C7.57771 11.5328 7.61099 11.5465 7.6431 11.5628C7.94828 11.6849 8.24269 11.8335 8.5231 12.007C8.73546 12.1411 8.91368 12.3249 9.04311 12.5432C9.1758 12.7908 9.24011 13.0706 9.22915 13.3528C9.2443 13.7029 9.13968 14.0474 8.93334 14.327C8.72767 14.5841 8.45269 14.7736 8.14264 14.8718C7.77795 14.9888 7.39733 15.0454 7.01519 15.0394C6.67234 15.041 6.32999 15.0123 5.99194 14.9537C5.70651 14.9059 5.42796 14.8221 5.16264 14.7042V13.5494C5.41625 13.7349 5.69959 13.8735 5.99985 13.9589C6.2991 14.0544 6.61017 14.1054 6.92357 14.1104C7.21363 14.1292 7.50318 14.0663 7.76078 13.9285C7.94123 13.8242 8.05098 13.6267 8.04637 13.4147C8.04757 13.2671 7.99055 13.1253 7.88823 13.0213C7.76098 12.8934 7.61366 12.7883 7.45242 12.7104C7.26638 12.6151 6.99242 12.4896 6.63056 12.3337C6.34269 12.2152 6.06706 12.0677 5.80776 11.8932Z",
                            fill: "white"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip0_271_181641",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "20",
                            height: "20",
                            fill: "white",
                            transform: "translate(2 2)"
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                        id: "clip1_271_181641",
                        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                            width: "20",
                            height: "20",
                            fill: "white",
                            transform: "translate(2 2)"
                        })
                    })
                ]
            })
        ]
    });
module.exports["SharePointIcon"] = $7bfba04b070f6d86$export$53d8bcde0f28cd56;

});

parcelRegister("b4FVC", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $1888d1f4214166db$export$65b9e0ddb04a51a1 = (_)=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_6321_165901)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M16.2797 17.7143C19.9787 17.7143 22.9774 14.6442 22.9774 10.8571C22.9774 7.07005 19.9787 4 16.2797 4C12.5807 4 9.58203 7.07005 9.58203 10.8571C9.58203 14.6442 12.5807 17.7143 16.2797 17.7143Z",
                        fill: "#036C70"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M21.8602 23.4286C25.251 23.4286 27.9998 20.6144 27.9998 17.1429C27.9998 13.6714 25.251 10.8572 21.8602 10.8572C18.4695 10.8572 15.7207 13.6714 15.7207 17.1429C15.7207 20.6144 18.4695 23.4286 21.8602 23.4286Z",
                        fill: "#1A9BA1"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M17.1163 27.9999C19.7364 27.9999 21.8604 25.8253 21.8604 23.1428C21.8604 20.4603 19.7364 18.2856 17.1163 18.2856C14.4961 18.2856 12.3721 20.4603 12.3721 23.1428C12.3721 25.8253 14.4961 27.9999 17.1163 27.9999Z",
                        fill: "#37C6D0"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.1",
                        d: "M17.395 10.1885V22.3828C17.3922 22.8065 17.1414 23.1872 16.7587 23.3485C16.6369 23.4013 16.5059 23.4285 16.3736 23.4285H12.3773C12.3718 23.3314 12.3718 23.24 12.3718 23.1428C12.3699 23.0474 12.3736 22.952 12.3829 22.8571C12.4851 21.0305 13.5842 19.4189 15.2239 18.6914V17.6285C11.5747 17.0365 9.08523 13.5279 9.66351 9.79181C9.66752 9.76593 9.67166 9.74007 9.67596 9.71425C9.70374 9.52153 9.74289 9.3307 9.79317 9.14282H16.3736C16.9368 9.14502 17.3929 9.61192 17.395 10.1885Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M15.8156 9.71436H9.67607C9.05586 13.4437 11.506 16.9816 15.1486 17.6166C15.2589 17.6358 15.3696 17.6522 15.4807 17.6658C13.7505 18.5058 12.4896 20.8915 12.3825 22.8572C12.3732 22.9521 12.3695 23.0475 12.3713 23.1429C12.3713 23.2401 12.3713 23.3315 12.3769 23.4286C12.387 23.6207 12.4112 23.8117 12.4495 24.0001H15.815C16.2289 23.9972 16.6007 23.7405 16.7583 23.3486C16.8098 23.2239 16.8364 23.0898 16.8364 22.9543V10.7601C16.8343 10.1837 16.3786 9.71687 15.8156 9.71436Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M15.8156 9.71436H9.67602C9.05594 13.444 11.5064 16.9821 15.1494 17.617C15.2239 17.63 15.2986 17.6417 15.3735 17.6521C13.6991 18.5526 12.4879 20.9327 12.383 22.8572H15.8156C16.3779 22.8529 16.8327 22.3872 16.837 21.8115V10.7601C16.8348 10.1835 16.3788 9.71655 15.8156 9.71436Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M15.2572 9.71436H9.67584C9.09032 13.2352 11.2452 16.6258 14.6265 17.5041C13.3462 19.0017 12.5609 20.8753 12.3828 22.8572H15.2572C15.8204 22.855 16.2765 22.3881 16.2786 21.8115V10.7601C16.2783 10.1827 15.8212 9.71468 15.2572 9.71436Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M5.02307 9.71436H15.256C15.821 9.71436 16.2791 10.1833 16.2791 10.7618V21.2384C16.2791 21.8168 15.821 22.2858 15.256 22.2858H5.02307C4.45804 22.2858 4 21.8168 4 21.2384V10.7618C4 10.1833 4.45804 9.71436 5.02307 9.71436Z",
                        fill: "#04868B"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M8.56932 15.872C8.32956 15.7091 8.12929 15.4924 7.98383 15.2382C7.84287 14.9726 7.77262 14.6736 7.7801 14.3714C7.76755 13.9622 7.90243 13.5625 8.15907 13.2485C8.42876 12.9342 8.77736 12.7014 9.16707 12.5754C9.61123 12.4257 10.0764 12.352 10.544 12.3571C11.1589 12.3341 11.7729 12.4221 12.3579 12.6171V13.9314C12.1037 13.7737 11.8269 13.658 11.5375 13.5885C11.2235 13.5097 10.9013 13.4702 10.578 13.4708C10.2371 13.458 9.89841 13.5314 9.59181 13.6845C9.3551 13.7891 9.20161 14.0275 9.20112 14.2914C9.20015 14.4515 9.26023 14.6056 9.36856 14.7211C9.49651 14.8572 9.64787 14.968 9.81507 15.048C10.0011 15.1428 10.2802 15.2689 10.6523 15.4263C10.6933 15.4395 10.7332 15.4559 10.7717 15.4754C11.1379 15.6219 11.4912 15.8003 11.8277 16.0085C12.0825 16.1694 12.2964 16.3899 12.4517 16.652C12.611 16.949 12.6881 17.2848 12.675 17.6234C12.6932 18.0435 12.5676 18.457 12.32 18.7925C12.0732 19.101 11.7432 19.3284 11.3712 19.4463C10.9335 19.5867 10.4768 19.6546 10.0182 19.6474C9.60681 19.6493 9.19598 19.6149 8.79033 19.5445C8.44781 19.4872 8.11355 19.3866 7.79517 19.2451V17.8594C8.0995 18.0819 8.43951 18.2482 8.79982 18.3508C9.15892 18.4654 9.53221 18.5266 9.90829 18.5325C10.2564 18.5551 10.6038 18.4796 10.9129 18.3143C11.1295 18.1892 11.2612 17.9522 11.2556 17.6977C11.2571 17.5206 11.1887 17.3504 11.0659 17.2257C10.9132 17.0722 10.7364 16.9461 10.5429 16.8525C10.3197 16.7383 9.9909 16.5876 9.55667 16.4005C9.21122 16.2584 8.88047 16.0813 8.56932 15.872Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_6321_165901",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white",
                        transform: "translate(4 4)"
                    })
                })
            })
        ]
    });
module.exports["SharePointSearchResultIcon"] = $1888d1f4214166db$export$65b9e0ddb04a51a1;

});

parcelRegister("77KdG", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $f2d99a04ee67733c$export$b33fb54b08bb6422 = (props)=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_271_181639)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.33321 2C8.22767 2.00082 7.33294 2.89621 7.33375 3.99954C7.33294 5.10288 8.22849 5.99827 9.33403 5.99909H11.3343V4.00036C11.3351 2.89702 10.4396 2.00163 9.33321 2C9.33403 2 9.33403 2 9.33321 2V2ZM9.33321 7.33321H4.00077C2.89522 7.33402 1.99967 8.22941 2.00049 9.33275C1.99886 10.4361 2.89441 11.3315 3.99995 11.3331H9.33321C10.4388 11.3323 11.3343 10.4369 11.3335 9.33357C11.3343 8.22941 10.4388 7.33402 9.33321 7.33321V7.33321Z",
                        fill: "#36C5F0"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M21.9998 9.33275C22.0006 8.22941 21.1051 7.33402 19.9995 7.33321C18.894 7.33402 17.9984 8.22941 17.9992 9.33275V11.3331H19.9995C21.1051 11.3323 22.0006 10.4369 21.9998 9.33275ZM16.6665 9.33275V3.99954C16.6673 2.89702 15.7726 2.00163 14.667 2C13.5615 2.00082 12.6659 2.89621 12.6668 3.99954V9.33275C12.6651 10.4361 13.5607 11.3315 14.6662 11.3331C15.7718 11.3323 16.6673 10.4369 16.6665 9.33275Z",
                        fill: "#2EB67D"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M14.6665 21.9995C15.7721 21.9987 16.6677 21.1033 16.6668 19.9999C16.6677 18.8966 15.7721 18.0012 14.6665 18.0004H12.6663V19.9999C12.6654 21.1025 13.561 21.9979 14.6665 21.9995ZM14.6665 16.6654H19.9998C21.1054 16.6646 22.0009 15.7692 22.0001 14.6659C22.0018 13.5626 21.1062 12.6672 20.0006 12.6655H14.6674C13.5618 12.6663 12.6663 13.5617 12.6671 14.6651C12.6663 15.7692 13.561 16.6646 14.6665 16.6654V16.6654Z",
                        fill: "#ECB22E"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M2.00073 14.6663C1.99992 15.7696 2.89547 16.665 4.00102 16.6659C5.10657 16.665 6.00212 15.7696 6.0013 14.6663V12.6667H4.00102C2.89547 12.6676 1.99992 13.563 2.00073 14.6663ZM7.33401 14.6663V19.9995C7.33237 21.1029 8.22792 21.9983 9.33347 21.9999C10.439 21.9991 11.3346 21.1037 11.3338 20.0003V14.6679C11.3354 13.5646 10.4398 12.6692 9.33429 12.6676C8.22792 12.6676 7.33319 13.563 7.33401 14.6663C7.33401 14.6671 7.33401 14.6663 7.33401 14.6663Z",
                        fill: "#E01E5A"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_271_181639",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "20",
                        height: "20",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });
module.exports["SlackIcon"] = $f2d99a04ee67733c$export$b33fb54b08bb6422;

});

parcelRegister("i26Jf", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $a7d0bbaf1082f6f1$export$9e3ecebaf98513b9 = (_)=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12.7993 4C11.4726 4.00098 10.3989 5.07545 10.3999 6.39945C10.3989 7.72346 11.4736 8.79793 12.8003 8.79891H15.2006V6.40043C15.2016 5.07643 14.1269 4.00196 12.7993 4C12.8003 4 12.8003 4 12.7993 4V4ZM12.7993 10.3998H6.40034C5.07368 10.4008 3.99902 11.4753 4 12.7993C3.99804 14.1233 5.0727 15.1978 6.39936 15.1997H12.7993C14.1259 15.1988 15.2006 14.1243 15.1996 12.8003C15.2006 11.4753 14.1259 10.4008 12.7993 10.3998Z",
                fill: "#36C5F0"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M28.0004 12.7993C28.0014 11.4753 26.9267 10.4008 25.6001 10.3998C24.2734 10.4008 23.1988 11.4753 23.1997 12.7993V15.1997H25.6001C26.9267 15.1988 28.0014 14.1243 28.0004 12.7993ZM21.6005 12.7993V6.39945C21.6015 5.07643 20.5278 4.00196 19.2011 4C17.8745 4.00098 16.7998 5.07545 16.8008 6.39945V12.7993C16.7988 14.1233 17.8735 15.1978 19.2001 15.1997C20.5268 15.1988 21.6015 14.1243 21.6005 12.7993Z",
                fill: "#2EB67D"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.1992 27.9993C20.5258 27.9984 21.6005 26.9239 21.5995 25.5999C21.6005 24.2759 20.5258 23.2014 19.1992 23.2004H16.7988V25.5999C16.7978 26.9229 17.8725 27.9974 19.1992 27.9993ZM19.1992 21.5985H25.5991C26.9258 21.5975 28.0004 20.523 27.9995 19.199C28.0014 17.875 26.9268 16.8005 25.6001 16.7986H19.2002C17.8735 16.7996 16.7988 17.874 16.7998 19.198C16.7988 20.523 17.8725 21.5975 19.1992 21.5985Z",
                fill: "#ECB22E"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4 19.1998C3.99902 20.5238 5.07368 21.5982 6.40034 21.5992C7.727 21.5982 8.80166 20.5238 8.80068 19.1998V16.8003H6.40034C5.07368 16.8013 3.99902 17.8757 4 19.1998ZM10.3999 19.1998V25.5996C10.398 26.9236 11.4726 27.9981 12.7993 28.0001C14.1259 27.9991 15.2006 26.9246 15.1996 25.6006V19.2017C15.2016 17.8777 14.1269 16.8032 12.8003 16.8013C11.4726 16.8013 10.3989 17.8757 10.3999 19.1998C10.3999 19.2007 10.3999 19.1998 10.3999 19.1998Z",
                fill: "#E01E5A"
            })
        ]
    });
module.exports["SlackSearchResultIcon"] = $a7d0bbaf1082f6f1$export$9e3ecebaf98513b9;

});

parcelRegister("dHucp", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $ed84f6ffa6dc4ec7$export$1bcbc9c337da86da = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "1 1 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_3561_46629)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M15.0321 10H19.4879C19.9088 10 20.2501 10.3403 20.2501 10.76V14.8068C20.2501 16.3494 18.9959 17.6 17.4488 17.6H17.4355C15.8884 17.6002 14.634 16.3498 14.6338 14.8072C14.6338 14.8071 14.6338 14.8069 14.6338 14.8068V10.3972C14.6338 10.1778 14.8121 10 15.0321 10Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M18.0435 9.19961C19.0405 9.19961 19.8487 8.39372 19.8487 7.39961C19.8487 6.4055 19.0405 5.59961 18.0435 5.59961C17.0465 5.59961 16.2383 6.4055 16.2383 7.39961C16.2383 8.39372 17.0465 9.19961 18.0435 9.19961Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M12.4274 9.20001C13.8675 9.20001 15.0349 8.03594 15.0349 6.6C15.0349 5.16406 13.8675 4 12.4274 4C10.9873 4 9.81982 5.16406 9.81982 6.6C9.81982 8.03594 10.9873 9.20001 12.4274 9.20001Z",
                        fill: "#7B83EB"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M15.904 10H8.54908C8.13313 10.0103 7.8041 10.3545 7.81375 10.7692V15.3848C7.75566 17.8737 9.73048 19.9391 12.2265 20C14.7226 19.9391 16.6974 17.8737 16.6393 15.3848V10.7692C16.649 10.3545 16.3199 10.0103 15.904 10Z",
                        fill: "#7B83EB"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.1",
                        d: "M12.6276 10V16.468C12.6256 16.7646 12.4454 17.0311 12.1703 17.144C12.0827 17.1809 11.9886 17.2 11.8935 17.2H8.16671C8.11456 17.068 8.06642 16.936 8.0263 16.8C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H12.6276Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.2265 10V16.868C12.2265 16.9628 12.2074 17.0567 12.1703 17.144C12.0571 17.4183 11.7898 17.598 11.4924 17.6H8.35526C8.28706 17.468 8.22288 17.336 8.16671 17.2C8.11055 17.064 8.06642 16.936 8.0263 16.8C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H12.2265Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.2265 10V16.068C12.2234 16.471 11.8965 16.797 11.4923 16.8H8.0263C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H12.2265Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8253 10V16.068C11.8223 16.471 11.4954 16.797 11.0912 16.8H8.0263C7.88588 16.341 7.81423 15.8639 7.81368 15.384V10.768C7.80404 10.3539 8.13253 10.0103 8.54781 10H11.8253Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.1",
                        d: "M12.628 7.93121V9.19121C12.5598 9.19521 12.4956 9.19921 12.4274 9.19921C12.3592 9.19921 12.2951 9.19522 12.2269 9.19121C12.0914 9.18225 11.9572 9.16083 11.8257 9.12721C11.0133 8.93539 10.3422 8.36732 10.0205 7.59922C9.9651 7.47023 9.92213 7.33629 9.89209 7.19922H11.8939C12.2987 7.20075 12.6265 7.52757 12.628 7.93121Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.2269 8.3316V9.1916C12.0915 9.18264 11.9572 9.16122 11.8257 9.12761C11.0134 8.93578 10.3422 8.36772 10.0205 7.59961H11.4928C11.8976 7.60114 12.2254 7.92797 12.2269 8.3316Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M12.2269 8.3316V9.1916C12.0915 9.18264 11.9572 9.16122 11.8257 9.12761C11.0134 8.93578 10.3422 8.36772 10.0205 7.59961H11.4928C11.8976 7.60114 12.2254 7.92797 12.2269 8.3316Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M11.8257 8.33161V9.12761C11.0134 8.93578 10.3422 8.36772 10.0205 7.59961H11.0916C11.4964 7.60115 11.8242 7.92798 11.8257 8.33161Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M3.73533 7.59961H11.0902C11.4964 7.59961 11.8256 7.92788 11.8256 8.33281V15.6664C11.8256 16.0713 11.4963 16.3996 11.0902 16.3996H3.73533C3.32921 16.3996 3 16.0713 3 15.6664V8.33281C3 7.92788 3.32922 7.59961 3.73533 7.59961Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M9.34796 10.3916H7.87769V14.3836H6.94098V10.3916H5.47754V9.61719H9.34796V10.3916Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_3561_46629",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "17.25",
                        height: "16",
                        fill: "white",
                        transform: "translate(3 4)"
                    })
                })
            })
        ]
    });
module.exports["TeamsIcon"] = $ed84f6ffa6dc4ec7$export$1bcbc9c337da86da;

});

parcelRegister("97rBY", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $34d821975c330887$export$fa291efbf00e84d3 = (_)=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                clipPath: "url(#clip0_6321_165930)",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M20.7408 13H26.94C27.5257 13 28.0005 13.5104 28.0005 14.14V20.2102C28.0005 22.5242 26.2555 24.4 24.103 24.4H24.0846C21.932 24.4003 20.1868 22.5248 20.1865 20.2108C20.1865 20.2106 20.1865 20.2104 20.1865 20.2102V13.5958C20.1865 13.2667 20.4347 13 20.7408 13Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M24.9306 11.7999C26.3177 11.7999 27.4422 10.5911 27.4422 9.0999C27.4422 7.60873 26.3177 6.3999 24.9306 6.3999C23.5434 6.3999 22.4189 7.60873 22.4189 9.0999C22.4189 10.5911 23.5434 11.7999 24.9306 11.7999Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M17.1162 11.8C19.1198 11.8 20.7441 10.0539 20.7441 7.9C20.7441 5.74609 19.1198 4 17.1162 4C15.1126 4 13.4883 5.74609 13.4883 7.9C13.4883 10.0539 15.1126 11.8 17.1162 11.8Z",
                        fill: "#7B83EB"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M21.954 13H11.7211C11.1424 13.0154 10.6846 13.5317 10.698 14.1538V21.0772C10.6172 24.8106 13.3648 27.9086 16.8376 28C20.3103 27.9086 23.0579 24.8106 22.9771 21.0772V14.1538C22.9905 13.5317 22.5327 13.0154 21.954 13Z",
                        fill: "#7B83EB"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.1",
                        d: "M17.3952 13V22.702C17.3925 23.1469 17.1417 23.5466 16.759 23.716C16.6371 23.7714 16.5061 23.8 16.3738 23.8H11.1887C11.1162 23.602 11.0492 23.404 10.9934 23.2C10.798 22.5115 10.6983 21.7958 10.6976 21.076V14.152C10.6841 13.5309 11.1412 13.0154 11.7189 13H17.3952Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M16.8371 13V23.302C16.8371 23.4442 16.8105 23.585 16.759 23.716C16.6014 24.1274 16.2296 24.397 15.8157 24.4H11.4511C11.3562 24.202 11.2669 24.004 11.1887 23.8C11.1106 23.596 11.0492 23.404 10.9934 23.2C10.798 22.5115 10.6983 21.7958 10.6976 21.076V14.152C10.6841 13.5309 11.1412 13.0154 11.7189 13H16.8371Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M16.8371 13V22.102C16.8328 22.7065 16.378 23.1954 15.8157 23.2H10.9934C10.798 22.5115 10.6983 21.7958 10.6976 21.076V14.152C10.6841 13.5309 11.1412 13.0154 11.7189 13H16.8371Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M16.2789 13V22.102C16.2747 22.7065 15.8199 23.1954 15.2576 23.2H10.9934C10.798 22.5115 10.6983 21.7958 10.6976 21.076V14.152C10.6841 13.5309 11.1412 13.0154 11.7189 13H16.2789Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.1",
                        d: "M17.3954 9.89804V11.788C17.3005 11.794 17.2112 11.8 17.1163 11.8C17.0214 11.8 16.9321 11.794 16.8372 11.788C16.6488 11.7746 16.462 11.7425 16.2791 11.692C15.1489 11.4043 14.2151 10.5522 13.7675 9.40005C13.6905 9.20656 13.6307 9.00565 13.5889 8.80005H16.374C16.9372 8.80234 17.3932 9.29258 17.3954 9.89804Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M16.8373 10.4979V11.7879C16.6489 11.7745 16.4621 11.7423 16.2792 11.6919C15.149 11.4042 14.2152 10.5521 13.7676 9.3999H15.8159C16.3792 9.40219 16.8352 9.89244 16.8373 10.4979Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M16.8373 10.4979V11.7879C16.6489 11.7745 16.4621 11.7423 16.2792 11.6919C15.149 11.4042 14.2152 10.5521 13.7676 9.3999H15.8159C16.3792 9.40219 16.8352 9.89244 16.8373 10.4979Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        opacity: "0.2",
                        d: "M16.2792 10.4979V11.6919C15.149 11.4042 14.2152 10.5521 13.7676 9.3999H15.2578C15.821 9.40221 16.2771 9.89245 16.2792 10.4979Z",
                        fill: "black"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M5.02306 9.3999H15.256C15.821 9.3999 16.2791 9.8923 16.2791 10.4997V21.5001C16.2791 22.1075 15.821 22.5999 15.256 22.5999H5.02306C4.45804 22.5999 4 22.1075 4 21.5001V10.4997C4 9.8923 4.45805 9.3999 5.02306 9.3999Z",
                        fill: "#5059C9"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("path", {
                        d: "M12.8322 13.5869H10.7866V19.5749H9.48336V13.5869H7.44727V12.4253H12.8322V13.5869Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_6321_165930",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white",
                        transform: "translate(4 4)"
                    })
                })
            })
        ]
    });
module.exports["TeamsSearchResultIcon"] = $34d821975c330887$export$fa291efbf00e84d3;

});

parcelRegister("c3jFl", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $7059a0a6b8e771ed$export$4b1dce6f0fbd3e37 = ()=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "3 3 26 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.39008 15.0002H11.02C11.117 12.621 11.5575 10.4492 12.2472 8.78245C12.3552 8.52159 12.4707 8.26946 12.594 8.02828C9.793 9.22645 7.75112 11.8577 7.39008 15.0002ZM15.9997 5.3335C10.1086 5.3335 5.33301 10.1091 5.33301 16.0002C5.33301 21.8912 10.1086 26.6668 15.9997 26.6668C21.8907 26.6668 26.6663 21.8912 26.6663 16.0002C26.6663 10.1091 21.8907 5.3335 15.9997 5.3335ZM15.9997 7.3335C15.7983 7.3335 15.5142 7.42791 15.1575 7.79247C14.7976 8.16034 14.4274 8.74437 14.0953 9.54715C13.5201 10.9372 13.1178 12.84 13.0218 15.0002H18.9776C18.8816 12.84 18.4793 10.9372 17.9041 9.54715C17.5719 8.74437 17.2017 8.16034 16.8418 7.79247C16.4852 7.42791 16.2011 7.3335 15.9997 7.3335ZM20.9794 15.0002C20.8824 12.621 20.4418 10.4492 19.7521 8.78245C19.6442 8.52159 19.5286 8.26946 19.4054 8.02828C22.2063 9.22645 24.2482 11.8577 24.6093 15.0002H20.9794ZM18.9776 17.0002H13.0218C13.1178 19.1604 13.5201 21.0631 14.0953 22.4532C14.4274 23.2559 14.7976 23.84 15.1575 24.2079C15.5142 24.5724 15.7983 24.6668 15.9997 24.6668C16.2011 24.6668 16.4852 24.5724 16.8418 24.2079C17.2017 23.84 17.5719 23.2559 17.9041 22.4532C18.4793 21.0631 18.8816 19.1604 18.9776 17.0002ZM19.4054 23.972C19.5286 23.7309 19.6442 23.4787 19.7521 23.2179C20.4418 21.5511 20.8824 19.3793 20.9794 17.0002H24.6093C24.2482 20.1427 22.2063 22.7739 19.4054 23.972ZM12.594 23.972C12.4707 23.7309 12.3552 23.4787 12.2472 23.2179C11.5575 21.5511 11.117 19.3793 11.02 17.0002H7.39008C7.75112 20.1427 9.793 22.7739 12.594 23.972Z",
            fill: "currentColor"
        })
    });
module.exports["WebDomainIcon"] = $7059a0a6b8e771ed$export$4b1dce6f0fbd3e37;

});

parcelRegister("k1Fwx", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $84118f4f27084a17$export$b16288f56aa4a879 = (_)=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.5428 12.0273H8.26521C8.33797 10.243 8.6684 8.61411 9.18567 7.36406C9.26662 7.16841 9.35328 6.97932 9.44572 6.79843C7.34499 7.69706 5.81358 9.67046 5.5428 12.0273ZM12 4.77734C7.58172 4.77734 4 8.35907 4 12.7773C4 17.1956 7.58172 20.7773 12 20.7773C16.4183 20.7773 20 17.1956 20 12.7773C20 8.35907 16.4183 4.77734 12 4.77734ZM12 6.27734C11.849 6.27734 11.6359 6.34815 11.3684 6.62157C11.0985 6.89748 10.8208 7.3355 10.5717 7.93758C10.1403 8.98016 9.83856 10.4072 9.76656 12.0273H14.2334C14.1614 10.4072 13.8597 8.98016 13.4283 7.93758C13.1792 7.3355 12.9015 6.89748 12.6316 6.62157C12.3641 6.34815 12.151 6.27734 12 6.27734ZM15.7348 12.0273C15.662 10.243 15.3316 8.61411 14.8143 7.36406C14.7334 7.16841 14.6467 6.97931 14.5543 6.79843C16.655 7.69706 18.1864 9.67046 18.4572 12.0273H15.7348ZM14.2334 13.5273H9.76656C9.83856 15.1475 10.1403 16.5745 10.5717 17.6171C10.8208 18.2192 11.0985 18.6572 11.3684 18.9331C11.6359 19.2065 11.849 19.2773 12 19.2773C12.151 19.2773 12.3641 19.2065 12.6316 18.9331C12.9015 18.6572 13.1792 18.2192 13.4283 17.6171C13.8597 16.5745 14.1614 15.1475 14.2334 13.5273ZM14.5543 18.7563C14.6467 18.5754 14.7334 18.3863 14.8143 18.1906C15.3316 16.9406 15.662 15.3117 15.7348 13.5273H18.4572C18.1864 15.8842 16.655 17.8576 14.5543 18.7563ZM9.44572 18.7563C9.35328 18.5754 9.26662 18.3863 9.18567 18.1906C8.6684 16.9406 8.33797 15.3117 8.26521 13.5273H5.5428C5.81358 15.8842 7.34499 17.8576 9.44572 18.7563Z",
            fill: "currentColor"
        })
    });
module.exports["WebDomainSearchResultIcon"] = $84118f4f27084a17$export$b16288f56aa4a879;

});

parcelRegister("djVXt", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $e1256a34ed0c6996$export$9969d63eaadfddf7 = ()=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            d: "M15.0857 11.8028V25.1868H4L15.0857 11.8028ZM15.0857 7C15.0857 8.47005 14.5017 9.8799 13.4622 10.9194C12.4227 11.9589 11.0129 12.5428 9.54284 12.5428C8.07279 12.5428 6.66295 11.9589 5.62346 10.9194C4.58398 9.8799 4 8.47005 4 7H15.0857ZM16.9119 25.188C16.9119 23.7179 17.4959 22.3081 18.5354 21.2686C19.5749 20.2291 20.9847 19.6451 22.4548 19.6451C23.9248 19.6451 25.3347 20.2291 26.3742 21.2686C27.4137 22.3081 27.9976 23.7179 27.9976 25.188H16.9119ZM16.9119 20.3851V7H28L16.9119 20.3839V20.3851Z",
            fill: "var(--ds-text-accent-teal-bolder, #164555)"
        })
    });
var $e1256a34ed0c6996$export$2e2bcd8739ae039 = $e1256a34ed0c6996$export$9969d63eaadfddf7;
module.exports["ZendeskIcon"] = $e1256a34ed0c6996$export$9969d63eaadfddf7;
module.exports["default"] = $e1256a34ed0c6996$export$2e2bcd8739ae039;

});

parcelRegister("4mTS8", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");

const $c59b1fee85e1c517$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
async function $c59b1fee85e1c517$export$f49dad89491f6bf2({ graphQuery: graphQuery, variables: variables, operationName: operationName, aggAbsoluteUrl: url = $c59b1fee85e1c517$var$DEFAULT_GRAPHQL_ENDPOINT }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName
            }
        }
    };
    return (0, $dwp40.utils).requestService({
        url: url
    }, options);
}
module.exports["fetchAgg"] = $c59b1fee85e1c517$export$f49dad89491f6bf2;

});

parcelRegister("1EqNn", function(module, exports) {

var $2CHGe = parcelRequire("2CHGe");

const $8d501caa759a15ca$export$26b8d9fa10eeb703 = (args)=>{
    const cacheInstance = (0, $2CHGe.getInstance)(args);
    const get = (key)=>key.length ? cacheInstance.get(key) : undefined;
    const set = (key, result)=>{
        if (key.length) cacheInstance.set(key, result);
    };
    const has = (key)=>cacheInstance.has(key);
    const clear = (key)=>cacheInstance.clear(key);
    const inMemoryDecorator = (key, supplier, expireWhen)=>{
        // Check if the key is already in the cache
        const cached = get(key);
        // If the key is in the cache, return the cached value
        if (cached) return cached;
        // If the key is not in the cache, call the supplier function
        const result = supplier();
        set(key, result);
        // If the promise is rejected, clear the cache
        result.catch(()=>{
            // If the promise is rejected, clear the cache
            cacheInstance.clear(key);
        });
        // Return the result
        // If the result should be expired, clear the cache
        return result.then((value)=>{
            if (expireWhen && expireWhen(value)) cacheInstance.clear(key);
            return value;
        });
    };
    return {
        get: get,
        set: set,
        has: has,
        clear: clear,
        inMemoryDecorator: inMemoryDecorator
    };
};
module.exports["inMemoryCache"] = $8d501caa759a15ca$export$26b8d9fa10eeb703;

});

parcelRegister("7tGzv", function(module, exports) {

var $gLLcz = parcelRequire("gLLcz");

const $c5e1b4a2d0458afe$export$ffa5bf38ea9a76ee = (0, $gLLcz.z).enum([
    'true',
    'false'
]).transform((x)=>x === 'true');
const $c5e1b4a2d0458afe$export$236bfa8a18b6097 = (0, $gLLcz.z).string().transform((x)=>x.split(','));
const $c5e1b4a2d0458afe$export$1cbda5ccc2e23e06 = (0, $gLLcz.z).nativeEnum({
    Asana: 'asana',
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    GoogleDrive: 'drive',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    Opsgenie: 'opsgenie',
    Sharepoint: 'sharepoint',
    Slack: 'slack',
    Trello: 'trello',
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Teams: 'teams',
    Figma: 'figma',
    Github: 'github',
    Loom: 'loom',
    OneDrive: 'onedrive',
    GoogleCalendar: 'google-calendar',
    Dropbox: 'dropbox',
    Gmail: 'gmail',
    OutlookCalendar: 'outlook-calendar',
    Airtable: 'airtable',
    Zendesk: 'zendesk',
    Notion: 'notion',
    Miro: 'miro'
});
const $c5e1b4a2d0458afe$export$f3a53bd43617a593 = $c5e1b4a2d0458afe$export$1cbda5ccc2e23e06.enum;
const $c5e1b4a2d0458afe$export$7a844b7429919d2 = (0, $gLLcz.z).nativeEnum({
    All: 'all'
});
const $c5e1b4a2d0458afe$export$ec20ab1a5eb36014 = $c5e1b4a2d0458afe$export$7a844b7429919d2.enum;
const $c5e1b4a2d0458afe$export$ddfc756f87e8324d = (0, $gLLcz.z).nativeEnum({
    Goal: 'goal',
    Learning: 'learning',
    Project: 'project',
    Tag: 'tag'
});
const $c5e1b4a2d0458afe$export$48b648eee115c3e5 = $c5e1b4a2d0458afe$export$ddfc756f87e8324d.enum;
const $c5e1b4a2d0458afe$export$578ac6cc3cc5997a = (0, $gLLcz.z).nativeEnum({
    WorkItem: 'work-item'
});
const $c5e1b4a2d0458afe$export$721015a6e24d06a0 = $c5e1b4a2d0458afe$export$578ac6cc3cc5997a.enum;
const $c5e1b4a2d0458afe$export$d872f0aa011c3a9d = (0, $gLLcz.z).nativeEnum({
    Answer: 'answer',
    Attachment: 'attachment',
    Blogpost: 'blogpost',
    Calendar: 'calendar',
    Comment: 'comment',
    Database: 'database',
    Document: 'document',
    Embed: 'embed',
    Folder: 'folder',
    Page: 'page',
    Question: 'question',
    Space: 'space',
    SpaceCalendar: 'space-calendar',
    Whiteboard: 'whiteboard'
});
const $c5e1b4a2d0458afe$export$98ac9eece9e68319 = $c5e1b4a2d0458afe$export$d872f0aa011c3a9d.enum;
const $c5e1b4a2d0458afe$export$340da7d4450f4487 = (0, $gLLcz.z).nativeEnum({
    Document: 'document',
    Presentation: 'presentation',
    Spreadsheet: 'spreadsheet'
});
const $c5e1b4a2d0458afe$export$bcc0874ed7743007 = $c5e1b4a2d0458afe$export$340da7d4450f4487.enum;
const $c5e1b4a2d0458afe$export$2d13808294fd047f = (0, $gLLcz.z).nativeEnum({
    Document: 'document',
    Presentation: 'presentation',
    Spreadsheet: 'spreadsheet'
});
const $c5e1b4a2d0458afe$export$847712e479ca402d = $c5e1b4a2d0458afe$export$2d13808294fd047f.enum;
const $c5e1b4a2d0458afe$export$dbec9fc36dbba98b = (0, $gLLcz.z).nativeEnum({
    Document: 'document',
    Presentation: 'presentation',
    Spreadsheet: 'spreadsheet'
});
const $c5e1b4a2d0458afe$export$8c76eb96ebfefeac = $c5e1b4a2d0458afe$export$dbec9fc36dbba98b.enum;
const $c5e1b4a2d0458afe$export$e31a67e5bb829f5c = (0, $gLLcz.z).nativeEnum({
    Project: 'project',
    Issue: 'issue',
    Filter: 'filter',
    Dashboard: 'dashboard',
    Board: 'board'
});
const $c5e1b4a2d0458afe$export$e3ddf72248eaf972 = $c5e1b4a2d0458afe$export$e31a67e5bb829f5c.enum;
const $c5e1b4a2d0458afe$export$e3c670f5c4b4df75 = (0, $gLLcz.z).nativeEnum({
    Component: 'component'
});
const $c5e1b4a2d0458afe$export$39271a5a1b74da02 = $c5e1b4a2d0458afe$export$e3c670f5c4b4df75.enum;
const $c5e1b4a2d0458afe$export$15f07c0375d70d62 = (0, $gLLcz.z).nativeEnum({
    Board: 'board',
    Card: 'card'
});
const $c5e1b4a2d0458afe$export$309520b897e0c0b = $c5e1b4a2d0458afe$export$15f07c0375d70d62.enum;
const $c5e1b4a2d0458afe$export$78ff7f7a3ef7dca8 = (0, $gLLcz.z).nativeEnum({
    Message: 'message',
    Conversation: 'conversation'
});
const $c5e1b4a2d0458afe$export$d51b5367809bb96 = $c5e1b4a2d0458afe$export$78ff7f7a3ef7dca8.enum;
const $c5e1b4a2d0458afe$export$e362a3dbc1368cf2 = (0, $gLLcz.z).nativeEnum({
    Message: 'message',
    Conversation: 'conversation'
});
const $c5e1b4a2d0458afe$export$c69d59ad598aee72 = $c5e1b4a2d0458afe$export$e362a3dbc1368cf2.enum;
const $c5e1b4a2d0458afe$export$3d532d345dacbf34 = (0, $gLLcz.z).nativeEnum({
    Repository: 'repository',
    PullRequest: 'pull-request',
    Commit: 'commit',
    Branch: 'branch'
});
const $c5e1b4a2d0458afe$export$8de16d71f5b0d410 = $c5e1b4a2d0458afe$export$3d532d345dacbf34.enum;
const $c5e1b4a2d0458afe$export$c30d3299c2899a1f = (0, $gLLcz.z).nativeEnum({
    WebPage: 'web-page'
});
const $c5e1b4a2d0458afe$export$bf86d9f770860253 = $c5e1b4a2d0458afe$export$c30d3299c2899a1f.enum;
const $c5e1b4a2d0458afe$export$f4b8db47840ea062 = (0, $gLLcz.z).nativeEnum({
    Design: 'design'
});
const $c5e1b4a2d0458afe$export$66f84ff942de6e1f = $c5e1b4a2d0458afe$export$f4b8db47840ea062.enum;
const $c5e1b4a2d0458afe$export$915266ba4ee70164 = (0, $gLLcz.z).nativeEnum({
    Video: 'video'
});
const $c5e1b4a2d0458afe$export$56591a3ad34d704b = $c5e1b4a2d0458afe$export$915266ba4ee70164.enum;
const $c5e1b4a2d0458afe$export$8669b3074569e564 = (0, $gLLcz.z).nativeEnum({
    WorkItem: 'work-item'
});
const $c5e1b4a2d0458afe$export$fd3bdf5548c7bf84 = $c5e1b4a2d0458afe$export$8669b3074569e564.enum;
const $c5e1b4a2d0458afe$export$4f29dba8e623c3d1 = (0, $gLLcz.z).nativeEnum({
    ...$c5e1b4a2d0458afe$export$ec20ab1a5eb36014,
    ...$c5e1b4a2d0458afe$export$721015a6e24d06a0,
    ...$c5e1b4a2d0458afe$export$48b648eee115c3e5,
    ...$c5e1b4a2d0458afe$export$98ac9eece9e68319,
    ...$c5e1b4a2d0458afe$export$bcc0874ed7743007,
    ...$c5e1b4a2d0458afe$export$847712e479ca402d,
    ...$c5e1b4a2d0458afe$export$e3ddf72248eaf972,
    ...$c5e1b4a2d0458afe$export$39271a5a1b74da02,
    ...$c5e1b4a2d0458afe$export$309520b897e0c0b,
    ...$c5e1b4a2d0458afe$export$d51b5367809bb96,
    ...$c5e1b4a2d0458afe$export$c69d59ad598aee72,
    ...$c5e1b4a2d0458afe$export$66f84ff942de6e1f,
    ...$c5e1b4a2d0458afe$export$8de16d71f5b0d410,
    ...$c5e1b4a2d0458afe$export$56591a3ad34d704b,
    ...$c5e1b4a2d0458afe$export$bf86d9f770860253,
    ...$c5e1b4a2d0458afe$export$8c76eb96ebfefeac,
    ...$c5e1b4a2d0458afe$export$fd3bdf5548c7bf84
});
const $c5e1b4a2d0458afe$export$e2e108cbe2e4f865 = $c5e1b4a2d0458afe$export$4f29dba8e623c3d1.enum;
const $c5e1b4a2d0458afe$export$7c078c2ec2ab4e93 = (0, $gLLcz.z).nativeEnum({
    Anytime: 'anytime',
    Today: 'today',
    Yesterday: 'yesterday',
    Past7Days: 'past7Days',
    Past30Days: 'past30Days',
    PastYear: 'pastYear',
    Custom: 'custom'
});
const $c5e1b4a2d0458afe$export$e6747eee8f26f8c0 = $c5e1b4a2d0458afe$export$7c078c2ec2ab4e93.enum;
const $c5e1b4a2d0458afe$export$7b58b3b9a7b83d61 = (0, $gLLcz.z).object({
    text: (0, $gLLcz.z).optional((0, $gLLcz.z).string().max(200)),
    originalQuery: (0, $gLLcz.z).optional((0, $gLLcz.z).string().max(200)),
    product: (0, $gLLcz.z).optional((0, $gLLcz.z).string().pipe($c5e1b4a2d0458afe$export$1cbda5ccc2e23e06)),
    type: (0, $gLLcz.z).optional((0, $gLLcz.z).string().pipe($c5e1b4a2d0458afe$export$4f29dba8e623c3d1)),
    // Last Modified
    lastModified: (0, $gLLcz.z).optional((0, $gLLcz.z).string().pipe($c5e1b4a2d0458afe$export$7c078c2ec2ab4e93)),
    lastModified_lt: (0, $gLLcz.z).optional((0, $gLLcz.z).string().pipe((0, $gLLcz.z).coerce.date())),
    lastModified_gt: (0, $gLLcz.z).optional((0, $gLLcz.z).string().pipe((0, $gLLcz.z).coerce.date())),
    from: (0, $gLLcz.z).optional((0, $gLLcz.z).string()),
    to: (0, $gLLcz.z).optional((0, $gLLcz.z).string()),
    titleMatch: (0, $gLLcz.z).optional($c5e1b4a2d0458afe$export$ffa5bf38ea9a76ee),
    // Confluence filters
    contributors: (0, $gLLcz.z).optional($c5e1b4a2d0458afe$export$236bfa8a18b6097),
    owners: (0, $gLLcz.z).optional($c5e1b4a2d0458afe$export$236bfa8a18b6097),
    ancestor: (0, $gLLcz.z).optional((0, $gLLcz.z).string()),
    spaces: (0, $gLLcz.z).optional($c5e1b4a2d0458afe$export$236bfa8a18b6097),
    verified: (0, $gLLcz.z).optional($c5e1b4a2d0458afe$export$ffa5bf38ea9a76ee),
    labels: (0, $gLLcz.z).optional($c5e1b4a2d0458afe$export$236bfa8a18b6097),
    // Jira Filters
    jAssignee: (0, $gLLcz.z).optional($c5e1b4a2d0458afe$export$236bfa8a18b6097),
    jProject: (0, $gLLcz.z).optional($c5e1b4a2d0458afe$export$236bfa8a18b6097),
    referrer: (0, $gLLcz.z).optional((0, $gLLcz.z).string()),
    // sort
    sortField: (0, $gLLcz.z).optional((0, $gLLcz.z).enum([
        'latestModifiedDate',
        'createdDate'
    ])),
    sortOrder: (0, $gLLcz.z).optional((0, $gLLcz.z).enum([
        'ASC',
        'DESC'
    ]))
});
const $c5e1b4a2d0458afe$export$f374b5430ac28f4c = $c5e1b4a2d0458afe$export$7b58b3b9a7b83d61.keyof().enum;
const $c5e1b4a2d0458afe$export$ff67c0a0b67bb249 = [
    (queryParams)=>{
        if (queryParams.lastModified !== 'custom') {
            const { lastModified_gt: lastModified_gt, lastModified_lt: lastModified_lt, ...restQueryParams } = queryParams;
            return restQueryParams;
        }
        return queryParams;
    },
    (queryParams)=>{
        const { lastModified_lt: lastModified_lt, lastModified_gt: lastModified_gt } = queryParams;
        if (lastModified_lt && lastModified_gt && lastModified_lt > lastModified_gt) {
            const { lastModified: lastModified, lastModified_gt: lastModified_gt, lastModified_lt: lastModified_lt, ...restQueryParams } = queryParams;
            return restQueryParams;
        }
        return queryParams;
    }
];
const $c5e1b4a2d0458afe$export$83efce6e50d7c43b = (0, $gLLcz.z).nativeEnum({
    ...$c5e1b4a2d0458afe$export$f3a53bd43617a593,
    ...$c5e1b4a2d0458afe$export$e2e108cbe2e4f865,
    ...$c5e1b4a2d0458afe$export$e6747eee8f26f8c0,
    ...$c5e1b4a2d0458afe$export$f374b5430ac28f4c
});
const $c5e1b4a2d0458afe$export$3d21d7040623da50 = $c5e1b4a2d0458afe$export$83efce6e50d7c43b.enum;
module.exports["productKeySchema"] = $c5e1b4a2d0458afe$export$1cbda5ccc2e23e06;
module.exports["ProductKey"] = $c5e1b4a2d0458afe$export$f3a53bd43617a593;
module.exports["ContentType"] = $c5e1b4a2d0458afe$export$e2e108cbe2e4f865;
module.exports["LastModified"] = $c5e1b4a2d0458afe$export$e6747eee8f26f8c0;
module.exports["searchQueryParamsBaseSchema"] = $c5e1b4a2d0458afe$export$7b58b3b9a7b83d61;
module.exports["searchQueryParamsValidators"] = $c5e1b4a2d0458afe$export$ff67c0a0b67bb249;

});

parcelRegister("bGd7w", function(module, exports) {
const $2f1d1d6d3d37503b$var$SearchResultCompassComponent = `
... on SearchResultCompassComponent {
	lastModifiedDate
	ownerId
	tier
	component {
		description
		state
	}
}
`;
const $2f1d1d6d3d37503b$export$72cf2e1294c50ff4 = ()=>{
    return $2f1d1d6d3d37503b$var$SearchResultCompassComponent;
};
const $2f1d1d6d3d37503b$export$b8968ce5f9785283 = (partial)=>{
    return partial.__typename === 'SearchResultCompassComponent';
};
module.exports["getCompassPartials"] = $2f1d1d6d3d37503b$export$72cf2e1294c50ff4;
module.exports["isSearchCompassPartial"] = $2f1d1d6d3d37503b$export$b8968ce5f9785283;

});

parcelRegister("ERUZZ", function(module, exports) {

var $ibSzG = parcelRequire("ibSzG");

/**
 * Hydrating the project avatar field causes additional latency so it is removed in this GraphQL Query
 * Investigation: https://hello.atlassian.net/wiki/x/iKKu8w
 */ const $77bf01452136c0d8$var$SearchResultJiraProject = `
... on SearchResultJiraProject {
  projectId
  projectKey
  projectType
  lastModifiedDate
  project {
    webUrl
  }
}`;
const $77bf01452136c0d8$export$aab3eed7c97209f8 = (partial)=>{
    return partial.__typename === 'SearchResultJiraProject';
};
const $77bf01452136c0d8$export$1f4b5d2e43f14510 = `
... on SearchResultJiraIssue {
  id
  title
  type
  description
  url
  iconUrl
  lastModifiedDate
  status {
    id
    name
  }
  issue {
    webUrl
	key
    fieldsById(ids: ["project"]) {
      edges {
        node {
          __typename
          name
          ... on JiraProjectField {
            project {
              id
              name
			  projectType
            }
          }
        }
      }
    }
  }
  socialSignal(tenantId: $tenantId) {
	    signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
	    }
  }
  __typename
}
`;
const $77bf01452136c0d8$export$65f412f3857c35e0 = (partial)=>{
    return {
        ...partial,
        url: partial.issue?.webUrl || partial.url
    };
};
const $77bf01452136c0d8$export$85182d219d5a304f = (partial)=>({
        ...partial,
        url: partial.project?.webUrl || partial.url
    });
const $77bf01452136c0d8$export$e221e36ba6e9f139 = (partial)=>{
    return partial.__typename === 'SearchResultJiraIssue';
};
const $77bf01452136c0d8$export$9c283c2de8ddb8fb = (partial)=>{
    return partial.__typename === 'JiraProjectField' && partial.name === 'Project';
};
const $77bf01452136c0d8$export$832b8ae8473ed171 = ``;
const $77bf01452136c0d8$export$e0968d23c481cf04 = (partial)=>{
    return partial.__typename === 'SearchResultJiraFilter';
};
const $77bf01452136c0d8$export$7860041bfeffea77 = ``;
const $77bf01452136c0d8$export$3e9a71746a0d5ef1 = (partial)=>{
    return partial.__typename === 'SearchResultJiraDashboard';
};
const $77bf01452136c0d8$export$f2ae751487c16c56 = `
... on SearchResultJiraBoard {
  boardId
  container {
		__typename
	}
  product
}
`;
const $77bf01452136c0d8$export$98e434e98950249c = (partial)=>{
    return partial.__typename === 'SearchResultJiraBoard';
};
const $77bf01452136c0d8$export$5a36738ca5faa27f = (partial)=>{
    return $77bf01452136c0d8$export$aab3eed7c97209f8(partial) || $77bf01452136c0d8$export$e221e36ba6e9f139(partial) || $77bf01452136c0d8$export$e0968d23c481cf04(partial) || $77bf01452136c0d8$export$3e9a71746a0d5ef1(partial) || $77bf01452136c0d8$export$98e434e98950249c(partial);
};
const $77bf01452136c0d8$export$d1f9da0e5c74ebcb = ()=>{
    return `
		${$77bf01452136c0d8$var$SearchResultJiraProject}
		${$77bf01452136c0d8$export$1f4b5d2e43f14510}
		${$77bf01452136c0d8$export$832b8ae8473ed171}
		${$77bf01452136c0d8$export$7860041bfeffea77}
		${$77bf01452136c0d8$export$f2ae751487c16c56}
	`;
};
module.exports["isSearchResultJiraProject"] = $77bf01452136c0d8$export$aab3eed7c97209f8;
module.exports["mapJiraIssuePartial"] = $77bf01452136c0d8$export$65f412f3857c35e0;
module.exports["mapJiraProjectPartial"] = $77bf01452136c0d8$export$85182d219d5a304f;
module.exports["isSearchResultJiraIssue"] = $77bf01452136c0d8$export$e221e36ba6e9f139;
module.exports["isJiraProjectField"] = $77bf01452136c0d8$export$9c283c2de8ddb8fb;
module.exports["isSearchResultJiraFilter"] = $77bf01452136c0d8$export$e0968d23c481cf04;
module.exports["isSearchResultJiraDashboard"] = $77bf01452136c0d8$export$3e9a71746a0d5ef1;
module.exports["isSearchResultJiraBoard"] = $77bf01452136c0d8$export$98e434e98950249c;
module.exports["isSearchJiraPartial"] = $77bf01452136c0d8$export$5a36738ca5faa27f;
module.exports["getJiraPartials"] = $77bf01452136c0d8$export$d1f9da0e5c74ebcb;

});

parcelRegister("k6Hr4", function(module, exports) {

var $2nDCB = parcelRequire("2nDCB");


var $lPWlo = parcelRequire("lPWlo");


var $7mBSb = parcelRequire("7mBSb");


var $4sOnC = parcelRequire("4sOnC");

const $b680b590345fe880$export$d0fa02fe9eb5952 = {
    [(0, $7mBSb.TypeFilterValueKey).Document]: {
        products: [
            (0, $4sOnC.ProductKeys).Confluence,
            (0, $4sOnC.ProductKeys).GoogleDrive,
            (0, $4sOnC.ProductKeys).Sharepoint,
            (0, $4sOnC.ProductKeys).OneDrive,
            (0, $4sOnC.ProductKeys).Dropbox,
            (0, $4sOnC.ProductKeys).Airtable,
            (0, $4sOnC.ProductKeys).Notion
        ],
        entities: {
            confluence: [
                'ati:cloud:confluence:blogpost',
                'ati:cloud:confluence:page',
                'ati:cloud:confluence:attachment'
            ],
            drive: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            onedrive: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            sharepoint: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            dropbox: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            airtable: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            notion: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI)
        },
        subCategories: [
            (0, $7mBSb.TypeFilterValueKey).Document
        ]
    },
    [(0, $7mBSb.TypeFilterValueKey).Spreadsheet]: {
        products: [
            (0, $4sOnC.ProductKeys).GoogleDrive,
            (0, $4sOnC.ProductKeys).Sharepoint,
            (0, $4sOnC.ProductKeys).OneDrive,
            (0, $4sOnC.ProductKeys).Dropbox
        ],
        entities: {
            drive: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            onedrive: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            sharepoint: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            dropbox: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI)
        },
        subCategories: [
            (0, $7mBSb.TypeFilterValueKey).Spreadsheet
        ]
    },
    [(0, $7mBSb.TypeFilterValueKey).Presentation]: {
        products: [
            (0, $4sOnC.ProductKeys).GoogleDrive,
            (0, $4sOnC.ProductKeys).Sharepoint,
            (0, $4sOnC.ProductKeys).OneDrive,
            (0, $4sOnC.ProductKeys).Dropbox
        ],
        entities: {
            drive: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            onedrive: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            sharepoint: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
            dropbox: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI)
        },
        subCategories: [
            (0, $7mBSb.TypeFilterValueKey).Presentation
        ]
    },
    [(0, $7mBSb.TypeFilterValueKey).Repository]: {
        products: [
            (0, $4sOnC.ProductKeys).Bitbucket,
            (0, $4sOnC.ProductKeys).Github
        ],
        entities: {
            github: [
                'ati:cloud:graph:repository'
            ],
            bitbucket: [
                'ati:cloud:graph:repository'
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).PullRequest]: {
        products: [
            (0, $4sOnC.ProductKeys).Bitbucket,
            (0, $4sOnC.ProductKeys).Github
        ],
        entities: {
            github: [
                'ati:cloud:graph:pull-request'
            ],
            bitbucket: [
                'ati:cloud:graph:pull-request'
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Branch]: {
        products: [
            (0, $4sOnC.ProductKeys).Bitbucket,
            (0, $4sOnC.ProductKeys).Github
        ],
        entities: {
            github: [
                'ati:cloud:graph:branch'
            ],
            bitbucket: [
                'ati:cloud:graph:branch'
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Commit]: {
        products: [
            (0, $4sOnC.ProductKeys).Bitbucket,
            (0, $4sOnC.ProductKeys).Github
        ],
        entities: {
            github: [
                'ati:cloud:graph:commit'
            ],
            bitbucket: [
                'ati:cloud:graph:commit'
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).WebPage]: {
        products: [
            (0, $4sOnC.ProductKeys).AtlassianWebCrawler
        ],
        entities: {
            'atlassian-web-crawler': [
                'ati:cloud:graph:document'
            ]
        },
        subCategories: [
            (0, $7mBSb.TypeFilterValueKey).WebPage
        ]
    },
    [(0, $7mBSb.TypeFilterValueKey).Conversation]: {
        products: [
            (0, $4sOnC.ProductKeys).Slack,
            (0, $4sOnC.ProductKeys).Teams
        ],
        entities: {
            slack: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI),
            teams: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI)
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Message]: {
        products: [
            (0, $4sOnC.ProductKeys).Slack,
            (0, $4sOnC.ProductKeys).Teams
        ],
        entities: {
            slack: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI),
            teams: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI)
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Video]: {
        products: [
            (0, $4sOnC.ProductKeys).Loom
        ],
        entities: {
            loom: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI)
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Design]: {
        products: [
            (0, $4sOnC.ProductKeys).Figma,
            (0, $4sOnC.ProductKeys).Miro
        ],
        entities: {
            figma: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI),
            miro: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI)
        },
        subCategories: [
            'file'
        ]
    },
    [(0, $7mBSb.TypeFilterValueKey).Page]: {
        products: [
            (0, $4sOnC.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                'ati:cloud:confluence:page'
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Blogpost]: {
        products: [
            (0, $4sOnC.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                'ati:cloud:confluence:blogpost'
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Attachment]: {
        products: [
            (0, $4sOnC.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                'ati:cloud:confluence:attachment'
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Space]: {
        products: [
            (0, $4sOnC.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                'ati:cloud:confluence:space'
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Comment]: {
        products: [
            (0, $4sOnC.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                'ati:cloud:confluence:comment'
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Whiteboard]: {
        products: [
            (0, $4sOnC.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                'ati:cloud:confluence:whiteboard'
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Database]: {
        products: [
            (0, $4sOnC.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                'ati:cloud:confluence:database'
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Embed]: {
        products: [
            (0, $4sOnC.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                'ati:cloud:confluence:embed'
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Folder]: {
        products: [
            (0, $4sOnC.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                'ati:cloud:confluence:folder'
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Calendar]: {
        products: [
            (0, $4sOnC.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                (0, $lPWlo.CONFLUENCE_CALENDAR_ENTITY_ATI)
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).SpaceCalendar]: {
        products: [
            (0, $4sOnC.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                (0, $lPWlo.CONFLUENCE_SPACE_CALENDAR_ENTITY_ATI)
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Question]: {
        products: [
            (0, $4sOnC.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                (0, $lPWlo.CONFLUENCE_QUESTION_ENTITY_ATI)
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Answer]: {
        products: [
            (0, $4sOnC.ProductKeys).Confluence
        ],
        entities: {
            confluence: [
                (0, $lPWlo.CONFLUENCE_ANSWER_ENTITY_ATI)
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Issue]: {
        products: [
            (0, $4sOnC.ProductKeys).Jira,
            (0, $4sOnC.ProductKeys).JiraProductDiscovery,
            (0, $4sOnC.ProductKeys).JiraServiceManagement
        ],
        entities: {
            jira: [
                (0, $lPWlo.JIRA_ISSUE_ENTITY_ATI)
            ],
            [(0, $4sOnC.ProductKeys).JiraProductDiscovery]: [
                (0, $lPWlo.JIRA_ISSUE_ENTITY_ATI)
            ],
            [(0, $4sOnC.ProductKeys).JiraServiceManagement]: [
                (0, $lPWlo.JIRA_ISSUE_ENTITY_ATI)
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Component]: {
        products: [
            (0, $4sOnC.ProductKeys).Compass
        ],
        entities: {
            compass: [
                'ati:cloud:compass:component'
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Board]: {
        products: [
            (0, $4sOnC.ProductKeys).Trello
        ],
        entities: {
            trello: [
                'ati:cloud:trello:board'
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Card]: {
        products: [
            (0, $4sOnC.ProductKeys).Trello
        ],
        entities: {
            trello: [
                'ati:cloud:trello:card'
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Project]: {
        products: [
            (0, $4sOnC.ProductKeys).Jira,
            (0, $4sOnC.ProductKeys).JiraProductDiscovery,
            (0, $4sOnC.ProductKeys).JiraServiceManagement,
            (0, $4sOnC.ProductKeys).Atlas
        ],
        entities: {
            jira: [
                (0, $lPWlo.JIRA_PROJECT_ENTITY_ATI)
            ],
            [(0, $4sOnC.ProductKeys).JiraProductDiscovery]: [
                (0, $lPWlo.JIRA_PROJECT_ENTITY_ATI)
            ],
            [(0, $4sOnC.ProductKeys).JiraServiceManagement]: [
                (0, $lPWlo.JIRA_PROJECT_ENTITY_ATI)
            ],
            townsquare: [
                'ati:cloud:townsquare:project'
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Goal]: {
        products: [
            (0, $4sOnC.ProductKeys).Atlas
        ],
        entities: {
            townsquare: [
                'ati:cloud:townsquare:goal'
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).Tag]: {
        products: [
            (0, $4sOnC.ProductKeys).Atlas
        ],
        entities: {
            townsquare: [
                'ati:cloud:townsquare:tag'
            ]
        },
        subCategories: []
    },
    [(0, $7mBSb.TypeFilterValueKey).WorkItem]: {
        products: [
            (0, $4sOnC.ProductKeys).Asana,
            (0, $4sOnC.ProductKeys).Zendesk
        ],
        entities: {
            asana: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI),
            zendesk: (0, $lPWlo.DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI)
        },
        subCategories: []
    }
};
const $b680b590345fe880$export$68b63b298725b685 = new Map([
    [
        (0, $4sOnC.ProductKeys).Confluence,
        new Map([
            [
                (0, $7mBSb.TypeFilterValueKey).Document,
                [
                    'ati:cloud:confluence:blogpost',
                    'ati:cloud:confluence:page',
                    'ati:cloud:confluence:attachment'
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).Page,
                [
                    'ati:cloud:confluence:page'
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).Blogpost,
                [
                    'ati:cloud:confluence:blogpost'
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).Attachment,
                [
                    'ati:cloud:confluence:attachment'
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).Space,
                [
                    'ati:cloud:confluence:space'
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).Comment,
                [
                    'ati:cloud:confluence:comment'
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).Whiteboard,
                [
                    'ati:cloud:confluence:whiteboard'
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).Database,
                [
                    'ati:cloud:confluence:database'
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).Embed,
                [
                    'ati:cloud:confluence:embed'
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).Folder,
                [
                    'ati:cloud:confluence:folder'
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).Calendar,
                [
                    (0, $lPWlo.CONFLUENCE_CALENDAR_ENTITY_ATI)
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).SpaceCalendar,
                [
                    (0, $lPWlo.CONFLUENCE_SPACE_CALENDAR_ENTITY_ATI)
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).Question,
                [
                    (0, $lPWlo.CONFLUENCE_QUESTION_ENTITY_ATI)
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).Answer,
                [
                    (0, $lPWlo.CONFLUENCE_ANSWER_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $4sOnC.ProductKeys).Jira,
        new Map([
            [
                (0, $7mBSb.TypeFilterValueKey).Issue,
                [
                    (0, $lPWlo.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).Project,
                [
                    (0, $lPWlo.JIRA_PROJECT_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $4sOnC.ProductKeys).JiraProductDiscovery,
        new Map([
            [
                (0, $7mBSb.TypeFilterValueKey).Issue,
                [
                    (0, $lPWlo.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).Project,
                [
                    (0, $lPWlo.JIRA_PROJECT_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $4sOnC.ProductKeys).JiraServiceManagement,
        new Map([
            [
                (0, $7mBSb.TypeFilterValueKey).Issue,
                [
                    (0, $lPWlo.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).Project,
                [
                    (0, $lPWlo.JIRA_PROJECT_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $4sOnC.ProductKeys).Compass,
        new Map([
            [
                (0, $7mBSb.TypeFilterValueKey).Component,
                [
                    'ati:cloud:compass:component'
                ]
            ]
        ])
    ],
    [
        (0, $4sOnC.ProductKeys).Trello,
        new Map([
            [
                (0, $7mBSb.TypeFilterValueKey).Board,
                [
                    'ati:cloud:trello:board'
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).Card,
                [
                    'ati:cloud:trello:card'
                ]
            ]
        ])
    ],
    [
        (0, $4sOnC.ProductKeys).Atlas,
        new Map([
            [
                (0, $7mBSb.TypeFilterValueKey).Project,
                [
                    'ati:cloud:townsquare:project'
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).Goal,
                [
                    'ati:cloud:townsquare:goal'
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).Tag,
                [
                    'ati:cloud:townsquare:tag'
                ]
            ]
        ])
    ],
    [
        (0, $4sOnC.ProductKeys).Bitbucket,
        new Map([
            [
                (0, $7mBSb.TypeFilterValueKey).Commit,
                [
                    'ati:cloud:graph:commit'
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).PullRequest,
                [
                    'ati:cloud:graph:pull-request'
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).Repository,
                [
                    'ati:cloud:graph:repository'
                ]
            ],
            [
                (0, $7mBSb.TypeFilterValueKey).Branch,
                [
                    'ati:cloud:graph:branch'
                ]
            ]
        ])
    ]
]);
const $b680b590345fe880$var$getNewTypeMapping = ()=>{
    const mappings = Object.fromEntries((0, $7mBSb.allTypeFilterValueKeys).map((TypeFilterValueKey)=>{
        const baseMapping = {
            entities: {},
            products: [],
            subCategories: []
        };
        return [
            TypeFilterValueKey,
            baseMapping
        ];
    }));
    // Add all the 1P products
    $b680b590345fe880$export$68b63b298725b685.forEach((_, productKey1P)=>{
        $b680b590345fe880$export$68b63b298725b685.get(productKey1P)?.forEach((_, typeFilterValueKey)=>{
            mappings[typeFilterValueKey].products.push(productKey1P);
            mappings[typeFilterValueKey].entities[productKey1P] = $b680b590345fe880$export$68b63b298725b685.get(productKey1P)?.get(typeFilterValueKey);
        });
    });
    // Add all the 3P products
    (0, $2nDCB.ThirdPartyConfigs).forEach((_, productKey3P)=>{
        const typeFilterValues3P = (0, $2nDCB.ThirdPartyConfigs).get(productKey3P)?.typeFilterValues || [];
        typeFilterValues3P.forEach((typeFilterValueKey)=>{
            mappings[typeFilterValueKey].products.push(productKey3P);
            mappings[typeFilterValueKey].entities[productKey3P] = (0, $7mBSb.TypeFilterTWGNounMapping).get(typeFilterValueKey)?.entities3P;
            mappings[typeFilterValueKey].subCategories = (0, $7mBSb.TypeFilterTWGNounMapping).get(typeFilterValueKey)?.subTypes3P || [];
        });
    });
    return mappings;
};
const $b680b590345fe880$export$a7663ee59d66492f = ()=>$b680b590345fe880$export$d0fa02fe9eb5952;
module.exports["getTypeMapping"] = $b680b590345fe880$export$a7663ee59d66492f;

});

parcelRegister("dKCFm", function(module, exports) {

var $6JNBT = parcelRequire("6JNBT");

var $lg8Ws = parcelRequire("lg8Ws");

var $9NrbM = parcelRequire("9NrbM");


var $4sOnC = parcelRequire("4sOnC");


var $33vwh = parcelRequire("33vwh");


var $405LB = parcelRequire("405LB");

const $92dcc6eca0804ee9$var$searchAssignee = async (query, config)=>{
    const searchClient = (0, $6JNBT.createClient)({
        cloudId: config.cloudId || ''
    });
    const searchAssigneesResponse = await searchClient.search({
        query: query,
        resultLimit: 5,
        scopes: [
            (0, $lg8Ws.Scope).People
        ],
        analytics: {
            identifier: 'search-page'
        }
    });
    const [searchAssigneeResults] = searchAssigneesResponse.response.rawData.scopes ?? [];
    const allAssignees = searchAssigneeResults.results.map((user)=>({
            picture: user.avatarUrl,
            name: user.name,
            id: `ari:cloud:identity::user/${user.id}`,
            accountId: user.id
        }));
    const userIds = new Set();
    const assigneeOptions = allAssignees.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
    .map((user)=>({
            trackingKey: user.id,
            value: user.id,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId
        }));
    return assigneeOptions;
};
const $92dcc6eca0804ee9$var$productKeys1P = [
    (0, $4sOnC.ProductKeys).Jira,
    (0, $4sOnC.ProductKeys).JiraProductDiscovery,
    (0, $4sOnC.ProductKeys).JiraServiceManagement
];
const $92dcc6eca0804ee9$var$originalProducts3P = [];
const $92dcc6eca0804ee9$var$products3PFromConfig = (0, $33vwh.getProducts3PFromConfigForFilter)('assignee');
const $92dcc6eca0804ee9$var$getProducts3P = ()=>{
    // fg('rovo-full-page-search-3p-static-config') => false
    return $92dcc6eca0804ee9$var$originalProducts3P;
};
const $92dcc6eca0804ee9$export$3dea766d36a8935f = (0, $405LB.createMultiSelectFilter)({
    id: 'assignee',
    products: [
        ...$92dcc6eca0804ee9$var$productKeys1P,
        ...$92dcc6eca0804ee9$var$getProducts3P()
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'jAssignee',
        fetcher: async (queryParams, _)=>{
            const initialUsersResponse = await (0, $9NrbM.usersQuery)(queryParams);
            const allAssignees = initialUsersResponse.data?.users ?? [];
            const userIds = new Set();
            const assigneeOptions = allAssignees.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
            .map((user)=>({
                    trackingKey: user.id,
                    value: user.id,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId
                }));
            return assigneeOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $92dcc6eca0804ee9$var$searchAssignee('', config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $92dcc6eca0804ee9$var$searchAssignee(query, config);
        }
    }
});
module.exports["filter"] = $92dcc6eca0804ee9$export$3dea766d36a8935f;

});

parcelRegister("7l9HL", function(module, exports) {

var $4mTS8 = parcelRequire("4mTS8");


var $1EqNn = parcelRequire("1EqNn");

const $d08231b6a225af0b$export$fe2cce9cc2f02a10 = (0, $1EqNn.inMemoryCache)();
const $d08231b6a225af0b$var$GQL_CF_PAGES_OPERATION_NAME = 'SearchPageConfluencePagesQuery';
const $d08231b6a225af0b$var$getConfluencePagesQuery = ()=>`
query ${$d08231b6a225af0b$var$GQL_CF_PAGES_OPERATION_NAME}($pageIds: [ID]!) {
  confluence {
    pages(ids: $pageIds) {
      id
      title
      type
      links {
        base
      }
    }
  }
}
`;
const $d08231b6a225af0b$export$eeab7469706cab80 = (pageIds)=>{
    return $d08231b6a225af0b$export$fe2cce9cc2f02a10.inMemoryDecorator(// TODO: >>>> Limit this to a max string length
    // TODO: Refactor so that it can cache per page id
    pageIds.join(','), async ()=>{
        if (pageIds.length === 0) return {
            data: {
                confluence: {
                    pages: []
                }
            }
        };
        const response = await (0, $4mTS8.fetchAgg)({
            graphQuery: $d08231b6a225af0b$var$getConfluencePagesQuery(),
            variables: {
                pageIds: pageIds
            },
            operationName: $d08231b6a225af0b$var$GQL_CF_PAGES_OPERATION_NAME
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};


var $5aC84 = parcelRequire("5aC84");


var $4sOnC = parcelRequire("4sOnC");


var $33vwh = parcelRequire("33vwh");


var $h7ecj = parcelRequire("h7ecj");

const $e8d8927fcc99b65e$var$getContentId = (ari)=>{
    const EXTRACT_ID = /ari:.*?:.*?:.*?:.*?\/(.*)?.*/;
    const matches = ari.match(EXTRACT_ID);
    // content id of the ari
    return matches && matches.length > 1 ? matches[1] : '';
};
const $e8d8927fcc99b65e$var$searchContent = async (query, config)=>{
    const location = `ari:cloud:confluence::site/${config.cloudId}`;
    const contentPagesResponse = await (0, $5aC84.searchEntitiesQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            query: query,
            first: 10,
            filters: {
                entities: [
                    'ati:cloud:confluence:page'
                ],
                locations: [
                    location
                ]
            }
        }
    });
    const allContentPages = contentPagesResponse.data?.search?.results.edges.map((content)=>({
            title: content.node.title,
            id: content.node.id
        })) || [];
    const contentOptions = allContentPages.map((content)=>{
        const contentId = $e8d8927fcc99b65e$var$getContentId(content.id);
        return {
            trackingKey: contentId,
            value: contentId,
            label: content.title,
            queryParamValue: contentId
        };
    });
    return contentOptions;
};
const $e8d8927fcc99b65e$var$productKeys1P = [
    (0, $4sOnC.ProductKeys).Confluence
];
const $e8d8927fcc99b65e$var$originalProducts3P = [];
const $e8d8927fcc99b65e$var$products3PFromConfig = (0, $33vwh.getProducts3PFromConfigForFilter)('content');
const $e8d8927fcc99b65e$var$getProducts3P = ()=>{
    // fg('rovo-full-page-search-3p-static-config') => false
    return $e8d8927fcc99b65e$var$originalProducts3P;
};
const $e8d8927fcc99b65e$export$3dea766d36a8935f = (0, $h7ecj.createSingleSelectFilter)({
    id: 'content',
    products: [
        ...$e8d8927fcc99b65e$var$productKeys1P,
        ...$e8d8927fcc99b65e$var$getProducts3P()
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'ancestor',
        fetcher: async (queryParams, config)=>{
            const initialContentARIs = queryParams.map((contentId)=>`ari:cloud:confluence:${config.cloudId}:page/${contentId}`);
            const initialContentResponse = await (0, $d08231b6a225af0b$export$eeab7469706cab80)(initialContentARIs);
            const allContentPages = initialContentResponse.data?.confluence.pages.map((page)=>({
                    title: page.title,
                    id: page.id
                })) || [];
            const contentOptions = allContentPages.map((content)=>{
                const contentId = $e8d8927fcc99b65e$var$getContentId(content.id);
                return {
                    trackingKey: contentId,
                    value: contentId,
                    label: content.title,
                    queryParamValue: contentId
                };
            });
            return contentOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $e8d8927fcc99b65e$var$searchContent('', config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $e8d8927fcc99b65e$var$searchContent(query, config);
        }
    }
});
module.exports["filter"] = $e8d8927fcc99b65e$export$3dea766d36a8935f;

});

parcelRegister("eJ38t", function(module, exports) {

var $5kTPO = parcelRequire("5kTPO");

const $341060dfac483a1e$export$f63f2da3517cdf9c = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'contributors',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $5kTPO.default)(requestParams, intl);
};


var $i37tO = parcelRequire("i37tO");

var $9NrbM = parcelRequire("9NrbM");


var $4sOnC = parcelRequire("4sOnC");


var $33vwh = parcelRequire("33vwh");


var $405LB = parcelRequire("405LB");

const $cd3b96725fa99d10$var$MAX_SMART_DEFAULT_OPTIONS = 5;
const $cd3b96725fa99d10$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $cd3b96725fa99d10$var$loadRecommendedContributor = async (config)=>{
    const initialUsersQuery = (0, $9NrbM.usersQuery)([
        ...config.userId ? [
            config.userId
        ] : []
    ]);
    const recommendedUserQuery = (0, $i37tO.smartsRecommendedUserQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            userId: config.userId || '',
            tenantId: config.cloudId || '',
            maxNumberOfResults: $cd3b96725fa99d10$var$MAX_SMART_DEFAULT_OPTIONS
        }
    });
    const [initialUsersReponse, smartsRecommendedUserResponse] = await Promise.all([
        initialUsersQuery,
        recommendedUserQuery
    ]);
    const recommendedUsersResults = smartsRecommendedUserResponse.data?.smarts.results ?? [];
    const allRecommendedUsers = [
        ...initialUsersReponse.data?.users ?? [],
        ...recommendedUsersResults.flatMap((recommendedUsers)=>!!recommendedUsers && !!recommendedUsers.user ? {
                id: recommendedUsers.id,
                ...recommendedUsers.user
            } : [])
    ];
    const recommendedUserOptions = allRecommendedUsers.map((user)=>({
            trackingKey: user.accountId,
            value: user.accountId,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId
        }));
    return recommendedUserOptions;
};
// fg('universal-contributor-filter') => false
const $cd3b96725fa99d10$var$isUniversalContributorFilter = false;
// Filter out Trello for milestone 1 (QS-4733)
const $cd3b96725fa99d10$var$productKeys1P = $cd3b96725fa99d10$var$isUniversalContributorFilter ? (0, $4sOnC.all1pProductKeys).filter((key)=>key !== (0, $4sOnC.ProductKeys).Trello) : [
    (0, $4sOnC.ProductKeys).Confluence
];
const $cd3b96725fa99d10$var$originalProducts3P = [];
const $cd3b96725fa99d10$var$products3PFromConfig = (0, $33vwh.getProducts3PFromConfigForFilter)('contributor');
const $cd3b96725fa99d10$var$getProducts3P = ()=>{
    // fg('rovo-full-page-search-3p-static-config') => false
    return $cd3b96725fa99d10$var$originalProducts3P;
};
const $cd3b96725fa99d10$export$3dea766d36a8935f = (0, $405LB.createMultiSelectFilter)({
    id: 'contributor',
    // 1P only for now (excluding Trello)
    products: [
        ...$cd3b96725fa99d10$var$productKeys1P,
        ...$cd3b96725fa99d10$var$getProducts3P()
    ],
    alwaysVisible: true,
    universal: $cd3b96725fa99d10$var$isUniversalContributorFilter,
    queryParams: {
        key: 'contributors',
        fetcher: async (queryParams, _)=>{
            const initialUsersReponse = await (0, $9NrbM.usersQuery)([
                ...queryParams
            ]);
            const allRecommendedUsers = initialUsersReponse.data?.users ?? [];
            const recommendedUserOptions = allRecommendedUsers.map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId
                }));
            return recommendedUserOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $cd3b96725fa99d10$var$loadRecommendedContributor(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (!config.intl) return []; // base on existing interface, can only query contributors with intl
            const response = await (0, $341060dfac483a1e$export$f63f2da3517cdf9c)({
                query: query,
                cloudId: config.cloudId || '',
                userId: config.userId || '',
                productKey: (0, $4sOnC.ProductKeys).Confluence,
                maxNumberOfResults: $cd3b96725fa99d10$var$MAX_SEARCHED_OPTIONS_RESULTS,
                intl: config.intl
            });
            if (!response) // TODO: log not found somewhere
            return [];
            return response.map((contributor)=>({
                    trackingKey: contributor.id,
                    value: contributor.id,
                    label: contributor.name,
                    avatarUrl: contributor.avatarUrl,
                    queryParamValue: contributor.id
                }));
        }
    }
});
module.exports["filter"] = $cd3b96725fa99d10$export$3dea766d36a8935f;

});

parcelRegister("11Uwq", function(module, exports) {

var $4mTS8 = parcelRequire("4mTS8");


var $1EqNn = parcelRequire("1EqNn");

const $068b3d5dfddc4e7c$export$a8f449a3d81f3a4c = (0, $1EqNn.inMemoryCache)();
const $068b3d5dfddc4e7c$var$GQL_CF_LABEL_OPERATION_NAME = 'SearchLabelsQuery';
const $068b3d5dfddc4e7c$var$getConfluenceLabelsQuery = ()=>`
query ${$068b3d5dfddc4e7c$var$GQL_CF_LABEL_OPERATION_NAME}($cloudId: ID! $searchText: String!, $limit: Int) {
  confluence {
    searchLabels(cloudId: $cloudId, searchText: $searchText, limit: $limit) @optIn(to: "ConfluenceExperimentalSearchLabels") {
	  otherLabels {
        label
      }
      suggestedLabels {
        label
      }
    }
  }
}
`;
const $068b3d5dfddc4e7c$export$b9ea4761dac8a473 = (cloudId, searchText, limit)=>{
    return $068b3d5dfddc4e7c$export$a8f449a3d81f3a4c.inMemoryDecorator(searchText, async ()=>{
        const response = await (0, $4mTS8.fetchAgg)({
            graphQuery: $068b3d5dfddc4e7c$var$getConfluenceLabelsQuery(),
            variables: {
                cloudId: cloudId,
                searchText: searchText,
                limit: limit
            },
            operationName: $068b3d5dfddc4e7c$var$GQL_CF_LABEL_OPERATION_NAME
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};



var $4sOnC = parcelRequire("4sOnC");


var $33vwh = parcelRequire("33vwh");


var $405LB = parcelRequire("405LB");

const $426281e67cf62d95$var$productKeys1P = [
    (0, $4sOnC.ProductKeys).Confluence
];
const $426281e67cf62d95$var$originalProducts3P = [];
const $426281e67cf62d95$var$products3PFromConfig = (0, $33vwh.getProducts3PFromConfigForFilter)('label');
const $426281e67cf62d95$var$getProducts3P = ()=>{
    // fg('rovo-full-page-search-3p-static-config') => false
    return $426281e67cf62d95$var$originalProducts3P;
};
const $426281e67cf62d95$export$3dea766d36a8935f = (0, $405LB.createMultiSelectFilter)({
    id: 'label',
    products: [
        ...$426281e67cf62d95$var$productKeys1P,
        ...$426281e67cf62d95$var$getProducts3P()
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'labels',
        fetcher: async (queryParams, _)=>{
            return queryParams.map((label)=>({
                    trackingKey: label,
                    value: label,
                    queryParamValue: label,
                    label: label
                }));
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (!config.intl) return []; // base on existing interface, can only query contributors with intl
            if (config.cloudId === undefined) return [];
            const initialLabelsResponse = await (0, $068b3d5dfddc4e7c$export$b9ea4761dac8a473)(config.cloudId, query, 10);
            const suggestedLabels = initialLabelsResponse.data?.confluence.searchLabels.suggestedLabels || [];
            const otherLabels = initialLabelsResponse.data?.confluence.searchLabels.otherLabels || [];
            return [
                ...suggestedLabels,
                ...otherLabels
            ].map((label)=>({
                    trackingKey: label.label || '',
                    value: label.label || '',
                    queryParamValue: label.label || '',
                    label: label.label || ''
                })) ?? [];
        }
    }
});
module.exports["filter"] = $426281e67cf62d95$export$3dea766d36a8935f;

});

parcelRegister("i4ijn", function(module, exports) {

var $4sOnC = parcelRequire("4sOnC");


var $7tGzv = parcelRequire("7tGzv");


var $33vwh = parcelRequire("33vwh");


var $7mBSb = parcelRequire("7mBSb");


var $e2xgH = parcelRequire("e2xgH");

const $36544e820f9fe7a0$export$711b0a1d273f9525 = (initial)=>{
    const initialState = Object.freeze({
        id: initial.id,
        type: 'single-select',
        didMount: false,
        hasSelection: false,
        alwaysVisible: initial.alwaysVisible,
        universal: initial.universal,
        queryParams: {
            isLoading: false,
            options: []
        },
        lookup: {
            isLoading: false,
            isActive: false,
            isDefined: !!initial.lookup,
            options: [],
            lookupResultOptions: [],
            input: ''
        },
        initialOptions: {
            options: [],
            isLoading: false
        },
        options: [],
        selectedOptions: [],
        value: [],
        products: initial.products
    });
    return {
        id: initial.id,
        type: initialState.type,
        queryParams: {
            key: initial.queryParams.key
        },
        products: initial.products,
        universal: initial.universal,
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$36544e820f9fe7a0$export$44d389225cc01eb5({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$36544e820f9fe7a0$export$44d389225cc01eb5({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (filterState)=>{
            return filterState?.id === initial.id;
        },
        isSupportCustomValue: true
    };
};
const $36544e820f9fe7a0$export$e2de15bbd9edf9c6 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const options = $36544e820f9fe7a0$export$44d389225cc01eb5({
            initial: initial,
            state: state,
            config: config
        }).getOptions({
            isLookupActive: false
        });
        const selectedOptions = options.filter((option)=>option.isSelected);
        const queryParamValue = selectedOptions.map((option)=>option.queryParamValue);
        const isCustomOptionSelected = selectedOptions.find((option)=>option.value === (0, $7mBSb.CUSTOM_OPTION_VALUE));
        const customValueQueryParam = isCustomOptionSelected && state.customValue ? state.customValue : {};
        return {
            [initial.queryParams.key]: queryParamValue,
            ...customValueQueryParam
        };
    };
};
const $36544e820f9fe7a0$export$7755017099c85a0d = ({ initial: initial, state: state, config: config })=>{
    return async (queryParams, onStateChange)=>{
        const queryParamValues = queryParams[initial.queryParams.key];
        const filter = $36544e820f9fe7a0$export$44d389225cc01eb5({
            initial: initial,
            state: state,
            config: config
        });
        if (!queryParamValues) {
            const clearedOptions = filter.clearOptions();
            onStateChange?.(clearedOptions.getState());
            return clearedOptions;
        }
        const allCurrentOptions = filter.getOptions({
            isLookupActive: false
        });
        const allQueryParamValues = allCurrentOptions.map((option)=>option.queryParamValue);
        const queryParamsToHydrate = queryParamValues.filter((value)=>!allQueryParamValues.includes(value));
        if (queryParamsToHydrate.length === 0) {
            const newOptions = allCurrentOptions.map((option)=>({
                    isSelected: queryParamValues.includes(option.queryParamValue),
                    value: option.value
                }));
            const isCustomOptionSelected = newOptions.find((option)=>option.value === (0, $7mBSb.CUSTOM_OPTION_VALUE))?.isSelected;
            const customValueParser = initial.queryParams.customValueParser;
            let customValue;
            if (isCustomOptionSelected) {
                if (customValueParser) customValue = customValueParser(queryParams);
                else customValue = initial.customValueFields ? initial.customValueFields.reduce((acc, field)=>({
                        ...acc,
                        [field]: queryParams[field]?.at(0) ?? ''
                    }), {}) : {};
            }
            const filterWithNewOptions = filter.setOption(newOptions, customValue);
            onStateChange?.(filterWithNewOptions.getState());
            return filterWithNewOptions;
        }
        // At this point we need to hydrate the filters with new options from
        // the query params
        const newQueryParamOptions = [
            ...state.queryParams.options
        ];
        const fetcher = initial.queryParams.fetcher;
        if (fetcher) {
            onStateChange?.({
                ...state,
                queryParams: {
                    ...state.queryParams,
                    isLoading: true
                }
            });
            const fetchedOptions = await fetcher(queryParamsToHydrate, config);
            fetchedOptions.forEach((option)=>{
                const mappedOption = {
                    isSelected: true,
                    trackingKey: option.trackingKey,
                    value: option.value,
                    queryParamValue: option.queryParamValue,
                    isSuggested: false,
                    isDefault: option.isDefault ?? false,
                    avatarUrl: option.avatarUrl,
                    label: option.label
                };
                newQueryParamOptions.push(mappedOption);
            });
        }
        const selectedOptionsFromQueryParams = newQueryParamOptions.map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const selectedInitialOptionsFromQueryParams = [
            ...state.initialOptions.options
        ].map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const hydratedQueryParams = $36544e820f9fe7a0$export$44d389225cc01eb5({
            initial: initial,
            state: {
                ...state,
                queryParams: {
                    ...state.queryParams,
                    options: selectedOptionsFromQueryParams,
                    isLoading: false
                },
                initialOptions: {
                    ...state.initialOptions,
                    options: selectedInitialOptionsFromQueryParams
                }
            },
            config: config
        });
        onStateChange?.(hydratedQueryParams.getState());
        return hydratedQueryParams;
    };
};
const $36544e820f9fe7a0$export$44d389225cc01eb5 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: (0, $e2xgH.getState)({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: $36544e820f9fe7a0$export$e2de15bbd9edf9c6({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: $36544e820f9fe7a0$export$7755017099c85a0d({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: (0, $e2xgH.loadInitialOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: $36544e820f9fe7a0$export$b2a7969df3fe0aa3({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: (0, $e2xgH.clearOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: (0, $e2xgH.setLookupInput)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $e2xgH.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: (0, $e2xgH.getValue)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: (0, $e2xgH.deselectOptions)({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $36544e820f9fe7a0$var$updateOptionState = (props)=>(option)=>{
        if (option.isDefault) return {
            ...option,
            isSelected: false
        };
        return {
            ...option,
            isSelected: props.selectedOption ? props.selectedOption.value === option.value : option.isSelected
        };
    };
const $36544e820f9fe7a0$export$b2a7969df3fe0aa3 = ({ initial: initial, state: state, config: config })=>{
    return (option, customValue)=>{
        const optionsToChange = Array.isArray(option) ? option : [
            option
        ];
        const selectedOption = optionsToChange.filter((o)=>o.isSelected).at(0);
        const queryParamOptions = state.queryParams.options.map($36544e820f9fe7a0$var$updateOptionState({
            selectedOption: selectedOption
        }));
        const initialOptions = state.initialOptions.options.map($36544e820f9fe7a0$var$updateOptionState({
            selectedOption: selectedOption
        }));
        const lookupOptions = [
            ...state.lookup.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // These 'interacted' options need to be persisted if a user wants to select them again
            ...state.lookup.lookupResultOptions.flatMap((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value)) return [];
                return [
                    option
                ];
            })
        ].map($36544e820f9fe7a0$var$updateOptionState({
            selectedOption: selectedOption
        }));
        return $36544e820f9fe7a0$export$44d389225cc01eb5({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                },
                customValue: customValue
            },
            config: config
        });
    };
};



var $cgtv4 = parcelRequire("cgtv4");

const $55a70c144209ed4b$export$3f164da8f895a853 = (0, $cgtv4.defineMessages)({
    anytime: {
        id: "dynamic-cards-search-page.filter.last.updated.anytime",
        defaultMessage: "Anytime"
    },
    today: {
        id: "dynamic-cards-search-page.filter.last.updated.today",
        defaultMessage: "Today"
    },
    yesterday: {
        id: "dynamic-cards-search-page.filter.last.updated.yesterday",
        defaultMessage: "Yesterday"
    },
    past7Days: {
        id: "dynamic-cards-search-page.filter.last.updated.past7Days",
        defaultMessage: "Past 7 days"
    },
    past30Days: {
        id: "dynamic-cards-search-page.filter.last.updated.past30Days",
        defaultMessage: "Past 30 days"
    },
    pastYear: {
        id: "dynamic-cards-search-page.filter.last.updated.pastYear",
        defaultMessage: "Past year"
    },
    custom: {
        id: "dynamic-cards-search-page.filter.last.updated.costum",
        defaultMessage: "Custom"
    }
});


const $30acb047cccc7a19$var$LAST_UPDATED_VALUES = [
    'today',
    'yesterday',
    'past7Days',
    'past30Days',
    'pastYear',
    'custom'
];
const $30acb047cccc7a19$var$sortCompareFn = (a, b)=>{
    return $30acb047cccc7a19$var$LAST_UPDATED_VALUES.indexOf(a.value) - $30acb047cccc7a19$var$LAST_UPDATED_VALUES.indexOf(b.value);
};
const $30acb047cccc7a19$var$isIsoDate = (str)=>{
    if (!str) return false;
    if (!/\d{4}-\d{2}-\d{2}/.test(str)) return false;
    const d = new Date(str);
    return !isNaN(d.getTime());
};
const $30acb047cccc7a19$var$getLastUpdatedValue = ()=>{
    // fg('rovo-custom-date-range-picker') => true
    const isCustomRangePickEnabled = true;
    return $30acb047cccc7a19$var$LAST_UPDATED_VALUES.filter((value)=>{
        if (value === 'custom') return isCustomRangePickEnabled;
        return true;
    });
};
const $30acb047cccc7a19$var$productKeys1P = [
    (0, $4sOnC.ProductKeys).Atlas,
    (0, $4sOnC.ProductKeys).Confluence,
    (0, $4sOnC.ProductKeys).Jira,
    (0, $4sOnC.ProductKeys).JiraProductDiscovery,
    (0, $4sOnC.ProductKeys).JiraServiceManagement,
    (0, $4sOnC.ProductKeys).Compass
];
const $30acb047cccc7a19$var$originalProducts3P = [
    (0, $4sOnC.ProductKeys).Figma,
    (0, $4sOnC.ProductKeys).Github,
    (0, $4sOnC.ProductKeys).GoogleDrive,
    (0, $4sOnC.ProductKeys).Loom,
    (0, $4sOnC.ProductKeys).OneDrive,
    (0, $4sOnC.ProductKeys).Slack,
    (0, $4sOnC.ProductKeys).Sharepoint,
    (0, $4sOnC.ProductKeys).Teams,
    (0, $4sOnC.ProductKeys).Dropbox
];
const $30acb047cccc7a19$var$products3PFromConfig = (0, $33vwh.getProducts3PFromConfigForFilter)('lastUpdated');
const $30acb047cccc7a19$var$getProducts3P = ()=>{
    // fg('rovo-full-page-search-3p-static-config') => false
    return $30acb047cccc7a19$var$originalProducts3P;
};
const $30acb047cccc7a19$export$3dea766d36a8935f = (0, $36544e820f9fe7a0$export$711b0a1d273f9525)({
    id: 'lastUpdated',
    products: [
        ...$30acb047cccc7a19$var$productKeys1P,
        ...$30acb047cccc7a19$var$getProducts3P()
    ],
    alwaysVisible: true,
    universal: true,
    queryParams: {
        key: 'lastModified',
        fetcher: async (_, config)=>{
            return $30acb047cccc7a19$var$getLastUpdatedValue().map((value)=>({
                    trackingKey: value,
                    label: config.intl?.formatMessage((0, $55a70c144209ed4b$export$3f164da8f895a853)[value]) || (0, $55a70c144209ed4b$export$3f164da8f895a853)[value].defaultMessage,
                    value: value,
                    queryParamValue: value
                }));
        },
        customValueParser: (queryParams)=>{
            const { to: to, from: from } = queryParams;
            const isToDateValid = $30acb047cccc7a19$var$isIsoDate(to?.[0]);
            const isFromDateValid = $30acb047cccc7a19$var$isIsoDate(from?.[0]);
            const toDate = isToDateValid && to?.[0] ? to?.[0] : '';
            const fromDate = isFromDateValid && from?.[0] ? from?.[0] : '';
            const invalidDateRange = (0, $33vwh.getInvalidDateRange)(fromDate, toDate);
            if (!invalidDateRange) return {
                to: toDate,
                from: fromDate
            };
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return [
                {
                    trackingKey: 'anytime',
                    label: config.intl?.formatMessage((0, $55a70c144209ed4b$export$3f164da8f895a853)['anytime']) || (0, $55a70c144209ed4b$export$3f164da8f895a853)['anytime'].defaultMessage,
                    value: 'anytime',
                    isDefault: true,
                    queryParamValue: (0, $7tGzv.LastModified).Anytime
                },
                ...$30acb047cccc7a19$var$getLastUpdatedValue().map((value)=>({
                        trackingKey: value,
                        label: config.intl?.formatMessage((0, $55a70c144209ed4b$export$3f164da8f895a853)[value]) || (0, $55a70c144209ed4b$export$3f164da8f895a853)[value].defaultMessage,
                        value: value,
                        queryParamValue: value
                    }))
            ];
        }
    },
    sortCompareFn: $30acb047cccc7a19$var$sortCompareFn,
    customValueFields: [
        'to',
        'from'
    ]
});
module.exports["filter"] = $30acb047cccc7a19$export$3dea766d36a8935f;

});

parcelRegister("2zUQE", function(module, exports) {

var $5kTPO = parcelRequire("5kTPO");

const $22a723112a43a925$export$148de59b68ce26ae = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'owners',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $5kTPO.default)(requestParams, intl);
};


var $i37tO = parcelRequire("i37tO");

var $9NrbM = parcelRequire("9NrbM");


var $4sOnC = parcelRequire("4sOnC");


var $33vwh = parcelRequire("33vwh");


var $405LB = parcelRequire("405LB");

const $ab79182644f833ff$var$MAX_SMART_DEFAULT_OPTIONS = 5;
const $ab79182644f833ff$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $ab79182644f833ff$var$loadRecommendedOwner = async (config)=>{
    const initialUsersQuery = (0, $9NrbM.usersQuery)([
        ...config.userId ? [
            config.userId
        ] : []
    ]);
    const recommendedUserQuery = (0, $i37tO.smartsRecommendedUserQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            userId: config.userId || '',
            tenantId: config.cloudId || '',
            maxNumberOfResults: $ab79182644f833ff$var$MAX_SMART_DEFAULT_OPTIONS
        }
    });
    const [initialUsersResponse, smartsRecommendedUserResponse] = await Promise.all([
        initialUsersQuery,
        recommendedUserQuery
    ]);
    const recommendedUsersResults = smartsRecommendedUserResponse.data?.smarts.results ?? [];
    const allRecommendedUsers = [
        ...initialUsersResponse.data?.users ?? [],
        ...recommendedUsersResults.flatMap((recommendedUsers)=>!!recommendedUsers && !!recommendedUsers.user ? {
                id: recommendedUsers.id,
                ...recommendedUsers.user
            } : [])
    ];
    const recommendedUserOptions = allRecommendedUsers.map((user)=>({
            trackingKey: user.accountId,
            value: user.accountId,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId
        }));
    return recommendedUserOptions;
};
const $ab79182644f833ff$var$productKeys1P = [
    (0, $4sOnC.ProductKeys).Confluence
];
const $ab79182644f833ff$var$originalProducts3P = [];
const $ab79182644f833ff$var$products3PFromConfig = (0, $33vwh.getProducts3PFromConfigForFilter)('owner');
const $ab79182644f833ff$var$getProducts3P = ()=>{
    // fg('rovo-full-page-search-3p-static-config') => false
    return $ab79182644f833ff$var$originalProducts3P;
};
const $ab79182644f833ff$export$3dea766d36a8935f = (0, $405LB.createMultiSelectFilter)({
    id: 'owner',
    products: [
        ...$ab79182644f833ff$var$productKeys1P,
        ...$ab79182644f833ff$var$getProducts3P()
    ],
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'owners',
        fetcher: async (queryParams, _)=>{
            const initialUsersReponse = await (0, $9NrbM.usersQuery)([
                ...queryParams
            ]);
            const allRecommendedUsers = initialUsersReponse.data?.users ?? [];
            const recommendedUserOptions = allRecommendedUsers.map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId
                }));
            return recommendedUserOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $ab79182644f833ff$var$loadRecommendedOwner(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (!config.intl) return [];
            const response = await (0, $22a723112a43a925$export$148de59b68ce26ae)({
                query: query,
                cloudId: config.cloudId || '',
                userId: config.userId || '',
                productKey: (0, $4sOnC.ProductKeys).Confluence,
                maxNumberOfResults: $ab79182644f833ff$var$MAX_SEARCHED_OPTIONS_RESULTS,
                intl: config.intl
            });
            if (!response) // TODO: log not found somewhere
            return [];
            return response.map((owner)=>({
                    trackingKey: owner.id,
                    value: owner.id,
                    label: owner.name,
                    avatarUrl: owner.avatarUrl,
                    queryParamValue: owner.id
                }));
        }
    }
});
module.exports["filter"] = $ab79182644f833ff$export$3dea766d36a8935f;

});

parcelRegister("hYkUd", function(module, exports) {

var $6JNBT = parcelRequire("6JNBT");

var $4mTS8 = parcelRequire("4mTS8");


var $1EqNn = parcelRequire("1EqNn");

const $d2b64463bc9f56c5$export$56d694fb8fe349ab = (0, $1EqNn.inMemoryCache)();
const $d2b64463bc9f56c5$var$GQL_JIRA_PROJECTS_OPERATION_NAME = 'SearchPageJiraProjectQuery';
const $d2b64463bc9f56c5$var$jiraProjectsQueryString = `query ${$d2b64463bc9f56c5$var$GQL_JIRA_PROJECTS_OPERATION_NAME}($projectIds: [ID!]!) {
  jira {
    jiraProjects(ids: $projectIds) {
			projectId
      name
      avatar {
        small
      }
    }
  }
}`;
const $d2b64463bc9f56c5$export$fd1d4a933080bfe2 = (projectIds)=>{
    return $d2b64463bc9f56c5$export$56d694fb8fe349ab.inMemoryDecorator(projectIds.join(','), async ()=>{
        if (projectIds.length === 0) return {
            data: {
                jira: {
                    jiraProjects: []
                }
            }
        };
        const response = await (0, $4mTS8.fetchAgg)({
            graphQuery: $d2b64463bc9f56c5$var$jiraProjectsQueryString,
            variables: {
                projectIds: projectIds
            },
            operationName: $d2b64463bc9f56c5$var$GQL_JIRA_PROJECTS_OPERATION_NAME
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return $d2b64463bc9f56c5$var$filterProjectsWithoutId(response);
    });
};
const $d2b64463bc9f56c5$var$filterProjectsWithoutId = (response)=>{
    const filteredProjects = response.data?.jira.jiraProjects?.filter((project)=>project.projectId);
    return {
        ...response,
        data: {
            jira: {
                jiraProjects: filteredProjects
            }
        }
    };
};


var $lg8Ws = parcelRequire("lg8Ws");


var $4sOnC = parcelRequire("4sOnC");


var $33vwh = parcelRequire("33vwh");


var $405LB = parcelRequire("405LB");

const $4071957cb60e08fa$var$projectIdToARI = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
const $4071957cb60e08fa$var$searchProject = async (query, config)=>{
    const searchClient = (0, $6JNBT.createClient)({
        cloudId: config.cloudId || ''
    });
    const searchProjectsResponse = await searchClient.search({
        query: query,
        resultLimit: 5,
        scopes: [
            (0, $lg8Ws.Scope).JiraProject
        ],
        analytics: {
            identifier: 'search-page'
        }
    });
    const searchedProjects = searchProjectsResponse.response.rawData.scopes.length > 0 ? searchProjectsResponse.response.rawData.scopes[0].results.map((projectResult)=>({
            projectId: projectResult.id,
            name: projectResult.name,
            avatar: {
                small: 'url' in projectResult.attributes.avatar ? projectResult.attributes.avatar.url : undefined
            }
        })) : [];
    const allProjects = searchedProjects;
    const projectOptions = allProjects.map((project)=>({
            trackingKey: $4071957cb60e08fa$var$projectIdToARI(config.cloudId || '', project.projectId),
            value: $4071957cb60e08fa$var$projectIdToARI(config.cloudId || '', project.projectId),
            label: project.name,
            avatarUrl: project.avatar?.small,
            queryParamValue: project.projectId
        }));
    return projectOptions;
};
const $4071957cb60e08fa$var$productKeys1P = [
    (0, $4sOnC.ProductKeys).Jira,
    (0, $4sOnC.ProductKeys).JiraProductDiscovery,
    (0, $4sOnC.ProductKeys).JiraServiceManagement
];
const $4071957cb60e08fa$var$originalProducts3P = [];
const $4071957cb60e08fa$var$products3PFromConfig = (0, $33vwh.getProducts3PFromConfigForFilter)('project');
const $4071957cb60e08fa$var$getProducts3P = ()=>{
    // fg('rovo-full-page-search-3p-static-config') => false
    return $4071957cb60e08fa$var$originalProducts3P;
};
const $4071957cb60e08fa$export$3dea766d36a8935f = (0, $405LB.createMultiSelectFilter)({
    id: 'project',
    products: [
        ...$4071957cb60e08fa$var$productKeys1P,
        ...$4071957cb60e08fa$var$getProducts3P()
    ],
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'jProject',
        fetcher: async (queryParams, config)=>{
            const initialProjectARIs = queryParams.map((projectId)=>$4071957cb60e08fa$var$projectIdToARI(config.cloudId || '', projectId));
            const initialProjectsResponse = await (0, $d2b64463bc9f56c5$export$fd1d4a933080bfe2)(initialProjectARIs);
            const initialProjects = initialProjectsResponse.data?.jira.jiraProjects ?? [];
            const allProjects = initialProjects;
            const projectOptions = allProjects.map((project)=>({
                    trackingKey: $4071957cb60e08fa$var$projectIdToARI(config.cloudId || '', project.projectId),
                    value: $4071957cb60e08fa$var$projectIdToARI(config.cloudId || '', project.projectId),
                    label: project.name,
                    avatarUrl: project.avatar?.small,
                    queryParamValue: project.projectId
                }));
            return projectOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $4071957cb60e08fa$var$searchProject('', config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $4071957cb60e08fa$var$searchProject(query, config);
        }
    }
});
module.exports["filter"] = $4071957cb60e08fa$export$3dea766d36a8935f;

});

parcelRegister("e4Y2w", function(module, exports) {

var $4mTS8 = parcelRequire("4mTS8");


var $1EqNn = parcelRequire("1EqNn");

const $01632052bec0945e$export$f400862b5c7e6c62 = (0, $1EqNn.inMemoryCache)();
const $01632052bec0945e$var$GQL_CF_SPACES_OPERATION_NAME = 'SearchPageConfluenceSpacesQuery';
const $01632052bec0945e$var$getConfluenceSpacesQuery = ()=>`
query ${$01632052bec0945e$var$GQL_CF_SPACES_OPERATION_NAME}($spaceIds: [ID]!) {
  confluence {
    spaces(ids: $spaceIds) {
      id
      spaceId
      name
      key
      links {
        base
      }
      icon {
        path
      }
    }
  }
}
`;
const $01632052bec0945e$export$d8fbf668d55936f8 = (spaceIds)=>{
    return $01632052bec0945e$export$f400862b5c7e6c62.inMemoryDecorator(// TODO: >>>> Limit this to a max string length
    // TODO: Refactor so that it can cache per page id
    spaceIds.join(','), async ()=>{
        if (spaceIds.length === 0) return {
            data: {
                confluence: {
                    spaces: []
                }
            }
        };
        const response = await (0, $4mTS8.fetchAgg)({
            graphQuery: $01632052bec0945e$var$getConfluenceSpacesQuery(),
            variables: {
                spaceIds: spaceIds
            },
            operationName: $01632052bec0945e$var$GQL_CF_SPACES_OPERATION_NAME
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};


var $5aC84 = parcelRequire("5aC84");




var $gtxdb = parcelRequire("gtxdb");




const $83c5b06dce42a834$var$operationName = 'SmartsRecommendedContainerQuery';
const $83c5b06dce42a834$var$SmartsRecommendedContainerQuery = `
query ${$83c5b06dce42a834$var$operationName}($userId: String!, $tenantId: String!) {
  smarts {
    results: recommendedContainer(
      recommendationsQuery: {
        context: {
          userId: $userId,
          tenantId: $tenantId,
          product: "confluence"
        },
        modelRequestParams: {
          caller: "full-page-search",
          experience: "CgContainerNearbyUser"
        },
        requestingUserId: $userId
      }
    ) {
      id
      score
      container {
        createdDate
        id
        key
        name
        spaceId
        status
        type
        links {
          base
        }
        icon {
          path
        }
      }
    }
  }
}
`;
const $83c5b06dce42a834$export$69a3209f1a06c04d = (0, $1EqNn.inMemoryCache)();
// Expire the cache if there are errors or edges are empty
const $83c5b06dce42a834$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    const { results: results } = data.smarts;
    return !results || results.length === 0;
};
const $83c5b06dce42a834$export$9d6625cf80401405 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>$83c5b06dce42a834$export$69a3209f1a06c04d.inMemoryDecorator((0, $gtxdb.generateHashFromVariables)(variables), ()=>(0, $4mTS8.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: $83c5b06dce42a834$var$SmartsRecommendedContainerQuery,
            operationName: $83c5b06dce42a834$var$operationName
        }), $83c5b06dce42a834$var$expireWhen);



var $4sOnC = parcelRequire("4sOnC");


var $33vwh = parcelRequire("33vwh");


var $405LB = parcelRequire("405LB");

const $0d91fc6ec46614fb$var$productKeys1P = [
    (0, $4sOnC.ProductKeys).Confluence
];
const $0d91fc6ec46614fb$var$originalProducts3P = [];
const $0d91fc6ec46614fb$var$products3PFromConfig = (0, $33vwh.getProducts3PFromConfigForFilter)('space');
const $0d91fc6ec46614fb$var$getProducts3P = ()=>{
    // fg('rovo-full-page-search-3p-static-config') => false
    return $0d91fc6ec46614fb$var$originalProducts3P;
};
const $0d91fc6ec46614fb$export$3dea766d36a8935f = (0, $405LB.createMultiSelectFilter)({
    id: 'space',
    products: [
        ...$0d91fc6ec46614fb$var$productKeys1P,
        ...$0d91fc6ec46614fb$var$getProducts3P()
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'spaces',
        fetcher: async (_, config)=>{
            // use initial space ARIs from config as we can not directly use space value in queryParams
            const initialSpacesResponse = await (0, $01632052bec0945e$export$d8fbf668d55936f8)(config.initialSpaceARIs || []);
            const allRecommendedSpaces = initialSpacesResponse.data?.confluence.spaces.map((space)=>({
                    key: space.key,
                    name: space.name,
                    ari: space.id,
                    avatarUrl: space.links?.base && space.icon?.path ? `${space.links.base}${space.icon.path}` : ''
                })) || [];
            return allRecommendedSpaces.map((space)=>({
                    trackingKey: space.ari,
                    value: space.key,
                    queryParamValue: space.key,
                    avatarUrl: space.avatarUrl,
                    label: space.name || ''
                }));
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            const recommendedSpacesResponse = await (0, $83c5b06dce42a834$export$9d6625cf80401405)({
                aggAbsoluteUrl: config.aggAbsoluteUrl,
                variables: {
                    userId: config.userId || '',
                    tenantId: config.cloudId || ''
                }
            });
            const allRecommendedSpaces = recommendedSpacesResponse.data?.smarts.results?.flatMap(({ container: container })=>{
                if (!(container && container.key)) return [];
                return [
                    {
                        key: container.key,
                        name: container.name,
                        ari: container.id,
                        avatarUrl: container.links?.base && container.icon?.path ? `${container.links.base}${container.icon.path}` : ''
                    }
                ];
            }) || [];
            const recommendedSpaceOptions = allRecommendedSpaces.map((space)=>{
                return {
                    trackingKey: space.ari,
                    value: space.key,
                    queryParamValue: space.key,
                    avatarUrl: space.avatarUrl,
                    label: space.name || ''
                };
            });
            return recommendedSpaceOptions;
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            const response = await (0, $5aC84.searchEntitiesQuery)({
                aggAbsoluteUrl: config.aggAbsoluteUrl,
                variables: {
                    query: query,
                    first: 15,
                    filters: {
                        entities: [
                            'ati:cloud:confluence:space'
                        ],
                        locations: [
                            `ari:cloud:confluence::site/${config.cloudId}`
                        ]
                    },
                    experience: 'full-page-search-space-filter'
                },
                includeSpaceKey: true
            });
            const { data: data } = response;
            if (!data) return [];
            return data.search?.results.edges.map(({ node: node })=>({
                    trackingKey: node.id || '',
                    value: node.key || '',
                    queryParamValue: node.key ?? '',
                    avatarUrl: node.iconUrl || undefined,
                    label: node.title
                })) ?? [];
        }
    }
});
module.exports["filter"] = $0d91fc6ec46614fb$export$3dea766d36a8935f;

});

parcelRegister("9md6K", function(module, exports) {

var $4sOnC = parcelRequire("4sOnC");


var $33vwh = parcelRequire("33vwh");


var $fjZo5 = parcelRequire("fjZo5");

const $8dc2a020c742091e$var$productKeys1P = [];
const $8dc2a020c742091e$var$originalProducts3P = [
    (0, $4sOnC.ProductKeys).GoogleDrive,
    (0, $4sOnC.ProductKeys).Sharepoint,
    (0, $4sOnC.ProductKeys).Dropbox,
    (0, $4sOnC.ProductKeys).GoogleCalendar,
    (0, $4sOnC.ProductKeys).OneDrive
];
const $8dc2a020c742091e$var$products3PFromConfig = (0, $33vwh.getProducts3PFromConfigForFilter)('onlyTitleMatch');
const $8dc2a020c742091e$var$getProducts3P = ()=>{
    // fg('rovo-full-page-search-3p-static-config') => false
    return $8dc2a020c742091e$var$originalProducts3P;
};
const $8dc2a020c742091e$export$3dea766d36a8935f = (0, $fjZo5.createBooleanFilter)({
    id: 'onlyTitleMatch',
    queryParams: {
        key: 'titleMatch'
    },
    products: [
        ...$8dc2a020c742091e$var$productKeys1P,
        ...$8dc2a020c742091e$var$getProducts3P()
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $8dc2a020c742091e$export$3dea766d36a8935f;

});

parcelRegister("lKbSE", function(module, exports) {

var $4sOnC = parcelRequire("4sOnC");


var $33vwh = parcelRequire("33vwh");


var $fjZo5 = parcelRequire("fjZo5");

const $f9b1bc7a3a963b11$var$productKeys1P = [
    (0, $4sOnC.ProductKeys).Confluence
];
const $f9b1bc7a3a963b11$var$originalProducts3P = [];
const $f9b1bc7a3a963b11$var$products3PFromConfig = (0, $33vwh.getProducts3PFromConfigForFilter)('verified');
const $f9b1bc7a3a963b11$var$getProducts3P = ()=>{
    // fg('rovo-full-page-search-3p-static-config') => false
    return $f9b1bc7a3a963b11$var$originalProducts3P;
};
const $f9b1bc7a3a963b11$export$3dea766d36a8935f = (0, $fjZo5.createBooleanFilter)({
    id: 'verified',
    queryParams: {
        key: 'verified'
    },
    products: [
        ...$f9b1bc7a3a963b11$var$productKeys1P,
        ...$f9b1bc7a3a963b11$var$getProducts3P()
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $f9b1bc7a3a963b11$export$3dea766d36a8935f;

});

parcelRegister("k5Lzq", function(module, exports) {

var $7mBSb = parcelRequire("7mBSb");


var $4sOnC = parcelRequire("4sOnC");


var $h7ecj = parcelRequire("h7ecj");


var $1L9Cd = parcelRequire("1L9Cd");

const $4d009e1e0395d3b1$var$loadQueryParams = (queryParams, config)=>{
    const allOptions = (0, $1L9Cd.getAllTypeOptions)(config);
    return allOptions.filter((option)=>!option.isDefault).filter((option)=>queryParams.includes(option.queryParamValue)).map((option)=>({
            trackingKey: option.value,
            label: option.label,
            value: option.value,
            queryParamValue: option.queryParamValue,
            isDefault: option.isDefault
        }));
};
const $4d009e1e0395d3b1$var$getInitialOptions = (config)=>{
    const allOptions = (0, $1L9Cd.getAllTypeOptions)(config);
    return allOptions.map((option)=>({
            trackingKey: option.value,
            label: option.label,
            value: option.value,
            queryParamValue: option.queryParamValue,
            isDefault: option.isDefault
        }));
};
const $4d009e1e0395d3b1$var$sortCompareFn = (a, b)=>{
    const allOption = (0, $1L9Cd.getAllTypeOptions)({
        intl: undefined
    });
    return allOption.findIndex((option)=>option.queryParamValue === a.queryParamValue) - allOption.findIndex((option)=>option.queryParamValue === b.queryParamValue);
};
const $4d009e1e0395d3b1$export$3dea766d36a8935f = (0, $h7ecj.createSingleSelectFilter)({
    id: (0, $7mBSb.universalTypeFilterId),
    products: (0, $4sOnC.allProductKeys),
    alwaysVisible: true,
    universal: true,
    queryParams: {
        key: 'type',
        fetcher: async (queryParams, config)=>{
            return $4d009e1e0395d3b1$var$loadQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $4d009e1e0395d3b1$var$getInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            // NOTE: this is the first step of filtering options
            //  the store does product specific filtering
            return (0, $1L9Cd.lookupOptions)(query, config);
        }
    },
    sortCompareFn: $4d009e1e0395d3b1$var$sortCompareFn
});
module.exports["filter"] = $4d009e1e0395d3b1$export$3dea766d36a8935f;

});

parcelRegister("iQC4a", function(module, exports) {
const $bccf47b5a21ca021$var$SearchDefaultResultAtlas = ``;
const $bccf47b5a21ca021$var$SearchResultAtlasProject = `
... on SearchResultAtlasProject {
  project {
    key
    state {
      label
      value
    }
    dueDate {
      label
    }
  }
}
`;
const $bccf47b5a21ca021$var$SearchResultAtlasGoal = `
... on SearchResultAtlasGoal {
  goal {
    description
    key
    status {
      localizedLabel {
        messageId
      }
    }
    targetDate {
      label
    }
  }
}
`;
const $bccf47b5a21ca021$export$1724df33341798e0 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasProject';
};
const $bccf47b5a21ca021$export$1d556a3125797ca6 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasGoal';
};
const $bccf47b5a21ca021$export$bff995b1cea89df3 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasTag';
};
const $bccf47b5a21ca021$export$aa63de26c950cf0f = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchDefaultResult';
};
const $bccf47b5a21ca021$export$750af6f011d7ee10 = (partial)=>{
    return $bccf47b5a21ca021$export$1d556a3125797ca6(partial) || $bccf47b5a21ca021$export$1724df33341798e0(partial) || $bccf47b5a21ca021$export$bff995b1cea89df3(partial) || $bccf47b5a21ca021$export$aa63de26c950cf0f(partial);
};
const $bccf47b5a21ca021$export$272c689528faac47 = ()=>{
    return `
		${$bccf47b5a21ca021$var$SearchResultAtlasGoal}
		${$bccf47b5a21ca021$var$SearchResultAtlasProject}
		${$bccf47b5a21ca021$var$SearchDefaultResultAtlas}
	`;
};
module.exports["isSearchResultAtlasProjectPartial"] = $bccf47b5a21ca021$export$1724df33341798e0;
module.exports["isSearchResultAtlasGoalPartial"] = $bccf47b5a21ca021$export$1d556a3125797ca6;
module.exports["isSearchAtlasPartial"] = $bccf47b5a21ca021$export$750af6f011d7ee10;
module.exports["getAtlasPartials"] = $bccf47b5a21ca021$export$272c689528faac47;

});

parcelRegister("2Btfj", function(module, exports) {
const $8d6e42674132590b$var$SearchConfluencePageBlogAttachment = `
... on SearchConfluencePageBlogAttachment {
	lastModified
	isVerified
	space {
		id
		name
		webUiLink
	}
	__typename
	confluenceEntity {
		... on ConfluencePage {
			subtype
			properties(keys: ["cover-picture-id-published", "cover-picture-id-draft"]) {
				key
				value
			}
			ancestors {
				id
				title
				links {
					webUi
				}
			}
			metadata {
				titleEmojiPublished {
					id
					value
				}
			}
			commentCountSummary {
				total
			}
			likesSummary {
				count
			}
		}
		... on ConfluenceBlogPost {
			properties(keys: ["cover-picture-id-published", "cover-picture-id-draft"]) {
				key
				value
			}
			metadata {
				titleEmojiPublished {
					id
					value
				}
			}
		}
	}
	socialSignal(tenantId: $tenantId) {
		signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
		}
	}
}
`;
const $8d6e42674132590b$export$c89c057fd480d10c = (partial)=>{
    return partial.__typename === 'SearchConfluencePageBlogAttachment';
};
const $8d6e42674132590b$var$SearchConfluenceSpace = `
... on SearchConfluenceSpace {
	key
	lastModified
	iconPath
	socialSignal(tenantId: $tenantId) {
		signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
		}

	}
}
`;
const $8d6e42674132590b$export$4619f000f23ee8d1 = (partial)=>{
    return partial.__typename === 'SearchConfluenceSpace';
};
const $8d6e42674132590b$export$e4e5a86cb4c1e3e4 = (partial)=>{
    return $8d6e42674132590b$export$c89c057fd480d10c(partial) || $8d6e42674132590b$export$4619f000f23ee8d1(partial);
};
const $8d6e42674132590b$export$d1ddb94b35ac2d77 = ()=>{
    return `
		${$8d6e42674132590b$var$SearchConfluencePageBlogAttachment}
		${$8d6e42674132590b$var$SearchConfluenceSpace}
	`;
};
module.exports["isSearchConfluencePageBlogAttachment"] = $8d6e42674132590b$export$c89c057fd480d10c;
module.exports["isSearchConfluencePartial"] = $8d6e42674132590b$export$e4e5a86cb4c1e3e4;
module.exports["getConfluencePartials"] = $8d6e42674132590b$export$d1ddb94b35ac2d77;

});

parcelRegister("57Ynd", function(module, exports) {

var $k4HRJ = parcelRequire("k4HRJ");


var $bJguZ = parcelRequire("bJguZ");


var $jmwQa = parcelRequire("jmwQa");


var $gSUtj = parcelRequire("gSUtj");


var $hFLLm = parcelRequire("hFLLm");


var $51tJJ = parcelRequire("51tJJ");


var $giUQ9 = parcelRequire("giUQ9");


var $2olQG = parcelRequire("2olQG");


var $ewLvK = parcelRequire("ewLvK");


var $cMovz = parcelRequire("cMovz");


var $bFwde = parcelRequire("bFwde");

const $158a0408fac59be7$var$TEAMS_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $158a0408fac59be7$var$SearchThirdPartyGraphDocumentPartial = `
... on SearchResultGraphDocument {
	excerpt,
	permissionLevel,
	initialContributors {
		name
	}
	subtype
	integrationId
	lastModifiedDate
	linkedEntities {
		id
		title
		excerpt,
		permissionLevel,
		subtype
		integrationId
		lastModifiedDate
		entity {
			${(0, $2olQG.ExternalMessagePartial)}
		}
	}
	entity {
		${(0, $bJguZ.ExternalBranchPartial)}
		${(0, $jmwQa.ExternalCalendarEventPartial)}
		${(0, $gSUtj.ExternalCommitPartial)}
		${(0, $hFLLm.ExternalConversationPartial)}
		${(0, $51tJJ.ExternalDesignPartial)}
		${(0, $giUQ9.ExternalDocumentPartial)}
		${(0, $2olQG.ExternalMessagePartial)}
		${(0, $ewLvK.ExternalPullRequestPartial)}
		${(0, $cMovz.ExternalRepositoryPartial)}
		${(0, $bFwde.ExternalVideoPartial)}
	}
}
`;
var $158a0408fac59be7$var$AccountStatus = /*#__PURE__*/ function(AccountStatus) {
    AccountStatus[AccountStatus["active"] = 0] = "active";
    AccountStatus[AccountStatus["inactive"] = 1] = "inactive";
    AccountStatus[AccountStatus["closed"] = 2] = "closed";
    return AccountStatus;
}($158a0408fac59be7$var$AccountStatus || {});
var $158a0408fac59be7$var$ExternalDocumentCategory = /*#__PURE__*/ function(ExternalDocumentCategory) {
    ExternalDocumentCategory[ExternalDocumentCategory["ARCHIVE"] = 0] = "ARCHIVE";
    ExternalDocumentCategory[ExternalDocumentCategory["AUDIO"] = 1] = "AUDIO";
    ExternalDocumentCategory[ExternalDocumentCategory["CODE"] = 2] = "CODE";
    ExternalDocumentCategory[ExternalDocumentCategory["DOCUMENT"] = 3] = "DOCUMENT";
    ExternalDocumentCategory[ExternalDocumentCategory["FOLDER"] = 4] = "FOLDER";
    ExternalDocumentCategory[ExternalDocumentCategory["FORM"] = 5] = "FORM";
    ExternalDocumentCategory[ExternalDocumentCategory["IMAGE"] = 6] = "IMAGE";
    ExternalDocumentCategory[ExternalDocumentCategory["OTHER"] = 7] = "OTHER";
    ExternalDocumentCategory[ExternalDocumentCategory["PDF"] = 8] = "PDF";
    ExternalDocumentCategory[ExternalDocumentCategory["PRESENTATION"] = 9] = "PRESENTATION";
    ExternalDocumentCategory[ExternalDocumentCategory["SHORTCUT"] = 10] = "SHORTCUT";
    ExternalDocumentCategory[ExternalDocumentCategory["SPREADSHEET"] = 11] = "SPREADSHEET";
    ExternalDocumentCategory[ExternalDocumentCategory["VIDEO"] = 12] = "VIDEO";
    ExternalDocumentCategory[ExternalDocumentCategory["WEB_PAGE"] = 13] = "WEB_PAGE";
    return ExternalDocumentCategory;
}($158a0408fac59be7$var$ExternalDocumentCategory || {});
var $158a0408fac59be7$var$ExternalWorkItemType = /*#__PURE__*/ function(ExternalWorkItemType) {
    ExternalWorkItemType["TASK"] = "TASK";
    ExternalWorkItemType["DEFAULT_TASK"] = "DEFAULT_TASK";
    ExternalWorkItemType["WORK_ITEM"] = "WORK_ITEM";
    ExternalWorkItemType["EPIC"] = "EPIC";
    ExternalWorkItemType["BUG"] = "BUG";
    ExternalWorkItemType["STORY"] = "STORY";
    ExternalWorkItemType["MILESTONE"] = "MILESTONE";
    ExternalWorkItemType["SECTION"] = "SECTION";
    ExternalWorkItemType["APPROVAL"] = "APPROVAL";
    ExternalWorkItemType["PROBLEM"] = "PROBLEM";
    ExternalWorkItemType["INCIDENT"] = "INCIDENT";
    ExternalWorkItemType["QUESTION"] = "QUESTION";
    ExternalWorkItemType["ISSUE"] = "ISSUE";
    ExternalWorkItemType["OTHER"] = "OTHER";
    return ExternalWorkItemType;
}($158a0408fac59be7$var$ExternalWorkItemType || {});
var $158a0408fac59be7$var$ExternalMembershipType = /*#__PURE__*/ function(ExternalMembershipType) {
    ExternalMembershipType["PRIVATE"] = "PRIVATE";
    ExternalMembershipType["PUBLIC"] = "PUBLIC";
    ExternalMembershipType["SHARED"] = "SHARED";
    return ExternalMembershipType;
}($158a0408fac59be7$var$ExternalMembershipType || {});
var $158a0408fac59be7$var$ExternalConversationType = /*#__PURE__*/ function(ExternalConversationType) {
    ExternalConversationType["CHANNEL"] = "CHANNEL";
    ExternalConversationType["DIRECT_MESSAGE"] = "DIRECT_MESSAGE";
    ExternalConversationType["GROUP_DIRECT_MESSAGE"] = "GROUP_DIRECT_MESSAGE";
    return ExternalConversationType;
}($158a0408fac59be7$var$ExternalConversationType || {});
var $158a0408fac59be7$var$ResourceType = /*#__PURE__*/ function(ResourceType) {
    ResourceType["BRANCH"] = "branch";
    ResourceType["CALENDAR_EVENT"] = "calendar-event";
    ResourceType["COMMIT"] = "commit";
    ResourceType["CONVERSATION"] = "conversation";
    ResourceType["DESIGN"] = "design";
    ResourceType["DOCUMENT"] = "document";
    ResourceType["MESSAGE"] = "message";
    ResourceType["PULL_REQUEST"] = "pull-request";
    ResourceType["REPOSITORY"] = "repository";
    ResourceType["VIDEO"] = "video";
    ResourceType["WORK_ITEM"] = "work-item";
    return ResourceType;
}($158a0408fac59be7$var$ResourceType || {});
const $158a0408fac59be7$export$e169b729a14ad5f8 = ()=>{
    //TODO: update for GitHub graph entities
    return $158a0408fac59be7$var$SearchThirdPartyGraphDocumentPartial;
};
const $158a0408fac59be7$export$7dd4baba91338caa = (partial)=>partial.__typename === 'SearchResultGraphDocument';
const $158a0408fac59be7$export$6c20afe8743cb761 = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "conversation";
};
const $158a0408fac59be7$export$8dc9be81b5b6266b = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "design";
};
const $158a0408fac59be7$export$33e8c1bbf9148b0e = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "message";
};
const $158a0408fac59be7$export$9cfcc6ca7fb6e839 = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "video";
};
const $158a0408fac59be7$export$9a3959a38fa67fd0 = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "branch";
};
const $158a0408fac59be7$export$ece3e91c16809748 = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "commit";
};
const $158a0408fac59be7$export$5ba84cc314040e0c = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "pull-request";
};
const $158a0408fac59be7$export$9c4afe4ccb574692 = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "repository";
};
const $158a0408fac59be7$export$32c06ee7e0e9b79e = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "document";
};
const $158a0408fac59be7$export$92306a022e0703e0 = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "calendar-event";
};
const $158a0408fac59be7$export$40f90006d8fc8dee = (partial)=>$158a0408fac59be7$export$33e8c1bbf9148b0e(partial) && partial.integrationId === $158a0408fac59be7$var$TEAMS_INTEGRATION_ARI;
const $158a0408fac59be7$export$162dad7a1238d377 = (partial)=>{
    const { resourceType: resourceType } = (0, $k4HRJ.AnyAri).parse(partial.id);
    return resourceType === "work-item";
};
module.exports["getGraphPartials"] = $158a0408fac59be7$export$e169b729a14ad5f8;
module.exports["isSearchResultGraphEntity"] = $158a0408fac59be7$export$7dd4baba91338caa;
module.exports["isConversationEntity"] = $158a0408fac59be7$export$6c20afe8743cb761;
module.exports["isDesignEntity"] = $158a0408fac59be7$export$8dc9be81b5b6266b;
module.exports["isMessageEntity"] = $158a0408fac59be7$export$33e8c1bbf9148b0e;
module.exports["isVideoEntity"] = $158a0408fac59be7$export$9cfcc6ca7fb6e839;
module.exports["isBranchEntity"] = $158a0408fac59be7$export$9a3959a38fa67fd0;
module.exports["isCommitEntity"] = $158a0408fac59be7$export$ece3e91c16809748;
module.exports["isPullRequestEntity"] = $158a0408fac59be7$export$5ba84cc314040e0c;
module.exports["isRepositoryEntity"] = $158a0408fac59be7$export$9c4afe4ccb574692;
module.exports["isDocumentEntity"] = $158a0408fac59be7$export$32c06ee7e0e9b79e;
module.exports["isCalendarEventEntity"] = $158a0408fac59be7$export$92306a022e0703e0;
module.exports["isWorkItemEntity"] = $158a0408fac59be7$export$162dad7a1238d377;

});

parcelRegister("1rDtO", function(module, exports) {
const $fe594af6064fca48$var$SearchResultTrelloBoard = `
... on SearchResultTrelloBoard {
	type
	description
	lastModifiedDate
}
`;
const $fe594af6064fca48$export$d40aaa445b6f7858 = (partial)=>{
    return partial.__typename === 'SearchResultTrelloBoard';
};
const $fe594af6064fca48$var$SearchResultTrelloCard = `
... on SearchResultTrelloCard {
	type
	description
	lastModifiedDate
	boardName
	commentsCount
}
`;
const $fe594af6064fca48$export$980cabf11d827509 = (partial)=>{
    return partial.__typename === 'SearchResultTrelloCard';
};
const $fe594af6064fca48$export$6ed59678949b7701 = (partial)=>{
    return $fe594af6064fca48$export$d40aaa445b6f7858(partial) || $fe594af6064fca48$export$980cabf11d827509(partial);
};
const $fe594af6064fca48$export$73993ded7a48a460 = ()=>{
    return `
		${$fe594af6064fca48$var$SearchResultTrelloBoard}
		${$fe594af6064fca48$var$SearchResultTrelloCard}
	`;
};
module.exports["isSearchTrelloPartial"] = $fe594af6064fca48$export$6ed59678949b7701;
module.exports["getTrelloPartials"] = $fe594af6064fca48$export$73993ded7a48a460;

});

parcelRegister("af8fO", function(module, exports) {
/**
 * @deprecated do not use or change this file, use the new third-party-graph-entity package instead
 */ const $4d8e36709a0bb90c$var$GOOGLE_INTEGRATION_ARI = 'ari:cloud:platform::integration/google';
const $4d8e36709a0bb90c$var$MICROSOFT_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $4d8e36709a0bb90c$var$SearchThirdPartyDocumentPartial = `
... on SearchResultGoogleDocument {
  lastModifiedDate
  excerpt
  permissionLevel
}
... on SearchResultGooglePresentation {
  lastModifiedDate
  excerpt
	permissionLevel
}
... on SearchResultGoogleSpreadsheet {
  lastModifiedDate
  excerpt
	permissionLevel
}
... on SearchResultGooglePresentation {
  lastModifiedDate
  excerpt
	permissionLevel
}
... on SearchResultGoogleSpreadsheet {
  lastModifiedDate
  excerpt
	permissionLevel
}
... on SearchResultMicrosoftDocument {
  lastModifiedDate
  excerpt
  permissionLevel
}
`;
const $4d8e36709a0bb90c$var$SlackMessagePartial = `
... on SearchResultSlackMessage {
  lastModifiedDate
  subtype
  mentions {
    name
	externalId
  }
  initialContributors {
    name
  }
  linkedEntities {
	id
	title
	description
	initialContributors {
  	  name
	  externalId
	}
	mentions {
	  name
	  externalId
	}
  }
}
`;
const $4d8e36709a0bb90c$export$a1e4e7e35d852037 = ()=>{
    return $4d8e36709a0bb90c$var$SearchThirdPartyDocumentPartial;
};
const $4d8e36709a0bb90c$export$2580337ea423563e = ()=>{
    return $4d8e36709a0bb90c$var$SearchThirdPartyDocumentPartial;
};
const $4d8e36709a0bb90c$export$dad2c93cb82acac0 = ()=>{
    return `${$4d8e36709a0bb90c$var$SlackMessagePartial}`;
};
const $4d8e36709a0bb90c$export$2b6b5ca2b503e8cd = (partial)=>partial.__typename === 'SearchResultMicrosoftDocument' || $4d8e36709a0bb90c$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $4d8e36709a0bb90c$var$MICROSOFT_INTEGRATION_ARI;
const $4d8e36709a0bb90c$export$ccb18eeab2a052be = (partial)=>$4d8e36709a0bb90c$export$2b6b5ca2b503e8cd(partial) && partial.type === 'document' || $4d8e36709a0bb90c$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $4d8e36709a0bb90c$var$MICROSOFT_INTEGRATION_ARI && partial.subtype === 'document';
const $4d8e36709a0bb90c$export$aa6b9bf904d5faaa = (partial)=>$4d8e36709a0bb90c$export$2b6b5ca2b503e8cd(partial) && partial.type === 'presentation' || $4d8e36709a0bb90c$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $4d8e36709a0bb90c$var$MICROSOFT_INTEGRATION_ARI && partial.subtype === 'presentation';
const $4d8e36709a0bb90c$export$6da7ca6e6bf249aa = (partial)=>$4d8e36709a0bb90c$export$2b6b5ca2b503e8cd(partial) && partial.type === 'spreadsheet' || $4d8e36709a0bb90c$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $4d8e36709a0bb90c$var$MICROSOFT_INTEGRATION_ARI && partial.subtype === 'spreadsheet';
const $4d8e36709a0bb90c$export$bb2c616baa181494 = (partial)=>$4d8e36709a0bb90c$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $4d8e36709a0bb90c$var$MICROSOFT_INTEGRATION_ARI;
const $4d8e36709a0bb90c$export$927c2feba595f1cb = (partial)=>$4d8e36709a0bb90c$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $4d8e36709a0bb90c$var$MICROSOFT_INTEGRATION_ARI && (partial.type === 'document' || partial.subtype === 'document');
const $4d8e36709a0bb90c$export$6712295d6d2d4b9 = (partial)=>$4d8e36709a0bb90c$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $4d8e36709a0bb90c$var$MICROSOFT_INTEGRATION_ARI && (partial.type === 'presentation' || partial.subtype === 'presentation');
const $4d8e36709a0bb90c$export$b1c281e549a5f797 = (partial)=>$4d8e36709a0bb90c$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $4d8e36709a0bb90c$var$MICROSOFT_INTEGRATION_ARI && (partial.type === 'spreadsheet' || partial.subtype === 'spreadsheet');
const $4d8e36709a0bb90c$export$ac12fd23f64c998f = (partial)=>$4d8e36709a0bb90c$export$e6a288d5cd4cda6(partial) || $4d8e36709a0bb90c$export$5fa365506597a68f(partial) || $4d8e36709a0bb90c$export$bb8318bfdc4716ee(partial);
const $4d8e36709a0bb90c$export$e6a288d5cd4cda6 = (partial)=>partial.__typename === 'SearchResultGoogleDocument' || $4d8e36709a0bb90c$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $4d8e36709a0bb90c$var$GOOGLE_INTEGRATION_ARI && partial.subtype === 'document';
const $4d8e36709a0bb90c$export$5fa365506597a68f = (partial)=>partial.__typename === 'SearchResultGooglePresentation' || $4d8e36709a0bb90c$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $4d8e36709a0bb90c$var$GOOGLE_INTEGRATION_ARI && partial.subtype === 'presentation';
const $4d8e36709a0bb90c$export$bb8318bfdc4716ee = (partial)=>partial.__typename === 'SearchResultGoogleSpreadsheet' || $4d8e36709a0bb90c$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $4d8e36709a0bb90c$var$GOOGLE_INTEGRATION_ARI && partial.subtype === 'spreadsheet';
const $4d8e36709a0bb90c$export$2fedbabcc623299 = (partial)=>partial.__typename === 'SearchResultSlackMessage';
const $4d8e36709a0bb90c$export$677950c93e2449ad = (partial)=>{
    return $4d8e36709a0bb90c$export$ac12fd23f64c998f(partial) || $4d8e36709a0bb90c$export$2b6b5ca2b503e8cd(partial) || $4d8e36709a0bb90c$export$34ee1a2c0a1a45b7(partial);
};
const $4d8e36709a0bb90c$export$34ee1a2c0a1a45b7 = (partial)=>partial.__typename === 'SearchResultGraphDocument';
module.exports["getGooglePartials"] = $4d8e36709a0bb90c$export$a1e4e7e35d852037;
module.exports["getMicrosoftPartials"] = $4d8e36709a0bb90c$export$2580337ea423563e;
module.exports["getSlackPartials"] = $4d8e36709a0bb90c$export$dad2c93cb82acac0;
module.exports["isSharepointResult"] = $4d8e36709a0bb90c$export$2b6b5ca2b503e8cd;
module.exports["isGraphDocument"] = $4d8e36709a0bb90c$export$34ee1a2c0a1a45b7;
module.exports["isSharepointDocument"] = $4d8e36709a0bb90c$export$ccb18eeab2a052be;
module.exports["isSharepointPresentation"] = $4d8e36709a0bb90c$export$aa6b9bf904d5faaa;
module.exports["isSharepointSpreadsheet"] = $4d8e36709a0bb90c$export$6da7ca6e6bf249aa;
module.exports["isGoogleResult"] = $4d8e36709a0bb90c$export$ac12fd23f64c998f;
module.exports["isGoogleDocument"] = $4d8e36709a0bb90c$export$e6a288d5cd4cda6;
module.exports["isGooglePresentation"] = $4d8e36709a0bb90c$export$5fa365506597a68f;
module.exports["isGoogleSpreadsheet"] = $4d8e36709a0bb90c$export$bb8318bfdc4716ee;
module.exports["isSlackMessage"] = $4d8e36709a0bb90c$export$2fedbabcc623299;

});

parcelRegister("gtxdb", function(module, exports) {
/**
 * Simple implementation of djb2 hashing.
 * The reason we have it internally is because at the moment we can't add new
 * dependencies into search-client package as it triggers a deprecated VR test in Editor
 * and it is locked down. So it fails to resolve the new dependency
 */ const $ca71035f89bb6e83$export$daf4c137c5f56404 = (query)=>{
    let hash = 5381;
    for(let i = 0; i < query.length; i++){
        const char = query.charCodeAt(i);
        hash = (hash << 5) + hash + char; /* hash * 33 + char */ 
    }
    return hash;
};
const $ca71035f89bb6e83$export$5c07a4287a46fa1f = (variables)=>{
    try {
        return $ca71035f89bb6e83$export$daf4c137c5f56404(JSON.stringify(variables)).toString();
    } catch (e) {
        return '';
    }
};
module.exports["generateHash"] = $ca71035f89bb6e83$export$daf4c137c5f56404;
module.exports["generateHashFromVariables"] = $ca71035f89bb6e83$export$5c07a4287a46fa1f;

});

parcelRegister("2CHGe", function(module, exports) {
const $0b11b28f6565913d$var$DEFAULT_EXPIRATION = 900000; // 15 mins in milliseconds
class $0b11b28f6565913d$var$Cache {
    get(key, returnExpired = false) {
        const entry = this.map[key];
        if (entry) {
            if (entry.isExpired()) {
                delete this.map[key];
                return returnExpired ? entry.getResult() : undefined;
            } else return entry.getResult();
        }
        return;
    }
    set(key, result) {
        const entry = new $0b11b28f6565913d$var$Entry({
            result: result,
            expirationTime: Date.now() + this.expiration,
            accessCount: 0
        });
        this.map[key] = entry;
    }
    has(key) {
        return key in this.map;
    }
    clear(key) {
        if (key) delete this.map[key];
        else this.map = {};
    }
    async serialize() {
        const serialized = {};
        const resolvers = Object.entries(this.map).map(([key, entry])=>(async ()=>{
                serialized[key] = {
                    result: await entry.getResult(),
                    expirationTime: entry.getExpirationTime(),
                    accessCount: entry.getAccessCount()
                };
            })());
        await Promise.all(resolvers);
        return JSON.stringify(serialized);
    }
    deserialize(persisted) {
        try {
            const object = JSON.parse(persisted);
            for(const key in object){
                const { result: result, expirationTime: expirationTime, accessCount: accessCount } = object[key];
                this.map[key] = new $0b11b28f6565913d$var$Entry({
                    result: Promise.resolve(result),
                    expirationTime: expirationTime,
                    accessCount: accessCount
                });
            }
        } catch (e) {
        // TODO: Log error via sentry
        }
    }
    constructor(args = {}){
        this.map = void 0;
        this.expiration = void 0;
        const { expiration: expiration = $0b11b28f6565913d$var$DEFAULT_EXPIRATION } = args;
        this.map = {};
        this.expiration = expiration;
    }
}
class $0b11b28f6565913d$var$Entry {
    getResult() {
        this.accessCount++;
        return this.result;
    }
    isExpired() {
        return this.expirationTime < Date.now();
    }
    getExpirationTime() {
        return this.expirationTime;
    }
    getAccessCount() {
        return this.accessCount;
    }
    constructor({ result: result, expirationTime: expirationTime, accessCount: accessCount }){
        this.result = void 0;
        this.expirationTime = void 0;
        this.accessCount = void 0;
        this.result = result;
        this.expirationTime = expirationTime;
        this.accessCount = accessCount;
    }
}
const $0b11b28f6565913d$export$8bedcca5bbd73999 = (args)=>{
    return new $0b11b28f6565913d$var$Cache(args);
};
module.exports["getInstance"] = $0b11b28f6565913d$export$8bedcca5bbd73999;

});

parcelRegister("c5nm0", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $e5c764dad0b8c4b1$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    atlas: {
        id: "dynamic-cards-search-page.products.atlas",
        defaultMessage: "Atlas"
    },
    webPage: {
        id: "dynamic-cards-search-page.products.custom-website",
        defaultMessage: "Web page"
    },
    webPages: {
        id: "dynamic-cards-search-page.products.custom-websites",
        defaultMessage: "Web pages"
    },
    project: {
        id: "dynamic-cards-search-page.nouns.project",
        defaultMessage: "Project"
    },
    projects: {
        id: "dynamic-cards-search-page.nouns.projects",
        defaultMessage: "Projects"
    },
    goal: {
        id: "dynamic-cards-search-page.nouns.goal",
        defaultMessage: "Goal"
    },
    goals: {
        id: "dynamic-cards-search-page.nouns.goals",
        defaultMessage: "Goals"
    },
    tag: {
        id: "dynamic-cards-search-page.nouns.tag",
        defaultMessage: "Tag"
    },
    tags: {
        id: "dynamic-cards-search-page.nouns.tags",
        defaultMessage: "Tags"
    },
    sharepoint: {
        id: "dynamic-cards-search-page.products.sharepoint",
        defaultMessage: "SharePoint"
    },
    atlassianWebCrawler: {
        id: "dynamic-cards-search-page.products.atlassian-web-crawler",
        defaultMessage: "Atlassian Web Crawler"
    }
});
module.exports["messages"] = $e5c764dad0b8c4b1$export$defe85febe8b728c;

});

parcelRegister("lPWlo", function(module, exports) {
const $8a3902c2221766e0$export$c87d62ed9387fa60 = [
    'ati:cloud:townsquare:project',
    'ati:cloud:townsquare:goal',
    'ati:cloud:townsquare:tag'
];
const $8a3902c2221766e0$export$d520529b4595d46c = [
    'ati:cloud:graph:document'
];
const $8a3902c2221766e0$export$8bd7fa13a82672fe = [
    'ati:cloud:graph:message'
];
const $8a3902c2221766e0$export$a752b216a5b9069f = [
    'ati:cloud:graph:conversation'
];
const $8a3902c2221766e0$export$9d37c36d8b43baee = [
    'ati:cloud:graph:design'
];
const $8a3902c2221766e0$export$a3d7cddace4fe237 = [
    'ati:cloud:graph:video'
];
const $8a3902c2221766e0$export$d810eae89914369b = [
    'ati:cloud:graph:work-item'
];
const $8a3902c2221766e0$export$733c2acb2513a07a = [
    'ati:cloud:graph:calendar-event'
];
const $8a3902c2221766e0$export$6ecda3d3ffc4c36b = [
    'ati:cloud:graph:repository',
    'ati:cloud:graph:pull-request',
    'ati:cloud:graph:commit',
    'ati:cloud:graph:branch'
];
const $8a3902c2221766e0$export$2113db8105db1e2f = 'ati:cloud:confluence:';
const $8a3902c2221766e0$export$c07a1c127052b557 = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:space',
    'ati:cloud:confluence:whiteboard'
];
const $8a3902c2221766e0$export$1d1f9443ac350d6f = [
    'ati:cloud:confluence:comment',
    'ati:cloud:confluence:database',
    'ati:cloud:confluence:embed',
    'ati:cloud:confluence:folder'
];
const $8a3902c2221766e0$export$fd9583608bfd5225 = 'confluence.com.atlassian.confluence.extra.team-calendars:calendar-content-type';
const $8a3902c2221766e0$export$842fc5f4c9a103cc = 'confluence.com.atlassian.confluence.extra.team-calendars:space-calendars-view-content-type';
const $8a3902c2221766e0$export$85fae06d428ca65d = 'confluence.ac:com.atlassian.confluence.plugins.confluence-questions:answer';
const $8a3902c2221766e0$export$de533c0a50cfcba1 = 'confluence.ac:com.atlassian.confluence.plugins.confluence-questions:question';
const $8a3902c2221766e0$export$4fb210ecd60bcccb = 'ati:cloud:jira:issue';
const $8a3902c2221766e0$export$2d84b48cf0a2eca6 = 'ati:cloud:jira:project';
const $8a3902c2221766e0$export$b4a7e1c18385196d = [
    $8a3902c2221766e0$export$2d84b48cf0a2eca6,
    $8a3902c2221766e0$export$4fb210ecd60bcccb
];
const $8a3902c2221766e0$export$d3361702bd2fd562 = [
    'message'
];
const $8a3902c2221766e0$export$18938ead1fad4569 = [
    ...$8a3902c2221766e0$export$c87d62ed9387fa60,
    ...$8a3902c2221766e0$export$c07a1c127052b557,
    ...$8a3902c2221766e0$export$b4a7e1c18385196d
];
const $8a3902c2221766e0$export$423da9b1dcd76b7 = 15;
const $8a3902c2221766e0$export$405ff9c6ee9ee7de = 30;
module.exports["DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI"] = $8a3902c2221766e0$export$d520529b4595d46c;
module.exports["DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI"] = $8a3902c2221766e0$export$8bd7fa13a82672fe;
module.exports["DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI"] = $8a3902c2221766e0$export$a752b216a5b9069f;
module.exports["DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI"] = $8a3902c2221766e0$export$9d37c36d8b43baee;
module.exports["DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI"] = $8a3902c2221766e0$export$a3d7cddace4fe237;
module.exports["DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI"] = $8a3902c2221766e0$export$d810eae89914369b;
module.exports["CONFLUENCE_CALENDAR_ENTITY_ATI"] = $8a3902c2221766e0$export$fd9583608bfd5225;
module.exports["CONFLUENCE_SPACE_CALENDAR_ENTITY_ATI"] = $8a3902c2221766e0$export$842fc5f4c9a103cc;
module.exports["CONFLUENCE_ANSWER_ENTITY_ATI"] = $8a3902c2221766e0$export$85fae06d428ca65d;
module.exports["CONFLUENCE_QUESTION_ENTITY_ATI"] = $8a3902c2221766e0$export$de533c0a50cfcba1;
module.exports["JIRA_ISSUE_ENTITY_ATI"] = $8a3902c2221766e0$export$4fb210ecd60bcccb;
module.exports["JIRA_PROJECT_ENTITY_ATI"] = $8a3902c2221766e0$export$2d84b48cf0a2eca6;
module.exports["DEFAULT_ENTITY_ATI"] = $8a3902c2221766e0$export$18938ead1fad4569;
module.exports["RESULT_LIMIT_FOR_MULTIPLE_PRODUCTS"] = $8a3902c2221766e0$export$423da9b1dcd76b7;
module.exports["RESULT_LIMIT_FOR_SINGLE_PRODUCT"] = $8a3902c2221766e0$export$405ff9c6ee9ee7de;

});

parcelRegister("dgfdr", function(module, exports) {

var $7mBSb = parcelRequire("7mBSb");


var $eMyDT = parcelRequire("eMyDT");


var $htLpQ = parcelRequire("htLpQ");

const $97a42ebacb78821d$export$962b0679c5bd2c33 = {
    displayName: 'Airtable',
    id: 'airtable',
    resourceType: 'airtable-connector',
    icon: (0, $htLpQ.AirtableFilterIcon),
    searchResultIcon: (0, $eMyDT.AirtableIcon),
    integrationAri: 'ari:cloud:platform::integration/airtable',
    typeFilterValues: [
        (0, $7mBSb.TypeFilterValueKey).Document
    ],
    requiresOauth: true,
    isEnabled: ()=>false
};
module.exports["airtableConfig"] = $97a42ebacb78821d$export$962b0679c5bd2c33;

});

parcelRegister("9d6Pf", function(module, exports) {

var $7mBSb = parcelRequire("7mBSb");


var $ia5aS = parcelRequire("ia5aS");

const $33bc61e55d34f9e6$export$72c8845a87b8934e = {
    displayName: 'Asana',
    id: 'asana',
    icon: (0, $ia5aS.default),
    integrationAri: 'ari:cloud:platform::integration/asana',
    typeFilterValues: [
        (0, $7mBSb.TypeFilterValueKey).WorkItem
    ],
    requiresOauth: true,
    isEnabled: ()=>false
};
module.exports["asanaConfig"] = $33bc61e55d34f9e6$export$72c8845a87b8934e;

});

parcelRegister("ifD4G", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $7mBSb = parcelRequire("7mBSb");


var $c3jFl = parcelRequire("c3jFl");


var $k1Fwx = parcelRequire("k1Fwx");


var $7vyq1 = parcelRequire("7vyq1");

const $6f45650c242aa91f$export$fbd198cf40195606 = {
    displayName: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...(0, $7vyq1.messages)['atlassian-web-crawler']
    }),
    id: 'atlassian-web-crawler',
    resourceType: 'webcrawler-connector',
    icon: (0, $c3jFl.WebDomainIcon),
    searchResultIcon: (0, $k1Fwx.WebDomainSearchResultIcon),
    integrationAri: 'ari:cloud:platform::integration/atlassian-web-crawler',
    typeFilterValues: [
        (0, $7mBSb.TypeFilterValueKey).WebPage
    ],
    requiresOauth: false,
    isEnabled: ()=>true
};
module.exports["atlassianWebCrawlerConfig"] = $6f45650c242aa91f$export$fbd198cf40195606;

});

parcelRegister("1BJiv", function(module, exports) {

var $7mBSb = parcelRequire("7mBSb");


var $lC6Bo = parcelRequire("lC6Bo");

const $0aaf29259a5ca5fe$export$4a63cdb15a145936 = {
    displayName: 'Dropbox',
    id: 'dropbox',
    resourceType: 'dropbox-connector',
    icon: (0, $lC6Bo.DropboxIcon),
    integrationAri: 'ari:cloud:platform::integration/dropbox',
    typeFilterValues: [
        (0, $7mBSb.TypeFilterValueKey).Document,
        (0, $7mBSb.TypeFilterValueKey).Spreadsheet,
        (0, $7mBSb.TypeFilterValueKey).Presentation
    ],
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["dropboxConfig"] = $0aaf29259a5ca5fe$export$4a63cdb15a145936;

});

parcelRegister("lQmBe", function(module, exports) {

var $7mBSb = parcelRequire("7mBSb");


var $kNd5F = parcelRequire("kNd5F");


var $cFnPW = parcelRequire("cFnPW");

const $44a2c8a1ea9fd76d$export$e821d8af66e3adab = {
    displayName: 'Figma',
    id: 'figma',
    resourceType: 'figma-connector',
    icon: (0, $kNd5F.FigmaIcon),
    searchResultIcon: (0, $cFnPW.FigmaSearchResultIcon),
    integrationAri: 'ari:cloud:platform::integration/figma',
    typeFilterValues: [
        (0, $7mBSb.TypeFilterValueKey).Design
    ],
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["figmaConfig"] = $44a2c8a1ea9fd76d$export$e821d8af66e3adab;

});

parcelRegister("8nc1P", function(module, exports) {

var $7mBSb = parcelRequire("7mBSb");


var $jIZgI = parcelRequire("jIZgI");


var $aZEPk = parcelRequire("aZEPk");

const $f58e1250068b6743$export$71c63cb45707eee = {
    displayName: 'Github',
    id: 'github',
    resourceType: 'github-connector',
    icon: (0, $jIZgI.GithubIcon),
    searchResultIcon: (0, $aZEPk.GithubSearchResultIcon),
    integrationAri: 'ari:cloud:platform::integration/github',
    typeFilterValues: [
        (0, $7mBSb.TypeFilterValueKey).Repository,
        (0, $7mBSb.TypeFilterValueKey).PullRequest,
        (0, $7mBSb.TypeFilterValueKey).Branch,
        (0, $7mBSb.TypeFilterValueKey).Commit
    ],
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["githubConfig"] = $f58e1250068b6743$export$71c63cb45707eee;

});

parcelRegister("3nRFC", function(module, exports) {

var $72WyQ = parcelRequire("72WyQ");

const $cae6baa918f8e42e$export$c771ac380e225e02 = {
    displayName: 'Gmail',
    id: 'gmail',
    resourceType: 'gmail-connector',
    icon: (0, $72WyQ.GmailIcon),
    integrationAri: 'ari:cloud:platform::integration/gmail',
    requiresOauth: true,
    typeFilterValues: [],
    // fg('enable_3p_search_gmail') => false
    isEnabled: ()=>false
};
module.exports["gmailConfig"] = $cae6baa918f8e42e$export$c771ac380e225e02;

});

parcelRegister("jwCqK", function(module, exports) {

var $7mBSb = parcelRequire("7mBSb");


var $1tp1E = parcelRequire("1tp1E");


var $5ErYS = parcelRequire("5ErYS");

const $fa5664d18fa736c2$export$6634ddcb22ed69a = {
    displayName: 'Google Drive',
    id: 'drive',
    resourceType: 'ai-3p-connector:google-workspace',
    icon: (0, $1tp1E.GoogleDriveIcon),
    searchResultIcon: (0, $5ErYS.GoogleDriveSearchResultIcon),
    integrationAri: 'ari:cloud:platform::integration/google',
    typeFilterValues: [
        (0, $7mBSb.TypeFilterValueKey).Document,
        (0, $7mBSb.TypeFilterValueKey).Spreadsheet,
        (0, $7mBSb.TypeFilterValueKey).Presentation
    ],
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["googleDriveConfig"] = $fa5664d18fa736c2$export$6634ddcb22ed69a;

});

parcelRegister("bM2Mh", function(module, exports) {

var $6sPwH = parcelRequire("6sPwH");

const $adcaadfae616c53d$export$be326f2f9a08a3a4 = {
    displayName: 'Google Calendar',
    id: 'google-calendar',
    resourceType: 'google-calendar-connector',
    icon: (0, $6sPwH.default),
    integrationAri: 'ari:cloud:platform::integration/google-calendar',
    requiresOauth: true,
    // TODO: >>>> QS-5465: Uncomment when calendar nouns are ready to be ingested
    typeFilterValues: [],
    // typeFilterValues: [TypeFilterValueKey.Calendar],
    // fg('enable_3p_search_google_calendar') => false
    isEnabled: ()=>false
};
module.exports["googleCalendarConfig"] = $adcaadfae616c53d$export$be326f2f9a08a3a4;

});

parcelRegister("7OwWa", function(module, exports) {

var $7mBSb = parcelRequire("7mBSb");


var $c7WVa = parcelRequire("c7WVa");

const $4193a5eabb88d389$export$9cb908560d4a0a78 = {
    displayName: 'Loom',
    id: 'loom',
    icon: (0, $c7WVa.LoomIcon),
    integrationAri: 'ari:cloud:platform::integration/loom',
    typeFilterValues: [
        (0, $7mBSb.TypeFilterValueKey).Video
    ],
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true
};
module.exports["loomConfig"] = $4193a5eabb88d389$export$9cb908560d4a0a78;

});

parcelRegister("ckAAF", function(module, exports) {

var $7mBSb = parcelRequire("7mBSb");


var $hy7mW = parcelRequire("hy7mW");


var $gQ6Bq = parcelRequire("gQ6Bq");

const $f65cde570b3e36bf$export$b11bada05d439596 = {
    displayName: 'Miro',
    id: 'miro',
    resourceType: 'miro-connector',
    icon: (0, $hy7mW.MiroIcon),
    searchResultIcon: (0, $gQ6Bq.MiroFilterIcon),
    integrationAri: 'ari:cloud:platform::integration/miro',
    typeFilterValues: [
        (0, $7mBSb.TypeFilterValueKey).Design
    ],
    filters: [
        'lastUpdated'
    ],
    requiresOauth: false,
    isEnabled: ()=>true
};
module.exports["miroConfig"] = $f65cde570b3e36bf$export$b11bada05d439596;

});

parcelRegister("iElCD", function(module, exports) {

var $7mBSb = parcelRequire("7mBSb");


var $IzNHb = parcelRequire("IzNHb");


var $kqu9k = parcelRequire("kqu9k");

const $055ea2fa9745f7b7$export$ddf7404f556e473a = {
    displayName: 'Notion',
    id: 'notion',
    resourceType: 'notion-connector',
    icon: (0, $kqu9k.NotionFilterIcon),
    searchResultIcon: (0, $IzNHb.NotionIcon),
    integrationAri: 'ari:cloud:platform::integration/notion',
    typeFilterValues: [
        (0, $7mBSb.TypeFilterValueKey).Document
    ],
    requiresOauth: true,
    isEnabled: ()=>false
};
module.exports["notionConfig"] = $055ea2fa9745f7b7$export$ddf7404f556e473a;

});

parcelRegister("i6qjN", function(module, exports) {

var $7mBSb = parcelRequire("7mBSb");


var $6RO5S = parcelRequire("6RO5S");

const $03a68701aba5ef12$export$b3b3a7aaf94fe09 = {
    displayName: 'OneDrive',
    id: 'onedrive',
    resourceType: 'onedrive-connector',
    icon: (0, $6RO5S.OneDriveIcon),
    integrationAri: 'ari:cloud:platform::integration/onedrive',
    typeFilterValues: [
        (0, $7mBSb.TypeFilterValueKey).Document,
        (0, $7mBSb.TypeFilterValueKey).Spreadsheet,
        (0, $7mBSb.TypeFilterValueKey).Presentation
    ],
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["oneDriveConfig"] = $03a68701aba5ef12$export$b3b3a7aaf94fe09;

});

parcelRegister("gwQPM", function(module, exports) {

var $lTHwu = parcelRequire("lTHwu");

const $1635259603efafc8$export$3e5044818f2e9ef3 = {
    displayName: 'Outlook Calendar',
    id: 'outlook-calendar',
    resourceType: 'outlook-connector',
    icon: (0, $lTHwu.OutlookCalendarIcon),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    // TODO: >>>> QS-5465: Uncomment when calendar nouns are ready to be ingested
    typeFilterValues: [],
    // typeFilterValues: [TypeFilterValueKey.Calendar],
    requiresOauth: true,
    isEnabled: ()=>false
};
module.exports["outlookCalendarConfig"] = $1635259603efafc8$export$3e5044818f2e9ef3;

});

parcelRegister("kMXgf", function(module, exports) {

var $7mBSb = parcelRequire("7mBSb");


var $1gvAG = parcelRequire("1gvAG");


var $b4FVC = parcelRequire("b4FVC");

const $9cdfa15061ead352$export$eb46bb6c4f0e628c = {
    displayName: 'Microsoft Sharepoint',
    id: 'sharepoint',
    resourceType: 'ai-3p-connector:sharepoint-domain',
    icon: (0, $1gvAG.SharePointIcon),
    searchResultIcon: (0, $b4FVC.SharePointSearchResultIcon),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterValues: [
        (0, $7mBSb.TypeFilterValueKey).Document,
        (0, $7mBSb.TypeFilterValueKey).Spreadsheet,
        (0, $7mBSb.TypeFilterValueKey).Presentation
    ],
    filters: [
        'lastUpdated',
        'onlyTitleMatch'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["sharepointConfig"] = $9cdfa15061ead352$export$eb46bb6c4f0e628c;

});

parcelRegister("jB3tf", function(module, exports) {

var $7mBSb = parcelRequire("7mBSb");


var $77KdG = parcelRequire("77KdG");


var $i26Jf = parcelRequire("i26Jf");

const $6515febe2a5aa88b$export$c33894e475506863 = {
    displayName: 'Slack',
    id: 'slack',
    resourceType: 'ai-3p-connector:slack-workspace',
    icon: (0, $77KdG.SlackIcon),
    searchResultIcon: (0, $i26Jf.SlackSearchResultIcon),
    integrationAri: 'ari:cloud:platform::integration/slack',
    typeFilterValues: [
        (0, $7mBSb.TypeFilterValueKey).Conversation,
        (0, $7mBSb.TypeFilterValueKey).Message
    ],
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["slackConfig"] = $6515febe2a5aa88b$export$c33894e475506863;

});

parcelRegister("QUygY", function(module, exports) {

var $7mBSb = parcelRequire("7mBSb");


var $dHucp = parcelRequire("dHucp");


var $97rBY = parcelRequire("97rBY");

const $d4b8178085293a09$export$a579e078acf13bef = {
    displayName: 'Teams',
    id: 'teams',
    resourceType: 'microsoft-teams-connector',
    icon: (0, $dHucp.TeamsIcon),
    searchResultIcon: (0, $97rBY.TeamsSearchResultIcon),
    integrationAri: 'ari:cloud:platform::integration/microsoft',
    typeFilterValues: [
        (0, $7mBSb.TypeFilterValueKey).Conversation,
        (0, $7mBSb.TypeFilterValueKey).Message
    ],
    filters: [
        'lastUpdated'
    ],
    requiresOauth: true,
    isEnabled: ()=>true
};
module.exports["teamsConfig"] = $d4b8178085293a09$export$a579e078acf13bef;

});

parcelRegister("7DGGZ", function(module, exports) {

var $7mBSb = parcelRequire("7mBSb");


var $djVXt = parcelRequire("djVXt");

const $036af25d46c34349$export$74a2db0a5eb2da3f = {
    displayName: 'Zendesk',
    id: 'zendesk',
    icon: (0, $djVXt.default),
    integrationAri: 'ari:cloud:platform::integration/zendesk',
    typeFilterValues: [
        (0, $7mBSb.TypeFilterValueKey).WorkItem
    ],
    requiresOauth: true,
    isEnabled: ()=>false
};
module.exports["zendeskConfig"] = $036af25d46c34349$export$74a2db0a5eb2da3f;

});

parcelRegister("duanB", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $c86cef71ebbaff05$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    controlKey: {
        id: "dynamic-cards-search-page.icons.control-key",
        defaultMessage: "Ctrl"
    },
    googleCalendarLabel: {
        id: "dynamic-cards-search-page.icons.google-calendar-label",
        defaultMessage: "Google Calendar"
    }
});
module.exports["messages"] = $c86cef71ebbaff05$export$defe85febe8b728c;

});

parcelRegister("6JNBT", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $3LdwA = parcelRequire("3LdwA");

const $4519da42049d0993$var$MAX_SITES_INITIAL_QUERY = 3;
const $4519da42049d0993$var$limitToMaxSiteUsage = (sites = [])=>{
    return sites.slice(0, $4519da42049d0993$var$MAX_SITES_INITIAL_QUERY);
};
class $4519da42049d0993$var$AggregatorClient {
    async getAutoCorrection({ query: query }) {
        const cloudId = this.cloudId;
        // The language is hardcoded to 'en' as the backend does not support other languages
        // Also the frontend only auto corrects in English locale
        const body = {
            query: query,
            language: 'en',
            cloudId: cloudId
        };
        const response = await this.makePostRequest($4519da42049d0993$var$AggregatorClient.AUTO_CORRECT_API_URL, body);
        return response.fullCorrection;
    }
    async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [] }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : $4519da42049d0993$var$limitToMaxSiteUsage(this.siteMasterList).map((site)=>site.cloudId);
        const body = {
            query: query,
            cloudId: cloudId,
            limit: resultLimit,
            scopes: scopes,
            filters: filters,
            searchSession: context,
            ...modelParams.length > 0 ? {
                modelParams: modelParams
            } : {},
            experience: experience,
            cloudIds: cloudIdsToFilterOn
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $3LdwA.timed)(this.makePostRequest($4519da42049d0993$var$AggregatorClient.QUICKSEARCH_API_URL, body));
        return {
            response: {
                rawData: response,
                retrieveScope: (scope)=>// @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                    response.scopes.find((s)=>s.id === scope) || null
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $dwp40.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
    }
}
$4519da42049d0993$var$AggregatorClient.QUICKSEARCH_API_URL = 'quicksearch/v1';
$4519da42049d0993$var$AggregatorClient.AUTO_CORRECT_API_URL = 'autocorrect';
const $4519da42049d0993$export$5d730b7aed1a3eb0 = ({ cloudId: cloudId, aggregatorUrl: aggregatorUrl, aggregatorHostName: aggregatorHostName })=>{
    const aggregatorClient = new $4519da42049d0993$var$AggregatorClient({
        cloudId: cloudId,
        url: aggregatorUrl || `${aggregatorHostName || ''}/gateway/api/xpsearch-aggregator`,
        siteMasterList: []
    });
    async function getAutoCorrection({ query: query }) {
        return aggregatorClient.getAutoCorrection({
            query: query
        });
    }
    async function search({ query: query, scopes: scopes, resultLimit: resultLimit, analytics: analytics, sites: sites = [] }) {
        return aggregatorClient.search({
            query: query,
            context: {
                sessionId: analytics.sessionId ? analytics.sessionId : 'not-applicable',
                referrerId: null
            },
            scopes: scopes,
            modelParams: [],
            resultLimit: resultLimit,
            filters: [],
            experience: `external-${analytics.identifier}`,
            sites: sites
        });
    }
    return {
        search: search,
        getAutoCorrection: getAutoCorrection
    };
};
module.exports["createClient"] = $4519da42049d0993$export$5d730b7aed1a3eb0;

});

parcelRegister("9NrbM", function(module, exports) {

var $4mTS8 = parcelRequire("4mTS8");


var $1EqNn = parcelRequire("1EqNn");

const $df4b77d6f4ea9f46$export$69a3209f1a06c04d = (0, $1EqNn.inMemoryCache)();
const $df4b77d6f4ea9f46$var$GQL_OPERATION_NAME = 'SearchPageUserQuery';
const $df4b77d6f4ea9f46$var$getUserQuery = ()=>`
query ${$df4b77d6f4ea9f46$var$GQL_OPERATION_NAME}($accountId: ID!) {
  user(accountId: $accountId) {
    id
    accountId
    name
    picture
  }
}
`;
const $df4b77d6f4ea9f46$export$25f4d46d5dabadfc = (accountId)=>{
    return $df4b77d6f4ea9f46$export$69a3209f1a06c04d.inMemoryDecorator(accountId, async ()=>{
        const response = await (0, $4mTS8.fetchAgg)({
            graphQuery: $df4b77d6f4ea9f46$var$getUserQuery(),
            variables: {
                accountId: accountId
            },
            operationName: $df4b77d6f4ea9f46$var$GQL_OPERATION_NAME
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
const $df4b77d6f4ea9f46$export$c3d7afa7f49d431e = (0, $1EqNn.inMemoryCache)();
const $df4b77d6f4ea9f46$var$GQL_USERS_OPERATION_NAME = 'SearchPageUsersQuery';
const $df4b77d6f4ea9f46$var$getUsersQuery = ()=>`
query ${$df4b77d6f4ea9f46$var$GQL_USERS_OPERATION_NAME}($accountIds: [ID!]!) {
  users(accountIds: $accountIds) {
    id
    name
    picture
    accountId
  }
}
`;
const $df4b77d6f4ea9f46$export$ef7fb495aeba8901 = (accountIds)=>{
    return $df4b77d6f4ea9f46$export$c3d7afa7f49d431e.inMemoryDecorator(// TODO: >>>> Limit this to a max string length
    // TODO: Refactor so that it can cache per user id
    accountIds.join(','), async ()=>{
        const response = await (0, $4mTS8.fetchAgg)({
            graphQuery: $df4b77d6f4ea9f46$var$getUsersQuery(),
            variables: {
                accountIds: accountIds
            },
            operationName: $df4b77d6f4ea9f46$var$GQL_USERS_OPERATION_NAME
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["userQuery"] = $df4b77d6f4ea9f46$export$25f4d46d5dabadfc;
module.exports["usersQuery"] = $df4b77d6f4ea9f46$export$ef7fb495aeba8901;

});

parcelRegister("e2xgH", function(module, exports) {

var $4sOnC = parcelRequire("4sOnC");


var $7tL1u = parcelRequire("7tL1u");

const $c1a49f3ec17b55f6$export$ac822ab68badd883 = ({ filterId: filterId })=>{
    const [state, storeActions] = (0, $7tL1u.useSelectFilterStore)({
        filterId: filterId
    });
    const viewActions = {
        setOption: (option, customValue)=>{
            const options = Array.isArray(option) ? option : [
                option
            ];
            const optionChange = options.map((option)=>({
                    value: option.value,
                    isSelected: !option.isSelected
                }));
            return storeActions.setSelectFilterOption({
                filterId: filterId,
                optionChange: optionChange,
                customValue: customValue
            });
        },
        loadInitialOptions: ()=>storeActions.loadInitialSelectFilterOptions({
                filterId: filterId
            }),
        setLookupInput: (query)=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: query
            }),
        clearLookupInput: ()=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: ''
            }),
        clearOptions: ()=>storeActions.clearSelectFilterOptions({
                filterId: filterId
            })
    };
    if (!state) return [
        ,
        viewActions
    ];
    const viewState = {
        defaultIsOpen: state.alwaysVisible === false,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        isLookupDefined: state.lookup.isDefined,
        isLoading: // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        state.queryParams.isLoading || state.initialOptions.isLoading || state.lookup.isLoading,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        lookupInput: state.lookup.input,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        options: state.options,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        suggestedOptions: state.options.filter((option)=>!option.isSelected && option.isSuggested),
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        selectedOptions: state.selectedOptions,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        isLookupActive: state.lookup.isActive,
        alwaysVisible: state.alwaysVisible,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        customValue: state.customValue
    };
    return [
        viewState,
        viewActions
    ];
};
const $c1a49f3ec17b55f6$export$eb312ee1d3a7a748 = ({ filterId: filterId, optionsToProducts: optionsToProducts })=>{
    const [state, storeActions] = (0, $7tL1u.useSelectFilterStore)({
        filterId: filterId
    });
    const viewActions = {
        setOption: (option)=>{
            const options = Array.isArray(option) ? option : [
                option
            ];
            const optionChange = options.map((option)=>({
                    value: option.value,
                    isSelected: !option.isSelected
                }));
            return storeActions.setSelectFilterOption({
                filterId: filterId,
                optionChange: optionChange
            });
        },
        loadInitialOptions: ()=>storeActions.loadInitialSelectFilterOptions({
                filterId: filterId
            }),
        setLookupInput: (query)=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: query
            }),
        clearLookupInput: ()=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: ''
            }),
        clearOptions: ()=>storeActions.clearSelectFilterOptions({
                filterId: filterId
            })
    };
    if (!state) return [
        ,
        viewActions
    ];
    const selectedProductsAvailable = state.selectedProducts.length > 0;
    const products = selectedProductsAvailable ? state.selectedProducts : state.availableProducts;
    // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
    const filteredOptions = state.options.filter(// @ts-ignore - TS7006 TypeScript 5.9.2 upgrade
    (option)=>option.isDefault || option.isSelected || optionsToProducts[option.value]?.some((product)=>products.includes(product)))// This is a temporary hack to filter out Atlas specific types, unless Atlas is the selected product
    .filter(// @ts-ignore - TS7006 TypeScript 5.9.2 upgrade
    (option)=>!(state.selectedProducts[0] !== (0, $4sOnC.ProductKeys).Atlas && (option.value === 'goal' || option.value === 'tag')))// Filtering out all options that are tied exclusively to allFilterExcludedProducts for universal types
    // @ts-ignore - TS7006 TypeScript 5.9.2 upgrade
    .filter((option)=>!selectedProductsAvailable && optionsToProducts[option.value]?.length ? optionsToProducts[option.value].some((product)=>!state.allFilterExcludedProducts.includes(product)) : true);
    const viewState = {
        defaultIsOpen: state.alwaysVisible === false,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        isLookupDefined: state.lookup.isDefined,
        isLoading: // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        state.queryParams.isLoading || state.initialOptions.isLoading || state.lookup.isLoading,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        lookupInput: state.lookup.input,
        options: filteredOptions,
        // @ts-ignore - TS7006 TypeScript 5.9.2 upgrade
        suggestedOptions: filteredOptions.filter((option)=>!option.isSelected && option.isSuggested),
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        selectedOptions: state.selectedOptions,
        // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
        isLookupActive: state.lookup.isActive,
        alwaysVisible: state.alwaysVisible
    };
    return [
        viewState,
        viewActions
    ];
};
const $c1a49f3ec17b55f6$export$639eaf0f64f8fe4 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: $c1a49f3ec17b55f6$export$50fdfeece43146fd({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: $c1a49f3ec17b55f6$export$e2de15bbd9edf9c6({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: $c1a49f3ec17b55f6$export$7755017099c85a0d({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: $c1a49f3ec17b55f6$export$ad6c12f692e14555({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: $c1a49f3ec17b55f6$export$b2a7969df3fe0aa3({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: $c1a49f3ec17b55f6$export$69017055aa8b346e({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: $c1a49f3ec17b55f6$export$92164aa84e23cd67({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: $c1a49f3ec17b55f6$export$d2312e68e1f5ad00({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: $c1a49f3ec17b55f6$export$bf7199a9ebcb84a9({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: $c1a49f3ec17b55f6$export$d0f857db6e3e26d7({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $c1a49f3ec17b55f6$export$8e6bea29334a2099 = (type)=>{
    return type === 'single-select' || type === 'multi-select';
};
const $c1a49f3ec17b55f6$export$50fdfeece43146fd = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const filter = $c1a49f3ec17b55f6$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        const allOptions = filter.getOptions({
            isLookupActive: false
        });
        const newOptions = filter.getOptions({
            isLookupActive: state.lookup.isActive
        });
        const selectedOptions = allOptions.filter((option)=>option.isSelected);
        const newState = {
            ...state,
            options: newOptions,
            selectedOptions: selectedOptions,
            hasSelection: selectedOptions.length > 0,
            value: filter.getValue()
        };
        return newState;
    };
};
const $c1a49f3ec17b55f6$export$7755017099c85a0d = ({ initial: initial, state: state, config: config })=>{
    return async (queryParams, onStateChange)=>{
        const queryParamValues = queryParams[initial.queryParams.key];
        const filter = $c1a49f3ec17b55f6$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        if (!queryParamValues) {
            const clearedOptions = filter.clearOptions();
            onStateChange?.(clearedOptions.getState());
            return clearedOptions;
        }
        const allCurrentOptions = filter.getOptions({
            isLookupActive: false
        });
        const allQueryParamValues = allCurrentOptions.map((option)=>option.queryParamValue);
        const queryParamsToHydrate = queryParamValues.filter((value)=>!allQueryParamValues.includes(value));
        if (queryParamsToHydrate.length === 0) {
            const newOptions = allCurrentOptions.map((option)=>({
                    isSelected: queryParamValues.includes(option.queryParamValue),
                    value: option.value
                }));
            const filterWithNewOptions = filter.setOption(newOptions);
            onStateChange?.(filterWithNewOptions.getState());
            return filterWithNewOptions;
        }
        // At this point we need to hydrate the filters with new options from
        // the query params
        const newQueryParamOptions = [
            ...state.queryParams.options
        ];
        const fetcher = initial.queryParams.fetcher;
        if (fetcher) {
            onStateChange?.({
                ...state,
                queryParams: {
                    ...state.queryParams,
                    isLoading: true
                }
            });
            const fetchedOptions = await fetcher(queryParamsToHydrate, config);
            fetchedOptions.forEach((option)=>{
                const mappedOption = {
                    isSelected: true,
                    trackingKey: option.trackingKey,
                    value: option.value,
                    queryParamValue: option.queryParamValue,
                    isSuggested: false,
                    isDefault: option.isDefault ?? false,
                    avatarUrl: option.avatarUrl,
                    label: option.label
                };
                newQueryParamOptions.push(mappedOption);
            });
        }
        const selectedOptionsFromQueryParams = newQueryParamOptions.map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const selectedInitialOptionsFromQueryParams = [
            ...state.initialOptions.options
        ].map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const hydratedQueryParams = $c1a49f3ec17b55f6$export$639eaf0f64f8fe4({
            initial: initial,
            state: {
                ...state,
                queryParams: {
                    ...state.queryParams,
                    options: selectedOptionsFromQueryParams,
                    isLoading: false
                },
                initialOptions: {
                    ...state.initialOptions,
                    options: selectedInitialOptionsFromQueryParams
                }
            },
            config: config
        });
        onStateChange?.(hydratedQueryParams.getState());
        return hydratedQueryParams;
    };
};
const $c1a49f3ec17b55f6$export$e2de15bbd9edf9c6 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const queryParamValue = $c1a49f3ec17b55f6$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        }).getOptions({
            isLookupActive: false
        }).filter((option)=>option.isSelected).map((option)=>option.queryParamValue);
        return {
            [initial.queryParams.key]: queryParamValue
        };
    };
};
const $c1a49f3ec17b55f6$export$ad6c12f692e14555 = ({ initial: initial, state: state, config: config })=>{
    return async (onStateChange)=>{
        if (state.didMount) {
            const newDropdownState = {
                ...state
            };
            onStateChange?.(newDropdownState);
            return $c1a49f3ec17b55f6$export$639eaf0f64f8fe4({
                initial: initial,
                state: newDropdownState,
                config: config
            });
        }
        const newOptions = [
            ...state.initialOptions.options
        ];
        const fetcher = initial.initialOptions?.fetcher;
        if (fetcher) {
            const fetchingInitialOptionsState = {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    isLoading: true
                }
            };
            onStateChange?.(fetchingInitialOptionsState);
            try {
                const fetchedOptions = await fetcher(config);
                fetchedOptions.forEach((option)=>{
                    const mappedOption = {
                        isSelected: false,
                        trackingKey: option.trackingKey,
                        value: option.value,
                        queryParamValue: option.queryParamValue,
                        isSuggested: true,
                        isDefault: option.isDefault ?? false,
                        avatarUrl: option.avatarUrl,
                        label: option.label
                    };
                    newOptions.push(mappedOption);
                });
            } catch  {
                const fetchFailedState = {
                    ...state,
                    initialOptions: {
                        ...state.initialOptions,
                        isLoading: false
                    }
                };
                onStateChange?.(fetchFailedState);
            }
        }
        const newInitialOptionsState = {
            ...state,
            didMount: true,
            initialOptions: {
                ...state.initialOptions,
                options: newOptions,
                isLoading: false
            }
        };
        onStateChange?.(newInitialOptionsState);
        return $c1a49f3ec17b55f6$export$639eaf0f64f8fe4({
            initial: initial,
            state: newInitialOptionsState,
            config: config
        });
    };
};
const $c1a49f3ec17b55f6$export$d2312e68e1f5ad00 = ({ initial: initial, state: state })=>{
    return (options)=>{
        const allSelectedValues = new Set([
            ...state.queryParams.options.filter((option)=>option.isSelected).map((option)=>option.value),
            ...state.initialOptions.options.filter((option)=>option.isSelected).map((option)=>option.value),
            ...state.lookup.options.filter((lookupOption)=>lookupOption.isSelected).map((option)=>option.value)
        ]);
        if (options.isLookupActive) {
            const lookupResults = state.lookup.lookupResultOptions.map((option)=>({
                    ...option,
                    isSelected: allSelectedValues.has(option.value)
                }));
            return lookupResults;
        }
        const duplicateOptions = new Set();
        const newOptions = [
            ...state.queryParams.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // The 'interacted' options are persisted in  state.lookup.options
            ...state.lookup.options,
            ...state.initialOptions.options
        ].filter((option)=>!duplicateOptions.has(option.value) && duplicateOptions.add(option.value)).map((option)=>({
                ...option,
                isSelected: allSelectedValues.has(option.value)
            }));
        if (initial.sortCompareFn) return newOptions.sort(initial.sortCompareFn);
        return newOptions;
    };
};
const $c1a49f3ec17b55f6$export$b2a7969df3fe0aa3 = ({ initial: initial, state: state, config: config })=>{
    return (option)=>{
        const optionsToChange = Array.isArray(option) ? option : [
            option
        ];
        const optionsToChangeRecord = Object.fromEntries(optionsToChange.map((option)=>[
                option.value,
                option
            ]));
        const queryParamOptions = state.queryParams.options.map((option)=>{
            if (!optionsToChange.find((x)=>x.value === option.value)) return option;
            return {
                ...option,
                isSelected: optionsToChangeRecord[option.value]?.isSelected ?? false
            };
        });
        const initialOptions = state.initialOptions.options.map((option)=>{
            if (!optionsToChange.find((x)=>x.value === option.value)) return option;
            return {
                ...option,
                isSelected: optionsToChangeRecord[option.value]?.isSelected ?? false
            };
        });
        const duplicateOptions = new Set();
        const lookupOptions = [
            ...state.lookup.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // The 'interacted' options are persisted in  state.lookup.options
            ...state.lookup.lookupResultOptions.flatMap((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value)) return [];
                return [
                    option
                ];
            })
        ].filter((option)=>!duplicateOptions.has(option.value) && duplicateOptions.add(option.value)).map((option)=>({
                ...option,
                isSuggested: true,
                isSelected: optionsToChangeRecord[option.value]?.isSelected ?? option.isSelected
            }));
        return $c1a49f3ec17b55f6$export$639eaf0f64f8fe4({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                }
            },
            config: config
        });
    };
};
const $c1a49f3ec17b55f6$export$69017055aa8b346e = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const queryParamOptions = state.queryParams.options.map((option)=>{
            const isSuggested = state.initialOptions.options.find((x)=>x.value === option.value)?.isSuggested ?? false;
            return {
                ...option,
                isSuggested: isSuggested,
                isSelected: false
            };
        });
        const initialOptions = state.initialOptions.options.map((option)=>({
                ...option,
                isSelected: false
            }));
        const lookupOptions = state.lookup.options.map((option)=>({
                ...option,
                isSelected: false
            }));
        return $c1a49f3ec17b55f6$export$639eaf0f64f8fe4({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                }
            },
            config: config
        });
    };
};
const $c1a49f3ec17b55f6$export$92164aa84e23cd67 = ({ initial: initial, state: state, config: config })=>{
    return async (query, onStateChange)=>{
        if (!initial.lookup || query.length === 0 || state.lookup.input === query) {
            const noQueryState = {
                ...state,
                lookup: {
                    ...state.lookup,
                    input: query,
                    isLoading: false,
                    isActive: false
                }
            };
            onStateChange?.(noQueryState);
            return $c1a49f3ec17b55f6$export$639eaf0f64f8fe4({
                initial: initial,
                state: noQueryState,
                config: config
            });
        }
        const fetchingLookupOptionsState = {
            ...state,
            lookup: {
                ...state.lookup,
                input: query,
                isLoading: true,
                isActive: true
            }
        };
        onStateChange?.(fetchingLookupOptionsState);
        try {
            const fetchedLookupOptions = await initial.lookup.fetcher(query, config);
            const newLookupOptions = fetchedLookupOptions.map((option)=>{
                const mappedOption = {
                    isSelected: false,
                    trackingKey: option.trackingKey,
                    value: option.value,
                    queryParamValue: option.queryParamValue,
                    isSuggested: false,
                    isDefault: option.isDefault ?? false,
                    avatarUrl: option.avatarUrl,
                    label: option.label
                };
                return mappedOption;
            });
            const newLookupOptionsState = {
                ...state,
                lookup: {
                    ...state.lookup,
                    input: query,
                    lookupResultOptions: newLookupOptions,
                    isLoading: false,
                    isActive: true
                }
            };
            onStateChange?.(newLookupOptionsState);
            return $c1a49f3ec17b55f6$export$639eaf0f64f8fe4({
                initial: initial,
                state: newLookupOptionsState,
                config: config
            });
        } catch  {
            const failedLookupOptionsState = {
                ...state,
                lookup: {
                    ...state.lookup,
                    input: query,
                    isLoading: false,
                    isActive: true
                }
            };
            onStateChange?.(failedLookupOptionsState);
            return $c1a49f3ec17b55f6$export$639eaf0f64f8fe4({
                initial: initial,
                state: failedLookupOptionsState,
                config: config
            });
        }
    };
};
const $c1a49f3ec17b55f6$export$bf7199a9ebcb84a9 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        return $c1a49f3ec17b55f6$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        }).getOptions({
            isLookupActive: false
        }).filter((option)=>option.isSelected).map((option)=>option.value);
    };
};
const $c1a49f3ec17b55f6$export$d0f857db6e3e26d7 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const filter = $c1a49f3ec17b55f6$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        const allOptions = [
            ...filter.getOptions({
                isLookupActive: true
            }),
            ...filter.getOptions({
                isLookupActive: false
            })
        ].map((option)=>({
                value: option.value,
                isSelected: false
            }));
        return filter.setOption(allOptions);
    };
};
module.exports["useSelectFilter"] = $c1a49f3ec17b55f6$export$ac822ab68badd883;
module.exports["useUniversalSelectFilter"] = $c1a49f3ec17b55f6$export$eb312ee1d3a7a748;
module.exports["getState"] = $c1a49f3ec17b55f6$export$50fdfeece43146fd;
module.exports["getQueryParams"] = $c1a49f3ec17b55f6$export$e2de15bbd9edf9c6;
module.exports["setQueryParams"] = $c1a49f3ec17b55f6$export$7755017099c85a0d;
module.exports["loadInitialOptions"] = $c1a49f3ec17b55f6$export$ad6c12f692e14555;
module.exports["setOption"] = $c1a49f3ec17b55f6$export$b2a7969df3fe0aa3;
module.exports["clearOptions"] = $c1a49f3ec17b55f6$export$69017055aa8b346e;
module.exports["setLookupInput"] = $c1a49f3ec17b55f6$export$92164aa84e23cd67;
module.exports["getOptions"] = $c1a49f3ec17b55f6$export$d2312e68e1f5ad00;
module.exports["getValue"] = $c1a49f3ec17b55f6$export$bf7199a9ebcb84a9;
module.exports["deselectOptions"] = $c1a49f3ec17b55f6$export$d0f857db6e3e26d7;
module.exports["isSelectFilter"] = $c1a49f3ec17b55f6$export$8e6bea29334a2099;

});

parcelRegister("405LB", function(module, exports) {

var $e2xgH = parcelRequire("e2xgH");

const $4d5ef8c9839ca6d5$export$9c05e038f495cba8 = (initial)=>{
    const initialState = Object.freeze({
        id: initial.id,
        type: 'multi-select',
        didMount: false,
        hasSelection: false,
        alwaysVisible: initial.alwaysVisible,
        universal: initial.universal,
        queryParams: {
            isLoading: false,
            options: []
        },
        lookup: {
            isLoading: false,
            isActive: false,
            isDefined: !!initial.lookup,
            options: [],
            lookupResultOptions: [],
            input: ''
        },
        initialOptions: {
            options: [],
            isLoading: false
        },
        options: [],
        selectedOptions: [],
        value: [],
        products: initial.products
    });
    return {
        id: initial.id,
        type: initialState.type,
        queryParams: {
            key: initial.queryParams.key
        },
        products: initial.products,
        universal: initial.universal,
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$4d5ef8c9839ca6d5$export$63027158d47e5479({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$4d5ef8c9839ca6d5$export$63027158d47e5479({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (filterState)=>{
            return filterState?.id === initial.id;
        },
        isSupportCustomValue: false
    };
};
const $4d5ef8c9839ca6d5$export$63027158d47e5479 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: (0, $e2xgH.getState)({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: (0, $e2xgH.getQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: (0, $e2xgH.setQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: (0, $e2xgH.loadInitialOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: (0, $e2xgH.setOption)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: (0, $e2xgH.clearOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: (0, $e2xgH.setLookupInput)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $e2xgH.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: (0, $e2xgH.getValue)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: (0, $e2xgH.deselectOptions)({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
module.exports["createMultiSelectFilter"] = $4d5ef8c9839ca6d5$export$9c05e038f495cba8;

});

parcelRegister("i37tO", function(module, exports) {

var $4mTS8 = parcelRequire("4mTS8");


var $gtxdb = parcelRequire("gtxdb");


var $1EqNn = parcelRequire("1EqNn");

const $c8716099b9bec011$var$operationName = 'FPSConfluenceSmartUsersQuery';
const $c8716099b9bec011$var$SmartsRecommendedUserQuery = `
query ${$c8716099b9bec011$var$operationName}($userId: String!, $tenantId: String!, $maxNumberOfResults: Int!) {
  smarts {
    results: recommendedUser(
      recommendationsQuery: {
        context: {
          userId: $userId
          tenantId: $tenantId
          product: "confluence"
        },
        modelRequestParams: {
          caller: "full-page-search"
          experience: "CgUserNearbyUser"
        }
        requestingUserId: $userId
        maxNumberOfResults: $maxNumberOfResults
      }
    ) {
      id
      user {
        accountId
        name
        picture
      }
    }
  }
}
`;
const $c8716099b9bec011$export$69a3209f1a06c04d = (0, $1EqNn.inMemoryCache)();
// Expire the cache if there are errors or edges are empty
const $c8716099b9bec011$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    const { results: results } = data.smarts;
    return !results || results.length === 0;
};
const $c8716099b9bec011$export$74adda2a74e06fa9 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl })=>$c8716099b9bec011$export$69a3209f1a06c04d.inMemoryDecorator((0, $gtxdb.generateHashFromVariables)(variables), ()=>(0, $4mTS8.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: $c8716099b9bec011$var$SmartsRecommendedUserQuery,
            operationName: $c8716099b9bec011$var$operationName
        }), $c8716099b9bec011$var$expireWhen);
module.exports["smartsRecommendedUserQuery"] = $c8716099b9bec011$export$74adda2a74e06fa9;

});

parcelRegister("lg8Ws", function(module, exports) {
/**
 * Instead of enum types for ResultType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $c83095eb37fba8e8$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["JiraIssue"] = "jira.issue";
    Scope["JiraPlan"] = "jira.plan";
    Scope["JiraDashboard"] = "jira.dashboard";
    Scope["JiraIssueDashboardBoardProjectFilter"] = "jira.issue,dashboard,board,project,filter";
    Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
    Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
    Scope["JiraProject"] = "jira.project";
    Scope["People"] = "urs.user-jira";
    return Scope;
}({});
var $c83095eb37fba8e8$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["JiraIssue"] = "jira-issue";
    ContentType["JiraDashboard"] = "jira-dashboard";
    ContentType["JiraBoard"] = "jira-board";
    ContentType["JiraProject"] = "jira-project";
    ContentType["JiraFilter"] = "jira-filter";
    ContentType["JiraPlan"] = "jira-plan";
    ContentType["JiraPeople"] = "jira-people";
    return ContentType;
}({});
function $c83095eb37fba8e8$export$b3b8cefe01df28d2(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
function $c83095eb37fba8e8$export$496f9fe01bbac92b(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
var $c83095eb37fba8e8$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType["issue"] = "issue";
    AttributeType["dashboard"] = "dashboard";
    AttributeType["board"] = "board";
    AttributeType["project"] = "project";
    AttributeType["filter"] = "filter";
    AttributeType["plan"] = "plan";
    AttributeType["people"] = "people";
    return AttributeType;
}({});
module.exports["Scope"] = $c83095eb37fba8e8$export$775b6bb06e53a214;

});

parcelRegister("5aC84", function(module, exports) {

var $4mTS8 = parcelRequire("4mTS8");


var $gtxdb = parcelRequire("gtxdb");


var $1EqNn = parcelRequire("1EqNn");

const $fc933e1d85c3a46e$var$operationName = 'SearchEntitiesQuery';
const $fc933e1d85c3a46e$var$getSearchEntitiesQuery = ({ includeSpaceKey: includeSpaceKey })=>{
    const SearchConfluenceSpace = `
    ... on SearchConfluenceSpace {
      key
    }
  `;
    return `
  query ${$fc933e1d85c3a46e$var$operationName}($experience: String!, $query: String!, $first: Int, $filters: SearchFilterInput!) {
    search {
      results: search(
        experience: $experience
        query: $query
        first: $first
        filters: $filters
      ) {
        edges {
          node {
            id
            title
            type
            url
            iconUrl
            ${includeSpaceKey ? SearchConfluenceSpace : ``}
          }
        }
      }
    }
  }
  `;
};
const $fc933e1d85c3a46e$export$69a3209f1a06c04d = (0, $1EqNn.inMemoryCache)();
// Expire the cache if there are errors or edges are empty
const $fc933e1d85c3a46e$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    return data.search?.results.edges.length === 0;
};
const $fc933e1d85c3a46e$export$98f1867fd4cb2c65 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, includeSpaceKey: includeSpaceKey })=>$fc933e1d85c3a46e$export$69a3209f1a06c04d.inMemoryDecorator((0, $gtxdb.generateHashFromVariables)(variables), ()=>(0, $4mTS8.fetchAgg)({
            variables: {
                first: 20,
                experience: '',
                ...variables
            },
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: $fc933e1d85c3a46e$var$getSearchEntitiesQuery({
                includeSpaceKey: includeSpaceKey
            }),
            operationName: $fc933e1d85c3a46e$var$operationName
        }), $fc933e1d85c3a46e$var$expireWhen);
module.exports["searchEntitiesQuery"] = $fc933e1d85c3a46e$export$98f1867fd4cb2c65;

});

parcelRegister("fjZo5", function(module, exports) {

var $7tL1u = parcelRequire("7tL1u");

const $399ae3605c00543d$export$c97cd60200241832 = ({ filterId: filterId })=>{
    const [state, storeActions] = (0, $7tL1u.useBooleanFilterStore)({
        filterId: filterId
    });
    const viewActions = {
        toggle: ()=>{
            if (!state) return;
            storeActions.setBooleanFilterValue({
                filterId: filterId,
                value: !state.value
            });
        }
    };
    if (!state) return [
        ,
        viewActions
    ];
    const viewState = {
        value: state.value,
        autoFocus: state.alwaysVisible === false
    };
    return [
        viewState,
        viewActions
    ];
};
const $399ae3605c00543d$export$2963583aeb05fcae = (initial)=>{
    const initialState = {
        ...initial,
        type: 'boolean',
        value: false,
        hasSelection: false,
        universal: initial.universal
    };
    return {
        id: initial.id,
        type: initialState.type,
        products: initial.products,
        universal: initial.universal,
        queryParams: {
            key: initialState.queryParams.key
        },
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$399ae3605c00543d$export$cd193ee4357dee7f({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$399ae3605c00543d$export$cd193ee4357dee7f({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (filterState)=>{
            return filterState?.id === initial.id;
        },
        isSupportCustomValue: false
    };
};
const $399ae3605c00543d$export$cd193ee4357dee7f = ({ initial: initial, state: state, config: config })=>{
    const filterState = {
        ...state,
        hasSelection: state.value
    };
    return {
        ...filterState,
        setValue: $399ae3605c00543d$var$setValue({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: ()=>filterState.value,
        getState: ()=>filterState,
        queryParams: {
            key: initial.queryParams.key,
            get: $399ae3605c00543d$var$getQueryParams({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: $399ae3605c00543d$var$setQueryParams({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        clear: $399ae3605c00543d$var$clear({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $399ae3605c00543d$var$setValue = ({ initial: initial, state: state, config: config })=>{
    return (value)=>{
        const newState = {
            ...state,
            value: value,
            hasSelection: value
        };
        return $399ae3605c00543d$export$cd193ee4357dee7f({
            initial: initial,
            state: newState,
            config: config
        });
    };
};
const $399ae3605c00543d$var$getQueryParams = ({ initial: initial, state: state })=>{
    return ()=>({
            [initial.queryParams.key]: state.value === true ? [
                'true'
            ] : undefined
        });
};
const $399ae3605c00543d$var$setQueryParams = ({ initial: initial, state: state, config: config })=>{
    return async (queryParams)=>{
        const queryParamValue = queryParams[initial.queryParams.key];
        const booleanValue = queryParamValue?.at(0) === 'true' ? true : false;
        return $399ae3605c00543d$export$cd193ee4357dee7f({
            initial: initial,
            state: {
                ...state,
                value: booleanValue,
                hasSelection: booleanValue
            },
            config: config
        });
    };
};
const $399ae3605c00543d$var$clear = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const filter = $399ae3605c00543d$export$cd193ee4357dee7f({
            initial: initial,
            state: state,
            config: config
        });
        return filter.setValue(false);
    };
};
module.exports["useBooleanFilter"] = $399ae3605c00543d$export$c97cd60200241832;
module.exports["createBooleanFilter"] = $399ae3605c00543d$export$2963583aeb05fcae;

});

parcelRegister("h7ecj", function(module, exports) {

var $e2xgH = parcelRequire("e2xgH");

const $a2e27bcd8ae80945$export$b77715d04a87c12b = (initial)=>{
    const initialState = Object.freeze({
        id: initial.id,
        type: 'single-select',
        didMount: false,
        hasSelection: false,
        alwaysVisible: initial.alwaysVisible,
        universal: initial.universal,
        queryParams: {
            isLoading: false,
            options: []
        },
        lookup: {
            isLoading: false,
            isActive: false,
            isDefined: !!initial.lookup,
            options: [],
            lookupResultOptions: [],
            input: ''
        },
        initialOptions: {
            options: [],
            isLoading: false
        },
        options: [],
        selectedOptions: [],
        value: [],
        products: initial.products
    });
    return {
        id: initial.id,
        type: initialState.type,
        queryParams: {
            key: initial.queryParams.key
        },
        products: initial.products,
        universal: initial.universal,
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$a2e27bcd8ae80945$export$767f444f15b8d660({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$a2e27bcd8ae80945$export$767f444f15b8d660({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (filterState)=>{
            return filterState?.id === initial.id;
        },
        isSupportCustomValue: false
    };
};
const $a2e27bcd8ae80945$export$767f444f15b8d660 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: (0, $e2xgH.getState)({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: (0, $e2xgH.getQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: (0, $e2xgH.setQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: (0, $e2xgH.loadInitialOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: $a2e27bcd8ae80945$export$b2a7969df3fe0aa3({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: (0, $e2xgH.clearOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: (0, $e2xgH.setLookupInput)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $e2xgH.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: (0, $e2xgH.getValue)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: (0, $e2xgH.deselectOptions)({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $a2e27bcd8ae80945$var$updateOptionState = (props)=>(option)=>{
        if (option.isDefault) return {
            ...option,
            isSelected: false
        };
        return {
            ...option,
            isSelected: props.firstSelectedOption?.value === option.value
        };
    };
const $a2e27bcd8ae80945$export$b2a7969df3fe0aa3 = ({ initial: initial, state: state, config: config })=>{
    return (option)=>{
        // Theoretically this should only ever give you one option to change
        const optionsToChange = Array.isArray(option) ? option : [
            option
        ];
        const firstSelectedOption = optionsToChange.at(0);
        const isOptionAlreadySelected = state.options.filter((x)=>x.isSelected).find((x)=>x.value === firstSelectedOption?.value);
        if (isOptionAlreadySelected) // do nothing
        return $a2e27bcd8ae80945$export$767f444f15b8d660({
            initial: initial,
            state: state,
            config: config
        });
        const queryParamOptions = state.queryParams.options.map($a2e27bcd8ae80945$var$updateOptionState({
            optionsToChange: optionsToChange,
            firstSelectedOption: firstSelectedOption
        }));
        const initialOptions = state.initialOptions.options.map($a2e27bcd8ae80945$var$updateOptionState({
            optionsToChange: optionsToChange,
            firstSelectedOption: firstSelectedOption
        }));
        const lookupOptions = [
            ...state.lookup.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // These 'interacted' options need to be persisted if a user wants to select them again
            ...state.lookup.lookupResultOptions.flatMap((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value)) return [];
                return [
                    option
                ];
            })
        ].map($a2e27bcd8ae80945$var$updateOptionState({
            optionsToChange: optionsToChange,
            firstSelectedOption: firstSelectedOption
        }));
        return $a2e27bcd8ae80945$export$767f444f15b8d660({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                }
            },
            config: config
        });
    };
};
module.exports["createSingleSelectFilter"] = $a2e27bcd8ae80945$export$b77715d04a87c12b;

});

parcelRegister("1L9Cd", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $7mBSb = parcelRequire("7mBSb");


var $4sOnC = parcelRequire("4sOnC");


var $7tGzv = parcelRequire("7tGzv");


var $k6Hr4 = parcelRequire("k6Hr4");


var $4d6KB = parcelRequire("4d6KB");

const $43cda8fbd603265b$var$isProductEntitiesIncluded = (availableProducts, product, outboundAuthConfigs)=>{
    if (!(0, $4sOnC.products)[product]) return false;
    else if ((0, $4sOnC.products)[product]?.is3P) return availableProducts.includes(product) && !outboundAuthConfigs[product]?.userNeedsOAuth;
    else return availableProducts.includes(product);
};
const $43cda8fbd603265b$export$cf63d35399eb18ae = (query, config)=>{
    const allOptions = $43cda8fbd603265b$export$b220eb3fbdd854af(config);
    const matchingOptions = allOptions.filter((option)=>$43cda8fbd603265b$export$e902a1c7f3216533(query, option.label)).map((option)=>({
            label: option.label,
            trackingKey: option.value,
            value: option.value,
            queryParamValue: option.queryParamValue,
            isDefault: option.isDefault
        }));
    return matchingOptions;
};
const $43cda8fbd603265b$export$e085e94f90daa6c8 = (products, selectedTypes, outboundAuthConfigs, availableProducts)=>{
    if ((0, $dh538.fg)('confluence_performance_improve_search_query')) return $43cda8fbd603265b$export$d9f0dc47e74a61d2({
        products: products,
        selectedTypes: selectedTypes,
        outboundAuthConfigs: outboundAuthConfigs,
        availableProducts: availableProducts
    });
    const selectedEntities = new Set();
    const unselectedEntities = new Set();
    const types = selectedTypes.length === 0 ? (0, $7mBSb.allTypeFilterValueKeys) : selectedTypes;
    const typeMapping = (0, $k6Hr4.getTypeMapping)();
    const otherProducts = availableProducts.filter((product)=>!products.includes(product));
    types.forEach((type)=>{
        const productToEntityMap = typeMapping[type].entities;
        products.forEach((product)=>{
            if ($43cda8fbd603265b$var$isProductEntitiesIncluded(products, product, outboundAuthConfigs)) productToEntityMap[product]?.forEach((ati)=>selectedEntities.add(ati));
        });
        // collect unselected entities
        otherProducts.forEach((product)=>{
            if ($43cda8fbd603265b$var$isProductEntitiesIncluded(otherProducts, product, outboundAuthConfigs)) productToEntityMap[product]?.forEach((ati)=>{
                if (!selectedEntities.has(ati)) unselectedEntities.add(ati);
            });
        });
    });
    /// result count wants all entities for selected type
    const entitiesForResultsCountQuery = Array.from([
        ...selectedEntities,
        ...unselectedEntities
    ]).sort();
    // Do not show Atlas goal and tag results when no product is selected
    if (types.includes('project') && products.length > 1) {
        selectedEntities.delete('ati:cloud:townsquare:goal');
        selectedEntities.delete('ati:cloud:townsquare:tag');
    }
    // This exists to narrow down the possible types for Dynamic Cards
    // This reduces the entities we use for the query to just these two
    const dynamicCardsAllowedATIs = [
        'ati:cloud:confluence:page',
        'ati:cloud:confluence:blogpost'
    ];
    const entitiesForQuery = Array.from(selectedEntities).filter((entity)=>{
        return dynamicCardsAllowedATIs.includes(entity);
    }).sort();
    // Sorting helps a ton in testing
    return {
        entitiesForQuery: entitiesForQuery,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery
    };
};
const $43cda8fbd603265b$var$getProductsWithEntities = (products, outboundAuthConfigs)=>{
    return products.reduce((acc, product)=>{
        if ($43cda8fbd603265b$var$isProductEntitiesIncluded(products, product, outboundAuthConfigs)) acc.push(product);
        return acc;
    }, []);
};
const $43cda8fbd603265b$export$d9f0dc47e74a61d2 = ({ products: products, selectedTypes: selectedTypes, outboundAuthConfigs: outboundAuthConfigs, availableProducts: availableProducts })=>{
    const otherProducts = availableProducts.filter((product)=>!products.includes(product));
    const productsWithEntities = $43cda8fbd603265b$var$getProductsWithEntities(products, outboundAuthConfigs);
    const otherProductsWithEntities = $43cda8fbd603265b$var$getProductsWithEntities(otherProducts, outboundAuthConfigs);
    // Stuff that we can't be cached that easy
    const selectedEntities = new Set();
    const unselectedEntities = new Set();
    const types = selectedTypes.length === 0 ? (0, $7mBSb.allTypeFilterValueKeys) : selectedTypes;
    const typeMapping = (0, $k6Hr4.getTypeMapping)();
    // Using normal-loop to reduce overhead and improve performance
    for(let i = 0; i < types.length; i++){
        const type = types[i];
        const productToEntityMap = typeMapping[type].entities;
        for(let h = 0; h < productsWithEntities.length; h++){
            const product = productsWithEntities[h];
            const arr = productToEntityMap[product];
            if (!arr || !Array.isArray(arr)) continue;
            for(let w = 0; w < arr.length; w++){
                const ati = arr[w];
                selectedEntities.add(ati);
            }
        }
        for(let j = 0; j < otherProductsWithEntities.length; j++){
            const product = productsWithEntities[j];
            const arr = productToEntityMap[product];
            if (!arr || !Array.isArray(arr)) continue;
            for(let w = 0; w < arr.length; w++){
                const ati = arr[w];
                if (!selectedEntities.has(ati)) unselectedEntities.add(ati);
            }
        }
    }
    /// result count wants all entities for selected type
    const entitiesForResultsCountQuery = Array.from([
        ...selectedEntities,
        ...unselectedEntities
    ]).sort();
    // Do not show Atlas goal and tag results when no product is selected
    if (types.includes('project') && products.length > 1) {
        selectedEntities.delete('ati:cloud:townsquare:goal');
        selectedEntities.delete('ati:cloud:townsquare:tag');
    }
    // This exists to narrow down the possible types for Dynamic Cards
    // This reduces the entities we use for the query to just these two
    const dynamicCardsAllowedATIs = [
        'ati:cloud:confluence:page',
        'ati:cloud:confluence:blogpost'
    ];
    const entitiesForQuery = Array.from(selectedEntities).filter((entity)=>{
        return dynamicCardsAllowedATIs.includes(entity);
    }).sort();
    return {
        entitiesForQuery: entitiesForQuery,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery
    };
};
const $43cda8fbd603265b$export$e902a1c7f3216533 = (query, label)=>{
    return label.toLowerCase().includes(query.toLowerCase());
};
const $43cda8fbd603265b$export$b220eb3fbdd854af = (config)=>{
    const typeMapping = (0, $k6Hr4.getTypeMapping)();
    const allOption = {
        products: [],
        label: config.intl?.formatMessage((0, $4d6KB.typeLabels)['all']) || '',
        value: 'all',
        trackingKey: 'all',
        queryParamValue: (0, $7tGzv.ContentType)['All'],
        isDefault: true
    };
    // This exists to narrow down the possible types for Dynamic Cards
    // This reduces the types we display in the filter to just these two
    const dynamicCardsAllowedTypes = [
        (0, $7mBSb.TypeFilterValueKey).Page,
        (0, $7mBSb.TypeFilterValueKey).Blogpost
    ];
    const typeOptions = (0, $7mBSb.allTypeFilterValueKeys).filter((type)=>{
        return dynamicCardsAllowedTypes.includes(type);
    }).map((type)=>({
            products: typeMapping[type].products,
            value: type,
            trackingKey: type,
            queryParamValue: type,
            isDefault: false,
            label: config.intl?.formatMessage((0, $4d6KB.typeLabels)[type]) || ''
        }));
    return [
        allOption,
        ...typeOptions
    ];
};
module.exports["lookupOptions"] = $43cda8fbd603265b$export$cf63d35399eb18ae;
module.exports["getAllTypeOptions"] = $43cda8fbd603265b$export$b220eb3fbdd854af;
module.exports["getEntitiesForQuery"] = $43cda8fbd603265b$export$e085e94f90daa6c8;

});

parcelRegister("bJguZ", function(module, exports) {
const $e7172f2d9263c638$export$5b6173385ccfaeaa = `
... on ExternalBranch {
    name
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalRepository {
            name
        }
    }
}
`;
module.exports["ExternalBranchPartial"] = $e7172f2d9263c638$export$5b6173385ccfaeaa;

});

parcelRegister("jmwQa", function(module, exports) {
// TODO: >>>> [QS-5465] Add GQL Partial
const $20561d21ee9367f9$export$253480f0254db4f8 = `
`;
module.exports["ExternalCalendarEventPartial"] = $20561d21ee9367f9$export$253480f0254db4f8;

});

parcelRegister("gSUtj", function(module, exports) {
const $cf0e6be7786dc637$export$3dcd3e619ad10a8c = `
... on ExternalCommit {
    author {
        user {
            name
        }
    }
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalRepository{
            name
        }
    }
}
`;
module.exports["ExternalCommitPartial"] = $cf0e6be7786dc637$export$3dcd3e619ad10a8c;

});

parcelRegister("hFLLm", function(module, exports) {
const $d3e5b39886ec2304$export$4597d51c3a28368e = `
... on ExternalConversation {
    id
    memberCount
    displayName
    membershipType
    workspace
    topic
    members {
        thirdPartyUser {
            id
            name
        }
        user {
            id
            name
        }
    }
}
`;
module.exports["ExternalConversationPartial"] = $d3e5b39886ec2304$export$4597d51c3a28368e;

});

parcelRegister("51tJJ", function(module, exports) {
const $fbc122585f6c59b2$export$5eda2cda79f28143 = `
... on ExternalDesign {
    thumbnail {
        externalUrl
    }
}
`;
module.exports["ExternalDesignPartial"] = $fbc122585f6c59b2$export$5eda2cda79f28143;

});

parcelRegister("giUQ9", function(module, exports) {
const $2ccacf9df0f0ed46$export$6193eef58692a804 = `
... on ExternalDocument {
    type {
        iconUrl
    }
    parent @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalDocument {
        displayName
        url
        }
    }
}
`;
module.exports["ExternalDocumentPartial"] = $2ccacf9df0f0ed46$export$6193eef58692a804;

});

parcelRegister("2olQG", function(module, exports) {
const $ab2f225f47bfaa95$export$3b9ed83b2b731ba0 = `
... on ExternalMessage {
    lastUpdated
    description
    reactionCount
    attachments {
	    title
        mimeType
        thumbnailUrl
        url
    }
    createdBy {
        thirdPartyUser {
            id
            accountId
            externalId
            name
            email
        }
        user {
            id
            name
        }
    }
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalConversation {
            id
            displayName
            memberCount
            membershipType
            type
            members {
                thirdPartyUser {
                    id
                    name
                }
            }
        }
    }
    associatedWith {
        edges {
            node {
                id
                createdBy {
                    thirdPartyUser {
                        id
                        accountId
                        externalId
                        name
                        email
                    }
                }
                entity {
					__typename
					... on ExternalConversation {
						id
						displayName
						channelId:externalId
					}
					... on ThirdPartyUser {
                        id
                        name
						externalId
                    }
                }
            }
        }
    }
}
`;
module.exports["ExternalMessagePartial"] = $ab2f225f47bfaa95$export$3b9ed83b2b731ba0;

});

parcelRegister("ewLvK", function(module, exports) {
const $d25948a937ef38c6$export$fa7eefb2a03609fe = `
... on ExternalPullRequest {
    title
    lastUpdate
	pullRequestId
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalRepository {
            name
        }
    }
}
`;
module.exports["ExternalPullRequestPartial"] = $d25948a937ef38c6$export$fa7eefb2a03609fe;

});

parcelRegister("cMovz", function(module, exports) {
const $aaf48f2d34b44f27$export$82972f33e243e789 = `
... on ExternalRepository {
    name
}
`;
module.exports["ExternalRepositoryPartial"] = $aaf48f2d34b44f27$export$82972f33e243e789;

});

parcelRegister("bFwde", function(module, exports) {
const $cb46ae76056056c2$export$d872aa2b0db5eb10 = `
... on ExternalVideo {
    durationInSeconds
    thumbnailUrl
    chapters {
        title
        startTimeInSeconds
    }
    createdBy {
        thirdPartyUser {
            id
            email
            name
        }
        user {
            name
        }
    }
}
`;
module.exports["ExternalVideoPartial"] = $cb46ae76056056c2$export$d872aa2b0db5eb10;

});

parcelRegister("7vyq1", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $75a3341787e96411$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    ['atlassian-web-crawler']: {
        id: "dynamic-cards-search-page.products.custom-website",
        defaultMessage: "Web page"
    }
});
module.exports["messages"] = $75a3341787e96411$export$defe85febe8b728c;

});

parcelRegister("3LdwA", function(module, exports) {
const $4866ef4ddd3e9e58$export$d35186a762cd39c8 = async (promise)=>{
    const startTime = Date.now();
    const result = await promise;
    const duration = Date.now() - startTime;
    return {
        result: result,
        durationMs: duration
    };
};
module.exports["timed"] = $4866ef4ddd3e9e58$export$d35186a762cd39c8;

});

parcelRegister("7tL1u", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $FOT9i = parcelRequire("FOT9i");

var $cclHy = parcelRequire("cclHy");

var $1P1Tu = parcelRequire("1P1Tu");


var $bGd7w = parcelRequire("bGd7w");

var $ERUZZ = parcelRequire("ERUZZ");

var $4ERNs = parcelRequire("4ERNs");


var $4WTnQ = parcelRequire("4WTnQ");


var $7mBSb = parcelRequire("7mBSb");


var $4sOnC = parcelRequire("4sOnC");


var $fFmb3 = parcelRequire("fFmb3");


var $7xGy0 = parcelRequire("7xGy0");


var $e2xgH = parcelRequire("e2xgH");


var $1L9Cd = parcelRequire("1L9Cd");


var $cqgOH = parcelRequire("cqgOH");

const $2473122a63c54686$var$initialState = {
    // Search Input states
    inputQuery: '',
    searchQuery: '',
    // Product States
    primaryProduct: null,
    // Filter States
    filters: {},
    filterSelectionOrder: [],
    selectedProducts: [],
    availableProducts: [],
    allFilterExcludedProducts: [],
    // Rest of store states
    resultsSort: {
        field: (0, $4ERNs.SORT_FIELD_KEY).LAST_MODIFIED_DATE,
        order: (0, $4ERNs.SORT_ORDER).DESC
    },
    retryCount: 0,
    version: 1,
    queryUpdatedTime: Date.now(),
    isLoading: false,
    isJiraHydrationLoading: false,
    isCompassTeamsLoading: false,
    shownCount: 0,
    results: undefined,
    resultError: undefined,
    productResultCountMap: null,
    paginationTokens: [],
    isLoadingMore: false
};
const $2473122a63c54686$var$convertQueryParamsToStringArray = (queryParams, keys)=>{
    return keys.reduce((acc, key)=>{
        if (queryParams[key] === undefined) return acc;
        if (Array.isArray(queryParams[key])) return {
            ...acc,
            [key]: queryParams[key]
        };
        if (typeof queryParams[key] === 'string' || typeof queryParams[key] === 'boolean') return {
            ...acc,
            [key]: [
                queryParams[key].toString()
            ]
        };
        return acc;
    }, {});
};
const $2473122a63c54686$var$getUpdatedFilterSelectionOrder = (previousOrder, newFilterId, selected)=>{
    let filterSelectionOrder = new Set([
        ...previousOrder,
        newFilterId
    ]);
    if (!selected) filterSelectionOrder.delete(newFilterId);
    return [
        ...filterSelectionOrder
    ];
};
/**
 * Only these keys can get set before the updateQueryParams loop when updateQueryParams=true in setSearchStoreState
 */ const $2473122a63c54686$var$safeStateKeys = [
    'filterSelectionOrder',
    'retryCount',
    'paginationTokens'
];
/**
 * Please use setSearchStoreState instead of setState within the Search Store controller.
 *
 * This is because we treat the URL as the source of truth for some state. Filter value states are set in the URL directly and then we listen to URL state changs to represent them in our state.
 *
 * @param newState - state properties to set
 * @param {boolean} options.updateQueryParams - [false] Whether a setState call should trigger an URL update
 *
 * Notes on updateQueryParams:
 *
 * When false, this function acts like a standard setState
 * When true, this function will allow only the {safeStateKeys} to be set and will then use the provided query/filter etc state to set the URL directly, relying on the URL observer to complete the loop
 *
 * Non-url updates should NEVER trigger the setQueryParams callback. Otherwise, this will cause infinite loops or extra render cycles.
 **/ const $2473122a63c54686$var$setSearchStoreState = (newState, options)=>({ getState: getState, setState: setState }, { setQueryParams: setQueryParams, allFilters: allFilters, config: config })=>{
        // TODO future refactoring: we should instead query the newState object for any URL-state changes, then clean up the setState we perform, then update the URL. Then a consumer of this function will not need to care about any of this and can simply pass `newState` as expected
        if (!options?.updateQueryParams) {
            setState(newState);
            return;
        }
        // We still want to set variables in state that do NOT participate in the URL
        // Initially we'll allow-list this set, as the set of filters (the disallow set) will grow over time
        const safeNewState = Object.fromEntries(Object.entries(newState).filter(([key])=>$2473122a63c54686$var$safeStateKeys.includes(key)));
        if (Object.keys(safeNewState).length > 0) setState(safeNewState);
        const { searchQuery: newSearchQuery, inputQuery: newInputQuery } = newState;
        const { inputQuery: oldInputQuery } = getState();
        const { selectedProducts: selectedProducts, filters: allFilterStates, resultsSort: newResultsSort } = {
            ...getState(),
            ...newState
        };
        const staticFilters = Object.values(allFilters).filter((f)=>{
            const filterState = f.getInitialState(config).getState();
            return selectedProducts.length === 0 ? filterState.universal : filterState.products.some((product)=>selectedProducts.includes(product));
        });
        const filterQueryParamValues = staticFilters.map((staticFilter)=>{
            const filterState = allFilterStates[staticFilter.id];
            if (!staticFilter.isCompatible(filterState)) return {};
            return staticFilter.withState(filterState, config).queryParams.get();
        });
        const filterQueryParams = Object.assign({}, ...filterQueryParamValues);
        const text = [
            newSearchQuery,
            newInputQuery,
            oldInputQuery
        ].find(Boolean);
        const parsedQueryParams = (0, $fFmb3.parseQueryParams)({
            product: selectedProducts?.[0],
            text: text !== '' ? text : undefined,
            ...filterQueryParams,
            ...newResultsSort && {
                sortField: newResultsSort.field,
                sortOrder: newResultsSort.order
            }
        }, {
            commaSeparatedValues: true
        });
        setQueryParams(parsedQueryParams);
    };
const $2473122a63c54686$export$f14fed79ef571627 = $2473122a63c54686$var$setSearchStoreState;
const $2473122a63c54686$var$privateStoreActions = {
    initialiseStore: ()=>async ({ dispatch: dispatch }, { allFilters: allFilters, queryParams: queryParams, config: config, setQueryParams: setQueryParams, availableProducts: availableProducts, allFilterExcludedProducts: allFilterExcludedProducts })=>{
            const { getSelectedProducts: getSelectedProducts, filtersByProduct: filtersByProduct, isMissingProductSelection: isMissingProductSelection } = (0, $cqgOH.FilterUtils)(allFilters, {});
            const selectedProducts = getSelectedProducts(queryParams);
            if (isMissingProductSelection(queryParams)) {
                setQueryParams({
                    ...queryParams,
                    product: selectedProducts[0]
                });
                return;
            }
            const { staticFilterValues: staticFiltersByProduct } = filtersByProduct(selectedProducts);
            const resolvedQueryParams = await Promise.allSettled(staticFiltersByProduct.map((staticFilter)=>{
                const queryParamsKeys = [
                    staticFilter.queryParams.key
                ];
                if (staticFilter.isSupportCustomValue && staticFilter.customValueFields) queryParamsKeys.push(...staticFilter.customValueFields);
                return staticFilter.getInitialState(config).queryParams.set($2473122a63c54686$var$convertQueryParamsToStringArray(queryParams, queryParamsKeys));
            }));
            const filterStatesByProduct = resolvedQueryParams.flatMap((promise)=>{
                switch(promise.status){
                    case 'fulfilled':
                        return [
                            promise.value.getState()
                        ];
                    case 'rejected':
                        return [];
                }
            });
            const { filterStates: filterStates } = (0, $cqgOH.FilterUtils)(staticFiltersByProduct, filterStatesByProduct);
            const sortField = queryParams.sortField || $2473122a63c54686$var$initialState.resultsSort.field;
            const sortOrder = queryParams.sortOrder || $2473122a63c54686$var$initialState.resultsSort.order;
            dispatch($2473122a63c54686$var$setSearchStoreState({
                filters: filterStates,
                resultsSort: {
                    field: sortField,
                    order: sortOrder
                },
                selectedProducts: selectedProducts,
                inputQuery: String(queryParams.text ?? ''),
                searchQuery: String(queryParams.text ?? ''),
                originalQuery: String(queryParams.originalQuery ?? ''),
                availableProducts: availableProducts,
                allFilterExcludedProducts: allFilterExcludedProducts
            }, {
                updateQueryParams: false
            }));
        },
    // TODO QS-4438 move this out to be private/unsafe like setSearchStoreState
    updateStore: ()=>async ({ dispatch: dispatch, getState: getState }, { allFilters: allFilters, queryParams: queryParams, config: config, availableProducts: availableProducts })=>{
            const { filters: filterStates, inputQuery: inputQuery, searchQuery: searchQuery, originalQuery: originalQuery } = getState();
            const { getSelectedProducts: getSelectedProducts, filtersByProduct: filtersByProduct } = (0, $cqgOH.FilterUtils)(allFilters, filterStates);
            const selectedProducts = getSelectedProducts(queryParams);
            const { staticFilterValues: staticFiltersByProduct, filterStates: filterStatesByProduct } = filtersByProduct(selectedProducts);
            const resolvedQueryParams = await Promise.allSettled(staticFiltersByProduct.map((staticFilter)=>{
                const filterState = filterStatesByProduct[staticFilter.id];
                const queryParamsKeys = [
                    staticFilter.queryParams.key
                ];
                if (staticFilter.isSupportCustomValue && staticFilter.customValueFields) queryParamsKeys.push(...staticFilter.customValueFields);
                const queryParamStringArray = $2473122a63c54686$var$convertQueryParamsToStringArray(queryParams, queryParamsKeys);
                if (!staticFilter.isCompatible(filterState)) return staticFilter.getInitialState(config).queryParams.set(queryParamStringArray);
                return staticFilter.withState(filterState, config).queryParams.set(queryParamStringArray);
            }));
            const fullfilledFilterStates = resolvedQueryParams.flatMap((promise)=>{
                switch(promise.status){
                    case 'fulfilled':
                        return [
                            promise.value.getState()
                        ];
                    case 'rejected':
                        return [];
                }
            });
            const { getFiltersWithSelection: getFiltersWithSelection, filterStates: resolvedFilterStates } = (0, $cqgOH.FilterUtils)(staticFiltersByProduct, fullfilledFilterStates);
            // In order, ensure all filters with values are added to selection
            // Ensures filters enter selection order from resume-from-url
            // TODO: this should be done with the global ordering, but we don't have that in constants yet
            let { filterSelectionOrder: filterSelectionOrder } = getState();
            getFiltersWithSelection().map((filterId)=>{
                filterSelectionOrder = $2473122a63c54686$var$getUpdatedFilterSelectionOrder(filterSelectionOrder, filterId, resolvedFilterStates[filterId]?.hasSelection);
            });
            const sortField = queryParams.sortField || $2473122a63c54686$var$initialState.resultsSort.field;
            const sortOrder = queryParams.sortOrder || $2473122a63c54686$var$initialState.resultsSort.order;
            dispatch($2473122a63c54686$var$setSearchStoreState({
                filters: resolvedFilterStates,
                resultsSort: {
                    field: sortField,
                    order: sortOrder
                },
                selectedProducts: getSelectedProducts(queryParams),
                filterSelectionOrder: filterSelectionOrder,
                inputQuery: String(queryParams.text ?? inputQuery),
                searchQuery: String(queryParams.text ?? searchQuery),
                originalQuery: String(queryParams.originalQuery ?? originalQuery),
                availableProducts: availableProducts,
                paginationTokens: []
            }, {
                updateQueryParams: false
            }));
        },
    setFilter: (state, shouldSetQueryParams)=>async ({ dispatch: dispatch, getState: getState }, { allFilters: allFilters, config: config })=>{
            const staticFilter = allFilters[state.id];
            const { filters: allFiltersState } = getState();
            if (!staticFilter.isCompatible(state)) return;
            const filterWithState = staticFilter.withState(state, config).getState();
            dispatch($2473122a63c54686$var$setSearchStoreState({
                filters: {
                    ...allFiltersState,
                    [staticFilter.id]: filterWithState
                }
            }, {
                updateQueryParams: shouldSetQueryParams
            }));
        },
    updateFilterSelectionOrder: (filterId, selected)=>async ({ dispatch: dispatch, getState: getState })=>{
            const { filterSelectionOrder: oldSelectionOrder } = getState();
            const newFilterSelectionOrder = $2473122a63c54686$var$getUpdatedFilterSelectionOrder(oldSelectionOrder, filterId, selected);
            dispatch($2473122a63c54686$var$setSearchStoreState({
                filterSelectionOrder: newFilterSelectionOrder
            }));
        }
};
const $2473122a63c54686$export$e324594224ef24da = {
    loadInitialSelectFilterOptions: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticSelectFilter.isCompatible(filterState) || !(0, $e2xgH.isSelectFilter)(staticSelectFilter.type)) return;
            const newFilter = staticSelectFilter.withState(filterState, config);
            // @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
            await newFilter.loadInitialOptions((stateChange)=>{
                dispatch($2473122a63c54686$var$privateStoreActions.setFilter(stateChange));
            });
        },
    clearSelectFilterOptions: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticSelectFilter.isCompatible(filterState) || !(0, $e2xgH.isSelectFilter)(staticSelectFilter.type)) return;
            const newFilterState = staticSelectFilter.withState(filterState, config).clear().getState();
            dispatch($2473122a63c54686$var$privateStoreActions.setFilter(newFilterState, true));
            dispatch($2473122a63c54686$var$privateStoreActions.updateFilterSelectionOrder(props.filterId, newFilterState.hasSelection));
            dispatch($2473122a63c54686$var$setSearchStoreState({
                productResultCountMap: null
            }));
        },
    setSelectFilterOption: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticSelectFilter.isCompatible(filterState) || !(0, $e2xgH.isSelectFilter)(staticSelectFilter.type)) return;
            const newFilterState = staticSelectFilter.withState(filterState, config)// @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
            .setOption(props.optionChange, props.customValue).getState();
            dispatch($2473122a63c54686$var$privateStoreActions.setFilter(newFilterState, true));
            dispatch($2473122a63c54686$var$privateStoreActions.updateFilterSelectionOrder(props.filterId, newFilterState.hasSelection));
            dispatch($2473122a63c54686$var$setSearchStoreState({
                productResultCountMap: null
            }));
        },
    setSelectFilterLookupInput: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticSelectFilter.isCompatible(filterState) || !(0, $e2xgH.isSelectFilter)(staticSelectFilter.type)) return;
            await staticSelectFilter.withState(filterState, config)// @ts-ignore - TS2339 TypeScript 5.9.2 upgrade
            .setLookupInput(props.query, (stateChange)=>{
                dispatch($2473122a63c54686$var$privateStoreActions.setFilter(stateChange));
            });
        },
    setBooleanFilterValue: (props, privateActions = $2473122a63c54686$var$privateStoreActions)=>({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticBooleanFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticBooleanFilter.isCompatible(filterState)) return;
            if (staticBooleanFilter.type !== 'boolean') return;
            const newBooleanFilterState = staticBooleanFilter.withState(filterState, config).setValue(props.value).getState();
            dispatch(privateActions.setFilter(newBooleanFilterState, true));
            dispatch(privateActions.updateFilterSelectionOrder(props.filterId, newBooleanFilterState.hasSelection));
            dispatch($2473122a63c54686$var$setSearchStoreState({
                productResultCountMap: null
            }));
        },
    clearAllFilters: ()=>({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const { filters: allFilterStates } = getState();
            const staticFilters = Object.values(allFilters);
            dispatch($2473122a63c54686$var$setSearchStoreState({
                filters: $2473122a63c54686$var$clearFilters(allFilterStates, staticFilters, config),
                selectedProducts: [],
                filterSelectionOrder: []
            }, {
                updateQueryParams: true
            }));
        },
    clearAllAvailableFilters: ()=>({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticFilters = Object.values(allFilters);
            const { filters: allFilterStates } = getState();
            dispatch($2473122a63c54686$var$setSearchStoreState({
                filters: $2473122a63c54686$var$clearFilters(allFilterStates, staticFilters, config),
                filterSelectionOrder: [],
                resultsSort: $2473122a63c54686$var$initialState.resultsSort
            }, {
                updateQueryParams: true
            }));
        },
    // Product filter actions
    selectProductFilter: (productKey)=>({ getState: getState, dispatch: dispatch })=>{
            const { selectedProducts: selectedProducts, filters: filters, filterSelectionOrder: filterSelectionOrder } = getState();
            if (productKey && selectedProducts.includes(productKey)) return;
            const persistedFilters = {};
            // Persist selected universal filters if they are relevant to the selected product
            for (const [id, filter] of Object.entries(filters)){
                if (!filter) continue;
                if (filter.universal && filter.hasSelection && (!productKey || productKey && filter.products.includes(productKey))) persistedFilters[id] = filter;
            }
            // Type is a universal filter, but type needs to be cleared if we're filtering away from Atlas
            // This is because selecting a global noun sets product AND type values
            if (selectedProducts.includes((0, $4sOnC.ProductKeys).Atlas)) delete persistedFilters[0, $7mBSb.universalTypeFilterId];
            // Universal filters being persisted also retain their ordering
            const newFilterSelectionOrder = filterSelectionOrder.filter((f)=>{
                return Object.keys(persistedFilters).includes(f);
            });
            dispatch($2473122a63c54686$var$setSearchStoreState({
                selectedProducts: productKey ? [
                    productKey
                ] : [],
                filterSelectionOrder: newFilterSelectionOrder,
                filters: persistedFilters,
                resultsSort: $2473122a63c54686$var$initialState.resultsSort
            }, {
                updateQueryParams: true
            }));
        },
    // TODO: >>>> QS-4163 After removing the old search store, merge selectProductFilter and unselectProductFilter
    // together as they do the same thing
    unselectProductFilter: (productKey)=>({ getState: getState, dispatch: dispatch })=>{
            const { selectedProducts: selectedProducts } = getState();
            if (selectedProducts.includes(productKey)) dispatch($2473122a63c54686$export$e324594224ef24da.selectProductFilter(undefined));
        },
    // Search Input Actions
    setInputQuery: (inputQuery)=>({ dispatch: dispatch })=>{
            dispatch($2473122a63c54686$var$setSearchStoreState({
                inputQuery: inputQuery.trim()
            }));
        },
    setSearchQuery: (searchQuery)=>({ dispatch: dispatch })=>{
            dispatch($2473122a63c54686$var$setSearchStoreState({
                searchQuery: searchQuery.trim()
            }, {
                updateQueryParams: true
            }));
        },
    triggerSearch: ()=>({ getState: getState, dispatch: dispatch })=>{
            const { inputQuery: inputQuery, searchQuery: searchQuery, retryCount: retryCount, productResultCountMap: productResultCountMap } = getState();
            dispatch($2473122a63c54686$var$setSearchStoreState({
                productResultCountMap: searchQuery === inputQuery ? productResultCountMap : null
            }));
            dispatch($2473122a63c54686$var$setSearchStoreState({
                searchQuery: inputQuery,
                retryCount: searchQuery === inputQuery ? retryCount + 1 : 0
            }, {
                updateQueryParams: true
            }));
        },
    retrySearch: ()=>({ dispatch: dispatch, getState: getState })=>{
            dispatch($2473122a63c54686$var$setSearchStoreState({
                retryCount: getState().retryCount + 1
            }));
        },
    setResultsSort: ({ field: field, order: order })=>({ dispatch: dispatch })=>{
            dispatch($2473122a63c54686$var$setSearchStoreState({
                resultsSort: {
                    field: field,
                    order: order
                },
                paginationTokens: []
            }, {
                updateQueryParams: true
            }));
        },
    resetSort: ()=>({ dispatch: dispatch })=>{
            dispatch($2473122a63c54686$var$setSearchStoreState({
                resultsSort: $2473122a63c54686$var$initialState.resultsSort,
                paginationTokens: []
            }));
        },
    // Rest of Search Actions
    setQueryUpdatedTime: ()=>({ dispatch: dispatch })=>{
            dispatch($2473122a63c54686$var$setSearchStoreState({
                queryUpdatedTime: Date.now()
            }));
        },
    incrementVersion: ()=>({ dispatch: dispatch, getState: getState })=>{
            const { version: version } = getState();
            dispatch($2473122a63c54686$var$setSearchStoreState({
                version: version + 1
            }));
        },
    setIsLoading: (isLoading)=>({ dispatch: dispatch })=>{
            dispatch($2473122a63c54686$var$setSearchStoreState({
                isLoading: isLoading
            }));
        },
    // Results actions
    setResults: (results, error, requestId)=>({ dispatch: dispatch })=>{
            dispatch($2473122a63c54686$var$setSearchStoreState({
                isLoading: false,
                results: results,
                resultError: error,
                requestId: requestId
            }));
        },
    appendMoreResults: (results)=>({ dispatch: dispatch, getState: getState })=>{
            const { results: currentResults } = getState();
            if (!currentResults || !results) return;
            const currentEdges = currentResults.edges;
            const newEdges = results.edges;
            const newResults = {
                ...currentResults,
                edges: currentEdges.concat(newEdges),
                pageInfo: results?.pageInfo
            };
            dispatch($2473122a63c54686$var$setSearchStoreState({
                results: newResults,
                isLoadingMore: false
            }));
        },
    setFetchFromCursor: (cursor)=>({ dispatch: dispatch })=>{
            dispatch($2473122a63c54686$var$setSearchStoreState({
                paginationTokens: [
                    {
                        cursor: cursor
                    }
                ]
            }));
        },
    setIsLoadingMore: (isLoadingMore)=>({ dispatch: dispatch })=>{
            dispatch($2473122a63c54686$var$setSearchStoreState({
                isLoadingMore: isLoadingMore
            }));
        },
    setJiraIssueFieldsLoading: (isLoading)=>({ dispatch: dispatch })=>{
            dispatch($2473122a63c54686$var$setSearchStoreState({
                isJiraHydrationLoading: isLoading
            }));
        },
    setJiraIssueDetails: (issueData)=>({ dispatch: dispatch, getState: getState })=>{
            const { results: results } = getState();
            let hydratedResults = [];
            if (results?.edges && results.edges.length > 0 && issueData.length > 0) {
                hydratedResults = [
                    ...results.edges
                ].map((edge)=>{
                    if ((0, $ERUZZ.isSearchResultJiraIssue)(edge.node)) {
                        const id = edge.node.id;
                        const hydratedIssue = issueData.find((issue)=>issue.id === id);
                        if (edge.node.status && hydratedIssue) edge.node.status.name = hydratedIssue.statusField.status.name;
                    }
                    return edge;
                });
                dispatch($2473122a63c54686$var$setSearchStoreState({
                    results: {
                        ...results,
                        edges: hydratedResults
                    }
                }));
            }
        },
    setCompassTeamsLoading: (isLoading)=>({ dispatch: dispatch })=>{
            dispatch($2473122a63c54686$var$setSearchStoreState({
                isCompassTeamsLoading: isLoading
            }));
        },
    setCompassTeams: (teamData)=>({ dispatch: dispatch, getState: getState })=>{
            const { results: results } = getState();
            let resultsWithTeamNames = [];
            if (results?.edges && results.edges.length > 0 && teamData.length > 0) {
                resultsWithTeamNames = [
                    ...results.edges
                ].map((edge)=>{
                    if ((0, $bGd7w.isSearchCompassPartial)(edge.node)) {
                        const teamId = (0, $7xGy0.getTeamId)(edge.node.ownerId);
                        const team = teamData.find((team)=>team.id === teamId);
                        edge.node.ownerName = team?.displayName;
                    }
                    return edge;
                });
                dispatch($2473122a63c54686$var$setSearchStoreState({
                    results: {
                        ...results,
                        edges: resultsWithTeamNames
                    }
                }));
            }
        },
    resetResults: ()=>({ dispatch: dispatch })=>{
            dispatch($2473122a63c54686$var$setSearchStoreState({
                isLoading: false,
                shownCount: 0,
                results: undefined,
                resultError: undefined,
                requestId: undefined
            }));
        },
    setAutoCorrection: (autoCorrection)=>({ dispatch: dispatch })=>{
            dispatch($2473122a63c54686$var$setSearchStoreState({
                autoCorrection: autoCorrection
            }));
        },
    setProductResultCount: (totalCounts)=>({ dispatch: dispatch, getState: getState })=>{
            if (totalCounts === undefined) {
                dispatch($2473122a63c54686$var$setSearchStoreState({
                    productResultCountMap: null
                }));
                return;
            }
            const { productResultCountMap: oldProductResultCountMap } = getState();
            const productResultCountMap = totalCounts.reduce((acc, { product: product, count: count })=>{
                if (product) acc[product] = count;
                return acc;
            }, {});
            dispatch($2473122a63c54686$var$setSearchStoreState({
                productResultCountMap: {
                    ...oldProductResultCountMap,
                    ...productResultCountMap
                }
            }));
        },
    // For backwards compatibility
    clearHybridFilters: ()=>({ dispatch: dispatch })=>{
            dispatch($2473122a63c54686$export$e324594224ef24da.clearAllFilters());
        },
    /**
	 * Considered unsafe since it's using queryParams to change the state.
	 * Ideally we should set it directly in the state, but that requires introducing a new action.
	 * This is because the cooresponding "Type" filter that this selects isn't available or easy to set from outside
	 * The product=townsquare&type=project will correctly hydrate the filter from the URL after params are set though!
	 *
	 * We hope to improve Atlassian Home / global noun handling after GA
	 *
	 * @param value: a noun to be set
	 */ unsafe_setAtlasNouns: (value)=>({ dispatch: dispatch }, { queryParams: queryParams, setQueryParams: setQueryParams })=>{
            dispatch($2473122a63c54686$var$setSearchStoreState({
                productResultCountMap: null
            }));
            if (!value) {
                const { product: product, type: type, ...queryParamsWithResetNounFilter } = queryParams;
                setQueryParams({
                    ...queryParamsWithResetNounFilter
                });
            } else {
                const { text: text, originalQuery: originalQuery, lastModified: lastModified } = queryParams;
                // We explicityly only keep text and lastModified
                setQueryParams({
                    product: (0, $4sOnC.ProductKeys).Atlas,
                    type: value,
                    text: text,
                    originalQuery: originalQuery,
                    lastModified: lastModified
                });
            }
        }
};
const $2473122a63c54686$var$clearFilters = (allFilterStates, filters, config)=>{
    const clearedFilters = filters.map((filter)=>{
        const filterState = allFilterStates[filter.id];
        if (!filter.isCompatible(filterState)) return [];
        return [
            filter.id,
            filter.withState(filterState, config).clear().getState()
        ];
    });
    return Object.fromEntries(clearedFilters);
};
// Keep store private and use hooks to access state and actions
const $2473122a63c54686$var$Store = (0, $1P1Tu.createStore)({
    initialState: $2473122a63c54686$var$initialState,
    actions: $2473122a63c54686$export$e324594224ef24da,
    name: 'dynamic-cards-search'
});
const $2473122a63c54686$export$b8f9c0e048639dd4 = (0, $9zUhf.createActionsHook)($2473122a63c54686$var$Store);
const $2473122a63c54686$export$bf072992274c9fb = (0, $FOT9i.createContainer)($2473122a63c54686$var$Store, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch($2473122a63c54686$var$privateStoreActions.initialiseStore());
        },
    onUpdate: ()=>({ dispatch: dispatch })=>{
            dispatch($2473122a63c54686$var$privateStoreActions.updateStore());
        },
    onCleanup: ()=>({ setState: setState })=>{
            setState($2473122a63c54686$var$initialState);
        }
});
const $2473122a63c54686$export$bd221a7c56b93941 = (0, $9zUhf.createHook)($2473122a63c54686$var$Store);
const $2473122a63c54686$export$c5a5afdff2ff0385 = (0, $9zUhf.createActionsHook)($2473122a63c54686$var$Store);
const $2473122a63c54686$export$973ca22476b0e05f = (0, $9zUhf.createStateHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.filters
});
const $2473122a63c54686$export$da992673b1309795 = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.inputQuery
});
const $2473122a63c54686$export$e985158d10c27e34 = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.searchQuery
});
const $2473122a63c54686$export$c2380c4d76e63cc4 = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.originalQuery
});
const $2473122a63c54686$export$ba2ad669c5b27bca = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.autoCorrection
});
const $2473122a63c54686$export$140d37088821fcb1 = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.retryCount
});
const $2473122a63c54686$export$275c72361969d62c = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.productResultCountMap
});
const $2473122a63c54686$export$14279a3fbdb52451 = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.results?.abTest
});
const $2473122a63c54686$export$34418e307d9100b4 = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.results?.queryInfo
});
const $2473122a63c54686$export$8a4c65ea4f241b48 = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.searchQuery ? (0, $4WTnQ.QueryState).POSTQUERY : (0, $4WTnQ.QueryState).PREQUERY
});
const $2473122a63c54686$export$a2b38489a4538322 = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.queryUpdatedTime
});
const $2473122a63c54686$export$bda9ac73817ceec3 = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.results
});
const $2473122a63c54686$export$1c9622ace43d770d = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.resultError
});
const $2473122a63c54686$export$49f5dec896c355cd = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.requestId
});
const $2473122a63c54686$export$4dface15d86304a4 = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.isLoading
});
const $2473122a63c54686$export$f59185497e80e274 = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.resultsSort
});
const $2473122a63c54686$export$826bdf756a8bf13a = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.selectedProducts
});
const $2473122a63c54686$export$387e1da2bc9c93cc = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.selectedProducts[0]
});
const $2473122a63c54686$export$8c11ef422551818 = (0, $9zUhf.createStateHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.isJiraHydrationLoading
});
const $2473122a63c54686$export$795623048d841bf2 = (0, $9zUhf.createStateHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.isCompassTeamsLoading
});
const $2473122a63c54686$export$8dc083eb9766b48 = (0, $9zUhf.createStateHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.availableProducts && state.availableProducts.length > 0
});
const $2473122a63c54686$export$e80788222dba30a3 = (0, $9zUhf.createStateHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.results?.pageInfo?.endCursor
});
const $2473122a63c54686$export$bedf78a7ab879711 = (0, $9zUhf.createStateHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.paginationTokens[0]?.cursor
});
const $2473122a63c54686$export$f258398dab7c75ba = (0, $9zUhf.createStateHook)($2473122a63c54686$var$Store, {
    selector: (state)=>state.isLoadingMore
});
const $2473122a63c54686$export$964e8498268f0fe3 = (0, $9zUhf.createStateHook)($2473122a63c54686$var$Store, {
    selector: (0, $cclHy.createSelector)([
        (state)=>state.selectedProducts.at(0),
        (state)=>state.selectedProducts[0] ? [
                state.selectedProducts[0]
            ] : state.availableProducts,
        (state)=>state.availableProducts
    ], (selectedProduct, filteredProducts, availableProducts)=>({
            selectedProduct: selectedProduct,
            filteredProducts: filteredProducts,
            availableProducts: availableProducts
        }))
});
const $2473122a63c54686$export$6466dd1b74ba3dff = (productsToSearch, typeFilter, outboundAuthConfigs, availableProducts)=>{
    // This early return is to appease Typescript. The typeFilter is always defined and is always single select.
    if (!typeFilter || !(typeFilter.type === 'single-select')) return {
        selectedEntities: [],
        entitiesForQuery: [],
        entitiesForResultsCountQuery: []
    };
    const defaultOptionValue = typeFilter.options?.find((option)=>option.isDefault)?.value;
    const selectedTypes = typeFilter.value.filter((value)=>value !== defaultOptionValue).filter(Boolean);
    const { entitiesForQuery: entitiesForQuery, entitiesForResultsCountQuery: entitiesForResultsCountQuery } = (0, $1L9Cd.getEntitiesForQuery)(productsToSearch, selectedTypes, outboundAuthConfigs, availableProducts);
    return {
        selectedEntities: selectedTypes,
        entitiesForQuery: entitiesForQuery,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery
    };
};
const $2473122a63c54686$export$59086fbf0d8f8d2a = (0, $9zUhf.createStateHook)($2473122a63c54686$var$Store, {
    selector: (0, $cclHy.createSelector)([
        (state)=>{
            // Filter out excluded products from "All" filter
            const allFilterIncludedProducts = state.availableProducts.filter((product)=>!state.allFilterExcludedProducts.includes(product));
            return state.selectedProducts[0] ? [
                state.selectedProducts[0]
            ] : allFilterIncludedProducts;
        },
        (state)=>state.filters[0, $7mBSb.universalTypeFilterId],
        (_, props)=>props.outboundAuthConfigs,
        (state)=>state.availableProducts
    ], (productsToSearch, typeFilter, outboundAuthConfigs, availableProducts)=>$2473122a63c54686$export$6466dd1b74ba3dff(productsToSearch, typeFilter, outboundAuthConfigs, availableProducts))
});
const $2473122a63c54686$export$aad641f503e4b4a8 = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: (state, props)=>{
        const filter = state.filters[props.filterId];
        if (filter === undefined) return undefined;
        if (!(0, $e2xgH.isSelectFilter)(filter.type)) throw new Error('Not a select filter');
        return {
            ...filter,
            selectedProducts: state.selectedProducts,
            availableProducts: state.availableProducts,
            allFilterExcludedProducts: state.allFilterExcludedProducts
        };
    }
});
const $2473122a63c54686$export$c724ec2cbd2fedce = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: (state, props)=>{
        const filter = state.filters[props.filterId];
        if (filter === undefined) return undefined;
        if (filter?.type !== 'boolean') throw new Error('Not a boolean filter');
        return filter;
    }
});
const $2473122a63c54686$export$1c5018e1c1ce99ae = (filters)=>{
    const filterIdOrdering = (0, $7mBSb.getFilterIdOrdering)();
    return filterIdOrdering.flatMap((f)=>{
        const filter = filters[f];
        return filter && filter.universal ? [
            filter
        ] : [];
    });
};
const $2473122a63c54686$export$a8734449e402b6ca = (filters, selectedProducts)=>{
    const filterIdOrdering = (0, $7mBSb.getFilterIdOrdering)();
    return filterIdOrdering.flatMap((f)=>{
        const filter = filters[f];
        return filter && selectedProducts.some((product)=>filter?.products.includes(product)) ? [
            filter
        ] : [];
    });
};
/**
 * All available filters in the initial ordering
 */ const $2473122a63c54686$var$getAllAvailableFilters = (filters, selectedProducts)=>{
    return selectedProducts.length === 0 ? $2473122a63c54686$export$1c5018e1c1ce99ae(filters) : $2473122a63c54686$export$a8734449e402b6ca(filters, selectedProducts);
};
/**
 * All available filters are always returned for inline, but the ordering depends on selection
 * The caller UI is responsible for deciding how many can be rendered by available width
 */ const $2473122a63c54686$var$getFilterIdsForInline = (filters, selectedProducts, filterSelectionOrder)=>{
    const allAvailableFilterIds = $2473122a63c54686$var$getAllAvailableFilters(filters, selectedProducts).map((a)=>a.id);
    // using the selection order, filter from the available (removes any invalid filters to show)
    let filtersForInline = filterSelectionOrder.filter((f)=>allAvailableFilterIds.includes(f));
    // then simply add the rest back (with a set for deduplication)
    return [
        ...new Set([
            ...filtersForInline,
            ...allAvailableFilterIds
        ])
    ];
};
const $2473122a63c54686$export$94c94f88577d66b2 = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: ({ filters: filters, selectedProducts: selectedProducts, filterSelectionOrder: filterSelectionOrder })=>{
        // All filters always show in the dropdown, in order
        const filtersInDropdown = $2473122a63c54686$var$getAllAvailableFilters(filters, selectedProducts).map((f)=>f.id);
        const filtersInLine = $2473122a63c54686$var$getFilterIdsForInline(filters, selectedProducts, filterSelectionOrder);
        return {
            filtersInDropdown: filtersInDropdown,
            filtersInLine: filtersInLine,
            filterSelectionOrder: filterSelectionOrder
        };
    }
});
const $2473122a63c54686$export$754cc306c2d9241e = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: ({ selectedProducts: selectedProducts, filters: filters, resultsSort: resultsSort })=>{
        const selectedFilters = Object.values(filters).filter((filter)=>filter?.hasSelection).filter((filter)=>{
            const isAtlasSelected = selectedProducts.includes((0, $4sOnC.ProductKeys).Atlas);
            const isTypeFilter = filter?.id === (0, $7mBSb.universalTypeFilterId);
            return isAtlasSelected ? !isTypeFilter : true;
        });
        const { field: field, order: order } = resultsSort;
        const isSortedByDefault = field === $2473122a63c54686$var$initialState.resultsSort.field && order === $2473122a63c54686$var$initialState.resultsSort.order;
        return {
            selectedFilterCount: selectedFilters.length + (isSortedByDefault ? 0 : 1)
        };
    }
});
const $2473122a63c54686$export$210935c1afa2c65c = (0, $9zUhf.createHook)($2473122a63c54686$var$Store, {
    selector: ({ selectedProducts: selectedProducts, filters: filters })=>{
        const hasSelectedProduct = selectedProducts[0];
        if (hasSelectedProduct) return true;
        return Object.values(filters).some((filter)=>filter?.hasSelection);
    }
});
module.exports["SearchStoreContainer"] = $2473122a63c54686$export$bf072992274c9fb;
module.exports["useSearchActions"] = $2473122a63c54686$export$c5a5afdff2ff0385;
module.exports["useFilters"] = $2473122a63c54686$export$973ca22476b0e05f;
module.exports["useInputQuery"] = $2473122a63c54686$export$da992673b1309795;
module.exports["useSearchQuery"] = $2473122a63c54686$export$e985158d10c27e34;
module.exports["useOriginalQuery"] = $2473122a63c54686$export$c2380c4d76e63cc4;
module.exports["useAutoCorrection"] = $2473122a63c54686$export$ba2ad669c5b27bca;
module.exports["useRetryCount"] = $2473122a63c54686$export$140d37088821fcb1;
module.exports["useResults"] = $2473122a63c54686$export$bda9ac73817ceec3;
module.exports["useResultsError"] = $2473122a63c54686$export$1c9622ace43d770d;
module.exports["useResultsRequestId"] = $2473122a63c54686$export$49f5dec896c355cd;
module.exports["useIsLoading"] = $2473122a63c54686$export$4dface15d86304a4;
module.exports["useResultsSort"] = $2473122a63c54686$export$f59185497e80e274;
module.exports["useSelectedProduct"] = $2473122a63c54686$export$387e1da2bc9c93cc;
module.exports["useIsJiraHydrationLoading"] = $2473122a63c54686$export$8c11ef422551818;
module.exports["useIsCompassTeamsLoading"] = $2473122a63c54686$export$795623048d841bf2;
module.exports["useIsSearchReady"] = $2473122a63c54686$export$8dc083eb9766b48;
module.exports["usePageEndCursor"] = $2473122a63c54686$export$e80788222dba30a3;
module.exports["useFetchFromCursor"] = $2473122a63c54686$export$bedf78a7ab879711;
module.exports["useIsLoadingMore"] = $2473122a63c54686$export$f258398dab7c75ba;
module.exports["useProducts"] = $2473122a63c54686$export$964e8498268f0fe3;
module.exports["useTypeEntities"] = $2473122a63c54686$export$59086fbf0d8f8d2a;
module.exports["useSelectFilterStore"] = $2473122a63c54686$export$aad641f503e4b4a8;
module.exports["useBooleanFilterStore"] = $2473122a63c54686$export$c724ec2cbd2fedce;
module.exports["useFiltersToDisplay"] = $2473122a63c54686$export$94c94f88577d66b2;
module.exports["useSelectedFilterCount"] = $2473122a63c54686$export$754cc306c2d9241e;

});

parcelRegister("4d6KB", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $3b9af1d9c26cd041$export$9f8e6b98f3e412c5 = (0, $cgtv4.defineMessages)({
    all: {
        id: "dynamic-cards-search-page.filter.type.all",
        defaultMessage: "All"
    },
    document: {
        id: "dynamic-cards-search-page.filter.type.documents",
        defaultMessage: "Documents"
    },
    spreadsheet: {
        id: "dynamic-cards-search-page.filter.type.spreadsheet",
        defaultMessage: "Spreadsheets"
    },
    presentation: {
        id: "dynamic-cards-search-page.filter.type.presentation",
        defaultMessage: "Presentations"
    },
    repository: {
        id: "dynamic-cards-search-page.filter.type.repository",
        defaultMessage: "Repositories"
    },
    'pull-request': {
        id: "dynamic-cards-search-page.filter.type.pull-request",
        defaultMessage: "Pull requests"
    },
    branch: {
        id: "dynamic-cards-search-page.filter.type.branch",
        defaultMessage: "Branches"
    },
    commit: {
        id: "dynamic-cards-search-page.filter.type.commit",
        defaultMessage: "Commits"
    },
    conversation: {
        id: "dynamic-cards-search-page.filter.type.conversation",
        defaultMessage: "Channels"
    },
    message: {
        id: "dynamic-cards-search-page.filter.type.message",
        defaultMessage: "Messages"
    },
    video: {
        id: "dynamic-cards-search-page.filter.type.video",
        defaultMessage: "Videos"
    },
    design: {
        id: "dynamic-cards-search-page.filter.type.design",
        defaultMessage: "Designs"
    },
    page: {
        id: "dynamic-cards-search-page.filter.type.page",
        defaultMessage: "Pages"
    },
    blogpost: {
        id: "dynamic-cards-search-page.filter.type.blogpost",
        defaultMessage: "Blog posts"
    },
    attachment: {
        id: "dynamic-cards-search-page.filter.type.attachment",
        defaultMessage: "Attachments"
    },
    space: {
        id: "dynamic-cards-search-page.filter.type.space",
        defaultMessage: "Spaces"
    },
    whiteboard: {
        id: "dynamic-cards-search-page.filter.type.whiteboard",
        defaultMessage: "Whiteboards"
    },
    issue: {
        id: "dynamic-cards-search-page.filter.type.issue",
        defaultMessage: "Issues"
    },
    project: {
        id: "dynamic-cards-search-page.filter.type.project",
        defaultMessage: "Projects"
    },
    goal: {
        id: "dynamic-cards-search-page.filter.type.goal",
        defaultMessage: "Goals"
    },
    tag: {
        id: "dynamic-cards-search-page.filter.type.tag",
        defaultMessage: "Tags"
    },
    'web-page': {
        id: "dynamic-cards-search-page.filter.type.web-page",
        defaultMessage: "Web pages"
    },
    comment: {
        id: "dynamic-cards-search-page.filter.type.comment",
        defaultMessage: "Comments"
    },
    database: {
        id: "dynamic-cards-search-page.filter.type.database",
        defaultMessage: "Databases"
    },
    embed: {
        id: "dynamic-cards-search-page.filter.type.embed",
        defaultMessage: "Smart Links"
    },
    folder: {
        id: "dynamic-cards-search-page.filter.type.folder",
        defaultMessage: "Folders"
    },
    calendar: {
        id: "dynamic-cards-search-page.filter.type.calendar",
        defaultMessage: "Calendars"
    },
    'space-calendar': {
        id: "dynamic-cards-search-page.filter.type.space-calendar",
        defaultMessage: "Space calendars"
    },
    answer: {
        id: "dynamic-cards-search-page.filter.type.answer",
        defaultMessage: "Answers"
    },
    question: {
        id: "dynamic-cards-search-page.filter.type.question",
        defaultMessage: "Questions"
    },
    component: {
        id: "dynamic-cards-search-page.filter.type.component",
        defaultMessage: "Components"
    },
    'work-item': {
        id: "dynamic-cards-search-page.filter.type.work-item",
        defaultMessage: "Work items"
    },
    board: {
        id: "dynamic-cards-search-page.filter.type.board",
        defaultMessage: "Board"
    },
    card: {
        id: "dynamic-cards-search-page.filter.type.card",
        defaultMessage: "Card"
    }
});
module.exports["typeLabels"] = $3b9af1d9c26cd041$export$9f8e6b98f3e412c5;

});

parcelRegister("4WTnQ", function(module, exports) {
/**
 * Mappings are typecasted with `as const` rather than using enums to
 * prevent reverse mappings generated by enums.
 */ const $682453f63f1e9035$export$e8d1ded05852e864 = {
    source: 'source'
};
const $682453f63f1e9035$export$d1fe2a1199482e6d = {
    release: 'release',
    product: 'product',
    cloudId: 'cloudId',
    userId: 'userId',
    primaryProduct: 'primaryProduct',
    experimentId: 'experimentId',
    experimentLayers: 'experimentLayers',
    abTestId: 'abTestId',
    isHello: 'isHello',
    version: 'version'
};
const $682453f63f1e9035$export$ed78826c06dd24e3 = 'fabric-elements';
const $682453f63f1e9035$export$ad44d4a0591d8dba = 'advancedSearchScreen';
const $682453f63f1e9035$export$98bd2afc08f981ef = 'searchPage';
var $682453f63f1e9035$export$1118b8908e5d0501 = /*#__PURE__*/ function(OptionIds) {
    OptionIds["TITLE"] = "title";
    OptionIds["ARCHIVED"] = "archived";
    OptionIds["ANCESTOR"] = "ancestor";
    OptionIds["TO"] = "to";
    OptionIds["FROM"] = "from";
    OptionIds["LAST_MODIFIED"] = "lastModified";
    return OptionIds;
}({});
const $682453f63f1e9035$export$eed19b551669af14 = 'CURRENT';
const $682453f63f1e9035$export$c936349447a77fe0 = 'ARCHIVED';
const $682453f63f1e9035$export$a4c5cde0daa9b961 = 'crossProductSearch';
const $682453f63f1e9035$export$2be5c31192ba8783 = 'all';
const $682453f63f1e9035$export$cabdc1d3c523c88 = 'fullPageSearchErrorScreen';
var $682453f63f1e9035$export$15029b2eda44c6a7 = /*#__PURE__*/ function(QueryState) {
    QueryState["POSTQUERY"] = "PostQuery";
    QueryState["PREQUERY"] = "PreQuery";
    return QueryState;
}({});
module.exports["ACTION_SUBJECT_PREFIX"] = $682453f63f1e9035$export$98bd2afc08f981ef;
module.exports["QueryState"] = $682453f63f1e9035$export$15029b2eda44c6a7;

});

parcelRegister("fFmb3", function(module, exports) {

var $7tGzv = parcelRequire("7tGzv");

const $c6116437d0fd86af$export$17d9a81ce3c86a85 = (urlSearchParams)=>{
    const queryParamsObject = Array.from(urlSearchParams.entries()).reduce((paramsObject, [paramKey, value])=>{
        return {
            ...paramsObject,
            [paramKey]: value
        };
    }, {});
    return queryParamsObject;
};
const $c6116437d0fd86af$export$67c4cee80a3410cd = (queryParams, options)=>{
    const filteredParsedQueryParamEntries = Object.entries((0, $7tGzv.searchQueryParamsBaseSchema).shape).map(([key, schema])=>{
        const queryParamValue = queryParams[key];
        const parsedRawValue = schema.safeParse(queryParamValue);
        if (parsedRawValue.success || !options?.commaSeparatedValues) return [
            key,
            parsedRawValue.data
        ];
        const commaSeparatedString = Array.isArray(queryParamValue) && queryParamValue.length ? queryParamValue.join(',') : undefined;
        const parsedString = schema.safeParse(commaSeparatedString);
        return [
            key,
            parsedString.success ? parsedString.data : null
        ];
    }).filter(([_, value])=>!(value === null || value === undefined));
    const parsedQueryParams = Object.fromEntries(filteredParsedQueryParamEntries);
    const validatedQueryParams = (0, $7tGzv.searchQueryParamsValidators).reduce((queryParams, validator)=>validator(queryParams), parsedQueryParams);
    return validatedQueryParams;
};
const $c6116437d0fd86af$export$60eb5b58f94d0071 = (oldQueryParams, newQueryParams)=>{
    const oldQueryParamEntries = Object.entries(oldQueryParams).filter(([_, value])=>!Array.isArray(value));
    const newQueryParamEntries = Object.entries(newQueryParams).filter(([_, value])=>!Array.isArray(value));
    const oldQueryParamArrayEntries = Object.entries(oldQueryParams).filter(([_, value])=>Array.isArray(value));
    const newQueryParamArrayEntries = Object.entries(newQueryParams).filter(([_, value])=>Array.isArray(value));
    const mergedQueryStringParamKeys = [
        ...new Set([
            ...oldQueryParamArrayEntries,
            ...newQueryParamArrayEntries
        ].map(([key])=>key))
    ];
    const mergedSearchQueryArrays = mergedQueryStringParamKeys.map((key)=>{
        return [
            key,
            [
                ...new Set([
                    ...oldQueryParams[key] ?? [],
                    ...newQueryParams[key] ?? []
                ])
            ]
        ];
    });
    return {
        ...Object.fromEntries(oldQueryParamEntries),
        ...Object.fromEntries(newQueryParamEntries),
        ...Object.fromEntries(mergedSearchQueryArrays)
    };
};
const $c6116437d0fd86af$export$fc8e8d0c43c32316 = (queryParams)=>{
    return Object.entries(queryParams).flatMap((queryParam)=>{
        const [key, value] = queryParam;
        if (Array.isArray(value)) return [
            [
                key,
                value.join(',')
            ]
        ];
        return [
            [
                key,
                value
            ]
        ];
    });
};
const $c6116437d0fd86af$export$17404cc52c459484 = (queryParams)=>{
    const queryParamRawEntries = Object.entries(queryParams).flatMap((queryParam)=>{
        const [paramKey, value] = queryParam;
        if (value instanceof Date) {
            const dateFormatOptions = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            };
            const dateFormatter = new Intl.DateTimeFormat('en-US', dateFormatOptions);
            const { month: month, day: day, year: year } = Object.fromEntries(dateFormatter.formatToParts(value).map((part)=>[
                    part.type,
                    part.value
                ]));
            return [
                [
                    paramKey,
                    `${year}-${month}-${day}`
                ]
            ];
        }
        if (value === false || value === true) return [
            [
                paramKey,
                String(value)
            ]
        ];
        if (Array.isArray(value)) return [
            [
                paramKey,
                value.join(',')
            ]
        ];
        return [
            [
                paramKey,
                value
            ]
        ];
    }).sort(([firstKey], [secondKey])=>firstKey < secondKey ? 1 : -1);
    return Object.fromEntries(queryParamRawEntries);
};
const $c6116437d0fd86af$export$249cc09c933c4d7a = (queryParams)=>{
    const sanitizedQueryParams = Object.fromEntries(Object.entries(queryParams).filter(([_, value])=>value !== undefined));
    return new URLSearchParams($c6116437d0fd86af$export$fc8e8d0c43c32316($c6116437d0fd86af$export$17404cc52c459484(sanitizedQueryParams))).toString();
};
const $c6116437d0fd86af$export$f30b1e6bbcaec160 = (queryParams)=>{
    return Object.fromEntries($c6116437d0fd86af$export$fc8e8d0c43c32316($c6116437d0fd86af$export$17404cc52c459484(queryParams)));
};
const $c6116437d0fd86af$export$e247f217269cd2eb = (...queryParamArray)=>{
    const queryParamStrings = queryParamArray.map((queryParams)=>$c6116437d0fd86af$export$249cc09c933c4d7a(queryParams));
    const allQueryParamsAreEqual = new Set(queryParamStrings).size === 1;
    return allQueryParamsAreEqual;
};
module.exports["parseQueryParams"] = $c6116437d0fd86af$export$67c4cee80a3410cd;
module.exports["toQueryString"] = $c6116437d0fd86af$export$249cc09c933c4d7a;
module.exports["toQueryParamsRaw"] = $c6116437d0fd86af$export$f30b1e6bbcaec160;
module.exports["areAllEqualQueryParams"] = $c6116437d0fd86af$export$e247f217269cd2eb;

});

parcelRegister("7xGy0", function(module, exports) {

var $eMqrF = parcelRequire("eMqrF");


var $iBY5n = parcelRequire("iBY5n");

const $e6de893f402499c2$export$e8eac31981efe1fb = (ari)=>{
    let teamId = null;
    if (!ari) return teamId;
    const isTeamsAri = (0, $iBY5n.TeamsTeamAri).check(ari);
    const isIdentityTeamsAri = (0, $eMqrF.IdentityTeamAri).check(ari);
    if (isTeamsAri) teamId = (0, $iBY5n.TeamsTeamAri).parse(ari).teamId;
    else if (isIdentityTeamsAri) teamId = (0, $eMqrF.IdentityTeamAri).parse(ari).teamId;
    if (teamId === 'unidentified') teamId = null;
    return teamId;
};
module.exports["getTeamId"] = $e6de893f402499c2$export$e8eac31981efe1fb;

});

parcelRegister("cqgOH", function(module, exports) {

var $7tGzv = parcelRequire("7tGzv");

const $64adaff71ff9981b$var$notEmpty = (value)=>{
    return value !== null && value !== undefined;
};
const $64adaff71ff9981b$export$a97e25c038594c73 = (staticFilters, filterStates)=>{
    const staticFilterValues = Array.isArray(staticFilters) ? staticFilters : Object.values(staticFilters);
    const staticFiltersRecord = Array.isArray(staticFilters) ? Object.fromEntries(staticFilters.map((staticFilter)=>[
            staticFilter.id,
            staticFilter
        ])) : staticFilters;
    const filterStateValues = Array.isArray(filterStates) ? filterStates : Object.values(filterStates).filter($64adaff71ff9981b$var$notEmpty);
    const filterStatesRecord = Array.isArray(filterStates) ? Object.fromEntries(filterStates.map((filterState)=>[
            filterState.id,
            filterState
        ])) : filterStates;
    return {
        staticFilters: staticFiltersRecord,
        staticFilterValues: staticFilterValues,
        filterStates: filterStatesRecord,
        filterStateValues: filterStateValues,
        getSelectedProducts: (queryParams)=>{
            const queryParamKeys = Object.keys(queryParams);
            const productKey = (0, $7tGzv.productKeySchema).safeParse(queryParams.product);
            if (productKey.success) return [
                productKey.data
            ];
            const allProductsWithSelections = staticFilterValues.filter((staticFilter)=>!staticFilter.universal) // Ignore universal filters as they are relevant to every product
            .filter((staticFilter)=>queryParamKeys.includes(staticFilter.queryParams.key)).map((staticFilter)=>staticFilter.products).flat();
            const selectedProducts = Array.from(new Set(allProductsWithSelections)); // might have to sort this based on some priority
            return selectedProducts;
        },
        isMissingProductSelection: (queryParams)=>{
            const selectedProducts = $64adaff71ff9981b$export$a97e25c038594c73(staticFilters, filterStates).getSelectedProducts(queryParams);
            const productKey = (0, $7tGzv.productKeySchema).safeParse(queryParams.product).data;
            return selectedProducts.length > 0 && !productKey;
        },
        filtersByProduct: (products)=>{
            const staticFiltersByProduct = staticFilterValues.filter((staticFilterValue)=>{
                if (!products.length) return staticFilterValue.universal; // Only universal filters are relevant if no apps are selected
                return staticFilterValue.products.some((product)=>products.includes(product));
            });
            const staticFiltersByProductKeys = staticFiltersByProduct.map((staticFilter)=>staticFilter.id);
            const filterStatesByProduct = filterStateValues.filter((filterState)=>staticFiltersByProductKeys.includes(filterState.id));
            return $64adaff71ff9981b$export$a97e25c038594c73(staticFiltersByProduct, filterStatesByProduct);
        },
        getFiltersWithSelection: ()=>{
            const filterIDsWithSelection = filterStateValues.filter((x)=>x.hasSelection).map((x)=>x.id);
            return filterIDsWithSelection;
        }
    };
};
module.exports["FilterUtils"] = $64adaff71ff9981b$export$a97e25c038594c73;

});


//# sourceMappingURL=cards-extension.2a4acf56.js.map
